/* design-my-book.js */

/* =========================
   MODE / NAVIGATION FIXES
   ========================= */

/* session ID + per-session book counter for PDF filenames */
const DMB_SESSION_ID = Date.now().toString(36);
let dmbBookCounter = 0;


const DMB_MAP_LIBRARY = {
  lebanon: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 240" class="dmb-country-map" data-map-name="lebanon">
      <path d="M55 10 L75 20 L80 40 L72 60 L85 85 L78 110 L88 140 L80 170 L70 205 L58 230 L45 220 L42 190 L35 160 L30 130 L36 100 L32 75 L40 50 L48 25 Z"></path>
    </svg>
  `,
  afghanistan: `
    <svg
      xmlns:mapsvg="http://mapsvg.com"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      mapsvg:geoViewBox="60.517000 38.490877 74.889862 29.377200"
      version="1.1"
      id="svg2"
      width="699.60461"
      height="532.77234">
      <path
        id="AF-PIA"
        title="Paktya"
        
        d="m 456.68715,266.76119 -2.93,-1.73 -0.34,-0.13 -0.3,-0.07 -0.27,-0.02 -0.26,0.08 -0.29,0.19 -1.69,2.07 -2.7,1.69 -0.54,0.2 -0.58,-0.02 -0.17,-0.21 -0.01,-0.39 0.06,-0.43 0.03,-0.36 -0.07,-0.29 -0.17,-0.2 -0.38,-0.22 -0.44,-0.17 -1.65,-0.4 -2.16,-0.16 -0.6,0.06 -0.82,-0.01 -0.47,0.08 -0.46,0.15 -1.07,0.67 -0.31,0.32 -0.39,1.18 -0.72,1.5 -0.5,0.7 -0.82,0.93 -0.54,0.48 -0.59,0.34 -1.89,1.66 -0.27,0.28 -2.59,2.75 -0.35,0.71 -0.27,0.36 -1.54,1.06 -4.85,2.28 -4.71,3.54 -0.66,0.51 -0.6,0.63 -0.76,1.56 -0.54,1.6 -0.93,1.68 -0.64,0.56 -0.32,0.22 -0.56,0.28 -0.65,0.22 -0.76,0.12 -0.58,0 -1,-0.42 -0.76,-0.14 -7.19,-0.06 -0.17,2.12 0.09,2.06 0.12,1.08 0.19,0.7 0.58,1.09 0.43,1.05 0.11,0.57 -0.06,0.5 -1.18,2.61 -0.28,1 3.54,-1.31 1.25,-0.21 0.91,0.51 0.51,0.1 0.36,-0.09 0.37,-0.16 0.27,-0.03 0.25,0.04 1.08,0.49 0.27,0.21 0.19,0.21 0.52,1.02 0.77,1.06 0.16,0.32 0.07,0.39 0.01,0.6 -0.2,2.74 0.04,1.18 0.42,3.41 -0.02,0.31 -0.05,0.28 -0.01,0.49 0.19,0.64 0.25,1.32 0.23,0.38 0.14,0.03 0.16,-0.01 0.31,-0.05 0.72,-0.3 0.68,-0.43 1.31,-1.25 1.97,-1.17 2.39,-1.08 1.66,-1.05 0.4,-0.41 0.02,-0.16 -0.02,-0.16 -0.04,-0.18 -0.04,-0.24 -0.01,-0.36 0.11,-0.15 0.15,-0.07 0.29,0.02 0.32,0.08 0.19,0.09 0.2,0.15 0.14,0.14 0.39,0.32 1.46,1.16 1.01,0.2 0.88,-0.13 2.22,-0.79 0.78,-0.08 0.34,0.17 0.19,0.12 0.97,0.32 0.24,-1.19 0.16,-0.28 0.66,-0.74 0.85,-1.03 0.2,-0.72 0.13,-0.63 0.25,-0.39 2.62,-2.35 1.12,-0.67 0.31,-0.38 0.46,-0.73 0.27,-0.69 1.14,-3.7 -0.82,-0.89 -0.05,-0.71 0.27,-0.69 0.78,-1.51 0.26,-0.71 1.49,-1.25 0.74,-0.46 0.73,-0.36 2.99,-0.91 3.34,-0.33 0.13,0.02 0.07,0.04 0.8,0.62 1.46,-2.22 0.26,-0.23 0.45,-0.3 0.38,-0.05 1.15,-0.41 0.8,-0.51 1.12,-0.49 1.4,-0.85 1.2,-0.39 0.33,-0.22 0.81,-0.9 0.23,-0.46 0.13,-0.41 0.01,-0.85 -1.16,-0.16 -0.73,-0.46 -0.5,-1.12 -0.34,-1.14 -0.43,-0.88 -1.15,-1.7 -0.43,-0.93 -0.65,-2.21 -0.43,-0.77 -1.42,-1.43 -0.3,-0.86 0.64,-0.85 0.86,-0.89 0.09,-0.87 -0.16,-0.88 0.1,-0.92 0.81,-0.82 0.78,-0.27 -0.38,-0.55 z"
        />
      <path
        id="AF-WAR"
        title="Wardak"
        
        d="m 384.03715,232.72119 -0.92,-0.15 -0.28,-0.08 -0.21,-0.27 -0.17,-0.26 -0.31,-1.73 -0.08,-0.89 -0.14,-0.46 -0.24,-0.56 -2.5,-2.54 -0.21,-0.48 -0.2,-0.67 -0.1,-1.16 -0.31,-1.11 -5.59,2.91 -1.37,1.03 -0.7,1.16 -1.01,1.1 -0.53,0.44 -0.39,0.16 -0.54,-0.31 -0.36,-0.1 -0.42,0.01 -0.56,0.13 -0.35,0.22 -0.33,0.36 -0.32,0.49 -0.95,1.09 -0.2,0.3 -0.25,0.74 -1.09,2.32 -2.98,-0.34 -8.92,-2.53 -1.13,-0.2 -1.83,0.25 -1.39,-0.04 -0.8,-0.12 -0.93,-0.28 -1.49,-0.14 -0.4,-0.12 -0.23,-0.23 -0.24,-0.3 -0.39,-0.32 -0.93,-0.41 -0.55,-0.17 -0.45,-0.07 -0.29,0.04 -0.29,0.1 -1.37,0.84 -0.31,0.13 -4.25,0.86 -2.7,0.37 -0.4,0.14 -0.48,0.24 -0.17,0.23 -0.25,0.64 0.48,1.64 0.51,0.73 1.45,1.22 0.28,0.42 0.11,0.45 -0.06,1.02 -0.09,0.35 -0.17,0.25 -0.84,0.67 -0.24,0.12 -0.27,0.07 -1.3,0.14 -0.31,0.12 -0.3,0.19 -0.25,0.25 -0.24,0.33 -0.25,0.44 -0.24,0.58 -0.31,0.94 0.01,0.72 0.12,0.5 0.27,0.35 0.31,0.25 0.34,0.18 0.33,0.13 3.38,0.31 2.13,-0.11 0.49,0.04 0.45,0.14 0.49,0.38 0.24,0.39 0.13,0.41 0.05,0.37 -0.01,0.38 -0.06,0.31 -0.12,0.23 -0.15,0.18 -0.21,0.13 -0.18,0.09 -0.39,0.11 -1.08,0.61 -0.11,0.23 -0.03,0.31 0.18,0.15 0.28,0.1 1.56,0.19 0.6,0.17 4.78,2.18 0.57,0.45 0.17,0.34 -0.48,0.51 -0.7,0.95 -0.15,0.32 -0.21,0.57 -0.13,0.19 -0.2,0.16 -3.9,1.51 -0.34,0.33 -0.32,0.5 -0.3,1.19 0,0.62 0.2,0.5 0.87,0.81 2.29,0.31 0.81,-0.01 1.51,-0.52 0.24,-0.18 0.1,-0.19 0.29,-1.34 0.19,-0.29 0.32,-0.32 0.62,-0.49 0.43,-0.23 0.39,-0.13 3.29,-0.7 1.22,-0.06 1.49,0.34 1.8,0.69 1.5,1.04 1.22,1.16 0.53,0.27 0.66,0.16 2.24,0.17 0.64,-0.04 0.74,-0.15 3.09,-1.08 1.39,-0.74 0.7,-0.58 0.26,-0.09 0.34,-0.19 0.16,-0.14 0.69,-0.45 1.06,0.25 0.72,0.49 1.46,1.38 0.39,0.6 0.25,0.55 0.48,2.62 0.03,0.45 -0.08,0.85 0.02,0.49 0.06,0.51 0.16,0.64 0.05,0.43 -0.02,0.43 -0.07,0.38 0.03,0.51 0.12,0.59 0.43,1.46 0.03,0.82 0.35,1 0.49,0.32 0.61,0.17 3.03,1.23 0.25,0.2 0.5,0.86 2.33,1.45 0.71,0.77 0.18,0.29 4.14,4.37 0.32,0.28 0.29,0.15 0.24,0.01 0.48,-0.04 0.43,-0.1 1.08,-0.04 0.45,1.28 -0.01,0.33 -0.05,0.46 -0.4,1.17 -0.23,0.96 -0.01,0.51 0.07,0.37 0.09,0.13 0.13,0.15 0.43,0.3 0.62,0.28 1.94,0.48 0.51,0 0.8,-0.09 0.42,-0.17 4.1,-2.41 0.33,-0.27 2.05,-2.55 1.16,-1.14 1.63,-1.85 0.2,-0.34 0.38,-0.87 0.32,-2.09 -0.08,-0.44 -0.17,-0.54 -0.5,-0.63 -0.08,-0.16 -0.02,-0.09 0.12,-0.16 0.64,-1.24 0.55,-0.75 1.19,-1.02 0.66,-0.36 0.69,-0.28 2.33,-0.48 0.43,-0.15 0.2,-0.17 0.06,-0.23 0,-0.11 -0.09,-0.33 -0.7,-1.75 -0.21,-0.24 -0.51,-0.44 -0.61,-0.4 -1.12,-1.01 -0.47,-0.69 -0.24,-0.66 0.17,-2.1 0.46,-1.99 1.03,-2.24 0.86,-1.15 1.03,-0.96 0.67,-0.46 1.43,-3.4 0.96,-1.5 1.27,-1.46 -0.26,-0.89 -0.85,-2.86 -1.66,-1.24 -0.34,-0.17 -1.55,-0.4 -0.27,-0.12 -0.21,-0.23 -0.17,-0.38 -0.25,-0.77 -0.22,-0.51 -0.21,-0.37 -0.18,-0.5 -0.09,-0.71 0.08,-1.61 0.5,-1.96 -0.08,-1.3 0.6,-2.04 -0.62,0.18 -0.76,-0.14 -1.49,-0.67 -1.68,-0.48 -0.71,-0.36 -0.38,-0.05 -1.47,0.09 -0.64,-0.07 -0.7,-0.27 -0.87,-0.67 -0.24,-0.14 -0.21,-0.09 -0.85,-0.23 -0.68,-0.31 -3.58,-0.88 -0.48,0.01 -0.69,0.29 -2.86,1.88 -1.49,0.75 -0.8,0.25 -0.26,0.16 -0.41,0.43 -0.25,0.13 -0.34,0.04 z"
        />
      <path
        id="AF-SAM"
        title="Samangan"
        
        d="m 368.52715,117.15119 -9.66,-1.37 -2.34,-0.29 -1.12,-0.37 -0.64,-0.41 -0.28,-0.24 -1.51,-0.95 -2.77,-1.36 -0.68,-0.19 -0.78,0.05 -0.74,0.18 -1.4,0.57 -0.67,0.18 -5.53,-0.52 -0.69,0.25 -0.68,1.67 -0.51,0.48 -2.21,0.67 -0.98,0.49 -0.47,0.38 -0.43,0.44 -0.15,0.24 -0.09,0.15 -0.01,0.15 0.04,0.14 0.08,0.15 0.84,1.13 1.3,2.73 0.06,0.46 0.02,0.66 -1.14,3.19 -0.7,2.89 -0.06,2.7 -0.34,2.19 -0.23,0.39 -0.34,0.48 -0.76,0.62 -0.44,0.47 -0.2,0.36 -0.05,0.29 0.05,0.19 0.09,0.28 0.09,0.4 0,0.4 -0.1,0.8 -0.23,0.45 -0.34,0.38 -1.01,0.94 -0.81,0.98 -0.48,0.46 -0.39,0.3 -0.69,0.21 -2.57,0.39 -0.9,0.29 -4.57,3.51 -0.98,0.96 -0.01,0.1 0.01,0.13 0.05,0.2 0.11,0.19 0.17,0.2 0.3,0.23 0.12,0.11 0.08,0.16 0.04,0.24 0.03,0.63 0.03,0.13 0.18,0.39 0.31,0.5 1.33,1.78 0.11,0.45 0.02,0.53 -0.13,1.17 -0.21,0.68 -0.25,0.5 -0.31,0.25 -0.79,0.42 -0.38,0.33 -0.2,0.41 -0.16,0.61 -0.22,0.4 -0.25,0.29 -0.61,0.47 -0.65,0.78 -1.85,2.22 -1.02,0.78 -1.81,0.87 -0.44,0.43 -0.36,0.44 -0.81,1.47 -0.2,0.56 -0.11,0.51 -0.07,0.49 0.06,0.65 4.59,2.16 1.11,0.98 0.15,0.68 0.02,0.23 0.01,0.18 -0.04,0.15 -0.06,0.17 -0.12,0.19 -0.19,0.18 -0.27,0.18 -0.91,0.4 -0.24,0.21 -0.17,0.26 -0.05,0.39 0.14,0.21 1.08,0.57 0.15,0.16 0.07,0.15 -0.07,0.5 -0.01,0.31 0.07,0.79 -0.03,0.23 -0.06,0.17 -0.14,0.06 -0.68,0.17 -0.15,0.07 -0.09,0.08 -0.03,0.13 0.01,0.24 0.28,1.53 0.02,0.43 -0.01,0.52 -0.07,0.68 -0.11,0.5 -0.17,0.44 -0.23,0.42 -0.29,0.4 -2.29,2.31 -0.83,0.68 -0.9,0.57 -1.55,0.7 -0.76,0.47 -0.59,0.6 2.65,1.06 1.32,0.26 4.87,0.03 1.36,-0.32 4.37,-1.96 3.78,-0.97 4.53,-1.76 0.55,-0.08 0.43,0.04 0.27,0.12 0.6,0.14 0.97,0.06 1.9,0.53 5.23,-2.14 3.01,-0.62 1.22,-0.02 6.41,1.5 0.64,0.06 0.52,-0.04 2.64,-0.89 0.48,-0.02 0.36,0.1 0.24,0.23 0.4,0.58 0.26,0.25 0.39,0.23 0.39,0.05 4.82,-0.73 1.95,0.11 4.26,-0.93 2.62,-2.73 0.18,-0.38 0.03,-0.56 0.1,-0.52 0.22,-0.56 1.08,-1.41 0.63,-1.1 0.26,-1.8 -0.58,-0.78 -0.22,-0.21 -1.25,-0.73 -0.1,-0.55 0.02,-0.29 0.05,-0.39 0.24,-0.82 0.36,-0.82 6.98,-9.35 0.2,-0.41 0.2,-1.92 0.18,-0.69 0.23,-2.31 0,-0.38 -0.06,-0.81 0.03,-0.38 0.12,-0.37 0.34,-0.82 0.22,-0.4 0.33,-0.38 1.45,-0.72 4.51,-3.99 0.97,-1.11 2.14,-3.65 -0.11,-0.5 -0.35,-0.62 -0.3,-0.39 -1.18,-1.14 -3.23,-2.46 -2.04,-1.09 -0.55,-0.48 -2.27,-3.04 -3.35,-5.52 -2.35,-3.55 -0.23,-0.48 -0.36,-0.94 -0.21,-0.37 -0.69,-0.92 -0.14,-0.34 -0.04,-0.36 0.15,-0.54 0.36,-0.8 0.21,-0.34 0.3,-0.29 0.4,-0.22 1.12,-0.31 0.71,-0.52 -1.59,-0.46 -0.86,-0.87 -3.93,1.61 -1.37,0.27 z"
        />
      <path
        id="AF-PAR"
        title="Parwan"
        
        d="m 423.87715,186.02119 -1.73,-0.41 -1.15,0.98 -0.46,0.66 -0.4,0.35 -0.32,0.19 -0.33,0.1 -2.45,1.11 -0.53,0.35 -0.38,0.39 -0.83,1.55 -0.46,0.69 -0.32,0.33 -0.33,0.2 -2.05,0.59 -0.42,0.28 -0.22,0.24 -0.35,0.73 -2.17,1.48 -0.39,0.09 -0.49,0.04 -2.01,-1.41 -1.88,0.55 -0.28,0.18 -0.44,0.33 -0.47,0.48 -0.49,0.8 -0.79,1.06 -0.73,1.36 -0.37,0.43 -0.09,0.05 -3.59,2.75 -0.69,0.41 -2.22,0.49 -0.29,0.18 -0.14,0.23 0.02,0.18 0.07,0.3 0.27,0.57 0.09,0.29 0.03,0.2 -0.18,0.65 -1.34,0.73 -1,0.21 -2.48,0.12 -2.98,-0.26 -3.22,0.46 -0.7,-0.08 -3.56,-1 -0.33,0.03 -0.16,0.16 -0.03,0.24 -0.06,0.29 -0.17,0.29 -0.3,0.37 -0.56,0.44 -0.69,0.43 -1.35,0.46 -1.04,0.55 -0.37,0.5 2.55,2.75 0.63,1.74 0.04,1.51 0.15,1.32 -0.06,1.76 -0.25,1.81 0.12,0.31 0.12,0.18 0.92,0.52 0.57,0.48 0.31,1.11 0.1,1.16 0.2,0.67 0.21,0.48 2.5,2.54 0.24,0.56 0.14,0.46 0.08,0.89 0.31,1.73 0.17,0.26 0.21,0.27 0.28,0.08 0.92,0.15 0.34,-0.04 0.25,-0.13 0.41,-0.43 0.26,-0.16 0.8,-0.25 1.49,-0.75 2.86,-1.88 0.69,-0.29 0.48,-0.01 3.58,0.88 0.68,0.31 0.85,0.23 0.21,0.09 0.24,0.14 0.87,0.67 0.7,0.27 0.64,0.07 1.47,-0.09 0.38,0.05 0.71,0.36 1.68,0.48 1.49,0.67 0.76,0.14 0.62,-0.18 0.63,-2.32 -0.2,-2.52 1.2,-2.59 0.62,-0.55 0.17,-0.8 1.39,-4.2 1.84,-2.95 0.17,-0.2 3.51,0.9 0.71,-0.05 4.42,0.29 1.44,-0.35 0.94,0.15 0.85,0.39 0.86,0.65 0.56,0.52 2.06,1.23 0.38,1.57 1.59,2.58 0.33,0.74 0.51,0.47 0.99,0.2 0.85,0.73 1.22,2.85 0.6,2.67 0.76,2.41 1.03,0.18 1.94,-0.6 0.67,-0.48 0.62,-0.71 0.21,-0.6 0.14,-0.63 0.24,-0.67 0.43,-0.27 0.59,0 1.7,0.36 0.4,-1.86 0.12,-0.36 0,-0.43 -0.52,-0.29 -0.28,-0.25 -0.3,-0.37 -0.28,-0.53 -0.32,-0.33 -0.25,-0.43 -0.3,-0.75 -0.19,-0.78 -0.05,-1.05 0.21,-2.95 -0.04,-1.23 0.2,-2.45 -0.26,-1.35 -1.61,-0.55 -2.12,-0.82 -2.93,-0.15 -1.4,-1.49 -0.91,-1.23 -0.64,-0.48 -0.77,-0.45 -1.35,-0.3 -1.28,-0.66 -0.75,-0.9 -0.19,-1.15 0.09,-1.15 0.38,-3.29 -0.23,-2.27 -1.83,0.26 -0.07,-2.07 0.19,-1.05 0.13,-6.69 0.58,-2.67 0.04,-1.49 -0.78,-1.14 -0.32,-0.23 -0.31,0.1 -0.65,0.03 z"
        />
      <path
        id="AF-LOG"
        title="Logar"
        
        d="m 435.57715,261.02119 -1,-1.89 -1.05,-1.38 -0.35,-0.56 -0.29,-0.76 -0.13,-0.48 -0.25,-0.55 -0.34,-0.57 -1.47,-1.9 -0.94,-0.82 -0.64,-0.65 -0.58,-0.8 -1.17,-2.19 -0.56,-0.41 -3.99,2.7 -0.26,0.29 -0.3,0.18 -0.32,0.03 -0.85,-0.41 -0.77,0.12 -0.79,0.32 -0.7,0.08 -7.17,-2.44 -1.27,1.46 -0.96,1.5 -1.43,3.4 -0.67,0.46 -1.03,0.96 -0.86,1.15 -1.03,2.24 -0.46,1.99 -0.17,2.1 0.24,0.66 0.47,0.69 1.12,1.01 0.61,0.4 0.51,0.44 0.21,0.24 0.7,1.75 0.09,0.33 0,0.11 -0.06,0.23 -0.2,0.17 -0.43,0.15 -2.33,0.48 -0.69,0.28 -0.66,0.36 -1.19,1.02 -0.55,0.75 -0.64,1.24 -0.12,0.16 0.02,0.09 0.08,0.16 0.5,0.63 0.17,0.54 0.08,0.44 -0.32,2.09 -0.38,0.87 -0.2,0.34 -1.63,1.85 1.46,0.7 0.19,0.23 0.24,0.4 0.07,0.38 0.38,1.18 0.45,1 0.16,0.47 0.03,0.3 -0.12,0.08 -0.4,0.08 -0.19,0.1 -0.2,0.19 -0.2,0.4 -0.17,0.46 -0.1,0.62 0.1,0.31 0.2,0.24 0.24,0.17 0.24,0.2 0.06,0.22 -0.03,0.67 0.04,0.2 0.35,0.43 0.14,1.28 0,0.01 7.19,0.06 0.76,0.14 1,0.42 0.58,0 0.76,-0.12 0.65,-0.22 0.56,-0.28 0.32,-0.22 0.64,-0.56 0.93,-1.68 0.54,-1.6 0.76,-1.56 0.6,-0.63 0.66,-0.51 4.71,-3.54 4.85,-2.28 1.54,-1.06 0.27,-0.36 0.35,-0.71 2.59,-2.75 0.27,-0.28 1.89,-1.66 0.59,-0.34 0.54,-0.48 0.82,-0.93 0.5,-0.7 0.72,-1.5 0.39,-1.18 0.31,-0.32 1.07,-0.67 0.46,-0.15 0.47,-0.08 0.82,0.01 0.6,-0.06 2.16,0.16 1.65,0.4 0.44,0.17 0.38,0.22 0.17,0.2 0.07,0.29 -0.03,0.36 -0.06,0.43 0.01,0.39 0.17,0.21 0.58,0.02 0.54,-0.2 2.7,-1.69 1.69,-2.07 0.29,-0.19 0.26,-0.08 0.27,0.02 0.3,0.07 0.34,0.13 2.93,1.73 -0.86,-1.24 -0.5,-1.99 -0.52,-0.87 -0.4,-0.43 -0.74,-0.94 -0.24,-0.83 -0.09,-0.17 -0.13,-0.17 -0.36,-0.37 -0.13,-0.16 -0.12,-0.21 -0.17,-0.47 -0.5,-0.85 -0.21,-0.61 -0.12,-0.24 -0.18,-0.17 -0.22,-0.15 -0.55,-0.26 -0.13,-0.09 -0.11,-0.18 -0.15,-0.27 -0.1,-0.13 -0.14,-0.12 -0.42,-0.23 -0.09,-0.08 -0.13,-0.14 -0.34,-0.45 -0.23,-0.19 -0.35,-0.09 -0.48,0.08 -1.03,0.35 -5.7,2.66 -3.61,2.53 -0.92,-0.19 -0.63,0.79 -0.16,0.13 -0.35,0.01 z"
        />
      <path
        id="AF-LAG"
        title="Laghman"
        
        d="m 463.39715,204.55119 -0.44,-0.37 -0.48,-1 -0.14,-2.33 -0.19,-0.59 -0.3,-0.64 -1.26,-2.02 -0.28,-1.03 -0.35,0.91 -0.38,0.7 -1.82,2.46 -0.77,0.7 -1.49,0.95 -1.57,0.78 -0.36,0.22 -0.53,0.23 -0.3,0.06 -0.17,0.15 -0.17,0.34 -0.1,0.64 -0.49,1.05 0.75,2.31 1.69,1.33 0.25,0.47 0.31,0.78 0.17,0.8 0.36,1.05 1.48,2.4 0.32,0.85 0.45,2.09 -0.92,1.37 1.54,4.34 0.01,0.67 -0.06,0.88 -0.27,0.4 -0.52,0.55 -1.97,1.76 -0.5,0.82 -0.35,0.74 -0.07,0.55 0.05,0.94 -0.11,2.37 -0.22,0.5 -0.19,0.32 -0.92,1.03 0.05,1.34 0.72,1.88 -0.08,0.64 -0.32,0.83 -0.4,0.81 -0.49,1.25 -0.16,0.81 -0.05,0.81 0.02,0.49 0.16,1.36 1.47,0.48 5.22,-0.6 2.74,-0.53 2.83,0.61 0.82,-0.17 2.88,-1.34 5.13,-0.88 2.74,-0.8 2.43,-1.23 0.62,-0.54 1.35,-1.02 1.24,-2.58 0.09,-0.83 0.03,-1.02 -0.79,-3.9 1.18,-1 2.59,-0.98 0.54,-0.39 0.35,-2.37 0.32,-0.69 0.51,-0.65 1.52,-1.17 1.7,-0.87 1.46,-0.46 0.21,-1.86 0.02,-2.33 -0.14,-1.11 -0.28,-1.09 -0.6,-1.14 -0.27,-0.7 -0.04,-0.57 0.01,-0.54 -0.07,-0.63 -0.23,-0.71 -0.6,-0.79 -0.9,1.26 -2.31,1.94 -0.57,0.32 -2.57,1.08 -2.52,0.73 -0.69,0.02 -0.66,-0.18 -2.28,-1.39 -2.22,-0.35 -0.55,-0.36 -1,-2.17 -1.06,-1.14 -1.27,-1.74 -0.67,-2.52 -1.31,-1.24 -3.88,-0.69 -1.66,0.08 z"
        />
      <path
        id="AF-PAN"
        title="Panjshayr"
        
        d="m 474.91715,159.94119 -3.03,-1.36 -1.36,-1.08 -0.29,-0.07 -0.03,0.19 0.1,0.46 -0.03,0.55 -0.3,0.69 -0.48,0.66 -0.64,0.72 -0.62,0.55 -1.11,0.54 -3.32,0.38 -2.02,0.81 -0.81,0.46 -0.19,0.02 -0.09,-0.12 -0.04,-0.41 -0.04,-0.17 -0.1,-0.1 -0.12,-0.08 -0.63,-0.22 -0.6,1.57 -0.21,0.23 -0.34,0.28 -1.5,0.71 -0.38,0.46 -0.91,1.83 -0.43,0.55 -0.43,0.35 -0.74,0.21 -0.69,0.07 -0.72,-0.03 -1.28,1.93 -0.43,1.2 -0.19,0.94 -0.12,1.24 -0.61,3.07 -0.24,0.74 -0.47,0.7 -2.42,0.71 -6.11,3.99 -0.82,0.35 -2.61,-0.35 -2.2,0.26 -0.55,0.18 -0.33,0.26 -0.43,0.76 -1.31,1.27 -1.36,-0.09 -0.7,0.25 -0.58,0.44 -0.42,0.22 -1.56,-0.06 -2.14,0.66 -0.04,1.49 -0.58,2.67 -0.13,6.69 -0.19,1.05 0.07,2.07 1.83,-0.26 0.78,-0.39 0.4,-0.81 0.69,0.25 0.66,0.46 2.51,0.19 2.07,0.78 0.94,-0.05 1.02,-0.28 0.66,-0.04 0.95,0.37 2.39,-0.09 0.55,0.15 3.35,-0.96 2.17,0.25 1.54,0.35 0.89,0.49 0.67,0.63 1.61,2.27 1.06,1.22 0.49,-1.05 0.1,-0.64 0.17,-0.34 0.17,-0.15 0.3,-0.06 0.53,-0.23 0.36,-0.22 1.57,-0.78 1.49,-0.95 0.77,-0.7 1.82,-2.46 0.38,-0.7 0.35,-0.91 0.12,-3.15 -0.23,-0.6 -0.47,-0.9 -1.95,-1.72 0.08,-0.76 0.4,-0.64 0.5,-0.5 0.83,-0.53 3.61,-1.89 1.13,-1.58 0.22,-0.6 0.83,-1.42 0.25,-0.05 0.27,0.14 0.49,0.16 0.69,-0.02 1.13,-0.35 0.79,-0.62 0.61,-0.69 0.42,-0.77 0.26,-0.64 0.05,-0.44 -0.11,-0.29 -0.17,-0.24 -0.13,-0.27 -0.02,-0.68 0.08,-0.31 0.32,-0.23 1.2,-0.69 0.37,-0.54 0.23,-0.78 0.2,-2.82 0.56,-1.46 0.35,-0.78 0.01,-0.66 0.35,-2.97 0.23,-1.02 0.17,-2.64 0.94,-2.68 z"
        />
      <path
        id="AF-KAP"
        title="Kapisa"
        
        d="m 434.00715,201.45119 -2.07,-0.78 -2.51,-0.19 -0.66,-0.46 -0.69,-0.25 -0.4,0.81 -0.78,0.39 0.23,2.27 -0.38,3.29 -0.09,1.15 0.19,1.15 0.75,0.9 1.28,0.66 1.35,0.3 0.77,0.45 0.64,0.48 0.91,1.23 1.4,1.49 2.93,0.15 2.12,0.82 1.61,0.55 0.26,1.35 -0.2,2.45 0.04,1.23 -0.21,2.95 0.05,1.05 0.19,0.78 0.3,0.75 0.25,0.43 0.32,0.33 0.28,0.53 0.3,0.37 0.28,0.25 0.52,0.29 0,0.43 -0.12,0.36 -0.4,1.86 1.08,0.59 0.54,0 2.53,-0.65 1.42,0 0.33,-0.39 0.24,-0.64 0.16,-0.78 2.21,-5.73 0.85,-0.74 2.25,-1.11 0.66,-0.24 0.36,-0.3 0.11,-0.25 0.45,-0.79 1.01,-1.03 0.92,-1.37 -0.45,-2.09 -0.32,-0.85 -1.48,-2.4 -0.36,-1.05 -0.17,-0.8 -0.31,-0.78 -0.25,-0.47 -1.69,-1.33 -0.75,-2.31 -1.06,-1.22 -1.61,-2.27 -0.67,-0.63 -0.89,-0.49 -1.54,-0.35 -2.17,-0.25 -3.35,0.96 -0.55,-0.15 -2.39,0.09 -0.95,-0.37 -0.66,0.04 -1.02,0.28 -0.94,0.05 z"
        />
      <path
        id="AF-KAB"
        title="Kabul"
        
        d="m 415.82715,217.64119 -3.51,-0.9 -0.17,0.2 -1.84,2.95 -1.39,4.2 -0.17,0.8 -0.62,0.55 -1.2,2.59 0.2,2.52 -0.63,2.32 -0.6,2.04 0.08,1.3 -0.5,1.96 -0.08,1.61 0.09,0.71 0.18,0.5 0.21,0.37 0.22,0.51 0.25,0.77 0.17,0.38 0.21,0.23 0.27,0.12 1.55,0.4 0.34,0.17 1.66,1.24 0.85,2.86 0.26,0.89 7.17,2.44 0.7,-0.08 0.79,-0.32 0.77,-0.12 0.85,0.41 0.32,-0.03 0.3,-0.18 0.26,-0.29 3.99,-2.7 0.56,0.41 1.17,2.19 0.58,0.8 0.64,0.65 0.94,0.82 1.47,1.9 0.34,0.57 0.25,0.55 0.13,0.48 0.29,0.76 0.35,0.56 1.05,1.38 1,1.89 0.35,-0.01 0.16,-0.13 0.63,-0.79 -0.32,-2.12 0.06,-0.42 0.15,-0.2 0.29,-0.25 0.79,-0.44 2.43,-1.8 2.99,-3.1 1.94,-2.6 0.35,-0.57 0.11,-0.5 0,-0.31 -0.22,-0.82 -0.03,-0.27 0,-0.21 0.04,-0.13 1.62,-0.38 5.62,-0.67 -0.16,-1.36 -0.02,-0.49 0.05,-0.81 0.16,-0.81 0.49,-1.25 0.4,-0.81 0.32,-0.83 0.08,-0.64 -0.72,-1.88 -0.05,-1.34 0.92,-1.03 0.19,-0.32 0.22,-0.5 0.11,-2.37 -0.05,-0.94 0.07,-0.55 0.35,-0.74 0.5,-0.82 1.97,-1.76 0.52,-0.55 0.27,-0.4 0.06,-0.88 -0.01,-0.67 -1.54,-4.34 -1.01,1.03 -0.45,0.79 -0.11,0.25 -0.36,0.3 -0.66,0.24 -2.25,1.11 -0.85,0.74 -2.21,5.73 -0.16,0.78 -0.24,0.64 -0.33,0.39 -1.42,0 -2.53,0.65 -0.54,0 -1.08,-0.59 -1.7,-0.36 -0.59,0 -0.43,0.27 -0.24,0.67 -0.14,0.63 -0.21,0.6 -0.62,0.71 -0.67,0.48 -1.94,0.6 -1.03,-0.18 -0.76,-2.41 -0.6,-2.67 -1.22,-2.85 -0.85,-0.73 -0.99,-0.2 -0.51,-0.47 -0.33,-0.74 -1.59,-2.58 -0.38,-1.57 -2.06,-1.23 -0.56,-0.52 -0.86,-0.65 -0.85,-0.39 -0.94,-0.15 -1.44,0.35 -4.42,-0.29 -0.71,0.05 z"
        />
      <path
        id="AF-BGL"
        title="Baghlan"
        
        d="m 380.28715,118.00119 -0.45,-0.14 -1.21,-0.7 -2.35,-0.56 -0.71,0.52 -1.12,0.31 -0.4,0.22 -0.3,0.29 -0.21,0.34 -0.36,0.8 -0.15,0.54 0.04,0.36 0.14,0.34 0.69,0.92 0.21,0.37 0.36,0.94 0.23,0.48 2.35,3.55 3.35,5.52 2.27,3.04 0.55,0.48 2.04,1.09 3.23,2.46 1.18,1.14 0.3,0.39 0.35,0.62 0.11,0.5 -2.14,3.65 -0.97,1.11 -4.51,3.99 -1.45,0.72 -0.33,0.38 -0.22,0.4 -0.34,0.82 -0.12,0.37 -0.03,0.38 0.06,0.81 0,0.38 -0.23,2.31 -0.18,0.69 -0.2,1.92 -0.2,0.41 -6.98,9.35 -0.36,0.82 -0.24,0.82 -0.05,0.39 -0.02,0.29 0.1,0.55 1.25,0.73 0.22,0.21 0.58,0.78 -0.26,1.8 -0.63,1.1 -1.08,1.41 -0.22,0.56 -0.1,0.52 -0.03,0.56 -0.18,0.38 -2.62,2.73 -0.13,1.53 0.19,1.04 0.73,2.01 0.06,0.49 -0.06,0.44 -0.37,0.84 -0.17,0.63 0.02,0.53 0.38,1.21 -0.04,0.4 -0.18,0.35 -0.2,0.27 -0.19,0.48 -0.17,0.63 -0.27,1.72 -0.14,0.47 -0.34,0.74 -0.13,0.54 -0.32,0.69 -1.24,0.68 -0.29,0.25 -0.34,0.37 -0.24,0.35 -0.27,0.53 -0.11,0.39 -0.22,1.29 0,0.35 0.07,0.32 0.12,0.3 0.09,0.32 0.04,0.35 0,0.35 -0.03,0.37 0,0.35 0.21,1.99 0.12,0.46 0.17,0.26 0.25,0.18 1.48,0.45 0.16,0.11 0.15,0.17 0.18,0.16 0.22,0.12 0.28,0.03 0.34,-0.04 1.13,-0.27 0.34,0 0.35,0.08 0.32,0.17 1.7,1.45 0.23,0.09 0.24,0 0.21,-0.03 0.3,-0.14 0.37,-0.5 1.04,-0.55 1.35,-0.46 0.69,-0.43 0.56,-0.44 0.3,-0.37 0.17,-0.29 0.06,-0.29 0.03,-0.24 0.16,-0.16 0.33,-0.03 3.56,1 0.7,0.08 3.22,-0.46 2.98,0.26 2.48,-0.12 1,-0.21 1.34,-0.73 0.18,-0.65 -0.03,-0.2 -0.09,-0.29 -0.27,-0.57 -0.07,-0.3 -0.02,-0.18 0.14,-0.23 0.29,-0.18 2.22,-0.49 0.69,-0.41 3.59,-2.75 0.09,-0.05 0.37,-0.43 0.73,-1.36 0.79,-1.06 0.49,-0.8 0.47,-0.48 0.44,-0.33 0.28,-0.18 1.88,-0.55 2.01,1.41 0.49,-0.04 0.39,-0.09 2.17,-1.48 0.35,-0.73 0.22,-0.24 0.42,-0.28 2.05,-0.59 0.33,-0.2 0.32,-0.33 0.46,-0.69 0.83,-1.55 0.38,-0.39 0.53,-0.35 2.45,-1.11 0.33,-0.1 0.32,-0.19 0.4,-0.35 0.46,-0.66 1.15,-0.98 1.73,0.41 0.65,-0.03 0.31,-0.1 0.32,0.23 0.78,1.14 2.14,-0.66 1.56,0.06 0.42,-0.22 0.58,-0.44 0.7,-0.25 1.36,0.09 1.31,-1.27 0.43,-0.76 0.33,-0.26 0.55,-0.18 2.2,-0.26 2.61,0.35 0.82,-0.35 6.11,-3.99 2.42,-0.71 0.47,-0.7 0.24,-0.74 0.61,-3.07 0.12,-1.24 0.19,-0.94 0.43,-1.2 1.28,-1.93 0.72,0.03 0.69,-0.07 0.74,-0.21 0.43,-0.35 0.43,-0.55 0.91,-1.83 0.38,-0.46 1.5,-0.71 0.34,-0.28 0.21,-0.23 0.6,-1.57 -0.23,-4.62 -0.22,-0.51 -0.36,-0.57 -0.71,-0.93 -0.29,-0.47 -0.1,-0.44 0.04,-0.42 -0.02,-0.11 -0.05,-0.17 -0.12,-0.2 -0.18,-0.21 -0.38,-0.34 -0.28,-0.4 -0.5,-1.11 -0.09,-0.32 -0.02,-0.17 0,-0.31 -0.04,-0.19 -0.09,-0.26 -0.85,-1.65 -1,-1.24 -2.9,-2.69 -0.5,-6.88 -0.58,-1.17 -0.65,-0.17 -1.23,0.11 -0.17,-0.02 -0.18,-0.06 -0.19,-0.11 -0.2,-0.21 -0.19,-0.39 -0.18,-0.55 -0.09,-0.91 0,-1.22 -0.07,-0.6 -0.17,-0.71 -0.79,-2.2 -0.5,-0.19 -1.16,1.06 -1.55,0.91 -2.93,1.17 -0.75,0.11 -0.79,0.23 -0.65,0.39 -3.16,2.51 -2.05,0.62 -1.71,-0.08 -0.4,0.1 -0.33,0.16 -0.19,0.16 -0.15,0.1 -0.11,-0.03 -0.13,-0.11 -0.23,-0.31 -0.23,-0.14 -0.39,0 -0.26,0.1 -0.25,0.16 -0.38,0.34 -0.15,0.07 -0.18,-0.09 -0.23,-0.27 -0.45,-0.79 -0.24,-0.56 -0.28,-0.83 -0.19,-0.28 -0.29,-0.17 -0.62,-0.09 -0.81,-0.22 -0.59,-0.83 -0.67,-0.98 -0.18,-0.33 -0.22,-0.33 -0.39,-0.28 -0.61,-0.28 -1.85,-0.48 -0.88,-0.13 -1.96,-0.71 -0.94,-0.6 -1.39,-1.24 -0.59,-0.78 -0.33,-0.36 -0.57,-0.44 -0.06,-0.07 -0.05,-0.12 -0.05,-0.13 -0.59,-0.27 -2.32,-0.44 -1.2,-0.24 -0.24,0.04 -0.27,0.12 -1.35,0.85 -0.35,0.15 -0.33,0.08 -0.44,-0.12 -0.52,-0.31 -2.12,-1.68 -3.08,-3.89 -0.6,-1.34 -2.98,0.43 -0.78,0.3 -0.5,0.07 -0.56,-0.04 -4.11,-1.17 -7.91,-0.55 -2.58,0.13 z"
        />
      <path
        id="AF-TAK"
        title="Takhar"
        
        d="m 461.85715,57.031194 -0.27,-0.26 -0.19,-0.41 -0.25,-0.31 -0.63,-0.12 -1.02,-0.38 -0.53,-0.87 -0.45,-0.97 -0.8,-0.71 -1.14,-0.06 -2.04,1.04 -0.98,0.28 -0.48,0.22 -0.51,0.44 -0.5,0.26 -0.51,-0.28 -0.35,-0.26 -1.08,-0.33 -0.39,-0.05 -1.2,0.15 -2.05,0.89 -1.08,0.21 -6.61,-0.6 -0.97,0.43 -0.84,2.57 -1.05,1.03 -2.15,1.58 -0.17,0.29 -0.3,0.73 -0.19,0.31 -0.38,0.35 -0.69,0.49 -0.25,0.34 -0.3,0.96 -0.1,1.14 0.04,2.33 0.09,0.22 0.45,0.12 0.14,0.27 -0.01,0.33 -0.12,0.09 -0.13,0.04 -0.06,0.18 0.02,0.57 0.07,0.57 0.15,0.52 0.25,0.42 0.41,0.91 0.32,2.1 0.4,0.55 -0.39,1.34 0.82,0.38 0.89,0.19 -0.15,0.77 -1.67,2.81 -0.8,0.78 -1.96,1.25 -0.77,0.92 -0.53,0.49 -0.57,0.22 -0.17,0.03 0.07,0.21 1.33,1.54 0.06,0.28 0.03,0.37 -0.91,1.2 -0.11,0.23 -0.33,1.41 0,0.57 0.07,0.59 0.15,0.8 0.02,0.5 -0.58,8.51 -0.56,1.699996 -0.53,0.64 -0.18,0.1 -0.13,0.05 -2.23,0.26 -0.66,0.72 -0.04,0.22 -0.04,0.42 0.18,1.24 -0.05,1.28 -0.07,0.4 -0.32,0.4 -0.07,0.13 -0.02,0.18 0.03,0.26 0.04,0.1 0.43,0.77 0.2,0.57 0.06,0.49 -0.02,0.45 -0.08,0.54 0.07,0.23 0.16,0.1 0.25,0.04 0.1,0.03 0.12,0.09 0.13,0.14 0.31,0.52 0.57,1.24 0.04,0.55 -0.06,0.52 -0.93,2.03 -0.36,1.34 -0.16,0.42 -0.2,0.3 -0.21,0.27 -1.37,1.13 -0.13,0.16 -0.09,0.16 -0.05,0.17 -0.07,0.15 -0.11,0.13 -0.21,0.13 -0.58,0.24 -0.76,0.72 -0.04,0.2 0.01,0.25 0.41,0.58 0.49,0.85 0.53,2.18 0.6,1.03 0.44,0.57 0.16,0.46 0.02,0.54 -0.07,0.6 0.03,0.81 0.18,0.63 0.45,0.89 0.2,0.63 0.11,0.48 0.01,0.97 0.59,0.83 0.81,0.22 0.62,0.09 0.29,0.17 0.19,0.28 0.28,0.83 0.24,0.56 0.45,0.79 0.23,0.27 0.18,0.09 0.15,-0.07 0.38,-0.34 0.25,-0.16 0.26,-0.1 0.39,0 0.23,0.14 0.23,0.31 0.13,0.11 0.11,0.03 0.15,-0.1 0.19,-0.16 0.33,-0.16 0.4,-0.1 1.71,0.08 2.05,-0.62 3.16,-2.51 0.65,-0.39 0.79,-0.23 0.75,-0.11 2.93,-1.17 1.55,-0.91 1.16,-1.06 0.5,0.19 0.79,2.2 0.17,0.71 0.07,0.6 0,1.22 0.09,0.91 0.18,0.55 0.19,0.39 0.2,0.21 0.19,0.11 0.18,0.06 0.17,0.02 1.23,-0.11 0.65,0.17 0.58,1.17 0.5,6.88 2.9,2.69 1,1.24 0.85,1.65 0.09,0.26 0.04,0.19 0,0.31 0.02,0.17 0.09,0.32 0.5,1.11 0.28,0.4 0.38,0.34 0.18,0.21 0.12,0.2 0.05,0.17 0.02,0.11 -0.04,0.42 0.1,0.44 0.29,0.47 0.71,0.93 0.36,0.57 0.22,0.51 0.23,4.62 0.63,0.22 0.12,0.08 0.1,0.1 0.04,0.17 0.04,0.41 0.09,0.12 0.19,-0.02 0.81,-0.46 2.02,-0.81 3.32,-0.38 1.11,-0.54 0.62,-0.55 0.64,-0.72 0.48,-0.66 0.3,-0.69 0.03,-0.55 -0.1,-0.46 0.03,-0.19 0.29,0.07 1.36,1.08 3.03,1.36 0.48,-0.41 0.17,-0.22 0.2,-0.31 0.31,-0.63 0.16,-0.18 0.17,-0.12 1.1,-0.48 2.11,-1.35 0.54,-0.5 0.91,-1.15 0.29,-0.23 2.46,-1.27 0.24,-0.35 0.08,-0.47 -0.29,-0.71 -1.01,-1.47 -0.24,-0.45 -0.14,-0.47 0.01,-0.47 0.25,-0.54 0.42,-0.6 0.06,-0.29 -0.05,-0.57 0.04,-0.49 0.5,-1.7 0.19,-1.01 0.11,-0.36 0.13,-0.29 0.57,-0.85 0.13,-1.72 -0.24,-6.34 -0.4,-0.6 -0.21,-0.21 -0.4,-0.24 -0.54,-0.17 -1.67,-0.16 -1.84,0.17 -0.33,-0.01 -3.16,-1.03 -1.62,-0.33 -0.35,0 -1,0.25 -0.53,-0.28 -0.72,-0.65 -3.38,-4.04 -2.74,-2.09 -1.94,-1.07 -0.23,-0.29 -0.13,-0.47 0.13,-2.16 -0.05,-0.58 -0.16,-0.62 -0.62,-1.57 -0.25,-1.48 -0.36,-0.94 -0.23,-1.42 -0.03,-2.21 0.29,-2.67 -0.07,-13.239996 -0.06,-0.48 0.21,-0.27 0.61,-0.49 0.39,-0.18 0.28,-0.21 0.12,-0.25 0.09,-0.53 0.02,-0.35 0.7,-1.2 1.33,-0.51 0.38,-0.29 0.21,-0.2 0.21,-0.89 1.15,-1.93 -1.15,-1.98 -0.78,-0.96 -1.82,-1.38 -0.39,-0.56 -0.28,-0.75 -0.06,-1.19 0.18,-1.39 -0.05,-0.66 -0.21,-0.78 -1.12,-2.93 -0.13,-1.64 0.3,-3.47 0.38,-1.59 0.23,-0.48 0.55,-0.76 0.25,-0.26 0.1,-0.22 -0.07,-0.17 -0.41,-0.2 -0.41,-0.1 -0.43,-0.05 -0.27,-0.08 -0.18,-0.64 -0.14,-1.21 -0.18,-6.32 0.29,-1.19 -0.02,-0.06 z"
        />
      <path
        id="AF-NAN"
        title="Nangarhar"
        
        d="m 495.44715,234.78119 -0.35,-0.19 -0.27,-0.17 -1.51,-2.01 -0.26,-1.09 0,-0.93 0.22,-1.4 0.23,-0.89 0.33,-0.71 0.12,-0.47 0.09,-0.88 0,-0.32 -0.05,-0.35 -0.22,-0.72 -0.18,-0.44 -0.79,-1.08 -1.3,-0.76 -1.46,0.46 -1.7,0.87 -1.52,1.17 -0.51,0.65 -0.32,0.69 -0.35,2.37 -0.54,0.39 -2.59,0.98 -1.18,1 0.79,3.9 -0.03,1.02 -0.09,0.83 -1.24,2.58 -1.35,1.02 -0.62,0.54 -2.43,1.23 -2.74,0.8 -5.13,0.88 -2.88,1.34 -0.82,0.17 -2.83,-0.61 -2.74,0.53 -5.22,0.6 -1.47,-0.48 -5.62,0.67 -1.62,0.38 -0.04,0.13 0,0.21 0.03,0.27 0.22,0.82 0,0.31 -0.11,0.5 -0.35,0.57 -1.94,2.6 -2.99,3.1 -2.43,1.8 -0.79,0.44 -0.29,0.25 -0.15,0.2 -0.06,0.42 0.32,2.12 0.92,0.19 3.61,-2.53 5.7,-2.66 1.03,-0.35 0.48,-0.08 0.35,0.09 0.23,0.19 0.34,0.45 0.13,0.14 0.09,0.08 0.42,0.23 0.14,0.12 0.1,0.13 0.15,0.27 0.11,0.18 0.13,0.09 0.55,0.26 0.22,0.15 0.18,0.17 0.12,0.24 0.21,0.61 0.5,0.85 0.17,0.47 0.12,0.21 0.13,0.16 0.36,0.37 0.13,0.17 0.09,0.17 0.24,0.83 0.74,0.94 0.4,0.43 0.52,0.87 0.5,1.99 0.86,1.24 0.38,0.55 0.52,-0.18 2.57,-0.4 1.64,0.11 10.47,3.69 2.76,0.27 1.66,0.84 0.89,0.26 3.92,0.17 4,0.86 1.48,0.06 6.51,-0.94 6.55,0.07 3.44,-0.66 0.86,-1.72 0.21,-0.75 0.49,-0.14 1.3,0.42 0.9,0.08 0.69,-0.23 0.57,-0.53 0.55,-0.79 1,-0.35 2.38,-0.5 0.77,-0.72 0.22,-1.1 -0.16,-0.93 -0.05,-0.96 0.54,-1.17 1.35,-1.56 0.3,-0.78 0.07,-1.41 -0.14,-1.18 -0.47,-2.05 0.01,-1.07 1.42,-4.09 -0.21,-1.45 -3.45,-1.93 -1.51,-1.45 -1.37,-1.69 -1,-1.51 -0.47,-1.11 -0.27,-1.31 0.07,-1.3 0.56,-1.04 0.71,-0.33 -0.06,0.01 -5.9,0.43 -1.81,-0.26 -2.55,1.11 -1.39,0.14 -0.47,-1.42 0.19,-0.28 0.29,-0.36 0.65,-0.37 0.27,-0.23 0.15,-0.23 0.06,-0.25 -0.22,-0.24 -0.41,-0.25 -1.01,-0.24 -0.55,-0.05 -0.44,0.07 -0.49,0.3 -0.21,0.09 z"
        />
      <path
        id="AF-KDZ"
        title="Kunduz"
        
        d="m 425.06715,84.321194 -4.59,-3.11 -0.25,-0.12 -1.08,-0.74 -0.45,-0.51 -0.86,-2.16 -0.88,-0.74 -1.1,-0.73 -0.97,-0.88 -0.71,-2.22 -0.76,-1.07 -0.98,-0.9 -0.96,-0.54 -3.31,-0.41 -0.17,-0.08 -0.28,-0.06 -0.13,0.21 0.25,0.72 0.31,0.4 0.79,0.59 0.22,0.26 0.17,0.88 -0.25,0.55 -0.54,0.14 -0.7,-0.32 -0.65,-0.86 -0.43,-0.98 -0.55,-0.78 -1.01,-0.26 -1.07,0.35 -0.18,0.69 0.58,1.84 0.12,1.3 -0.2,0.59 -0.58,-0.04 -1.8,-1.17 -0.57,-0.27 -0.63,-0.06 -1,0.1 -1.89,-0.27 -0.88,0.04 -0.55,0.65 0.25,0.24 0.13,0.27 0.28,0.74 -1.09,0.17 -0.6,0.88 -0.27,0.98 -0.19,0.46 -0.87,0.13 -1.82,0.58 -0.97,0.12 -0.23,0.27 -0.67,1.17 -0.43,0.26 -0.52,0.05 -2.3,0.52 -3.01,0.23 0.69,1.42 -0.32,0.91 -0.95,0.48 -1.26,0.13 -0.96,-0.22 -0.94,-0.37 -0.94,-0.08 -0.92,0.67 -0.36,1.01 0.04,1.23 0.32,2.55 -0.51,0.87 -1.17,-0.01 -1.99,-0.67 -1.27,0.18 -0.9,0.75 -0.77,0.8 -0.9,0.38 -0.6,0.38 -3.21,2.77 -0.49,0.33 -0.59,0.24 -0.38,-0.01 -0.01,0.08 0.47,2.51 0.1,3.479996 0.09,0.51 2.61,6.4 1.3,2.3 0.3,0.35 0.78,0.57 0.97,0.92 0.67,0.9 0.32,0.66 0.37,1.43 0.86,0.87 1.59,0.46 2.35,0.56 1.21,0.7 0.45,0.14 2.58,-0.13 7.91,0.55 4.11,1.17 0.56,0.04 0.5,-0.07 0.78,-0.3 2.98,-0.43 0.6,1.34 3.08,3.89 2.12,1.68 0.52,0.31 0.44,0.12 0.33,-0.08 0.35,-0.15 1.35,-0.85 0.27,-0.12 0.24,-0.04 1.2,0.24 2.32,0.44 0.59,0.27 0.05,0.13 0.05,0.12 0.06,0.07 0.57,0.44 0.33,0.36 0.59,0.78 1.39,1.24 0.94,0.6 1.96,0.71 0.88,0.13 1.85,0.48 0.61,0.28 0.39,0.28 0.22,0.33 0.18,0.33 0.67,0.98 -0.01,-0.97 -0.11,-0.48 -0.2,-0.63 -0.45,-0.89 -0.18,-0.63 -0.03,-0.81 0.07,-0.6 -0.02,-0.54 -0.16,-0.46 -0.44,-0.57 -0.6,-1.03 -0.53,-2.18 -0.49,-0.85 -0.41,-0.58 -0.01,-0.25 0.04,-0.2 0.76,-0.72 0.58,-0.24 0.21,-0.13 0.11,-0.13 0.07,-0.15 0.05,-0.17 0.09,-0.16 0.13,-0.16 1.37,-1.13 0.21,-0.27 0.2,-0.3 0.16,-0.42 0.36,-1.34 0.93,-2.03 0.06,-0.52 -0.04,-0.55 -0.57,-1.24 -0.31,-0.52 -0.13,-0.14 -0.12,-0.09 -0.1,-0.03 -0.25,-0.04 -0.16,-0.1 -0.07,-0.23 0.08,-0.54 0.02,-0.45 -0.06,-0.49 -0.2,-0.57 -0.43,-0.77 -0.04,-0.1 -0.03,-0.26 0.02,-0.18 0.07,-0.13 0.32,-0.4 0.07,-0.4 0.05,-1.28 -0.18,-1.24 0.04,-0.42 0.04,-0.22 0.66,-0.72 2.23,-0.26 0.13,-0.05 0.18,-0.1 0.53,-0.64 0.56,-1.699996 0.58,-8.51 -0.02,-0.5 -0.15,-0.8 -0.07,-0.59 0,-0.57 0.33,-1.41 0.11,-0.23 0.91,-1.2 -0.03,-0.37 -0.06,-0.28 -1.33,-1.54 -0.07,-0.21 -1.12,0.24 -0.96,0.46 -0.98,0.09 z"
        />
      <path
        id="AF-KNR"
        title="Kunar"
        
        d="m 531.75715,214.23119 0.71,-0.29 0.47,-0.41 0.34,-0.63 0.42,-1.37 0.39,-0.63 0,0 0,0 0,-0.01 0.53,-0.38 0.34,-0.48 0.08,-0.55 -0.26,-0.6 0.07,-2.6 1.26,-1.57 3.35,-2.35 1.22,-1.89 0.42,-1.16 -0.2,-0.8 -1.48,-1.2 -2.69,-3.11 -0.87,-1.5 0.08,-1.61 1.49,-1.94 2.37,-2.07 0.48,-0.88 0.07,-1.16 -0.41,-0.8 -0.64,-0.73 -0.36,-0.52 -0.33,0.61 -0.34,0.4 -0.48,0.42 -1.04,0.72 -0.61,0.29 -1.01,0.34 -0.4,0.27 -0.35,0.6 -0.33,0.37 -1.13,0.52 -0.22,0.28 -0.17,0.41 -0.42,1.64 -0.45,0.34 -2.1,0.2 -0.87,-0.21 -0.73,-0.62 -0.66,0.09 -5.77,2.2 -1.26,0.9 -0.68,1 -0.57,1.01 -0.27,0.96 0,2.11 -1.05,1.36 -0.26,0.45 -0.28,0.66 -0.39,2.1 -0.46,1.17 -0.24,0.49 -0.51,0.35 -0.39,-0.8 -0.2,-0.27 -0.25,-0.15 -0.47,0.23 -0.43,0.27 -1.96,2.4 -1.46,-0.43 -0.39,-0.17 -0.68,-0.12 -0.74,0 -3.28,0.56 -0.58,0.18 -0.56,0.27 -0.66,0.08 -0.48,-0.02 -2.71,-0.92 -2.22,-0.39 -0.78,-0.25 -0.93,-0.44 -1.43,-0.92 -1.68,-0.78 -1.13,3.33 -0.34,0.78 -2.29,4.04 0.6,0.79 0.23,0.71 0.07,0.63 -0.01,0.54 0.04,0.57 0.27,0.7 0.6,1.14 0.28,1.09 0.14,1.11 -0.02,2.33 -0.21,1.86 1.3,0.76 0.79,1.08 0.18,0.44 0.22,0.72 0.05,0.35 0,0.32 -0.09,0.88 -0.12,0.47 -0.33,0.71 -0.23,0.89 -0.22,1.4 0,0.93 0.26,1.09 1.51,2.01 0.27,0.17 0.35,0.19 0.21,-0.09 0.49,-0.3 0.44,-0.07 0.55,0.05 1.01,0.24 0.41,0.25 0.22,0.24 -0.06,0.25 -0.15,0.23 -0.27,0.23 -0.65,0.37 -0.29,0.36 -0.19,0.28 0.47,1.42 1.39,-0.14 2.55,-1.11 1.81,0.26 5.9,-0.43 0.06,-0.01 0.12,-0.05 1.03,-0.01 1.97,0.31 0.88,-0.44 0.53,-1.18 0.16,-1.44 -0.18,-1.22 -0.36,-1.31 0.06,-0.9 0.51,-0.69 3.41,-2.8 1.87,-0.99 0.66,-0.65 2.55,-3.67 0.74,-2.01 0.9,-1.82 1.72,-1.33 5.84,-2.38 z"
        />
      <path
        id="AF-NUR"
        title="Nuristan"
        
        d="m 538.93715,182.99119 -0.27,-0.4 -0.29,-1.33 0.21,-1.13 0.33,-1.07 0.03,-1.15 -0.45,-0.88 -0.8,-0.6 -2.67,-1.32 -0.97,-0.79 -0.46,-1.01 0.61,-1.2 0.88,-1.13 0.28,-1.09 -0.21,-1.06 -0.61,-1.04 -0.33,-0.33 -0.71,-0.57 -0.28,-0.42 -0.22,-0.67 0,-0.54 0.05,-0.52 -0.06,-0.59 -0.31,-0.89 -1.62,-2.93 -0.7,-0.9 -2.2,-1.58 -0.51,-0.9 -0.21,-1.97 -0.72,-0.85 -1.41,-0.6 -1.37,-0.31 -1.3,-0.54 -1.24,-1.35 -0.68,-0.52 -1.75,-0.97 -0.53,-0.49 -0.05,-0.22 0,0 -0.75,0.63 -0.54,0.62 -0.47,0.72 -0.7,1.31 -0.4,0.64 -0.38,0.45 -0.63,0.49 -0.26,0.46 -0.23,0.67 -0.38,2.23 -0.1,1.11 -0.15,0.61 -0.24,0.62 -1.41,2.16 -0.42,0.81 -0.22,0.32 -0.28,0.23 -0.71,0.38 -0.72,0.28 -0.29,0.18 -0.26,0.37 -0.19,0.54 -0.16,0.93 0.14,0.67 0.22,0.37 1.12,0.65 0.34,0.28 0.29,0.32 0.24,0.36 -0.03,0.43 -0.28,0.45 -1.4,1.28 -0.93,1.66 -1.78,0.81 -0.93,-0.09 -0.34,-0.09 -0.34,-0.03 -0.3,0.12 -0.29,0.28 -0.44,1.01 -0.13,0.51 0.05,0.38 0.08,0.41 0.03,0.35 -0.06,0.66 0.06,0.3 0.27,0.62 0.07,0.33 0.09,0.73 0.18,0.8 0.03,0.42 -0.06,0.4 -0.12,0.32 -0.58,0.92 -0.12,0.27 -0.38,0.13 -0.63,-0.05 -2.44,-0.6 -1.73,0.25 -1.35,-0.52 -0.77,-0.81 -0.98,-1.29 -0.32,-0.25 -0.44,0.08 -0.49,0.38 -0.84,1.11 -0.22,0.56 -0.04,0.49 0.05,0.3 -0.02,0.31 -0.08,0.31 -0.12,0.32 -0.34,0.39 -0.48,0.37 -1.04,0.55 -1.29,0.46 -1.62,-0.23 -0.27,-0.75 -0.12,-0.87 -0.02,-0.51 0.04,-0.97 0.07,-0.52 0.29,-1.01 0.49,-1.21 0.1,-0.41 0.04,-0.45 -0.08,-0.48 -0.2,-0.44 -0.36,-0.51 -2.12,-2.34 -0.16,-0.42 -0.08,-0.4 -0.1,-0.83 -0.12,-0.37 -0.16,-0.34 -0.35,-0.32 -0.48,-0.28 -2.24,-0.75 -1.35,-0.72 -0.56,-0.11 -0.6,0.06 -0.88,0.39 -0.53,0.36 -1.16,1.06 -1.19,0.37 -3.05,-0.59 -0.56,1.46 -0.2,2.82 -0.23,0.78 -0.37,0.54 -1.2,0.69 -0.32,0.23 -0.08,0.31 0.02,0.68 0.13,0.27 0.17,0.24 0.11,0.29 -0.05,0.44 -0.26,0.64 -0.42,0.77 -0.61,0.69 -0.79,0.62 -1.13,0.35 -0.69,0.02 -0.49,-0.16 -0.27,-0.14 -0.25,0.05 -0.83,1.42 -0.22,0.6 -1.13,1.58 -3.61,1.89 -0.83,0.53 -0.5,0.5 -0.4,0.64 -0.08,0.76 1.95,1.72 0.47,0.9 0.23,0.6 -0.12,3.15 0.28,1.03 1.26,2.02 0.3,0.64 0.19,0.59 0.14,2.33 0.48,1 0.44,0.37 1.66,-0.08 3.88,0.69 1.31,1.24 0.67,2.52 1.27,1.74 1.06,1.14 1,2.17 0.55,0.36 2.22,0.35 2.28,1.39 0.66,0.18 0.69,-0.02 2.52,-0.73 2.57,-1.08 0.57,-0.32 2.31,-1.94 0.9,-1.26 2.29,-4.04 0.34,-0.78 1.13,-3.33 1.68,0.78 1.43,0.92 0.93,0.44 0.78,0.25 2.22,0.39 2.71,0.92 0.48,0.02 0.66,-0.08 0.56,-0.27 0.58,-0.18 3.28,-0.56 0.74,0 0.68,0.12 0.39,0.17 1.46,0.43 1.96,-2.4 0.43,-0.27 0.47,-0.23 0.25,0.15 0.2,0.27 0.39,0.8 0.51,-0.35 0.24,-0.49 0.46,-1.17 0.39,-2.1 0.28,-0.66 0.26,-0.45 1.05,-1.36 0,-2.11 0.27,-0.96 0.57,-1.01 0.68,-1 1.26,-0.9 5.77,-2.2 0.66,-0.09 0.73,0.62 0.87,0.21 2.1,-0.2 0.45,-0.34 0.42,-1.64 0.17,-0.41 0.22,-0.28 1.13,-0.52 0.33,-0.37 0.35,-0.6 0.4,-0.27 1.01,-0.34 0.61,-0.29 1.04,-0.72 0.48,-0.42 0.34,-0.4 0.33,-0.61 z"
        />
      <path
        id="AF-BDS"
        title="Badakhshan"
        
        d="m 508.89715,0.25119373 -1.13,0.04 -0.35,0.44 0.16,1.40999997 -0.51,0.63 -1.16,-0.29 -2,-0.96 -0.57,0.09 -0.28,0.27 -0.18,0.28 -0.33,0.17 -0.43,-0.03 -0.79,-0.27 -0.44,-0.09 -1.53,0 -0.79,0.18 -0.33,0.43 -0.6,1.06 -2.84,0.3 -0.89,0.57 0,0.42 0.96,0.74 -0.39,0.72 -1.71,1.29 -0.45,0.25 -1.11,-0.07 -0.45,0.26 -0.2,0.55 -0.01,0.64 0.05,0.63 0,0.5200003 -0.66,2.11 -0.49,0.25 -0.66,0.17 -0.59,0.34 -0.45,1.52 -1.42,2.82 -1.26,3.4 -0.6,1.04 -0.5,0.5 -1.65,0.72 -0.51,0.38 -2.15,2.23 -2.17,2.9 -0.41,0.3 -0.94,0.5 -0.23,0.13 -0.25,0.32 -0.24,0.55 -0.53,0.23 -0.58,0.11 -0.33,0.19 -0.17,0.57 -0.02,0.52 0.17,0.51 0.38,0.49 -1.13,0.43 -1.14,0.19 -1.09,-0.22 -0.97,-0.81 -0.57,1.56 0.23,1.89 0.68,1.79 0.82,1.28 0.55,0.26 1.6,0.5 0.33,0.52 0.13,0.87 0.32,0.81 0.44,0.65 0.46,0.43 -0.26,0.71 0.1,0.85 0.49,1.79 0.06,0.9 -0.12,0.54 -0.17,0.49 -0.1,0.77 -0.61,0.89 -0.23,0.17 -0.2,0.22 0.01,0.49 0.07,0.56 -0.06,0.41 -0.28,0.45 -0.1,0.13 -0.25,0.25 -0.16,-0.06 -0.94,0.04 -0.09,0.02 -0.71,1.79 -0.12,0.53 -0.32,0.2 -1.69,2.12 -1.4,0.56 -1.46,-0.27 -1.44,-0.52 -1.34,-0.23 0.31,0.46 -1.51,-0.28 -0.45,-0.18 -0.17,-0.15 0.02,0.06 -0.29,1.19 0.18,6.32 0.14,1.21 0.18,0.64 0.27,0.08 0.43,0.05 0.41,0.1 0.41,0.2 0.07,0.17 -0.1,0.22 -0.25,0.26 -0.55,0.76 -0.23,0.48 -0.38,1.59 -0.3,3.47 0.13,1.64 1.12,2.93 0.21,0.78 0.05,0.66 -0.18,1.39 0.06,1.19 0.28,0.75 0.39,0.56 1.82,1.38 0.78,0.96 1.15,1.98 -1.15,1.93 -0.21,0.89 -0.21,0.2 -0.38,0.29 -1.33,0.51 -0.7,1.2 -0.02,0.35 -0.09,0.53 -0.12,0.25 -0.28,0.21 -0.39,0.18 -0.61,0.49 -0.21,0.27 0.06,0.48 0.07,13.239996 -0.29,2.67 0.03,2.21 0.23,1.42 0.36,0.94 0.25,1.48 0.62,1.57 0.16,0.62 0.05,0.58 -0.13,2.16 0.13,0.47 0.23,0.29 1.94,1.07 2.74,2.09 3.38,4.04 0.72,0.65 0.53,0.28 1,-0.25 0.35,0 1.62,0.33 3.16,1.03 0.33,0.01 1.84,-0.17 1.67,0.16 0.54,0.17 0.4,0.24 0.21,0.21 0.4,0.6 0.24,6.34 -0.13,1.72 -0.57,0.85 -0.13,0.29 -0.11,0.36 -0.19,1.01 -0.5,1.7 -0.04,0.49 0.05,0.57 -0.06,0.29 -0.42,0.6 -0.25,0.54 -0.01,0.47 0.14,0.47 0.24,0.45 1.01,1.47 0.29,0.71 -0.08,0.47 -0.24,0.35 -2.46,1.27 -0.29,0.23 -0.91,1.15 -0.54,0.5 -2.11,1.35 -1.1,0.48 -0.17,0.12 -0.16,0.18 -0.31,0.63 -0.2,0.31 -0.17,0.22 -0.48,0.41 -0.94,2.68 -0.17,2.64 -0.23,1.02 -0.35,2.97 -0.01,0.66 -0.35,0.78 3.05,0.59 1.19,-0.37 1.16,-1.06 0.53,-0.36 0.88,-0.39 0.6,-0.06 0.56,0.11 1.35,0.72 2.24,0.75 0.48,0.28 0.35,0.32 0.16,0.34 0.12,0.37 0.1,0.83 0.08,0.4 0.16,0.42 2.12,2.34 0.36,0.51 0.2,0.44 0.08,0.48 -0.04,0.45 -0.1,0.41 -0.49,1.21 -0.29,1.01 -0.07,0.52 -0.04,0.97 0.02,0.51 0.12,0.87 0.27,0.75 1.62,0.23 1.29,-0.46 1.04,-0.55 0.48,-0.37 0.34,-0.39 0.12,-0.32 0.08,-0.31 0.02,-0.31 -0.05,-0.3 0.04,-0.49 0.22,-0.56 0.84,-1.11 0.49,-0.38 0.44,-0.08 0.32,0.25 0.98,1.29 0.77,0.81 1.35,0.52 1.73,-0.25 2.44,0.6 0.63,0.05 0.38,-0.13 0.12,-0.27 0.58,-0.92 0.12,-0.32 0.06,-0.4 -0.03,-0.42 -0.18,-0.8 -0.09,-0.73 -0.07,-0.33 -0.27,-0.62 -0.06,-0.3 0.06,-0.66 -0.03,-0.35 -0.08,-0.41 -0.05,-0.38 0.13,-0.51 0.44,-1.01 0.29,-0.28 0.3,-0.12 0.34,0.03 0.34,0.09 0.93,0.09 1.78,-0.81 0.93,-1.66 1.4,-1.28 0.28,-0.45 0.03,-0.43 -0.24,-0.36 -0.29,-0.32 -0.34,-0.28 -1.12,-0.65 -0.22,-0.37 -0.14,-0.67 0.16,-0.93 0.19,-0.54 0.26,-0.37 0.29,-0.18 0.72,-0.28 0.71,-0.38 0.28,-0.23 0.22,-0.32 0.42,-0.81 1.41,-2.16 0.24,-0.62 0.15,-0.61 0.1,-1.11 0.38,-2.23 0.23,-0.67 0.26,-0.46 0.63,-0.49 0.38,-0.45 0.4,-0.64 0.7,-1.31 0.47,-0.72 0.54,-0.62 0.75,-0.63 0,0 -0.19,-0.9 0.46,-0.93 1.56,-1.58 0.24,-0.56 0.25,-1.27 0.26,-0.44 1.9,-1.25 1.48,-0.7 0.45,-0.33 0.34,-0.56 0.24,-1.28 0.25,-0.4 3.07,-1.08 0.99,-0.77 3.7,-4.16 0.81,-0.55 0.91,-0.33 1.18,-0.25 0.94,-0.51 -0.27,-0.79 -0.51,-0.93 0.24,-0.92 1.22,-1.21 0.39,-0.64 0.41,-0.97 0.58,-1.86 0.47,-0.52 0.91,-0.1 0.97,0.41 2.8,1.89 1.42,1.54 0.72,0.29 0.77,-0.05 0.76,-0.28 0.57,-0.67 -0.14,-0.82 -0.82,-1.64 -0.07,-1.9 1,-0.65 3.14,-0.21 0.79,-0.29 0.62,-0.54 0.59,-0.63 0.67,-0.55 2.3,-1.33 0.78,-0.81 1.01,-0.57 1.99,-0.49 0.78,-0.74 0.06,-0.55 -0.2,-0.51 -0.08,-0.5 0.42,-0.51 0.57,-0.32 1.22,-0.4 2.82,-0.39 0.85,-0.5 -0.34,-0.99 -0.73,-1.17 0.19,-0.77 0.78,-0.56 2.13,-0.91 4.29,-0.99 2.14,-0.13 2,-0.66 2.22,0.15 1.02,-0.28 3.04,-2.58 2.35,-1.21 3.12,-0.75 3.21,-0.23 4.05,0.6 4.29,-0.22 1.41,-0.39 1.18,-0.629996 1.2,-0.3 1.5,0.619996 0.66,0.03 0.58,-0.279996 1.16,-0.81 0.79,-0.29 7.24,-0.77 1.53,0.16 1.42,0.38 0.72,0.09 0.69,-0.08 2.43,-0.86 2.32,0.17 3.21,-0.44 1.5,0.22 1.58,0.26 6.34,-1.09 3.37,0.14 0.07,0.01 0.01,0 0.03,0 2.96,0.13 2.97,0.55 1.5,0.63 3.97,2.519996 1.45,0.37 1.43,0.55 1.41,0.01 2.86,-0.95 0.47,-0.61 0.23,-2.079996 0.32,-0.84 0.69,-0.54 0.8,-0.2 3.18,0.4 1.17,-0.43 2.37,-1.94 4.05,-2.58 1.26,-1.05 2.01,-0.56 1.04,-0.07 0.95,0.31 0.18,0.14 0.16,0.18 0.88,1.31 0.95,0.85 0.78,-0.23 0.33,-1.93 0.19,-0.46 0.06,-0.45 -0.09,-0.41 -0.25,-0.36 -1.12,-0.52 -0.65,-1.02 -0.57,-1.18 -0.85,-1.02 -3.02,-1.5 -1.54,-1.14 -0.8,-1.29 0.11,-1.17 0.68,-0.31 1.84,0.25 1.03,-0.15 0.73,-0.42 0.54,-0.76 0.43,-1.23 0.52,-0.97 0.62,-0.34 1.56,-0.04 2.12,-0.6 0.68,-0.08 0.32,0.16 0.6,0.64 0.29,0.12 0.41,-0.15 0.19,-0.22 0.13,-0.24 0.63,-0.61 0.16,-0.4 0.23,-0.29 0.97,-0.1 0.26,-0.15 1.09,-1.01 0.51,-0.64 0.59,-0.42 0.77,0.1 0.32,0.47 1.91,4.19 0.52,0.34 0.92,-0.09 3.84,-0.95 -1.44,-0.82 -2.22,-3.8 -1.37,-1.48 -6.21,-3.83 -1.41,0.78 -4.93,0.33 -0.42,0.01 -0.41,-0.1 -1.75,-0.54 -1.06,-0.46 -0.91,0.08 -0.85,0.19 -1.41,-0.26 -0.54,-0.02 -0.49,-0.16 -0.7,-1.19 -0.48,-0.31 -0.55,0.04 -0.56,0.39 -0.26,-0.79 -0.57,1.63 -1.18,0.16 -1.41,-0.38 -1.28,0.02 -0.79,0.82 -0.08,2.1 -0.89,1.05 -1.19,0.51 -5.39,1.08 -3.65,1.34 -1.03,0.22 -2.73,1.29 -2.08,0.24 -0.98,0.3 -1.84,1.72 -0.69,0.16 -0.74,-0.19 -1.1,-0.1 -0.48,0.18 -0.79,0.61 -0.52,0.04 -0.33,-0.26 -0.69,-0.95 -0.37,-0.34 -1,-0.08 -2.05,0.64 -0.78,-0.47 -0.21,-1.27 0.62,-1.2 1.02,-0.89 1.02,-0.37 1.86,-0.19 0.71,-0.35 0.83,-0.7 0.82,-0.97 0.32,-0.88 0.01,-2.57 0.06,-0.5 0.31,-1.54 -1.73,-0.21 -2.1,0.04 -3.37,-0.9 -5.81,-2.15 -2.17,0.07 -3.01,1.67 -0.81,-0.24 -0.81,-0.49 -1.16,-0.15 -1.2,0.12 -0.99,0.34 -0.76,0.57 -2.37,2.55 -0.53,0.25 -1.04,-0.4 -0.43,0.15 -1.85,1.46 -0.76,0.94 -0.83,1.78 -0.56,0.84 -0.98,0.67 -3.49,0.35 -3.46,2.1 -1.07,1.29 -1.2,0.42 -2.28,0.43 -1.93,1.19 -1.44,1.99 -2.26,4.72 -2.02,3.19 -0.3,1.17 -0.43,0.57 -7.23,1.08 -1.63,0.83 -3.35,-0.62 -2.18,0.45 -4.91,2 -1.91,1.32 -0.48,0.54 -0.7,1.07 -0.45,0.46 -1.64,0.95 -1.27,1.4 -14.07,10.509996 -1.89,0.79 -2.38,0.45 -2.36,0 -2.28,-0.51 -2.03,-1.07 -1.64,-1.72 -0.65,-1.06 -0.53,-1.14 -0.37,-1.24 -0.33,-2.79 -0.49,-1.219996 -2.75,-4.48 -0.42,-1.09 -0.15,-1.32 0,-2.49 -0.17,-0.71 -0.84,-1.31 -0.29,-0.65 -0.1,-0.74 0.1,-3.67 0.38,-2.5 0.28,-0.93 0.34,-0.55 -0.18,-1.46 1.79,-3.07 0.04,-1.7 0.29,-0.77 0.13,-1.28 -0.09,-2.57 -0.36,-2.35 0.15,-0.87 0.55,-1.37 0.47,-2.45 -0.69,-4.93 0.22,-2.68 0.17,-0.35 0.59,-0.81 0.23,-0.51 0.13,-0.62 0.23,-1.89 0.56,-1.91 0.08,-0.6 -0.11,-0.67 -0.45,-1.31 -0.08,-0.57 0.4,-1.1 1.79,-1.17 0.76,-1.08 0.19,-1.11 0.04,-1.46 -0.08,-1.34 -0.15,-0.74 0.36,-0.43 -1.47,-1.83 -1.47,-1 -1.74,-0.11 -5.92,2.04 -0.88,0.68 -0.96,0.53 -1.04,-0.45 -1.84,-1.5 -0.52,-0.07 -0.37,0.11 -0.25,-0.13 -0.18,-0.79 0.06,-0.65 0.49,-1.39 0.32,-1.57 1.45,-2.73 0.66,-2.52 0.9,-1.75 0.31,-1.8 0.88,-2.67 0.26,-1.4 -0.31,-2.74 -1.15,-1.82 -1.66,-1.11 -4,-1.6800003 -2.99,-3.12 -1.87,-1.38 -1.36,-0.7 -0.6,-0.14 -0.59,0.02 -0.38,0.17 -0.35,0.03 -0.5,-0.42 -0.32,-0.51 -0.41,-1.13 -0.28,-0.49 -0.49,-0.55 -0.5,-0.42999997 -0.56,-0.33 -0.62,-0.17 z"
        />
      <path
        id="AF-PKA"
        title="Paktika"
        
        d="m 408.15715,303.86119 -0.51,-0.1 -0.91,-0.51 -1.25,0.21 -3.54,1.31 -0.11,0.09 -3.38,3.02 -0.56,0.8 -0.51,1.62 -0.21,1.07 -0.31,0.95 -0.47,0.95 -0.56,0.86 -2.89,3.31 -4.54,3.4 -0.58,0.75 -0.37,0.73 -2.21,6.69 -2,2.12 -0.35,0.72 -0.6,0.99 -3.35,3.27 -0.58,0.5 -0.48,0.44 -0.09,0.23 -0.11,0.56 -0.08,0.92 -0.36,0.62 -1.28,1.33 -1.97,1.53 -0.64,0.37 -1.29,0.51 -1.29,0.27 -2.94,0.22 -0.63,0.15 -0.39,-0.04 -0.47,-0.19 -2,-1.28 -4.15,-4.11 -2.38,2.84 -1.95,3.51 -0.13,0.35 -0.05,0.25 0.02,0.26 1.03,1.16 4.49,3.43 0.39,1.35 0.45,0.61 1.42,0.94 2.14,2.09 0.25,0.17 1.02,0.46 0.16,0.12 0.18,0.19 0.19,0.37 0.96,3.03 0.32,1.79 0.2,0.63 0.09,0.46 -0.02,0.38 -0.4,1.07 -0.15,0.6 -0.01,0.63 0.35,2.35 -0.1,2.13 -0.48,0.68 -0.14,0.35 -0.09,0.46 0.1,0.66 0.64,2.39 0.06,0.49 0.01,0.49 -0.32,1.59 -1.3,3.03 0.83,2.7 0.37,2.12 0.03,0.43 -0.01,0.18 -0.15,0.54 -0.58,1.56 -0.86,2 -1.45,2.22 -0.19,0.43 -0.03,0.32 -0.02,0.35 0.05,0.88 0.15,1.14 0.13,0.57 0.15,0.52 0.23,0.52 0.26,0.44 0.37,0.43 0.86,0.71 1.79,1.07 0.34,0.25 0.01,0 0.3,-0.55 1.03,-2.43 0.62,-0.76 1,-0.07 1.24,0.44 1.07,0.59 1.23,1.01 0.51,0.76 0.6,0.6 1.06,0.16 1.92,-0.09 1.92,0.15 5.09,1.83 1.79,0.3 0.83,-0.27 1.05,-0.63 0.63,-0.72 -0.44,-0.51 -0.94,-0.13 -2.9,0.07 -1.06,-0.17 -0.84,-0.38 -0.17,-0.56 0.94,-0.74 2.1,-1.12 1.15,-0.4 1.08,-0.02 1.63,0.64 2.83,1.61 2.73,0.51 0.61,0.34 0.32,0.7 0.15,2.31 0.36,0.83 1.25,1.47 2.24,3.24 1.28,0.92 1.93,-0.23 3.08,-1.58 1.65,-0.53 1.76,0.12 1.29,-0.55 1.75,-1.25 1.53,-1.41 0.64,-1.02 0.74,-0.47 0.69,-0.79 5.31,-8.23 1.32,-1.43 2.32,-1.75 0.12,-0.21 0.17,-0.32 -0.13,-0.74 -1.52,-4.35 -0.95,-5.42 0.04,-1.24 0.37,-2.42 0.02,-2.43 0.34,-2.45 0.05,-1.25 -0.18,-1.2 -1.25,-3.21 -0.51,-2.47 0.23,-2.38 0.91,-2.18 1.47,-1.85 0.98,-0.64 2.01,-0.7 0.86,-0.72 2.56,-3.86 0.58,-1.12 0.15,-0.71 -0.48,-1.91 -0.09,-1.01 -0.13,-0.44 -0.34,-0.25 -0.41,-0.17 -0.43,-0.29 -0.34,-0.38 -0.25,-0.45 -0.09,-1.13 0.53,-0.77 1.64,-1.24 1.19,-1.67 1.25,-0.95 0.29,-0.27 0.48,-1.68 -0.91,-6.26 0.47,-0.99 -0.02,0 -4.56,-1.67 -1.86,-0.18 -0.22,-1.41 1.45,-1.65 1.42,-2.08 0.14,-0.47 0.02,-0.62 -0.19,-1.35 -0.19,-0.61 -0.18,-0.45 -0.09,-0.14 0.02,-0.65 0.53,-2.23 -0.97,-0.32 -0.19,-0.12 -0.34,-0.17 -0.78,0.08 -2.22,0.79 -0.88,0.13 -1.01,-0.2 -1.46,-1.16 -0.39,-0.32 -0.14,-0.14 -0.2,-0.15 -0.19,-0.09 -0.32,-0.08 -0.29,-0.02 -0.15,0.07 -0.11,0.15 0.01,0.36 0.04,0.24 0.04,0.18 0.02,0.16 -0.02,0.16 -0.4,0.41 -1.66,1.05 -2.39,1.08 -1.97,1.17 -1.31,1.25 -0.68,0.43 -0.72,0.3 -0.31,0.05 -0.16,0.01 -0.14,-0.03 -0.23,-0.38 -0.25,-1.32 -0.19,-0.64 0.01,-0.49 0.05,-0.28 0.02,-0.31 -0.42,-3.41 -0.04,-1.18 0.2,-2.74 -0.01,-0.6 -0.07,-0.39 -0.16,-0.32 -0.77,-1.06 -0.52,-1.02 -0.19,-0.21 -0.27,-0.21 -1.08,-0.49 -0.25,-0.04 -0.27,0.03 -0.37,0.16 -0.36,0.09 z"
        />
      <path
        id="AF-KHO"
        title="Khost"
        
        d="m 464.83715,285.70119 -2.61,-1.13 -0.74,-0.1 -0.01,0.85 -0.13,0.41 -0.23,0.46 -0.81,0.9 -0.33,0.22 -1.2,0.39 -1.4,0.85 -1.12,0.49 -0.8,0.51 -1.15,0.41 -0.38,0.05 -0.45,0.3 -0.26,0.23 -1.46,2.22 -0.8,-0.62 -0.07,-0.04 -0.13,-0.02 -3.34,0.33 -2.99,0.91 -0.73,0.36 -0.74,0.46 -1.49,1.25 -0.26,0.71 -0.78,1.51 -0.27,0.69 0.05,0.71 0.82,0.89 -1.14,3.7 -0.27,0.69 -0.46,0.73 -0.31,0.38 -1.12,0.67 -2.62,2.35 -0.25,0.39 -0.13,0.63 -0.2,0.72 -0.85,1.03 -0.66,0.74 -0.16,0.28 -0.24,1.19 -0.53,2.23 -0.02,0.65 0.09,0.14 0.18,0.45 0.19,0.61 0.19,1.35 -0.02,0.62 -0.14,0.47 -1.42,2.08 -1.45,1.65 0.22,1.41 1.86,0.18 4.56,1.67 0.02,0 0.46,-0.98 1.29,-1.64 1.61,-1.06 1.96,-0.26 0.99,0.02 1.57,-0.3 0.46,0.14 0.42,0.2 0.44,0.08 0.88,-0.22 2.28,-1.65 1.88,-0.31 3.25,1.62 2.05,-0.15 3.63,-2.22 0.48,-0.1 1.4,0.12 0.59,-0.26 0.37,-0.52 1.63,-3.09 0.57,-0.23 1.16,0.39 1.05,0.09 0.94,-0.54 8.23,-6.95 0.35,-1.91 -0.77,-1.8 -2.56,-2.89 -0.25,-0.43 -0.36,-0.93 -0.34,-0.31 -1.35,-0.45 -0.39,-0.25 -0.67,-0.89 -0.42,-1.05 -0.18,-1.12 0.08,-1.09 0.99,-3.68 0.03,-1.41 -0.18,-0.38 -0.38,-0.27 -0.8,-0.39 -0.44,-0.37 -0.21,-0.3 -0.29,-0.9 -0.41,-2.31 -0.48,-0.63 -2.07,0.37 z"
        />
      <path
        id="AF-GHA"
        title="Ghazni"
        
        d="m 358.21715,260.97119 -2.24,-0.17 -0.66,-0.16 -0.53,-0.27 -1.22,-1.16 -1.5,-1.04 -1.8,-0.69 -1.49,-0.34 -1.22,0.06 -3.29,0.7 -0.39,0.13 -0.43,0.23 -0.62,0.49 -0.32,0.32 -0.19,0.29 -0.29,1.34 -0.1,0.19 -0.24,0.18 -1.51,0.52 -0.81,0.01 -2.29,-0.31 -1.99,1.49 -0.63,0.8 -0.38,0.91 -0.21,0.4 -0.88,2.37 0.89,0.73 0.09,0.37 0.02,0.34 -0.31,0.6 -0.49,1.58 -0.14,0.24 -0.15,0.19 -0.52,0.45 -0.3,0.44 -0.03,0.29 0.12,0.24 0.54,0.35 0.7,0.35 0.08,0.06 0.25,0.39 0.34,0.88 0.66,2.12 -0.02,0.4 -0.17,0.3 -1.02,0.56 -0.36,0.25 -0.33,0.36 -1.66,2.39 -1.03,0.95 -3.06,2.66 -0.44,0.54 -0.55,0.82 -0.36,0.73 -0.76,1.02 -1.03,0.74 -0.98,0.52 -4.61,1.38 -0.27,0.03 -1.2,-0.05 -2.73,0.58 -4.31,1.76 -0.53,0.32 -0.21,0.19 -0.5,0.57 -0.68,1.71 -0.05,0.34 0.01,1.08 1.43,4.23 0.06,1.58 -0.18,0.48 -0.12,0.5 -0.1,0.65 -0.11,2.43 -0.05,0.32 -0.09,0.25 -0.14,0.24 -0.37,0.9 -0.35,2.68 0.73,1.85 1.26,0.23 4.95,-0.25 0.82,0.21 0.29,0.42 0.25,0.63 0.11,0.86 -0.02,0.56 -0.12,0.39 -0.16,0.17 -0.82,0.43 -0.27,0.22 -0.19,0.26 -0.36,0.64 -0.28,0.32 -1.69,1.23 -0.2,0.2 -0.11,0.21 -0.04,0.19 -0.09,0.68 -0.05,0.17 -0.15,0.82 0.08,1.62 -0.02,0.45 -0.1,0.31 -0.08,0.66 -0.02,0.94 0.22,2.07 0.22,1.03 0.33,0.91 0.4,0.59 0.44,0.42 0.59,0.28 2.34,0.54 0.58,0.23 1.5,0.01 0.26,-0.17 0.28,-0.21 0.12,-0.27 0.09,-0.3 0.61,-1.1 0.82,-1.17 0.33,-0.57 0.15,-0.42 -0.06,-0.24 -0.13,-0.26 -0.64,-1 -0.23,-0.44 -0.15,-0.42 -0.03,-0.51 0.09,-0.29 0.18,-0.2 0.24,-0.12 0.65,-0.21 1.34,-0.09 1.42,0.3 0.4,0.17 0.27,0.19 0.12,0.22 0.08,0.26 0.11,1.16 0.12,0.53 0.22,0.54 0.48,0.77 0.31,0.3 0.24,0.14 0.19,0.01 1.51,-0.2 0.49,-0.01 0.21,0.04 0.18,0.13 0.1,0.17 0.06,0.2 0.02,0.19 -0.03,0.43 0.05,0.25 0.15,0.12 0.68,0.21 0.28,0.2 0.42,0.4 0.22,0.11 0.29,-0.01 0.32,-0.1 1.51,0.01 0.32,-0.08 0.32,-0.13 0.25,-0.17 0.24,-0.24 0.43,-0.58 0.58,-0.96 0.79,-0.97 0.21,-0.16 0.3,-0.17 0.55,-0.08 0.24,0.05 0.11,0.14 -0.01,0.19 -0.06,0.2 -0.06,0.15 -0.19,0.33 -0.08,0.18 -0.04,0.15 0,0.13 0.03,0.06 0.05,0.08 0.28,0.31 0.19,0.27 0.09,0.14 0.13,0.27 0.11,0.33 0.08,0.37 0.01,0.33 -0.05,0.3 -0.12,0.27 -0.18,0.23 -0.2,0.21 -0.27,0.19 -1.85,1.03 -0.21,0.21 -0.11,0.27 0.04,0.32 0.25,0.45 0.3,0.22 1.7,0.69 0.39,0.3 0.26,0.3 0.12,0.24 0.05,0.2 -0.02,0.18 -0.08,0.15 -0.14,0.11 -0.21,0.07 -0.7,0.05 -0.17,0.07 -0.15,0.14 -0.14,0.2 -0.13,0.25 -0.1,0.27 -0.06,0.29 0,0.62 0.24,0.69 1.26,1.86 1.23,1.15 0.13,0.21 0.1,0.53 0.14,0.21 7.38,7.42 0.49,0.34 1.61,0.68 0.13,0.16 -0.06,0.19 -3.29,3.67 3.08,2.27 0.78,0.97 0.4,1.94 0.13,0.19 0.14,0.1 1.87,0.31 0.36,0.16 1.58,1.02 0.44,0.43 0.24,0.38 0.02,0.3 -0.05,0.31 -0.12,0.31 -0.22,0.34 -0.64,0.71 -0.82,0.76 -0.86,0.61 -1.33,0.66 -0.25,0.06 -0.2,0.02 -0.16,0 -0.48,-0.08 -0.74,-0.22 -0.18,0 -0.12,0.04 -0.19,0.12 -0.23,0.21 -0.28,0.32 -0.27,0.51 -0.19,0.59 -0.11,0.84 0.08,0.5 0.16,0.34 0.22,0.13 0.19,0.05 0.16,0 1.39,-0.43 0.28,-0.05 0.19,0 0.18,0.04 0.27,0.09 0.33,0.24 0.39,0.38 0.51,0.68 0.2,0.48 0.06,0.54 -0.34,2.19 -0.02,0.52 0.09,0.3 0.14,0.19 0.48,0.34 0.7,0.48 0.31,0.13 3.02,0.44 0.92,0.28 0.66,0.29 0.95,0.77 1.33,0.86 0.76,0.67 0.62,0.45 0.46,0.19 0.45,0.09 3.18,-0.08 0.3,-0.15 1.93,-1.29 1.3,-3.03 0.32,-1.59 -0.01,-0.49 -0.06,-0.49 -0.64,-2.39 -0.1,-0.66 0.09,-0.46 0.14,-0.35 0.48,-0.68 0.1,-2.13 -0.35,-2.35 0.01,-0.63 0.15,-0.6 0.4,-1.07 0.02,-0.38 -0.09,-0.46 -0.2,-0.63 -0.32,-1.79 -0.96,-3.03 -0.19,-0.37 -0.18,-0.19 -0.16,-0.12 -1.02,-0.46 -0.25,-0.17 -2.14,-2.09 -1.42,-0.94 -0.45,-0.61 -0.39,-1.35 -4.49,-3.43 -1.03,-1.16 -0.02,-0.26 0.05,-0.25 0.13,-0.35 1.95,-3.51 2.38,-2.84 4.15,4.11 2,1.28 0.47,0.19 0.39,0.04 0.63,-0.15 2.94,-0.22 1.29,-0.27 1.29,-0.51 0.64,-0.37 1.97,-1.53 1.28,-1.33 0.36,-0.62 0.08,-0.92 0.11,-0.56 0.09,-0.23 0.48,-0.44 0.58,-0.5 3.35,-3.27 0.6,-0.99 0.35,-0.72 2,-2.12 2.21,-6.69 0.37,-0.73 0.58,-0.75 4.54,-3.4 2.89,-3.31 0.56,-0.86 0.47,-0.95 0.31,-0.95 0.21,-1.07 0.51,-1.62 0.56,-0.8 3.38,-3.02 0.11,-0.09 0.28,-1 1.18,-2.61 0.06,-0.5 -0.11,-0.57 -0.43,-1.05 -0.58,-1.09 -0.19,-0.7 -0.12,-1.08 -0.09,-2.06 0.17,-2.12 0,-0.01 -0.14,-1.28 -0.35,-0.43 -0.04,-0.2 0.03,-0.67 -0.06,-0.22 -0.24,-0.2 -0.24,-0.17 -0.2,-0.24 -0.1,-0.31 0.1,-0.62 0.17,-0.46 0.2,-0.4 0.2,-0.19 0.19,-0.1 0.4,-0.08 0.12,-0.08 -0.03,-0.3 -0.16,-0.47 -0.45,-1 -0.38,-1.18 -0.07,-0.38 -0.24,-0.4 -0.19,-0.23 -1.46,-0.7 -1.16,1.14 -2.05,2.55 -0.33,0.27 -4.1,2.41 -0.42,0.17 -0.8,0.09 -0.51,0 -1.94,-0.48 -0.62,-0.28 -0.43,-0.3 -0.13,-0.15 -0.09,-0.13 -0.07,-0.37 0.01,-0.51 0.23,-0.96 0.4,-1.17 0.05,-0.46 0.01,-0.33 -0.45,-1.28 -1.08,0.04 -0.43,0.1 -0.48,0.04 -0.24,-0.01 -0.29,-0.15 -0.32,-0.28 -4.14,-4.37 -0.18,-0.29 -0.71,-0.77 -2.33,-1.45 -0.5,-0.86 -0.25,-0.2 -3.03,-1.23 -0.61,-0.17 -0.49,-0.32 -0.35,-1 -0.03,-0.82 -0.43,-1.46 -0.12,-0.59 -0.03,-0.51 0.07,-0.38 0.02,-0.43 -0.05,-0.43 -0.16,-0.64 -0.06,-0.51 -0.02,-0.49 0.08,-0.85 -0.03,-0.45 -0.48,-2.62 -0.25,-0.55 -0.39,-0.6 -1.46,-1.38 -0.72,-0.49 -1.06,-0.25 -0.69,0.45 -0.16,0.14 -0.34,0.19 -0.26,0.09 -0.7,0.58 -1.39,0.74 -3.09,1.08 -0.74,0.15 -0.64,0.04 z"
        />
      <path
        id="AF-ZAB"
        title="Zabul"
        
        d="m 326.08715,328.39119 -0.19,-0.01 -0.24,-0.14 -0.31,-0.3 -0.48,-0.77 -0.22,-0.54 -0.12,-0.53 -0.11,-1.16 -0.08,-0.26 -0.12,-0.22 -0.27,-0.19 -0.4,-0.17 -1.42,-0.3 -1.34,0.09 -0.65,0.21 -0.24,0.12 -0.18,0.2 -0.09,0.29 0.03,0.51 0.15,0.42 0.23,0.44 0.64,1 0.13,0.26 0.06,0.24 -0.15,0.42 -0.33,0.57 -0.82,1.17 -0.61,1.1 -0.09,0.3 -0.12,0.27 -0.28,0.21 -0.26,0.17 -1.5,-0.01 -0.2,3.41 -0.07,0.42 -0.16,0.59 -0.21,0.32 -0.33,0.6 -0.2,0.24 -0.26,0.15 -0.24,0.08 -0.37,0.25 -0.21,0.1 -0.33,0.04 -0.38,-0.04 -0.41,-0.09 -0.27,-0.11 -0.52,-0.33 -0.43,-0.17 -0.57,0.06 -0.86,0.67 -0.32,0.18 -0.29,0.08 -1.19,-0.06 -1.49,0.11 -0.68,0.17 -0.55,0.29 -0.32,0.32 -3.17,2.02 -0.83,0.66 -0.75,0.76 -0.78,1.06 -0.15,0.26 -0.08,0.27 -0.02,0.28 0.12,0.67 0,0.33 -0.33,0.45 -0.54,0.37 -1.14,0.55 -0.63,0.16 -0.43,0.01 -0.2,-0.12 -0.1,-0.1 -0.06,-0.09 -0.06,-0.19 -0.02,-0.25 0.08,-0.38 1.09,-3.35 0.11,-0.51 0.01,-0.31 -0.06,-0.18 -0.15,-0.14 -0.76,-0.08 -2.14,0.23 -1.46,2.77 -0.78,0.69 -2.38,0.35 -2.31,1.15 -0.4,0.38 -0.58,1.01 -0.62,0.84 -2.38,2.68 -0.43,0.63 -0.04,0.36 0.02,0.4 -0.01,0.5 -0.06,0.57 -0.58,1.18 -0.13,0.33 0.02,0.25 0.13,0.33 0.17,0.34 0.45,0.68 1.55,0.62 0.4,0.04 0.64,-0.01 0.35,-0.16 0.28,-0.24 1.02,-1.57 0.56,-1.36 0.2,-0.38 0.33,-0.45 0.21,-0.18 0.2,-0.06 0.16,0.05 0.17,0.07 0.18,0.05 0.2,-0.01 0.52,-0.09 0.35,0.05 0.2,0.15 0.14,0.2 0.18,0.38 0.12,0.15 0.15,0.14 0.56,0.37 0.33,0.31 0.16,0.09 0.48,0.15 0.35,0.19 0.24,0.28 0.11,0.32 -0.02,0.32 -0.19,0.55 -0.03,0.28 0.07,0.97 -0.01,0.33 -0.03,0.35 -0.55,2.62 -0.11,0.29 -0.48,0.94 -0.64,1.11 -0.2,0.18 -0.45,0.29 -1.74,0.89 -0.52,0.4 -0.36,0.4 -0.65,1.85 -0.27,0.56 -0.56,1 -0.78,0.96 -1.13,0.9 -1.2,1.24 -0.25,0.4 -0.29,0.56 -0.16,0.65 0,0.46 0.09,0.47 0.23,0.59 0.06,0.29 0.06,0.73 0.11,0.4 0.05,0.11 0.03,0.15 0.07,1.27 0.22,1.27 -0.03,0.29 -0.11,0.31 -0.67,1.19 -0.62,1.49 -0.05,0.36 0.08,0.28 0.21,0.17 0.54,0.36 0.42,0.35 0.34,1.23 0.03,1.45 -0.11,0.39 -0.59,1.44 -1.01,1.45 -0.45,0.54 -0.2,0.14 -0.25,0.14 -1.79,0.53 -1.18,0.64 -0.66,0.45 -1.61,1.54 0,1.41 0.14,0.44 0.26,0.56 0.22,0.27 0.18,0.17 1.57,1.03 3.91,4.12 0.11,0.06 0.31,0.01 1.94,-1.37 1.16,-1.23 0.62,-0.49 0.95,-0.57 0.9,-0.38 0.99,-0.2 0.23,0 0.2,0.08 0.21,0.13 0.51,0.07 0.72,0.02 2.16,-0.47 0.52,-0.23 6.17,-5.14 0.57,-0.61 0.21,-0.07 0.18,0.08 0.34,0.46 0.2,0.22 2.28,1.88 0.75,0.78 2.16,1.12 1.93,0.62 0.47,0.21 0.4,0.33 0.4,0.4 0.87,0.72 1.09,0.59 0.77,0.57 0.45,0.22 0.4,0.13 0.28,0.01 1.3,0.3 2.22,0.49 1.07,-0.13 3.41,-1.01 1.01,-0.59 2.07,-0.78 1.33,2.19 0.56,1.72 0.11,0.2 0.13,0.07 0.7,0.07 0.31,0.08 0.36,0.16 0.16,0.11 0.07,0.08 0.67,1.46 0.34,0.42 0.33,0.29 0.52,0.26 0.45,0.17 0.1,0.03 0.11,0 0.12,-0.08 0.17,-0.19 0.26,-0.68 0.14,-0.22 0.2,-0.12 0.79,0.21 2.16,1.24 1.03,1.9 0.19,0.87 -0.07,0.23 -0.4,0.8 -0.13,0.42 0.01,0.26 0.08,0.15 0.26,0.12 0.25,0.07 0.28,0.04 0.26,0.01 0.27,-0.02 1.53,-0.35 0.29,-0.02 3.29,0.15 0.8,-0.09 0.73,-0.18 2.6,-0.98 1.13,-0.02 1.8,0.18 0.39,0.09 2.45,1.23 0.02,0.01 1.59,-1.13 2.99,-3.37 1.35,-0.67 0.67,-0.03 1.47,0.25 1.97,-0.11 0.52,-0.28 0.55,-0.78 0.81,-0.66 2.55,-1.42 0.27,-0.4 0.16,-1.21 0.24,-0.51 1.6,-1.48 0.24,-0.44 -0.01,0 -0.34,-0.25 -1.79,-1.07 -0.86,-0.71 -0.37,-0.43 -0.26,-0.44 -0.23,-0.52 -0.15,-0.52 -0.13,-0.57 -0.15,-1.14 -0.05,-0.88 0.02,-0.35 0.03,-0.32 0.19,-0.43 1.45,-2.22 0.86,-2 0.58,-1.56 0.15,-0.54 0.01,-0.18 -0.03,-0.43 -0.37,-2.12 -0.83,-2.7 -1.93,1.29 -0.3,0.15 -3.18,0.08 -0.45,-0.09 -0.46,-0.19 -0.62,-0.45 -0.76,-0.67 -1.33,-0.86 -0.95,-0.77 -0.66,-0.29 -0.92,-0.28 -3.02,-0.44 -0.31,-0.13 -0.7,-0.48 -0.48,-0.34 -0.14,-0.19 -0.09,-0.3 0.02,-0.52 0.34,-2.19 -0.06,-0.54 -0.2,-0.48 -0.51,-0.68 -0.39,-0.38 -0.33,-0.24 -0.27,-0.09 -0.18,-0.04 -0.19,0 -0.28,0.05 -1.39,0.43 -0.16,0 -0.19,-0.05 -0.22,-0.13 -0.16,-0.34 -0.08,-0.5 0.11,-0.84 0.19,-0.59 0.27,-0.51 0.28,-0.32 0.23,-0.21 0.19,-0.12 0.12,-0.04 0.18,0 0.74,0.22 0.48,0.08 0.16,0 0.2,-0.02 0.25,-0.06 1.33,-0.66 0.86,-0.61 0.82,-0.76 0.64,-0.71 0.22,-0.34 0.12,-0.31 0.05,-0.31 -0.02,-0.3 -0.24,-0.38 -0.44,-0.43 -1.58,-1.02 -0.36,-0.16 -1.87,-0.31 -0.14,-0.1 -0.13,-0.19 -0.4,-1.94 -0.78,-0.97 -3.08,-2.27 3.29,-3.67 0.06,-0.19 -0.13,-0.16 -1.61,-0.68 -0.49,-0.34 -7.38,-7.42 -0.14,-0.21 -0.1,-0.53 -0.13,-0.21 -1.23,-1.15 -1.26,-1.86 -0.24,-0.69 0,-0.62 0.06,-0.29 0.1,-0.27 0.13,-0.25 0.14,-0.2 0.15,-0.14 0.17,-0.07 0.7,-0.05 0.21,-0.07 0.14,-0.11 0.08,-0.15 0.02,-0.18 -0.05,-0.2 -0.12,-0.24 -0.26,-0.3 -0.39,-0.3 -1.7,-0.69 -0.3,-0.22 -0.25,-0.45 -0.04,-0.32 0.11,-0.27 0.21,-0.21 1.85,-1.03 0.27,-0.19 0.2,-0.21 0.18,-0.23 0.12,-0.27 0.05,-0.3 -0.01,-0.33 -0.08,-0.37 -0.11,-0.33 -0.13,-0.27 -0.09,-0.14 -0.19,-0.27 -0.28,-0.31 -0.05,-0.08 -0.03,-0.06 0,-0.13 0.04,-0.15 0.08,-0.18 0.19,-0.33 0.06,-0.15 0.06,-0.2 0.01,-0.19 -0.11,-0.14 -0.24,-0.05 -0.55,0.08 -0.3,0.17 -0.21,0.16 -0.79,0.97 -0.58,0.96 -0.43,0.58 -0.24,0.24 -0.25,0.17 -0.32,0.13 -0.32,0.08 -1.51,-0.01 -0.32,0.1 -0.29,0.01 -0.22,-0.11 -0.42,-0.4 -0.28,-0.2 -0.68,-0.21 -0.15,-0.12 -0.05,-0.25 0.03,-0.43 -0.02,-0.19 -0.06,-0.2 -0.1,-0.17 -0.18,-0.13 -0.21,-0.04 -0.49,0.01 -1.51,0.2 z"
        />
      <path
        id="AF-KAN"
        title="Kandahar"
        
        d="m 252.11715,352.75119 -3.57,-0.68 -0.41,0.03 -0.31,0.07 -0.11,0.05 -0.14,0.11 -0.33,0.31 -1.72,2.18 -0.49,0.83 -0.23,0.67 -0.14,0.91 -0.18,0.68 -0.44,0.82 -0.37,0.47 -0.35,0.32 -0.21,0.12 -0.69,0.26 -0.84,0.42 -0.15,0.13 -0.11,0.13 -0.07,0.35 0,0.56 0.11,1.24 0.3,1.2 -0.01,0.24 -0.27,0.23 -0.46,0.26 -0.18,0.14 -0.09,0.09 -0.07,0.11 -0.08,0.23 -0.25,1 -0.16,0.31 -0.16,0.24 -0.11,0.14 0.01,0.29 0.03,0.24 0.76,1.5 -0.28,0.27 -0.42,0.12 -0.68,0.04 -0.64,-0.11 -0.71,-0.27 -1.84,-1.04 -0.75,-0.26 -2.59,0.13 -0.56,-0.08 -0.42,-0.23 -0.7,-0.87 -0.47,-0.13 -0.78,2.96 -0.02,0.26 -0.11,0.21 -0.19,0.16 -0.85,0.45 -1.39,1.29 -0.19,0.81 -0.04,0.36 -0.09,0.43 -0.39,0.95 -0.06,0.32 -0.06,0.63 -0.1,0.25 -0.2,0.22 -0.4,0.22 -0.16,0.13 -0.11,0.17 0.11,0.19 0.2,0.16 0.2,0.21 0,0.32 -0.13,0.46 -0.36,0.83 -0.71,2.6 -0.26,0.48 -0.33,0.22 -0.75,0.11 -0.97,-0.01 -0.47,-0.1 -0.4,-0.18 -0.79,-0.54 -0.39,-0.16 -0.74,-0.08 -0.44,0.11 -0.42,0.24 -0.81,0.63 -0.9,0.48 -0.28,0.09 -0.25,0.14 -0.25,0.25 -0.26,0.35 -0.35,0.64 -0.39,1.04 -0.04,1.93 -0.43,2.07 -0.26,0.52 -0.76,0.83 -2.14,2.09 -0.34,0.43 -0.84,0.71 -0.15,0.16 -0.12,0.27 -0.16,0.45 -0.92,4.8 -0.03,0.62 0.13,0.4 0.46,0.45 0.35,0.28 0.31,0.18 0.11,0.16 0.02,0.1 -0.4,0.74 -0.76,5.01 -0.09,0.31 -0.76,1.79 -1.47,5.52 -0.65,3.21 -0.69,8.84 -0.16,1.96 -2.17,28.09 -0.66,18.2 -1.43,10.8 -6.34,36.22 -0.02,0.3 0,0.01 8.94,0.08 6.62,0.05 8.06,1.47 2.42,0.08 7.03,-2.06 2.82,-0.83 2.82,-0.82 2.82,-0.83 2.81,-0.82 2.81,-0.82 2.82,-0.83 2.81,-0.83 2.82,-0.82 2.82,-0.83 2.81,-0.82 2.82,-0.83 2.82,-0.82 2.81,-0.83 2.82,-0.82 2.82,-0.83 2.81,-0.83 4.13,-1.21 3.86,-2.79 1.29,-1.71 1,-1.72 0.29,-0.17 0.41,-0.14 0.18,-0.26 -0.39,-0.53 -1.5,-1.16 -1.99,-2.03 -1.71,-1.2 -0.29,-0.75 0.12,-0.89 0.71,-2.12 3.13,-6.4 0.21,-1.07 -0.11,-3.4 0.91,-7.43 -0.11,-1.15 -0.28,-1.15 -0.37,-0.72 -1.17,-1.52 -0.83,-2.24 0.15,-2.45 4.77,-18.15 0.44,-0.78 0.82,-0.45 6.56,-1.34 1.09,-0.49 4.56,-4.7 0.93,-1.3 1.64,-6.39 1.18,-0.82 1.85,-0.26 1.25,-0.96 1.13,-1.3 1.45,-1.27 3.27,-1.61 1.82,-0.53 2.85,-0.06 0.71,0.38 0.35,0.79 0.1,1.26 -0.13,0.46 -0.27,0.35 -0.19,0.35 0.07,0.45 0.37,0.3 0.6,0.2 1.11,0.2 0.98,0.02 1.86,-0.47 0.97,-0.05 0.97,0.3 1.77,0.98 0.99,0.36 0.81,0.09 2.51,-0.12 3.11,0.28 0.89,-0.16 3.36,-1.44 2.88,-0.39 1.79,-0.78 2.59,-0.49 0.9,-0.33 3.09,-2 0.64,-0.58 0.67,-0.49 0.78,-0.23 1.96,0.07 0.75,-0.34 0.5,-1.07 -0.23,-2.38 -1.75,-0.57 -4.03,0.54 -0.96,-0.28 -0.97,-0.6 -0.7,-0.85 -0.28,-2.22 -0.64,-0.99 -0.71,-0.86 -0.35,-0.85 0.62,-1 1.53,-0.04 3.15,0.7 1.5,-0.15 1.47,-0.6 1.05,-0.74 -0.02,-0.01 -2.45,-1.23 -0.39,-0.09 -1.8,-0.18 -1.13,0.02 -2.6,0.98 -0.73,0.18 -0.8,0.09 -3.29,-0.15 -0.29,0.02 -1.53,0.35 -0.27,0.02 -0.26,-0.01 -0.28,-0.04 -0.25,-0.07 -0.26,-0.12 -0.08,-0.15 -0.01,-0.26 0.13,-0.42 0.4,-0.8 0.07,-0.23 -0.19,-0.87 -1.03,-1.9 -2.16,-1.24 -0.79,-0.21 -0.2,0.12 -0.14,0.22 -0.26,0.68 -0.17,0.19 -0.12,0.08 -0.11,0 -0.1,-0.03 -0.45,-0.17 -0.52,-0.26 -0.33,-0.29 -0.34,-0.42 -0.67,-1.46 -0.07,-0.08 -0.16,-0.11 -0.36,-0.16 -0.31,-0.08 -0.7,-0.07 -0.13,-0.07 -0.11,-0.2 -0.56,-1.72 -1.33,-2.19 -2.07,0.78 -1.01,0.59 -3.41,1.01 -1.07,0.13 -2.22,-0.49 -1.3,-0.3 -0.28,-0.01 -0.4,-0.13 -0.45,-0.22 -0.77,-0.57 -1.09,-0.59 -0.87,-0.72 -0.4,-0.4 -0.4,-0.33 -0.47,-0.21 -1.93,-0.62 -2.16,-1.12 -0.75,-0.78 -2.28,-1.88 -0.2,-0.22 -0.34,-0.46 -0.18,-0.08 -0.21,0.07 -0.57,0.61 -6.17,5.14 -0.52,0.23 -2.16,0.47 -0.72,-0.02 -0.51,-0.07 -0.21,-0.13 -0.2,-0.08 -0.23,0 -0.99,0.2 -0.9,0.38 -0.95,0.57 -0.62,0.49 -1.16,1.23 -1.94,1.37 -0.31,-0.01 -0.11,-0.06 -3.91,-4.12 -1.57,-1.03 -0.18,-0.17 -0.22,-0.27 -0.26,-0.56 -0.14,-0.44 0,-1.41 1.61,-1.54 0.66,-0.45 1.18,-0.64 1.79,-0.53 0.25,-0.14 0.2,-0.14 0.45,-0.54 1.01,-1.45 0.59,-1.44 0.11,-0.39 -0.03,-1.45 -0.34,-1.23 -0.42,-0.35 -0.54,-0.36 -0.21,-0.17 -0.08,-0.28 0.05,-0.36 0.62,-1.49 0.67,-1.19 0.11,-0.31 0.03,-0.29 -0.22,-1.27 -0.07,-1.27 -0.03,-0.15 -0.05,-0.11 -0.11,-0.4 -0.06,-0.73 -0.06,-0.29 -0.23,-0.59 -0.09,-0.47 0,-0.46 0.16,-0.65 0.29,-0.56 0.25,-0.4 1.2,-1.24 1.13,-0.9 0.78,-0.96 0.56,-1 0.27,-0.56 0.65,-1.85 0.36,-0.4 0.52,-0.4 1.74,-0.89 0.45,-0.29 0.2,-0.18 0.64,-1.11 0.48,-0.94 0.11,-0.29 0.55,-2.62 0.03,-0.35 0.01,-0.33 -0.07,-0.97 0.03,-0.28 0.19,-0.55 0.02,-0.32 -0.11,-0.32 -0.24,-0.28 -0.35,-0.19 -0.48,-0.15 -0.16,-0.09 -0.33,-0.31 -0.56,-0.37 -0.15,-0.14 -0.12,-0.15 -0.18,-0.38 -0.14,-0.2 -0.2,-0.15 -0.35,-0.05 -0.52,0.09 -0.2,0.01 -0.18,-0.05 -0.17,-0.07 -0.16,-0.05 -0.2,0.06 -0.21,0.18 -0.33,0.45 -0.2,0.38 -0.56,1.36 -1.02,1.57 -0.28,0.24 -0.35,0.16 -0.64,0.01 -0.4,-0.04 -1.55,-0.62 -1.16,0.76 -0.26,0.25 -0.52,0.23 -3.19,0.51 -0.53,0.15 -0.54,-0.13 -0.22,-0.2 -0.12,-0.2 -0.09,-0.14 -0.17,0 -0.23,0.13 -0.27,0.37 -0.1,0.29 -0.02,0.35 0.02,0.59 -0.02,0.17 -0.03,0.18 -0.11,0.28 -0.29,0.24 -1.58,0.27 -3,-0.35 -0.77,0.08 -0.46,-0.05 -0.43,-0.16 -0.37,-0.38 -0.51,-0.72 -0.08,-0.2 -0.11,-0.41 -0.08,-0.18 -0.63,-0.24 -2.26,-0.19 -2.54,-0.32 -0.82,-0.24 -0.37,-0.05 -1.11,0.12 -0.25,0 -1.57,-0.51 -0.43,-0.09 -0.35,-0.01 -0.51,0.13 -0.46,0.21 -0.23,0.14 -0.18,0.18 -0.17,0.2 -0.6,1.02 -0.18,0.24 -0.2,0.2 -0.23,0.15 -0.24,0.11 -0.79,0.2 -0.21,0 -0.15,-0.02 -0.05,-0.21 -0.04,-0.39 0.11,-1.6 -0.29,-3.29 0.1,-0.75 0.16,-0.5 0.13,-0.24 0.03,-0.18 -0.09,-0.21 -0.14,-0.04 -0.14,-0.01 -0.81,0.29 -0.62,0.04 z"
        />
      <path
        id="AF-DAY"
        title="Daykundi"
        
        d="m 283.39715,247.33119 -0.27,-0.04 -0.26,-0.13 -0.63,-0.6 -0.19,-0.14 -0.41,-0.22 -0.53,-0.2 -2.55,-0.46 -0.62,0.03 -0.4,0.18 -0.32,0.69 -0.17,0.26 -0.99,1.14 -0.36,0.28 -0.51,0.26 -0.5,0.05 -1.28,-0.17 -1.8,0.34 -0.32,-0.03 -0.97,-0.18 -1.81,-0.06 -0.35,0.06 -0.1,0.1 -0.66,0.82 -0.4,0.35 -0.54,0.35 -0.87,0.43 -0.58,0.15 -0.53,0.02 -3.08,-0.62 -6.45,-0.42 -3.66,-0.67 -1.83,-0.14 -4.5,0.17 -0.5,0.25 -0.5,1.89 -0.05,0.89 0.07,0.51 -0.12,0.47 -0.68,1.73 -0.22,0.85 -0.25,1.39 -0.04,0.54 0.04,0.37 0.1,0.11 0.13,0.13 0.14,0.16 0.11,0.3 -0.02,0.28 -0.6,1.16 -0.08,0.41 -0.01,0.46 0.03,0.64 -0.27,1.16 -0.28,0.86 -0.14,1.52 0.06,0.23 0.18,0.15 0.12,0.11 0.13,0.17 0.12,0.2 0.12,0.27 0.26,0.78 0.11,0.2 0.14,0.13 0.15,0.07 0.21,0.03 0.63,0.04 0.18,0.23 0.12,0.21 0.32,1.75 -0.27,1.38 -0.4,0.63 -0.58,0.33 -0.74,1.14 -0.3,1.08 -0.26,0.52 -0.19,0.28 -0.17,0.04 -0.88,0.1 -0.21,0.06 -0.15,0.07 -0.14,0.08 -0.25,0.2 -1.17,0.65 -0.22,0.23 -0.15,0.28 -0.06,0.36 -0.01,0.21 0.04,0.17 0.04,0.15 0.1,0.26 0.06,0.21 0.1,0.79 0.06,0.16 0.09,0.15 0.15,0.16 1.3,0.8 0.16,0.17 0.1,0.21 0.07,0.24 0.05,0.23 0.06,0.16 0.09,0.12 0.18,0.19 0.12,0.08 0.12,0.06 0.3,0.07 0.31,0.14 0.15,0.1 0.11,0.11 0.2,0.35 0.31,0.34 0.3,0.58 0.3,1.74 0.42,3.23 0.43,0.94 1.02,0.47 0.78,0.68 0.64,0.73 0.3,0.55 0.18,0.63 -0.03,0.28 -0.12,0.24 -1.22,0.93 -0.75,0.43 -0.68,0.31 -0.26,0.15 -1.61,1.43 -1.44,1.76 -1.6,1.33 -0.13,0.15 -0.1,0.15 -0.12,0.13 -0.14,0.11 -0.15,0.06 -0.16,0.04 -0.64,0.07 -0.18,0.05 -0.14,0.08 -0.11,0.11 -0.69,1.05 -0.12,0.28 0,0.19 0.1,0.11 0.22,0.17 0.05,0.17 0.02,0.13 -0.05,0.84 -1.92,1.03 -0.92,0.32 -1.34,0.27 -1.07,0.43 -0.76,0.5 -1.32,1.04 1,1.13 0.9,0.49 1.64,0.17 0.26,0.12 0.1,0.24 -0.04,0.28 -0.11,0.31 -0.11,0.26 -0.05,0.28 0.16,0.52 1.11,2.02 0.48,0.64 0.49,0.49 0.64,0.53 0.27,0.38 0.18,0.43 0.02,0.99 -0.06,0.47 -0.09,0.38 -0.12,0.32 -0.04,0.25 -0.01,0.63 -0.05,0.39 -0.19,0.67 -0.03,0.27 0.01,0.56 -0.1,0.51 -0.04,0.35 0.01,0.43 0.04,0.34 -0.01,0.84 1.5,0.32 1.43,0.95 0.41,0.19 0.28,0 0.12,-0.27 0.09,-0.36 0.17,-0.36 0.28,-0.26 0.63,-0.18 0.56,0.14 0.52,0.26 0.67,0.45 0.26,0.01 0.1,-0.19 -0.05,-0.49 -0.48,-1.73 -0.44,-1.19 -0.07,-0.29 0.12,-0.26 0.41,-0.09 3.95,0.19 0.52,0.1 0.47,0.15 0.45,0.21 2.85,1.88 0.34,0.06 0.33,-0.06 1.03,-0.41 0.49,-0.09 0.54,-0.04 0.44,0.04 1.64,0.37 0.35,-0.03 0.29,-0.13 0.2,-0.24 0.58,-1.02 0.47,-0.44 0.44,-0.11 0.3,0.02 0.45,0.41 1.84,1.91 1.25,0.7 6.07,1.38 1.46,0.36 0.77,-0.08 0.23,-0.2 0.23,-0.33 0.19,-0.44 0.05,-0.39 -0.01,-0.42 -0.07,-0.42 -0.02,-0.45 0.06,-0.57 0.62,-2.67 0.32,-0.88 0.36,-0.45 0.33,-0.31 1.36,-0.74 0.93,-0.29 1.45,-0.69 5.87,-4.42 0.96,-0.5 0.61,-0.2 0.41,-0.06 0.21,0.06 1.07,0.6 0.42,0.18 0.58,-0.04 0.73,-0.19 2.32,-0.93 0.68,-0.19 0.4,-0.01 0.31,0.04 0.2,0.08 0.17,0.14 0.64,1.02 0.13,0.31 0.08,0.33 0.04,0.32 0.07,0.29 0.21,0.42 0.49,0.79 0.58,0.72 1.36,0.34 3.45,-1.89 1.29,-0.45 1.01,-0.04 0.81,-0.17 0.53,-0.33 0.55,-0.53 0.98,-1.15 0.31,-0.18 0.17,0 0.15,0.22 0.18,1.15 0.26,0.97 0.19,0.24 0.33,0.16 0.8,0.06 0.6,-0.09 1.62,-0.53 0.35,-2.68 0.37,-0.9 0.14,-0.24 0.09,-0.25 0.05,-0.32 0.11,-2.43 0.1,-0.65 0.12,-0.5 0.18,-0.48 -0.06,-1.58 -1.43,-4.23 -0.01,-1.08 0.05,-0.34 0.68,-1.71 0.5,-0.57 0.21,-0.19 0.53,-0.32 4.31,-1.76 2.73,-0.58 1.2,0.05 0.27,-0.03 4.61,-1.38 0.98,-0.52 1.03,-0.74 0.76,-1.02 0.36,-0.73 0.55,-0.82 0.44,-0.54 3.06,-2.66 1.03,-0.95 1.66,-2.39 0.33,-0.36 0.36,-0.25 1.02,-0.56 0.17,-0.3 0.02,-0.4 -0.66,-2.12 -0.34,-0.88 -0.25,-0.39 -0.08,-0.06 -0.7,-0.35 -0.54,-0.35 -0.12,-0.24 0.03,-0.29 0.3,-0.44 0.52,-0.45 0.15,-0.19 0.14,-0.24 0.49,-1.58 0.31,-0.6 -0.02,-0.34 -0.09,-0.37 -0.89,-0.73 -0.7,0.86 -0.43,0.36 -0.44,0.29 -4.03,0.64 -1.62,0.46 -0.26,0.21 -0.2,0.22 -0.17,0.23 -0.37,0.73 -0.16,0.19 -0.35,0.28 -0.13,0.15 -0.12,0.09 -0.15,-0.02 -0.74,-0.87 -0.2,-0.17 -0.1,-0.05 -0.27,-0.03 -0.45,0.04 -0.79,0.22 -0.49,0.19 -2.75,1.69 -0.29,0.06 -0.36,-0.01 -1.83,-0.78 -0.25,-0.17 -0.08,-0.1 -0.12,-0.18 -0.12,-0.24 -0.16,-0.24 -0.24,-0.2 -0.37,-0.18 -8.61,-1.75 -0.82,0 -1.46,0.27 -0.64,0.27 -0.45,0.29 -0.2,0.2 -0.23,0.13 -0.59,0.15 -1.27,0.55 -1.06,-0.14 -2.78,-1.5 -2.78,-2.7 -0.5,-0.58 -0.18,-0.29 -0.13,-0.57 -0.02,-0.82 0.15,-1.74 0.33,-1.03 1.18,-2.54 0.11,-0.6 0.02,-0.38 -0.72,-1.88 -0.22,-2.17 0.08,-0.3 0.17,-0.31 0.3,-0.32 0.65,-0.56 0.26,-0.14 0.51,-0.18 0.22,-0.11 0.15,-0.17 0.09,-0.24 -0.02,-0.35 -0.1,-0.32 -0.29,-0.35 -0.36,-0.26 -0.61,-0.3 -1.54,-0.58 -1.73,-0.08 -0.35,-0.63 -0.48,-0.61 0.02,-0.28 0.04,-0.21 0.89,-1.22 -1.1,-0.43 -6.08,0.96 -0.44,0.18 -0.26,0.04 z"
        />
      <path
        id="AF-URU"
        title="Uruzgan"
        
        d="m 294.63715,313.85119 -1.36,-0.34 -0.58,-0.72 -0.49,-0.79 -0.21,-0.42 -0.07,-0.29 -0.04,-0.32 -0.08,-0.33 -0.13,-0.31 -0.64,-1.02 -0.17,-0.14 -0.2,-0.08 -0.31,-0.04 -0.4,0.01 -0.68,0.19 -2.32,0.93 -0.73,0.19 -0.58,0.04 -0.42,-0.18 -1.07,-0.6 -0.21,-0.06 -0.41,0.06 -0.61,0.2 -0.96,0.5 -5.87,4.42 -1.45,0.69 -0.93,0.29 -1.36,0.74 -0.33,0.31 -0.36,0.45 -0.32,0.88 -0.62,2.67 -0.06,0.57 0.02,0.45 0.07,0.42 0.01,0.42 -0.05,0.39 -0.19,0.44 -0.23,0.33 -0.23,0.2 -0.77,0.08 -1.46,-0.36 -6.07,-1.38 -1.25,-0.7 -1.84,-1.91 -0.45,-0.41 -0.3,-0.02 -0.44,0.11 -0.47,0.44 -0.58,1.02 -0.2,0.24 -0.29,0.13 -0.35,0.03 -1.64,-0.37 -0.44,-0.04 -0.54,0.04 -0.49,0.09 -1.03,0.41 -0.33,0.06 -0.34,-0.06 -2.85,-1.88 -0.45,-0.21 -0.47,-0.15 -0.52,-0.1 -3.95,-0.19 -0.41,0.09 -0.12,0.26 0.07,0.29 0.44,1.19 0.48,1.73 0.05,0.49 -0.1,0.19 -0.26,-0.01 -0.67,-0.45 -0.52,-0.26 -0.56,-0.14 -0.63,0.18 -0.28,0.26 -0.17,0.36 -0.09,0.36 -0.12,0.27 -0.28,0 -0.41,-0.19 -1.43,-0.95 -1.5,-0.32 -0.89,-0.13 -0.26,0.13 -0.38,0.28 -1.09,1.07 -0.27,0.34 -0.11,0.3 0.14,0.47 0.04,0.21 -0.02,0.29 -0.04,0.32 -0.18,0.49 -0.86,0.9 -0.57,0.46 -0.52,0.74 -2.88,5.22 -0.05,0.26 0,0.23 0.07,0.2 0.15,0.19 0.19,0.17 0.4,0.24 0.19,0.16 0.12,0.17 0.09,0.25 0.05,0.27 0.03,0.31 -0.05,0.51 -0.55,2.33 -0.05,0.46 0.03,0.32 0.08,0.23 0.15,0.24 0.12,0.51 0.13,0.39 -0.6,3.08 -0.87,1.9 0.07,0.16 0.14,0.19 0.35,0.05 0.37,0.2 0.48,0.34 0.21,0.06 0.21,0.01 0.75,-0.18 0.32,0.07 0.18,0.21 0.21,0.44 0.2,0.26 0.2,0.13 0.22,0.04 0.54,0.23 0.19,0.61 0.56,2.59 0.34,1.09 0.08,0.78 -0.08,0.48 -0.39,0.68 -0.73,0.89 -0.24,0.44 -0.06,0.28 0.05,0.25 0.1,0.2 0.16,0.46 0.13,0.63 0.14,1.26 0,0.71 -0.06,0.55 -0.15,0.78 -0.1,0.33 -0.15,0.32 -0.46,0.74 -0.4,1.31 -0.59,3.2 0.47,0.13 0.7,0.87 0.42,0.23 0.56,0.08 2.59,-0.13 0.75,0.26 1.84,1.04 0.71,0.27 0.64,0.11 0.68,-0.04 0.42,-0.12 0.28,-0.27 -0.76,-1.5 -0.03,-0.24 -0.01,-0.29 0.11,-0.14 0.16,-0.24 0.16,-0.31 0.25,-1 0.08,-0.23 0.07,-0.11 0.09,-0.09 0.18,-0.14 0.46,-0.26 0.27,-0.23 0.01,-0.24 -0.3,-1.2 -0.11,-1.24 0,-0.56 0.07,-0.35 0.11,-0.13 0.15,-0.13 0.84,-0.42 0.69,-0.26 0.21,-0.12 0.35,-0.32 0.37,-0.47 0.44,-0.82 0.18,-0.68 0.14,-0.91 0.23,-0.67 0.49,-0.83 1.72,-2.18 0.33,-0.31 0.14,-0.11 0.11,-0.05 0.31,-0.07 0.41,-0.03 3.57,0.68 0.62,-0.04 0.81,-0.29 0.14,0.01 0.14,0.04 0.09,0.21 -0.03,0.18 -0.13,0.24 -0.16,0.5 -0.1,0.75 0.29,3.29 -0.11,1.6 0.04,0.39 0.05,0.21 0.15,0.02 0.21,0 0.79,-0.2 0.24,-0.11 0.23,-0.15 0.2,-0.2 0.18,-0.24 0.6,-1.02 0.17,-0.2 0.18,-0.18 0.23,-0.14 0.46,-0.21 0.51,-0.13 0.35,0.01 0.43,0.09 1.57,0.51 0.25,0 1.11,-0.12 0.37,0.05 0.82,0.24 2.54,0.32 2.26,0.19 0.63,0.24 0.08,0.18 0.11,0.41 0.08,0.2 0.51,0.72 0.37,0.38 0.43,0.16 0.46,0.05 0.77,-0.08 3,0.35 1.58,-0.27 0.29,-0.24 0.11,-0.28 0.03,-0.18 0.02,-0.17 -0.02,-0.59 0.02,-0.35 0.1,-0.29 0.27,-0.37 0.23,-0.13 0.17,0 0.09,0.14 0.12,0.2 0.22,0.2 0.54,0.13 0.53,-0.15 3.19,-0.51 0.52,-0.23 0.26,-0.25 1.16,-0.76 -0.45,-0.68 -0.17,-0.34 -0.13,-0.33 -0.02,-0.25 0.13,-0.33 0.58,-1.18 0.06,-0.57 0.01,-0.5 -0.02,-0.4 0.04,-0.36 0.43,-0.63 2.38,-2.68 0.62,-0.84 0.58,-1.01 0.4,-0.38 2.31,-1.15 2.38,-0.35 0.78,-0.69 1.46,-2.77 2.14,-0.23 0.76,0.08 0.15,0.14 0.06,0.18 -0.01,0.31 -0.11,0.51 -1.09,3.35 -0.08,0.38 0.02,0.25 0.06,0.19 0.06,0.09 0.1,0.1 0.2,0.12 0.43,-0.01 0.63,-0.16 1.14,-0.55 0.54,-0.37 0.33,-0.45 0,-0.33 -0.12,-0.67 0.02,-0.28 0.08,-0.27 0.15,-0.26 0.78,-1.06 0.75,-0.76 0.83,-0.66 3.17,-2.02 0.32,-0.32 0.55,-0.29 0.68,-0.17 1.49,-0.11 1.19,0.06 0.29,-0.08 0.32,-0.18 0.86,-0.67 0.57,-0.06 0.43,0.17 0.52,0.33 0.27,0.11 0.41,0.09 0.38,0.04 0.33,-0.04 0.21,-0.1 0.37,-0.25 0.24,-0.08 0.26,-0.15 0.2,-0.24 0.33,-0.6 0.21,-0.32 0.16,-0.59 0.07,-0.42 0.2,-3.41 -0.58,-0.23 -2.34,-0.54 -0.59,-0.28 -0.44,-0.42 -0.4,-0.59 -0.33,-0.91 -0.22,-1.03 -0.22,-2.07 0.02,-0.94 0.08,-0.66 0.1,-0.31 0.02,-0.45 -0.08,-1.62 0.15,-0.82 0.05,-0.17 0.09,-0.68 0.04,-0.19 0.11,-0.21 0.2,-0.2 1.69,-1.23 0.28,-0.32 0.36,-0.64 0.19,-0.26 0.27,-0.22 0.82,-0.43 0.16,-0.17 0.12,-0.39 0.02,-0.56 -0.11,-0.86 -0.25,-0.63 -0.29,-0.42 -0.82,-0.21 -4.95,0.25 -1.26,-0.23 -0.73,-1.85 -1.62,0.53 -0.6,0.09 -0.8,-0.06 -0.33,-0.16 -0.19,-0.24 -0.26,-0.97 -0.18,-1.15 -0.15,-0.22 -0.17,0 -0.31,0.18 -0.98,1.15 -0.55,0.53 -0.53,0.33 -0.81,0.17 -1.01,0.04 -1.29,0.45 -3.45,1.89 z"
        />
      <path
        id="AF-NIM"
        title="Nimroz"
        
        d="m 146.70715,373.68119 -9.07,-2.23 -4.93,-0.26 -2.3,-0.61 -0.28,0 -0.34,0.03 -0.42,0.18 -0.45,0.3 -1.05,1.15 -0.42,0.65 -0.33,0.69 -0.47,1.31 -0.12,0.66 -0.13,4.25 -0.08,0.63 -0.2,0.68 -0.3,0.6 -0.47,0.7 -0.68,0.79 -0.89,0.84 -1.76,1.27 -0.78,0.35 -2.64,0.72 -2.7,0 -0.43,0.09 -4.43,1.7 -0.35,0.2 -0.99,0.71 -0.67,-0.31 -0.49,-0.31 -3.62,-4.09 -2.13,-2.43 -0.34,-0.23 -0.47,-0.24 -0.59,-0.2 -1.579997,-0.3 -0.97,-0.04 -0.64,0.04 -5.42,1.62 -20.14,1.28 -0.22,0.33 -0.06,0.14 -0.07,0.2 0,0.26 0.05,0.31 0.18,0.32 0.11,0.85 0.3,1.42 -0.03,0.47 -0.21,0.45 -0.66,0.62 -3.04,1.59 -0.43,0.4 -0.33,0.52 -0.21,0.66 -0.06,0.38 0.03,0.29 0.36,1.27 0.19,0.93 0,0.32 -0.02,0.28 -0.07,0.35 -0.35,0.61 -0.62,0.81 -1.48,1.62 -0.77,0.65 -1.18,1.34 -2.22,4.22 -1.57,2.07 -0.42,0.23 -0.59,0.26 -1.33,-0.12 -0.28,0.02 -0.24,0.08 -0.18,0.28 -0.1,0.43 0,0.77 0.17,0.82 0.09,0.16 0.29,0.44 0.14,0.29 0.09,0.37 -0.08,0.61 -0.26,0.49 -0.72,0.7 -0.45,0.21 -0.33,0.04 -0.13,-0.09 -0.11,-0.14 -0.08,-0.15 -0.05,-0.07 -0.07,-0.07 -0.11,0.01 -0.11,0.1 -0.19,0.25 -0.09,-0.04 -0.15,-0.41 -0.12,-0.2 -0.13,-0.12 -0.1,-0.07 -0.11,-0.03 -0.03,0.23 0.06,0.45 0.34,1.09 0.33,0.46 0.27,0.29 0.12,0.06 0.06,0.06 0.03,0.1 0,0.19 -0.07,0.25 -0.21,0.48 -0.05,0.33 0.12,0.41 0.12,0.33 -0.03,0.41 -0.38,0.54 -0.44,1.16 -0.19,0.46 -0.01,0.02 2.67,0.39 1.24,0.49 0.96,0.76 1.73,2.21 0.34,1.05 -0.34,2.44 0.02,1.13 0.47,1.16 1.3,2.15 0.41,1.28 0.08,1.66 0.12,0.59 0.85,1.8 0.59,1.85 0.24,1.12 0,1.11 -0.34,1.2 -0.93,1.83 0.21,0.66 0.18,3.87 -0.29,0.16 -0.12,0.4 -0.07,1.02 0.07,0.06 0.12,0.3 -0.83,0.88 -4,4.85 -6.13,7.42 -5.56,6.72 0,0.01 -3.94,4.74 -5.25,6.29 -2.74,3.29 -4.01,4.8 -7.5,8.96 -0.01,0.01 -3.69,4.33 -2.8,3.28 1.53,0.71 3.47,1.12 4.03,1.3 4.05,1.31 4.03,1.31 4.04,1.3 4.04,1.31 4.03,1.3 4.05,1.31 4.03,1.3 4.04,1.3 4.04,1.31 4.04,1.3 4.04,1.3 4.03,1.31 4.04,1.3 4.04,1.3 4.03,1.31 4.61,1.48 5,0.95 6.069997,-0.57 0,-0.02 5.74,-27.27 0.07,-2.49 -0.26,-2.58 0.06,-0.49 0.2,-0.5 1.26,-1.75 0.33,-0.66 0.17,-0.84 0.35,-4.01 -0.09,-2.8 0.17,-0.55 0.28,-0.42 0.3,-0.24 0.37,-0.18 0.42,-0.11 0.53,-0.08 0.41,-0.1 1.65,-0.95 1.97,-1.96 1.46,-1.83 2.05,-3.2 1.2,-2.29 0.65,-1.73 0.54,-1.1 0.61,-0.8 2.56,-1.89 0.75,-0.78 0.25,-0.61 0.04,-0.55 -0.13,-0.44 -0.2,-0.45 -0.26,-0.39 -0.66,-0.81 -0.3,-0.51 -0.16,-0.38 -0.06,-0.94 1.15,-1.73 0.02,-0.28 -0.04,-0.32 -0.69,-0.42 -0.36,-0.31 -0.33,-0.63 0.03,-0.42 0.29,-0.48 0.44,-0.45 1.64,-2.17 0.5,-0.51 0.48,-0.36 0.9,-0.49 0.41,-0.35 0.15,-0.38 0.01,-0.54 -0.46,-2.71 -0.05,-3.87 -0.15,-2.07 0.62,-0.73 1.89,-0.85 0.63,-0.43 0.88,-0.79 0.39,-0.53 0.48,-1.13 2.02,-3.87 0.38,-0.51 0.48,-0.38 1.05,-0.39 0.87,-1.08 0.12,-0.91 -0.03,-0.52 0.29,-4.99 -0.05,-0.65 -0.15,-0.39 -0.2,-0.41 -0.56,-0.87 -0.7,-2.11 0.12,-0.94 1.1,-1.34 0.54,-1.04 0.08,-5.98 2.58,-18.5 1.06,-3.16 2.01,-1.61 0.53,-0.62 0.77,-1.11 1.73,-3.62 0.27,-0.81 0.1,-0.63 -0.34,-1.32 -0.02,-0.48 0.13,-0.27 0.73,-0.73 0.71,-0.88 0.18,-0.48 -0.03,-0.37 -0.69,-0.68 -0.12,-0.24 -0.04,-0.27 0,-0.28 -0.05,-0.3 -0.13,-0.3 -0.38,-0.59 -0.07,-0.22 -0.03,-0.29 0.01,-0.5 -0.2,-0.84 -0.19,-2.01 -1.15,0.07 z"
        />
      <path
        id="AF-HEL"
        title="Helmand"
        
        d="m 174.82715,532.50119 1.32,-0.54 1.77,-3.46 1.1,-1.44 1.71,-0.87 13.09,-3.93 1.06,0.01 0,-0.01 0.02,-0.3 6.34,-36.22 1.43,-10.8 0.66,-18.2 2.17,-28.09 0.16,-1.96 0.69,-8.84 0.65,-3.21 1.47,-5.52 0.76,-1.79 0.09,-0.31 0.76,-5.01 0.4,-0.74 -0.02,-0.1 -0.11,-0.16 -0.31,-0.18 -0.35,-0.28 -0.46,-0.45 -0.13,-0.4 0.03,-0.62 0.92,-4.8 0.16,-0.45 0.12,-0.27 0.15,-0.16 0.84,-0.71 0.34,-0.43 2.14,-2.09 0.76,-0.83 0.26,-0.52 0.43,-2.07 0.04,-1.93 0.39,-1.04 0.35,-0.64 0.26,-0.35 0.25,-0.25 0.25,-0.14 0.28,-0.09 0.9,-0.48 0.81,-0.63 0.42,-0.24 0.44,-0.11 0.74,0.08 0.39,0.16 0.79,0.54 0.4,0.18 0.47,0.1 0.97,0.01 0.75,-0.11 0.33,-0.22 0.26,-0.48 0.71,-2.6 0.36,-0.83 0.13,-0.46 0,-0.32 -0.2,-0.21 -0.2,-0.16 -0.11,-0.19 0.11,-0.17 0.16,-0.13 0.4,-0.22 0.2,-0.22 0.1,-0.25 0.06,-0.63 0.06,-0.32 0.39,-0.95 0.09,-0.43 0.04,-0.36 0.19,-0.81 1.39,-1.29 0.85,-0.45 0.19,-0.16 0.11,-0.21 0.02,-0.26 0.78,-2.96 0.59,-3.2 0.4,-1.31 0.46,-0.74 0.15,-0.32 0.1,-0.33 0.15,-0.78 0.06,-0.55 0,-0.71 -0.14,-1.26 -0.13,-0.63 -0.16,-0.46 -0.1,-0.2 -0.05,-0.25 0.06,-0.28 0.24,-0.44 0.73,-0.89 0.39,-0.68 0.08,-0.48 -0.08,-0.78 -0.34,-1.09 -0.56,-2.59 -0.19,-0.61 -0.54,-0.23 -0.22,-0.04 -0.2,-0.13 -0.2,-0.26 -0.21,-0.44 -0.18,-0.21 -0.32,-0.07 -0.75,0.18 -0.21,-0.01 -0.21,-0.06 -0.48,-0.34 -0.37,-0.2 -0.35,-0.05 -0.14,-0.19 -0.07,-0.16 0.87,-1.9 0.6,-3.08 -0.13,-0.39 -0.12,-0.51 -0.15,-0.24 -0.08,-0.23 -0.03,-0.32 0.05,-0.46 0.55,-2.33 0.05,-0.51 -0.03,-0.31 -0.05,-0.27 -0.09,-0.25 -0.12,-0.17 -0.19,-0.16 -0.4,-0.24 -0.19,-0.17 -0.15,-0.19 -0.07,-0.2 0,-0.23 0.05,-0.26 2.88,-5.22 0.52,-0.74 0.57,-0.46 0.86,-0.9 0.18,-0.49 0.04,-0.32 0.02,-0.29 -0.04,-0.21 -0.14,-0.47 0.11,-0.3 0.27,-0.34 1.09,-1.07 0.38,-0.28 0.26,-0.13 0.89,0.13 0.01,-0.84 -0.04,-0.34 -0.01,-0.43 0.04,-0.35 0.1,-0.51 -0.01,-0.56 0.03,-0.27 0.19,-0.67 0.05,-0.39 0.01,-0.63 0.04,-0.25 0.12,-0.32 0.09,-0.38 0.06,-0.47 -0.02,-0.99 -0.18,-0.43 -0.27,-0.38 -0.64,-0.53 -0.49,-0.49 -0.48,-0.64 -1.11,-2.02 -0.16,-0.52 0.05,-0.28 0.11,-0.26 0.11,-0.31 0.04,-0.28 -0.1,-0.24 -0.26,-0.12 -1.64,-0.17 -0.9,-0.49 -1,-1.13 -1.81,-0.17 -0.53,0.03 -0.59,0.16 -2.09,1.33 -0.81,0.71 -0.55,0.64 -0.24,0.22 -4.22,1.99 -0.13,0.16 -0.11,0.13 -1.33,0.92 -0.48,0.48 -0.36,0.17 -0.43,0.02 -0.88,-0.18 -0.41,-0.21 -0.34,-0.21 -0.29,-0.07 -0.36,0.16 -0.64,0.56 -1.58,1.73 -0.34,0.31 -0.3,0.17 -0.35,0.15 -0.3,0.08 -0.34,0 -0.65,-0.11 -0.26,-0.24 -0.14,-0.19 -0.13,-1.43 -0.04,-0.2 -0.07,-0.2 -0.08,-0.17 -0.61,0.04 -2.17,1.07 0.37,0.59 0.15,0.17 0.12,0.18 0.01,0.17 -0.12,0.21 -1.56,1.4 -0.2,0.38 -0.13,0.49 0,0.79 0.05,0.41 0.07,0.25 0.79,0.43 -4.38,3.36 -0.54,0.49 -0.38,0.6 -0.42,0.52 -0.94,0.96 -0.48,0.59 -0.29,0.59 0.01,0.28 0.09,0.17 0.12,0.08 0.15,0.05 0.09,0.11 0.06,0.18 -0.09,0.32 -0.22,0.41 -0.51,0.76 -0.46,1.02 -0.24,0.43 -0.06,0.23 -0.01,0.12 0.04,0.06 0.15,0.11 1.16,0.48 0.27,0.17 0.19,0.17 0.08,0.2 -0.03,0.24 -0.22,0.29 -0.35,0.27 -6.32,2.49 -1.13,0.2 -0.39,0.16 -0.49,0.34 -0.49,0.44 -0.58,0.88 -0.77,0.82 -0.77,1.17 -0.17,0.34 -0.03,0.22 0.03,0.22 0.06,0.22 -0.23,0.37 -0.49,0.47 -1.99,1.41 -0.81,0.9 -0.46,0.89 -0.15,0.65 0.05,0.24 0.09,0.13 0.17,0.1 0.69,0.23 0.98,0.57 0.2,0.17 0.09,0.21 -0.05,0.29 -0.3,0.65 -0.07,0.3 0.01,0.35 0.05,0.38 -0.43,0.49 -0.84,0.59 -2.26,1.08 -1.61,1.02 -0.49,0.15 -2.49,0.1 -3.49,0.71 -0.51,0.03 -0.33,-0.07 -0.09,-0.17 -0.07,-0.22 -0.08,-0.44 -0.05,-0.08 -0.06,-0.05 -0.09,-0.02 -0.15,0.02 -0.2,0.07 -0.31,0.15 -0.47,0.4 -0.2,0.19 -0.17,0.41 -0.04,1.18 0.09,1.3 0.07,0.27 0.11,0.24 0.48,0.52 0.19,0.39 0.2,0.56 0.16,0.57 0.03,0.52 -0.13,0.44 -0.31,0.3 -0.73,0.34 -0.69,0.42 -0.7,0.61 -0.35,0.47 -0.26,0.43 -0.28,0.3 -0.26,0.12 -0.39,-0.16 -0.43,-0.43 -0.23,0.02 -0.37,0.23 -3.44,2.78 -0.27,0.31 -0.17,0.32 -0.06,0.34 -0.03,0.42 -0.14,0.32 -0.3,0.19 -0.69,0.06 -1.55,-0.4 -0.47,-0.02 -0.4,0.06 -1.11,0.35 -0.3,0.03 -0.34,0.09 -0.47,0.24 -2.68,2.81 -0.57,0.48 -0.87,0.54 -3.79,1.82 -1.15,0.95 0.19,2.01 0.2,0.84 -0.01,0.5 0.03,0.29 0.07,0.22 0.38,0.59 0.13,0.3 0.05,0.3 0,0.28 0.04,0.27 0.12,0.24 0.69,0.68 0.03,0.37 -0.18,0.48 -0.71,0.88 -0.73,0.73 -0.13,0.27 0.02,0.48 0.34,1.32 -0.1,0.63 -0.27,0.81 -1.73,3.62 -0.77,1.11 -0.53,0.62 -2.01,1.61 -1.06,3.16 -2.58,18.5 -0.08,5.98 -0.54,1.04 -1.1,1.34 -0.12,0.94 0.7,2.11 0.56,0.87 0.2,0.41 0.15,0.39 0.05,0.65 -0.29,4.99 0.03,0.52 -0.12,0.91 -0.87,1.08 -1.05,0.39 -0.48,0.38 -0.38,0.51 -2.02,3.87 -0.48,1.13 -0.39,0.53 -0.88,0.79 -0.63,0.43 -1.89,0.85 -0.62,0.73 0.15,2.07 0.05,3.87 0.46,2.71 -0.01,0.54 -0.15,0.38 -0.41,0.35 -0.9,0.49 -0.48,0.36 -0.5,0.51 -1.64,2.17 -0.44,0.45 -0.29,0.48 -0.03,0.42 0.33,0.63 0.36,0.31 0.69,0.42 0.04,0.32 -0.02,0.28 -1.15,1.73 0.06,0.94 0.16,0.38 0.3,0.51 0.66,0.81 0.26,0.39 0.2,0.45 0.13,0.44 -0.04,0.55 -0.25,0.61 -0.75,0.78 -2.56,1.89 -0.61,0.8 -0.54,1.1 -0.65,1.73 -1.2,2.29 -2.05,3.2 -1.46,1.83 -1.97,1.96 -1.65,0.95 -0.41,0.1 -0.53,0.08 -0.42,0.11 -0.37,0.18 -0.3,0.24 -0.28,0.42 -0.17,0.55 0.09,2.8 -0.35,4.01 -0.17,0.84 -0.33,0.66 -1.26,1.75 -0.2,0.5 -0.06,0.49 0.26,2.58 -0.07,2.49 -5.74,27.27 0,0.02 1.39,-0.13 2.38,-0.23 2.38,-0.22 2.37,-0.23 2.38,-0.22 2.38,-0.22 2.38,-0.23 2.38,-0.22 2.38,-0.23 2.37,-0.23 2.38,-0.22 2.38,-0.22 2.38,-0.23 2.37,-0.22 2.38,-0.23 2.38,-0.22 2.39,-0.23 7.4,-0.69 10.64,2.05 8.92,1.73 5.54,2.39 z"
        />
      <path
        id="AF-FRA"
        title="Farah"
        
        d="m 181.77715,318.36119 -0.3,-0.3 -0.37,-0.58 -1.43,-2.83 -0.38,-0.51 -0.68,-0.55 -0.17,-0.19 -0.15,-0.32 -0.17,-0.54 -0.18,-0.27 -0.32,-0.18 -0.53,-0.01 -0.41,-0.14 -0.67,-0.29 -0.16,-0.2 -0.14,-0.3 -0.02,-0.53 0.07,-0.62 0,-0.24 -0.14,-0.67 -0.05,-0.34 0.03,-0.94 -0.15,-0.47 -1.49,-3.51 -2.76,-4.53 -0.8,-0.75 -1.76,-0.95 -1.22,0.13 -2.18,1.02 -0.92,0.69 -0.69,0.63 -0.96,1.2 -0.76,1.19 -0.61,0.53 -0.78,0.3 -3.26,0.34 -2.05,0.47 -1.54,0.62 -0.99,0.6 -1.86,1.53 -1.95,0.78 -2.53,0.5 -9.82,0.4 -3.68,1.16 -0.67,0.09 -1.63,-0.05 -1.6,-0.67 -0.84,0.65 -1.1,0.52 -0.37,0.28 -0.46,0.75 -0.54,1.15 -0.84,2.3 -0.29,1.04 -0.12,0.74 0.02,0.27 -0.13,0.37 -0.12,0.22 -1.3,1.31 -4.24,1.59 -0.17,-0.04 -0.15,-0.07 -0.06,-0.06 -0.07,-0.11 -0.03,-0.14 0,-0.18 0.04,-0.19 0.12,-0.42 0.03,-0.14 -0.06,-0.08 -0.15,-0.01 -1.18,0.21 -4.03,1.43 -0.73,0.16 -0.64,0.07 -1.92,-0.13 -0.26,0.11 -0.29,0.27 -0.32,0.57 -0.12,0.54 -0.18,0.44 -0.26,0.41 -0.54,0.46 -0.73,0.42 -1.97,0.66 -2.5,0.48 -0.41,0.01 -0.37,-0.05 -0.3,-0.08 -1.29,-0.7 -0.219997,-0.08 -0.22,-0.06 -0.29,0.01 -0.4,0.06 -0.63,0.21 -1.99,1.01 -1.42,0.96 -1.25,1.04 -0.78,0.49 -0.31,0.29 -0.32,0.48 -0.29,0.94 -0.06,0.62 0.03,0.47 0.14,0.63 0.02,0.31 -0.03,0.29 -0.11,0.42 -1.13,2.44 -0.18,0.49 -0.04,0.37 0.14,0.89 0,0.15 -0.17,0.13 -0.34,0.06 -0.94,-0.15 -1.1,-0.04 -1.84,0.36 -3.97,0.41 -1.42,0.31 -0.77,0.31 -0.36,0.26 -1.47,1.36 -0.72,0.39 -0.41,0.17 -0.68,0.07 -0.71,-0.07 -0.33,-0.07 -0.29,-0.13 -0.2,-0.29 -0.13,-0.26 -0.17,-0.51 -0.11,-0.21 -0.29,-0.45 -0.08,-0.19 -0.04,-0.24 -0.01,-0.21 0.03,-0.25 0,-0.22 -0.03,-0.22 -0.28,-0.84 -0.12,-0.7 -0.1,-1.54 -0.1,-0.16 -0.16,-0.11 -0.3,-0.05 -0.4,0.02 -0.79,0.35 -2.46,1.81 -1.28,1.47 -0.53,0.57 -0.31,0.23 -0.39,0.2 -0.32,0.06 -0.24,-0.02 -0.22,-0.08 -0.24,-0.15 -0.41,-0.33 -1.8,-1.84 -0.51,-0.91 -0.32,-0.42 -0.36,-0.21 -0.5,-0.11 -2.89,-0.11 -0.52,-0.16 -0.49,-0.21 -0.39,-0.29 -0.3,-0.68 -0.1,-0.94 0.06,-2.05 0.27,-1.89 0.28,-0.88 0.21,-0.33 0.28,-0.26 1.08,-0.66 0.28,-0.24 0.2,-0.25 0.14,-0.28 0.13,-0.37 0.17,-0.32 0.22,-0.28 0.64,-0.51 1.63,-1.66 0.53,-0.75 0.31,-0.36 0.47,-0.43 1.33,-1.02 0.46,-0.6 0.04,-0.64 -2.19,-3.52 -1.9,-2.09 -0.23,-0.47 0.01,-0.52 0.15,-0.26 0.45,-0.41 0.22,-0.25 0.4,-0.61 0.24,-0.25 0.7,-0.52 0.88,-0.91 0.25,-0.39 0.13,-0.38 0.08,-0.46 0.02,-2.48 0.05,-0.5 0.12,-0.38 0.18,-0.27 0.7,-0.68 0.22,-0.31 0.17,-0.43 0.07,-0.48 0.01,-0.6 -0.1,-0.41 -0.47,-0.39 -3.21,-0.74 -3.65,-0.27 -1.48,0.1 -0.88,-0.07 -0.66,-0.74 -2.31,-0.48 -2.22,-0.1 -1.09,0.21 -0.5,0.28 -0.34,0.44 -0.24,0.57 -0.31,0.56 -0.41,0.4 -0.57,0.35 -1.33,0.46 -0.66,0.06 -0.52,-0.05 -1.01,-0.45 -0.56,-0.14 -0.89,0 -6.99,0.75 -3.29,-0.27 -6.42,-1.45 -2.77,-1.21 -1.71,-0.2 -0.97,-0.11 -0.38,0.64 -0.71,0.26 -2.3,0.16 -0.86,0.57 -0.14,0.84 0.17,0.97 0.09,1 -0.27,1.16 -0.51,0.66 -1.59,0.99 -1.4,1.25 -1.84,2.51 -2.3599997,3.21 -2.64,3.57 -2.34,3.18 -0.3,0.81 0.07,4.58 0.71,3.69 1.39,4.74 1.64,5.6 1.69,5.76 1.7799997,6.06 1.97,6.66 2.14,7.97 1.65,6.14 -0.1,4.67 -0.65,4.56 -0.29,0.95 -1.27,1.64 -0.38,0.88 0.17,0.35 0.4,0.24 0.29,0.32 -0.42,1.26 0.1,0.59 0.24,0.56 0.19,0.61 0.09,1.24 -0.36,3.53 0.1,2.77 0.68,5.28 -0.62,4.21 0.11,1.33 0.73,2.76 0.57,5.33 1.62,0.68 4.89,0.72 8.13,1.19 0.08,0.01 8.23,1.21 9.51,1.39 5.59,0.82 0.01,-0.02 0.19,-0.46 0.44,-1.16 0.38,-0.54 0.03,-0.41 -0.12,-0.33 -0.12,-0.41 0.05,-0.33 0.21,-0.48 0.07,-0.25 0,-0.19 -0.03,-0.1 -0.06,-0.06 -0.12,-0.06 -0.27,-0.29 -0.33,-0.46 -0.34,-1.09 -0.06,-0.45 0.03,-0.23 0.11,0.03 0.1,0.07 0.13,0.12 0.12,0.2 0.15,0.41 0.09,0.04 0.19,-0.25 0.11,-0.1 0.11,-0.01 0.07,0.07 0.05,0.07 0.08,0.15 0.11,0.14 0.13,0.09 0.33,-0.04 0.45,-0.21 0.72,-0.7 0.26,-0.49 0.08,-0.61 -0.09,-0.37 -0.14,-0.29 -0.29,-0.44 -0.09,-0.16 -0.17,-0.82 0,-0.77 0.1,-0.43 0.18,-0.28 0.24,-0.08 0.28,-0.02 1.33,0.12 0.59,-0.26 0.42,-0.23 1.57,-2.07 2.22,-4.22 1.18,-1.34 0.77,-0.65 1.48,-1.62 0.62,-0.81 0.35,-0.61 0.07,-0.35 0.02,-0.28 0,-0.32 -0.19,-0.93 -0.36,-1.27 -0.03,-0.29 0.06,-0.38 0.21,-0.66 0.33,-0.52 0.43,-0.4 3.04,-1.59 0.66,-0.62 0.21,-0.45 0.03,-0.47 -0.3,-1.42 -0.11,-0.85 -0.18,-0.32 -0.05,-0.31 0,-0.26 0.07,-0.2 0.06,-0.14 0.22,-0.33 20.14,-1.28 5.42,-1.62 0.64,-0.04 0.97,0.04 1.579997,0.3 0.59,0.2 0.47,0.24 0.34,0.23 2.13,2.43 3.62,4.09 0.49,0.31 0.67,0.31 0.99,-0.71 0.35,-0.2 4.43,-1.7 0.43,-0.09 2.7,0 2.64,-0.72 0.78,-0.35 1.76,-1.27 0.89,-0.84 0.68,-0.79 0.47,-0.7 0.3,-0.6 0.2,-0.68 0.08,-0.63 0.13,-4.25 0.12,-0.66 0.47,-1.31 0.33,-0.69 0.42,-0.65 1.05,-1.15 0.45,-0.3 0.42,-0.18 0.34,-0.03 0.28,0 2.3,0.61 4.93,0.26 9.07,2.23 1.15,-0.07 1.15,-0.95 3.79,-1.82 0.87,-0.54 0.57,-0.48 2.68,-2.81 0.47,-0.24 0.34,-0.09 0.3,-0.03 1.11,-0.35 0.4,-0.06 0.47,0.02 1.55,0.4 0.69,-0.06 0.3,-0.19 0.14,-0.32 0.03,-0.42 0.06,-0.34 0.17,-0.32 0.27,-0.31 3.44,-2.78 0.37,-0.23 0.23,-0.02 0.43,0.43 0.39,0.16 0.26,-0.12 0.28,-0.3 0.26,-0.43 0.35,-0.47 0.7,-0.61 0.69,-0.42 0.73,-0.34 0.31,-0.3 0.13,-0.44 -0.03,-0.52 -0.16,-0.57 -0.2,-0.56 -0.19,-0.39 -0.48,-0.52 -0.11,-0.24 -0.07,-0.27 -0.09,-1.3 0.04,-1.18 0.17,-0.41 0.2,-0.19 0.47,-0.4 0.31,-0.15 0.2,-0.07 0.15,-0.02 0.09,0.02 0.06,0.05 0.05,0.08 0.08,0.44 0.07,0.22 0.09,0.17 0.33,0.07 0.51,-0.03 3.49,-0.71 2.49,-0.1 0.49,-0.15 1.61,-1.02 2.26,-1.08 0.84,-0.59 0.43,-0.49 -0.05,-0.38 -0.01,-0.35 0.07,-0.3 0.3,-0.65 0.05,-0.29 -0.09,-0.21 -0.2,-0.17 -0.98,-0.57 -0.69,-0.23 -0.17,-0.1 -0.09,-0.13 -0.05,-0.24 0.15,-0.65 0.46,-0.89 0.81,-0.9 1.99,-1.41 0.49,-0.47 0.23,-0.37 -0.06,-0.22 -0.03,-0.22 0.03,-0.22 0.17,-0.34 0.77,-1.17 0.77,-0.82 0.58,-0.88 0.49,-0.44 0.49,-0.34 0.39,-0.16 1.13,-0.2 6.32,-2.49 0.35,-0.27 0.22,-0.29 0.03,-0.24 -0.08,-0.2 -0.19,-0.17 -0.27,-0.17 -1.16,-0.48 -0.15,-0.11 -0.04,-0.06 0.01,-0.12 0.06,-0.23 0.24,-0.43 0.46,-1.02 0.51,-0.76 0.22,-0.41 0.09,-0.32 -0.06,-0.18 -0.09,-0.11 -0.15,-0.05 -0.12,-0.08 -0.09,-0.17 -0.01,-0.28 0.29,-0.59 0.48,-0.59 0.94,-0.96 0.42,-0.52 0.38,-0.6 0.54,-0.49 4.38,-3.36 -0.79,-0.43 -0.07,-0.25 -0.05,-0.41 0,-0.79 0.13,-0.49 0.2,-0.38 1.56,-1.4 0.12,-0.21 -0.01,-0.17 -0.12,-0.18 -0.15,-0.17 -0.37,-0.59 -1.51,-1.12 -0.36,-0.74 -0.05,-0.35 -0.06,-0.3 -0.08,-0.24 -0.12,-0.19 -0.33,-0.16 -0.55,-0.13 -1.68,-0.03 -0.34,0.05 -0.14,0.05 -0.16,0.02 -0.3,-0.07 -0.39,-0.16 -0.6,-0.42 -0.44,-0.49 -0.15,-0.23 -0.18,-0.53 -0.07,-0.15 -0.11,-0.11 -0.11,-0.08 -0.16,-0.07 -0.55,-0.07 -0.83,0.19 -0.54,0.57 -1.11,2.92 -0.73,1.29 -0.45,0.56 -0.49,0.46 -0.63,0.48 -0.92,0.57 -0.85,0.4 -1.34,0.3 -0.25,0.11 -0.22,0.16 -0.11,0.14 -0.03,0.13 0.03,0.12 0.12,0.17 1.01,1.06 0.14,0.23 0.09,0.24 -0.02,0.18 -0.08,0.16 -0.15,0.12 -0.21,0.1 -0.29,0.08 -1.32,0.08 -0.42,0.08 -0.17,0.07 -0.21,0.13 -0.53,0.46 -0.14,0.05 -0.24,-0.04 -2.09,-1.15 -1.12,-1.07 -0.27,-0.15 -0.35,0 -0.67,0.26 -0.21,0.04 z"
        />
      <path
        id="AF-SAR"
        title="Sari Pul"
        
        d="m 294.82715,140.68119 -0.77,-0.15 -0.31,-0.18 -2.01,-1.64 -1.48,-0.75 -0.19,-0.25 -0.04,-0.2 0.1,-0.32 0.1,-0.23 0.62,-0.79 1.59,-2.47 0.27,-0.52 0.53,-0.82 0.13,-0.26 0.25,-0.76 1.16,-2.51 0.15,-0.47 0.24,-1.29 0.09,-0.33 0.12,-0.28 0.85,-1.56 0.54,-0.77 0.23,-0.27 1.15,-1.05 0.33,-0.48 0.56,-1.01 0.18,-0.23 0.44,-0.46 0.18,-0.25 0.61,-1.17 0.1,-0.27 0.09,-0.38 0.01,-0.2 -0.02,-0.24 -0.12,-0.34 -0.18,-0.25 -0.21,-0.21 -0.24,-0.17 -1.41,-0.5 -5.24,-1.04 -1.86,0.94 -0.29,0.09 -0.62,0.08 -0.64,-0.04 -1.49,0.1 -3.65,1.04 -5.66,0.94 -4.63,0.27 -1.96,-0.56 -1.31,0.15 -1.15,0.45 -2.06,1.34 -0.26,0.24 -0.16,0.18 -0.47,0.73 -0.5,0.57 -0.47,0.25 -4.42,0.92 -1.36,0.6 -2.92,2.23 -2.48,2.53 -1.19,0.84 -1.08,0.36 -5.31,0.7 -2.57,0.01 -0.79,0.5 -0.2,0.32 -0.23,0.57 -0.04,0.53 0.03,0.54 0.32,1.96 0.01,0.5 -0.87,9.67 1.14,1.08 0.59,0.91 0.21,0.51 0.18,0.64 0.08,0.49 0.01,0.41 -0.54,1.46 -0.05,1.17 0.15,0.47 0.29,0.22 6.23,-0.94 0.43,-0.15 0.32,-0.15 0.4,-0.33 1.24,-1.01 0.77,-0.24 0.32,0.03 0.32,0.08 0.27,0.16 0.28,0.23 0.2,0.26 0.11,0.25 0.01,0.19 -0.04,0.13 -0.33,0.48 -0.06,0.14 0,0.09 0.08,0.5 -0.02,0.12 -0.06,0.13 -0.12,0.17 -0.15,0.16 -0.11,0.23 -0.06,0.27 0.21,0.52 0.25,0.27 0.43,0.24 0.17,0.14 0.1,0.14 0.21,0.88 0.47,1.16 0.11,0.16 0.15,0.16 0.33,0.06 0.08,0.07 0.05,0.18 0.03,0.28 0.48,2.18 0.01,0.49 0.03,0.14 0.03,0.06 0.13,0.01 0.16,0.04 0.24,0.13 0.05,0.13 -0.05,0.16 -0.38,0.48 -0.18,0.34 -0.13,0.38 -0.12,0.65 -0.11,0.32 -0.1,0.2 -0.08,0.06 -0.84,0.29 -1.65,0.26 -1.28,-0.29 -0.86,-0.1 -0.23,0.01 -0.27,0.03 -0.35,0.15 -0.1,0.2 0.02,0.23 0.23,0.43 0.06,0.31 -0.05,0.37 -0.19,0.9 -0.18,0.43 -0.29,0.49 -0.23,0.28 -1.1,1.78 -0.93,1.23 -0.59,0.31 -0.24,0.02 -0.26,-0.02 -1.51,-0.41 -1.52,-0.15 -0.47,0.06 -0.35,0.13 -1.53,1.22 -0.29,0.34 -0.17,0.3 -0.02,0.37 0.03,0.41 -0.02,0.12 -0.06,0.18 -0.25,0.54 -0.14,0.47 -0.01,0.2 0,0.15 0.05,0.22 0.62,2.01 0.09,0.4 0,0.14 -0.01,0.12 -0.1,0.24 -1.5,2.93 -0.62,1.85 -0.22,0.36 -0.26,0.26 -0.68,0.41 -0.16,0.2 -0.09,0.23 -0.17,1.47 -0.09,1.68 0.2,1.12 -0.03,0.55 -0.15,1.12 0.03,0.68 0.16,0.9 0.55,1.86 0.17,0.45 0.21,0.38 1.08,1.32 0.51,0.87 0.47,0.19 2.86,-0.03 1.48,-0.29 0.46,-0.14 0.32,-0.16 0.53,-0.53 0.19,-0.14 0.2,-0.1 1.67,-0.55 0.35,-0.06 0.21,0.01 0.02,0.08 -0.01,0.1 -0.11,0.35 -0.05,0.21 -0.02,0.19 0,0.16 0.03,0.15 0.08,0.14 0.1,0.15 0.15,0.14 0.17,0.11 0.72,0.39 0.14,0.11 0.15,0.13 0.13,0.15 0.11,0.17 0.11,0.17 0.07,0.2 0.12,0.51 0.21,0.29 0.26,0.11 0.52,0.06 0.36,0.14 0.7,0.38 0.23,0.06 0.18,-0.01 0.78,-0.2 0.17,0.02 0.12,0.1 0.07,0.17 0.04,0.21 0,0.2 -0.1,0.65 0,0.26 0.06,0.34 0.09,0.31 0.12,0.32 0.64,1.27 0.26,0.41 0.52,0.59 0.39,0.29 0.35,0.19 5.01,1.73 1.5,0.15 2.43,0.55 0.31,-0.01 0.12,-0.12 0.24,-0.1 0.36,-0.05 0.65,0.05 0.35,0.11 0.29,0.19 0.18,0.25 0.16,0.3 0.13,0.31 0.08,0.28 0.03,0.25 0.01,0.27 -0.06,1.23 -0.04,0.28 -0.07,0.23 -0.08,0.15 -0.13,0.1 -0.54,0.22 -0.18,0.14 -0.01,0.25 0.16,0.31 0.91,0.79 0.16,0.18 -0.02,0.11 -0.08,0.14 -0.37,0.49 -0.13,0.33 0.02,0.37 0.82,0.23 0.4,0.39 0.32,0.53 0.39,0.87 1.38,4.83 0.06,0.37 -0.05,0.2 -0.34,0.79 -0.09,0.4 -0.03,0.51 0.17,0.27 0.15,0.1 0.17,-0.03 0.18,-0.11 0.46,-0.47 1.25,-1.62 0.15,-0.11 0.17,-0.07 0.66,-0.16 0.17,-0.08 0.12,-0.13 0.08,-0.15 0,-0.18 -0.02,-0.18 -0.05,-0.2 -0.03,-0.21 0.04,-0.2 0.09,-0.14 0.15,-0.11 0.21,-0.06 0.89,-0.08 0.15,-0.05 0.11,-0.1 0.09,-0.16 0.06,-0.2 0.08,-0.53 0.07,-0.12 0.15,-0.09 0.65,-0.15 0.21,-0.08 0.17,-0.09 0.09,-0.1 0.04,-0.12 -0.02,-0.12 -0.21,-0.47 -0.06,-0.21 -0.03,-0.22 0.02,-0.23 0.1,-0.24 0.19,-0.22 0.33,-0.2 0.22,-0.02 0.32,0.15 0.37,0.25 0.87,0.41 0.64,0.18 0.87,0.12 0.41,0.01 0.33,-0.03 0.22,-0.08 0.47,-0.27 0.94,-0.4 -0.44,-0.19 -0.33,-0.26 -0.12,-0.13 -0.36,-0.46 -0.15,-0.27 -0.12,-0.34 -0.06,-0.43 -0.02,-0.48 0.12,-1.55 0.09,-0.43 0.11,-0.35 0.14,-0.34 0.2,-0.71 0.11,-1.49 0.42,-2.4 -0.01,-0.37 -0.09,-0.35 -0.17,-0.25 -0.45,-0.43 -0.15,-0.19 -0.09,-0.22 -0.01,-0.23 0.23,-1.56 0.09,-0.33 0.32,-0.74 0.22,-0.4 0.24,-0.35 0.34,-0.38 0.27,-0.22 0.31,-0.19 0.76,-0.05 6.95,0.83 1.01,-0.09 1.67,-0.61 2.48,-1.01 0.35,-0.08 0.95,-0.05 0.3,-0.25 0.34,-0.47 3.14,-5.82 2.41,-2.99 0.53,-0.44 1.31,-0.27 0.59,-0.6 0.76,-0.47 1.55,-0.7 0.9,-0.57 0.83,-0.68 2.29,-2.31 0.29,-0.4 0.23,-0.42 0.17,-0.44 0.11,-0.5 0.07,-0.68 0.01,-0.52 -0.02,-0.43 -0.28,-1.53 -0.01,-0.24 0.03,-0.13 0.09,-0.08 0.15,-0.07 0.68,-0.17 0.14,-0.06 0.06,-0.17 0.03,-0.23 -0.07,-0.79 0.01,-0.31 0.07,-0.5 -0.07,-0.15 -0.15,-0.16 -1.08,-0.57 -0.14,-0.21 0.05,-0.39 0.17,-0.26 0.24,-0.21 0.91,-0.4 0.27,-0.18 0.19,-0.18 0.12,-0.19 0.06,-0.17 0.04,-0.15 -0.01,-0.18 -0.02,-0.23 -0.15,-0.68 -1.11,-0.98 -4.59,-2.16 -2.41,1.44 -0.77,0.37 -0.7,0.2 -0.41,0.21 -0.39,0.25 -0.42,0.12 -5.32,0.45 -0.28,-0.05 -0.26,-0.21 -0.15,-0.23 -0.24,-0.56 -0.07,-0.15 -0.09,-0.13 -0.08,-0.08 -0.06,-0.05 -0.07,-0.02 -6.93,1.31 -0.73,-0.06 -0.11,-0.29 1.05,-3.08 0.52,-0.95 0.27,-0.4 0.46,-0.55 0.42,-0.39 0.22,-0.14 0.69,-0.29 0.18,-0.12 0.13,-0.12 0.09,-0.12 0.05,-0.11 0.35,-1.09 1.31,-2.73 0.36,-1.06 0.05,-0.79 -0.07,-1.03 -0.87,-5.96 -0.17,-0.62 -0.72,-1.06 -0.04,-0.81 0.04,-0.73 0.04,-0.27 0.07,-0.24 0.07,-0.15 0.33,-0.46 0.06,-0.15 0.03,-0.17 -0.01,-0.17 -0.13,-0.54 -0.04,-0.36 -0.01,-2.3 0.08,-0.31 0.19,-0.49 0.02,-0.26 -0.02,-0.31 -0.18,-0.87 -0.14,-0.22 -0.24,-0.2 -0.49,-0.1 -1.17,0.04 z"
        />
      <path
        id="AF-GHO"
        title="Ghor"
        
        d="m 254.48715,199.21119 -0.23,-0.06 -0.7,-0.38 -0.36,-0.14 -0.52,-0.06 -0.26,-0.11 -0.21,-0.29 -0.12,-0.51 -0.07,-0.2 -0.11,-0.17 -0.11,-0.17 -0.13,-0.15 -0.15,-0.13 -0.14,-0.11 -0.72,-0.39 -0.17,-0.11 -0.15,-0.14 -0.1,-0.15 -0.08,-0.14 -0.03,-0.15 0,-0.16 0.02,-0.19 0.05,-0.21 0.11,-0.35 0.01,-0.1 -0.02,-0.08 -0.21,-0.01 -0.35,0.06 -1.67,0.55 -0.2,0.1 -0.19,0.14 -0.53,0.53 -0.32,0.16 -0.46,0.14 -1.48,0.29 -2.86,0.03 -0.47,-0.19 -0.51,-0.87 -1.59,1.16 -1.51,1.62 -0.27,0.19 -2.38,0.93 -0.7,0.03 -0.39,-0.17 -0.21,-0.13 -0.19,-0.16 -0.21,-0.06 -0.25,0.01 -0.84,0.4 -0.12,0.04 -0.11,0.06 -0.09,0.05 -0.12,0 -0.17,-0.07 -0.25,-0.27 -0.03,-0.23 0.06,-0.21 0.21,-0.32 0.06,-0.16 0.01,-0.19 -0.06,-0.22 -0.47,-0.86 -0.19,-0.25 -0.24,-0.22 -0.29,-0.11 -0.27,0.01 -0.32,0.23 -0.35,0.38 -0.18,0.11 -0.58,0.17 -0.15,-0.02 -0.89,-0.44 -0.18,-0.12 -0.47,-0.4 -0.27,-0.19 -0.6,-0.3 -0.49,-0.33 -0.36,-0.11 -0.48,0 -0.84,0.28 -0.66,0.37 -0.39,0.32 -1.34,0.76 -1.75,0.39 -0.14,0.06 -0.13,0.01 -0.09,-0.07 -0.1,-0.26 -0.01,-0.25 0.02,-0.23 -0.02,-0.18 -0.08,-0.11 -0.28,-0.04 -0.43,0.08 -3.65,1.41 -0.34,0.06 -0.34,-0.06 -0.54,-0.26 -1.1,-1.09 -0.33,-0.14 -0.5,-0.06 -2.33,0.3 -3.69,1.28 0.97,2.04 0.72,0.72 2.07,1.33 0.32,0.14 0.31,0.06 1.21,-0.11 0.6,0.18 0.49,0.35 0.46,0.44 0.7,0.83 1.2,1.78 0.39,0.4 2.98,2.14 0.64,0.81 0.36,0.7 0.07,0.52 0.22,0.64 0.39,0.72 0.83,1.19 0.33,0.69 0.13,0.64 -0.09,0.6 -0.47,2 -0.08,0.62 0.01,0.55 0.09,1.05 -0.04,0.49 -0.3,1.47 -0.24,0.78 -0.48,1.08 -0.17,0.25 -0.22,0.19 -0.18,0.1 -0.32,0.4 -1.48,0.72 -8.65,2.39 -3.21,1.61 -0.59,0.17 -0.5,0 -0.39,-0.14 -0.69,-0.04 -0.4,-0.15 -0.78,-0.4 -5.94,-0.24 -1,0.31 -0.61,0.33 -0.4,0.47 -0.28,0.37 -0.11,0.25 -0.18,0.62 -0.79,5.02 -0.02,1.58 0.09,0.39 0.17,0.53 0.74,1.72 0.11,0.82 -0.04,0.48 -0.19,0.24 -0.16,0.09 -0.2,0.03 -0.64,-0.16 -0.84,-0.07 -0.24,-0.1 -0.18,-0.18 -0.25,-0.41 -0.45,-0.9 -0.23,-0.12 -0.35,-0.06 -0.35,0.17 -0.99,0.67 -0.86,0.44 -1.06,0.11 -0.52,0.18 -0.36,0.24 -0.31,0.34 -0.56,0.36 -0.64,0.16 -0.62,0.06 -1,-0.09 -0.73,-0.17 -0.58,-0.07 -0.45,0.07 -0.69,0.27 -0.32,0.23 -0.19,0.26 -0.08,0.34 -0.04,0.43 0,0.52 0.22,1.69 -0.02,0.3 -0.13,0.78 -0.03,0.41 0.04,0.47 0.09,0.44 0.06,0.52 -0.03,0.42 -0.25,0.66 -0.1,0.38 0.04,0.33 0.14,0.23 0.41,0.55 0.23,0.36 0.16,0.4 0.08,0.54 -0.07,0.7 -0.35,0.92 -0.31,0.43 -0.33,0.24 -0.65,0.05 -0.49,0.16 -0.68,0.42 -0.72,0.8 -0.47,0.38 -0.4,0.22 -0.36,0.06 -1.18,-0.05 -0.15,0.03 -0.19,0.06 -0.22,0.03 -0.3,0.01 -0.33,-0.05 -0.37,-0.12 -2.18,-1.13 -0.14,-0.02 -0.09,0.04 -0.36,0.58 -0.31,0.66 -0.67,0.35 -6.15,-0.12 -0.79,-0.25 -0.84,-0.83 -0.66,-0.51 -0.8,-0.48 -1.42,-0.57 -0.76,-0.21 -4.12,-0.36 -0.82,0.03 -0.42,0.06 -6.67,0.27 -0.8,3.38 -1.32,2.53 -2.84,4.25 -0.22,0.65 0.07,0.59 1.95,3.3 0.27,0.64 0.2,0.92 0.17,0.51 0.22,0.43 0.36,0.37 1.54,1.29 0.92,1.11 0.6,0.88 0.39,0.77 0.68,2.47 0.25,0.43 1.37,1.41 0.51,0.83 0.04,0.5 -0.27,0.46 -0.46,0.31 -0.56,0.3 -0.46,0.19 -0.42,0.1 -0.84,0.08 -0.21,0.07 -0.2,0.14 -0.2,0.18 -0.19,0.25 -0.18,0.39 -0.05,0.3 0.05,0.29 0.65,2 0.08,0.55 0,0.33 -0.04,0.15 -0.72,1.45 -1.11,0.8 -1.32,0.44 -4.69,0.44 -5.44,1.52 -0.76,0.34 -0.04,0.09 -0.15,0.21 -0.26,0.27 -0.8,0.55 -0.67,0.29 -0.82,0.19 -1.95,0.87 -1.97,1.49 -0.66,0.69 -0.14,0.31 -0.05,0.36 0.03,0.21 0.09,0.19 0.45,0.4 0.21,0.26 0.19,0.33 0.12,0.47 -0.04,0.38 -0.23,0.69 0.14,0.62 0.34,0.67 0.99,1.37 0.34,0.8 0.25,0.97 0,1.13 0.19,2.18 0.3,1.06 1.6,0.67 1.63,0.05 0.67,-0.09 3.68,-1.16 9.82,-0.4 2.53,-0.5 1.95,-0.78 1.86,-1.53 0.99,-0.6 1.54,-0.62 2.05,-0.47 3.26,-0.34 0.78,-0.3 0.61,-0.53 0.76,-1.19 0.96,-1.2 0.69,-0.63 0.92,-0.69 2.18,-1.02 1.22,-0.13 1.76,0.95 0.8,0.75 2.76,4.53 1.49,3.51 0.15,0.47 -0.03,0.94 0.05,0.34 0.14,0.67 0,0.24 -0.07,0.62 0.02,0.53 0.14,0.3 0.16,0.2 0.67,0.29 0.41,0.14 0.53,0.01 0.32,0.18 0.18,0.27 0.17,0.54 0.15,0.32 0.17,0.19 0.68,0.55 0.38,0.51 1.43,2.83 0.37,0.58 0.3,0.3 0.21,-0.04 0.67,-0.26 0.35,0 0.27,0.15 1.12,1.07 2.09,1.15 0.24,0.04 0.14,-0.05 0.53,-0.46 0.21,-0.13 0.17,-0.07 0.42,-0.08 1.32,-0.08 0.29,-0.08 0.21,-0.1 0.15,-0.12 0.08,-0.16 0.02,-0.18 -0.09,-0.24 -0.14,-0.23 -1.01,-1.06 -0.12,-0.17 -0.03,-0.12 0.03,-0.13 0.11,-0.14 0.22,-0.16 0.25,-0.11 1.34,-0.3 0.85,-0.4 0.92,-0.57 0.63,-0.48 0.49,-0.46 0.45,-0.56 0.73,-1.29 1.11,-2.92 0.54,-0.57 0.83,-0.19 0.55,0.07 0.16,0.07 0.11,0.08 0.11,0.11 0.07,0.15 0.18,0.53 0.15,0.23 0.44,0.49 0.6,0.42 0.39,0.16 0.3,0.07 0.16,-0.02 0.14,-0.05 0.34,-0.05 1.68,0.03 0.55,0.13 0.33,0.16 0.12,0.19 0.08,0.24 0.06,0.3 0.05,0.35 0.36,0.74 1.51,1.12 2.17,-1.07 0.61,-0.04 0.08,0.17 0.07,0.2 0.04,0.2 0.13,1.43 0.14,0.19 0.26,0.24 0.65,0.11 0.34,0 0.3,-0.08 0.35,-0.15 0.3,-0.17 0.34,-0.31 1.58,-1.73 0.64,-0.56 0.36,-0.16 0.29,0.07 0.34,0.21 0.41,0.21 0.88,0.18 0.43,-0.02 0.36,-0.17 0.48,-0.48 1.33,-0.92 0.11,-0.13 0.13,-0.16 4.22,-1.99 0.24,-0.22 0.55,-0.64 0.81,-0.71 2.09,-1.33 0.59,-0.16 0.53,-0.03 1.81,0.17 1.32,-1.04 0.76,-0.5 1.07,-0.43 1.34,-0.27 0.92,-0.32 1.92,-1.03 0.05,-0.84 -0.02,-0.13 -0.05,-0.17 -0.22,-0.17 -0.1,-0.11 0,-0.19 0.12,-0.28 0.69,-1.05 0.11,-0.11 0.14,-0.08 0.18,-0.05 0.64,-0.07 0.16,-0.04 0.15,-0.06 0.14,-0.11 0.12,-0.13 0.1,-0.15 0.13,-0.15 1.6,-1.33 1.44,-1.76 1.61,-1.43 0.26,-0.15 0.68,-0.31 0.75,-0.43 1.22,-0.93 0.12,-0.24 0.03,-0.28 -0.18,-0.63 -0.3,-0.55 -0.64,-0.73 -0.78,-0.68 -1.02,-0.47 -0.43,-0.94 -0.42,-3.23 -0.3,-1.74 -0.3,-0.58 -0.31,-0.34 -0.2,-0.35 -0.11,-0.11 -0.15,-0.1 -0.31,-0.14 -0.3,-0.07 -0.12,-0.06 -0.12,-0.08 -0.18,-0.19 -0.09,-0.12 -0.06,-0.16 -0.05,-0.23 -0.07,-0.24 -0.1,-0.21 -0.16,-0.17 -1.3,-0.8 -0.15,-0.16 -0.09,-0.15 -0.06,-0.16 -0.1,-0.79 -0.06,-0.21 -0.1,-0.26 -0.04,-0.15 -0.04,-0.17 0.01,-0.21 0.06,-0.36 0.15,-0.28 0.22,-0.23 1.17,-0.65 0.25,-0.2 0.14,-0.08 0.15,-0.07 0.21,-0.06 0.88,-0.1 0.17,-0.04 0.19,-0.28 0.26,-0.52 0.3,-1.08 0.74,-1.14 0.58,-0.33 0.4,-0.63 0.27,-1.38 -0.32,-1.75 -0.12,-0.21 -0.18,-0.23 -0.63,-0.04 -0.21,-0.03 -0.15,-0.07 -0.14,-0.13 -0.11,-0.2 -0.26,-0.78 -0.12,-0.27 -0.12,-0.2 -0.13,-0.17 -0.12,-0.11 -0.18,-0.15 -0.06,-0.23 0.14,-1.52 0.28,-0.86 0.27,-1.16 -0.03,-0.64 0.01,-0.46 0.08,-0.41 0.6,-1.16 0.02,-0.28 -0.11,-0.3 -0.14,-0.16 -0.13,-0.13 -0.1,-0.11 -0.04,-0.37 0.04,-0.54 0.25,-1.39 0.22,-0.85 0.68,-1.73 0.12,-0.47 -0.07,-0.51 0.05,-0.89 0.5,-1.89 0.5,-0.25 4.5,-0.17 1.83,0.14 3.66,0.67 6.45,0.42 3.08,0.62 0.53,-0.02 0.58,-0.15 0.87,-0.43 0.54,-0.35 0.4,-0.35 0.66,-0.82 0.1,-0.1 0.35,-0.06 1.81,0.06 0.97,0.18 0.32,0.03 1.8,-0.34 1.28,0.17 0.5,-0.05 0.51,-0.26 0.36,-0.28 0.99,-1.14 0.17,-0.26 0.32,-0.69 0.4,-0.18 0.62,-0.03 2.55,0.46 0.53,0.2 0.41,0.22 0.19,0.14 0.63,0.6 0.26,0.13 0.27,0.04 0.26,-0.04 0.44,-0.18 6.08,-0.96 1.1,0.43 2.97,-2.09 0.46,-0.23 2.65,-0.77 0.22,-0.01 0.21,0.02 1.53,0.46 0.42,-0.19 0.64,-0.42 2.97,-2.54 0.07,-0.69 -0.85,-0.74 -0.21,-0.28 -0.25,-0.65 -0.04,-0.31 0.16,-0.66 0.11,-0.75 0.04,-0.12 0.13,-0.2 1.45,-1.33 0.78,-0.94 0.27,-0.44 0.15,-0.4 0.04,-0.4 -0.06,-0.43 -0.15,-0.48 -0.23,-0.46 -0.5,-0.58 -0.61,-0.53 -1.67,-1.05 -0.33,-0.13 -0.21,0.02 -0.68,0.18 -0.2,0.02 -0.19,-0.02 -0.18,-0.03 -0.83,-0.46 -0.12,-0.03 -0.11,0.03 -0.37,0.2 -0.17,0 -0.11,-0.13 -0.01,-0.42 0.15,-0.31 0.35,-0.44 0.04,-0.16 -0.18,-0.22 -0.34,-0.27 -0.76,-0.43 -0.49,-0.34 -0.44,-0.43 -0.48,-0.8 -0.24,-0.63 -0.44,-1.77 -0.26,-0.33 -1.42,-1.38 -0.81,-0.92 -0.16,-0.23 -0.14,-0.18 -4.02,-3.02 -1.34,-0.65 -2.2,-0.46 -0.94,0.4 -0.47,0.27 -0.22,0.08 -0.33,0.03 -0.41,-0.01 -0.87,-0.12 -0.64,-0.18 -0.87,-0.41 -0.37,-0.25 -0.32,-0.15 -0.22,0.02 -0.33,0.2 -0.19,0.22 -0.1,0.24 -0.02,0.23 0.03,0.22 0.06,0.21 0.21,0.47 0.02,0.12 -0.04,0.12 -0.09,0.1 -0.17,0.09 -0.21,0.08 -0.65,0.15 -0.15,0.09 -0.07,0.12 -0.08,0.53 -0.06,0.2 -0.09,0.16 -0.11,0.1 -0.15,0.05 -0.89,0.08 -0.21,0.06 -0.15,0.11 -0.09,0.14 -0.04,0.2 0.03,0.21 0.05,0.2 0.02,0.18 0,0.18 -0.08,0.15 -0.12,0.13 -0.17,0.08 -0.66,0.16 -0.17,0.07 -0.15,0.11 -1.25,1.62 -0.46,0.47 -0.18,0.11 -0.17,0.03 -0.15,-0.1 -0.17,-0.27 0.03,-0.51 0.09,-0.4 0.34,-0.79 0.05,-0.2 -0.06,-0.37 -1.38,-4.83 -0.39,-0.87 -0.32,-0.53 -0.4,-0.39 -0.82,-0.23 -0.02,-0.37 0.13,-0.33 0.37,-0.49 0.08,-0.14 0.02,-0.11 -0.16,-0.18 -0.91,-0.79 -0.16,-0.31 0.01,-0.25 0.18,-0.14 0.54,-0.22 0.13,-0.1 0.08,-0.15 0.07,-0.23 0.04,-0.28 0.06,-1.23 -0.01,-0.27 -0.03,-0.25 -0.08,-0.28 -0.13,-0.31 -0.16,-0.3 -0.18,-0.25 -0.29,-0.19 -0.35,-0.11 -0.65,-0.05 -0.36,0.05 -0.24,0.1 -0.12,0.12 -0.31,0.01 -2.43,-0.55 -1.5,-0.15 -5.01,-1.73 -0.35,-0.19 -0.39,-0.29 -0.52,-0.59 -0.26,-0.41 -0.64,-1.27 -0.12,-0.32 -0.09,-0.31 -0.06,-0.34 0,-0.26 0.1,-0.65 0,-0.2 -0.04,-0.21 -0.07,-0.17 -0.12,-0.1 -0.17,-0.02 -0.78,0.2 -0.18,0.01 z"
        />
      <path
        id="AF-JOW"
        title="Jawzjan"
        
        d="m 276.12715,67.771194 -0.57,-0.08 -0.97,-0.5 -0.84,-0.83 -1.35,-1.82 -0.88,-0.76 -10.89,-4.1 -0.93,-0.68 -0.33,-0.4 -0.39,-0.58 -0.82,-1.84 -0.38,-0.25 -0.96,-0.22 -0.74,-0.33 -0.12,0.87 -0.3,1.6 -0.64,0.54 -2,-0.02 -0.84,0.19 -0.59,0.35 -0.49,0.63 -0.5,0.99 0,0.01 0,0 -0.01,0.01 -0.6,1.2 -0.49,1.3 -0.23,1.37 0.39,2.62 0.02,1.35 -0.26,1.24 -0.62,0.86 -1.36,1.4 -2.25,3.1 -1.72,0.91 -0.65,0.02 -0.27,0.43 -5.6,10.01 -1.36,4.49 -0.33,1.88 -0.03,0.89 0.03,0.86 0.4,1.81 2.51,3.22 0.56,2.559996 0.15,0.32 0.31,0.52 0.36,0.38 0.68,0.9 0.3,0.57 0.19,0.51 0.03,0.33 -0.02,0.26 -0.34,1.47 -0.42,1.85 -0.6,2.64 -0.15,0.32 -0.29,0.48 -0.28,0.23 -0.37,0.38 -0.1,0.22 0.01,0.23 0.15,0.29 0.21,0.26 0.28,0.26 1.23,0.68 0.29,0.25 0.25,0.28 0.26,0.44 0.06,0.29 0.01,0.21 -0.51,1.91 -0.3,1.88 0.03,0.54 0.13,0.46 0.75,1.22 0.6,1.91 0.3,1.34 0.2,0.63 0.54,1.27 -0.98,0.43 -0.23,0.45 -0.04,0.28 -0.1,0.09 -0.15,0.02 -0.54,-0.09 -8,0.29 -0.94,0.26 -0.26,0.22 -0.37,0.44 -0.17,0.4 -1.49,5.68 0.01,2.81 0.05,0.48 0.07,0.39 0.11,0.33 0.07,0.37 0.03,0.44 -0.03,0.7 -0.08,0.37 -0.16,0.31 -0.4,0.59 -0.33,0.62 -0.17,0.21 -0.39,0.36 -0.21,0.15 -0.52,0.58 0.37,2.03 0.23,0.77 -0.08,0.28 -0.18,0.4 -0.63,0.87 -0.31,0.33 -0.25,0.23 -0.2,0.14 -0.96,0.44 -0.77,0.58 -0.31,0.29 -0.19,0.28 -0.05,0.29 -0.03,0.31 0.02,0.29 0.07,0.24 0.1,0.2 0.23,0.32 0.26,0.23 1.41,1.24 0.83,0.32 0.59,0.07 0.33,0 0.26,-0.07 0.5,-0.38 0.44,-0.23 1.95,-0.22 0.52,-0.13 0.24,-0.01 0.18,0.06 0.09,0.13 0.05,0.16 0.06,0.42 0.15,0.26 0.16,0.08 0.16,-0.03 0.48,-0.26 0.47,-0.16 0.26,0 0.17,0.03 0.41,0.31 0.26,0.16 2.23,0.82 2.32,0.32 3.32,-0.48 0.24,-0.09 0.21,-0.14 0.33,-0.4 0.26,-0.45 0.25,-0.33 0.09,-0.16 0.05,-0.16 0.02,-0.19 0.08,-0.21 0.15,-0.18 0.35,-0.19 0.26,-0.04 0.17,0.03 0.15,0.11 0.14,0.16 0.23,0.43 0.22,0.3 0.35,0.37 0.49,0.39 0.26,0.13 0.2,0 0.15,-0.09 0.49,-0.41 0.17,-0.11 1.37,-0.44 0.44,-0.23 0.84,-0.56 0.8,-0.39 0.18,-0.12 0.17,-0.13 0.16,-0.18 0.14,-0.2 0.13,-0.25 0.09,-0.25 0.11,-0.58 0.04,-0.4 -0.4,0.33 -0.32,0.15 -0.43,0.15 -6.23,0.94 -0.29,-0.22 -0.15,-0.47 0.05,-1.17 0.54,-1.46 -0.01,-0.41 -0.08,-0.49 -0.18,-0.64 -0.21,-0.51 -0.59,-0.91 -1.14,-1.08 0.87,-9.67 -0.01,-0.5 -0.32,-1.96 -0.03,-0.54 0.04,-0.53 0.23,-0.57 0.2,-0.32 0.79,-0.5 2.57,-0.01 5.31,-0.7 1.08,-0.36 1.19,-0.84 2.48,-2.53 2.92,-2.23 1.36,-0.6 4.42,-0.92 0.47,-0.25 0.5,-0.57 0.47,-0.73 0.16,-0.18 0.26,-0.24 2.06,-1.34 1.15,-0.45 1.31,-0.15 1.96,0.56 4.63,-0.27 5.66,-0.94 3.65,-1.04 1.49,-0.1 0.64,0.04 0.62,-0.08 0.29,-0.09 1.86,-0.94 -1.15,-0.98 -1.15,-1.17 -0.43,-0.82 -0.26,-0.94 -0.16,-3.19 -0.62,-0.63 -0.44,-0.28 -0.88,-0.74 -0.24,-0.42 0.01,-0.41 0.41,-0.64 0.46,-0.35 1.67,-0.74 0.2,-0.05 0.23,0.01 0.23,0.05 1.01,0.4 0.25,0.02 0.31,-0.04 0.32,-0.12 0.81,-0.54 0.22,-0.06 0.78,-0.11 0.24,-0.11 0.14,-0.33 0.06,-0.53 -0.43,-1.81 -0.25,-0.6 -0.49,-0.749996 -0.16,-0.65 -0.03,-0.42 0.08,-0.25 0.05,-0.22 0,-0.26 -0.17,-0.37 -0.31,-0.47 -1.17,-1.39 -1.32,-2.21 -0.72,-1.21 -0.23,-1.07 0.22,-1.44 0.41,-1.71 0.99,-3.04 0.11,-0.25 0.05,-0.11 0.14,-0.5 0.06,-0.36 -0.41,-1.05 -2.28,-2.45 -0.66,-0.93 -0.1,-0.19 -0.16,-0.91 -0.02,-0.48 -0.04,-0.25 -0.09,-0.29 -0.12,-0.25 -0.23,-0.36 -0.19,-0.57 -0.27,-0.62 -0.36,-0.4 -0.47,-0.36 -1.7,-0.98 -0.45,-0.16 -0.72,-0.04 -3.02,-0.84 -0.52,-0.22 -0.12,-0.1 -0.12,-0.12 -0.17,-0.22 -0.11,-0.2 -0.05,-0.39 -0.02,-0.32 0.11,-1.95 0.03,-0.41 -0.43,-0.22 -0.46,-0.13 -0.68,-0.57 -0.52,-0.13 -1.6,0.08 z"
        />
      <path
        id="AF-FYB"
        title="Faryab"
        
        d="m 241.16715,129.07119 0.15,-0.02 0.1,-0.09 0.04,-0.28 0.23,-0.45 0.98,-0.43 -0.54,-1.27 -0.2,-0.63 -0.3,-1.34 -0.6,-1.91 -0.75,-1.22 -0.13,-0.46 -0.03,-0.54 0.3,-1.88 0.51,-1.91 -0.01,-0.21 -0.06,-0.29 -0.26,-0.44 -0.25,-0.28 -0.29,-0.25 -1.23,-0.68 -0.28,-0.26 -0.21,-0.26 -0.15,-0.29 -0.01,-0.23 0.1,-0.22 0.37,-0.38 0.28,-0.23 0.29,-0.48 0.15,-0.32 0.6,-2.64 0.42,-1.85 0.34,-1.47 0.02,-0.26 -0.03,-0.33 -0.19,-0.51 -0.3,-0.57 -0.68,-0.9 -0.36,-0.38 -0.31,-0.52 -0.15,-0.32 -0.56,-2.559996 -2.51,-3.22 -0.4,-1.81 -0.03,-0.86 0.03,-0.89 0.33,-1.88 1.36,-4.49 5.6,-10.01 0.27,-0.43 -20.61,0.53 -3.59,1.19 -8.78,4.76 -1.42,1.06 -0.9,1.55 -0.22,2.37 0.92,4.62 0.2,2.37 -0.65,2.05 -1.78,3.28 -5.2,9.569996 -0.8,1.93 -0.62,2.39 -0.16,1.25 0.01,1.22 0.23,1.23 0.68,2.31 0.13,1.25 -0.22,2.4 -0.56,2.22 -0.86,2.09 -3.81,5.91 -0.99,1.19 -1.61,1.3 -1.63,0.61 -3.57,0.84 -0.89,0.37 -0.74,0.49 -0.57,0.73 -0.77,2.42 -0.48,0.4 -0.6,-0.14 -0.81,-0.34 -2,-0.32 -1.8,0.33 -1.71,0.86 -3.21,2.45 -0.61,0.77 -0.41,0.96 0.01,1.07 0.44,2.84 -0.02,0.75 -4.61,-1.81 -1.36,-0.29 -0.76,0.12 1.42,0.84 0.54,1.8 0.03,2.63 -0.18,2.35 -0.85,3.87 -0.42,1.28 -0.12,1.05 0.07,1.25 -0.07,0.29 -0.71,1.15 -0.52,1.45 -0.11,0.67 0.09,0.46 0.3,0.19 0.34,0.1 0.55,0.1 0.64,0.26 0.46,0.26 0.47,0.35 0.83,0.83 0.58,0.74 0.65,1.16 0.41,1.19 0.2,1 0.22,4.18 -0.02,0.58 -0.06,0.5 -0.14,0.59 0,0.33 0.07,0.23 0.19,0.22 0.24,0.2 0.24,0.17 0.52,0.28 7.71,0.55 2.96,0.56 0.31,0.31 0.21,0.36 0.15,0.36 0.06,0.34 -0.01,0.29 -0.11,0.27 -0.06,0.12 -0.33,0.44 -0.03,0.46 1.77,1.04 0.52,0.18 0.39,0.07 0.89,-0.27 0.54,-0.05 1.76,-0.58 2.12,-0.31 0.4,0.37 0.06,0.58 -0.01,0.76 -0.18,1.33 -0.46,1.81 -0.04,0.59 0.03,0.93 -0.26,2.17 -0.03,0.99 0.11,0.77 0.14,0.28 0.27,0.17 4.63,1.54 4.96,0.68 0.9,-0.01 1.44,-0.26 1.62,-0.06 1.14,-0.25 0.52,-0.24 3.69,-1.28 2.33,-0.3 0.5,0.06 0.33,0.14 1.1,1.09 0.54,0.26 0.34,0.06 0.34,-0.06 3.65,-1.41 0.43,-0.08 0.28,0.04 0.08,0.11 0.02,0.18 -0.02,0.23 0.01,0.25 0.1,0.26 0.09,0.07 0.13,-0.01 0.14,-0.06 1.75,-0.39 1.34,-0.76 0.39,-0.32 0.66,-0.37 0.84,-0.28 0.48,0 0.36,0.11 0.49,0.33 0.6,0.3 0.27,0.19 0.47,0.4 0.18,0.12 0.89,0.44 0.15,0.02 0.58,-0.17 0.18,-0.11 0.35,-0.38 0.32,-0.23 0.27,-0.01 0.29,0.11 0.24,0.22 0.19,0.25 0.47,0.86 0.06,0.22 -0.01,0.19 -0.06,0.16 -0.21,0.32 -0.06,0.21 0.03,0.23 0.25,0.27 0.17,0.07 0.12,0 0.09,-0.05 0.11,-0.06 0.12,-0.04 0.84,-0.4 0.25,-0.01 0.21,0.06 0.19,0.16 0.21,0.13 0.39,0.17 0.7,-0.03 2.38,-0.93 0.27,-0.19 1.51,-1.62 1.59,-1.16 -1.08,-1.32 -0.21,-0.38 -0.17,-0.45 -0.55,-1.86 -0.16,-0.9 -0.03,-0.68 0.15,-1.12 0.03,-0.55 -0.2,-1.12 0.09,-1.68 0.17,-1.47 0.09,-0.23 0.16,-0.2 0.68,-0.41 0.26,-0.26 0.22,-0.36 0.62,-1.85 1.5,-2.93 0.1,-0.24 0.01,-0.12 0,-0.14 -0.09,-0.4 -0.62,-2.01 -0.05,-0.22 0,-0.15 0.01,-0.2 0.14,-0.47 0.25,-0.54 0.06,-0.18 0.02,-0.12 -0.03,-0.41 0.02,-0.37 0.17,-0.3 0.29,-0.34 1.53,-1.22 0.35,-0.13 0.47,-0.06 1.52,0.15 1.51,0.41 0.26,0.02 0.24,-0.02 0.59,-0.31 0.93,-1.23 1.1,-1.78 0.23,-0.28 0.29,-0.49 0.18,-0.43 0.19,-0.9 0.05,-0.37 -0.06,-0.31 -0.23,-0.43 -0.02,-0.23 0.1,-0.2 0.35,-0.15 0.27,-0.03 0.23,-0.01 0.86,0.1 1.28,0.29 1.65,-0.26 0.84,-0.29 0.08,-0.06 0.1,-0.2 0.11,-0.32 0.12,-0.65 0.13,-0.38 0.18,-0.34 0.38,-0.48 0.05,-0.16 -0.05,-0.13 -0.24,-0.13 -0.16,-0.04 -0.13,-0.01 -0.03,-0.06 -0.03,-0.14 -0.01,-0.49 -0.48,-2.18 -0.03,-0.28 -0.05,-0.18 -0.08,-0.07 -0.33,-0.06 -0.15,-0.16 -0.11,-0.16 -0.47,-1.16 -0.21,-0.88 -0.1,-0.14 -0.17,-0.14 -0.43,-0.24 -0.25,-0.27 -0.21,-0.52 0.06,-0.27 0.11,-0.23 0.15,-0.16 0.12,-0.17 0.06,-0.13 0.02,-0.12 -0.08,-0.5 0,-0.09 0.06,-0.14 0.33,-0.48 0.04,-0.13 -0.01,-0.19 -0.11,-0.25 -0.2,-0.26 -0.28,-0.23 -0.27,-0.16 -0.32,-0.08 -0.32,-0.03 -0.77,0.24 -1.24,1.01 -0.04,0.4 -0.11,0.58 -0.09,0.25 -0.13,0.25 -0.14,0.2 -0.16,0.18 -0.17,0.13 -0.18,0.12 -0.8,0.39 -0.84,0.56 -0.44,0.23 -1.37,0.44 -0.17,0.11 -0.49,0.41 -0.15,0.09 -0.2,0 -0.26,-0.13 -0.49,-0.39 -0.35,-0.37 -0.22,-0.3 -0.23,-0.43 -0.14,-0.16 -0.15,-0.11 -0.17,-0.03 -0.26,0.04 -0.35,0.19 -0.15,0.18 -0.08,0.21 -0.02,0.19 -0.05,0.16 -0.09,0.16 -0.25,0.33 -0.26,0.45 -0.33,0.4 -0.21,0.14 -0.24,0.09 -3.32,0.48 -2.32,-0.32 -2.23,-0.82 -0.26,-0.16 -0.41,-0.31 -0.17,-0.03 -0.26,0 -0.47,0.16 -0.48,0.26 -0.16,0.03 -0.16,-0.08 -0.15,-0.26 -0.06,-0.42 -0.05,-0.16 -0.09,-0.13 -0.18,-0.06 -0.24,0.01 -0.52,0.13 -1.95,0.22 -0.44,0.23 -0.5,0.38 -0.26,0.07 -0.33,0 -0.59,-0.07 -0.83,-0.32 -1.41,-1.24 -0.26,-0.23 -0.23,-0.32 -0.1,-0.2 -0.07,-0.24 -0.02,-0.29 0.03,-0.31 0.05,-0.29 0.19,-0.28 0.31,-0.29 0.77,-0.58 0.96,-0.44 0.2,-0.14 0.25,-0.23 0.31,-0.33 0.63,-0.87 0.18,-0.4 0.08,-0.28 -0.23,-0.77 -0.37,-2.03 0.52,-0.58 0.21,-0.15 0.39,-0.36 0.17,-0.21 0.33,-0.62 0.4,-0.59 0.16,-0.31 0.08,-0.37 0.03,-0.7 -0.03,-0.44 -0.07,-0.37 -0.11,-0.33 -0.07,-0.39 -0.05,-0.48 -0.01,-2.81 1.49,-5.68 0.17,-0.4 0.37,-0.44 0.26,-0.22 0.94,-0.26 8,-0.29 0.54,0.09 z"
        />
      <path
        id="AF-BAL"
        title="Balkh"
        
        d="m 328.71715,79.381194 -1.08,-0.44 -0.56,-0.94 -0.35,-1.13 -0.49,-1.04 -0.97,-0.9 -2.15,-0.83 -0.98,-0.62 -0.46,-0.93 -0.8,-2.65 -0.6,-0.55 -1.01,-0.3 -1.94,-1.4 -0.89,-0.42 -2.34,-0.05 -4.45,1.06 -6.35,0.28 -0.51,0.19 -0.95,0.83 -0.52,0.19 -1.31,-0.05 -0.6,-0.11 -3.21,-1.37 -1.16,-0.13 -1.24,0.1 -0.94,0.3 -0.81,0.52 -0.86,0.74 -0.74,0.84 -0.41,0.32 -0.51,0.09 -0.6,-0.3 -0.73,-1.09 -0.49,-0.24 -1.16,0.15 -3.34,1.1 -1.27,-0.12 -0.98,-0.74 -0.8,-0.83 -0.34,-0.17 -0.03,0.41 -0.11,1.95 0.02,0.32 0.05,0.39 0.11,0.2 0.17,0.22 0.12,0.12 0.12,0.1 0.52,0.22 3.02,0.84 0.72,0.04 0.45,0.16 1.7,0.98 0.47,0.36 0.36,0.4 0.27,0.62 0.19,0.57 0.23,0.36 0.12,0.25 0.09,0.29 0.04,0.25 0.02,0.48 0.16,0.91 0.1,0.19 0.66,0.93 2.28,2.45 0.41,1.05 -0.06,0.36 -0.14,0.5 -0.05,0.11 -0.11,0.25 -0.99,3.04 -0.41,1.71 -0.22,1.44 0.23,1.07 0.72,1.21 1.32,2.21 1.17,1.39 0.31,0.47 0.17,0.37 0,0.26 -0.05,0.22 -0.08,0.25 0.03,0.42 0.16,0.65 0.49,0.749996 0.25,0.6 0.43,1.81 -0.06,0.53 -0.14,0.33 -0.24,0.11 -0.78,0.11 -0.22,0.06 -0.81,0.54 -0.32,0.12 -0.31,0.04 -0.25,-0.02 -1.01,-0.4 -0.23,-0.05 -0.23,-0.01 -0.2,0.05 -1.67,0.74 -0.46,0.35 -0.41,0.64 -0.01,0.41 0.24,0.42 0.88,0.74 0.44,0.28 0.62,0.63 0.16,3.19 0.26,0.94 0.43,0.82 1.15,1.17 1.15,0.98 5.24,1.04 1.41,0.5 0.24,0.17 0.21,0.21 0.18,0.25 0.12,0.34 0.02,0.24 -0.01,0.2 -0.09,0.38 -0.1,0.27 -0.61,1.17 -0.18,0.25 -0.44,0.46 -0.18,0.23 -0.56,1.01 -0.33,0.48 -1.15,1.05 -0.23,0.27 -0.54,0.77 -0.85,1.56 -0.12,0.28 -0.09,0.33 -0.24,1.29 -0.15,0.47 -1.16,2.51 -0.25,0.76 -0.13,0.26 -0.53,0.82 -0.27,0.52 -1.59,2.47 -0.62,0.79 -0.1,0.23 -0.1,0.32 0.04,0.2 0.19,0.25 1.48,0.75 2.01,1.64 0.31,0.18 0.77,0.15 1.17,-0.04 0.49,0.1 0.24,0.2 0.14,0.22 0.18,0.87 0.02,0.31 -0.02,0.26 -0.19,0.49 -0.08,0.31 0.01,2.3 0.04,0.36 0.13,0.54 0.01,0.17 -0.03,0.17 -0.06,0.15 -0.33,0.46 -0.07,0.15 -0.07,0.24 -0.04,0.27 -0.04,0.73 0.04,0.81 0.72,1.06 0.17,0.62 0.87,5.96 0.07,1.03 -0.05,0.79 -0.36,1.06 -1.31,2.73 -0.35,1.09 -0.05,0.11 -0.09,0.12 -0.13,0.12 -0.18,0.12 -0.69,0.29 -0.22,0.14 -0.42,0.39 -0.46,0.55 -0.27,0.4 -0.52,0.95 -1.05,3.08 0.11,0.29 0.73,0.06 6.93,-1.31 0.07,0.02 0.06,0.05 0.08,0.08 0.09,0.13 0.07,0.15 0.24,0.56 0.15,0.23 0.26,0.21 0.28,0.05 5.32,-0.45 0.42,-0.12 0.39,-0.25 0.41,-0.21 0.7,-0.2 0.77,-0.37 2.41,-1.44 -0.06,-0.65 0.07,-0.49 0.11,-0.51 0.2,-0.56 0.81,-1.47 0.36,-0.44 0.44,-0.43 1.81,-0.87 1.02,-0.78 1.85,-2.22 0.65,-0.78 0.61,-0.47 0.25,-0.29 0.22,-0.4 0.16,-0.61 0.2,-0.41 0.38,-0.33 0.79,-0.42 0.31,-0.25 0.25,-0.5 0.21,-0.68 0.13,-1.17 -0.02,-0.53 -0.11,-0.45 -1.33,-1.78 -0.31,-0.5 -0.18,-0.39 -0.03,-0.13 -0.03,-0.63 -0.04,-0.24 -0.08,-0.16 -0.12,-0.11 -0.3,-0.23 -0.17,-0.2 -0.11,-0.19 -0.05,-0.2 -0.01,-0.13 0.01,-0.1 0.98,-0.96 4.57,-3.51 0.9,-0.29 2.57,-0.39 0.69,-0.21 0.39,-0.3 0.48,-0.46 0.81,-0.98 1.01,-0.94 0.34,-0.38 0.23,-0.45 0.1,-0.8 0,-0.4 -0.09,-0.4 -0.09,-0.28 -0.05,-0.19 0.05,-0.29 0.2,-0.36 0.44,-0.47 0.76,-0.62 0.34,-0.48 0.23,-0.39 0.34,-2.19 0.06,-2.7 0.7,-2.89 1.14,-3.19 -0.02,-0.66 -0.06,-0.46 -1.3,-2.73 -0.84,-1.13 -0.08,-0.15 -0.04,-0.14 0.01,-0.15 0.09,-0.15 0.15,-0.24 0.43,-0.44 0.47,-0.38 0.98,-0.49 2.21,-0.67 0.51,-0.48 0.68,-1.67 0.69,-0.25 5.53,0.52 0.67,-0.18 1.4,-0.57 0.74,-0.18 0.78,-0.05 0.68,0.19 2.77,1.36 1.51,0.95 0.28,0.24 0.64,0.41 1.12,0.37 2.34,0.29 9.66,1.37 1.37,-0.27 3.93,-1.61 -0.37,-1.43 -0.32,-0.66 -0.67,-0.9 -0.97,-0.92 -0.78,-0.57 -0.3,-0.35 -1.3,-2.3 -2.61,-6.4 -0.09,-0.51 -0.1,-3.479996 -0.47,-2.51 0.01,-0.08 -0.22,-0.01 -0.44,-0.32 -0.25,-0.47 -0.19,-0.54 -0.29,-0.5 -1.66,-2.07 -0.44,-0.39 -1.14,-0.6 -0.53,-0.46 -0.77,-1.25 -0.51,-1.08 -0.67,-0.75 -2.2,-0.53 -1.2,-0.61 -1.1,-0.81 -0.6,-0.82 -0.05,-0.91 0.41,-3.89 -0.22,-1.14 -0.57,-0.81 -0.85,-0.52 -1.01,-0.25 -1.73,0.08 -0.61,-0.08 -0.54,-0.27 -1.06,-0.81 -0.55,-0.17 -0.56,0.07 -0.92,0.28 -0.51,0.07 -0.3,0.28 -0.3,0.6 -0.37,0.58 -0.53,0.2 -0.79,-0.71 -0.92,-2.52 -1.11,-0.55 -1.01,0.28 -0.89,0.68 -1.59,1.61 -0.97,0.72 -0.97,0.51 -1.05,0.3 -1.18,0.1 -1.24,0.28 -1.85,1.2 -1.09,0.22 z"
        />
      <path
        id="AF-BAM"
        title="Bamyan"
        
        d="m 352.23715,184.22119 -0.64,-0.06 -6.41,-1.5 -1.22,0.02 -3.01,0.62 -5.23,2.14 -1.9,-0.53 -0.97,-0.06 -0.6,-0.14 -0.27,-0.12 -0.43,-0.04 -0.55,0.08 -4.53,1.76 -3.78,0.97 -4.37,1.96 -1.36,0.32 -4.87,-0.03 -1.32,-0.26 -2.65,-1.06 -1.31,0.27 -0.53,0.44 -2.41,2.99 -3.14,5.82 -0.34,0.47 -0.3,0.25 -0.95,0.05 -0.35,0.08 -2.48,1.01 -1.67,0.61 -1.01,0.09 -6.95,-0.83 -0.76,0.05 -0.31,0.19 -0.27,0.22 -0.34,0.38 -0.24,0.35 -0.22,0.4 -0.32,0.74 -0.09,0.33 -0.23,1.56 0.01,0.23 0.09,0.22 0.15,0.19 0.45,0.43 0.17,0.25 0.09,0.35 0.01,0.37 -0.42,2.4 -0.11,1.49 -0.2,0.71 -0.14,0.34 -0.11,0.35 -0.09,0.43 -0.12,1.55 0.02,0.48 0.06,0.43 0.12,0.34 0.15,0.27 0.36,0.46 0.12,0.13 0.33,0.26 0.44,0.19 2.2,0.46 1.34,0.65 4.02,3.02 0.14,0.18 0.16,0.23 0.81,0.92 1.42,1.38 0.26,0.33 0.44,1.77 0.24,0.63 0.48,0.8 0.44,0.43 0.49,0.34 0.76,0.43 0.34,0.27 0.18,0.22 -0.04,0.16 -0.35,0.44 -0.15,0.31 0.01,0.42 0.11,0.13 0.17,0 0.37,-0.2 0.11,-0.03 0.12,0.03 0.83,0.46 0.18,0.03 0.19,0.02 0.2,-0.02 0.68,-0.18 0.21,-0.02 0.33,0.13 1.67,1.05 0.61,0.53 0.5,0.58 0.23,0.46 0.15,0.48 0.06,0.43 -0.04,0.4 -0.15,0.4 -0.27,0.44 -0.78,0.94 -1.45,1.33 -0.13,0.2 -0.04,0.12 -0.11,0.75 -0.16,0.66 0.04,0.31 0.25,0.65 0.21,0.28 0.85,0.74 -0.07,0.69 -2.97,2.54 -0.64,0.42 -0.42,0.19 -1.53,-0.46 -0.21,-0.02 -0.22,0.01 -2.65,0.77 -0.46,0.23 -2.97,2.09 -0.89,1.22 -0.04,0.21 -0.02,0.28 0.48,0.61 0.35,0.63 1.73,0.08 1.54,0.58 0.61,0.3 0.36,0.26 0.29,0.35 0.1,0.32 0.02,0.35 -0.09,0.24 -0.15,0.17 -0.22,0.11 -0.51,0.18 -0.26,0.14 -0.65,0.56 -0.3,0.32 -0.17,0.31 -0.08,0.3 0.22,2.17 0.72,1.88 -0.02,0.38 -0.11,0.6 -1.18,2.54 -0.33,1.03 -0.15,1.74 0.02,0.82 0.13,0.57 0.18,0.29 0.5,0.58 2.78,2.7 2.78,1.5 1.06,0.14 1.27,-0.55 0.59,-0.15 0.23,-0.13 0.2,-0.2 0.45,-0.29 0.64,-0.27 1.46,-0.27 0.82,0 8.61,1.75 0.37,0.18 0.24,0.2 0.16,0.24 0.12,0.24 0.12,0.18 0.08,0.1 0.25,0.17 1.83,0.78 0.36,0.01 0.29,-0.06 2.75,-1.69 0.49,-0.19 0.79,-0.22 0.45,-0.04 0.27,0.03 0.1,0.05 0.2,0.17 0.74,0.87 0.15,0.02 0.12,-0.09 0.13,-0.15 0.35,-0.28 0.16,-0.19 0.37,-0.73 0.17,-0.23 0.2,-0.22 0.26,-0.21 1.62,-0.46 4.03,-0.64 0.44,-0.29 0.43,-0.36 0.7,-0.86 0.88,-2.37 0.21,-0.4 0.38,-0.91 0.63,-0.8 1.99,-1.49 -0.87,-0.81 -0.2,-0.5 0,-0.62 0.3,-1.19 0.32,-0.5 0.34,-0.33 3.9,-1.51 0.2,-0.16 0.13,-0.19 0.21,-0.57 0.15,-0.32 0.7,-0.95 0.48,-0.51 -0.17,-0.34 -0.57,-0.45 -4.78,-2.18 -0.6,-0.17 -1.56,-0.19 -0.28,-0.1 -0.18,-0.15 0.03,-0.31 0.11,-0.23 1.08,-0.61 0.39,-0.11 0.18,-0.09 0.21,-0.13 0.15,-0.18 0.12,-0.23 0.06,-0.31 0.01,-0.38 -0.05,-0.37 -0.13,-0.41 -0.24,-0.39 -0.49,-0.38 -0.45,-0.14 -0.49,-0.04 -2.13,0.11 -3.38,-0.31 -0.33,-0.13 -0.34,-0.18 -0.31,-0.25 -0.27,-0.35 -0.12,-0.5 -0.01,-0.72 0.31,-0.94 0.24,-0.58 0.25,-0.44 0.24,-0.33 0.25,-0.25 0.3,-0.19 0.31,-0.12 1.3,-0.14 0.27,-0.07 0.24,-0.12 0.84,-0.67 0.17,-0.25 0.09,-0.35 0.06,-1.02 -0.11,-0.45 -0.28,-0.42 -1.45,-1.22 -0.51,-0.73 -0.48,-1.64 0.25,-0.64 0.17,-0.23 0.48,-0.24 0.4,-0.14 2.7,-0.37 4.25,-0.86 0.31,-0.13 1.37,-0.84 0.29,-0.1 0.29,-0.04 0.45,0.07 0.55,0.17 0.93,0.41 0.39,0.32 0.24,0.3 0.23,0.23 0.4,0.12 1.49,0.14 0.93,0.28 0.8,0.12 1.39,0.04 1.83,-0.25 1.13,0.2 8.92,2.53 2.98,0.34 1.09,-2.32 0.25,-0.74 0.2,-0.3 0.95,-1.09 0.32,-0.49 0.33,-0.36 0.35,-0.22 0.56,-0.13 0.42,-0.01 0.36,0.1 0.54,0.31 0.39,-0.16 0.53,-0.44 1.01,-1.1 0.7,-1.16 1.37,-1.03 5.59,-2.91 -0.57,-0.48 -0.92,-0.52 -0.12,-0.18 -0.12,-0.31 0.25,-1.81 0.06,-1.76 -0.15,-1.32 -0.04,-1.51 -0.63,-1.74 -2.55,-2.75 -0.3,0.14 -0.21,0.03 -0.24,0 -0.23,-0.09 -1.7,-1.45 -0.32,-0.17 -0.35,-0.08 -0.34,0 -1.13,0.27 -0.34,0.04 -0.28,-0.03 -0.22,-0.12 -0.18,-0.16 -0.15,-0.17 -0.16,-0.11 -1.48,-0.45 -0.25,-0.18 -0.17,-0.26 -0.12,-0.46 -0.21,-1.99 0,-0.35 0.03,-0.37 0,-0.35 -0.04,-0.35 -0.09,-0.32 -0.12,-0.3 -0.07,-0.32 0,-0.35 0.22,-1.29 0.11,-0.39 0.27,-0.53 0.24,-0.35 0.34,-0.37 0.29,-0.25 1.24,-0.68 0.32,-0.69 0.13,-0.54 0.34,-0.74 0.14,-0.47 0.27,-1.72 0.17,-0.63 0.19,-0.48 0.2,-0.27 0.18,-0.35 0.04,-0.4 -0.38,-1.21 -0.02,-0.53 0.17,-0.63 0.37,-0.84 0.06,-0.44 -0.06,-0.49 -0.73,-2.01 -0.19,-1.04 0.13,-1.53 -4.26,0.93 -1.95,-0.11 -4.82,0.73 -0.39,-0.05 -0.39,-0.23 -0.26,-0.25 -0.4,-0.58 -0.24,-0.23 -0.36,-0.1 -0.48,0.02 -2.64,0.89 -0.52,0.04 z"
        />
      <path
        id="AF-HER"
        title="Hirat"
        
        d="m 42.797153,175.00119 -0.6,-0.53 0.41,-0.67 0.04,-0.16 -0.45,-0.41 -0.36,-0.18 -0.41,0 -2.54,0.49 -0.66,0.25 0.35,0.55 0.52,2.45 0.12,1.2 -0.31,1.24 -0.64,1.12 -1.14,1.39 -0.54,1.15 -0.42,1.87 -0.26,0.6 -1.02,1.38 -0.28,0.66 -0.23,1.22 0.23,3.06 -0.39,1.05 -0.93,0.54 -1.16,0.19 -1.03,0.03 -0.7,0.57 -0.28,1.27 -0.04,1.27 0.03,0.57 0.27,0.26 0.24,0.57 -0.02,0.57 -0.49,0.26 -0.29,0.27 0.25,0.59 1.73,2.33 0.13,0.25 -0.09,0.68 -0.13,0.52 0.07,0.49 0.51,0.54 -1.17,1.65 -0.35,0.85 -0.29,2.45 -0.71,2.22 -0.16,1.16 -0.15,0.57 -0.69,1.11 -0.15,0.74 0.05,0.61 0.21,1.1 0.04,0.51 -0.21,2.09 -0.39,1.95 -1.49,0.5 -0.27,0.97 -0.94,1.7 -1.54,1.2 -0.88,1.03 -0.06,1.39 0.16,1.53 -0.19,1.43 -0.51,0.68 -0.56,0.13 -0.63,-0.05 -0.68,0.11 -0.65,0.38 -0.32,0.39 -0.24,0.47 -2.21,2.52 -0.94,0.65 -1.21,0.34 -2.66,0.36 -1.21,0.62 -0.71,1.24 0.52,0.07 0.41,0.24 0.32,0.4 0.41,1.41 0.43,0.41 1.19,0.54 0.59,0.54 0.47,0.68 0.77,1.53 3.59,4.69 0.56,1.1 -3.62,0.21 -4.93,0.31 -3.4199997,0.2 0.33,1.25 -0.76,0.83 -2.3,1.23 -1.7,1.77 -1.53,1.99 -1.36000003,2.76 -0.29,2.62 0.08,0.79 0.53,5.07 1.39000003,8.93 -0.11,2.29 -1.50000003,3.39 -0.39,1.91 1.21000003,4.25 3.06,2.95 3.91,1.62 3.7999997,0.3 3.57,-0.19 1.87,0.13 1.63,0.42 0.75,0.44 0.82,0.73 0.43,0.84 -0.05,0.09 0.97,0.11 1.71,0.2 2.77,1.21 6.42,1.45 3.29,0.27 6.99,-0.75 0.89,0 0.56,0.14 1.01,0.45 0.52,0.05 0.66,-0.06 1.33,-0.46 0.57,-0.35 0.41,-0.4 0.31,-0.56 0.24,-0.57 0.34,-0.44 0.5,-0.28 1.09,-0.21 2.22,0.1 2.31,0.48 0.66,0.74 0.88,0.07 1.48,-0.1 3.65,0.27 3.21,0.74 0.47,0.39 0.1,0.41 -0.01,0.6 -0.07,0.48 -0.17,0.43 -0.22,0.31 -0.7,0.68 -0.18,0.27 -0.12,0.38 -0.05,0.5 -0.02,2.48 -0.08,0.46 -0.13,0.38 -0.25,0.39 -0.88,0.91 -0.7,0.52 -0.24,0.25 -0.4,0.61 -0.22,0.25 -0.45,0.41 -0.15,0.26 -0.01,0.52 0.23,0.47 1.9,2.09 2.19,3.52 -0.04,0.64 -0.46,0.6 -1.33,1.02 -0.47,0.43 -0.31,0.36 -0.53,0.75 -1.63,1.66 -0.64,0.51 -0.22,0.28 -0.17,0.32 -0.13,0.37 -0.14,0.28 -0.2,0.25 -0.28,0.24 -1.08,0.66 -0.28,0.26 -0.21,0.33 -0.28,0.88 -0.27,1.89 -0.06,2.05 0.1,0.94 0.3,0.68 0.39,0.29 0.49,0.21 0.52,0.16 2.89,0.11 0.5,0.11 0.36,0.21 0.32,0.42 0.51,0.91 1.8,1.84 0.41,0.33 0.24,0.15 0.22,0.08 0.24,0.02 0.32,-0.06 0.39,-0.2 0.31,-0.23 0.53,-0.57 1.28,-1.47 2.46,-1.81 0.79,-0.35 0.4,-0.02 0.3,0.05 0.16,0.11 0.1,0.16 0.1,1.54 0.12,0.7 0.28,0.84 0.03,0.22 0,0.22 -0.03,0.25 0.01,0.21 0.04,0.24 0.08,0.19 0.29,0.45 0.11,0.21 0.17,0.51 0.13,0.26 0.2,0.29 0.29,0.13 0.33,0.07 0.71,0.07 0.68,-0.07 0.41,-0.17 0.72,-0.39 1.47,-1.36 0.36,-0.26 0.77,-0.31 1.42,-0.31 3.97,-0.41 1.84,-0.36 1.1,0.04 0.94,0.15 0.34,-0.06 0.17,-0.13 0,-0.15 -0.14,-0.89 0.04,-0.37 0.18,-0.49 1.13,-2.44 0.11,-0.42 0.03,-0.29 -0.02,-0.31 -0.14,-0.63 -0.03,-0.47 0.06,-0.62 0.29,-0.94 0.32,-0.48 0.31,-0.29 0.78,-0.49 1.25,-1.04 1.42,-0.96 1.99,-1.01 0.63,-0.21 0.4,-0.06 0.29,-0.01 0.22,0.06 0.219997,0.08 1.29,0.7 0.3,0.08 0.37,0.05 0.41,-0.01 2.5,-0.48 1.97,-0.66 0.73,-0.42 0.54,-0.46 0.26,-0.41 0.18,-0.44 0.12,-0.54 0.32,-0.57 0.29,-0.27 0.26,-0.11 1.92,0.13 0.64,-0.07 0.73,-0.16 4.03,-1.43 1.18,-0.21 0.15,0.01 0.06,0.08 -0.03,0.14 -0.12,0.42 -0.04,0.19 0,0.18 0.03,0.14 0.07,0.11 0.06,0.06 0.15,0.07 0.17,0.04 4.24,-1.59 1.3,-1.31 0.12,-0.22 0.13,-0.37 -0.02,-0.27 0.12,-0.74 0.29,-1.04 0.84,-2.3 0.54,-1.15 0.46,-0.75 0.37,-0.28 1.1,-0.52 0.84,-0.65 -0.3,-1.06 -0.19,-2.18 0,-1.13 -0.25,-0.97 -0.34,-0.8 -0.99,-1.37 -0.34,-0.67 -0.14,-0.62 0.23,-0.69 0.04,-0.38 -0.12,-0.47 -0.19,-0.33 -0.21,-0.26 -0.45,-0.4 -0.09,-0.19 -0.03,-0.21 0.05,-0.36 0.14,-0.31 0.66,-0.69 1.97,-1.49 1.95,-0.87 0.82,-0.19 0.67,-0.29 0.8,-0.55 0.26,-0.27 0.15,-0.21 0.04,-0.09 0.76,-0.34 5.44,-1.52 4.69,-0.44 1.32,-0.44 1.11,-0.8 0.72,-1.45 0.04,-0.15 0,-0.33 -0.08,-0.55 -0.65,-2 -0.05,-0.29 0.05,-0.3 0.18,-0.39 0.19,-0.25 0.2,-0.18 0.2,-0.14 0.21,-0.07 0.84,-0.08 0.42,-0.1 0.46,-0.19 0.56,-0.3 0.46,-0.31 0.27,-0.46 -0.04,-0.5 -0.51,-0.83 -1.37,-1.41 -0.25,-0.43 -0.68,-2.47 -0.39,-0.77 -0.6,-0.88 -0.92,-1.11 -1.54,-1.29 -0.36,-0.37 -0.22,-0.43 -0.17,-0.51 -0.2,-0.92 -0.27,-0.64 -1.95,-3.3 -0.07,-0.59 0.22,-0.65 2.84,-4.25 1.32,-2.53 0.8,-3.38 6.67,-0.27 0.42,-0.06 0.82,-0.03 4.12,0.36 0.76,0.21 1.42,0.57 0.8,0.48 0.66,0.51 0.84,0.83 0.79,0.25 6.15,0.12 0.67,-0.35 0.31,-0.66 0.36,-0.58 0.09,-0.04 0.14,0.02 2.18,1.13 0.37,0.12 0.33,0.05 0.3,-0.01 0.22,-0.03 0.19,-0.06 0.15,-0.03 1.18,0.05 0.36,-0.06 0.4,-0.22 0.47,-0.38 0.72,-0.8 0.68,-0.42 0.49,-0.16 0.65,-0.05 0.33,-0.24 0.31,-0.43 0.35,-0.92 0.07,-0.7 -0.08,-0.54 -0.16,-0.4 -0.23,-0.36 -0.41,-0.55 -0.14,-0.23 -0.04,-0.33 0.1,-0.38 0.25,-0.66 0.03,-0.42 -0.06,-0.52 -0.09,-0.44 -0.04,-0.47 0.03,-0.41 0.13,-0.78 0.02,-0.3 -0.22,-1.69 0,-0.52 0.04,-0.43 0.08,-0.34 0.19,-0.26 0.32,-0.23 0.69,-0.27 0.45,-0.07 0.58,0.07 0.73,0.17 1,0.09 0.62,-0.06 0.64,-0.16 0.56,-0.36 0.31,-0.34 0.36,-0.24 0.52,-0.18 1.06,-0.11 0.86,-0.44 0.99,-0.67 0.35,-0.17 0.35,0.06 0.23,0.12 0.45,0.9 0.25,0.41 0.18,0.18 0.24,0.1 0.84,0.07 0.64,0.16 0.2,-0.03 0.16,-0.09 0.19,-0.24 0.04,-0.48 -0.11,-0.82 -0.74,-1.72 -0.17,-0.53 -0.09,-0.39 0.02,-1.58 0.79,-5.02 -5.37,0.39 -0.33,-0.06 -1.26,-0.55 -0.56,-0.18 -0.58,-0.1 -4.75,-0.08 -0.46,0.05 -0.59,0.22 -0.71,0.36 -1.21,0.84 -0.51,0.52 -0.3,0.43 -0.25,1.03 -0.09,0.18 -0.1,0.14 -0.25,0.17 -0.31,0.11 -1.14,0.16 -0.5,0.18 -3.26,2.62 -10.01,3.01 -0.96,0.1 -0.41,-0.12 -0.61,-0.44 -0.4,-0.37 -1.43,-0.81 -3.71,-1.09 -0.74,0.35 -0.79,0.23 -0.53,-0.01 -2.8,-0.48 -0.88,-0.28 -2,-1.08 -0.49,-0.4 -0.7,-0.72 -1.61,-0.87 -3.52,-1.29 -4.06,-0.46 -1.57,-0.14 -0.54,0.11 -0.41,0.25 -1.73,1.5 -0.76,0.16 -3.03,-1.46 -1.56,-0.32 -1.42,-0.28 -0.65,0.02 -0.09,-0.02 -0.08,-0.05 -0.05,-0.15 0.07,-1.62 -0.33,-0.84 -0.25,-0.39 -0.18,-0.16 -0.15,-0.17 -0.73,-1.18 -0.22,-0.2 -0.24,-0.08 -0.91,0.11 -1.83,-0.01 -0.41,-0.12 -0.59,-0.23 -0.64,-0.4 -0.54,-0.42 -0.43,-0.45 -0.33,-0.28 -0.31,-0.18 -1.38,-0.39 -0.36,-0.15 -0.51,-0.29 -1.28,-1.01 -1.68,-1.64 -0.39,-0.27 -0.31,-0.1 -0.22,-0.01 -0.31,0.06 -0.44,0.02 -0.36,-0.03 -2.19,-0.93 -0.16,-0.12 -0.14,-0.21 -0.17,-0.38 -0.34,-1.09 -0.11,-0.61 -0.05,-0.7 0.61,-6.63 0.36,-2.13 0.88,-2.97 0.49,-1.15 4.08,-6.85 1.88,-5.47 0.01,-0.5 -3.04,1.49 -1.27,1.29 -0.61,0.85 -0.63,0.62 -0.73,0.45 -3.52,1.53 -0.8,0.19 -0.43,-0.07 -1.43,-0.6 -0.52,0.02 -0.48,0.14 -0.489997,0.04 -0.53,-0.29 -3.18,-2.95 -1.31,0.07 -1.58,1.47 -4.72,6.44 -0.77,0.4 -0.51,-0.61 -0.91,-2.14 -0.29,-0.91 0.08,-2.4 -0.07,-1.04 -0.33,-1.05 -0.52,-0.94 -0.71,-0.74 -2.67,-1.18 -1.34,-0.9 -4.97,-4.92 -1.28,-0.89 -1.44,-0.71 -2.83,-0.06 -5.84,2.05 -2.88,0.22 -6.54,-1 -3.2,-1.3 -2.23,-2.49 -3.16,-2.9 -0.4,-0.18 -0.33,-0.15 -0.55,-0.09 -0.39,-0.22 -0.31,-0.35 -0.32,-0.47 -0.01,-0.24 0.19,-0.64 -0.02,-0.26 -0.77,-0.69 -0.11,-0.03 -0.07,0.02 z"
        />
      <path
        id="AF-BDG"
        title="Badghis"
        
        d="m 185.50715,186.97119 -0.39,-0.07 -0.52,-0.18 -1.77,-1.04 0.03,-0.46 0.33,-0.44 0.06,-0.12 0.11,-0.27 0.01,-0.29 -0.06,-0.34 -0.15,-0.36 -0.21,-0.36 -0.31,-0.31 -2.96,-0.56 -7.71,-0.55 -0.52,-0.28 -0.24,-0.17 -0.24,-0.2 -0.19,-0.22 -0.07,-0.23 0,-0.33 0.14,-0.59 0.06,-0.5 0.02,-0.58 -0.22,-4.18 -0.2,-1 -0.41,-1.19 -0.65,-1.16 -0.58,-0.74 -0.83,-0.83 -0.47,-0.35 -0.46,-0.26 -0.64,-0.26 -0.55,-0.1 -0.34,-0.1 -0.3,-0.19 -0.09,-0.46 0.11,-0.67 0.52,-1.45 0.71,-1.15 0.07,-0.29 -0.07,-1.25 0.12,-1.05 0.42,-1.28 0.85,-3.87 0.18,-2.35 -0.03,-2.63 -0.54,-1.8 -1.42,-0.84 -0.8,0.13 -1.45,0.45 -4.56,2.68 -1.95,0.51 -5.99,0.37 -0.98,0.22 -0.9,0.5 -0.67,0.7 -1.15,1.57 -0.72,0.65 -3.92,1.85 -4.24,0.88 -10.55,-0.24 -1.03,0.23 -0.75,0.78 -0.21,1.04 0.34,0.76 0.48,0.76 0.22,1.06 0.31,0.78 2.48,2.25 0.68,0.92 0.32,0.27 1.23,0.47 0.25,0.31 -0.04,0.41 -0.29,0.55 -1.34,1 -3.73,1.22 -1.28,1.27 -0.08,0.89 0.11,3.04 0.16,0.73 0.81,0.66 0.17,0.63 -0.5,1.87 -0.21,2.25 -0.29,1.11 -0.65,0.68 -0.96,0.26 -2.01,0.17 -0.98,0.23 -3.26,1.57 -4.39,3.5 -0.22,0.11 -0.01,0.5 -1.88,5.47 -4.08,6.85 -0.49,1.15 -0.88,2.97 -0.36,2.13 -0.61,6.63 0.05,0.7 0.11,0.61 0.34,1.09 0.17,0.38 0.14,0.21 0.16,0.12 2.19,0.93 0.36,0.03 0.44,-0.02 0.31,-0.06 0.22,0.01 0.31,0.1 0.39,0.27 1.68,1.64 1.28,1.01 0.51,0.29 0.36,0.15 1.38,0.39 0.31,0.18 0.33,0.28 0.43,0.45 0.54,0.42 0.64,0.4 0.59,0.23 0.41,0.12 1.83,0.01 0.91,-0.11 0.24,0.08 0.22,0.2 0.73,1.18 0.15,0.17 0.18,0.16 0.25,0.39 0.33,0.84 -0.07,1.62 0.05,0.15 0.08,0.05 0.09,0.02 0.65,-0.02 1.42,0.28 1.56,0.32 3.03,1.46 0.76,-0.16 1.73,-1.5 0.41,-0.25 0.54,-0.11 1.57,0.14 4.06,0.46 3.52,1.29 1.61,0.87 0.7,0.72 0.49,0.4 2,1.08 0.88,0.28 2.8,0.48 0.53,0.01 0.79,-0.23 0.74,-0.35 3.71,1.09 1.43,0.81 0.4,0.37 0.61,0.44 0.41,0.12 0.96,-0.1 10.01,-3.01 3.26,-2.62 0.5,-0.18 1.14,-0.16 0.31,-0.11 0.25,-0.17 0.1,-0.14 0.09,-0.18 0.25,-1.03 0.3,-0.43 0.51,-0.52 1.21,-0.84 0.71,-0.36 0.59,-0.22 0.46,-0.05 4.75,0.08 0.58,0.1 0.56,0.18 1.26,0.55 0.33,0.06 5.37,-0.39 0.18,-0.62 0.11,-0.25 0.28,-0.37 0.4,-0.47 0.61,-0.33 1,-0.31 5.94,0.24 0.78,0.4 0.4,0.15 0.69,0.04 0.39,0.14 0.5,0 0.59,-0.17 3.21,-1.61 8.65,-2.39 1.48,-0.72 0.32,-0.4 0.18,-0.1 0.22,-0.19 0.17,-0.25 0.48,-1.08 0.24,-0.78 0.3,-1.47 0.04,-0.49 -0.09,-1.05 -0.01,-0.55 0.08,-0.62 0.47,-2 0.09,-0.6 -0.13,-0.64 -0.33,-0.69 -0.83,-1.19 -0.39,-0.72 -0.22,-0.64 -0.07,-0.52 -0.36,-0.7 -0.64,-0.81 -2.98,-2.14 -0.39,-0.4 -1.2,-1.78 -0.7,-0.83 -0.46,-0.44 -0.49,-0.35 -0.6,-0.18 -1.21,0.11 -0.31,-0.06 -0.32,-0.14 -2.07,-1.33 -0.72,-0.72 -0.97,-2.04 -0.52,0.24 -1.14,0.25 -1.62,0.06 -1.44,0.26 -0.9,0.01 -4.96,-0.68 -4.63,-1.54 -0.27,-0.17 -0.14,-0.28 -0.11,-0.77 0.03,-0.99 0.26,-2.17 -0.03,-0.93 0.04,-0.59 0.46,-1.81 0.18,-1.33 0.01,-0.76 -0.06,-0.58 -0.4,-0.37 -2.12,0.31 -1.76,0.58 -0.54,0.05 -0.89,0.27 z"
        />
    </svg>

  `,
  france: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 180" class="dmb-country-map" data-map-name="france">
      <path d="M60 20 L120 30 L150 70 L135 130 L90 160 L40 135 L25 85 Z"></path>
    </svg>
  `
};

(function () {
  const MODE_KEY = "dmb_mode";
  const COVER_KEY = "dmb_selected_cover";

  function setStoredMode(mode) {
    try {
      if (!mode) localStorage.removeItem(MODE_KEY);
      else localStorage.setItem(MODE_KEY, mode);
    } catch {}
  }

  function clearCoverState() {
    try { localStorage.removeItem(COVER_KEY); } catch {}
    try { sessionStorage.removeItem(COVER_KEY); } catch {}
  }

  function onCustomizeClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    clearCoverState();
    setStoredMode("customize");
    window.location.assign("/pages/design-my-book?step=upload");
    return false;
  }

  function onBrowseClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    setStoredMode("browse");
    window.location.assign("/collections");
    return false;
  }

  function hookButtonsDirect() {
    const browseBtn =
      document.getElementById("browseCollectionBtn") ||
      document.querySelector('#step1 a[href*="/collections"]');

    const customizeBtn =
      document.getElementById("customizeOrderBtn") ||
      document.querySelector('#step1 a[href*="mode=customize"]');

    if (browseBtn) browseBtn.addEventListener("click", onBrowseClick, true);
    if (customizeBtn) customizeBtn.addEventListener("click", onCustomizeClick, true);
  }

  function enforceUrlWinsOverStorage() {
    try {
      const qs = new URLSearchParams(window.location.search || "");
      const urlMode = qs.get("mode");
      if (urlMode) setStoredMode(urlMode);
    } catch {}
  }

  function enforceCustomizeClearsCover() {
    try {
      const qs = new URLSearchParams(window.location.search || "");
      if (qs.get("mode") === "customize") clearCoverState();
    } catch {}
  }

  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      hookButtonsDirect();
      enforceUrlWinsOverStorage();
      enforceCustomizeClearsCover();
    }
  });

  function renderBuilderCanvas() {
    if (builderMode === "cover") {
      renderCoverCanvas();
    } else {
      renderSpread();
    }
    syncBuilderModeButtons();
    setCanvasZoom(currentZoom);
  }

  function openCoverMode() {
    builderMode = "cover";
    syncBuilderModeButtons();
    renderBuilderCanvas();
    activateLeftTab("cover");
  }

  function initDefaultBuilderPreview() {
    if (!builderStep) return;

    initUnifiedTabs();
    initCoverDesigner();

    builderMode = "cover";
    syncBuilderModeButtons();
    renderCoverCanvas();
    renderThumbsRail();

    if (bookMeta) {
      const selectedPages = Number(pagesEl?.value || 0);
      if (selectedPages > 0) {
        bookMeta.textContent = `${selectedPages} pages (${Math.max(0, selectedPages - 1)} to design) • ${editor.photos.length} photos`;
      } else {
        bookMeta.textContent = "Start by choosing pages, photos, and customizing your cover.";
      }
    }
  }

  function getObjectListForTarget(targetType, pageNumber, zone) {
    if (targetType === "cover") {
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      return editor.coverObjects;
    }

    if (!editor.pageObjects || typeof editor.pageObjects !== "object") {
      editor.pageObjects = {};
    }

    // WARNING: Do NOT use `if (!p)` here — Number(0) = 0 and !0 = true,
    // which would silently return [] for page 0 (the special inner-cover page),
    // making all maps/stickers/text on page 0 invisible in the builder.
    if (pageNumber == null || !Number.isFinite(Number(pageNumber))) return [];
    const p = Number(pageNumber);

    if (!Array.isArray(editor.pageObjects[p])) {
      editor.pageObjects[p] = [];
    }

    return editor.pageObjects[p];
  }

  function renderFreeFrameObjects(container, meta) {
    const targetType = meta?.targetType || "page";
    const pageNumber = meta?.pageNumber ?? null;
    const zone = meta?.zone || null;
    // Pages: z >= 60 keeps frames above the spread overlay (z:50).
    // Cover: use own z-value — drops handled by peek-under method, not z-index.
    const minFrameZ = targetType === "cover" ? 0 : 60;

    const rawObjs = getObjectListForTarget(targetType, pageNumber, zone);

    const objs = Array.isArray(rawObjs)
      ? rawObjs.slice().sort((a, b) => Number(a.z || 0) - Number(b.z || 0))
      : [];

    objs.forEach((obj) => {
      if (obj.type === "text") {
        // Skip empty text — cleared text boxes are removed from state in
        // savePageTextState/saveCoverTextNodeState; this is a safety net so stale
        // empty objects left in older saved sessions never reappear after a re-render.
        if (!obj.text || !obj.text.trim()) return;
        const txt = document.createElement("div");
        txt.id = obj.id;
        txt.textContent = obj.text || "";
        txt.classList.add("dmb-editable-text");
        txt.style.position = "absolute";
        txt.style.left = obj.left || "40px";
        txt.style.top = obj.top || "40px";
        if (obj.width) txt.style.width = obj.width;
        txt.style.fontSize = obj.fontSize || "28px";
        txt.style.fontWeight = obj.fontWeight || "800";
        txt.style.color = obj.color || "#666";
        txt.style.fontFamily = obj.fontFamily || "'Londrina Solid', sans-serif";
        if (obj.textAlign) txt.style.textAlign = obj.textAlign;
        if (obj.textDecoration) txt.style.textDecoration = obj.textDecoration;
        if (obj.transform) txt.style.transform = obj.transform;
        if (obj.rotate) txt.dataset.rotate = obj.rotate;
        txt.dataset.z = obj.z || String(Date.now());
        txt.style.zIndex = txt.dataset.z;
        txt.dataset.pageNumber = String(pageNumber);
        txt.style.padding = "2px 6px";
        txt.style.background = "transparent";
        txt.style.outline = "none";
        attachTextNodeHandlers(txt);
        container.appendChild(txt);
        return;
      }

      if (obj.type !== "photo-frame") return;

      const frame = document.createElement("div");
      frame.className = "dmb-photo-frame-object";
      frame.dataset.objectId = obj.id;
      frame.style.left = `${obj.x}px`;
      frame.style.top = `${obj.y}px`;
      frame.style.width = `${obj.w}px`;
      frame.style.height = `${obj.h}px`;
      const z = obj.z || 10;
      // On pages: z >= 60 (above spread overlay z:50). On cover: z >= 100001 (above cover drag overlay z:100000).
      frame.style.zIndex = String(Math.max(z, minFrameZ));
      frame.dataset.z = String(z);
      if (obj.rotation) frame.style.transform = `rotate(${obj.rotation}deg)`;
      if (obj.coverZone) dmbApplyZoneClip(frame, obj);

      if (obj.photoId) {
        const ph = getPhotoById(obj.photoId);
        if (ph) {
          // Overflow visible so buttons escape; inner clip keeps photo contained
          frame.style.overflow = "visible";
          const photoClip = document.createElement("div");
          photoClip.style.cssText = "position:absolute;inset:0;overflow:hidden;border-radius:inherit;pointer-events:none;";
          const img = document.createElement("img");
          img.src = ph.url; img.alt = ""; img.draggable = false;
          img.style.cssText = "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;";
          if (obj.frameShape) applyDmbFrameShape(img, obj.frameShape);
          photoClip.appendChild(img);
          frame.appendChild(photoClip);

          // Adaptive button layout based on frame width
          const _btnSVGs = [
            { aria:"Remove photo",  title:"Remove photo",  svg:`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Remove Photo");obj.photoId=null;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail();renderPhotoTray(); }},
            { aria:"Rotate",        title:"Rotate 90° anti-clockwise", svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Rotate Photo");obj.rotation=((obj.rotation||0)-90+360)%360;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail(); }},
            { aria:"Crop",          title:"Crop photo",    svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();openCropModal(obj.photoId); }},
            { aria:"Frame shape",   title:"Frame shape",   svg:`<svg viewBox="0 0 22 22" width="13" height="13" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();showDmbFramePicker(e.currentTarget,obj.frameShape||"",(s)=>{ pushUndoState("Frame Shape");obj.frameShape=s;applyDmbFrameShape(img,s); }); }}
          ];
          const _bs = "border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";
          const fw = obj.w || 100;

          if (fw >= 130) {
            // Wide: single row top-right
            _btnSVGs.forEach((d, i) => {
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:4px;right:${4+i*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else if (fw >= 65) {
            // Medium: 2×2 grid top-right
            _btnSVGs.forEach((d, i) => {
              const r=Math.floor(i/2), c=i%2;
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:${4+r*26}px;right:${4+c*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else {
            // Narrow: single ⋯ toggle
            const mb = document.createElement("button"); mb.type="button"; mb.title="Options";
            mb.innerHTML="···";
            mb.style.cssText=`position:absolute;top:2px;right:2px;width:22px;height:22px;z-index:12;font-size:13px;line-height:1;${_bs}`;
            const pop = document.createElement("div");
            pop.style.cssText="position:absolute;top:26px;right:0;background:rgba(20,20,20,0.92);border-radius:8px;padding:4px;display:none;flex-direction:column;gap:2px;z-index:20;min-width:110px;";
            _btnSVGs.forEach(d => {
              const b = document.createElement("button"); b.type="button";
              b.innerHTML=`<span style="display:flex;align-items:center;gap:6px;">${d.svg}<span style="font-size:11px;font-weight:700;color:#fff;">${d.aria}</span></span>`;
              b.style.cssText="background:none;border:none;cursor:pointer;padding:4px 8px;border-radius:6px;width:100%;text-align:left;";
              b.addEventListener("click",(ev)=>{ pop.style.display="none"; d.fn(ev); });
              pop.appendChild(b);
            });
            mb.addEventListener("click",(e)=>{ e.preventDefault();e.stopPropagation(); const _open=pop.style.display==="none"; document.querySelectorAll(".dmb-frame-popup-open").forEach(p=>{p.style.display="none";p.classList.remove("dmb-frame-popup-open");}); if(_open){pop.style.display="flex";pop.classList.add("dmb-frame-popup-open");} });
            frame.appendChild(mb); frame.appendChild(pop);
          }
        }
      } else {
        const plus = document.createElement("div");
        plus.className = "dmb-photo-frame-plus";
        plus.innerHTML = '<span style="font-size:22px;display:block;">+</span><span style="font-size:11px;opacity:.7;">Drop photo here</span>';
        frame.appendChild(plus);
      }

      const handles = [
        ["tl", "0", "0"],
        ["tm", "50%", "0"],
        ["tr", "100%", "0"],
        ["ml", "0", "50%"],
        ["mr", "100%", "50%"],
        ["bl", "0", "100%"],
        ["bm", "50%", "100%"],
        ["br", "100%", "100%"]
      ];

      handles.forEach(([pos, left, top]) => {
        const h = document.createElement("div");
        h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
        h.dataset.handle = pos;
        h.style.left = left;
        h.style.top = top;
        frame.appendChild(h);
      });

      /* ── Frame rotation handle (Fix 4) ── */
      const _fRotHandle = document.createElement("div");
      _fRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
      _fRotHandle.innerHTML = "&#8635;";
      _fRotHandle.title = "Rotate frame";
      _fRotHandle.style.display = "none";
      document.body.appendChild(_fRotHandle);
      frame._dmbRotHandle = _fRotHandle;

      function _updateFrameRotPos() {
        if (!frame.isConnected) { _fRotHandle.remove(); return; }
        const _rr = frame.getBoundingClientRect();
        _fRotHandle.style.left = (_rr.right + 14) + "px";
        _fRotHandle.style.top = (_rr.bottom + 14) + "px";
      }
      requestAnimationFrame(_updateFrameRotPos);

      _fRotHandle.addEventListener("pointerdown", (e) => {
        e.preventDefault(); e.stopPropagation();
        const _startRot = obj.rotation || 0;
        const _rr2 = frame.getBoundingClientRect();
        const _cx = _rr2.left + _rr2.width / 2, _cy = _rr2.top + _rr2.height / 2;
        const _startAng = Math.atan2(e.clientY - _cy, e.clientX - _cx) * 180 / Math.PI;
        const _onMove = (ev) => {
          const _ang = Math.atan2(ev.clientY - _cy, ev.clientX - _cx) * 180 / Math.PI;
          obj.rotation = _dmbSnapAngle(_startRot + (_ang - _startAng));
          frame.style.transform = `rotate(${obj.rotation}deg)`;
          _updateFrameRotPos();
          showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
        };
        const _onUp = () => {
          hideRotDegTooltip();
          document.removeEventListener("pointermove", _onMove);
          document.removeEventListener("pointerup", _onUp);
          pushUndoState("Rotate Frame");
        };
        document.addEventListener("pointermove", _onMove);
        document.addEventListener("pointerup", _onUp);
      });

      frame.addEventListener("click", (e) => {
        e.stopPropagation();
        showFrameToolbarFor(frame, obj, {
          targetType,
          pageNumber,
          zone
        });
      });

      frame.addEventListener("dragover", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const payload = getDragPayload(e);
        e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
      });

      frame.addEventListener("drop", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const payload = getDragPayload(e);
        if (!payload || !payload.photoId) return;

        pushUndoState("Drop Photo In Frame");
        obj.photoId = payload.photoId;
        renderBuilderCanvas();
        renderPhotoTray();
        renderThumbsRail();
      });

      let dragMode = null;
      let sx = 0, sy = 0, ox = 0, oy = 0, ow = 0, oh = 0;

      frame.addEventListener("pointerdown", (e) => {
        if (e.target.closest(".dmb-frame-handle")) return;
        // Let action buttons (crop, remove, rotate, etc.) receive their click events
        // normally — pointerdown.preventDefault() would suppress click for the whole
        // pointer sequence, making inline buttons unresponsive.
        if (e.target.closest("button")) return;
        e.preventDefault();
        e.stopPropagation();

        showFrameToolbarFor(frame, obj, {
          targetType,
          pageNumber,
          zone
        });

        dragMode = "move";
        sx = e.clientX;
        sy = e.clientY;
        ox = obj.x;
        oy = obj.y;

        const onMove = (ev) => {
          if (dragMode !== "move") return;
          obj.x = ox + (ev.clientX - sx);
          obj.y = Math.max(0, oy + (ev.clientY - sy));
          frame.style.left = `${obj.x}px`;
          frame.style.top = `${obj.y}px`;
          showFrameToolbarFor(frame, obj, {
            targetType,
            pageNumber,
            zone
          });
        };

        const onUp = () => {
          dragMode = null;
          document.removeEventListener("pointermove", onMove);
          document.removeEventListener("pointerup", onUp);
        };

        document.addEventListener("pointermove", onMove);
        document.addEventListener("pointerup", onUp);
      });

      frame.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
        handle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();

          showFrameToolbarFor(frame, obj, {
            targetType,
            pageNumber,
            zone
          });

          dragMode = handle.dataset.handle;
          sx = e.clientX;
          sy = e.clientY;
          ox = obj.x;
          oy = obj.y;
          ow = obj.w;
          oh = obj.h;

          const onMove = (ev) => {
            const dx = ev.clientX - sx;
            const dy = ev.clientY - sy;

            if (dragMode.includes("r")) obj.w = Math.max(60, ow + dx);
            if (dragMode.includes("b")) obj.h = Math.max(60, oh + dy);

            if (dragMode.includes("l")) {
              const nextW = Math.max(60, ow - dx);
              const consumed = ow - nextW;
              obj.x = ox + consumed;
              obj.w = nextW;
            }

            if (dragMode.includes("t")) {
              const nextH = Math.max(60, oh - dy);
              const consumed = oh - nextH;
              obj.y = oy + consumed;
              obj.h = nextH;
            }

            frame.style.left = `${obj.x}px`;
            frame.style.top = `${obj.y}px`;
            frame.style.width = `${obj.w}px`;
            frame.style.height = `${obj.h}px`;
            showFrameToolbarFor(frame, obj, {
              targetType,
              pageNumber,
              zone
            });
          };

          const onUp = () => {
            dragMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
          };

          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });
      });

      container.appendChild(frame);
    });
  }
  function getActiveEditablePageIndex() {
    if (typeof builderMode !== "undefined" && builderMode === "cover") return null;

    const spread = Number(editor?.currentSpread || 0);
    const leftPage = spread * 2 + 1;
    const rightPage = leftPage + 1;

    if (leftPage >= 2 && leftPage <= editor.totalPages) return leftPage;
    if (rightPage >= 2 && rightPage <= editor.totalPages) return rightPage;

    return null;
  }

  document.addEventListener("DOMContentLoaded", () => {
    hookButtonsDirect();
    enforceUrlWinsOverStorage();
    enforceCustomizeClearsCover();
  });

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target && e.target.closest ? e.target.closest(".dmb-select-design-btn") : null;
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const href = btn.getAttribute("data-href") || btn.getAttribute("href");
      if (href) window.location.href = href;
    },
    true
  );
})();

/* =========================
   MAIN DMB APP
   ========================= */
(() => {
  // ---------- constants ----------
  const PRICES = {
    "24": { old: 40.99, new: 31.99 },
    "30": { old: 45, new: 33.99 },
    "40": { old: 55, new: 42.99 },
    "50": { old: 65, new: 51.99 }
  };

  // ── Extra spreads pricing ─────────────────────────────────────────────────
  // Each extra spread (2 pages) costs $1.99. The base variant price comes from
  // PRICES above; extra spread cost is added on top in updatePrice() and in
  // addDesignedBookToCart() (via DMB_EXTRA_SPREAD_VARIANT_ID cart line items).
  const EXTRA_SPREAD_PRICE = 0.99;

  const PHOTO_LIMITS = {
    "24": { min: 23, max: 32 },
    "30": { min: 29, max: 38 },
    "40": { min: 39, max: 48 },
    "50": { min: 49, max: 58 }
  };

  const SPECIAL_PAGE_TEXT = "Our special first page design";
  const LOCKED_PAGE_NUMBER = 1;
  const PORTRAIT_MAX_RATIO = 0.85;
  let spreadPhotoDragState = null; // { type:"pan"|"resize", si, startX, startY, startPanX, startPanY, startZoom }

  // ---------- page templates ----------
  const TEMPLATE_NAMES = {
    t1: "Triple Stack",
    t2: "Inset Full",
    t3: "Diagonal Duo",
    t4: "Tall Left Split Right",
    t5: "Center Panel Bands",
    t6: "2x2 Grid Top",
    t7: "3x3 Grid",
    t8: "Centered Duo",
    t9: "Triple Bands",
    t10: "Floating lower",
    t11: "Triple Stack Right",
    t12: "Floating Exact Center",
    t13: "Floating Upper",
    t14: "2x2 Upper",
    t15: "Banner Top + Full",
    t16: "Wide Top + 4 Mixed",
    t17: "Asymmetric 5",
    t18: "Full + Bottom 3",
    t19: "2 Column Full",
    t20: "Left 4 + Right Full",
    t21: "Left Full + Right 4",
    t22: "Top Wide + 2 Portrait",
    t23: "2x2 Full Bleed",
    t24: "Almost Full Page",
    t25: "Top 3 + Mixed Rows",
    t26: "Top 3 + Stack + Full",
    t27: "3 Center Bands",
    t28: "2 Portraits Centered",
    t29: "Right Column 3"
  };

  const TEMPLATE_DEFS = {
    t1: [
      { key: "S1", x: 28, y: 8,  w: 44, h: 24 },
      { key: "S2", x: 28, y: 35, w: 44, h: 24 },
      { key: "S3", x: 28, y: 62, w: 44, h: 24 }
    ],
    t2: [
      { key: "S1", x: 8, y: 8, w: 84, h: 84 }
    ],
    t3: [
      { key: "S1", x: 10, y: 12, w: 42, h: 28 },
      { key: "S2", x: 48, y: 60, w: 42, h: 28 }
    ],
    t4: [
      { key: "S1", x: 0,  y: 0,  w: 48, h: 100 },
      { key: "S2", x: 48, y: 0,  w: 52, h: 48 },
      { key: "S3", x: 48, y: 48, w: 52, h: 52 }
    ],
    t5: [
      { key: "S1", x: 20, y: 21, w: 60, h: 58 }
    ],
    t6: [
      { key: "S1", x: 14, y: 22, w: 32, h: 24 },
      { key: "S2", x: 54, y: 22, w: 32, h: 24 },
      { key: "S3", x: 14, y: 54, w: 32, h: 24 },
      { key: "S4", x: 54, y: 54, w: 32, h: 24 }
    ],
    t7: [
      { key: "S1", x: 2,  y: 8,  w: 31, h: 26 },
      { key: "S2", x: 34, y: 8,  w: 32, h: 26 },
      { key: "S3", x: 67, y: 8,  w: 31, h: 26 },
      { key: "S4", x: 2,  y: 36, w: 31, h: 26 },
      { key: "S5", x: 34, y: 36, w: 32, h: 26 },
      { key: "S6", x: 67, y: 36, w: 31, h: 26 },
      { key: "S7", x: 2,  y: 64, w: 31, h: 26 },
      { key: "S8", x: 34, y: 64, w: 32, h: 26 },
      { key: "S9", x: 67, y: 64, w: 31, h: 26 }
    ],
    t8: [
      { key: "S1", x: 24, y: 10, w: 52, h: 36 },
      { key: "S2", x: 24, y: 49, w: 52, h: 38 }
    ],
    t9: [
      { key: "S1", x: 0, y: 0,  w: 100, h: 31 },
      { key: "S2", x: 0, y: 31, w: 100, h: 31 },
      { key: "S3", x: 0, y: 62, w: 100, h: 38 }
    ],
    t10: [
      { key: "S1", x: 24, y: 46, w: 52, h: 28 }
    ],
    t11: [
      { key: "S1", x: 50, y: 8,  w: 44, h: 24 },
      { key: "S2", x: 50, y: 35, w: 44, h: 24 },
      { key: "S3", x: 50, y: 62, w: 44, h: 24 }
    ],
    t12: [
      { key: "S1", x: 24, y: 36, w: 52, h: 28 }
    ],
    t13: [
      { key: "S1", x: 24, y: 16, w: 52, h: 28 }
    ],
    // ── User-designed layouts (1–16) ──────────────────────────────────────
    // 1: 2×2 grid, upper portion – all frames same size, h-gap = v-gap = 10%
    t14: [
      { key: "S1", x:  9, y: 13, w: 36, h: 24 },
      { key: "S2", x: 55, y: 13, w: 36, h: 24 },
      { key: "S3", x:  9, y: 47, w: 36, h: 24 },
      { key: "S4", x: 55, y: 47, w: 36, h: 24 }
    ],
    // 2: 3 equal frames top row + 1 large frame filling rest of page
    t15: [
      { key: "S1", x:  0, y:  0, w: 31, h: 28 },
      { key: "S2", x: 32, y:  0, w: 32, h: 28 },
      { key: "S3", x: 65, y:  0, w: 35, h: 28 },
      { key: "S4", x:  0, y: 29, w:100, h: 71 }
    ],
    // 3: 1 wide centered top + 2 rows of 2 asymmetric frames (wide-narrow / narrow-wide)
    t16: [
      { key: "S1", x: 22, y:  7, w: 66, h: 29 },
      { key: "S2", x: 22, y: 37, w: 44, h: 22 },
      { key: "S3", x: 67, y: 37, w: 21, h: 22 },
      { key: "S4", x: 22, y: 60, w: 21, h: 21 },
      { key: "S5", x: 44, y: 60, w: 44, h: 21 }
    ],
    // 4: asymmetric 5-frame – left col 2 frames, right col 3 frames
    t17: [
      { key: "S1", x:  9, y:  7, w: 40, h: 39 },
      { key: "S2", x: 51, y:  7, w: 41, h: 17 },
      { key: "S3", x: 51, y: 25, w: 41, h: 17 },
      { key: "S4", x:  9, y: 47, w: 40, h: 27 },
      { key: "S5", x: 51, y: 43, w: 41, h: 31 }
    ],
    // 5: 1 large full-bleed top + 3 equal frames bottom row
    t18: [
      { key: "S1", x:  0, y:  0, w:100, h: 78 },
      { key: "S2", x:  0, y: 79, w: 32, h: 21 },
      { key: "S3", x: 33, y: 79, w: 32, h: 21 },
      { key: "S4", x: 67, y: 79, w: 33, h: 21 }
    ],
    // 6: 2 equal full-height columns, full bleed
    t19: [
      { key: "S1", x:  0, y:  0, w: 50, h:100 },
      { key: "S2", x: 51, y:  0, w: 49, h:100 }
    ],
    // 7: left col 4 stacked + right col 1 tall full-bleed
    t20: [
      { key: "S1", x:  0, y:  0, w: 32, h: 24 },
      { key: "S2", x:  0, y: 25, w: 32, h: 24 },
      { key: "S3", x:  0, y: 50, w: 32, h: 24 },
      { key: "S4", x:  0, y: 75, w: 32, h: 25 },
      { key: "S5", x: 34, y:  0, w: 66, h:100 }
    ],
    // 8: left col 1 tall full-bleed + right col 4 stacked
    t21: [
      { key: "S1", x:  0, y:  0, w: 67, h:100 },
      { key: "S2", x: 69, y:  0, w: 31, h: 24 },
      { key: "S3", x: 69, y: 25, w: 31, h: 24 },
      { key: "S4", x: 69, y: 50, w: 31, h: 24 },
      { key: "S5", x: 69, y: 75, w: 31, h: 25 }
    ],
    // 9: 1 wide landscape top (with margins) + 2 portrait frames below
    t22: [
      { key: "S1", x:  7, y:  6, w: 86, h: 43 },
      { key: "S2", x:  7, y: 51, w: 41, h: 43 },
      { key: "S3", x: 51, y: 51, w: 42, h: 43 }
    ],
    // 10: 2×2 full-bleed grid
    t23: [
      { key: "S1", x:  0, y:  0, w: 49, h: 49 },
      { key: "S2", x: 51, y:  0, w: 49, h: 49 },
      { key: "S3", x:  0, y: 51, w: 49, h: 49 },
      { key: "S4", x: 51, y: 51, w: 49, h: 49 }
    ],
    // 11: single large frame, equal margin top and bottom, small right margin
    t24: [
      { key: "S1", x:  0, y:  6, w: 91, h: 88 }
    ],
    // 12: top row 3 equal + large bottom-left + 3 stacked bottom-right
    t25: [
      { key: "S1", x:  0, y:  0, w: 32, h: 28 },
      { key: "S2", x: 33, y:  0, w: 32, h: 28 },
      { key: "S3", x: 66, y:  0, w: 34, h: 28 },
      { key: "S4", x:  0, y: 29, w: 65, h: 71 },
      { key: "S5", x: 66, y: 29, w: 34, h: 23 },
      { key: "S6", x: 66, y: 53, w: 34, h: 23 },
      { key: "S7", x: 66, y: 77, w: 34, h: 23 }
    ],
    // 13: top row 3 equal + 3 stacked bottom-left + large bottom-right
    t26: [
      { key: "S1", x:  0, y:  0, w: 32, h: 28 },
      { key: "S2", x: 33, y:  0, w: 32, h: 28 },
      { key: "S3", x: 66, y:  0, w: 34, h: 28 },
      { key: "S4", x:  0, y: 29, w: 32, h: 23 },
      { key: "S5", x:  0, y: 53, w: 32, h: 23 },
      { key: "S6", x:  0, y: 77, w: 32, h: 23 },
      { key: "S7", x: 33, y: 29, w: 67, h: 71 }
    ],
    // 14: 3 horizontal bands, centered with side margins
    t27: [
      { key: "S1", x: 18, y:  0, w: 64, h: 31 },
      { key: "S2", x: 18, y: 33, w: 64, h: 31 },
      { key: "S3", x: 18, y: 66, w: 64, h: 34 }
    ],
    // 15: 2 portrait frames side by side, centered horizontally and vertically
    t28: [
      { key: "S1", x:  4, y: 22, w: 44, h: 57 },
      { key: "S2", x: 52, y: 22, w: 44, h: 57 }
    ],
    // 16: right column only – 3 stacked frames
    t29: [
      { key: "S1", x: 51, y:  0, w: 49, h: 31 },
      { key: "S2", x: 51, y: 33, w: 49, h: 31 },
      { key: "S3", x: 51, y: 66, w: 49, h: 34 }
    ]
  };

  // ── Photo Frame Shapes ───────────────────────────────────────────────────
  var DMB_FRAME_SHAPES = [
    { id: "none",    label: "None" },
    { id: "circle",  label: "Circle" },
    { id: "rounded", label: "Rounded" },
    { id: "soft",    label: "Soft" },
    { id: "heart",   label: "Heart" },
    { id: "star",    label: "Star" },
    { id: "diamond", label: "Diamond" },
    { id: "hexagon", label: "Hexagon" },
  ];

  function ensureDmbClipPaths() {
    if (document.getElementById("dmb-clip-defs")) return;
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.id = "dmb-clip-defs";
    svg.setAttribute("width", "0"); svg.setAttribute("height", "0");
    svg.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;pointer-events:none;";
    svg.innerHTML = '<defs>' +
      '<clipPath id="dmb-clip-heart" clipPathUnits="objectBoundingBox"><path d="M0.5,0.85 C0.2,0.72 0,0.52 0,0.35 C0,0.14 0.16,0.04 0.3,0.04 C0.4,0.04 0.48,0.13 0.5,0.18 C0.52,0.13 0.6,0.04 0.7,0.04 C0.84,0.04 1,0.14 1,0.35 C1,0.52 0.8,0.72 0.5,0.85Z"/></clipPath>' +
      '<clipPath id="dmb-clip-star" clipPathUnits="objectBoundingBox"><polygon points="0.5,0.02 0.61,0.37 0.98,0.37 0.69,0.59 0.79,0.94 0.5,0.72 0.21,0.94 0.31,0.59 0.02,0.37 0.39,0.37"/></clipPath>' +
      '<clipPath id="dmb-clip-diamond" clipPathUnits="objectBoundingBox"><polygon points="0.5,0 1,0.5 0.5,1 0,0.5"/></clipPath>' +
      '<clipPath id="dmb-clip-hexagon" clipPathUnits="objectBoundingBox"><polygon points="0.25,0.02 0.75,0.02 1,0.5 0.75,0.98 0.25,0.98 0,0.5"/></clipPath>' +
      '</defs>';
    document.body.appendChild(svg);
  }

  function applyDmbFrameShape(el, shapeId) {
    el.style.borderRadius = "";
    el.style.clipPath = "";
    if (!shapeId || shapeId === "none") return;
    if (shapeId === "circle")       { el.style.borderRadius = "50%"; }
    else if (shapeId === "rounded") { el.style.borderRadius = "20%"; }
    else if (shapeId === "soft")    { el.style.borderRadius = "15px"; }
    else { ensureDmbClipPaths(); el.style.clipPath = "url(#dmb-clip-" + shapeId + ")"; }
  }

  function showDmbFramePicker(anchorEl, currentShape, onSelect) {
    var existing = document.getElementById("dmb-frame-shape-picker");
    if (existing) { existing.remove(); return; }
    ensureDmbClipPaths();
    var picker = document.createElement("div");
    picker.id = "dmb-frame-shape-picker";
    picker.style.cssText = "position:fixed;z-index:99999;background:#1e1e1e;border:1px solid #444;border-radius:12px;padding:10px;box-shadow:0 8px 32px rgba(0,0,0,0.7);display:grid;grid-template-columns:repeat(4,1fr);gap:8px;";
    DMB_FRAME_SHAPES.forEach(function(shape) {
      var btn = document.createElement("button");
      btn.type = "button"; btn.title = shape.label;
      var active = (shape.id === (currentShape || "none"));
      btn.style.cssText = "width:52px;height:60px;border:2px solid " + (active ? "#a9b4ff" : "#333") + ";border-radius:8px;background:#2a2a2a;cursor:pointer;padding:5px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;";
      var preview = document.createElement("div");
      preview.style.cssText = "width:32px;height:32px;background:linear-gradient(135deg,#c084fc,#818cf8);overflow:hidden;flex-shrink:0;";
      applyDmbFrameShape(preview, shape.id);
      var lbl = document.createElement("span");
      lbl.style.cssText = "font-size:8px;color:#aaa;font-weight:700;line-height:1;text-transform:uppercase;letter-spacing:0.3px;";
      lbl.textContent = shape.label;
      btn.appendChild(preview); btn.appendChild(lbl);
      btn.addEventListener("click", function(e) {
        e.stopPropagation();
        picker.remove();
        document.removeEventListener("pointerdown", outsideClose);
        onSelect(shape.id === "none" ? "" : shape.id);
      });
      picker.appendChild(btn);
    });
    var rect = anchorEl.getBoundingClientRect();
    var left = Math.min(rect.left - 80, window.innerWidth - 260);
    picker.style.left = Math.max(8, left) + "px";
    picker.style.top = (rect.bottom + 8) + "px";
    document.body.appendChild(picker);
    function outsideClose(e) {
      if (!picker.contains(e.target) && e.target !== anchorEl) {
        picker.remove();
        document.removeEventListener("pointerdown", outsideClose);
      }
    }
    setTimeout(function() { document.addEventListener("pointerdown", outsideClose); }, 60);
  }

  function applyCanvasFrameClip(ctx, shapeId, w, h) {
    if (!shapeId || shapeId === "none") return;
    ctx.beginPath();
    if (shapeId === "circle") {
      ctx.arc(w / 2, h / 2, Math.min(w, h) / 2, 0, Math.PI * 2);
    } else if (shapeId === "rounded") {
      var r = Math.min(w, h) * 0.2;
      ctx.moveTo(r,0); ctx.lineTo(w-r,0); ctx.quadraticCurveTo(w,0,w,r);
      ctx.lineTo(w,h-r); ctx.quadraticCurveTo(w,h,w-r,h);
      ctx.lineTo(r,h); ctx.quadraticCurveTo(0,h,0,h-r);
      ctx.lineTo(0,r); ctx.quadraticCurveTo(0,0,r,0); ctx.closePath();
    } else if (shapeId === "soft") {
      var sr = Math.min(w, h) * 0.12;
      ctx.moveTo(sr,0); ctx.lineTo(w-sr,0); ctx.quadraticCurveTo(w,0,w,sr);
      ctx.lineTo(w,h-sr); ctx.quadraticCurveTo(w,h,w-sr,h);
      ctx.lineTo(sr,h); ctx.quadraticCurveTo(0,h,0,h-sr);
      ctx.lineTo(0,sr); ctx.quadraticCurveTo(0,0,sr,0); ctx.closePath();
    } else if (shapeId === "heart") {
      ctx.moveTo(w*0.5,h*0.85);
      ctx.bezierCurveTo(w*0.2,h*0.72, 0,h*0.52, 0,h*0.35);
      ctx.bezierCurveTo(0,h*0.14, w*0.16,h*0.04, w*0.3,h*0.04);
      ctx.bezierCurveTo(w*0.4,h*0.04, w*0.48,h*0.13, w*0.5,h*0.18);
      ctx.bezierCurveTo(w*0.52,h*0.13, w*0.6,h*0.04, w*0.7,h*0.04);
      ctx.bezierCurveTo(w*0.84,h*0.04, w,h*0.14, w,h*0.35);
      ctx.bezierCurveTo(w,h*0.52, w*0.8,h*0.72, w*0.5,h*0.85); ctx.closePath();
    } else if (shapeId === "star") {
      var sp = [[0.5,0.02],[0.61,0.37],[0.98,0.37],[0.69,0.59],[0.79,0.94],[0.5,0.72],[0.21,0.94],[0.31,0.59],[0.02,0.37],[0.39,0.37]];
      sp.forEach(function(p,i){ i===0?ctx.moveTo(p[0]*w,p[1]*h):ctx.lineTo(p[0]*w,p[1]*h); }); ctx.closePath();
    } else if (shapeId === "diamond") {
      ctx.moveTo(w*0.5,0); ctx.lineTo(w,h*0.5); ctx.lineTo(w*0.5,h); ctx.lineTo(0,h*0.5); ctx.closePath();
    } else if (shapeId === "hexagon") {
      var hp = [[0.25,0.02],[0.75,0.02],[1,0.5],[0.75,0.98],[0.25,0.98],[0,0.5]];
      hp.forEach(function(p,i){ i===0?ctx.moveTo(p[0]*w,p[1]*h):ctx.lineTo(p[0]*w,p[1]*h); }); ctx.closePath();
    }
    ctx.clip();
  }

  function getSlotFrameShape(pageNumber, slot) {
    return (editor.pageFrameShapes && editor.pageFrameShapes[pageNumber] && editor.pageFrameShapes[pageNumber][slot]) || "";
  }
  function setSlotFrameShape(pageNumber, slot, shapeId) {
    if (!editor.pageFrameShapes) editor.pageFrameShapes = {};
    if (!editor.pageFrameShapes[pageNumber]) editor.pageFrameShapes[pageNumber] = {};
    editor.pageFrameShapes[pageNumber][slot] = shapeId || "";
  }

  // ---------- helpers ----------
  // Local renderBuilderCanvas — delegates to the actual render functions in this IIFE
  function renderBuilderCanvas() {
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => el.remove());
    if (builderMode === "cover") renderCoverCanvas();
    else renderSpread();
    if (typeof syncBuilderModeButtons === "function") syncBuilderModeButtons();
    if (typeof setCanvasZoom === "function") setCanvasZoom(currentZoom);
    // Pulse the preview button to remind customer to review after each edit
    const _pb = document.getElementById("previewBtn");
    if (_pb) _pb.classList.add("dmb-preview-needs-check");
    // Show photo quality notice the very first time a photo lands on any page
    _maybeShowPhotoQualityToast();
  }

  // ── Fix 3: 45° magnetic snap rotation helper ─────────────────────────────
  // Returns the raw angle snapped to the nearest 45° multiple when within
  // SNAP_DEG degrees of it, otherwise returns the raw angle unchanged.
  // Works for all rotation handlers: text, maps, stickers, shapes, icons.
  // "Breakaway" is natural: the angle is only snapped while the raw value stays
  // inside the snap zone; rotate past 5° away and it instantly releases.
  const _ROT_SNAP_DEG = 5;
  function _dmbSnapAngle(rawDeg) {
    // Normalise to 0–360 to find the nearest 45° multiple
    const norm    = ((rawDeg % 360) + 360) % 360;
    const nearest = Math.round(norm / 45) * 45; // 0, 45, 90 … 360
    const diff    = norm - nearest;
    return Math.abs(diff) <= _ROT_SNAP_DEG ? rawDeg - diff : rawDeg;
  }

  // ── First-photo quality toast ─────────────────────────────────────────────
  // Shows once per session the moment the customer places their first photo.
  // Disappears automatically after 4 s with a fade-out.
  // Uses sessionStorage so it never re-appears during the same browser session.
  let _photoQualityToastShown = false;
  function _maybeShowPhotoQualityToast() {
    if (_photoQualityToastShown) return;
    if (sessionStorage.getItem("dmb_photo_quality_toast_shown")) { _photoQualityToastShown = true; return; }
    // Check if at least one page slot has a photo
    const slots = editor.pageSlots || {};
    const hasPhoto = Object.values(slots).some(function(s) { return s && (s.A || s.B); });
    if (!hasPhoto) return;
    _photoQualityToastShown = true;
    sessionStorage.setItem("dmb_photo_quality_toast_shown", "1");
    const toast = document.getElementById("dmbPhotoQualityToast");
    if (!toast) return;
    // Animate in
    toast.style.display = "flex";
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { toast.classList.add("dmb-toast-visible"); });
    });
    // Animate out after 4 s
    setTimeout(function() {
      toast.classList.remove("dmb-toast-visible");
      setTimeout(function() { toast.style.display = "none"; }, 500);
    }, 4000);
  }

  let DMB_CURRENT_DRAG = null;
  const $ = (id) => document.getElementById(id);
  const fmtMoney = (n) => "$" + Number(n).toFixed(2);
  const isLockedPage = (p) => !window.DMB_MAGAZINE_MODE && p === LOCKED_PAGE_NUMBER;

  function getActivePageNumberForMap() {
    if (!editor.totalPages) return null;

    if (builderMode === "cover") return "cover";

    if (editor.currentSpread === -1) return 0;

    const leftPage = editor.currentSpread * 2 + 1;
    const rightPage = leftPage + 1;

    if (leftPage === 1) {
      return rightPage <= editor.totalPages ? rightPage : null;
    }

    return leftPage <= editor.totalPages ? leftPage : null;
  }

  function uid() {
    return "p_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function syncInputFiles(inputEl, filesArr) {
    if (!inputEl) return;
    const dt = new DataTransfer();
    filesArr.forEach((f) => dt.items.add(f));
    inputEl.files = dt.files;
  }

  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(String(r.result || "").split(",")[1] || "");
      r.onerror = reject;
      r.readAsDataURL(blob);
    });
  }

  // ── Mobile image compression ──────────────────────────────────────────────
  // Resizes oversized photos before they enter the builder, preventing iOS/Safari
  // from crashing due to canvas memory limits when processing large camera images.
  // 2500 px max keeps full print quality (300 Dpi on an 8" side) while cutting
  // a 48 MP iPhone photo from ~15 MB down to ~1–2 MB.
  async function compressImageIfNeeded(file) {
    const MAX_DIM = 2500;
    const QUALITY  = 0.88;
    return new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        if (img.naturalWidth <= MAX_DIM && img.naturalHeight <= MAX_DIM) {
          resolve(file);
          return;
        }
        const scale  = MAX_DIM / Math.max(img.naturalWidth, img.naturalHeight);
        const w = Math.round(img.naturalWidth  * scale);
        const h = Math.round(img.naturalHeight * scale);
        const canvas = document.createElement("canvas");
        canvas.width = w; canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            // Free canvas memory immediately after export
            canvas.width = 0; canvas.height = 0;
            resolve(new File([blob], file.name, { type: "image/jpeg", lastModified: file.lastModified }));
          },
          "image/jpeg", QUALITY
        );
      };
      img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  }

  async function compressFilesForMobile(files) {
    if (window.innerWidth > 749) return files;   // desktop — use originals
    // Process ONE AT A TIME — parallel (Promise.all) loads all originals into
    // memory simultaneously, which is what causes the iOS crash.
    const result = [];
    for (const f of files) {
      result.push(await compressImageIfNeeded(f));
    }
    return result;
  }

  // ── Apps Script URL + HTTP helper — module-level so both uploadPdfToGoogleDrive
  // and addDesignedBookToCart can call postToScript (e.g. for trash_file).
  const DMB_APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwzcCe9WkOMqPiSc58NJOMEPbDfLOH3q_C_4leRgoaK5Xg5BSLh2dpjvCRbzZF8/exec";

  async function postToScript(payload, attempts = 3) {
    let lastErr;
    for (let i = 1; i <= attempts; i++) {
      try {
        const res = await fetch(DMB_APPS_SCRIPT_URL, {
          method: "POST",
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || "Script error");
        return data;
      } catch (err) {
        lastErr = err;
        if (i < attempts) await new Promise(r => setTimeout(r, i * 1500));
      }
    }
    throw lastErr;
  }

  async function uploadPdfToGoogleDrive(pdfBlob) {
    const filename = `memories_nutshell_${DMB_SESSION_ID}-${++dmbBookCounter}.pdf`;

    // ── Architecture: Drive Resumable Upload ─────────────────────────────────
    // We use Google Drive's native resumable-upload API (via Apps Script as proxy).
    // Each chunk is forwarded directly from browser → Apps Script → Drive byte-range.
    // This eliminates ALL of the old failure modes:
    //   ✓ No temp files in Drive (no "Missing chunk N" race condition)
    //   ✓ No in-memory base64 concatenation (no OOM for large books)
    //   ✓ No 6-minute Apps Script timeout during finalize
    //   ✓ Works for any size PDF (1 GB+)
    //   ✓ If a chunk fails, Drive reports exactly where to resume
    //
    // CHUNK_BYTES must be a multiple of 256 KB as required by Drive's resumable API.
    const CHUNK_BYTES = 3 * 256 * 1024;  // 768 KB — valid multiple of 256 KB
    const totalSize   = pdfBlob.size;
    const totalChunks = Math.ceil(totalSize / CHUNK_BYTES);

    // ── Progress helpers ──────────────────────────────────────────────────────
    const _progWrap  = document.getElementById("dmbUploadProgressWrap");
    const _progBar   = document.getElementById("dmbUploadProgressBar");
    const _progLabel = document.getElementById("dmbUploadProgressLabel");
    const _progMsg   = document.getElementById("dmbPdfOverlayMsg");
    const _uploadMsgs = [
      "Sending your memories our way… 📬",
      "Packaging your precious moments… 🎁",
      "Almost there, hang tight… ✨",
      "Wrapping up your story… 📖",
      "Delivering your book with care… 💌",
      "Just a little more… 🌟",
      "Your memories are on their way… 🚀",
      "Sealing every beautiful moment… 🌸"
    ];
    function _setProgress(done, total, phase) {
      const pct = Math.round((done / total) * 100);
      if (_progWrap)  _progWrap.style.display  = "block";
      if (_progBar)   _progBar.style.width      = pct + "%";
      if (_progLabel) _progLabel.textContent    = phase || _uploadMsgs[Math.floor((done / total) * (_uploadMsgs.length - 1))];
      if (_progMsg)   _progMsg.textContent      = "Sending your book… 💛";
    }
    function _hideProgress() {
      if (_progWrap) _progWrap.style.display = "none";
    }

    // ── Step 1: Initialise the Drive resumable-upload session ─────────────────
    _setProgress(0, totalChunks + 1, "Preparing your book… ✨");
    const initRes    = await postToScript({ action: "init_upload", filename, totalSize });
    const sessionUri = initRes.sessionUri;

    // ── Step 2: Send chunks — each forwarded directly to Drive ───────────────
    let byteStart = 0;
    for (let i = 0; i < totalChunks; i++) {
      _setProgress(i + 1, totalChunks + 1, _uploadMsgs[i % _uploadMsgs.length]);
      const slice    = pdfBlob.slice(byteStart, byteStart + CHUNK_BYTES);
      const b64chunk = await blobToBase64(slice);
      const raw      = b64chunk.includes(",") ? b64chunk.split(",")[1] : b64chunk;

      const chunkRes = await postToScript({
        action:     "upload_chunk",
        sessionUri,           // Apps Script forwards this chunk to Drive directly
        data:       raw,
        byteStart,
        totalSize
      });

      byteStart += slice.size;

      if (chunkRes.complete) {
        // Drive confirmed the upload is fully complete on this chunk.
        _setProgress(totalChunks + 1, totalChunks + 1, "Your book is safe with us! 🎉");
        if (_progMsg) _progMsg.textContent = "Almost ready… 💛";
        _hideProgress();
        return chunkRes;  // { ok, id, viewUrl, downloadUrl }
      }
    }

    // If we exit the loop without seeing complete:true, something went wrong.
    _hideProgress();
    throw new Error("Upload finished all chunks but Drive did not confirm completion.");
  }

  function mergeFilesKeepOld(existingArr, newlyPickedArr) {
    const out = Array.isArray(existingArr) ? existingArr.slice() : [];
    const newArr = Array.isArray(newlyPickedArr) ? newlyPickedArr : [];

    const key = (f) => `${f.name}__${f.size}__${f.lastModified}`;
    const seen = new Set(out.map(key));

    newArr.forEach((f) => {
      const k = key(f);
      if (!seen.has(k)) {
        out.push(f);
        seen.add(k);
      }
    });

    return out;
  }

  function showReuseNotice() {
    let n = document.getElementById("dmbReuseNotice");

    if (!n) {
      n = document.createElement("div");
      n.id = "dmbReuseNotice";
      n.style.position = "fixed";
      n.style.left = "50%";
      n.style.bottom = "20px";
      n.style.transform = "translateX(-50%)";
      n.style.zIndex = "99999";
      n.style.background = "rgba(17,17,17,0.92)";
      n.style.color = "#fff";
      n.style.padding = "10px 14px";
      n.style.borderRadius = "999px";
      n.style.fontSize = "12px";
      n.style.fontWeight = "800";
      n.style.boxShadow = "0 8px 24px rgba(0,0,0,0.2)";
      document.body.appendChild(n);
    }

    n.textContent = "You have used this photo before (reused).";
    n.style.display = "block";
    n.style.opacity = "1";

    clearTimeout(showReuseNotice._t);
    showReuseNotice._t = setTimeout(() => {
      if (n) n.style.opacity = "0";
      setTimeout(() => { if (n) n.style.display = "none"; }, 180);
    }, 1400);
  }

  function enforceMax(filesArr, maxAllowed) {
    if (!maxAllowed) return;
    if (filesArr.length > maxAllowed) filesArr.length = maxAllowed;
  }

  function setDragPayload(e, payload) {
    DMB_CURRENT_DRAG = payload;
    const json = JSON.stringify(payload);
    e.dataTransfer.setData("application/x-dmb", json);
    e.dataTransfer.setData("text/x-dmb", json);
    e.dataTransfer.setData("text/plain", json);
    e.dataTransfer.effectAllowed = "copyMove";
  }

  function getDragPayload(e) {
    const dt = e.dataTransfer;
    if (!dt) return DMB_CURRENT_DRAG;

    let raw =
      dt.getData("application/x-dmb") ||
      dt.getData("text/x-dmb") ||
      dt.getData("text/plain") ||
      "";

    raw = (raw || "").trim();
    if (!raw) return DMB_CURRENT_DRAG;

    if (raw[0] !== "{") return { type: "photo", photoId: raw };

    try {
      return JSON.parse(raw);
    } catch {
      return DMB_CURRENT_DRAG;
    }
  }


  function syncCoverInputsFromState() {
    if (coverColorInput) coverColorInput.value = coverState.color || "#ffffff";
    if (coverColorSwatch) coverColorSwatch.style.background = coverState.color || "#ffffff";
    updateCoverPreview();
    if (typeof renderCoverTextList === "function") renderCoverTextList();
  }

  function renderCoverTextList() {
    const list = document.getElementById("dmbCoverTextList");
    if (!list) return;
    list.innerHTML = "";
    if (!Array.isArray(editor.coverUserTexts) || !editor.coverUserTexts.length) {
      const empty = document.createElement("div");
      empty.className = "dmb-cover-text-empty";
      empty.textContent = 'No text added yet. Click "Add text" on the cover.';
      list.appendChild(empty);
      return;
    }
    editor.coverUserTexts.forEach(({ id, zone }) => {
      const saved = coverState.textStyles?.[id];
      const row = document.createElement("div");
      row.className = "dmb-cover-text-row";

      const inp = document.createElement("input");
      inp.type = "text";
      inp.className = "dmb-input";
      inp.value = saved?.text || "";
      inp.placeholder = "Enter text…";
      inp.setAttribute("data-text-id", id);
      inp.addEventListener("input", () => {
        if (!coverState.textStyles) coverState.textStyles = {};
        if (!coverState.textStyles[id]) coverState.textStyles[id] = {};
        coverState.textStyles[id].text = inp.value;
        const liveNode = document.getElementById(id);
        if (liveNode) { liveNode.textContent = inp.value; }
      });

      const zoneLabel = document.createElement("span");
      zoneLabel.className = "dmb-cover-text-zone";
      zoneLabel.textContent = zone;

      const delBtn = document.createElement("button");
      delBtn.type = "button";
      delBtn.className = "dmb-cover-text-del";
      delBtn.title = "Remove text";
      delBtn.innerHTML = "&#x2715;";
      delBtn.addEventListener("click", () => {
        pushUndoState("Delete Cover Text");
        editor.coverUserTexts = editor.coverUserTexts.filter((t) => t.id !== id);
        if (coverState.textStyles) delete coverState.textStyles[id];
        const liveNode = document.getElementById(id);
        if (liveNode) liveNode.remove();
        renderCoverTextList();
        saveCoverDesignToStorage();
      });

      row.appendChild(inp);
      row.appendChild(zoneLabel);
      row.appendChild(delBtn);
      list.appendChild(row);
    });
  }

  function initEmptyBookFromPages() {
    const selectedPages = Number(pagesEl?.value || 0);
    if (!selectedPages) return;

    // Reset extra spreads whenever base page count changes
    editor.extraSpreads = 0;
    editor.totalPages = selectedPages;
    editor.editablePages = Math.max(0, selectedPages - 1);
    editor.totalSpreads = Math.max(1, Math.ceil(selectedPages / 2));
    editor.currentSpread = 0;

    editor.pageSlots = {};
    editor.pageRot = {};
    editor.pageTemplate = {};
    editor.pageFrames = {};
    editor.pageFrameRot = {};
    editor.pageFrameShapes = {};
    editor.pageObjects = {};
    editor.pageBackgrounds = {};
    editor.coverObjects = [];
    for (let p = 1; p <= selectedPages; p++) {
      editor.pageSlots[p] = { A: null, B: null };
      editor.pageRot[p] = { A: 0, B: 0 };
      editor.pageTemplate[p] = null;
      editor.pageFrames[p] = {};
      editor.pageFrameRot[p] = {};
      editor.pageObjects[p] = [];
    }

    if (bookMeta) {
      bookMeta.textContent = `${selectedPages} pages (${editor.editablePages} to design) • ${editor.photos.length} photos`;
    }

    // Show the "Add spread" button now that a page count is chosen
    _syncSpreadAdderUI();

    renderThumbsRail();

    if (builderMode === "cover") {
      renderCoverCanvas();
    } else {
      renderSpread();
    }
  }

  // ── Extra spreads: add / remove 2 pages at +$1.99 each ───────────────────
  // Callers: "+" and "−" buttons in the spread adder row.
  // WARNING: always call updatePrice() + refreshPhotoRule() after changing
  //          editor.extraSpreads so the displayed price + photo rule stay in sync.

  function addExtraSpread() {
    if (!pagesEl?.value) { alert("Please select a page count first."); return; }
    const newL = editor.totalPages + 1;
    const newR = editor.totalPages + 2;
    // Initialise the two new pages exactly like initEmptyBookFromPages does
    [newL, newR].forEach(p => {
      editor.pageSlots[p]     = { A: null, B: null };
      editor.pageRot[p]       = { A: 0, B: 0 };
      editor.pageTemplate[p]  = null;
      editor.pageFrames[p]    = {};
      editor.pageFrameRot[p]  = {};
      editor.pageObjects[p]   = [];
    });
    editor.totalPages    += 2;
    editor.editablePages += 2;
    editor.totalSpreads  += 1;
    editor.extraSpreads  += 1;
    pushUndoState("Add Extra Spread");
    updatePrice();
    refreshPhotoRule();
    _syncSpreadAdderUI();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  function removeExtraSpread() {
    if ((editor.extraSpreads || 0) <= 0) return;
    const remL = editor.totalPages - 1;
    const remR = editor.totalPages;
    // Navigate away from the spread being removed
    const maxAllowedSpread = Math.max(0, editor.totalSpreads - 2);
    if (editor.currentSpread >= maxAllowedSpread) {
      editor.currentSpread = Math.max(0, maxAllowedSpread - 1);
    }
    // Clean up removed pages
    [remL, remR].forEach(p => {
      delete editor.pageSlots[p];
      delete editor.pageRot[p];
      delete editor.pageTemplate[p];
      delete editor.pageFrames[p];
      delete editor.pageFrameRot[p];
      delete editor.pageObjects[p];
    });
    editor.totalPages    -= 2;
    editor.editablePages -= 2;
    editor.totalSpreads  -= 1;
    editor.extraSpreads  -= 1;
    pushUndoState("Remove Extra Spread");
    updatePrice();
    refreshPhotoRule();
    _syncSpreadAdderUI();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  // Sync the spread adder row: update counter, cost label, and button states.
  // The row is always visible inside the builder — no show/hide needed here.
  function _syncSpreadAdderUI() {
    const countEl   = $("dmbSpreadCountEl");
    const costEl    = $("dmbSpreadCostEl");
    const removeBtn = $("dmbRemoveSpreadBtn");
    const n = editor.extraSpreads || 0;
    if (countEl) countEl.textContent = n;
    if (costEl) {
      if (n > 0) {
        costEl.textContent = "+" + fmtMoney(n * EXTRA_SPREAD_PRICE);
        costEl.style.display = "inline";
      } else {
        costEl.style.display = "none";
      }
    }
    if (removeBtn) removeBtn.disabled = n <= 0;
  }


  function initUnifiedTabs() {
    const tabs = Array.from(document.querySelectorAll(".dmb-icon-tab"));
    const panels = Array.from(document.querySelectorAll(".dmb-side-panel"));
    const title = document.getElementById("dmbLeftTitle");

    const labels = {
      images: "Pictures",
      cover: "Cover",
      layouts: "Layouts",
      backgrounds: "Backgrounds",
      stickers: "Stickers",
      text: "Text"
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const key = tab.getAttribute("data-tab");

        // When clicking Layouts while in cover mode, open the cover layout picker directly
        if (key === "layouts" && builderMode === "cover") {
          const zone = activeCoverZone === "back" ? "back" : "front";
          showLayoutsForCoverZone(zone);
          return;
        }

        tabs.forEach((t) => t.classList.remove("active"));
        panels.forEach((p) => p.classList.remove("active"));
        tab.classList.add("active");
        const panel = document.querySelector(`.dmb-side-panel[data-panel="${key}"]`);
        if (panel) panel.classList.add("active");
        if (title) title.textContent = labels[key] || "Panel";
        if (key === "cover") {
          builderMode = "cover";
          if (typeof syncBuilderModeButtons === "function") syncBuilderModeButtons();
          if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        }
      });
    });
  }

  function applyPhotoFilters(list) {
    let arr = Array.isArray(list) ? list.slice() : [];

    if (currentPhotoSearch.trim()) {
      const q = currentPhotoSearch.trim().toLowerCase();
      arr = arr.filter((p) => {
        const filename = String(p.filename || p.file?.name || "").toLowerCase();
        const dateTaken = String(p.dateTaken || "").toLowerCase();
        const tags = Array.isArray(p.tags) ? p.tags.join(" ").toLowerCase() : "";
        return filename.includes(q) || dateTaken.includes(q) || tags.includes(q);
      });
    }

    if (hideUsedPhotos) {
      const used = getUsedPhotoIds();
      arr = arr.filter((p) => !used.has(p.id));
    }

    if (currentPhotoSort === "latest") {
      arr.sort((a, b) => (b.addedIndex || 0) - (a.addedIndex || 0));
    } else if (currentPhotoSort === "date") {
      arr.sort((a, b) => String(a.dateTaken || "").localeCompare(String(b.dateTaken || "")));
    } else if (currentPhotoSort === "filename") {
      arr.sort((a, b) => String(a.filename || "").localeCompare(String(b.filename || "")));
    } else if (currentPhotoSort === "portrait") {
      arr.sort((a, b) => (a.ratio || 1) - (b.ratio || 1));
    } else if (currentPhotoSort === "landscape") {
      arr.sort((a, b) => (b.ratio || 1) - (a.ratio || 1));
    } else {
      arr.sort((a, b) => (a.addedIndex || 0) - (b.addedIndex || 0));
    }

    return arr;
  }


  function setCanvasZoom(scale) {
    currentZoom = Math.max(0.25, Math.min(2, scale));

    if (spreadCanvas) {
      spreadCanvas.style.transform = `scale(${currentZoom})`;
      spreadCanvas.style.transformOrigin = "top left";
    }

    const zoomLabel =
      document.getElementById("zoomValue") ||
      document.getElementById("zoomLabel");

    if (zoomLabel) {
      zoomLabel.textContent = `${Math.round(currentZoom * 100)}%`;
    }

    const zoomRange = document.getElementById("zoomRange");
    if (zoomRange) {
      zoomRange.value = String(Math.round(currentZoom * 100));
    }
  }

  function openPagesMode() {
    builderMode = "pages";
    syncBuilderModeButtons();
    renderBuilderCanvas();
  }

  function saveProjectLocal() {
    saveProjectLocalWithMessage();
  }

  function loadProjectLocal() {
    try {
      const raw = localStorage.getItem("dmb_saved_project_v1");
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function initProjectMenu() {
    const btn = $("projectMenuBtn");
    if (!btn) return;
    btn.onclick = openProjectMenuPrompt;
  }

  function initHistoryButton() {
    const btn = $("historyBtn");
    if (!btn) return;
    btn.onclick = openHistoryPanel;
  }

  function initPhotoImportMenu() {
    // handled by the single delegated click + change listeners at the bottom
  }
  
  function initPhotoSearchSortControls() {
    const sort = $("photoSortSelect");
    const hide = $("hideUsedPhotosToggle");

    if (sort) {
      sort.addEventListener("change", () => {
        currentPhotoSort = sort.value || "earliest";
        renderPhotoTray();
      });
    }

    if (hide) {
      hide.addEventListener("change", () => {
        hideUsedPhotos = !!hide.checked;
        renderPhotoTray();
      });
    }
  }

  function refreshBuilderPhotos() {
    Promise.all(bookFiles.map(getImageMetaFromFile)).then((metas) => {
      editor.photos = bookFiles.map((f, i) => ({
        id: editor.photos[i]?.id || uid(),
        file: f,
        url: editor.photos[i]?.url || URL.createObjectURL(f),
        ratio: metas[i]?.ratio ?? 1,
        filename: String(f.name || "").toLowerCase(),
        dateTaken: metas[i]?.date || "",
        tags: editor.photos[i]?.tags || [],
        addedIndex: i
      }));

      renderPhotoTray();

      if (editor.totalPages > 0 && editor.totalSpreads > 0) {
        renderThumbsRail();
        renderBuilderCanvas();
      }
    });
  }

  function smartCreateBook() {
    if (!editor.totalPages || !editor.photos.length) return;

    pushUndoState("Smart Creation");

    const startPage = 2;
    const totalEditable = Math.max(0, editor.totalPages - 1);
    const totalPhotos = editor.photos.length;

    for (let p = startPage; p <= editor.totalPages; p++) {
      editor.pageSlots[p].A = null;
      editor.pageSlots[p].B = null;
      editor.pageRot[p].A = 0;
      editor.pageRot[p].B = 0;
      editor.pageTemplate[p] = null;
      editor.pageFrames[p] = {};
      editor.pageFrameRot[p] = {};
    }

    const ordered = applyPhotoFilters(editor.photos).slice();

    const portraits = ordered.filter((p) => p.ratio <= PORTRAIT_MAX_RATIO).map((p) => p.id);
    const landscapes = ordered.filter((p) => p.ratio > PORTRAIT_MAX_RATIO).map((p) => p.id);

    const twoCount = Math.min(totalEditable, Math.max(0, totalPhotos - totalEditable));
    const editablePages = [];
    for (let p = startPage; p <= editor.totalPages; p++) editablePages.push(p);

    const twoPageSet = chooseDistributedPages(editablePages, twoCount);
    const remaining = ordered.map((p) => p.id);
    const usedInFill = new Set();

    function pickPreferred(preferList) {
      while (preferList.length) {
        const id = preferList.shift();
        if (!usedInFill.has(id)) {
          usedInFill.add(id);
          return id;
        }
      }
      while (remaining.length) {
        const id = remaining.shift();
        if (!usedInFill.has(id)) {
          usedInFill.add(id);
          return id;
        }
      }
      return null;
    }

    for (const pageNum of editablePages) {
      if (twoPageSet.has(pageNum)) {
        const a = pickPreferred(landscapes);
        const b = pickPreferred(landscapes);
        editor.pageSlots[pageNum].A = a;
        editor.pageSlots[pageNum].B = b;
      } else {
        const a = pickPreferred(portraits);
        editor.pageSlots[pageNum].A = a;
        editor.pageSlots[pageNum].B = null;
      }
    }

    builderMode = "pages";
    renderPhotoTray();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  function getCurrentBuilderStateSnapshot() {
    return {
      book_title: getEffectiveBookTitle(),
      pages_selected: Number(pagesEl?.value || 0),
      coverState: cloneState(coverState),
      editor: cloneState(editor),
      builderMode,
      currentPhotoSort,
      currentPhotoSearch,
      hideUsedPhotos
    };
  }

  function applyBuilderStateSnapshot(snapshot) {
    if (!snapshot) return;

    if (pagesEl && snapshot.pages_selected) {
      pagesEl.value = String(snapshot.pages_selected);
      updatePrice();
      refreshPhotoRule();
    }

    if (snapshot.coverState) {
      const cs = snapshot.coverState;
      coverState.template      = cs.template      || "default";
      coverState.title1        = cs.title1        || "";
      coverState.title2        = cs.title2        || "";
      coverState.color         = cs.color         || "#ffffff";
      coverState.imageUrl      = cs.imageUrl      || "";
      coverState.imageFile     = cs.imageFile     || null;
      coverState.frontLayout   = cs.frontLayout   || null;
      coverState.backLayout    = cs.backLayout    || null;
      coverState.frontFrames   = cloneState(cs.frontFrames   || {});
      coverState.backFrames    = cloneState(cs.backFrames    || {});
      coverState.frontFrameRot = cloneState(cs.frontFrameRot || {});
      coverState.backFrameRot  = cloneState(cs.backFrameRot  || {});
      coverState.frontFrameShapes = cloneState(cs.frontFrameShapes || {});
      coverState.backFrameShapes  = cloneState(cs.backFrameShapes  || {});
      coverState.bleedImageUrl = cs.bleedImageUrl || "";
      coverState.bleedImageId  = cs.bleedImageId  || "";
      coverState.bleedZone     = cs.bleedZone     || "";
      coverState.bleedImageRot = cs.bleedImageRot || 0;
      coverState.spineImageUrl = cs.spineImageUrl || "";
      if (cs.textStyles) coverState.textStyles = cloneState(cs.textStyles);
      syncCoverInputsFromState();
    }

    if (snapshot.editor) {
      const se = snapshot.editor;
      editor.totalPages    = se.totalPages    || 0;
      editor.editablePages = se.editablePages || 0;
      editor.totalSpreads  = se.totalSpreads  || Math.ceil((se.totalPages || 0) / 2);
      editor.currentSpread = se.currentSpread || 0;
      editor.pageSlots     = cloneState(se.pageSlots     || {});
      editor.pageRot       = cloneState(se.pageRot       || {});
      editor.pageTemplate  = cloneState(se.pageTemplate  || {});
      editor.pageFrames    = cloneState(se.pageFrames    || {});
      editor.pageFrameRot  = cloneState(se.pageFrameRot  || {});
      editor.pageFrameShapes = cloneState(se.pageFrameShapes || {});
      editor.pageObjects      = cloneState(se.pageObjects      || {});
      editor.pageBackgrounds  = cloneState(se.pageBackgrounds  || {});
      editor.spreadPhoto      = cloneState(se.spreadPhoto      || {});
      editor.coverObjects     = cloneState(se.coverObjects     || []);
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      editor.coverUserTexts = cloneState(se.coverUserTexts || []);
      // Restore extra spreads so price display and spread adder stay in sync
      editor.extraSpreads = se.extraSpreads || 0;
    }

    builderMode = snapshot.builderMode || "pages";
    currentPhotoSort = snapshot.currentPhotoSort || "earliest";
    currentPhotoSearch = snapshot.currentPhotoSearch || "";
    hideUsedPhotos = !!snapshot.hideUsedPhotos;

    if (photoSortSelect) photoSortSelect.value = currentPhotoSort;
    if (hideUsedPhotosToggle) hideUsedPhotosToggle.checked = hideUsedPhotos;

    updatePrice();          // re-display price including any restored extraSpreads
    _syncSpreadAdderUI();   // re-sync spread adder counter + visibility
    updateCoverPreview();
    renderPhotoTray();
    renderThumbsRail();
    renderBuilderCanvas();
    // Full state restore — every page changed; clear and re-render preview cache
    try { _dmbPvReinitAll(); } catch(e) {}
  }

  const editor = {
    totalPages: 0,
    editablePages: 0,
    totalSpreads: 0,
    currentSpread: 0,
    extraSpreads: 0,      // count of extra spreads added by customer (each = 2 pages, +$0.99)
    pageSlots: {},
    pageRot: {},
    pageTemplate: {},
    pageFrames: {},
    pageFrameRot: {},
    pageObjects: {},
    pageBackgrounds: {},  // { [pageNumber]: "#rrggbb" } — per-page background color
    coverObjects: [],
    coverUserTexts: [],   // [{id, zone}] — user-added text nodes on the cover
    photos: []
  };

  // Silent auto-save (no banner) — debounced so it doesn't fire on every keystroke
  let _autoSaveTimer = null;
  function autoSave() {
    clearTimeout(_autoSaveTimer);
    _autoSaveTimer = setTimeout(() => {
      try {
        const payload = getCurrentBuilderStateSnapshot();
        localStorage.setItem("dmb_saved_project_v1", JSON.stringify(payload));
      } catch {}
    }, 800);
  }

  // ── PDF Preview Cache ─────────────────────────────────────────────────────
  // Pages are rendered to JPEG dataURLs in the background using the SAME
  // renderPage() / renderCoverSpread() code path as the real PDF export.
  // A 2-second debounce ensures re-renders only happen after edits settle.
  var _dmbPvCache   = {};       // pageNumber → JPEG dataURL
  var _dmbPvCover   = null;     // { back, spine, front } JPEG dataURLs
  var _dmbPvDirty   = new Set();
  var _dmbPvRendering = new Set();
  var _dmbPvTimer   = null;
  var _dmbPvRunning = false;
  var _dmbPvRefresh = null;     // callback set when preview overlay is open
  var _dmbPvGen     = 0;        // generation counter — incremented on reinit so
                                // in-flight renders from the previous generation
                                // know to discard their result instead of writing
                                // stale data to the (already cleared) cache.

  function _dmbPvMarkDirty(key) {
    _dmbPvDirty.add(key);
    clearTimeout(_dmbPvTimer);
    _dmbPvTimer = setTimeout(_dmbPvRun, 2000);
  }

  // Vacation-emoji orbit loading animation
  function _dmbPvMakeLoadingNode() {
    var emojis = ["✈️","🛂","🧳","🗺️","📸","🏖️"];
    var outer = document.createElement("div");
    outer.style.cssText = "display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;width:100%;height:100%;min-height:200px;";
    var ring = document.createElement("div");
    ring.style.cssText = "position:relative;width:130px;height:130px;";
    emojis.forEach(function(em, i) {
      var s = document.createElement("span");
      s.className = "dmb-pv-emoji";
      s.textContent = em;
      s.style.animationDelay = (-i * (3.5 / emojis.length)).toFixed(2) + "s";
      s.style.animationDuration = (3.2 + i * 0.2).toFixed(1) + "s";
      ring.appendChild(s);
    });
    var lbl = document.createElement("div");
    lbl.textContent = "Rendering…";
    lbl.style.cssText = "color:#888;font-size:11px;letter-spacing:0.4px;";
    outer.appendChild(ring);
    outer.appendChild(lbl);
    return outer;
  }

  async function _dmbPvRun() {
    if (_dmbPvRunning) return;
    _dmbPvRunning = true;
    var _myGen = _dmbPvGen; // snapshot generation at start — used to detect reinit
    try {
      while (_dmbPvDirty.size > 0) {
        // Abort entire loop if a reinit happened while we were awaiting
        if (_dmbPvGen !== _myGen) break;
        var _pvKeys = Array.from(_dmbPvDirty);
        for (var _pki = 0; _pki < _pvKeys.length; _pki++) {
          if (_dmbPvGen !== _myGen) break; // reinit mid-loop — stop immediately
          var _pvKey = _pvKeys[_pki];
          if (_dmbPvRendering.has(_pvKey)) continue;
          _dmbPvDirty.delete(_pvKey);
          _dmbPvRendering.add(_pvKey);
          try {
            var _pvResult = await new Promise(function(res, rej) {
              var _pvK = _pvKey;
              buildPdfBlobOnePagePerBookPage(null, _pvK === "cover"
                ? { cover: true,  resolve: res, reject: rej }
                : { page:  _pvK,  resolve: res, reject: rej });
            });
            // Discard result if a reinit happened while we were rendering
            if (_dmbPvGen !== _myGen) break;
            if (_pvKey === "cover") {
              _dmbPvCover = {
                back:  _pvResult.back.toDataURL("image/jpeg", 0.93),
                spine: _pvResult.spine.toDataURL("image/jpeg", 0.93),
                front: _pvResult.front.toDataURL("image/jpeg", 0.93),
              };
            } else {
              _dmbPvCache[_pvKey] = _pvResult.toDataURL("image/jpeg", 0.93);
            }
            if (typeof _dmbPvRefresh === "function") _dmbPvRefresh(_pvKey);
          } catch(_pvErr) {
            if (_dmbPvGen !== _myGen) break; // reinit — don't retry stale page
            console.warn("[DMB Preview] render failed for", _pvKey, ":", _pvErr && _pvErr.message);
            // Re-mark dirty so it retries on the next edit
            _dmbPvDirty.add(_pvKey);
          } finally {
            _dmbPvRendering.delete(_pvKey);
          }
          // Yield between pages so the UI stays responsive
          await new Promise(function(r) { setTimeout(r, 80); });
        }
      }
    } finally {
      // Only reset running flag if still our generation — a newer run took over
      if (_dmbPvGen === _myGen) _dmbPvRunning = false;
    }
  }

  function _dmbPvInitAll() {
    setTimeout(function() {
      _dmbPvDirty.add("cover");
      for (var _pvp = 0; _pvp <= (editor.totalPages || 0); _pvp++) {
        _dmbPvDirty.add(_pvp);
      }
      _dmbPvRunning = false; // allow fresh start
      _dmbPvRun();
    }, 1800);
  }

  // Call after any full state restore (undo/redo, progress restore, project load)
  // that changes ALL pages at once — clears stale cache and re-renders everything.
  function _dmbPvReinitAll() {
    _dmbPvGen++;            // invalidate ALL in-flight renders from previous generation
    _dmbPvCache   = {};
    _dmbPvCover   = null;
    _dmbPvDirty.clear();
    _dmbPvRendering.clear();
    clearTimeout(_dmbPvTimer);
    _dmbPvRunning = false;
    _dmbPvInitAll();
  }
  // ── End PDF Preview Cache ─────────────────────────────────────────────────

  // ── Contain-to-page ───────────────────────────────────────────────────────
  // Clips a free item to its page / cover-zone boundary using a CSS clip-path
  // polygon computed in the element's own (pre-rotation) coordinate space.
  //
  //   obj.contained  0 = off  |  1 = page / zone  |  2 = full spread (cover)
  //
  // The polygon technique:
  //   • Take the 4 corners of the clip rectangle in page coordinates
  //   • Translate them relative to the element centre, then inverse-rotate them
  //     into the element's local space (so the polygon follows any rotation)
  //   • CSS clip-path clips in local space → after transform the visible region
  //     is exactly the original rectangle in page space ✓

  function _dmbContainBounds(obj, isCover) {
    var FACE_PX  = 300, SPINE_PX = 22;
    var FACE_H   = Math.round(300 * 297 / 210); // 424px
    var PAGE_W   = 270,  PAGE_H = Math.round(270 * 297 / 210); // 382px
    // Magazine has no spine — front face starts at COVER_BACK_W (300), not COVER_FRONT_X (322)
    var isMag    = !!window.DMB_MAGAZINE_MODE;
    var FRONT_X  = isMag ? FACE_PX : (FACE_PX + SPINE_PX);  // 300 (mag) | 322 (book)
    var SPREAD_W = isMag ? FACE_PX * 2 : (FACE_PX * 2 + SPINE_PX); // 600 | 622
    if (!isCover) return { l: 0, t: 0, r: PAGE_W, b: PAGE_H };
    if ((obj.contained || 0) === 2)
      return { l: 0, t: 0, r: SPREAD_W, b: FACE_H }; // full spread
    var zone = obj.coverZone || "front";
    if (zone === "back")  return { l: 0,        t: 0, r: FACE_PX,          b: FACE_H };
    if (zone === "spine") return { l: FACE_PX,   t: 0, r: FACE_PX + SPINE_PX, b: FACE_H };
    return                        { l: FRONT_X,  t: 0, r: FRONT_X + FACE_PX,  b: FACE_H };
  }

  function _dmbContainClipPath(obj, bounds) {
    var L = obj.x || 0, T = obj.y || 0, W = obj.w || 100, H = obj.h || 100;
    var R    = -(obj.rotation || 0) * Math.PI / 180; // inverse rotation
    var cosR = Math.cos(R), sinR = Math.sin(R);
    var cx   = L + W / 2, cy = T + H / 2;
    var pts  = [[bounds.l, bounds.t],[bounds.r, bounds.t],
                [bounds.r, bounds.b],[bounds.l, bounds.b]].map(function(c) {
      var dx = c[0] - cx, dy = c[1] - cy;
      var lx = dx * cosR - dy * sinR + W / 2;
      var ly = dx * sinR + dy * cosR + H / 2;
      return lx.toFixed(1) + "px " + ly.toFixed(1) + "px";
    });
    return "polygon(" + pts.join(", ") + ")";
  }

  function _dmbApplyContain(wrapEl, obj, isCover) {
    if (!wrapEl) return;
    if (!obj || !obj.contained) { wrapEl.style.clipPath = ""; return; }
    wrapEl.style.clipPath = _dmbContainClipPath(obj, _dmbContainBounds(obj, isCover));
  }

  function _dmbContainBtnText(obj, isCover) {
    var s = obj.contained || 0;
    if (s === 0)            return "Contain: Off";
    if (isCover && s === 2) return "Contain: Spread ✓";
    if (isCover)            return "Contain: Zone ✓";
    return "Contain: On ✓";
  }

  function _dmbContainCycle(obj, wrapEl, isCover) {
    pushUndoState("Contain to page");
    var max = isCover ? 3 : 2;
    obj.contained = ((obj.contained || 0) + 1) % max;
    _dmbApplyContain(wrapEl, obj, isCover);
    ["dmbMapContainBtn","dmbShapeContainBtn","dmbFrameContainBtn"].forEach(function(id) {
      var btn = document.getElementById(id);
      if (btn) btn.textContent = _dmbContainBtnText(obj, isCover);
    });
  }

  // Re-apply contain clips to all visible item wrappers after any state change
  function _dmbReapplyAllContains() {
    document.querySelectorAll("[data-object-id]").forEach(function(el) {
      var objId   = el.dataset.objectId;
      var isCover = !!el.closest(".dmb-cover-preview");
      var obj = null;
      if (isCover) {
        obj = (editor.coverObjects || []).find(function(o) { return o.id === objId; });
      } else {
        var arrs = Object.values(editor.pageObjects || {});
        for (var _i = 0; _i < arrs.length; _i++) {
          if (!Array.isArray(arrs[_i])) continue;
          var _f = arrs[_i].find(function(o) { return o.id === objId; });
          if (_f) { obj = _f; break; }
        }
      }
      if (obj) _dmbApplyContain(el, obj, isCover);
    });
  }
  // ── End Contain-to-page ───────────────────────────────────────────────────

  // Cover zone layout constants (px)
  const COVER_BACK_W = 300; // matches .dmb-cover-face { width: 300px } in CSS
  const COVER_SPINE_W = 22;
  const COVER_FRONT_X = COVER_BACK_W + COVER_SPINE_W; // 322

  const DMB_MAG_ICONS = [
    { id: "vogue", label: "Vogue", file: "mag-icon-vogue.png" },
    { id: "elle", label: "Elle", file: "mag-icon-elle.png" },
    { id: "harpers-bazaar", label: "Harper's Bazaar", file: "mag-icon-harpers-bazaar.png" },
    { id: "harpers-bazaar-arabian", label: "Harper's Bazaar Arabian", file: "mag-icon-harpers-bazaar-arabian.png" },
  ];
  const _dmbIconColorCache = {};

  async function dmbGetColoredIconDataUrl(iconId, color) {
    const key = iconId + "|" + (color || "#000000");
    if (_dmbIconColorCache[key]) return _dmbIconColorCache[key];
    const iconUrl = dmbMagIconUrl(iconId);
    try {
      const resp = await fetch(iconUrl, { mode: "cors", cache: "force-cache" });
      const blob = await resp.blob();
      const blobUrl = URL.createObjectURL(blob);
      const img = await new Promise((res, rej) => {
        const i = new Image();
        i.onload = () => res(i);
        i.onerror = rej;
        i.src = blobUrl;
      });
      URL.revokeObjectURL(blobUrl);
      const c = document.createElement("canvas");
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      const cx = c.getContext("2d");
      cx.drawImage(img, 0, 0);
      cx.globalCompositeOperation = "source-in";
      cx.fillStyle = color || "#000000";
      cx.fillRect(0, 0, c.width, c.height);
      const dataUrl = c.toDataURL("image/png");
      _dmbIconColorCache[key] = dataUrl;
      return dataUrl;
    } catch(e) { return iconUrl; }
  }

  function dmbMagIconUrl(iconId) {
    const ic = DMB_MAG_ICONS.find((i) => i.id === iconId);
    if (!ic) return "";
    const base = (window.DMB_ASSET_BASE || "").replace(/\/[^/]+$/, "/");
    return base + ic.file;
  }

  function dmbFindObjectById(id, targetType) {
    if (targetType === "cover") {
      return (editor.coverObjects || []).find((o) => o.id === id) || null;
    }
    let found = null;
    Object.values(editor.pageObjects || {}).forEach((arr) => {
      if (!found) found = (arr || []).find((o) => o.id === id) || null;
    });
    return found;
  }

  let selectedTextNode = null;
  let selectedFrameObject = null;
  let dmbRotateHandle = null;
  let lastToolbarSide = "left";
  let activeMarkerType = null;
  let pendingMapMarkerPlacement = false;
  let currentInsertedMap = null;

  // Migrate old {front,back,spine} format to a flat array using full-cover x coordinates
  function migrateCoverObjectsToFlat() {
    if (Array.isArray(editor.coverObjects)) return;
    const old = editor.coverObjects || {};
    const flat = [];
    (old.back || []).forEach(o => flat.push(Object.assign({}, o)));
    (old.spine || []).forEach(o => flat.push(Object.assign({}, o, { x: (o.x || 0) + COVER_BACK_W })));
    (old.front || []).forEach(o => flat.push(Object.assign({}, o, { x: (o.x || 0) + COVER_FRONT_X })));
    editor.coverObjects = flat;
  }

  function ensureCoverObjects() {
    if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
    return editor.coverObjects;
  }

  function getCoverObjectsForZone(zone) {
    return ensureCoverObjects();
  }

  function pushObjectToCoverZone(zone, obj) {
    ensureCoverObjects().push(obj);
    return obj;
  }

  function getCurrentCoverZone() {
    return activeCoverZone || "front";
  }

  function getObjectByTarget(targetType, pageNumber, zone, objectId) {
    const arr = getObjectListForTarget(targetType, pageNumber, zone);
    return arr.find((o) => o.id === objectId) || null;
  }

  function deleteFrameObjectByTarget(targetType, pageNumber, zone, objectId) {
    const arr = getObjectListForTarget(targetType, pageNumber, zone);
    const idx = arr.findIndex((o) => o.id === objectId);
    if (idx >= 0) arr.splice(idx, 1);
    if (selectedFrameObject && selectedFrameObject.id === objectId) {
      selectedFrameObject = null;
    }
  }

  function markActiveCoverZone() {
    ["coverFront", "coverBack", "coverSpine"].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.remove("dmb-cover-zone-active");
    });

    const targetId =
      activeCoverZone === "back"
        ? "coverBack"
        : activeCoverZone === "spine"
        ? "coverSpine"
        : "coverFront";

    const activeEl = document.getElementById(targetId);
    if (activeEl) activeEl.classList.add("dmb-cover-zone-active");

    updateCoverZoneButtons();
  }

  function duplicateFrameObjectByTarget(targetType, pageNumber, zone, objectId) {
    const obj = getObjectByTarget(targetType, pageNumber, zone, objectId);
    if (!obj) return null;

    const copy = {
      ...cloneState(obj),
      id: uid(),
      x: obj.x + 20,
      y: obj.y + 20,
      z: Date.now()
    };

    getObjectListForTarget(targetType, pageNumber, zone).push(copy);
    return copy;
  }

  // ── Z-ORDER STEP HELPERS (2026-05) ──────────────────────────────────────
  // "⬆ Front" / "⬇ Back" buttons move an object ONE STEP at a time through
  // the stack (not jump-to-top / jump-to-bottom).
  // After the swap, z values are renormalised to multiples of 1000 to avoid
  // collisions. The BOTTOM item gets z=0 when it reaches the very last
  // position so it goes behind photos (which use z=1 in makePlacedImageBox).
  // The PDF renderer (renderPage / renderCoverSpread) reads these z values to
  // decide whether to draw an object before or after the photo layer.
  function _stepZ(targetType, pageNumber, zone, objectId, direction) {
    const list = getObjectListForTarget(targetType, pageNumber, zone);
    if (!list || list.length === 0) return;

    // Sort by current z (ascending = bottom to top)
    list.sort((a, b) => (a.z || 0) - (b.z || 0));
    const idx = list.findIndex(o => o.id === objectId);
    if (idx === -1) return;

    const newIdx = direction === "up"
      ? Math.min(list.length - 1, idx + 1)
      : Math.max(0, idx - 1);

    if (newIdx === idx) return; // already at top/bottom of the object stack

    // Swap positions in the sorted array
    const tmp = list[idx];
    list[idx] = list[newIdx];
    list[newIdx] = tmp;

    // Reassign clean z values: step 0 = z 1000, step 1 = z 2000, etc.
    // The bottom-most item (idx 0) gets z 1000 — still above placed photos (z=1)
    // unless this is a "send backward" where the object was already at the bottom,
    // in which case we drop it below photos by setting z = 0.
    list.forEach((o, i) => { o.z = (i + 1) * 1000; });

    // If sending backward and the object ended up at the very bottom of the
    // stack, drop it below photos (z=0) so it goes behind images too.
    if (direction === "down" && newIdx === 0) {
      list[0].z = 0;
    }
  }

  function bringFrameForwardByTarget(targetType, pageNumber, zone, objectId) {
    _stepZ(targetType, pageNumber, zone, objectId, "up");
  }

  function sendFrameBackwardByTarget(targetType, pageNumber, zone, objectId) {
    _stepZ(targetType, pageNumber, zone, objectId, "down");
  }
  function ensurePageObjects(pageNumber) {
    if (!editor.pageObjects) editor.pageObjects = {};
    if (!editor.pageObjects[pageNumber]) editor.pageObjects[pageNumber] = [];
    return editor.pageObjects[pageNumber];
  }

  function getCurrentVisiblePageNumber() {
    if (builderMode !== "pages") return null;
    const leftPage = editor.currentSpread * 2 + 1;
    if (leftPage > editor.totalPages) return null;
    if (!isLockedPage(leftPage)) return leftPage;
    const rightPage = leftPage + 1;
    if (rightPage <= editor.totalPages && !isLockedPage(rightPage)) return rightPage;
    return null;
  }

  function newFrameObject(target) {
    return {
      id: uid(),
      type: "photo-frame",
      targetType: target?.targetType || "page",
      page: target?.page ?? null,
      zone: target?.zone || null,
      x: 40,
      y: 40,
      w: 220,
      h: 160,
      z: Date.now(),
      photoId: null
    };
  }

  function getObjectById(pageNumber, objectId) {
    const arr = ensurePageObjects(pageNumber);
    return arr.find((o) => o.id === objectId) || null;
  }

  function deleteFrameObject(pageNumber, objectId) {
    const arr = ensurePageObjects(pageNumber);
    const idx = arr.findIndex((o) => o.id === objectId);
    if (idx >= 0) arr.splice(idx, 1);
    if (selectedFrameObject && selectedFrameObject.id === objectId) {
      selectedFrameObject = null;
    }
  }

  function duplicateFrameObject(pageNumber, objectId) {
    const obj = getObjectById(pageNumber, objectId);
    if (!obj) return null;
    const copy = {
      ...cloneState(obj),
      id: uid(),
      x: obj.x + 20,
      y: obj.y + 20,
      z: Date.now()
    };
    ensurePageObjects(pageNumber).push(copy);
    return copy;
  }

  function bringFrameForward(pageNumber, objectId) {
    const obj = getObjectById(pageNumber, objectId);
    if (!obj) return;
    obj.z = Date.now();
  }

  function sendFrameBackward(pageNumber, objectId) {
    const arr = ensurePageObjects(pageNumber);
    const minZ = arr.length ? Math.min(...arr.map((o) => Number(o.z || 0))) : 0;
    const obj = getObjectById(pageNumber, objectId);
    if (!obj) return;
    obj.z = minZ - 1;
  }

  function hideFrameToolbar() {
    const bar = document.getElementById("dmbFrameToolbar");
    if (bar) bar.classList.remove("is-open");
    document.querySelectorAll(".dmb-photo-frame-object, .dmb-sticker-object").forEach((el) => {
      el.classList.remove("is-selected");
      if (el._dmbRotHandle) el._dmbRotHandle.style.display = "none";
    });
    selectedFrameObject = null;
  }

  function showFrameToolbarFor(el, obj, meta) {
    const bar = document.getElementById("dmbFrameToolbar");
    const root = document.getElementById("dmb-root");
    if (!bar || !root || !el || !obj) return;

    hideTextToolbar();
    dmbCloseEditBar();
    dmbCloseShapeEditBar(); // close shape bar when frame toolbar opens
    selectedFrameObject = {
      id: obj.id,
      type: obj.type || "sticker",
      targetType: meta?.targetType || obj.targetType || "page",
      pageNumber: meta?.pageNumber ?? obj.page ?? null,
      zone: meta?.zone || obj.zone || null
    };
    const iconControls = document.getElementById("dmbFrameIconControls");
    if (iconControls) iconControls.style.display = obj.type === "mag-icon" ? "" : "none";
    // Contain button: visible for stickers + mag-icons, hidden for photo-frames
    const _containBtn = document.getElementById("dmbFrameContainBtn");
    if (_containBtn) {
      const _showContain = obj.type !== "photo-frame";
      _containBtn.style.display = _showContain ? "" : "none";
      if (_showContain) _containBtn.textContent = _dmbContainBtnText(obj, meta?.targetType === "cover");
    }
    if (obj.type === "mag-icon") {
      const colorInput = document.getElementById("dmbFrameIconColorInput");
      if (colorInput) colorInput.value = obj.color || "#000000";
    }
    document.querySelectorAll(".dmb-photo-frame-object, .dmb-sticker-object").forEach((node) => {
      node.classList.remove("is-selected");
      if (node._dmbRotHandle) node._dmbRotHandle.style.display = "none";
    });
    el.classList.add("is-selected");
    // Show + reposition sticker rotation handle if present
    if (el._dmbRotHandle && el.isConnected) {
      const rr2 = el.getBoundingClientRect();
      el._dmbRotHandle.style.left = (rr2.right + 14) + "px";
      el._dmbRotHandle.style.top = (rr2.bottom + 14) + "px";
      el._dmbRotHandle.style.display = "";
    }

    const er = el.getBoundingClientRect();
    const rr = root.getBoundingClientRect();

    bar.classList.add("is-open");
    const barW = bar.offsetWidth || 200;
    bar.style.left = `${Math.max(8, Math.min(er.left - rr.left, rr.width - barW - 8))}px`;
    bar.style.top = `${Math.max(8, er.top - rr.top - 42)}px`;
  }

  function ensureFrameToolbar() {
    if (document.getElementById("dmbFrameToolbar")) return;

    const root = document.getElementById("dmb-root");
    if (!root) return;

    const bar = document.createElement("div");
    bar.id = "dmbFrameToolbar";
    bar.className = "dmb-frame-toolbar";
    bar.innerHTML = `
      <button type="button" id="dmbFrameAlignLeftBtn" class="dmb-frame-tool-btn" title="Align left">&#8592;</button>
      <button type="button" id="dmbFrameAlignCenterBtn" class="dmb-frame-tool-btn" title="Center">&#8596;</button>
      <button type="button" id="dmbFrameAlignRightBtn" class="dmb-frame-tool-btn" title="Align right">&#8594;</button>
      <button type="button" id="dmbFrameDuplicateBtn" class="dmb-frame-tool-btn">Dup</button>
      <button type="button" id="dmbFrameFrontBtn" class="dmb-frame-tool-btn" title="Bring Forward — move above other objects">⬆ Front</button>
      <button type="button" id="dmbFrameBackBtn" class="dmb-frame-tool-btn" title="Send Backward — move behind photos">⬇ Back</button>
      <button type="button" id="dmbFrameShapeBtn" class="dmb-frame-tool-btn" title="Frame shape"><svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13.5,9 19,9.5 15,13.5 16.5,19 11,16 5.5,19 7,13.5 3,9.5 8.5,9" fill="currentColor" stroke="none" opacity="0.45"/></svg></button>
      <button type="button" id="dmbFrameDeleteBtn" class="dmb-frame-tool-btn" title="Delete" aria-label="Delete"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg></button>
      <button type="button" id="dmbFrameContainBtn" class="dmb-frame-tool-btn" title="Contain to page — clip item to page/zone boundary" style="display:none;">Contain: Off</button>
      <span id="dmbFrameIconControls" style="display:none;">
        <button type="button" id="dmbFrameIconColorBtn" class="dmb-frame-tool-btn" title="Change color">Color</button>
        <input type="color" id="dmbFrameIconColorInput" value="#000000" style="position:absolute;opacity:0;pointer-events:none;width:0;height:0;">
        <button type="button" id="dmbFrameIconFitBtn" class="dmb-frame-tool-btn" title="Fit to page">Fit</button>
      </span>
    `;
    root.appendChild(bar);

  ["left", "center", "right"].forEach(function(align) {
    const btnId = { left: "dmbFrameAlignLeftBtn", center: "dmbFrameAlignCenterBtn", right: "dmbFrameAlignRightBtn" }[align];
    document.getElementById(btnId)?.addEventListener("click", () => {
      if (!selectedFrameObject) return;
      const { id, targetType } = selectedFrameObject;
      let obj = null;
      if (targetType === "cover") {
        obj = (editor.coverObjects || []).find(function(o) { return o.id === id; });
      } else {
        Object.values(editor.pageObjects || {}).forEach(function(arr) {
          if (!obj) { const f = arr.find(function(o) { return o.id === id; }); if (f) obj = f; }
        });
      }
      const el = document.querySelector(`[data-object-id="${id}"]`);
      if (!obj || !el) return;
      dmbAlignObjectInZone(el, obj, align, targetType);
      showFrameToolbarFor(el, obj, { targetType, pageNumber: selectedFrameObject.pageNumber, zone: selectedFrameObject.zone });
    });
  });

  document.getElementById("dmbFrameDuplicateBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    pushUndoState("Duplicate Frame");
    const dup = duplicateFrameObjectByTarget(
      selectedFrameObject.targetType,
      selectedFrameObject.pageNumber,
      selectedFrameObject.zone,
      selectedFrameObject.id
    );
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    if (dup) {
      requestAnimationFrame(() => {
        const el = document.querySelector(`.dmb-photo-frame-object[data-object-id="${dup.id}"]`);
        if (el) {
          showFrameToolbarFor(el, dup, {
            targetType: dup.targetType,
            pageNumber: dup.page ?? null,
            zone: dup.zone || null
          });
        }
      });
    }
  });

  document.getElementById("dmbFrameFrontBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    pushUndoState("Bring Frame Forward");
    bringFrameForwardByTarget(
      selectedFrameObject.targetType,
      selectedFrameObject.pageNumber,
      selectedFrameObject.zone,
      selectedFrameObject.id
    );
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
  });

  document.getElementById("dmbFrameBackBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    pushUndoState("Send Frame Backward");
    sendFrameBackwardByTarget(
      selectedFrameObject.targetType,
      selectedFrameObject.pageNumber,
      selectedFrameObject.zone,
      selectedFrameObject.id
    );
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
  });

  document.getElementById("dmbFrameShapeBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    const btn = document.getElementById("dmbFrameShapeBtn");
    if (!btn) return;
    showDmbFramePicker(btn, obj ? (obj.frameShape || "") : "", (shapeId) => {
      if (obj) {
        obj.frameShape = shapeId;
        const el = document.querySelector(`[data-object-id="${selectedFrameObject.id}"] img`);
        if (el) applyDmbFrameShape(el, shapeId);
      }
      if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    });
  });

  document.getElementById("dmbFrameDeleteBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    pushUndoState("Delete Frame");
    deleteFrameObjectByTarget(
      selectedFrameObject.targetType,
      selectedFrameObject.pageNumber,
      selectedFrameObject.zone,
      selectedFrameObject.id
    );
    hideFrameToolbar();
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
  });

  document.getElementById("dmbFrameIconColorBtn")?.addEventListener("click", () => {
    document.getElementById("dmbFrameIconColorInput")?.click();
  });

  document.getElementById("dmbFrameIconColorInput")?.addEventListener("input", (e) => {
    if (!selectedFrameObject) return;
    const newColor = e.target.value;
    const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    if (!obj) return;
    obj.color = newColor;
    _dmbIconColorCache[obj.iconId + "|" + newColor] = null;
    dmbGetColoredIconDataUrl(obj.iconId, newColor).then((dataUrl) => {
      const imgEl = document.querySelector(`[data-object-id="${obj.id}"] img`);
      if (imgEl) imgEl.src = dataUrl;
    });
    pushUndoState("Recolor Icon");
  });

  document.getElementById("dmbFrameIconFitBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    const obj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    if (!obj || obj.type !== "mag-icon") return;
    const el = document.querySelector(`[data-object-id="${obj.id}"]`);
    const container = el?.parentElement;
    if (!el || !container) return;
    const cW = container.offsetWidth || 270;
    const cH = container.offsetHeight || 382;
    const PAD = 5;
    const aspect = (obj.naturalW && obj.naturalH) ? obj.naturalW / obj.naturalH : obj.w / (obj.h || 1);
    let nw, nh, nx, ny;
    if (aspect >= 1) {
      nw = cW - PAD * 2; nh = Math.round(nw / aspect); nx = PAD; ny = Math.round((cH - nh) / 2);
    } else {
      nh = cH - PAD * 2; nw = Math.round(nh * aspect); ny = PAD; nx = Math.round((cW - nw) / 2);
    }
    pushUndoState("Fit Icon to Page");
    obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
    if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
    requestAnimationFrame(() => {
      const newEl = document.querySelector(`[data-object-id="${obj.id}"]`);
      if (newEl) showFrameToolbarFor(newEl, obj, { targetType: selectedFrameObject.targetType, pageNumber: selectedFrameObject.pageNumber, zone: selectedFrameObject.zone });
    });
  });

  // ── Contain-to-page button (frame toolbar) ────────────────────────────────
  document.getElementById("dmbFrameContainBtn")?.addEventListener("click", () => {
    if (!selectedFrameObject) return;
    const _cObj = dmbFindObjectById(selectedFrameObject.id, selectedFrameObject.targetType);
    const _cEl  = document.querySelector(`[data-object-id="${selectedFrameObject.id}"]`);
    if (!_cObj || !_cEl) return;
    const _cIsCover = selectedFrameObject.targetType === "cover";
    _dmbContainCycle(_cObj, _cEl, _cIsCover);
  });

  }

  function getTextToolbar() {
    return document.getElementById("dmbTextToolbar");
  }

  function getDmbRoot() {
    return document.getElementById("dmb-root");
  }

  function rgbToHex(rgb) {
    const m = String(rgb || "").match(/\d+/g);
    if (!m || m.length < 3) return "#000000";
    return "#" + m.slice(0, 3).map((x) => Number(x).toString(16).padStart(2, "0")).join("");
  }

  var _rotDegTip = null;
  function showRotDegTooltip(deg, clientX, clientY) {
    if (!_rotDegTip) {
      _rotDegTip = document.createElement("div");
      _rotDegTip.style.cssText = "position:fixed;z-index:99999;background:rgba(0,0,0,0.78);color:#fff;font-size:12px;font-weight:700;padding:3px 10px;border-radius:20px;pointer-events:none;white-space:nowrap;font-family:sans-serif;letter-spacing:0.3px;";
      document.body.appendChild(_rotDegTip);
    }
    _rotDegTip.textContent = Math.round(((deg % 360) + 360) % 360) + "°";
    _rotDegTip.style.left = (clientX + 18) + "px";
    _rotDegTip.style.top = (clientY - 12) + "px";
    _rotDegTip.style.display = "block";
  }
  function hideRotDegTooltip() {
    if (_rotDegTip) _rotDegTip.style.display = "none";
  }

  function ensureRotateHandle() {
    if (dmbRotateHandle && document.body.contains(dmbRotateHandle)) return dmbRotateHandle;

    const root = getDmbRoot();
    if (!root) return null;

    const handle = document.createElement("div");
    handle.id = "dmbTextRotateHandle";
    handle.className = "dmb-text-rotate-handle";
    handle.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M19.5 4.5v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    root.appendChild(handle);
    dmbRotateHandle = handle;

    let rotating = false;
    let centerX = 0;
    let centerY = 0;
    let startAngle = 0;
    let startRotate = 0;

    const onMove = (e) => {
      if (!rotating || !selectedTextNode) return;

      const angle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * 180 / Math.PI;
      const raw  = startRotate + (angle - startAngle);
      const next = _dmbSnapAngle(raw); // Fix 3: 45° magnetic snap

      selectedTextNode.dataset.rotate = String(next);
      selectedTextNode.style.transform = `rotate(${next}deg)`;
      saveCoverTextNodeState(selectedTextNode);
      showTextToolbarFor(selectedTextNode);
      showRotDegTooltip(next, e.clientX, e.clientY);
    };

    const onUp = () => {
      rotating = false;
      hideRotDegTooltip();
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
    };

    handle.addEventListener("pointerdown", (e) => {
      if (!selectedTextNode) return;

      e.preventDefault();
      e.stopPropagation();

      const rect = selectedTextNode.getBoundingClientRect();
      centerX = rect.left + rect.width / 2;
      centerY = rect.top + rect.height / 2;

      startAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX) * 180 / Math.PI;
      startRotate = Number(selectedTextNode.dataset.rotate || "0");

      rotating = true;
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    });

    return handle;
  }

  function positionRotateHandle(node) {
    const handle = ensureRotateHandle();
    const root = getDmbRoot();
    if (!handle || !root || !node) return;

    const nodeRect = node.getBoundingClientRect();
    const rootRect = root.getBoundingClientRect();

    const left = nodeRect.left - rootRect.left + (nodeRect.width / 2) - 13;
    const top = nodeRect.bottom - rootRect.top + 10;

    handle.style.left = `${left}px`;
    handle.style.top = `${top}px`;
    handle.classList.add("is-visible");
  }

  function hideRotateHandle() {
    const handle = ensureRotateHandle();
    if (handle) handle.classList.remove("is-visible");
  }

  function showTextToolbarFor(node) {
    const toolbar = getTextToolbar();
    const root = getDmbRoot();
    if (!toolbar || !node || !root) return;

    hideFrameToolbar();
    dmbCloseShapeEditBar(); // close shape bar when text toolbar opens
    dmbCloseEditBar();
    selectedTextNode = node;

    document.querySelectorAll(".dmb-editable-text").forEach((el) => {
      el.classList.remove("is-selected");
    });
    node.classList.add("is-selected");

    const nodeRect = node.getBoundingClientRect();
    const rootRect = root.getBoundingClientRect();

    toolbar.classList.add("is-open");
    const tbW = toolbar.offsetWidth || 400;
    toolbar.style.left = `${Math.max(8, Math.min(nodeRect.left - rootRect.left, rootRect.width - tbW - 8))}px`;
    toolbar.style.top = `${Math.max(8, nodeRect.top - rootRect.top - 34)}px`;

    const fontFamily = document.getElementById("dmbFontFamily");
    const fontSize = document.getElementById("dmbFontSize");
    const textColor = document.getElementById("dmbTextColor");
    const textAlign = document.getElementById("dmbTextAlign");

    const cs = window.getComputedStyle(node);

    if (fontSize) fontSize.value = String(Math.round(parseFloat(cs.fontSize) || 28));
    if (textColor) textColor.value = rgbToHex(cs.color);
    if (textAlign) textAlign.value = cs.textAlign || "left";

    if (fontFamily) {
      const ff = (cs.fontFamily || "").toLowerCase();
      for (const opt of fontFamily.options) {
        const v = opt.value.toLowerCase().replace(/['"]/g, "");
        if (ff.includes(v.split(",")[0].trim())) {
          fontFamily.value = opt.value;
          break;
        }
      }
    }

    positionRotateHandle(node);
  }

  function hideTextToolbar() {
    const toolbar = getTextToolbar();
    if (toolbar) toolbar.classList.remove("is-open");

    document.querySelectorAll(".dmb-editable-text").forEach((el) => {
      el.classList.remove("is-selected");
    });

    hideRotateHandle();
    selectedTextNode = null;
  }

  // ── Fix 5: Auto-zone assignment ──────────────────────────────────────
  // Automatically assigns the cover zone (front/spine/back) based on where
  // the centre of the object sits after a drag. No dialog — silent assignment.
  // The zone drives clipping (dmbApplyZoneClip) and alignment (dmbAlignObjectInZone).
  function _dmbAutoAssignCoverZone(obj, el) {
    if (window.DMB_MAGAZINE_MODE) {
      // Magazine: no spine — just front/back split at COVER_BACK_W
      var cx = (obj.x || 0) + (obj.w || el.offsetWidth || 0) / 2;
      obj.coverZone = cx < COVER_BACK_W ? "back" : "front";
    } else {
      var cx = (obj.x || 0) + (obj.w || el.offsetWidth || 0) / 2;
      if (cx < COVER_BACK_W) obj.coverZone = "back";
      else if (cx < COVER_FRONT_X) obj.coverZone = "spine";
      else obj.coverZone = "front";
    }
    dmbApplyZoneClip(el, obj);
    // Re-apply contain clip with the newly assigned zone
    try { if (obj.contained) _dmbApplyContain(el, obj, true); } catch(e) {}
  }

  // Legacy wrapper — kept for any remaining callers but now auto-assigns
  // instead of showing a dialog.
  function checkCoverZoneBoundaries(getLeft, getWidth, setLeft, setZone) {
    // No-op: zone assignment is now handled by _dmbAutoAssignCoverZone
    // which is called directly from each pointerup handler.
  }

  function makeTextInteractive(node) {
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;
    let moved = false;
    // Natural glyph width for drag clamp (computed at drag start without forced CSS width
    // so a wide alignment box like width:220px doesn't trap the visible text in the middle).
    let _dragNW = 0;

    const onMove = (e) => {
      if (!dragging) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) moved = true;

      let newLeft = startLeft + dx;
      let newTop = startTop + dy;

      const parent = node.parentElement;
      if (parent) {
        // Rotation-aware bounds: rotated text must be able to visually reach all page edges.
        // For an element of CSS size nW×nH rotated by θ, the visual half-extents are:
        //   projH = nW/2·|cosθ| + nH/2·|sinθ|  (horizontal)
        //   projV = nW/2·|sinθ| + nH/2·|cosθ|  (vertical)
        // The CSS left/top that puts the visual edge exactly at 0 is (projH − nW/2) and (projV − nH/2).
        const _rotDeg = parseFloat(node.dataset.rotate || "0") || 0;
        const _θ = _rotDeg * Math.PI / 180;
        // Use the natural glyph width (measured at drag start without forced CSS width)
        // so an alignment box wider than the visible text doesn't restrict movement.
        const _nW = (_dragNW > 0 ? _dragNW : node.offsetWidth);
        const _nH = node.offsetHeight;
        const _pH = _nW / 2 * Math.abs(Math.cos(_θ)) + _nH / 2 * Math.abs(Math.sin(_θ));
        const _pV = _nW / 2 * Math.abs(Math.sin(_θ)) + _nH / 2 * Math.abs(Math.cos(_θ));
        const coverWrap = parent.closest(".dmb-cover-preview");
        if (coverWrap) {
          // Seamless drag across full cover (back + spine + front)
          const coverRect = coverWrap.getBoundingClientRect();
          const parentRect = parent.getBoundingClientRect();
          const coverLeft  = coverRect.left  - parentRect.left;
          const coverRight = coverRect.right - parentRect.left;
          const minLeft = Math.round(coverLeft  + _pH - _nW / 2);
          const maxLeft = Math.round(coverRight - _nW / 2 - _pH);
          const minTop  = Math.round(_pV - _nH / 2);
          const maxTop  = Math.round(parent.offsetHeight - _nH / 2 - _pV);
          newLeft = Math.max(minLeft, Math.min(newLeft, Math.max(minLeft, maxLeft)));
          newTop  = Math.max(minTop,  Math.min(newTop,  Math.max(minTop,  maxTop)));
        } else {
          const minLeft = Math.round(_pH - _nW / 2);
          const maxLeft = Math.round(parent.offsetWidth  - _nW / 2 - _pH);
          const minTop  = Math.round(_pV - _nH / 2);
          const maxTop  = Math.round(parent.offsetHeight - _nH / 2 - _pV);
          newLeft = Math.max(minLeft, Math.min(newLeft, Math.max(minLeft, maxLeft)));
          newTop  = Math.max(minTop,  Math.min(newTop,  Math.max(minTop,  maxTop)));
        }
      }

      node.style.left = `${newLeft}px`;
      node.style.top = `${newTop}px`;
      // Full sibling snap for text: shows guides AND snaps to all other objects.
      // The snap uses the GLYPH box (visible text), not the element box.  The text
      // element has padding 2px 6px, so the box left edge is 6px left of the first
      // letter and the box right edge is 6px right of the last letter.  We inset by
      // the padding so the alignment line lands on the actual letter edges, then
      // convert the snapped glyph-x back to the element box-x.
      if (parent) {
        const { gH: tGH, gV: tGV } = dmbGetSnapGuides(parent);
        const _isCoverTxt = !!parent.closest(".dmb-cover-preview");
        const _tpn = parseInt(node.dataset.pageNumber);
        const _tmeta = _isCoverTxt
          ? { targetType: "cover" }
          : (Number.isFinite(_tpn) ? { targetType: "page", pageNumber: _tpn } : null);
        const _TX_PL = 6, _TX_PT = 2; // matches CSS padding: 2px 6px
        const _glyphW = Math.max(0, (node.offsetWidth  || 132) - _TX_PL * 2) || 120;
        const _glyphH = Math.max(0, (node.offsetHeight || 34)  - _TX_PT * 2) || 26;
        const _snapTxt = {
          id: node.id,
          x: newLeft + _TX_PL, y: newTop + _TX_PT,
          w: _glyphW,
          h: _glyphH,
        };
        dmbCheckSnap(_snapTxt, parent, tGH, tGV, _tmeta);
        // Convert snapped glyph position back to the element box position
        newLeft = _snapTxt.x - _TX_PL;
        newTop  = _snapTxt.y - _TX_PT;
        // CRITICAL: re-apply to the DOM so the snap actually moves the text.
        // Without this the snapped position is computed but never written, so the
        // guide appears but the text does not snap into place.
        node.style.left = `${newLeft}px`;
        node.style.top  = `${newTop}px`;
      }
      saveCoverTextNodeState(node);
      savePageTextState(node);
      showTextToolbarFor(node);
    };

    const onUp = () => {
      dragging = false;
      document.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerup", onUp);
      if (moved) pushUndoState("Move Text");
      if (moved && node.closest(".dmb-cover-preview")) {
        // ── Use visual (post-rotation) bounding box for zone check ──────────
        // node.offsetWidth is the PRE-ROTATION width. For rotated text this
        // triggers false "zone boundary" dialogs even when the text is clearly
        // within one zone. getBoundingClientRect() returns the actual painted
        // axis-aligned bounds AFTER the CSS transform, so it's always correct.
        const _coverEl = document.querySelector(".dmb-cover-preview");
        const _coverRect = _coverEl ? _coverEl.getBoundingClientRect() : null;
        const _nodeRect  = node.getBoundingClientRect();
        const _visLeft   = _coverRect ? (_nodeRect.left  - _coverRect.left) : (parseFloat(node.style.left) || 0);
        const _visWidth  = _nodeRect.width;
        // Offset between CSS left and visual left — constant for a given rotation
        const _cssLeft   = parseFloat(node.style.left) || 0;
        const _vis2css   = _cssLeft - _visLeft; // add to visual left to get CSS left
        checkCoverZoneBoundaries(
          () => _visLeft,
          () => _visWidth,
          (newVisLeft) => {
            // Convert target visual-left back to the CSS left the node needs
            node.style.left = (newVisLeft + _vis2css) + "px";
            saveCoverTextNodeState(node);
          }
        );
      }
    };

    node.addEventListener("pointerdown", (e) => {
      if (e.target.closest("#dmbTextToolbar")) return;
      if (e.target.closest("#dmbTextRotateHandle")) return;

      showTextToolbarFor(node);

      dragging = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = parseFloat(node.style.left) || 0;
      startTop = parseFloat(node.style.top) || 0;
      // Compute natural glyph width without any forced CSS width so the drag clamp
      // uses the actual visible text extent (not an alignment box that may be wider).
      { const _sw = node.style.width; node.style.width = ''; _dragNW = node.offsetWidth || 80; node.style.width = _sw; }

      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    });

    node.addEventListener("click", (e) => {
      e.stopPropagation();
      showTextToolbarFor(node);
    });

    // Prevent native browser text-selection drag from bubbling to the page drop handler
    node.addEventListener("dragstart", (e) => { e.preventDefault(); e.stopPropagation(); });

    // Intercept Backspace / Delete when the text box is empty.
    // Without this, the browser removes the DOM node directly but leaves it in
    // editor.pageObjects / editor.coverObjects, so it reappears on the next
    // re-render.  We replicate the same cleanup the Delete toolbar button does.
    node.addEventListener("keydown", (e) => {
      if (e.key !== "Backspace" && e.key !== "Delete") return;
      if (node.textContent.trim() !== "") return; // still has content — let browser handle it
      e.preventDefault();
      pushUndoState("Delete Text");
      if (node.id) {
        editor.coverUserTexts = (editor.coverUserTexts || []).filter((en) => en.id !== node.id);
        if (coverState.textStyles) delete coverState.textStyles[node.id];
        const _kpn = parseInt(node.dataset.pageNumber);
        if (Number.isFinite(_kpn) && Array.isArray(editor.pageObjects?.[_kpn])) {
          editor.pageObjects[_kpn] = editor.pageObjects[_kpn].filter((o) => o.id !== node.id);
        }
      }
      if (typeof hideTextToolbar === "function") hideTextToolbar();
      node.remove();
    });

    node.addEventListener("blur", () => {
      if (selectedTextNode === node) {
        setTimeout(() => {
          if (selectedTextNode === node) showTextToolbarFor(node);
        }, 0);
      }
    });
  }

  function attachTextNodeHandlers(node) {
    if (!node) return;
    if (node.dataset.dmbTextReady === "true") return;
    node.dataset.dmbTextReady = "true";

    node.classList.add("dmb-editable-text");
    node.style.position = "absolute";
    node.dataset.z = node.dataset.z || String(Date.now());
    node.style.zIndex = node.dataset.z;
    node.style.transformOrigin = "center center";

    if (!node.style.left) node.style.left = "40px";
    if (!node.style.top) node.style.top = "40px";

    if (!node.hasAttribute("contenteditable")) {
      node.setAttribute("contenteditable", "true");
    }

    node.addEventListener("click", (e) => {
      e.stopPropagation();
      showTextToolbarFor(node);
    });

    node.addEventListener("input", () => {
      node.style.display = node.textContent.trim() ? "block" : "none";
      if (
        node.id === "coverFrontTitle1" ||
        node.id === "coverBackTitle1" ||
        node.id === "coverSpineTitle1"
      ) {
        coverState.title1 = node.textContent.trim();
        if (coverTitle1Input) coverTitle1Input.value = coverState.title1;
      }

      if (
        node.id === "coverFrontTitle2" ||
        node.id === "coverBackTitle2"
      ) {
        coverState.title2 = node.textContent.trim();
        if (coverTitle2Input) coverTitle2Input.value = coverState.title2;
      }
      saveCoverTextNodeState(node);
      savePageTextState(node);
      saveCoverDesignToStorage();
      showTextToolbarFor(node);
    });

    makeTextInteractive(node);
  }

  function wireTextToolbar() {
    if (wireTextToolbar._done) return;
    wireTextToolbar._done = true;

    ensureRotateHandle();

    const fontFamily = document.getElementById("dmbFontFamily");
    const fontSize = document.getElementById("dmbFontSize");
    const textColor = document.getElementById("dmbTextColor");
    const underlineBtn = document.getElementById("dmbUnderlineBtn");
    const textAlign = document.getElementById("dmbTextAlign");
    const duplicateBtn = document.getElementById("dmbDuplicateTextBtn");
    const deleteBtn = document.getElementById("dmbDeleteTextBtn");
    const applyAllBtn = document.getElementById("dmbApplyAllTextBtn");
    const textFrontBtn = document.getElementById("dmbTextFrontBtn");
    const textBackBtn = document.getElementById("dmbTextBackBtn");
    const textPosLeft = document.getElementById("dmbTextPosLeft");
    const textPosCenter = document.getElementById("dmbTextPosCenter");
    const textPosRight = document.getElementById("dmbTextPosRight");
    function applyToSelected(fn) {
      if (!selectedTextNode) return;
      pushUndoState("Text Edit");
      fn(selectedTextNode);
      saveCoverTextNodeState(selectedTextNode);
      savePageTextState(selectedTextNode);
      saveCoverDesignToStorage();
      showTextToolbarFor(selectedTextNode);
      // Only re-focus the text node if the user is NOT currently typing inside
      // a toolbar control (e.g. the font-size input).  Calling .focus() while
      // the size box is active steals focus back to the text node, so every
      // digit after the first lands in the text content instead of the input.
      const _active = document.activeElement;
      if (!_active || !_active.closest("#dmbTextToolbar")) {
        selectedTextNode.focus();
      }
    }

    if (fontFamily) {
      fontFamily.addEventListener("change", () => {
        applyToSelected((node) => {
          node.style.fontFamily = fontFamily.value;
        });
      });
    }

    if (fontSize) {
      const applyFontSize = () => {
        const v = Number(fontSize.value);
        if (!Number.isFinite(v) || v <= 0) return;

        applyToSelected((node) => {
          node.style.fontSize = `${v}px`;
        });
      };

      fontSize.addEventListener("input", applyFontSize);
      fontSize.addEventListener("change", applyFontSize);
    }

    if (textColor) {
      textColor.addEventListener("input", () => {
        applyToSelected((node) => {
          node.style.color = textColor.value;
        });
      });
    }

    if (underlineBtn) {
      underlineBtn.addEventListener("click", () => {
        applyToSelected((node) => {
          node.style.textDecoration =
            node.style.textDecoration === "underline" ? "none" : "underline";
        });
      });
    }

    if (textAlign) {
      textAlign.addEventListener("change", () => {
        applyToSelected((node) => {
          node.style.textAlign = textAlign.value;
          node.style.width = "220px";
        });
      });
    }
    if (textFrontBtn) {
      textFrontBtn.addEventListener("click", () => {
        bringSelectedTextToFront();
      });
    }

    if (textBackBtn) {
      textBackBtn.addEventListener("click", () => {
        sendSelectedTextToBack();
      });
    }

    if (textPosLeft) {
      textPosLeft.addEventListener("click", () => {
        if (selectedTextNode) dmbAlignTextNode(selectedTextNode, "left");
      });
    }
    if (textPosCenter) {
      textPosCenter.addEventListener("click", () => {
        if (selectedTextNode) dmbAlignTextNode(selectedTextNode, "center");
      });
    }
    if (textPosRight) {
      textPosRight.addEventListener("click", () => {
        if (selectedTextNode) dmbAlignTextNode(selectedTextNode, "right");
      });
    }

    if (duplicateBtn) {
      duplicateBtn.addEventListener("click", () => {
        if (!selectedTextNode || !selectedTextNode.parentElement) return;

        const clone = selectedTextNode.cloneNode(true);
        clone.dataset.dmbTextReady = "";
        clone.style.left = `${(parseFloat(selectedTextNode.style.left) || 40) + 20}px`;
        clone.style.top = `${(parseFloat(selectedTextNode.style.top) || 40) + 20}px`;
        clone.dataset.rotate = selectedTextNode.dataset.rotate || "0";
        clone.style.transform = selectedTextNode.style.transform || "";
        clone.dataset.z = String(Date.now());
        clone.style.zIndex = clone.dataset.z;

        // Register clone in the data model so it survives re-renders
        const newId = (builderMode === "cover" ? "utext_" : "pgtext_") + Date.now() + "_" + Math.random().toString(36).slice(2);
        clone.id = newId;

        if (builderMode === "cover") {
          const zone = activeCoverZone === "back" ? "back" : activeCoverZone === "spine" ? "spine" : "front";
          if (!Array.isArray(editor.coverUserTexts)) editor.coverUserTexts = [];
          editor.coverUserTexts.push({ id: newId, zone });
          saveCoverTextNodeState(clone);
        } else {
          const pn = parseInt(selectedTextNode.dataset.pageNumber);
          if (Number.isFinite(pn)) {
            clone.dataset.pageNumber = String(pn);
            if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
            editor.pageObjects[pn].push({
              id: newId, type: "text",
              text: clone.textContent || "",
              left: clone.style.left || "40px",
              top: clone.style.top || "40px",
              fontSize: clone.style.fontSize || "28px",
              fontWeight: clone.style.fontWeight || "800",
              color: clone.style.color || "#666",
              fontFamily: clone.style.fontFamily || "",
              textAlign: clone.style.textAlign || "",
              textDecoration: clone.style.textDecoration || "",
              transform: clone.style.transform || "",
              rotate: clone.dataset.rotate || "0",
              z: clone.dataset.z || String(Date.now()),
              width: clone.style.width || ""
            });
          }
        }

        attachTextNodeHandlers(clone);
        selectedTextNode.parentElement.appendChild(clone);
        showTextToolbarFor(clone);
        clone.focus();
      });
    }

    if (deleteBtn) {
      deleteBtn.addEventListener("click", () => {
        if (!selectedTextNode) return;
        const node = selectedTextNode;
        pushUndoState("Delete Text");
        // Remove from registry so it doesn't reappear on re-render
        if (node.id) {
          editor.coverUserTexts = (editor.coverUserTexts || []).filter((e) => e.id !== node.id);
          if (coverState.textStyles) delete coverState.textStyles[node.id];
          const _dpn = parseInt(node.dataset.pageNumber);
          if (Number.isFinite(_dpn) && Array.isArray(editor.pageObjects?.[_dpn])) {
            editor.pageObjects[_dpn] = editor.pageObjects[_dpn].filter((o) => o.id !== node.id);
          }
        }
        hideTextToolbar();
        node.remove();
      });
    }

    if (applyAllBtn) {
      applyAllBtn.addEventListener("click", () => {
        if (!selectedTextNode) return;

        const styles = {
          fontFamily: selectedTextNode.style.fontFamily,
          fontSize: selectedTextNode.style.fontSize,
          color: selectedTextNode.style.color,
          textDecoration: selectedTextNode.style.textDecoration,
          textAlign: selectedTextNode.style.textAlign,
          transform: selectedTextNode.style.transform,
          width: selectedTextNode.style.width
        };

        document.querySelectorAll(".dmb-editable-text").forEach((el) => {
          Object.assign(el.style, styles);
          el.dataset.rotate = selectedTextNode.dataset.rotate || "0";
        });
      });
    }

    document.addEventListener("click", (e) => {
      const clickedText = e.target.closest(".dmb-editable-text");
      const clickedToolbar = e.target.closest("#dmbTextToolbar");
      const clickedRotateHandle = e.target.closest("#dmbTextRotateHandle");
      if (!clickedText && !clickedToolbar && !clickedRotateHandle) {
        hideTextToolbar();
      }
    });

    window.addEventListener("resize", () => {
      if (selectedTextNode) showTextToolbarFor(selectedTextNode);
    });
  }

  function saveProjectLocalWithMessage() {
    const payload = getCurrentBuilderStateSnapshot();
    try {
      localStorage.setItem("dmb_saved_project_v1", JSON.stringify(payload));
      if (saveMsg) {
        saveMsg.textContent = "Saved ✅";
        saveMsg.style.display = "block";
        setTimeout(() => { saveMsg.style.display = "none"; }, 1400);
      }
    } catch {
      alert("Could not save on this device.");
    }
  }

  function openSavedProjectLocal() {
    const raw = loadProjectLocal();
    if (!raw) {
      alert("No saved project found.");
      return;
    }
    applyBuilderStateSnapshot(raw);
  }

  function startNewProjectLocal() {
    const ok = window.confirm("Start a new project? Unsaved changes may be lost.");
    if (!ok) return;

    try {
      localStorage.removeItem("dmb_saved_project_v1");
    } catch {}

    window.location.href = window.DMB_MAGAZINE_MODE
      ? "/pages/design-my-magazine?step=2&mode=customize"
      : "/pages/design-my-book?step=2&mode=customize";
  }

  function openProjectMenuPrompt() {
    const choice = window.prompt("Type one: save / open / new", "save");
    if (!choice) return;

    const v = choice.trim().toLowerCase();

    if (v === "save") {
      saveProjectLocalWithMessage();
    } else if (v === "open") {
      openSavedProjectLocal();
    } else if (v === "new") {
      startNewProjectLocal();
    }
  }

  function openHistoryPanel() {
    if (!undoStack.length) {
      alert("No history yet.");
      return;
    }

    const lines = undoStack
      .map((s, i) => `${i + 1}. ${s.label || "Edited"}`)
      .join("\n");

    const pick = window.prompt(`History:\n\n${lines}\n\nType a number to restore that step:`, "");
    if (!pick) return;

    const idx = Number(pick);
    if (!Number.isInteger(idx) || idx < 1 || idx > undoStack.length) return;

    const target = undoStack[idx - 1];
    if (!target) return;

    editor.currentSpread = target.currentSpread;
    editor.pageSlots = cloneState(target.pageSlots);
    editor.pageRot = cloneState(target.pageRot);
    editor.pageTemplate = cloneState(target.pageTemplate);
    editor.pageFrames = cloneState(target.pageFrames);
    editor.pageFrameRot = cloneState(target.pageFrameRot);
    builderMode = target.builderMode || "pages";
    editor.pageObjects = cloneState(target.pageObjects || {});
    editor.coverObjects = cloneState(target.coverObjects || []);
    if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
    coverState.textStyles = cloneState(target.coverState?.textStyles || {});
    coverState.template = target.coverState?.template || "default";
    coverState.title1 = target.coverState?.title1 || "";
    coverState.title2 = target.coverState?.title2 || "";
    coverState.color = target.coverState?.color || "#ffffff";

    syncCoverInputsFromState();
    renderPhotoTray();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  function ensurePreviewOverlay() {
    if (document.getElementById("dmbPreviewOverlay")) return;

    const overlay = document.createElement("div");
    overlay.id = "dmbPreviewOverlay";
    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.background = "rgba(0,0,0,0.82)";
    overlay.style.zIndex = "99999";
    overlay.style.display = "none";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.padding = "24px";

    const panel = document.createElement("div");
    panel.id = "dmbPreviewPanel";
    panel.style.width = "min(1200px, 96vw)";
    panel.style.height = "min(92vh, 920px)";
    panel.style.background = "#1a1a1a";
    panel.style.borderRadius = "20px";
    panel.style.display = "flex";
    panel.style.flexDirection = "column";
    panel.style.overflow = "hidden";

    const head = document.createElement("div");
    head.id = "dmbPreviewHead";
    head.style.cssText = "display:flex;justify-content:space-between;align-items:center;padding:14px 20px;border-bottom:1px solid #333;flex-shrink:0;";

    const titleWrap = document.createElement("div");
    titleWrap.id = "dmbPreviewTitleWrap";
    titleWrap.style.cssText = "display:flex;align-items:center;gap:16px;";

    const titleEl = document.createElement("div");
    titleEl.id = "dmbPreviewTitle";
    titleEl.textContent = "Preview";
    titleEl.style.cssText = "font-weight:900;font-size:16px;color:#fff;";

    const navWrap = document.createElement("div");
    navWrap.id = "dmbPreviewNavWrap";
    navWrap.style.cssText = "display:flex;align-items:center;gap:10px;";

    const prevBtn = document.createElement("button");
    prevBtn.id = "dmbPreviewPrev";
    prevBtn.type = "button";
    prevBtn.textContent = "◀ Prev";
    prevBtn.style.cssText = "padding:7px 14px;border-radius:8px;border:1px solid #555;background:#2a2a2a;color:#fff;font-weight:700;font-size:13px;cursor:pointer;";

    const spreadLabel = document.createElement("div");
    spreadLabel.id = "dmbPreviewSpreadLabel";
    spreadLabel.style.cssText = "font-size:12px;color:#aaa;min-width:80px;text-align:center;";

    const nextBtn = document.createElement("button");
    nextBtn.id = "dmbPreviewNext";
    nextBtn.type = "button";
    nextBtn.textContent = "Next ▶";
    nextBtn.style.cssText = "padding:7px 14px;border-radius:8px;border:1px solid #555;background:#2a2a2a;color:#fff;font-weight:700;font-size:13px;cursor:pointer;";

    const closeBtn = document.createElement("button");
    closeBtn.id = "dmbPreviewClose";
    closeBtn.type = "button";
    closeBtn.style.cssText = "padding:7px 16px;border-radius:8px;border:1px solid #555;background:#333;color:#fff;font-weight:700;font-size:13px;cursor:pointer;";
    closeBtn.textContent = "Close";

    const body = document.createElement("div");
    body.id = "dmbPreviewBody";
    body.style.cssText = "flex:1 1 auto;overflow:hidden;display:flex;align-items:center;justify-content:center;padding:24px;background:#111;";

    closeBtn.addEventListener("click", () => { overlay.style.display = "none"; });

    // ── Confirm banner (shown only in confirm-mode) ───────────────────────
    const confirmBanner = document.createElement("div");
    confirmBanner.id = "dmbPreviewConfirmBanner";
    confirmBanner.style.cssText = "display:none;flex-shrink:0;background:#1a1a1a;border-top:1px solid #333;padding:16px 24px;display:none;flex-direction:column;align-items:center;gap:12px;";

    const confirmMsg = document.createElement("div");
    confirmMsg.style.cssText = "color:#ffd700;font-size:14px;font-weight:700;text-align:center;";
    confirmMsg.textContent = "📋 Review every page carefully using the arrows above — cover, special page, and all spreads. When everything looks perfect, confirm below.";

    const confirmBtn = document.createElement("button");
    confirmBtn.id = "dmbPreviewConfirmBtn";
    confirmBtn.type = "button";
    confirmBtn.textContent = "✅ Looks perfect — Confirm & Place Order";
    confirmBtn.style.cssText = "background:#22c55e;color:#fff;border:none;border-radius:10px;padding:14px 32px;font-size:15px;font-weight:900;cursor:pointer;letter-spacing:0.3px;";
    confirmBtn.addEventListener("mouseover", () => { confirmBtn.style.background = "#16a34a"; });
    confirmBtn.addEventListener("mouseout",  () => { confirmBtn.style.background = "#22c55e"; });

    confirmBanner.appendChild(confirmMsg);
    confirmBanner.appendChild(confirmBtn);

    navWrap.appendChild(prevBtn);
    navWrap.appendChild(spreadLabel);
    navWrap.appendChild(nextBtn);
    titleWrap.appendChild(titleEl);
    titleWrap.appendChild(navWrap);
    head.appendChild(titleWrap);
    head.appendChild(closeBtn);
    panel.appendChild(head);
    panel.appendChild(body);
    panel.appendChild(confirmBanner);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    // ── Mobile layout overrides (applied inline — more reliable than CSS on dynamic elements) ──
    if (window.innerWidth <= 749) {
      panel.style.width         = "100vw";
      panel.style.height        = "100dvh";
      panel.style.borderRadius  = "0";
      panel.style.maxHeight     = "100dvh";

      head.style.position       = "relative";
      head.style.flexDirection  = "column";
      head.style.alignItems     = "flex-start";
      head.style.padding        = "10px 14px";
      head.style.gap            = "6px";

      titleWrap.style.flexDirection = "column";
      titleWrap.style.alignItems    = "flex-start";
      titleWrap.style.gap           = "6px";
      titleWrap.style.width         = "100%";
      titleWrap.style.paddingRight  = "80px"; // space for close button

      titleEl.style.fontSize    = "14px";
      titleEl.style.whiteSpace  = "nowrap";
      titleEl.style.overflow    = "hidden";
      titleEl.style.textOverflow = "ellipsis";
      titleEl.style.maxWidth    = "100%";

      closeBtn.style.position   = "absolute";
      closeBtn.style.top        = "10px";
      closeBtn.style.right      = "14px";
      closeBtn.style.padding    = "8px 16px";
      closeBtn.style.fontSize   = "14px";

      navWrap.style.gap         = "8px";

      body.style.padding        = "10px";
    }

    // Keyboard navigation
    overlay.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") { e.preventDefault(); prevBtn.click(); }
      if (e.key === "ArrowRight") { e.preventDefault(); nextBtn.click(); }
      if (e.key === "Escape") { overlay.style.display = "none"; }
    });
    overlay.setAttribute("tabindex", "0");
  }

  function getSelectedTextNode() {
    return selectedTextNode || null;
  }

  function bringSelectedTextToFront() {
    const node = getSelectedTextNode();
    if (!node) return;
    const z = String(Date.now());
    node.dataset.z = z;
    node.style.zIndex = z;
    showTextToolbarFor(node);
  }

  function sendSelectedTextToBack() {
    const node = getSelectedTextNode();
    if (!node) return;

    const all = Array.from(document.querySelectorAll(".dmb-editable-text, .dmb-photo-frame-object, .dmb-map-object"));
    let minZ = 1;

    all.forEach((el) => {
      if (el === node) return;
      const z = Number(el.dataset.z || el.style.zIndex || 1);
      if (!Number.isNaN(z)) minZ = Math.min(minZ, z);
    });

    const next = String(minZ - 1);
    node.dataset.z = next;
    node.style.zIndex = next;
    showTextToolbarFor(node);
  }

  function buildPreviewPageNode(pageNumber) {
    if (pageNumber === 0) {
      const coverWrap = document.createElement("div");
      coverWrap.className = "dmb-cover-preview";
      coverWrap.style.padding = "0";

      let back = $("coverBack")?.cloneNode(true);
      let spine = window.DMB_MAGAZINE_MODE ? null : ($("coverSpine")?.cloneNode(true) ?? null);
      let front = $("coverFront")?.cloneNode(true);

      if (!back || (!window.DMB_MAGAZINE_MODE && !spine) || !front) {
        // Cover not currently in DOM — temporarily render it to capture full fidelity
        // (stickers, texts, maps, logo) then restore the previous view.
        const savedMode = builderMode;
        builderMode = "cover";
        renderCoverCanvas();
        back = $("coverBack")?.cloneNode(true);
        spine = window.DMB_MAGAZINE_MODE ? null : ($("coverSpine")?.cloneNode(true) ?? null);
        front = $("coverFront")?.cloneNode(true);
        const _overlayTmp = $("coverOverlay")?.cloneNode(true);
        // Restore previous view
        builderMode = savedMode;
        if (savedMode !== "cover") renderSpread();
        // Build the preview wrapper from the temporary render and return early
        [back, spine, front].filter(Boolean).forEach(el => {
          el.style.cursor = "default";
          el.style.pointerEvents = "none";
          el.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
        });
        if (back) coverWrap.appendChild(back);
        if (spine) coverWrap.appendChild(spine);
        if (front) coverWrap.appendChild(front);
        if (_overlayTmp) {
          _overlayTmp.style.pointerEvents = "none";
          _overlayTmp.style.zIndex = "9999";
          _overlayTmp.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
          coverWrap.appendChild(_overlayTmp);
        }
        return coverWrap;
      }

      [back, spine, front].filter(Boolean).forEach(el => {
        el.style.cursor = "default";
        el.style.pointerEvents = "none";
        el.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
      });

      coverWrap.appendChild(back);
      if (spine) coverWrap.appendChild(spine);
      coverWrap.appendChild(front);
      // Include the overlay so stickers, objects, and logo appear in preview
      const _previewOverlay = $("coverOverlay")?.cloneNode(true);
      if (_previewOverlay) {
        _previewOverlay.style.pointerEvents = "none";
        _previewOverlay.style.zIndex = "9999";
        _previewOverlay.querySelectorAll('[contenteditable]').forEach(n => n.setAttribute('contenteditable', 'false'));
        coverWrap.appendChild(_previewOverlay);
      }
      return coverWrap;
    }

    return makeA4Page(pageNumber, pageNumber % 2 === 0 ? "R" : "L", true);
  }

  function openPreviewOverlay(confirmMode) {
    ensurePreviewOverlay();
    const overlay     = document.getElementById("dmbPreviewOverlay");
    const body        = document.getElementById("dmbPreviewBody");
    const prevBtn     = document.getElementById("dmbPreviewPrev");
    const nextBtn     = document.getElementById("dmbPreviewNext");
    const spreadLabel = document.getElementById("dmbPreviewSpreadLabel");
    const titleEl     = document.getElementById("dmbPreviewTitle");
    const confirmBanner = document.getElementById("dmbPreviewConfirmBanner");
    const confirmBtn    = document.getElementById("dmbPreviewConfirmBtn");
    if (!overlay || !body) return;

    // ── Confirm banner ────────────────────────────────────────────────────
    if (confirmBanner) {
      if (confirmMode) {
        confirmBanner.style.display = "flex";
        // Show a "please review" message for 4.5s before revealing the confirm button
        if (confirmBtn) confirmBtn.style.display = "none";
        const _reviewMsg = document.getElementById("dmbPreviewReviewMsg") || document.createElement("div");
        _reviewMsg.id = "dmbPreviewReviewMsg";
        _reviewMsg.className = "dmb-pv-review-msg";
        _reviewMsg.innerHTML = "✨ <strong>Almost there!</strong> Flip through every page carefully using the arrows — what you see is <em>exactly</em> what we'll print and deliver to you. Take your time! 📖";
        _reviewMsg.style.opacity = "1";
        if (!_reviewMsg.parentNode) confirmBanner.insertBefore(_reviewMsg, confirmBtn);
        setTimeout(function() {
          _reviewMsg.style.opacity = "0";
          setTimeout(function() {
            if (_reviewMsg.parentNode) _reviewMsg.remove();
            if (confirmBtn) confirmBtn.style.display = "";
          }, 600);
        }, 4500);
      } else {
        confirmBanner.style.display = "none";
      }
    }

    // Wire confirm button to the actual cart flow (only once)
    if (confirmMode && confirmBtn && !confirmBtn.dataset.wired) {
      confirmBtn.dataset.wired = "1";
      confirmBtn.addEventListener("click", () => {
        overlay.style.display = "none";
        _dmbPvRefresh = null;
        if (previewBtn) previewBtn.classList.remove("dmb-preview-needs-check");
        addDesignedBookToCart();
      });
    }

    // Preview opened — remove the "needs check" pulse from preview button
    if (previewBtn) previewBtn.classList.remove("dmb-preview-needs-check");

    // Hide all floating rotation handles — they live on document.body and would
    // otherwise show on top of the preview overlay.
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => { el.style.display = "none"; });

    // FIX 1 — flush any pending re-renders immediately (don't wait for the 2s
    // debounce).  This eliminates the staleness window: even if the customer
    // opens Preview within milliseconds of their last edit, the affected page(s)
    // start re-rendering right now and show the loading spinner until done,
    // rather than silently displaying the pre-edit cached image.
    clearTimeout(_dmbPvTimer);
    if (_dmbPvDirty.size > 0) _dmbPvRun();

    // Build spreads list: cover → page 0 → page pairs
    const totalSpreads = editor.totalSpreads || 1;
    const spreads = [{ isCover: true }, { isPage0: true }];
    for (let s = 0; s < totalSpreads; s++) {
      const left = s * 2 + 1;
      const right = s * 2 + 2;
      spreads.push({ isCover: false, isPage0: false, left, right });
    }

    let currentIdx = 0;

    // ── Helper: create a page image from the PDF cache, or a loading spinner ──
    // Each page slot: exactly half the spread container width minus half the 5px gap.
    // Using a wrapper div (not bare img) prevents the image from floating away from
    // its partner when the container is wider than the combined page widths.
    function _pvPageNode(pn) {
      const slot = document.createElement("div");
      slot.style.cssText = "flex:0 1 calc(50% - 3px);height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;";
      const url = _dmbPvCache[pn];
      if (url) {
        const img = document.createElement("img");
        img.src = url;
        img.style.cssText = "max-height:100%;max-width:100%;object-fit:contain;display:block;" +
          "box-shadow:0 4px 20px rgba(0,0,0,0.6);border-radius:2px;";
        slot.appendChild(img);
      } else {
        // Not yet rendered — schedule if needed and show loading animation
        if (!_dmbPvRendering.has(pn) && !_dmbPvDirty.has(pn)) _dmbPvMarkDirty(pn);
        slot.appendChild(_dmbPvMakeLoadingNode());
      }
      return slot;
    }

    function renderSpreadPreview(idx) {
      body.innerHTML = "";
      const s = spreads[idx];

      if (s.isCover) {
        // ── Cover: back face | spine | front face — proportional PDF images ──
        titleEl.textContent = "Preview — Cover";
        const wrap = document.createElement("div");
        wrap.style.cssText = "display:flex;flex-wrap:nowrap;gap:5px;height:100%;align-items:center;justify-content:center;max-width:100%;overflow:hidden;";
        if (_dmbPvCover) {
          const faces = window.DMB_MAGAZINE_MODE
            // Magazine: back cover | front cover (no spine strip, same left→right as book)
            ? [
                { url: _dmbPvCover.back,  label: "Back"  },
                { url: _dmbPvCover.front, label: "Front" },
              ]
            // Book: back face | spine strip | front face
            : [
                { url: _dmbPvCover.back,  label: "Back"  },
                { url: _dmbPvCover.spine, label: "Spine" },
                { url: _dmbPvCover.front, label: "Front" },
              ];
          faces.forEach(function(f) {
            const col = document.createElement("div");
            col.style.cssText = "display:flex;flex-direction:column;align-items:center;gap:5px;height:100%;max-height:100%;";
            if (f.label === "Spine") {
              col.classList.add("dmb-pv-spine-col");
              if (window.innerWidth <= 749) { col.style.display = "none"; } // hide on mobile
            }
            const img = document.createElement("img");
            img.src = f.url;
            img.style.cssText = "max-height:calc(100% - 20px);width:auto;object-fit:contain;display:block;" +
              "box-shadow:0 4px 20px rgba(0,0,0,0.6);border-radius:2px;";
            const lbl = document.createElement("div");
            lbl.textContent = f.label;
            lbl.style.cssText = "color:#888;font-size:10px;letter-spacing:0.6px;text-transform:uppercase;flex-shrink:0;";
            col.appendChild(img);
            col.appendChild(lbl);
            wrap.appendChild(col);
          });
        } else {
          // Cover not rendered yet — schedule and show spinner
          if (!_dmbPvRendering.has("cover") && !_dmbPvDirty.has("cover")) _dmbPvMarkDirty("cover");
          wrap.appendChild(_dmbPvMakeLoadingNode());
        }
        body.appendChild(wrap);

      } else if (s.isPage0) {
        // ── Special inner-cover page ──────────────────────────────────────
        titleEl.textContent = "Preview — Your Special Page";
        const wrap = document.createElement("div");
        wrap.style.cssText = "display:flex;align-items:center;justify-content:center;height:100%;width:100%;";
        const node = _pvPageNode(0);
        node.style.maxWidth = "100%";
        wrap.appendChild(node);
        body.appendChild(wrap);

      } else {
        // ── Regular spread — two pages side by side with 5px gap ─────────
        const left = s.left, right = s.right;
        titleEl.textContent = "Preview — Spread " + (idx - 1);
        const wrap = document.createElement("div");
        wrap.style.cssText = "display:flex;gap:5px;align-items:stretch;height:100%;width:100%;";
        if (left  <= editor.totalPages) wrap.appendChild(_pvPageNode(left));
        if (right <= editor.totalPages) wrap.appendChild(_pvPageNode(right));
        body.appendChild(wrap);
      }

      spreadLabel.textContent = (idx + 1) + " / " + spreads.length;
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === spreads.length - 1;
    }

    if (prevBtn) {
      prevBtn.onclick = () => {
        if (currentIdx > 0) { currentIdx--; renderSpreadPreview(currentIdx); }
      };
    }
    if (nextBtn) {
      nextBtn.onclick = () => {
        if (currentIdx < spreads.length - 1) { currentIdx++; renderSpreadPreview(currentIdx); }
      };
    }

    // When a page finishes rendering in the background, refresh if it's visible
    _dmbPvRefresh = function(key) {
      const s = spreads[currentIdx];
      if (!s) return;
      let affected = false;
      if (key === "cover" && s.isCover) affected = true;
      else if (key === 0 && s.isPage0) affected = true;
      else if (!s.isCover && !s.isPage0 && (key === s.left || key === s.right)) affected = true;
      if (affected) renderSpreadPreview(currentIdx);
    };

    // Keyboard: attach to overlay
    overlay.onkeydown = (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowUp") { e.preventDefault(); if (currentIdx > 0) { currentIdx--; renderSpreadPreview(currentIdx); } }
      if (e.key === "ArrowRight" || e.key === "ArrowDown") { e.preventDefault(); if (currentIdx < spreads.length - 1) { currentIdx++; renderSpreadPreview(currentIdx); } }
      if (e.key === "Escape") { overlay.style.display = "none"; _dmbPvRefresh = null; document.querySelectorAll(".dmb-map-rot-float").forEach((el) => { el.style.display = ""; }); }
    };

    // Clear live-refresh hook when overlay closes
    overlay.querySelector && overlay.querySelector("[type=button]"); // noop — close handled via button below
    const _closeBtns = overlay.querySelectorAll("button");
    _closeBtns.forEach(function(b) {
      if (b.textContent.trim() === "Close") {
        b.onclick = function() { overlay.style.display = "none"; _dmbPvRefresh = null; document.querySelectorAll(".dmb-map-rot-float").forEach((el) => { el.style.display = ""; }); };
      }
    });

    renderSpreadPreview(0);
    overlay.style.display = "flex";
    overlay.focus();
  }

  function syncBuilderModeButtons() {
    if (coverThumbBtn) {
      coverThumbBtn.classList.toggle("active", builderMode === "cover");
    }
    const canvasToolbar = document.querySelector(".dmb-canvas-toolbar-left");
    if (canvasToolbar) canvasToolbar.style.display = (builderMode === "cover") ? "" : "none";
  }

  function activateLeftTab(key) {
    document.querySelector(`.dmb-icon-tab[data-tab="${key}"]`)?.click();
  }

  function openProjectMenuPrompt() {
    const choice = window.prompt("Type one: save / open / new", "save");
    if (!choice) return;

    const v = choice.trim().toLowerCase();

    if (v === "save") {
      saveProjectLocalWithMessage();
    } else if (v === "open") {
      openSavedProjectLocal();
    } else if (v === "new") {
      startNewProjectLocal();
    }
  }

  function initCoverZoneButtons() {
    const frontBtn = $("coverZoneFrontBtn");
    const backBtn = $("coverZoneBackBtn");
    const spineBtn = $("coverZoneSpineBtn");

    if (frontBtn) {
      frontBtn.addEventListener("click", () => {
        activeCoverZone = "front";
        markActiveCoverZone();
      });
    }

    if (backBtn) {
      backBtn.addEventListener("click", () => {
        activeCoverZone = "back";
        markActiveCoverZone();
      });
    }

    if (spineBtn) {
      spineBtn.addEventListener("click", () => {
        activeCoverZone = "spine";
        markActiveCoverZone();
      });
    }

    updateCoverZoneButtons();
  }

  function initProjectMenu() {
    const btn = $("projectMenuBtn");
    if (!btn) return;

    btn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      openProjectMenuPrompt();
    };
  }

  function openHistoryPanel() {
    if (!undoStack.length) {
      alert("No history yet.");
      return;
    }

    const lines = undoStack
      .map((s, i) => `${i + 1}. ${s.label || "Edited"}`)
      .join("\n");

    const pick = window.prompt(`History:\n\n${lines}\n\nType a number to restore that step:`, "");
    if (!pick) return;

    const idx = Number(pick);
    if (!Number.isInteger(idx) || idx < 1 || idx > undoStack.length) return;

    const target = undoStack[idx - 1];
    if (!target) return;

    editor.currentSpread = target.currentSpread;
    editor.pageSlots = cloneState(target.pageSlots);
    editor.pageRot = cloneState(target.pageRot);
    editor.pageTemplate = cloneState(target.pageTemplate);
    editor.pageFrames = cloneState(target.pageFrames);
    editor.pageFrameRot = cloneState(target.pageFrameRot);
    builderMode = target.builderMode || "pages";

    coverState.template = target.coverState?.template || "default";
    coverState.title1 = target.coverState?.title1 || "";
    coverState.title2 = target.coverState?.title2 || "";
    coverState.color = target.coverState?.color || "#ffffff";

    syncCoverInputsFromState();
    renderPhotoTray();
    renderThumbsRail();
    renderBuilderCanvas();
  }

  function initHistoryButton() {
    const btn = $("historyBtn");
    if (!btn) return;

    btn.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      openHistoryPanel();
    };
  }


  // ---------- cover editor state ----------
  const coverState = {
    template: "default",
    title1: "",
    title2: "",
    color: "#ffffff",
    imageUrl: "",
    imageFile: null,
    textStyles: {},
    // Photo grid layouts for front/back cover faces
    frontLayout: null,
    backLayout: null,
    frontFrames: {},
    backFrames: {},
    frontFrameRot: {},
    backFrameRot: {},
    frontImageUrl: "",
    backImageUrl: "",
    frontImageId: "",
    backImageId: "",
    frontImageRot: 0,
    backImageRot: 0,
    frontFrameShapes: {},
    backFrameShapes: {},
    spineImageUrl: "",
    bleedImageUrl: "",
    bleedImageId: "",
    bleedZone: "",
    bleedImageRot: 0
  };

  function getEffectiveBookTitle() {
    // Use first user-added cover text as book title
    if (Array.isArray(editor.coverUserTexts) && editor.coverUserTexts.length > 0) {
      const first = editor.coverUserTexts[0];
      const txt = (coverState.textStyles?.[first.id]?.text || "").trim();
      if (txt) return txt;
    }
    const legacy = (titleEl?.value || "").trim();
    return legacy || "Untitled";
  }

  function saveCoverDesignToStorage() {
    const templateKey = getTemplateKey();
    if (!templateKey) return;

    try {
      localStorage.setItem(`dmb_cover_design_${templateKey}`, JSON.stringify({
        template: coverState.template,
        title1: coverState.title1,
        title2: coverState.title2,
        color: coverState.color,
        textStyles: coverState.textStyles || {},
        frontLayout: coverState.frontLayout || null,
        backLayout: coverState.backLayout || null,
        frontFrames: coverState.frontFrames || {},
        backFrames: coverState.backFrames || {},
        frontFrameRot: coverState.frontFrameRot || {},
        backFrameRot: coverState.backFrameRot || {},
        frontImageUrl: coverState.frontImageUrl || "",
        backImageUrl: coverState.backImageUrl || "",
        frontImageId: coverState.frontImageId || "",
        backImageId: coverState.backImageId || "",
        frontImageRot: coverState.frontImageRot || 0,
        backImageRot: coverState.backImageRot || 0,
        frontFrameShapes: coverState.frontFrameShapes || {},
        backFrameShapes: coverState.backFrameShapes || {},
        spineImageUrl: coverState.spineImageUrl || "",
        bleedImageUrl: coverState.bleedImageUrl || "",
        bleedImageId: coverState.bleedImageId || "",
        bleedZone: coverState.bleedZone || "",
        bleedImageRot: coverState.bleedImageRot || 0
      }));
    } catch {}
  }

  function loadCoverDesignFromStorage() {
    const templateKey = getTemplateKey();
    if (!templateKey) return null;

    try {
      const raw = localStorage.getItem(`dmb_cover_design_${templateKey}`);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function applyCoverTemplate(templateId) {
    coverState.template = templateId || "default";

    const frontTitle1 = $("coverFrontTitle1");
    const frontTitle2 = $("coverFrontTitle2");
    const spineTitle1 = $("coverSpineTitle1");
    const backTitle2 = $("coverBackTitle2");
    const frontImage = $("coverFrontImage");

    if (!frontTitle1 || !frontTitle2 || !spineTitle1 || !backTitle2) return;

    // reset
    frontTitle1.style.left = "12%";
    frontTitle1.style.top = "12%";
    frontTitle1.style.width = "76%";
    frontTitle1.style.textAlign = "center";

    frontTitle2.style.left = "12%";
    frontTitle2.style.top = "24%";
    frontTitle2.style.width = "76%";
    frontTitle2.style.textAlign = "center";

    if (frontImage) {
      frontImage.style.left = "12%";
      frontImage.style.top = "34%";
      frontImage.style.width = "76%";
      frontImage.style.height = "38%";
    }

    spineTitle1.style.left = "50%";
    spineTitle1.style.top = "50%";
    spineTitle1.style.transform = "translate(-50%,-50%) rotate(-90deg)";

    backTitle2.style.left = "12%";
    backTitle2.style.top = "12%";
    backTitle2.style.width = "76%";
    backTitle2.style.textAlign = "center";

    // future templates go here
    if (templateId === "default") {
      // already default
    }

    const items = document.querySelectorAll(".cover-template-item");
    items.forEach((btn) => {
      const active = btn.getAttribute("data-template") === coverState.template;
      btn.style.borderColor = active ? "#111" : "#ddd";
      btn.style.background = active ? "#f3f3f3" : "#fff";
    });

    saveCoverDesignToStorage();
  }

  function updateCoverPreview() {
    coverState.title1 = (coverTitle1Input?.value || "").trim();
    coverState.title2 = (coverTitle2Input?.value || "").trim();
    coverState.color = (coverColorInput?.value || "#ffffff").trim() || "#ffffff";

    if (builderMode === "cover") {
      // Update background color in-place so user-added text/frames are preserved
      ["coverBack", "coverSpine", "coverFront"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.style.background = coverState.color;
      });
      // Update default title nodes in-place
      [["coverFrontTitle1", "coverBackTitle1", "coverSpineTitle1"], coverState.title1,
       ["coverFrontTitle2", "coverBackTitle2"], coverState.title2].forEach((item, i, arr) => {
        if (i % 2 === 0) {
          const ids = item;
          const val = arr[i + 1];
          ids.forEach((id) => {
            const el = document.getElementById(id);
            if (el) {
              el.textContent = val;
              el.style.display = val ? "block" : "none";
            }
          });
        }
      });
    }

    saveCoverDesignToStorage();
  }

  function initCoverDesigner() {
    const saved = loadCoverDesignFromStorage();
    if (saved) {
      coverState.template = saved.template || "default";
      coverState.title1 = saved.title1 || "";
      coverState.title2 = saved.title2 || "";
      coverState.color = saved.color || "#ffffff";
      coverState.frontLayout = saved.frontLayout || null;
      coverState.backLayout = saved.backLayout || null;
      coverState.frontFrames = saved.frontFrames || {};
      coverState.backFrames = saved.backFrames || {};
      coverState.frontFrameRot = saved.frontFrameRot || {};
      coverState.backFrameRot = saved.backFrameRot || {};
      coverState.frontImageUrl = saved.frontImageUrl || "";
      coverState.backImageUrl = saved.backImageUrl || "";
      coverState.frontImageId = saved.frontImageId || "";
      coverState.backImageId = saved.backImageId || "";
      coverState.frontImageRot = saved.frontImageRot || 0;
      coverState.backImageRot = saved.backImageRot || 0;
      coverState.frontFrameShapes = saved.frontFrameShapes || {};
      coverState.backFrameShapes = saved.backFrameShapes || {};
      coverState.spineImageUrl = saved.spineImageUrl || "";
      coverState.bleedImageUrl = saved.bleedImageUrl || "";
      coverState.bleedImageId = saved.bleedImageId || "";
      coverState.bleedZone = saved.bleedZone || "";
      coverState.bleedImageRot = saved.bleedImageRot || 0;
    }

    if (coverTitle1Input && !coverTitle1Input.value) coverTitle1Input.value = coverState.title1;
    if (coverTitle2Input && !coverTitle2Input.value) coverTitle2Input.value = coverState.title2;
    if (coverColorInput) coverColorInput.value = coverState.color;

    // Cover template modal
    const _ctModal = document.getElementById("dmbCoverTemplateModal");
    const _ctClose = document.getElementById("dmbCoverTemplateModalClose");

    if (chooseCoverTemplateBtn && _ctModal) {
      chooseCoverTemplateBtn.addEventListener("click", (e) => {
        e.preventDefault();
        _ctModal.style.display = "flex";
      });
    }
    if (_ctClose && _ctModal) {
      _ctClose.addEventListener("click", () => { _ctModal.style.display = "none"; });
    }
    if (_ctModal) {
      _ctModal.addEventListener("click", (e) => {
        if (e.target === _ctModal) _ctModal.style.display = "none";
      });
    }

    document.querySelectorAll(".cover-template-item").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const templateId = btn.getAttribute("data-template") || "default";
        applyCoverTemplate(templateId);
        if (_ctModal) _ctModal.style.display = "none";
        updateCoverPreview();
      });
    });

    const chooseCoverLayoutBtn = $("chooseCoverLayoutBtn");
    if (chooseCoverLayoutBtn) {
      chooseCoverLayoutBtn.addEventListener("click", (e) => {
        e.preventDefault();
        // Use the currently active cover zone (front/back) — spine doesn't support layouts
        const zone = (activeCoverZone === "back") ? "back" : "front";
        showLayoutsForCoverZone(zone);
      });
    }

    if (coverTitle1Input) {
      coverTitle1Input.addEventListener("input", updateCoverPreview);
    }
    if (coverTitle2Input) {
      coverTitle2Input.addEventListener("input", updateCoverPreview);
    }

    if (coverColorSwatch && coverColorInput) {
      coverColorSwatch.addEventListener("click", (e) => {
        e.preventDefault();
        coverColorInput.click();
      });

      coverColorInput.addEventListener("input", () => {
        coverColorSwatch.style.background = coverColorInput.value || "#ffffff";
        updateCoverPreview();
      });

      coverColorInput.addEventListener("change", () => {
        coverColorSwatch.style.background = coverColorInput.value || "#ffffff";
        updateCoverPreview();
      });

      coverColorSwatch.style.background = coverColorInput.value || "#ffffff";
    } else if (coverColorInput) {
      coverColorInput.addEventListener("input", updateCoverPreview);
      coverColorInput.addEventListener("change", updateCoverPreview);
    }

    if (coverImageInput) {
      coverImageInput.addEventListener("change", () => {
        const file = coverImageInput.files && coverImageInput.files[0];
        if (!file) {
          coverState.imageFile = null;
          coverState.imageUrl = "";
          updateCoverPreview();
          return;
        }

        coverState.imageFile = file;
        try {
          if (coverState.imageUrl && coverState.imageUrl.startsWith("blob:")) {
            URL.revokeObjectURL(coverState.imageUrl);
          }
        } catch {}

        coverState.imageUrl = URL.createObjectURL(file);
        updateCoverPreview();
      });
    }

    applyCoverTemplate(coverState.template);
    updateCoverPreview();
  }

  // ---------- page template helpers ----------
  function getActiveDesignSurface() {
    return document.querySelector(".dmb-page.is-active .dmb-page-inner")
        || document.querySelector(".dmb-page.is-active")
        || document.getElementById("spreadCanvas");
  }

  /* ── MAP COUNTRY LIST ── */
  const DMB_COUNTRY_KEYS = [
    "afghanistan","albania","andorra","angola","argentina","armenia","australia",
    "austria","azerbaijan","bahamas","bahrain","bangladesh","belarus","belgium",
    "bermuda","bhutan","bolivia","bosnia-herzegovina-2","botswana","brazil",
    "brunei-darussalam","bulgaria","burkina-faso","burundi","cambodia","cameroon",
    "canada","cape-verde","central-african-republic","chad","chile","china",
    "colombia","congo","congo-dr","costa-rica","croatia","cuba","cyprus",
    "czech-republic","denmark","djibouti","dominican-republic","ecuador","egypt",
    "el-salvador","estonia","eswatini","ethiopia","finland","france","georgia",
    "germany","ghana","greece","guatemala","guinea","haiti","honduras","hong-kong",
    "hungary","iceland","india","indonesia","iran","iraq","ireland",
    "italy","ivory-coast","jamaica","japan","kazakhstan","kenya","kosovo",
    "kyrgyzstan","laos","latvia","lesotho","liechtenstein","lithuania","luxembourg",
    "macedonia","malaysia","mali","malta","mexico","moldova","montenegro","morocco",
    "mozambique","myanmar","namibia","nepal","netherlands","new-zealand","nicaragua",
    "nigeria","norway","oman","pakistan","palestine","panama","papua","paraguay",
    "peru","philippines","poland","portugal","puerto-rico","qatar","romania",
    "russia","rwanda","san-marino","saudi-arabia","serbia","sierra-leone",
    "singapore","slovakia","slovenia","south-africa","south-korea","spain",
    "sri-lanka","sudan","sweden","switzerland","syria","taiwan","tajikistan",
    "tanzania","thailand","trinidad-and-tobago","turkey","uganda","ukraine",
    "united-arab-emirates","united-kingdom","uruguay","usa","uzbekistan",
    "venezuela","vietnam","vietnam-with-islands","yemen","zambia","zimbabwe"
  ];

  function dmbKeyToName(key) {
    const overrides = {
      "bosnia-herzegovina-2": "Bosnia & Herzegovina",
      "brunei-darussalam": "Brunei",
      "cape-verde": "Cabo Verde",
      "central-african-republic": "Central African Republic",
      "congo-dr": "Congo (DR)",
      "costa-rica": "Costa Rica",
      "czech-republic": "Czech Republic",
      "dominican-republic": "Dominican Republic",
      "el-salvador": "El Salvador",
      "hong-kong": "Hong Kong",
      "ivory-coast": "Côte d'Ivoire",
      "new-zealand": "New Zealand",
      "papua": "Papua New Guinea",
      "puerto-rico": "Puerto Rico",
      "san-marino": "San Marino",
      "saudi-arabia": "Saudi Arabia",
      "sierra-leone": "Sierra Leone",
      "south-africa": "South Africa",
      "south-korea": "South Korea",
      "sri-lanka": "Sri Lanka",
      "trinidad-and-tobago": "Trinidad & Tobago",
      "united-arab-emirates": "United Arab Emirates",
      "united-kingdom": "United Kingdom",
      "usa": "United States",
      "vietnam-with-islands": "Vietnam (with Islands)",
      "burkina-faso": "Burkina Faso",
      "eswatini": "Eswatini (Swaziland)",
    };
    return overrides[key] || key.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  }

  /* ── MAP MODAL STATE ── */
  let dmbModalSelectedKey = null;
  let dmbModalSvgCache = {};

  function dmbGetAssetUrl(filename) {
    const base = (window.DMB_ASSET_BASE || "").replace(/\/[^/]+$/, "/");
    return base + filename;
  }

  function dmbGetModalStyles() {
    return {
      fill: document.getElementById("dmbMapFill")?.value || "#d9d9d9",
      stroke: document.getElementById("dmbMapStroke")?.value || "#111111",
      strokeWidth: parseFloat(document.getElementById("dmbMapStrokeWidth")?.value ?? 1.2),
      strokeDasharray: document.getElementById("dmbMapStrokeStyle")?.value || "",
      opacity: parseFloat(document.getElementById("dmbMapOpacity")?.value ?? 1),
      showOutline: document.getElementById("dmbMapShowOutline")?.checked || false,
      hideProvinces: document.getElementById("dmbMapHideProvinces")?.checked || false,
      transparentFill: document.getElementById("dmbMapTransparentFill")?.checked || false,
    };
  }

  function dmbEnsureOutlineFilter(svgEl, strokeColor, strokeWidth, filterId, hollowCenter) {
    const ns = "http://www.w3.org/2000/svg";
    let defs = svgEl.querySelector("defs");
    if (!defs) {
      defs = document.createElementNS(ns, "defs");
      svgEl.insertBefore(defs, svgEl.firstChild);
    }
    const old = defs.querySelector("#" + filterId);
    if (old) old.remove();

    const filter = document.createElementNS(ns, "filter");
    filter.id = filterId;
    filter.setAttribute("x", "-20%");
    filter.setAttribute("y", "-20%");
    filter.setAttribute("width", "140%");
    filter.setAttribute("height", "140%");

    // Step 1: dilate the combined silhouette
    const morph = document.createElementNS(ns, "feMorphology");
    morph.setAttribute("operator", "dilate");
    morph.setAttribute("radius", String(Math.max(0.5, strokeWidth || 1.2)));
    morph.setAttribute("in", "SourceAlpha");
    morph.setAttribute("result", "dilated");

    // Step 2: subtract original silhouette → outer ring only
    const ring = document.createElementNS(ns, "feComposite");
    ring.setAttribute("in", "dilated");
    ring.setAttribute("in2", "SourceAlpha");
    ring.setAttribute("operator", "out");
    ring.setAttribute("result", "ring");

    // Step 3: flood with stroke color
    const flood = document.createElementNS(ns, "feFlood");
    flood.setAttribute("flood-color", strokeColor || "#111111");
    flood.setAttribute("result", "color");

    // Step 4: clip color to ring shape
    const comp = document.createElementNS(ns, "feComposite");
    comp.setAttribute("in", "color");
    comp.setAttribute("in2", "ring");
    comp.setAttribute("operator", "in");
    comp.setAttribute("result", "coloredRing");

    if (hollowCenter) {
      // Output: ring only, interior transparent (used with transparent fill)
      filter.append(morph, ring, flood, comp);
    } else {
      // Output: original map content + outer ring drawn on top
      const merge = document.createElementNS(ns, "feMerge");
      const mn1 = document.createElementNS(ns, "feMergeNode");
      mn1.setAttribute("in", "SourceGraphic");
      const mn2 = document.createElementNS(ns, "feMergeNode");
      mn2.setAttribute("in", "coloredRing");
      merge.appendChild(mn1);
      merge.appendChild(mn2);
      filter.append(morph, ring, flood, comp, merge);
    }

    defs.appendChild(filter);
  }

  function dmbApplyStylesToSvg(svgEl, styles) {
    const effectiveFill = styles.transparentFill ? "none" : (styles.fill || "#d9d9d9");
    // When showOutline is active with transparent fill, paths still need an opaque fill
    // so SourceAlpha can capture the country silhouette. The filter hides the fill visually.
    const silhouetteFill = styles.fill || "#d9d9d9";
    const pathFill = (styles.showOutline && styles.transparentFill) ? silhouetteFill : effectiveFill;

    const filterId = styles.filterId || "dmbOutlineFilter";
    const g = svgEl.querySelector(":scope > g") || svgEl;

    if (styles.showOutline) {
      dmbEnsureOutlineFilter(svgEl, styles.stroke, styles.strokeWidth, filterId, !!styles.transparentFill);
      g.setAttribute("filter", "url(#" + filterId + ")");
    } else {
      g.removeAttribute("filter");
      svgEl.removeAttribute("filter");
    }

    svgEl.style.opacity = styles.opacity != null ? String(styles.opacity) : "1";

    svgEl.querySelectorAll("path").forEach((path) => {
      path.style.fill = pathFill;
      path.style.stroke = styles.hideProvinces ? pathFill : (styles.stroke || "#111111");
      path.style.strokeWidth = styles.hideProvinces ? "1" : (styles.strokeWidth || 1.2);
      path.style.strokeDasharray = styles.hideProvinces ? "" : (styles.strokeDasharray || "");
      path.style.opacity = "";
      path.style.vectorEffect = "non-scaling-stroke";
    });
  }

  function dmbUpdateModalPreview() {
    const preview = document.getElementById("dmbMapPreview");
    if (!preview) return;
    const svgEl = preview.querySelector("svg");
    if (!svgEl) return;
    dmbApplyStylesToSvg(svgEl, dmbGetModalStyles());
  }

  async function dmbSelectCountry(key) {
    dmbModalSelectedKey = key;

    /* highlight selected row */
    document.querySelectorAll(".dmb-country-item").forEach(el => el.classList.toggle("dmb-country-item--active", el.dataset.key === key));

    const preview = document.getElementById("dmbMapPreview");
    const insertBtn = document.getElementById("dmbMapInsertBtn");
    if (!preview) return;

    preview.innerHTML = '<span class="dmb-map-preview-placeholder">Loading…</span>';

    try {
      if (!dmbModalSvgCache[key]) {
        const url = dmbGetAssetUrl("dmb-map-" + key + ".svg");
        const res = await fetch(url);
        if (!res.ok) throw new Error("Not found");
        dmbModalSvgCache[key] = await res.text();
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(dmbModalSvgCache[key], "image/svg+xml");
      const svgEl = doc.querySelector("svg");
      if (!svgEl) throw new Error("No SVG element");

      svgEl.removeAttribute("width");
      svgEl.removeAttribute("height");
      svgEl.style.width = "100%";
      svgEl.style.height = "100%";
      svgEl.style.display = "block";

      dmbApplyStylesToSvg(svgEl, dmbGetModalStyles());

      preview.innerHTML = "";
      preview.appendChild(svgEl);

      if (insertBtn) insertBtn.disabled = false;
    } catch (e) {
      preview.innerHTML = '<span class="dmb-map-preview-placeholder">Preview unavailable</span>';
    }
  }

  function dmbBuildCountryList(filter) {
    const list = document.getElementById("dmbCountryList");
    if (!list) return;
    const q = (filter || "").toLowerCase().trim();
    list.innerHTML = "";
    DMB_COUNTRY_KEYS.forEach((key) => {
      const name = dmbKeyToName(key);
      if (q && !name.toLowerCase().includes(q) && !key.includes(q)) return;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-country-item";
      btn.dataset.key = key;
      btn.textContent = name;
      if (key === dmbModalSelectedKey) btn.classList.add("dmb-country-item--active");
      btn.addEventListener("click", () => dmbSelectCountry(key));
      list.appendChild(btn);
    });
  }

  function dmbOpenMapModal() {
    const modal = document.getElementById("dmbMapModal");
    if (!modal) return;
    dmbModalSelectedKey = null;
    const preview = document.getElementById("dmbMapPreview");
    if (preview) preview.innerHTML = '<span class="dmb-map-preview-placeholder">Select a country to preview</span>';
    const insertBtn = document.getElementById("dmbMapInsertBtn");
    if (insertBtn) insertBtn.disabled = true;
    const search = document.getElementById("dmbMapSearch");
    if (search) search.value = "";
    const ooModal = document.getElementById("dmbMapShowOutline");
    if (ooModal) ooModal.checked = false;
    const hpModal = document.getElementById("dmbMapHideProvinces");
    if (hpModal) hpModal.checked = false;
    const tfModal = document.getElementById("dmbMapTransparentFill");
    if (tfModal) tfModal.checked = false;
    dmbBuildCountryList("");
    modal.style.display = "flex";
  }

  function dmbCloseMapModal() {
    const modal = document.getElementById("dmbMapModal");
    if (modal) modal.style.display = "none";
  }

  function initMapModal() {
    const modal = document.getElementById("dmbMapModal");
    if (!modal || modal.dataset.dmbModalInit) return;
    modal.dataset.dmbModalInit = "1";

    document.getElementById("dmbMapModalClose")?.addEventListener("click", dmbCloseMapModal);
    modal.querySelector(".dmb-map-modal-backdrop")?.addEventListener("click", dmbCloseMapModal);

    document.getElementById("dmbMapSearch")?.addEventListener("input", (e) => {
      dmbBuildCountryList(e.target.value);
    });

    /* style controls → live preview update */
    ["dmbMapFill","dmbMapStroke","dmbMapStrokeWidth","dmbMapStrokeStyle","dmbMapOpacity","dmbMapShowOutline","dmbMapHideProvinces","dmbMapTransparentFill"].forEach((id) => {
      document.getElementById(id)?.addEventListener("change", () => dmbUpdateModalPreview());
      document.getElementById(id)?.addEventListener("input", () => {
        const wv = document.getElementById("dmbMapStrokeWidthVal");
        if (wv) wv.textContent = document.getElementById("dmbMapStrokeWidth")?.value;
        const ov = document.getElementById("dmbMapOpacityVal");
        if (ov) ov.textContent = Math.round(parseFloat(document.getElementById("dmbMapOpacity")?.value) * 100) + "%";
        dmbUpdateModalPreview();
      });
    });

    document.getElementById("dmbMapInsertBtn")?.addEventListener("click", () => {
      if (!dmbModalSelectedKey || !dmbModalSvgCache[dmbModalSelectedKey]) return;
      const styles = dmbGetModalStyles();
      const svgMarkup = dmbModalSvgCache[dmbModalSelectedKey];

      const doInsert = (finalSvg) => {
        if (window.insertMapIntoActivePage) {
          window.insertMapIntoActivePage(finalSvg, dmbModalSelectedKey, styles);
        }
        dmbCloseMapModal();
        const markStayBtn = document.getElementById("markStayBtn");
        if (markStayBtn) markStayBtn.style.display = "inline-flex";
      };

      const islands = dmbFindIslandPaths(svgMarkup);
      if (islands.length > 0) {
        showChoiceDialog(
          "Islands detected",
          `This map has ${islands.length} island(s) that appear separate from the main landmass. Include them?`,
          [
            { id: "yes", label: "Yes, include islands" },
            { id: "no", label: "No, main landmass only" }
          ]
        ).then(choice => {
          if (!choice) return;
          doInsert(choice === "no" ? dmbRemoveIslandPaths(svgMarkup, islands) : svgMarkup);
        });
      } else {
        doInsert(svgMarkup);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.style.display !== "none") dmbCloseMapModal();
    });
  }

  /* ── MAP EDIT BAR (floating, shown when a placed map is clicked) ── */
  let dmbEditingMapObj = null;
  let dmbEditingMapEl = null;
  let dmbEditBarUndoTimer = null;

  /* ── SHAPE EDIT BAR (floating, shown when a placed shape is clicked) ──
   * WARNING: Keep dmbEditingShapeObj/El in sync with the edit bar. Any
   * function that opens a different toolbar (text, map, frame) must call
   * dmbCloseShapeEditBar() so only one floating bar is ever visible.
   * ────────────────────────────────────────────────────────────────────── */
  let dmbEditingShapeObj = null;
  let dmbEditingShapeEl  = null;
  let _dmbShapeBarInit   = false;  // guard so we only wire bar events once
  let _dmbLineModeActive = false;  // true while waiting for a two-point line drag

  function dmbApplyEditBarToObj() {
    if (!dmbEditingMapObj || !dmbEditingMapEl) return;
    const fill = document.getElementById("dmbEditFill")?.value || "#d9d9d9";
    const stroke = document.getElementById("dmbEditStroke")?.value || "#111111";
    const strokeWidth = parseFloat(document.getElementById("dmbEditWidth")?.value ?? 1.2);
    const strokeDasharray = document.getElementById("dmbEditStrokeStyle")?.value || "";
    const opacity = parseFloat(document.getElementById("dmbEditOpacity")?.value ?? 1);
    const showOutline = document.getElementById("dmbEditShowOutline")?.checked || false;
    const hideProvinces = document.getElementById("dmbEditHideProvinces")?.checked || false;
    const transparentFill = document.getElementById("dmbEditTransparentFill")?.checked || false;

    dmbEditingMapObj.fill = fill;
    dmbEditingMapObj.stroke = stroke;
    dmbEditingMapObj.strokeWidth = strokeWidth;
    dmbEditingMapObj.strokeDasharray = strokeDasharray;
    dmbEditingMapObj.opacity = opacity;
    dmbEditingMapObj.showOutline = showOutline;
    dmbEditingMapObj.hideProvinces = hideProvinces;
    dmbEditingMapObj.transparentFill = transparentFill;

    const wv = document.getElementById("dmbEditWidthVal");
    if (wv) wv.textContent = strokeWidth;
    const ov = document.getElementById("dmbEditOpacityVal");
    if (ov) ov.textContent = Math.round(opacity * 100) + "%";

    const svgEl = dmbEditingMapEl.querySelector("svg");
    if (svgEl) dmbApplyStylesToSvg(svgEl, { fill, stroke, strokeWidth, strokeDasharray, opacity, showOutline, hideProvinces, transparentFill, filterId: dmbEditingMapObj.filterId });

    // Debounce undo so rapid slider drags collapse into one undo step
    clearTimeout(dmbEditBarUndoTimer);
    dmbEditBarUndoTimer = setTimeout(() => { pushUndoState("Edit Map Style"); }, 600);
  }

  function dmbOpenEditBar(obj, el) {
    hideTextToolbar();
    hideFrameToolbar();
    dmbCloseShapeEditBar(); // close shape bar when map bar opens
    // Deselect any previously selected map
    document.querySelectorAll(".dmb-map-object.dmb-selected").forEach((m) => {
      if (m !== el) {
        m.classList.remove("dmb-selected");
        m._dmbRotHandle?.style && (m._dmbRotHandle.style.display = "none");
      }
    });

    dmbEditingMapObj = obj;
    dmbEditingMapEl = el;
    el.classList.add("dmb-selected");
    // Show rotation handle if stored
    if (el._dmbRotHandle) el._dmbRotHandle.style.display = "";

    const bar = document.getElementById("dmbMapEditBar");
    if (!bar) return;

    document.getElementById("dmbEditFill").value = obj.fill || "#d9d9d9";
    document.getElementById("dmbEditStroke").value = obj.stroke || "#111111";
    document.getElementById("dmbEditWidth").value = obj.strokeWidth ?? 1.2;
    document.getElementById("dmbEditWidthVal").textContent = obj.strokeWidth ?? 1.2;
    document.getElementById("dmbEditStrokeStyle").value = obj.strokeDasharray || "";
    document.getElementById("dmbEditOpacity").value = obj.opacity ?? 1;
    document.getElementById("dmbEditOpacityVal").textContent = Math.round((obj.opacity ?? 1) * 100) + "%";
    const ooEl = document.getElementById("dmbEditShowOutline");
    if (ooEl) ooEl.checked = obj.showOutline || false;
    const hpEl = document.getElementById("dmbEditHideProvinces");
    if (hpEl) hpEl.checked = obj.hideProvinces || false;
    const tfEl = document.getElementById("dmbEditTransparentFill");
    if (tfEl) tfEl.checked = obj.transparentFill || false;

    // Update contain button text
    const _mcBtn = document.getElementById("dmbMapContainBtn");
    if (_mcBtn) _mcBtn.textContent = _dmbContainBtnText(obj, !!el.closest(".dmb-cover-preview"));

    /* position bar above the map element */
    bar.style.display = "block"; // show first so offsetHeight/offsetWidth are accurate
    const rect = el.getBoundingClientRect();
    const mapBarW = bar.offsetWidth || 300;
    const mapBarH = bar.offsetHeight || 80;
    bar.style.top = Math.max(8, rect.top - mapBarH - 8) + "px";
    bar.style.left = Math.max(8, Math.min(rect.left, window.innerWidth - mapBarW - 8)) + "px";
  }

  function dmbCloseEditBar() {
    const bar = document.getElementById("dmbMapEditBar");
    if (bar) bar.style.display = "none";
    if (dmbEditingMapEl) {
      dmbEditingMapEl.classList.remove("dmb-selected");
      if (dmbEditingMapEl._dmbRotHandle) dmbEditingMapEl._dmbRotHandle.style.display = "none";
    }
    dmbEditingMapObj = null;
    dmbEditingMapEl = null;
  }

  function initMapEditBar() {
    const bar = document.getElementById("dmbMapEditBar");
    if (!bar || bar.dataset.dmbBarInit) return;
    bar.dataset.dmbBarInit = "1";

    ["dmbEditFill","dmbEditStroke","dmbEditWidth","dmbEditStrokeStyle","dmbEditOpacity","dmbEditShowOutline","dmbEditHideProvinces","dmbEditTransparentFill"].forEach((id) => {
      document.getElementById(id)?.addEventListener("input", dmbApplyEditBarToObj);
      document.getElementById(id)?.addEventListener("change", dmbApplyEditBarToObj);
    });

    document.getElementById("dmbEditDone")?.addEventListener("click", dmbCloseEditBar);

    // Contain-to-page button
    document.getElementById("dmbMapContainBtn")?.addEventListener("click", () => {
      if (!dmbEditingMapObj || !dmbEditingMapEl) return;
      const _isCover = !!dmbEditingMapEl.closest(".dmb-cover-preview");
      _dmbContainCycle(dmbEditingMapObj, dmbEditingMapEl, _isCover);
    });

    ["left", "center", "right"].forEach(function(align) {
      const btnId = { left: "dmbEditAlignLeft", center: "dmbEditAlignCenter", right: "dmbEditAlignRight" }[align];
      document.getElementById(btnId)?.addEventListener("click", () => {
        if (!dmbEditingMapObj || !dmbEditingMapEl) return;
        const tType = dmbEditingMapEl.closest(".dmb-cover-preview") ? "cover" : "page";
        dmbAlignObjectInZone(dmbEditingMapEl, dmbEditingMapObj, align, tType);
        // Reposition bar after alignment
        const rect = dmbEditingMapEl.getBoundingClientRect();
        const b = document.getElementById("dmbMapEditBar");
        if (b) {
          const bW = b.offsetWidth || 300;
          b.style.top = Math.max(8, rect.top - b.offsetHeight - 8) + "px";
          b.style.left = Math.max(8, Math.min(rect.left, window.innerWidth - bW - 8)) + "px";
        }
      });
    });

    document.getElementById("dmbEditFrontBtn")?.addEventListener("click", () => {
      if (!dmbEditingMapObj || !dmbEditingMapEl) return;
      pushUndoState("Bring Map to Front");
      const z = String(Date.now());
      dmbEditingMapObj.z = z;
      dmbEditingMapEl.style.zIndex = z;
      dmbEditingMapEl.dataset.z = z;
    });

    document.getElementById("dmbEditBackBtn")?.addEventListener("click", () => {
      if (!dmbEditingMapObj || !dmbEditingMapEl) return;
      pushUndoState("Send Map to Back");
      const all = Array.from(document.querySelectorAll(".dmb-editable-text, .dmb-photo-frame-object, .dmb-map-object"));
      let minZ = 0;
      all.forEach((el) => {
        if (el === dmbEditingMapEl) return;
        const z = Number(el.dataset.z || el.style.zIndex || 1);
        if (!Number.isNaN(z)) minZ = Math.min(minZ, z);
      });
      const next = String(minZ - 1);
      dmbEditingMapObj.z = next;
      dmbEditingMapEl.style.zIndex = next;
      dmbEditingMapEl.dataset.z = next;
    });

    document.getElementById("dmbEditDelete")?.addEventListener("click", () => {
      if (!dmbEditingMapObj) return;
      const objId = dmbEditingMapObj.id;
      if (editor.pageObjects) {
        Object.keys(editor.pageObjects).forEach((p) => {
          const arr = editor.pageObjects[p];
          if (Array.isArray(arr)) {
            const idx = arr.findIndex((o) => o.id === objId);
            if (idx !== -1) arr.splice(idx, 1);
          }
        });
      }
      if (Array.isArray(editor.coverObjects)) {
        const idx = editor.coverObjects.findIndex((o) => o.id === objId);
        if (idx !== -1) editor.coverObjects.splice(idx, 1);
      }
      dmbCloseEditBar();
      if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    });

    // Close edit bar when pointer lands outside both the bar and any map object.
    // Use capture so stopPropagation on stickers/frames/text doesn't prevent this.
    document.addEventListener("pointerdown", (e) => {
      if (!dmbEditingMapObj) return;
      const bar = document.getElementById("dmbMapEditBar");
      if (bar && bar.contains(e.target)) return; // clicked inside edit bar
      if (e.target.closest(".dmb-map-object")) return; // clicked on a map
      dmbCloseEditBar();
    }, { capture: true });
  }

  /* ══════════════════════════════════════════════════════════════════════
     SHAPE EDIT BAR — open / close / apply / init
     WARNING: All changes to shape appearance must go through dmbApplyShapeEditBar.
     Do NOT update obj.fill/stroke/etc. from anywhere else — always update the
     bar controls first then call dmbApplyShapeEditBar() so the SVG stays in sync.
     ══════════════════════════════════════════════════════════════════════ */

  // Return SVG string for a given shape type + style properties.
  // viewBox 0 0 100 100; caller wraps in a div of the desired pixel size.
  function buildShapeSvg(shapeType, fill, stroke, strokeWidth, opacity, cornerRadius) {
    const f  = fill        || "#6366f1";
    const s  = stroke      || "transparent";
    const sw = strokeWidth || 0;
    const op = (opacity !== undefined && opacity !== null) ? opacity : 1;
    const half = sw / 2;
    // vector-effect="non-scaling-stroke" on every inner element:
    // With preserveAspectRatio="none", the X and Y scales differ for non-square shapes,
    // making stroke-width render thicker on one axis than the other. non-scaling-stroke
    // keeps the stroke exactly `sw` screen-pixels wide on ALL sides regardless of shape
    // aspect ratio — perfectly uniform borders every time.
    const vens = `vector-effect="non-scaling-stroke"`;
    let inner = "";
    switch (shapeType) {
      case "rect":
        // stroke-linejoin="miter" → sharp 90° outer stroke corners (not rounded)
        inner = `<rect x="${half}" y="${half}" width="${100 - sw}" height="${100 - sw}" rx="0" ry="0" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="miter" ${vens}/>`;
        break;
      case "rounded-rect": {
        // cx clamped 0-50: 50 = perfect semicircle; stored as viewBox % of 0-100 space
        const _cr = Math.max(0, Math.min(50, (cornerRadius !== undefined && cornerRadius !== null) ? cornerRadius : 12));
        inner = `<rect x="${half}" y="${half}" width="${100 - sw}" height="${100 - sw}" rx="${_cr}" ry="${_cr}" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      }
      case "circle":
        inner = `<ellipse cx="50" cy="50" rx="${50 - half}" ry="${50 - half}" fill="${f}" stroke="${s}" stroke-width="${sw}" ${vens}/>`;
        break;
      case "triangle":
        inner = `<polygon points="50,${half} ${100-half},${100-half} ${half},${100-half}" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "star":
        inner = `<polygon points="50,2 61.8,33.8 95.6,35.2 69,56.2 78.2,88.8 50,70 21.8,88.8 31,56.2 4.4,35.2 38.2,33.8" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "heart":
        inner = `<path d="M50,85 C20,70 5,55 5,38 C5,22 16,10 28,10 C36,10 44,15 50,22 C56,15 64,10 72,10 C84,10 95,22 95,38 C95,55 80,70 50,85 Z" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "arrow":
        inner = `<polygon points="5,35 60,35 60,15 95,50 60,85 60,65 5,65" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "pentagon":
        inner = `<polygon points="50,2 95.6,35.2 78.2,88.8 21.8,88.8 4.4,35.2" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "hexagon":
        inner = `<polygon points="98,50 74,91.6 26,91.6 2,50 26,8.4 74,8.4" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      case "line":
        inner = `<rect x="0" y="0" width="100" height="100" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
        break;
      default:
        inner = `<rect x="0" y="0" width="100" height="100" fill="${f}" stroke="${s}" stroke-width="${sw}" stroke-linejoin="round" ${vens}/>`;
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%" preserveAspectRatio="none" style="display:block;opacity:${op};">${inner}</svg>`;
  }

  // Draw a shape on a Canvas 2D context at (dx,dy,dw,dh) — used for PDF rendering.
  // ctx should already be saved/translated/rotated by the caller.
  function drawShapeOnCanvas(ctx, shapeType, fill, stroke, strokeWidth, dw, dh, cornerRadius) {
    const f  = fill        || "#6366f1";
    const s  = (strokeWidth && strokeWidth > 0) ? (stroke || "#000") : "transparent";
    const sw = strokeWidth || 0;
    const _isRectLike = shapeType === "rect" || shapeType === "line" || shapeType === "rounded-rect";
    ctx.save();
    // Scale so shape coords 0..100 map to dw x dh
    ctx.scale(dw / 100, dh / 100);
    ctx.beginPath();
    switch (shapeType) {
      case "rect":
        // Fill the full rect; stroke drawn separately in screen coords below so it is
        // uniform on all sides (matches SVG vector-effect="non-scaling-stroke" in builder).
        ctx.rect(0, 0, 100, 100);
        break;
      case "rounded-rect": {
        // cornerRadius is in 0-100 viewBox %, clamped 0-50; scale to match SVG rx/ry
        const _crV = Math.max(0, Math.min(50, (cornerRadius !== undefined && cornerRadius !== null) ? cornerRadius : 12));
        // In the scaled context (0..100 → dw×dh), draw the fill path using the same
        // viewBox radius. SVG clips rx/ry to half width/height automatically; canvas
        // roundRect clamps similarly, so they match.
        if (ctx.roundRect) {
          ctx.roundRect(0, 0, 100, 100, _crV);
        } else {
          ctx.rect(0, 0, 100, 100);
        }
        break;
      }
      case "circle":
        ctx.ellipse(50, 50, 50 - sw/2, 50 - sw/2, 0, 0, Math.PI * 2);
        break;
      case "triangle":
        ctx.moveTo(50, sw/2);
        ctx.lineTo(100 - sw/2, 100 - sw/2);
        ctx.lineTo(sw/2, 100 - sw/2);
        ctx.closePath();
        break;
      case "star": {
        const starPts = [[50,2],[61.8,33.8],[95.6,35.2],[69,56.2],[78.2,88.8],[50,70],[21.8,88.8],[31,56.2],[4.4,35.2],[38.2,33.8]];
        ctx.moveTo(starPts[0][0], starPts[0][1]);
        for (let i = 1; i < starPts.length; i++) ctx.lineTo(starPts[i][0], starPts[i][1]);
        ctx.closePath();
        break;
      }
      case "heart":
        ctx.moveTo(50, 85);
        ctx.bezierCurveTo(20, 70, 5, 55, 5, 38);
        ctx.bezierCurveTo(5, 22, 16, 10, 28, 10);
        ctx.bezierCurveTo(36, 10, 44, 15, 50, 22);
        ctx.bezierCurveTo(56, 15, 64, 10, 72, 10);
        ctx.bezierCurveTo(84, 10, 95, 22, 95, 38);
        ctx.bezierCurveTo(95, 55, 80, 70, 50, 85);
        ctx.closePath();
        break;
      case "arrow": {
        const arrowPts = [[5,35],[60,35],[60,15],[95,50],[60,85],[60,65],[5,65]];
        ctx.moveTo(arrowPts[0][0], arrowPts[0][1]);
        for (let i = 1; i < arrowPts.length; i++) ctx.lineTo(arrowPts[i][0], arrowPts[i][1]);
        ctx.closePath();
        break;
      }
      case "pentagon": {
        const pentPts = [[50,2],[95.6,35.2],[78.2,88.8],[21.8,88.8],[4.4,35.2]];
        ctx.moveTo(pentPts[0][0], pentPts[0][1]);
        for (let i = 1; i < pentPts.length; i++) ctx.lineTo(pentPts[i][0], pentPts[i][1]);
        ctx.closePath();
        break;
      }
      case "hexagon": {
        const hexPts = [[98,50],[74,91.6],[26,91.6],[2,50],[26,8.4],[74,8.4]];
        ctx.moveTo(hexPts[0][0], hexPts[0][1]);
        for (let i = 1; i < hexPts.length; i++) ctx.lineTo(hexPts[i][0], hexPts[i][1]);
        ctx.closePath();
        break;
      }
      case "line":
      default:
        ctx.rect(0, 0, 100, 100);
        break;
    }
    // Only fill if not transparent — canvas ignores fillStyle="none" and renders
    // black instead, so we must skip ctx.fill() entirely for outline-only shapes.
    if (f !== "none" && f !== "transparent") {
      ctx.fillStyle = f;
      ctx.fill();
    }
    // Non-rect shapes: stroke in scaled coordinates (path already built above)
    if (sw > 0 && s !== "transparent" && !_isRectLike) {
      ctx.strokeStyle = s;
      ctx.lineWidth = sw;
      ctx.lineJoin = "round";
      ctx.stroke();
    }
    ctx.restore();

    // Rect / line / rounded-rect: draw stroke in screen (pixel) coordinates so it is
    // exactly sw pixels wide on ALL sides — matching SVG vector-effect="non-scaling-stroke".
    if (sw > 0 && s !== "transparent" && _isRectLike) {
      ctx.save();
      ctx.beginPath();
      if (shapeType === "rounded-rect") {
        // Corner radius in screen pixels: same viewBox value (0-50) used directly in the
        // scaled ctx → gives the same proportional curvature as SVG rx/ry.
        // The stroke is drawn in screen coordinates so it's uniform on all sides.
        const _crV2 = Math.max(0, Math.min(50, (cornerRadius !== undefined && cornerRadius !== null) ? cornerRadius : 12));
        // Scale the viewBox radius to match the screen-coordinate stroke rect (sw/2 inset)
        const _rxPx = _crV2 * dw / 100;   // horizontal radius in screen px
        const _ryPx = _crV2 * dh / 100;   // vertical radius in screen px
        // Use DOMPoint {x,y} for elliptical corners matching SVG rx/ry exactly
        try {
          ctx.roundRect(sw / 2, sw / 2, dw - sw, dh - sw, [{x: _rxPx, y: _ryPx}]);
        } catch(e) {
          // Fallback: circular radius using min dimension (good approximation)
          const _rFallback = Math.min(_rxPx, _ryPx);
          if (ctx.roundRect) ctx.roundRect(sw / 2, sw / 2, dw - sw, dh - sw, _rFallback);
          else               ctx.rect(sw / 2, sw / 2, dw - sw, dh - sw);
        }
        ctx.lineJoin = "round";
      } else {
        ctx.rect(sw / 2, sw / 2, dw - sw, dh - sw);
        ctx.lineJoin = "miter"; // sharp 90° corners for plain rect/line
      }
      ctx.strokeStyle = s;
      ctx.lineWidth   = sw;
      ctx.stroke();
      ctx.restore();
    }
  }

  function dmbOpenShapeEditBar(obj, el) {
    // Close other floating bars so only one is visible at a time
    hideTextToolbar();
    hideFrameToolbar();
    dmbCloseEditBar();

    // Deselect previously selected shape
    document.querySelectorAll(".dmb-shape-object.dmb-selected").forEach((m) => {
      if (m !== el) {
        m.classList.remove("dmb-selected");
        if (m._dmbRotHandle) m._dmbRotHandle.style.display = "none";
      }
    });

    dmbEditingShapeObj = obj;
    dmbEditingShapeEl  = el;
    el.classList.add("dmb-selected");
    if (el._dmbRotHandle) el._dmbRotHandle.style.display = "";

    const bar = document.getElementById("dmbShapeEditBar");
    if (!bar) return;
    initShapeEditBar(); // idempotent — only wires events once

    document.getElementById("dmbShapeFill").value    = obj.fill      || "#6366f1";
    document.getElementById("dmbShapeStroke").value  = obj.stroke    || "#000000";
    document.getElementById("dmbShapeStrokeW").value = obj.strokeWidth ?? 0;
    document.getElementById("dmbShapeStrokeWVal").textContent = obj.strokeWidth ?? 0;
    document.getElementById("dmbShapeOpacity").value  = obj.opacity ?? 1;
    document.getElementById("dmbShapeOpacityVal").textContent = Math.round((obj.opacity ?? 1) * 100) + "%";
    document.getElementById("dmbShapeRotation").value = Math.round(obj.rotation || 0);

    // Show thickness slider only for line shapes; hide for all others
    const thicknessWrap = document.getElementById("dmbShapeThicknessWrap");
    const thicknessInput = document.getElementById("dmbShapeThickness");
    const thicknessVal   = document.getElementById("dmbShapeThicknessVal");
    if (thicknessWrap && thicknessInput && thicknessVal) {
      if (obj.shapeType === "line") {
        thicknessWrap.style.display = "";
        thicknessInput.value = Math.round(obj.h || 8);
        thicknessVal.textContent = Math.round(obj.h || 8) + "px";
      } else {
        thicknessWrap.style.display = "none";
      }
    }

    // Corner radius slider — only for rounded-rect
    const _crWrap  = document.getElementById("dmbShapeCornerRadiusWrap");
    const _crInput = document.getElementById("dmbShapeCornerRadius");
    const _crVal   = document.getElementById("dmbShapeCornerRadiusVal");
    if (_crWrap) {
      const _isRounded = obj.shapeType === "rounded-rect";
      _crWrap.style.display = _isRounded ? "" : "none";
      if (_isRounded && _crInput) {
        const _crCurrent = (obj.cornerRadius !== undefined && obj.cornerRadius !== null) ? obj.cornerRadius : 12;
        _crInput.value = _crCurrent;
        if (_crVal) _crVal.textContent = _crCurrent;
      }
    }

    // Outline-only toggle: hidden for lines (lines are fills by definition)
    const _outlineChk   = document.getElementById("dmbShapeOutlineOnly");
    const _fillLabelEl  = document.getElementById("dmbShapeFillLabel");
    if (_outlineChk) {
      const _isOutline = (obj.fill === "none" || obj.fill === "transparent");
      _outlineChk.checked = _isOutline;
      _outlineChk.closest("label").style.display = (obj.shapeType === "line") ? "none" : "";
      if (_fillLabelEl) _fillLabelEl.style.opacity = _isOutline ? "0.4" : "1";
    }

    // Update contain button text
    const _scBtn = document.getElementById("dmbShapeContainBtn");
    if (_scBtn) _scBtn.textContent = _dmbContainBtnText(obj, !!el.closest(".dmb-cover-preview"));

    bar.style.display = "block";
    const rect    = el.getBoundingClientRect();
    const barW    = bar.offsetWidth  || 340;
    const barH    = bar.offsetHeight || 80;
    bar.style.top  = Math.max(8, rect.top - barH - 8) + "px";
    bar.style.left = Math.max(8, Math.min(rect.left, window.innerWidth - barW - 8)) + "px";
  }

  function dmbCloseShapeEditBar() {
    const bar = document.getElementById("dmbShapeEditBar");
    if (bar) bar.style.display = "none";
    if (dmbEditingShapeEl) {
      dmbEditingShapeEl.classList.remove("dmb-selected");
      if (dmbEditingShapeEl._dmbRotHandle) dmbEditingShapeEl._dmbRotHandle.style.display = "none";
    }
    dmbEditingShapeObj = null;
    dmbEditingShapeEl  = null;
  }

  function dmbApplyShapeEditBar() {
    if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
    const obj = dmbEditingShapeObj;
    const _isOutlineOnly = document.getElementById("dmbShapeOutlineOnly")?.checked || false;
    const _fillLbl       = document.getElementById("dmbShapeFillLabel");
    // When outline-only: set fill to "none" and dim the fill picker
    obj.fill = _isOutlineOnly ? "none" : (document.getElementById("dmbShapeFill").value || "#6366f1");
    if (_fillLbl) _fillLbl.style.opacity = _isOutlineOnly ? "0.4" : "1";
    obj.stroke      = document.getElementById("dmbShapeStroke").value;
    obj.strokeWidth = parseFloat(document.getElementById("dmbShapeStrokeW").value) || 0;
    obj.opacity     = parseFloat(document.getElementById("dmbShapeOpacity").value);
    obj.rotation    = parseFloat(document.getElementById("dmbShapeRotation").value) || 0;
    // Auto-enable a default stroke when switching to outline-only with no stroke
    if (_isOutlineOnly && obj.strokeWidth < 1) {
      obj.strokeWidth = 2;
      const _swEl = document.getElementById("dmbShapeStrokeW");
      if (_swEl) _swEl.value = 2;
    }
    document.getElementById("dmbShapeStrokeWVal").textContent = obj.strokeWidth;
    document.getElementById("dmbShapeOpacityVal").textContent = Math.round(obj.opacity * 100) + "%";

    // Corner radius — only for rounded-rect
    if (obj.shapeType === "rounded-rect") {
      const _crEl  = document.getElementById("dmbShapeCornerRadius");
      const _crValEl = document.getElementById("dmbShapeCornerRadiusVal");
      if (_crEl) {
        obj.cornerRadius = Math.max(0, Math.min(50, parseInt(_crEl.value) || 12));
        if (_crValEl) _crValEl.textContent = obj.cornerRadius;
      }
    }

    // Line thickness: changing h re-centers the line vertically around its old midpoint
    if (obj.shapeType === "line") {
      const thicknessInput = document.getElementById("dmbShapeThickness");
      const thicknessVal   = document.getElementById("dmbShapeThicknessVal");
      if (thicknessInput) {
        const newH = Math.max(1, parseFloat(thicknessInput.value) || 8);
        const oldCenterY = (obj.y || 0) + (obj.h || 8) / 2;
        obj.h = newH;
        obj.y = oldCenterY - newH / 2;          // keep line centred at same Y
        dmbEditingShapeEl.style.height = newH + "px";
        dmbEditingShapeEl.style.top    = obj.y + "px";
        if (thicknessVal) thicknessVal.textContent = newH + "px";
      }
    }

    // Update the live SVG inside the shape wrapper.
    // CRITICAL: do NOT use innerHTML = ... on shWrap — it destroys the 8 resize handle
    // divs that are siblings of the SVG. Replace only the SVG element in-place.
    const _shOldSvg = dmbEditingShapeEl.querySelector("svg");
    const _shTmp    = document.createElement("div");
    _shTmp.innerHTML = buildShapeSvg(obj.shapeType, obj.fill, obj.stroke, obj.strokeWidth, obj.opacity, obj.cornerRadius);
    const _shNewSvg  = _shTmp.firstElementChild;
    if (_shOldSvg && _shNewSvg) {
      _shOldSvg.replaceWith(_shNewSvg);
    } else if (_shNewSvg) {
      dmbEditingShapeEl.prepend(_shNewSvg); // no existing SVG — add it first
    }
    dmbEditingShapeEl.style.transform = `rotate(${obj.rotation}deg)`;
  }

  function initShapeEditBar() {
    if (_dmbShapeBarInit) return;
    _dmbShapeBarInit = true;

    // Wire all shape bar controls — including dmbShapeThickness for line shapes
    // and dmbShapeCornerRadius for rounded-rect
    ["dmbShapeFill","dmbShapeStroke","dmbShapeStrokeW","dmbShapeOpacity","dmbShapeRotation","dmbShapeThickness","dmbShapeCornerRadius"].forEach((id) => {
      document.getElementById(id)?.addEventListener("input",  dmbApplyShapeEditBar);
      document.getElementById(id)?.addEventListener("change", dmbApplyShapeEditBar);
    });
    // Outline-only checkbox fires on "change" only
    document.getElementById("dmbShapeOutlineOnly")?.addEventListener("change", dmbApplyShapeEditBar);

    document.getElementById("dmbShapeDone")?.addEventListener("click", dmbCloseShapeEditBar);

    // Contain-to-page button
    document.getElementById("dmbShapeContainBtn")?.addEventListener("click", () => {
      if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
      const _isCover = !!dmbEditingShapeEl.closest(".dmb-cover-preview");
      _dmbContainCycle(dmbEditingShapeObj, dmbEditingShapeEl, _isCover);
    });

    document.getElementById("dmbShapeFrontBtn")?.addEventListener("click", () => {
      if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
      pushUndoState("Bring Shape Forward");
      const z = Date.now();
      dmbEditingShapeObj.z = z;
      dmbEditingShapeEl.style.zIndex = z;
      dmbEditingShapeEl.dataset.z    = z;
    });

    document.getElementById("dmbShapeBackBtn")?.addEventListener("click", () => {
      if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
      pushUndoState("Send Shape Backward");
      const all = Array.from(document.querySelectorAll(".dmb-editable-text, .dmb-photo-frame-object, .dmb-map-object, .dmb-sticker-object, .dmb-shape-object"));
      let minZ = 0;
      all.forEach((el) => {
        if (el === dmbEditingShapeEl) return;
        const z = Number(el.dataset.z || el.style.zIndex || 1);
        if (!Number.isNaN(z)) minZ = Math.min(minZ, z);
      });
      const next = minZ - 1;
      dmbEditingShapeObj.z = next;
      dmbEditingShapeEl.style.zIndex = next;
      dmbEditingShapeEl.dataset.z    = next;
    });

    ["left","center","right"].forEach((align) => {
      const btnId = { left:"dmbShapeAlignLeft", center:"dmbShapeAlignCenter", right:"dmbShapeAlignRight" }[align];
      document.getElementById(btnId)?.addEventListener("click", () => {
        if (!dmbEditingShapeObj || !dmbEditingShapeEl) return;
        const tType = dmbEditingShapeEl.closest(".dmb-cover-preview") ? "cover" : "page";
        dmbAlignObjectInZone(dmbEditingShapeEl, dmbEditingShapeObj, align, tType);
        const rect = dmbEditingShapeEl.getBoundingClientRect();
        const b    = document.getElementById("dmbShapeEditBar");
        if (b) {
          b.style.top  = Math.max(8, rect.top - b.offsetHeight - 8) + "px";
          b.style.left = Math.max(8, Math.min(rect.left, window.innerWidth - b.offsetWidth - 8)) + "px";
        }
      });
    });

    document.getElementById("dmbShapeDelete")?.addEventListener("click", () => {
      if (!dmbEditingShapeObj) return;
      const objId = dmbEditingShapeObj.id;
      if (editor.pageObjects) {
        Object.keys(editor.pageObjects).forEach((p) => {
          const arr = editor.pageObjects[p];
          if (Array.isArray(arr)) {
            const idx = arr.findIndex((o) => o.id === objId);
            if (idx !== -1) arr.splice(idx, 1);
          }
        });
      }
      if (Array.isArray(editor.coverObjects)) {
        const idx = editor.coverObjects.findIndex((o) => o.id === objId);
        if (idx !== -1) editor.coverObjects.splice(idx, 1);
      }
      if (dmbEditingShapeEl?._dmbRotHandle) dmbEditingShapeEl._dmbRotHandle.remove();
      dmbCloseShapeEditBar();
      if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    });

    // Close when clicking outside both the bar and any shape object
    document.addEventListener("pointerdown", (e) => {
      if (!dmbEditingShapeObj) return;
      const bar = document.getElementById("dmbShapeEditBar");
      if (bar && bar.contains(e.target))            return; // inside bar
      if (e.target.closest(".dmb-shape-object"))    return; // on a shape
      if (e.target.closest(".dmb-frame-handle"))    return; // resize handle
      dmbCloseShapeEditBar();
    }, { capture: true });
  }

  // Insert a new shape object into the currently active page/cover.
  // WARNING: Do NOT use a bare `currentPage` variable — it is not defined.
  // Use the same spread/side logic as addDefaultText and map insertion:
  //   - cover mode  → editor.coverObjects
  //   - spread -1   → page 0
  //   - otherwise   → derived from editor.currentSpread + lastToolbarSide
  function insertShapeIntoActivePage(shapeType) {
    const isCover = (builderMode === "cover");
    let pn = null;
    if (!isCover) {
      if (editor.currentSpread === -1) {
        pn = 0;
      } else {
        const _lp = editor.currentSpread * 2 + 1;
        const _rp = _lp + 1;
        if (lastToolbarSide === "right" && _rp <= editor.totalPages && !isLockedPage(_rp)) {
          pn = _rp;
        } else if (_lp <= editor.totalPages && !isLockedPage(_lp)) {
          pn = _lp;
        } else if (_rp <= editor.totalPages && !isLockedPage(_rp)) {
          pn = _rp;
        }
      }
    }
    // Abort silently if there is no valid target page (locked / out of range)
    if (!isCover && pn === null) return;

    const isLine  = shapeType === "line";
    const shapeObj = {
      id:          "shape_" + Date.now(),
      type:        "shape",
      shapeType:   shapeType,
      x:           60,
      y:           60,
      w:           isLine ? 160 : 120,
      h:           isLine ?   8 : 120,
      fill:        "#6366f1",
      stroke:      "#000000",
      strokeWidth: 0,
      opacity:     1,
      rotation:    0,
      z:           Date.now(),
    };
    pushUndoState("Add Shape");
    if (isCover) {
      if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
      editor.coverObjects.push(shapeObj);
      renderCoverCanvas();
    } else {
      if (!editor.pageObjects) editor.pageObjects = {};
      if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
      editor.pageObjects[pn].push(shapeObj);
      renderBuilderCanvas();
    }
  }

  function initMapTools() {
    initMapModal();
    initMapEditBar();

    const addMyMapBtn = document.getElementById("addMyMapBtn");
    const markStayBtn = document.getElementById("markStayBtn");
    const markerPickerMenu = document.getElementById("markerPickerMenu");

    if (addMyMapBtn && !addMyMapBtn.dataset.boundMapClick) {
      addMyMapBtn.dataset.boundMapClick = "true";
      addMyMapBtn.addEventListener("click", () => {
        dmbOpenMapModal();
      });
    }

    if (markStayBtn && !markStayBtn.dataset.boundMarkerClick) {
      markStayBtn.dataset.boundMarkerClick = "true";
      markStayBtn.addEventListener("click", () => {
        if (!currentInsertedMap) return;
        if (!markerPickerMenu) return;
        if (markerPickerMenu.style.display === "block") {
          markerPickerMenu.style.display = "none";
        } else {
          const rect = markStayBtn.getBoundingClientRect();
          markerPickerMenu.style.top = (rect.bottom + 4) + "px";
          markerPickerMenu.style.left = rect.left + "px";
          markerPickerMenu.style.width = rect.width + "px";
          markerPickerMenu.style.display = "block";
        }
      });
    }

    if (markerPickerMenu && !markerPickerMenu.dataset.boundMarkerMenu) {
      markerPickerMenu.dataset.boundMarkerMenu = "true";
      markerPickerMenu.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-marker-type]");
        if (!btn) return;
        activeMarkerType = btn.dataset.markerType;
        pendingMapMarkerPlacement = true;
        markerPickerMenu.style.display = "none";
      });
    }
  }

  function initStickerLibrary() {
    const btn = document.getElementById("dmbBrowseStickersBtn");
    if (!btn || btn.dataset.boundStickerLib) return;
    btn.dataset.boundStickerLib = "true";

    let stickerData = [];
    let selectedStickerUrl = null;
    let selectedStickerName = null;

    const _stickerUrl = (window.DMB_MAGAZINE_MODE && window.DMB_SELECTED_MAGAZINE_STYLE?.stickersUrl)
      ? window.DMB_SELECTED_MAGAZINE_STYLE.stickersUrl
      : (window.DMB_STICKERS_JSON_URL || "");
    fetch(_stickerUrl)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => { stickerData = Array.isArray(data) ? data : []; })
      .catch(() => { stickerData = []; });

    const modal = document.getElementById("dmbStickerModal");
    const grid = document.getElementById("dmbStickerGrid");
    const search = document.getElementById("dmbStickerSearch");
    const insertBtn = document.getElementById("dmbStickerInsertBtn");
    const closeBtn = document.getElementById("dmbStickerCloseBtn");
    const cancelBtn = document.getElementById("dmbStickerCancelBtn");

    function closeModal() { if (modal) modal.style.display = "none"; }

    function renderGrid(filter) {
      if (!grid) return;
      const q = (filter || "").toLowerCase().trim();
      const items = q ? stickerData.filter((s) => s.name.toLowerCase().includes(q)) : stickerData;
      grid.innerHTML = "";
      selectedStickerUrl = null;
      selectedStickerName = null;
      if (insertBtn) insertBtn.disabled = true;

      if (items.length === 0) {
        grid.innerHTML =
          stickerData.length === 0
            ? '<p style="grid-column:1/-1;text-align:center;color:#888;padding:24px 0;">No stickers uploaded yet.<br><small>Upload PNG images to Shopify Files and add them to custom-stickers.json</small></p>'
            : '<p style="grid-column:1/-1;text-align:center;color:#888;">No stickers match your search.</p>';
        return;
      }

      items.forEach((sticker) => {
        const cell = document.createElement("div");
        cell.style.cssText =
          "border:2px solid transparent;border-radius:8px;padding:8px 6px;cursor:pointer;text-align:center;background:#f7f7f7;transition:border-color .15s;";

        const img = document.createElement("img");
        img.src = sticker.url;
        img.alt = sticker.name;
        img.style.cssText =
          "width:80px;height:80px;object-fit:contain;display:block;margin:0 auto 6px;";

        const label = document.createElement("div");
        label.textContent = sticker.name;
        label.style.cssText =
          "font-size:11px;color:#555;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;";

        cell.appendChild(img);
        cell.appendChild(label);

        cell.addEventListener("click", () => {
          grid.querySelectorAll("[data-sticker-selected]").forEach((c) => {
            c.style.borderColor = "transparent";
            delete c.dataset.stickerSelected;
          });
          cell.style.borderColor = "#4a90e2";
          cell.dataset.stickerSelected = "true";
          selectedStickerUrl = sticker.url;
          selectedStickerName = sticker.name;
          if (insertBtn) insertBtn.disabled = false;
        });

        grid.appendChild(cell);
      });
    }

    btn.addEventListener("click", () => {
      if (!modal) return;
      renderGrid("");
      if (search) search.value = "";
      modal.style.display = "flex";
    });

    closeBtn?.addEventListener("click", closeModal);
    cancelBtn?.addEventListener("click", closeModal);
    modal?.addEventListener("click", (e) => { if (e.target === modal) closeModal(); });
    search?.addEventListener("input", () => renderGrid(search.value));

    insertBtn?.addEventListener("click", () => {
      if (!selectedStickerUrl) return;
      const pageNumber = getActivePageNumberForMap();
      if (pageNumber == null) { closeModal(); return; }
      const isCover = pageNumber === "cover";
      const url = selectedStickerUrl;
      const name = selectedStickerName || "Sticker";
      closeModal();

      const tempImg = new Image();
      tempImg.crossOrigin = "anonymous";
      let _libStickerDone = false;
      tempImg.onload = () => {
        if (_libStickerDone) return; _libStickerDone = true;
        const origW = tempImg.naturalWidth || 100;
        const origH = tempImg.naturalHeight || 100;

        // Find tight bounding box of non-transparent pixels and crop to it
        let cropX = 0, cropY = 0, cropW = origW, cropH = origH;
        let tightUrl = null;
        try {
          const ofc = document.createElement("canvas");
          ofc.width = origW; ofc.height = origH;
          const ofCtx = ofc.getContext("2d");
          ofCtx.drawImage(tempImg, 0, 0);
          const px = ofCtx.getImageData(0, 0, origW, origH).data;
          let minX = origW, minY = origH, maxX = 0, maxY = 0;
          for (let y = 0; y < origH; y++) {
            for (let x = 0; x < origW; x++) {
              if (px[(y * origW + x) * 4 + 3] > 10) {
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
              }
            }
          }
          if (maxX >= minX && maxY >= minY) {
            cropX = minX; cropY = minY;
            cropW = maxX - minX + 1; cropH = maxY - minY + 1;
          }
          // Export the cropped area as a data URL so the img element needs no offset tricks
          const cropCanvas = document.createElement("canvas");
          cropCanvas.width = cropW; cropCanvas.height = cropH;
          cropCanvas.getContext("2d").drawImage(ofc, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);
          tightUrl = cropCanvas.toDataURL("image/png");
        } catch(e) { /* CORS fallback — use original URL */ }

        const MAX = 150;
        let w = cropW, h = cropH;
        if (w > MAX || h > MAX) {
          const scale = MAX / Math.max(w, h);
          w = Math.round(w * scale);
          h = Math.round(h * scale);
        }
        const stickerObj = {
          id: "sticker_" + Date.now(),
          type: "sticker",
          name,
          url,
          tightUrl,
          x: 20,
          y: 20,
          w,
          h,
          z: Date.now(),
          rotation: 0,
          cropX,
          cropY,
          cropW,
          cropH,
        };
        pushUndoState("Insert Sticker");
        if (isCover) {
          if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
          editor.coverObjects.push(stickerObj);
        } else {
          if (!editor.pageObjects) editor.pageObjects = {};
          if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = [];
          editor.pageObjects[pageNumber].push(stickerObj);
        }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.onerror = () => {
        if (_libStickerDone) return; _libStickerDone = true;
        // fallback to 100x100 if image can't be measured
        const stickerObj = {
          id: "sticker_" + Date.now(),
          type: "sticker",
          name,
          url,
          x: 20,
          y: 20,
          w: 100,
          h: 100,
          z: Date.now(),
          rotation: 0,
        };
        pushUndoState("Insert Sticker");
        if (isCover) {
          if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
          editor.coverObjects.push(stickerObj);
        } else {
          if (!editor.pageObjects) editor.pageObjects = {};
          if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = [];
          editor.pageObjects[pageNumber].push(stickerObj);
        }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.src = url;
    });
  }

  function _commitMagIconObj(obj) {
    pushUndoState("Insert Icon");
    const pageNumber = getActivePageNumberForMap();
    if (pageNumber === "cover") {
      if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
      editor.coverObjects.push(obj);
      renderCoverCanvas();
    } else {
      const pn = pageNumber;
      if (!editor.pageObjects) editor.pageObjects = {};
      if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
      editor.pageObjects[pn].push(obj);
      if (typeof renderSpread === "function") renderSpread();
    }
    if (typeof renderThumbsRail === "function") renderThumbsRail();
  }

  function insertMagIcon(iconId, color) {
    const base = (window.DMB_ASSET_BASE || "").replace(/\/[^/]+$/, "/");
    const ic = DMB_MAG_ICONS.find((i) => i.id === iconId);
    if (!ic) return;
    const url = base + ic.file;
    const img = new Image();
    img.crossOrigin = "anonymous";
    let _magIconDone = false;
    img.onload = () => {
      if (_magIconDone) return; _magIconDone = true;
      const naturalW = img.naturalWidth || 300;
      const naturalH = img.naturalHeight || 120;
      const MAX = 250;
      let w = naturalW, h = naturalH;
      if (w > MAX) { h = Math.round(h * MAX / w); w = MAX; }
      if (h > MAX) { w = Math.round(w * MAX / h); h = MAX; }
      _commitMagIconObj({ id: "mag-icon_" + Date.now(), type: "mag-icon", iconId, color: color || "#000000", x: 20, y: 20, w, h, naturalW, naturalH, z: Date.now(), rotation: 0 });
    };
    img.onerror = () => {
      if (_magIconDone) return; _magIconDone = true;
      _commitMagIconObj({ id: "mag-icon_" + Date.now(), type: "mag-icon", iconId, color: color || "#000000", x: 20, y: 20, w: 200, h: 80, naturalW: 200, naturalH: 80, z: Date.now(), rotation: 0 });
    };
    img.src = url;
  }

  function initMagIconPanel() {
    const modal = document.getElementById("dmbMagIconModal");
    const closeBtn = document.getElementById("dmbMagIconModalClose");
    const colorInput = document.getElementById("dmbMagIconModalColor");
    const grid = document.getElementById("dmbMagIconModalGrid");
    if (!modal) return;
    if (modal.dataset.boundMagIcon) return;
    modal.dataset.boundMagIcon = "true";

    // Open modal
    document.getElementById("dmbMagIconsBtn")?.addEventListener("click", () => {
      modal.style.display = "flex";
    });

    // Close modal
    closeBtn?.addEventListener("click", () => { modal.style.display = "none"; });
    modal.addEventListener("click", (e) => { if (e.target === modal) modal.style.display = "none"; });

    // Insert icon on click
    grid?.addEventListener("click", (e) => {
      const btn = e.target.closest(".dmb-mag-icon-pick-btn");
      if (!btn) return;
      insertMagIcon(btn.dataset.iconId, colorInput ? colorInput.value : "#000000");
      modal.style.display = "none";
    });
  }

  function initCustomStickersPanel() {
    const modal = document.getElementById("dmbCustomStickerModal");
    const closeBtn = document.getElementById("dmbCustomStickerModalClose");
    const grid = document.getElementById("dmbCustomStickerModalGrid");
    if (!modal) return;
    if (modal.dataset.boundCustomStickers) return;
    modal.dataset.boundCustomStickers = "true";

    document.getElementById("dmbStickersBtn")?.addEventListener("click", () => {
      modal.style.display = "flex";
    });

    closeBtn?.addEventListener("click", () => { modal.style.display = "none"; });
    modal.addEventListener("click", (e) => { if (e.target === modal) modal.style.display = "none"; });

    grid?.addEventListener("click", (e) => {
      const btn = e.target.closest(".dmb-mag-icon-pick-btn");
      if (!btn) return;
      const url = btn.dataset.stickerUrl;
      const name = btn.dataset.stickerName || "Sticker";
      modal.style.display = "none";

      const pageNumber = getActivePageNumberForMap();
      if (pageNumber == null) return;
      const isCover = pageNumber === "cover";

      const tempImg = new Image();
      tempImg.crossOrigin = "anonymous";
      let _stickerDone = false;
      tempImg.onload = () => {
        if (_stickerDone) return; _stickerDone = true;
        const origW = tempImg.naturalWidth || 100;
        const origH = tempImg.naturalHeight || 100;
        let cropX = 0, cropY = 0, cropW = origW, cropH = origH, tightUrl = null;
        try {
          const ofc = document.createElement("canvas");
          ofc.width = origW; ofc.height = origH;
          const ofCtx = ofc.getContext("2d");
          ofCtx.drawImage(tempImg, 0, 0);
          const px = ofCtx.getImageData(0, 0, origW, origH).data;
          let minX = origW, minY = origH, maxX = 0, maxY = 0;
          for (let y = 0; y < origH; y++) {
            for (let x = 0; x < origW; x++) {
              if (px[(y * origW + x) * 4 + 3] > 10) {
                if (x < minX) minX = x; if (x > maxX) maxX = x;
                if (y < minY) minY = y; if (y > maxY) maxY = y;
              }
            }
          }
          if (maxX >= minX && maxY >= minY) { cropX = minX; cropY = minY; cropW = maxX - minX + 1; cropH = maxY - minY + 1; }
          const cc = document.createElement("canvas"); cc.width = cropW; cc.height = cropH;
          cc.getContext("2d").drawImage(ofc, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);
          tightUrl = cc.toDataURL("image/png");
        } catch(e) {}
        const MAX = 150;
        let w = cropW, h = cropH;
        if (w > MAX || h > MAX) { const s = MAX / Math.max(w, h); w = Math.round(w * s); h = Math.round(h * s); }
        const obj = { id: "sticker_" + Date.now(), type: "sticker", name, url, tightUrl, x: 20, y: 20, w, h, z: Date.now(), rotation: 0, cropX, cropY, cropW, cropH };
        pushUndoState("Insert Sticker");
        if (isCover) { if (!Array.isArray(editor.coverObjects)) editor.coverObjects = []; editor.coverObjects.push(obj); }
        else { if (!editor.pageObjects) editor.pageObjects = {}; if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = []; editor.pageObjects[pageNumber].push(obj); }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.onerror = () => {
        if (_stickerDone) return; _stickerDone = true;
        const obj = { id: "sticker_" + Date.now(), type: "sticker", name, url, x: 20, y: 20, w: 100, h: 100, z: Date.now(), rotation: 0 };
        pushUndoState("Insert Sticker");
        if (isCover) { if (!Array.isArray(editor.coverObjects)) editor.coverObjects = []; editor.coverObjects.push(obj); }
        else { if (!editor.pageObjects) editor.pageObjects = {}; if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = []; editor.pageObjects[pageNumber].push(obj); }
        if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      };
      tempImg.src = url;
    });
  }

  function initPhoneUpload() {
    ["importPhoneBtn", "step1bPhoneBtn"].forEach((id) => {
      const btn = document.getElementById(id);
      if (!btn || btn.dataset.boundPhone) return;
      btn.dataset.boundPhone = "true";
      btn.addEventListener("click", openPhoneUploadModal);
    });
  }

  function openPhoneUploadModal() {
    {
      const sessionId = String(Math.floor(1000 + Math.random() * 9000));
      const uploadUrl = window.location.origin + "/pages/phone-upload?s=" + sessionId;
      const qrSrc = null; // QR generated via qrcode.js into canvas

      let modal = document.getElementById("dmbPhoneUploadModal");
      if (!modal) {
        modal = document.createElement("div");
        modal.id = "dmbPhoneUploadModal";
        modal.style.cssText =
          "position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;";
        var _qrImgSrc = window.DMB_PHONE_QR_URL || "";
        modal.innerHTML = [
          '<div style="background:#fff;border-radius:16px;padding:28px 24px;max-width:360px;width:92vw;text-align:center;position:relative;">',
          '<button id="dmbPhoneModalClose" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;line-height:1;">&#x2715;</button>',
          '<h3 style="margin:0 0 6px;font-size:17px;">Upload from Phone</h3>',
          '<p style="margin:0 0 14px;color:#666;font-size:13px;">1. Scan the QR code with your phone<br>2. Enter your session code when prompted</p>',
          '<img src="' + _qrImgSrc + '" style="width:200px;height:200px;display:block;margin:0 auto 16px;border-radius:8px;border:1px solid #eee;">',
          '<div style="background:#f5f5f5;border-radius:12px;padding:12px 20px;margin-bottom:16px;">',
          '<div style="font-size:11px;color:#999;margin-bottom:4px;letter-spacing:1px;text-transform:uppercase;">Your session code</div>',
          '<div id="dmbPhoneCode" style="font-size:48px;font-weight:900;letter-spacing:12px;color:#111;"></div>',
          '</div>',
          '<div id="dmbPhoneStatus" style="font-size:14px;color:#999;padding:4px 0;">Waiting for phone to connect\u2026</div>',
          '<div id="dmbPhoneCount" style="font-size:13px;color:#2e7d32;margin-top:6px;display:none;"></div>',
          '</div>',
        ].join("");
        document.body.appendChild(modal);
        modal.addEventListener("click", (e) => { if (e.target === modal) closeModal(); });
      }

      const statusEl = document.getElementById("dmbPhoneStatus");
      const countEl  = document.getElementById("dmbPhoneCount");
      const codeEl   = document.getElementById("dmbPhoneCode");
      const closeBtn = document.getElementById("dmbPhoneModalClose");

      codeEl.textContent = sessionId;
      statusEl.textContent = "Waiting for phone to connect\u2026";
      statusEl.style.color = "#999";
      countEl.style.display = "none";
      countEl.textContent = "";
      modal.style.display = "flex";

      let activePeer = null;
      let receivedCount = 0;

      function closeModal() {
        modal.style.display = "none";
        if (activePeer) { try { activePeer.destroy(); } catch (_) {} activePeer = null; }
      }

      closeBtn.onclick = closeModal;

      function createPeer() {
        if (activePeer) { try { activePeer.destroy(); } catch (_) {} }
        const peer = new Peer("mn-" + sessionId);
        activePeer = peer;
        let pendingMeta = null;

        peer.on("error", () => {
          statusEl.textContent = "Connection error. Please close and try again.";
          statusEl.style.color = "#c00";
        });

        peer.on("connection", (conn) => {
          statusEl.textContent = "\uD83D\uDCF1 Phone connected! Select photos on your phone.";
          statusEl.style.color = "#2e7d32";

          conn.on("data", (data) => {
            const isBinary = data instanceof ArrayBuffer || data instanceof Uint8Array ||
              (typeof Buffer !== "undefined" && Buffer.isBuffer(data));
            if (!isBinary && data && typeof data === "object" && data.type === "meta") {
              pendingMeta = data;
            } else if (isBinary) {
              const meta = pendingMeta || { name: "phone-" + Date.now() + ".jpg", mimeType: "image/jpeg" };
              pendingMeta = null;
              const blob = new Blob([data], { type: meta.mimeType || "image/jpeg" });
              const file = new File([blob], meta.name || ("photo-" + Date.now() + ".jpg"), {
                type: meta.mimeType || "image/jpeg",
                lastModified: Date.now(),
              });
              // Inject into step1b if builder not open yet, otherwise into builder tray
              const step1bEl = document.getElementById("step1b");
              const builderEl = document.getElementById("builderStep");
              if (step1bEl && step1bEl.style.display !== "none") {
                const input = document.getElementById("step1bFileInput");
                if (input && typeof DataTransfer !== "undefined") {
                  const dt = new DataTransfer();
                  for (const f of (input.files || [])) dt.items.add(f);
                  dt.items.add(file);
                  input.files = dt.files;
                  input.dispatchEvent(new Event("change", { bubbles: true }));
                }
              } else {
                bookFiles = mergeFilesKeepOld(bookFiles, [file]);
                renderPhotoTray();
                validatePhotos();
              }
              receivedCount++;
              countEl.style.display = "block";
              countEl.textContent = receivedCount + " photo" + (receivedCount > 1 ? "s" : "") + " received \u2713";
            }
          });

          conn.on("close", () => {
            statusEl.textContent = "Phone disconnected \u2014 photos are in your tray.";
            statusEl.style.color = "#555";
          });
        });
      }

      if (typeof Peer === "undefined") {
        const s = document.createElement("script");
        s.src = "https://unpkg.com/peerjs@1.5.2/dist/peerjs.min.js";
        s.onload = createPeer;
        s.onerror = () => {
          statusEl.textContent = "Could not load connection library. Check your internet.";
          statusEl.style.color = "#c00";
        };
        document.head.appendChild(s);
      } else {
        createPeer();
      }
    }
  }

  function enableMapMarkerPlacement() {
    document.addEventListener("click", function(e) {
      if (!pendingMapMarkerPlacement || !activeMarkerType) return;

      const mapObject = e.target.closest(".dmb-map-object");
      if (!mapObject) return;

      const svg = mapObject.querySelector("svg");
      if (!svg) return;

      const svgRect = svg.getBoundingClientRect();
      const x = ((e.clientX - svgRect.left) / svgRect.width) * 100;
      const y = ((e.clientY - svgRect.top) / svgRect.height) * 100;

      if (!Array.isArray(currentInsertedMap.markers)) {
        currentInsertedMap.markers = [];
      }

      currentInsertedMap.markers.push({
        type: activeMarkerType,
        x,
        y
      });

      pendingMapMarkerPlacement = false;

      if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
      if (typeof renderThumbsRail === "function") renderThumbsRail();
    });
  }

  function dmbCropSvgToContent(svgMarkup) {
    // Returns { svg: croppedMarkup, aspect: width/height }
    // Crops the SVG viewBox to tightly fit actual path content so the frame matches the visible map.
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgMarkup, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) return { svg: svgMarkup, aspect: 1 };

      const host = document.createElement("div");
      host.style.cssText = "position:fixed;left:-9999px;top:-9999px;visibility:hidden;width:1px;height:1px;overflow:visible;";
      document.body.appendChild(host);
      const svgClone = svg.cloneNode(true);
      svgClone.setAttribute("width", "1000");
      svgClone.setAttribute("height", "1000");
      host.appendChild(svgClone);

      const elements = Array.from(svgClone.querySelectorAll("path, polygon, polyline, circle, ellipse, rect"));
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      elements.forEach(function(el) {
        try {
          const b = el.getBBox();
          if (b.width > 0 || b.height > 0) {
            minX = Math.min(minX, b.x);
            minY = Math.min(minY, b.y);
            maxX = Math.max(maxX, b.x + b.width);
            maxY = Math.max(maxY, b.y + b.height);
          }
        } catch(e2) {}
      });
      document.body.removeChild(host);

      if (!isFinite(minX) || maxX <= minX || maxY <= minY) {
        return { svg: svgMarkup, aspect: 1 };
      }

      const pad = (maxX - minX) * 0.02; // 2% padding each side
      const nx = minX - pad, ny = minY - pad;
      const nw = maxX - minX + pad * 2;
      const nh = maxY - minY + pad * 2;

      svg.setAttribute("viewBox", `${nx} ${ny} ${nw} ${nh}`);
      svg.removeAttribute("width");
      svg.removeAttribute("height");

      return { svg: new XMLSerializer().serializeToString(svg), aspect: nw / nh };
    } catch(e) { return { svg: svgMarkup, aspect: 1 }; }
  }

  function dmbFindIslandPaths(svgMarkup) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgMarkup, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) return [];
      const vb = svg.getAttribute("viewBox");
      let vbW = 100;
      if (vb) { const parts = vb.trim().split(/[\s,]+/); vbW = parseFloat(parts[2]) || 100; }
      const threshold = Math.max(5, 14 * vbW / 270);
      const host = document.createElement("div");
      host.style.cssText = "position:fixed;left:-9999px;top:-9999px;visibility:hidden;width:1px;height:1px;overflow:visible;";
      document.body.appendChild(host);
      const svgClone = svg.cloneNode(true);
      svgClone.setAttribute("width", "500"); svgClone.setAttribute("height", "500");
      host.appendChild(svgClone);
      const elements = Array.from(svgClone.querySelectorAll("path, polygon, polyline, circle, ellipse, rect"));
      const boxes = elements.map(el => { try { return el.getBBox(); } catch(e) { return null; } });
      document.body.removeChild(host);
      if (elements.length < 2) return [];
      const islands = [];
      boxes.forEach((b, i) => {
        if (!b || b.width === 0 && b.height === 0) return;
        let minDist = Infinity;
        boxes.forEach((b2, j) => {
          if (i === j || !b2) return;
          const dx = Math.max(0, Math.max(b.x, b2.x) - Math.min(b.x + b.width, b2.x + b2.width));
          const dy = Math.max(0, Math.max(b.y, b2.y) - Math.min(b.y + b.height, b2.y + b2.height));
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < minDist) minDist = dist;
        });
        if (minDist > threshold) islands.push({ index: i });
      });
      return islands;
    } catch (e) { return []; }
  }

  function dmbRemoveIslandPaths(svgMarkup, islandIndices) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgMarkup, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) return svgMarkup;
      const elements = Array.from(svg.querySelectorAll("path, polygon, polyline, circle, ellipse, rect"));
      islandIndices.map(i => i.index).sort((a, b) => b - a).forEach(idx => {
        const el = elements[idx];
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
      return new XMLSerializer().serializeToString(svg);
    } catch (e) { return svgMarkup; }
  }

  function insertMapIntoActivePage(svgMarkup, mapKey, styles) {
    const pageNumber = getActivePageNumberForMap();
    if (pageNumber == null) return;

    const isCover = pageNumber === "cover";
    const s = styles || {};
    const mapId = "map_" + Date.now();

    // Crop SVG viewBox to actual content bounds so frame matches visible map exactly
    const cropped = dmbCropSvgToContent(svgMarkup);
    svgMarkup = cropped.svg;

    // Size map to fit its natural aspect ratio (not fill the whole page)
    let mapX = 0, mapY = 0, mapW, mapH;
    const MAX_MAP_SIZE = 180; // max starting dimension in px
    const naturalAspect = cropped.aspect;
    if (naturalAspect >= 1) {
      mapW = MAX_MAP_SIZE;
      mapH = Math.round(MAX_MAP_SIZE / naturalAspect);
    } else {
      mapH = MAX_MAP_SIZE;
      mapW = Math.round(MAX_MAP_SIZE * naturalAspect);
    }

    if (isCover) {
      const zone = (typeof activeCoverZone !== "undefined" && activeCoverZone) || "front";
      const faceW = 300;
      const faceH = Math.round(faceW * 1.414);
      const zoneStartX = zone === "front" ? (window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X)
                       : zone === "back"  ? 0
                       : COVER_BACK_W;
      mapX = zoneStartX + Math.round((faceW - mapW) / 2);
      mapY = Math.round((faceH - mapH) / 2);
    } else {
      // Center in page body (270px wide, ~338px tall)
      mapX = Math.round((270 - mapW) / 2);
      mapY = Math.round((338 - mapH) / 2);
    }

    const mapObj = {
      id: mapId,
      type: "map",
      name: mapKey || "Map",
      svg: svgMarkup,
      x: mapX,
      y: mapY,
      w: mapW,
      h: mapH,
      z: 20,
      rotation: 0,
      fill: s.fill || "#d9d9d9",
      stroke: s.stroke || "#111111",
      strokeWidth: s.strokeWidth != null ? s.strokeWidth : 1.2,
      strokeDasharray: s.strokeDasharray || "",
      opacity: s.opacity != null ? s.opacity : 1,
      showOutline: s.showOutline || false,
      hideProvinces: s.hideProvinces || false,
      transparentFill: s.transparentFill || false,
      filterId: "dmbOF_" + mapId,
      markers: []
    };

    if (isCover) {
      if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
      editor.coverObjects.push(mapObj);
    } else {
      if (!editor.pageObjects || typeof editor.pageObjects !== "object") editor.pageObjects = {};
      if (!Array.isArray(editor.pageObjects[pageNumber])) editor.pageObjects[pageNumber] = [];
      editor.pageObjects[pageNumber].push(mapObj);
    }

    currentInsertedMap = mapObj;
    pendingMapMarkerPlacement = false;

    if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    if (typeof renderThumbsRail === "function") renderThumbsRail();
  }
  window.insertMapIntoActivePage = insertMapIntoActivePage;

  function renderMapObject(obj, parent, pageIndex) {
    const wrap = document.createElement("div");
    wrap.className = "dmb-map-object";
    wrap.dataset.objectId = obj.id;
    wrap.style.position = "absolute";
    wrap.style.left = (obj.x || 0) + "%";
    wrap.style.top = (obj.y || 0) + "%";
    wrap.style.width = (obj.width || 70) + "%";
    wrap.style.height = (obj.height || 70) + "%";
    wrap.style.transform = `rotate(${obj.rotation || 0}deg)`;
    wrap.style.transformOrigin = "center center";
    wrap.style.cursor = "move";

    wrap.innerHTML = obj.svg || "";

    const svg = wrap.querySelector("svg");
    if (svg) {
      svg.style.width = "100%";
      svg.style.height = "100%";
      svg.style.display = "block";

      svg.querySelectorAll("path").forEach((path) => {
        path.style.fill = obj.fill || "#d9d9d9";
        path.style.stroke = obj.stroke || "#111111";
        path.style.strokeWidth = obj.strokeWidth || 1.2;
        path.style.strokeDasharray = obj.strokeDasharray || "";
        path.style.opacity = obj.opacity || 1;
        path.style.vectorEffect = "non-scaling-stroke";
      });
    }

    if (Array.isArray(obj.markers)) {
      obj.markers.forEach((markerData) => {
        const marker = createMarkerElement(markerData.type || "pin", markerData.color || "#e74c3c");
        marker.style.left = (markerData.x || 50) + "%";
        marker.style.top  = (markerData.y || 50) + "%";
        wrap.appendChild(marker);
        attachMarkerInteractions(marker, markerData, wrap);
      });
    }

    parent.appendChild(wrap);
    currentInsertedMap = obj;

    /* click → open edit bar */
    wrap.addEventListener("click", (e) => {
      if (e.target.closest(".dmb-map-marker")) return;
      dmbOpenEditBar(obj, wrap);
    });
  }




  function enableBasicDragging(node, container) {
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;

    node.addEventListener("pointerdown", (e) => {
      if (e.target.closest(".dmb-map-marker")) return;
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = parseFloat(node.style.left || 0);
      startTop = parseFloat(node.style.top || 0);
      node.setPointerCapture?.(e.pointerId);
      e.preventDefault();
    });

    node.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      node.style.left = `${startLeft + dx}px`;
      node.style.top = `${startTop + dy}px`;
    });

    node.addEventListener("pointerup", () => {
      dragging = false;
    });

    node.addEventListener("pointercancel", () => {
      dragging = false;
    });
  }

  function createMarkerElement(markerType, color) {
    const c = color || "#e74c3c";
    const marker = document.createElement("div");
    marker.className = "dmb-map-marker";
    marker.dataset.markerType = markerType;
    marker.style.position = "absolute";
    marker.style.transform = "translate(-50%, -50%)";
    marker.style.zIndex = "10";
    marker.style.cursor = "move";
    marker.style.userSelect = "none";

    if (markerType === "dot") {
      const dot = document.createElement("div");
      dot.className = "dmb-map-marker-dot";
      dot.style.backgroundColor = c;
      marker.appendChild(dot);
    } else if (markerType === "pin") {
      marker.innerHTML = `<svg width="18" height="26" viewBox="0 0 18 26" xmlns="http://www.w3.org/2000/svg"><ellipse cx="9" cy="9" rx="7.5" ry="7.5" fill="${c}" stroke="white" stroke-width="1.5"/><polygon points="9,26 3.5,15 14.5,15" fill="${c}"/><circle cx="9" cy="9" r="2.8" fill="white"/></svg>`;
    } else if (markerType === "heart") {
      marker.style.fontSize = "22px";
      marker.style.lineHeight = "1";
      marker.style.color = c;
      marker.style.textShadow = "0 1px 3px rgba(0,0,0,0.4)";
      marker.textContent = "♥";
    } else if (markerType === "star") {
      marker.style.fontSize = "22px";
      marker.style.lineHeight = "1";
      marker.style.color = c;
      marker.style.textShadow = "0 1px 3px rgba(0,0,0,0.4)";
      marker.textContent = "★";
    }

    return marker;
  }

  function updateMarkerColor(markerEl, markerType, color) {
    if (markerType === "dot") {
      const dot = markerEl.querySelector(".dmb-map-marker-dot");
      if (dot) dot.style.backgroundColor = color;
    } else if (markerType === "pin") {
      markerEl.querySelectorAll("ellipse, polygon").forEach(function(el) { el.setAttribute("fill", color); });
    } else {
      markerEl.style.color = color;
    }
  }

  function attachMarkerInteractions(marker, markerData, wrap) {
    // Drag to reposition — updates markerData.x / markerData.y in %
    marker.addEventListener("pointerdown", function(e) {
      if (e.button !== 0) return;
      e.stopPropagation();
      e.preventDefault();
      const wRect = wrap.getBoundingClientRect();
      const startX = e.clientX, startY = e.clientY;
      const startPctX = markerData.x || 0, startPctY = markerData.y || 0;
      marker.setPointerCapture(e.pointerId);
      function onMove(ev) {
        markerData.x = Math.max(0, Math.min(100, startPctX + ((ev.clientX - startX) / wRect.width)  * 100));
        markerData.y = Math.max(0, Math.min(100, startPctY + ((ev.clientY - startY) / wRect.height) * 100));
        marker.style.left = markerData.x + "%";
        marker.style.top  = markerData.y + "%";
      }
      function onUp() {
        document.removeEventListener("pointermove", onMove);
        document.removeEventListener("pointerup", onUp);
        if (typeof renderThumbsRail === "function") renderThumbsRail();
      }
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    });

    // Click to change color
    marker.addEventListener("click", function(e) {
      e.stopPropagation();
      const inp = document.createElement("input");
      inp.type = "color";
      inp.value = markerData.color || "#e74c3c";
      inp.style.cssText = "position:fixed;opacity:0;width:0;height:0;pointer-events:none;";
      document.body.appendChild(inp);
      inp.addEventListener("input", function() {
        markerData.color = inp.value;
        updateMarkerColor(marker, markerData.type, inp.value);
      });
      inp.addEventListener("change", function() {
        markerData.color = inp.value;
        updateMarkerColor(marker, markerData.type, inp.value);
        if (typeof renderThumbsRail === "function") renderThumbsRail();
        setTimeout(function() { inp.remove(); }, 500);
      });
      inp.click();
    });
  }

  function enableBasicMarkerDragging(marker, container) {
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;

    marker.addEventListener("pointerdown", (e) => {
      dragging = true;
      startX = e.clientX;
      startY = e.clientY;
      startLeft = parseFloat(marker.style.left || 0);
      startTop = parseFloat(marker.style.top || 0);
      marker.setPointerCapture?.(e.pointerId);
      e.stopPropagation();
      e.preventDefault();
    });

    marker.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      marker.style.left = `${startLeft + dx}px`;
      marker.style.top = `${startTop + dy}px`;
    });

    marker.addEventListener("pointerup", () => {
      dragging = false;
    });

    marker.addEventListener("pointercancel", () => {
      dragging = false;
    });
  }


  function captureVisualText(el) {
    var result = [];
    var curLine = "";
    var lastTop = null;
    function walk(node) {
      if (node.nodeType === 3) {
        var s = node.nodeValue || "";
        for (var i = 0; i < s.length; i++) {
          if (s[i] === "\n") { result.push(curLine); curLine = ""; lastTop = null; continue; }
          var r = document.createRange();
          r.setStart(node, i); r.setEnd(node, i + 1);
          var rect = r.getBoundingClientRect();
          if (lastTop !== null && rect.top > lastTop + 2) { result.push(curLine); curLine = ""; }
          curLine += s[i];
          lastTop = rect.top;
        }
      } else if (node.nodeName === "BR") {
        result.push(curLine); curLine = ""; lastTop = null;
      } else if (node.nodeType === 1) {
        var disp = window.getComputedStyle(node).display || "";
        var isBlock = disp !== "inline" && disp !== "inline-block" && disp !== "none";
        if (isBlock && (result.length > 0 || curLine !== "")) { result.push(curLine); curLine = ""; lastTop = null; }
        node.childNodes.forEach(walk);
      }
    }
    el.childNodes.forEach(walk);
    result.push(curLine);
    while (result.length > 1 && result[result.length - 1] === "") result.pop();
    return result.join("\n");
  }

  function saveCoverTextNodeState(node) {
    if (!node || !node.id) return;
    if (!coverState.textStyles) coverState.textStyles = {};
    // Fully-cleared cover text — remove from all state so re-renders don't revive it
    const _coverTxt = captureVisualText(node);
    if (!_coverTxt.trim()) {
      delete coverState.textStyles[node.id];
      if (Array.isArray(editor.coverUserTexts)) {
        editor.coverUserTexts = editor.coverUserTexts.filter((e) => e.id !== node.id);
      }
      return;
    }
    coverState.textStyles[node.id] = {
      text: _coverTxt,
      left: node.style.left || "",
      top: node.style.top || "",
      // Store only explicit CSS width — NOT the parent's offsetWidth fallback.
      width: node.style.width || "",
      // ── boxWidth / boxHeight: exact DOM element dimensions (pre-rotation) ──
      // These are used by the PDF renderer to compute the rotation anchor
      // (element centre = left + boxWidth/2, top + boxHeight/2). Canvas text
      // measurement can differ from the browser by 1-3px; for rotated text that
      // small error moves the anchor visibly. Storing the real DOM size fixes it.
      boxWidth:  String(node.offsetWidth  || 0),
      boxHeight: String(node.offsetHeight || 0),
      color: node.style.color || "",
      fontFamily: node.style.fontFamily || "",
      fontSize: node.style.fontSize || "",
      fontWeight: node.style.fontWeight || "",
      textAlign: node.style.textAlign || "",
      textDecoration: node.style.textDecoration || "",
      transform: node.style.transform || "",
      // Clamp floating-point drift (e.g. -2.84e-14) to "0" at save time so
      // templates and session state never store near-zero garbage rotations.
      rotate: (Math.abs(parseFloat(node.dataset.rotate || "0")) < 0.001 ? "0" : (node.dataset.rotate || "0")),
      z: node.dataset.z || node.style.zIndex || "20"
    };
  }

  function savePageTextState(node) {
    if (!node || !node.id) return;
    const pn = parseInt(node.dataset.pageNumber);
    if (!Number.isFinite(pn)) return;
    if (!Array.isArray(editor.pageObjects?.[pn])) return;
    // If the text box has been fully cleared, remove it from state so a
    // re-render (triggered by adding stickers, frames, etc.) cannot resurrect it.
    const _capturedText = captureVisualText(node);
    if (!_capturedText.trim()) {
      editor.pageObjects[pn] = editor.pageObjects[pn].filter((o) => o.id !== node.id);
      return;
    }
    const obj = editor.pageObjects[pn].find((o) => o.id === node.id);
    if (!obj) return;
    obj.text = _capturedText;
    obj.left = node.style.left || "";
    obj.top = node.style.top || "";
    // Store only explicit CSS width — NOT the parent offsetWidth fallback.
    // The parent fallback (≈270px page width) is meaningless for positioning and
    // causes wrong textAlign centering in the PDF (text centred across whole page).
    obj.width = node.style.width || "";
    obj.color = node.style.color || "";
    obj.fontFamily = node.style.fontFamily || "";
    obj.fontSize = node.style.fontSize || "";
    obj.fontWeight = node.style.fontWeight || "";
    obj.textAlign = node.style.textAlign || "";
    obj.textDecoration = node.style.textDecoration || "";
    obj.transform = node.style.transform || "";
    // Clamp floating-point drift (e.g. -2.84e-14) to "0" at save time.
    obj.rotate = (Math.abs(parseFloat(node.dataset.rotate || "0")) < 0.001 ? "0" : (node.dataset.rotate || "0"));
    obj.z = node.dataset.z || node.style.zIndex || "20";
    // ── boxWidth / boxHeight: exact DOM element dimensions (pre-rotation) ──
    // The PDF renderer uses these to compute the rotation pivot (element centre =
    // left + boxWidth/2, top + boxHeight/2).  Canvas text measurement can differ
    // from the browser by 1–3px; for rotated text that small error visibly shifts
    // the anchor.  Storing the real DOM size here eliminates the discrepancy.
    // (Cover text already saves these — this brings page text in line with it.)
    obj.boxWidth  = String(node.offsetWidth  || 0);
    obj.boxHeight = String(node.offsetHeight || 0);
  }

  function applyCoverTextNodeState(node) {
    if (!node || !node.id) return;
    const saved = coverState.textStyles && coverState.textStyles[node.id];
    if (!saved) return;

    if (saved.text != null) node.textContent = saved.text;
    if (saved.left) node.style.left = saved.left;
    if (saved.top) node.style.top = saved.top;
    if (saved.width) node.style.width = saved.width;
    if (saved.color) node.style.color = saved.color;
    if (saved.fontFamily) node.style.fontFamily = saved.fontFamily;
    if (saved.fontSize) node.style.fontSize = saved.fontSize;
    if (saved.textAlign) node.style.textAlign = saved.textAlign;
    if (saved.textDecoration) node.style.textDecoration = saved.textDecoration;
    if (saved.transform) node.style.transform = saved.transform;
    if (saved.rotate != null) node.dataset.rotate = saved.rotate;
    if (saved.z != null) {
      node.dataset.z = saved.z;
      node.style.zIndex = saved.z;
    }
  }


  function getPageTemplateId(pageNumber) {
    return editor.pageTemplate?.[pageNumber] || null;
  }

  function isTemplatePage(pageNumber) {
    return !!getPageTemplateId(pageNumber);
  }

  function ensureTemplateState(pageNumber, templateId) {
    if (!editor.pageTemplate) editor.pageTemplate = {};
    if (!editor.pageFrames) editor.pageFrames = {};
    if (!editor.pageFrameRot) editor.pageFrameRot = {};

    editor.pageTemplate[pageNumber] = templateId || null;

    if (templateId) {
      const def = TEMPLATE_DEFS[templateId] || [];
      editor.pageFrames[pageNumber] = editor.pageFrames[pageNumber] || {};
      editor.pageFrameRot[pageNumber] = editor.pageFrameRot[pageNumber] || {};

      def.forEach((f) => {
        if (!(f.key in editor.pageFrames[pageNumber])) editor.pageFrames[pageNumber][f.key] = null;
        if (!(f.key in editor.pageFrameRot[pageNumber])) editor.pageFrameRot[pageNumber][f.key] = 0;
      });

      Object.keys(editor.pageFrames[pageNumber]).forEach((k) => {
        if (!def.find((d) => d.key === k)) delete editor.pageFrames[pageNumber][k];
      });
      Object.keys(editor.pageFrameRot[pageNumber]).forEach((k) => {
        if (!def.find((d) => d.key === k)) delete editor.pageFrameRot[pageNumber][k];
      });
    } else {
      editor.pageFrames[pageNumber] = {};
      editor.pageFrameRot[pageNumber] = {};
    }
  }

  function clearPageAllLayouts(pageNumber) {
    if (isLockedPage(pageNumber)) return;
    if (editor.pageSlots?.[pageNumber]) {
      editor.pageSlots[pageNumber].A = null;
      editor.pageSlots[pageNumber].B = null;
    }
    if (editor.pageRot?.[pageNumber]) {
      editor.pageRot[pageNumber].A = 0;
      editor.pageRot[pageNumber].B = 0;
    }
    if (editor.pageFrames?.[pageNumber]) {
      Object.keys(editor.pageFrames[pageNumber]).forEach((k) => editor.pageFrames[pageNumber][k] = null);
    }
    if (editor.pageFrameRot?.[pageNumber]) {
      Object.keys(editor.pageFrameRot[pageNumber]).forEach((k) => editor.pageFrameRot[pageNumber][k] = 0);
    }
    if (editor.pageObjects?.[pageNumber]) {
      editor.pageObjects[pageNumber] = [];
    }
    // Note: spreadPhoto is independent — only removed via its own X button
  }

  function clearPagePhotosOnly(pageNumber) {
    if (isLockedPage(pageNumber)) return;
    if (editor.pageSlots?.[pageNumber]) {
      editor.pageSlots[pageNumber].A = null;
      editor.pageSlots[pageNumber].B = null;
    }
    if (editor.pageRot?.[pageNumber]) {
      editor.pageRot[pageNumber].A = 0;
      editor.pageRot[pageNumber].B = 0;
    }
    if (editor.pageFrames?.[pageNumber]) {
      Object.keys(editor.pageFrames[pageNumber]).forEach(k => { editor.pageFrames[pageNumber][k] = null; });
    }
    if (editor.pageFrameRot?.[pageNumber]) {
      Object.keys(editor.pageFrameRot[pageNumber]).forEach(k => { editor.pageFrameRot[pageNumber][k] = 0; });
    }
    // Note: spreadPhoto is independent — only removed via its own X button
  }

  function pageHasAnyPhotos(pageNumber) {
    if (isTemplatePage(pageNumber)) {
      const m = editor.pageFrames?.[pageNumber] || {};
      return Object.values(m).some(Boolean);
    }
    const d = editor.pageSlots?.[pageNumber];
    return !!(d && (d.A || d.B));
  }

  function pageHasAnyContent(pageNumber) {
    if (isLockedPage(pageNumber)) return false;
    const si = Math.floor((pageNumber - 1) / 2);
    if (editor.spreadPhoto?.[si]) return true;
    // Only free photo-frames that hold a photo count as photo-content
    const freeObjs = editor.pageObjects?.[pageNumber] || [];
    if (freeObjs.some(o => o.type === "photo-frame" && o.photoId)) return true;
    return pageHasAnyPhotos(pageNumber);
  }

  function showChoiceDialog(title, message, options) {
    return new Promise((resolve) => {
      const overlay = document.createElement("div");
      overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:999999;display:flex;align-items:center;justify-content:center;";
      const modal = document.createElement("div");
      modal.style.cssText = "background:#1e1e1e;border:1px solid #444;border-radius:16px;padding:24px;max-width:320px;width:90%;box-shadow:0 20px 60px rgba(0,0,0,0.6);";
      const ttl = document.createElement("div");
      ttl.style.cssText = "font-weight:900;font-size:15px;color:#fff;margin-bottom:8px;";
      ttl.textContent = title;
      const msg = document.createElement("div");
      msg.style.cssText = "font-size:13px;color:#aaa;margin-bottom:20px;line-height:1.5;";
      msg.textContent = message;
      const btnWrap = document.createElement("div");
      btnWrap.style.cssText = "display:flex;flex-direction:column;gap:8px;";
      modal.appendChild(ttl);
      modal.appendChild(msg);
      modal.appendChild(btnWrap);
      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      const cleanup = (id) => { document.body.removeChild(overlay); resolve(id); };
      options.forEach((opt) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = opt.label;
        const isPrimary = opt.id !== "cancel";
        btn.style.cssText = `padding:10px 14px;border-radius:8px;font-weight:800;font-size:13px;cursor:pointer;border:1px solid ${isPrimary ? "#a9b4ff" : "#444"};background:${isPrimary ? "#a9b4ff" : "#2a2a2a"};color:${isPrimary ? "#1e1e1e" : "#ccc"};`;
        btn.addEventListener("click", () => cleanup(opt.id));
        btnWrap.appendChild(btn);
      });
      overlay.addEventListener("click", (e) => { if (e.target === overlay) cleanup(null); });
    });
  }

  async function handleSpreadZoneDrop(zone, payload, leftPage, rightPage, si) {
    const photoId = payload?.photoId;
    if (!photoId) return;
    const used = getUsedPhotoIds();
    if (payload.type === "photo" && used.has(photoId)) showReuseNotice();

    if (zone === "left") {
      const hasContent = pageHasAnyContent(leftPage);
      if (hasContent) {
        const choice = await showChoiceDialog("Page has content", "This page already has content. What would you like to do?", [
          { id: "replace", label: "Replace existing content" },
          { id: "add", label: "Add alongside" },
          { id: "cancel", label: "Cancel" }
        ]);
        if (!choice || choice === "cancel") return;
        if (choice === "replace") {
          pushUndoState();
          clearPageAllLayouts(leftPage);
          editor.pageSlots[leftPage].A = photoId;
        } else {
          pushUndoState();
          if (!editor.pageSlots[leftPage].B) {
            editor.pageSlots[leftPage].B = editor.pageSlots[leftPage].A ? photoId : null;
            if (!editor.pageSlots[leftPage].A) editor.pageSlots[leftPage].A = photoId;
            else editor.pageSlots[leftPage].B = photoId;
          } else {
            editor.pageSlots[leftPage].A = photoId;
          }
        }
      } else {
        pushUndoState();
        if (!editor.pageSlots[leftPage]) editor.pageSlots[leftPage] = { A: null, B: null };
        editor.pageSlots[leftPage].A = photoId;
      }
    } else if (zone === "right") {
      if (!rightPage || rightPage > editor.totalPages) return;
      const hasContent = pageHasAnyContent(rightPage);
      if (hasContent) {
        const choice = await showChoiceDialog("Page has content", "This page already has content. What would you like to do?", [
          { id: "replace", label: "Replace existing content" },
          { id: "add", label: "Add alongside" },
          { id: "cancel", label: "Cancel" }
        ]);
        if (!choice || choice === "cancel") return;
        if (choice === "replace") {
          pushUndoState();
          clearPageAllLayouts(rightPage);
          editor.pageSlots[rightPage].A = photoId;
        } else {
          pushUndoState();
          if (!editor.pageSlots[rightPage]) editor.pageSlots[rightPage] = { A: null, B: null };
          if (!editor.pageSlots[rightPage].A) editor.pageSlots[rightPage].A = photoId;
          else if (!editor.pageSlots[rightPage].B) editor.pageSlots[rightPage].B = photoId;
          else editor.pageSlots[rightPage].A = photoId;
        }
      } else {
        pushUndoState();
        if (!editor.pageSlots[rightPage]) editor.pageSlots[rightPage] = { A: null, B: null };
        editor.pageSlots[rightPage].A = photoId;
      }
    } else if (zone === "spread") {
      const leftHas = pageHasAnyContent(leftPage);
      const rightHas = rightPage <= editor.totalPages && pageHasAnyContent(rightPage);
      if (leftHas || rightHas) {
        let clearMsg = "Placing a full-spread photo will clear content on ";
        if (leftHas && rightHas) clearMsg += "both pages.";
        else if (leftHas) clearMsg += "the left page.";
        else clearMsg += "the right page.";
        const choice = await showChoiceDialog("Full spread photo", clearMsg, [
          { id: "continue", label: "Continue" },
          { id: "cancel", label: "Cancel" }
        ]);
        if (!choice || choice === "cancel") return;
      }
      pushUndoState();
      clearPageAllLayouts(leftPage);
      if (rightPage <= editor.totalPages) clearPageAllLayouts(rightPage);
      if (!editor.spreadPhoto) editor.spreadPhoto = {};
      editor.spreadPhoto[si] = { photoId, panX: 0, panY: 0, zoom: 1 };
    }
    renderSpread();
    renderThumbsRail();
    renderPhotoTray();
  }

  async function setPageTemplateWithConfirm(pageNumber, templateId) {
    if (isLockedPage(pageNumber)) return false;

    const pageHasPhotos = pageHasAnyPhotos(pageNumber);
    if (pageHasPhotos) {
      const choice = await showChoiceDialog(
        "This page has photos",
        "How would you like to apply the layout?",
        [
          { id: "over", label: "Apply layout over existing photos" },
          { id: "replace", label: "Remove photos and apply layout" },
          { id: "cancel", label: "Cancel" }
        ]
      );
      if (!choice || choice === "cancel") return false;
      pushUndoState();
      if (choice === "replace") clearPageAllLayouts(pageNumber);
    } else {
      pushUndoState();
      clearPageAllLayouts(pageNumber);
    }

    ensureTemplateState(pageNumber, templateId || null);
    renderSpread();
    renderThumbsRail();
    renderPhotoTray();
    return true;
  }

  function rotateCCW90(editorObj, pageNumber, slot) {
    if (!editorObj.pageRot[pageNumber]) {
      editorObj.pageRot[pageNumber] = { A: 0, B: 0 };
    }
    const cur = editorObj.pageRot[pageNumber][slot] || 0;
    editorObj.pageRot[pageNumber][slot] = (cur - 90 + 360) % 360;
  }

  function rotateFrameCCW90(editorObj, pageNumber, slotKey) {
    if (isTemplatePage(pageNumber)) {
      if (!editorObj.pageFrameRot[pageNumber]) editorObj.pageFrameRot[pageNumber] = {};
      const cur = editorObj.pageFrameRot[pageNumber][slotKey] || 0;
      editorObj.pageFrameRot[pageNumber][slotKey] = (cur - 90 + 360) % 360;
    } else {
      rotateCCW90(editorObj, pageNumber, slotKey);
    }
  }

  function getFramePhotoId(pageNumber, slotKey) {
    if (isTemplatePage(pageNumber)) return editor.pageFrames?.[pageNumber]?.[slotKey] || null;
    return editor.pageSlots?.[pageNumber]?.[slotKey] || null;
  }

  function setFramePhotoId(pageNumber, slotKey, photoId) {
    if (isTemplatePage(pageNumber)) editor.pageFrames[pageNumber][slotKey] = photoId || null;
    else editor.pageSlots[pageNumber][slotKey] = photoId || null;
  }

  function getFrameRotation(pageNumber, slotKey) {
    if (isTemplatePage(pageNumber)) return editor.pageFrameRot?.[pageNumber]?.[slotKey] || 0;
    return editor.pageRot?.[pageNumber]?.[slotKey] || 0;
  }

  function setFrameRotation(pageNumber, slotKey, deg) {
    if (isTemplatePage(pageNumber)) editor.pageFrameRot[pageNumber][slotKey] = deg || 0;
    else editor.pageRot[pageNumber][slotKey] = deg || 0;
  }

  function clearFrame(pageNumber, slotKey) {
    setFramePhotoId(pageNumber, slotKey, null);
    setFrameRotation(pageNumber, slotKey, 0);
  }

  function getBodyRelativeFrameRects(bodyEl, pageNumber) {
    const tid = getPageTemplateId(pageNumber);
    if (!tid) return null;

    const def = TEMPLATE_DEFS[tid];
    const w = bodyEl.clientWidth || 1;
    const h = bodyEl.clientHeight || 1;

    return def.map((f) => ({
      key: f.key,
      x: (f.x / 100) * w,
      y: (f.y / 100) * h,
      w: (f.w / 100) * w,
      h: (f.h / 100) * h
    }));
  }

  function pickNearestTemplateFrame(bodyEl, pageNumber, clientX, clientY) {
    const rects = getBodyRelativeFrameRects(bodyEl, pageNumber);
    if (!rects || !rects.length) return null;

    const b = bodyEl.getBoundingClientRect();
    const x = clientX - b.left;
    const y = clientY - b.top;

    for (const r of rects) {
      if (x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h) return r;
    }

    let best = null;
    let bestD = Infinity;
    rects.forEach((r) => {
      const cx = r.x + r.w / 2;
      const cy = r.y + r.h / 2;
      const d = (cx - x) ** 2 + (cy - y) ** 2;
      if (d < bestD) {
        bestD = d;
        best = r;
      }
    });
    return best;
  }

  function renderTemplateMini(el, templateId) {
    el.innerHTML = "";
    const defs = TEMPLATE_DEFS[templateId] || [];
    defs.forEach((f) => {
      const d = document.createElement("div");
      d.className = "dmb-template-mini-frame";
      d.style.left = f.x + "%";
      d.style.top = f.y + "%";
      d.style.width = f.w + "%";
      d.style.height = f.h + "%";
      el.appendChild(d);
    });
  }

  function buildTemplatePanel(pageNumber, pageEl) {
    const panel = document.createElement("div");
    panel.className = "dmb-template-panel";
    panel.style.display = "none";

    const title = document.createElement("div");
    title.className = "dmb-template-panel-title";
    title.textContent = "Choose template";
    panel.appendChild(title);

    const list = document.createElement("div");
    list.className = "dmb-template-list";
    panel.appendChild(list);

    const addItem = (id, name, subtitle, isDefault = false) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-template-item";

      const currentId = getPageTemplateId(pageNumber);
      if ((isDefault && !currentId) || (!isDefault && currentId === id)) {
        btn.classList.add("active");
      }

      const row = document.createElement("div");
      row.className = "dmb-template-item-row";

      const mini = document.createElement("div");
      mini.className = "dmb-template-mini";

      if (isDefault) {
        const a = document.createElement("div");
        a.className = "dmb-template-mini-frame";
        a.style.left = "0";
        a.style.top = "0";
        a.style.width = "100%";
        a.style.height = "49%";

        const b = document.createElement("div");
        b.className = "dmb-template-mini-frame";
        b.style.left = "0";
        b.style.top = "51%";
        b.style.width = "100%";
        b.style.height = "49%";

        mini.appendChild(a);
        mini.appendChild(b);
      } else {
        renderTemplateMini(mini, id);
      }

      const txt = document.createElement("div");
      txt.style.minWidth = "0";

      const nm = document.createElement("div");
      nm.className = "dmb-template-item-name";
      nm.textContent = name;

      const sub = document.createElement("div");
      sub.className = "dmb-template-item-sub";
      sub.textContent = subtitle;

      txt.appendChild(nm);
      txt.appendChild(sub);

      row.appendChild(mini);
      row.appendChild(txt);
      btn.appendChild(row);

      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isDefault) await setPageTemplateWithConfirm(pageNumber, null);
        else await setPageTemplateWithConfirm(pageNumber, id);
      });

      list.appendChild(btn);
    };

    addItem(null, "Default Layout", "1 photo full / 2-photo split", true);

    Object.keys(TEMPLATE_DEFS).forEach((id) => {
      addItem(id, TEMPLATE_NAMES[id] || id.toUpperCase(), `${TEMPLATE_DEFS[id].length} frame(s)`);
    });

    pageEl.appendChild(panel);
    return panel;
  }

  // ---------- elements ----------
  const params = new URLSearchParams(window.location.search);
  const stepParam    = params.get("step");
  const mode         = params.get("mode");
  const restoreParam = params.get("restore");
  const coverTitleParam = params.get("cover_title");
  const coverImgParam = params.get("cover_img");
  const coverHandleParam = params.get("cover");
  const templateParam = params.get("template");

  const step1 = $("step1");
  const step2 = $("step2");
  const step3 = $("step3");
  const builderStep = step2;
  const exportTemplateBtn = $("exportTemplateBtn");

  const selectedCoverBox = $("selectedCoverBox");
  const selectedCoverImg = $("selectedCoverImg");
  const selectedCoverTitle = $("selectedCoverTitle");
  const bookDetails = $("bookDetails");
  const customizeBlock = $("customizeBlock");

  const titleEl = $("bookTitle"); // legacy fallback
  const pagesEl = $("pages");
  const mainError = $("mainError");

  const priceBox = $("priceBox");
  const oldPriceEl = $("oldPrice");
  const newPriceEl = $("newPrice");

  const photosEl = $("bookPhotos");
  const photoRuleEl = $("photoRule");
  const photoCountEl = $("photoCount");
  const photoErrorEl = $("photoError");
  const photoPreviewEl = $("photoPreview");

  // cover designer
  const chooseCoverTemplateBtn = $("chooseCoverTemplateBtn");
  const coverTemplatePanel = $("coverTemplatePanel");
  const coverTitle1Input = $("coverTitle1");
  const coverTitle2Input = $("coverTitle2");
  const coverColorInput = $("coverColor");
  const coverColorSwatch = $("coverColorSwatch");
  const coverImageInput = $("coverImageInput");

  // editor ui
  const editorPhotoTray = $("editorPhotoTray");
  const bookMeta = $("bookMeta");
  const spreadIndexEl = $("spreadIndex");
  const spreadCanvas = $("spreadCanvas");
  const prevSpreadBtn = $("prevSpreadBtn");
  const nextSpreadBtn = $("nextSpreadBtn");
  const backToDetailsBtn = $("backToDetailsBtn");
  const saveLayoutBtn = $("saveLayoutBtn");
  const saveTemplateBtn = $("saveTemplateBtn");
  const saveMsg = $("saveMsg");
  const undoBtn = $("undoBtn");
  const addToCartBtn = $("addToCartBtn");
  const thumbsRail = $("thumbsRail");
  const spreadViewport = $("spreadViewport");
  const redoBtn = $("redoBtn");
  const previewBtn = $("previewBtn");
  const zoomInBtn = $("zoomInBtn");
  const zoomOutBtn = $("zoomOutBtn");
  const zoomResetBtn = $("zoomResetBtn");
  const smartCreationBtn = $("smartCreationBtn");
  const coverThumbBtn = $("coverThumbBtn");
  const canvasTextBtn = $("canvasTextBtn");
  const canvasPhotoBtn = $("canvasPhotoBtn");
  const canvasLayoutBtn = $("canvasLayoutBtn");
  const canvasShapeBtn = $("canvasShapeBtn");
  const canvasLayersBtn = $("canvasLayersBtn");
  const canvasDeleteBtn = $("canvasDeleteBtn");
  const addTextBtn = $("addTextBtn");
  const projectMenuBtn = $("projectMenuBtn");
  const historyBtn = $("historyBtn");
  const addMorePhotosBtn = $("addMorePhotosBtn");
  const importDeviceBtn = $("importDeviceBtn");
  const importCameraBtn = $("importCameraBtn");
  const cameraPhotos = $("cameraPhotos");
  const photoSortSelect = $("photoSortSelect");
  const hideUsedPhotosToggle = $("hideUsedPhotosToggle");
  const coverThumbBtnEl = $("coverThumbBtn");

  if (!step1 || !builderStep) return;

  // ---------- state ----------
  let bookFiles = [];
  let currentMin = 0;
  let currentMax = 0;
  let hideUsedPhotos = false;
  let currentPhotoSort = "earliest";
  let currentPhotoSearch = "";
  let currentZoom = 1;
  let redoStack = [];
  let builderMode = "pages";
  let selectedObject = null;
  let activeCoverZone = "front";

  // ---------- undo ----------
  const undoStack = [];
  const UNDO_LIMIT = 100;

  function cloneState(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function exportTemplateJSON() {
    const payload = buildTemplatePayload();

    // Strip test photos — keep everything else (text, stickers, icons, maps)
    payload.coverState.frontImageUrl = "";
    payload.coverState.backImageUrl = "";
    payload.coverState.imageUrl = "";
    payload.coverState.imageFile = null;
    payload.coverObjects = (payload.coverObjects || []).map(obj =>
      obj.type === "photo-frame" ? { ...obj, imageUrl: null, imageData: null } : obj
    );
    if (payload.page0?.pageSlots) payload.page0.pageSlots = { A: null, B: null };

    const json = JSON.stringify(payload, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    // Use the book handle so each book type has its own template file.
    // e.g. ?cover=photobook-20x20 → cover-photobook-20x20.json
    // Falls back to cover-default.json when no handle is in the URL.
    const _handle = (new URLSearchParams(window.location.search).get("cover") || "").trim();
    a.download = _handle ? ("cover-" + _handle + ".json") : "cover-default.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }


  async function dmbApplyCoverTemplate(tag) {
    if (!tag) return;
    try {
      const base = new URL(window.DMB_ASSET_BASE, window.location.href);
      base.pathname = base.pathname.replace(/\/[^\/]+$/, "/cover-" + tag + ".json");
      base.search = "";
      const resp = await fetch(base.toString());
      if (!resp.ok) return;
      const data = await resp.json();
      if (data.coverState) {
        Object.assign(coverState, data.coverState);
        syncCoverInputsFromState();
      }
      if (Array.isArray(data.coverObjects)) {
        editor.coverObjects = data.coverObjects;
      }
      if (data.activeCoverZone) activeCoverZone = data.activeCoverZone;
      if (data.coverUserTexts) editor.coverUserTexts = cloneState(data.coverUserTexts);
      if (data.page0) {
        if (!editor.pageSlots) editor.pageSlots = {};
        if (!editor.pageFrames) editor.pageFrames = {};
        if (!editor.pageTemplate) editor.pageTemplate = {};
        if (!editor.pageObjects) editor.pageObjects = {};
        if (!editor.pageRot) editor.pageRot = {};
        editor.pageSlots[0] = cloneState(data.page0.pageSlots || { A: null, B: null });
        editor.pageFrames[0] = cloneState(data.page0.pageFrames || {});
        editor.pageTemplate[0] = data.page0.pageTemplate || null;
        editor.pageObjects[0] = cloneState(data.page0.pageObjects || []);
        editor.pageRot[0] = cloneState(data.page0.pageRot || { A: 0, B: 0 });
      }
      renderCoverCanvas();
      // Template also replaces page 0 content — dirty-mark it too
      try { _dmbPvMarkDirty(0); } catch(e) {}
    } catch (err) {
      console.warn("[DMB] Cover template load failed:", err);
    }
  }

  function getTemplateKey() {
    const liveTemplate = new URLSearchParams(window.location.search).get("template");
    return (liveTemplate || "").trim();
  }

  // ── Customer progress save/load (per-book, persists across sessions) ──────

  function getCustomerSaveKey() {
    const type = window.DMB_MAGAZINE_MODE ? "mag" : "book";
    const tKey = getTemplateKey();
    return `dmb_progress_${type}_${tKey || "custom"}`;
  }

  // ── IndexedDB photo persistence ──────────────────────────────────────────
  function _openPhotoDB() {
    return new Promise((resolve, reject) => {
      const req = indexedDB.open("dmb_photo_store", 1);
      req.onupgradeneeded = (e) => {
        const db = e.target.result;
        if (!db.objectStoreNames.contains("blobs")) db.createObjectStore("blobs");
      };
      req.onsuccess = (e) => resolve(e.target.result);
      req.onerror = () => reject(req.error);
    });
  }

  async function _savePhotosToIDB(saveKey, photos) {
    if (!Array.isArray(photos) || !photos.length) return;
    try {
      // Step 1: fetch all blobs OUTSIDE any IDB transaction
      // (IDB transactions auto-commit when they go idle between awaits)
      const blobEntries = [];
      for (const ph of photos) {
        if (!ph.url) continue;
        try {
          const resp = await fetch(ph.url);
          const blob = await resp.blob();
          blobEntries.push({ id: ph.id, blob });
        } catch(e) { /* skip individual failures */ }
      }

      // Step 2: write everything in one synchronous transaction
      const db = await _openPhotoDB();
      const tx = db.transaction("blobs", "readwrite");
      const store = tx.objectStore("blobs");

      const meta = photos.map(p => ({
        id: p.id, ratio: p.ratio, filename: p.filename,
        dateTaken: p.dateTaken, tags: p.tags, addedIndex: p.addedIndex
      }));
      store.put(meta, saveKey + "__meta");

      for (const { id, blob } of blobEntries) {
        store.put(blob, saveKey + "__" + id);
      }

      await new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = () => rej(tx.error); });
      db.close();
    } catch(e) { console.warn("[DMB] savePhotos:", e); }
  }

  async function _loadPhotosFromIDB(saveKey) {
    try {
      const db = await _openPhotoDB();
      const tx = db.transaction("blobs", "readonly");
      const store = tx.objectStore("blobs");
      const meta = await new Promise(res => {
        const r = store.get(saveKey + "__meta");
        r.onsuccess = () => res(r.result || []);
        r.onerror = () => res([]);
      });
      if (!meta.length) { db.close(); return []; }
      const photos = [];
      for (const m of meta) {
        const blob = await new Promise(res => {
          const r = store.get(saveKey + "__" + m.id);
          r.onsuccess = () => res(r.result || null);
          r.onerror = () => res(null);
        });
        if (blob) {
          photos.push({ ...m, file: null, url: URL.createObjectURL(blob) });
        }
      }
      db.close();
      return photos;
    } catch(e) { console.warn("[DMB] loadPhotos:", e); return []; }
  }

  async function _clearPhotosFromIDB(saveKey) {
    try {
      const db = await _openPhotoDB();
      const tx = db.transaction("blobs", "readwrite");
      const store = tx.objectStore("blobs");
      const keys = await new Promise(res => {
        const r = store.getAllKeys();
        r.onsuccess = () => res(r.result || []);
        r.onerror = () => res([]);
      });
      keys.filter(k => String(k).startsWith(saveKey + "__")).forEach(k => store.delete(k));
      await new Promise(res => { tx.oncomplete = res; tx.onerror = res; });
      db.close();
    } catch(e) {}
  }

  // ── Public save / load / clear ───────────────────────────────────────────
  async function saveCustomerProgress() {
    const key = getCustomerSaveKey();
    try {
      // Save builder state to localStorage (with timestamp)
      const payload = getCurrentBuilderStateSnapshot();
      payload.savedAt = new Date().toISOString();
      payload._saveType = window.DMB_MAGAZINE_MODE ? "magazine" : "book";
      payload._templateKey = getTemplateKey() || "custom";
      // Cover handle: try URL ?cover= param, then ?template= param, then carry
      // forward whatever was stored in the previous save (so re-saving from
      // ?restore=1 — which has no ?cover= — doesn't lose the original handle).
      const _urlCover = new URLSearchParams(window.location.search).get("cover") || getTemplateKey() || "";
      const _prevSave = loadCustomerProgress();
      payload._coverHandle = _urlCover || (_prevSave && _prevSave._coverHandle) || "";
      localStorage.setItem(key, JSON.stringify(payload));
    } catch(e) {
      alert("Could not save layout (storage full?)."); return;
    }
    // Save photos to IndexedDB in background — show progress
    if (saveMsg) { saveMsg.textContent = "Saving photos…"; saveMsg.style.display = "block"; }
    await _savePhotosToIDB(key, editor.photos || []);
    if (saveMsg) {
      saveMsg.textContent = "All saved ✅";
      setTimeout(() => { saveMsg.style.display = "none"; }, 2500);
    }
  }

  function loadCustomerProgress() {
    try {
      const raw = localStorage.getItem(getCustomerSaveKey());
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  }

  async function clearCustomerProgress() {
    const key = getCustomerSaveKey();
    try { localStorage.removeItem(key); } catch {}
    await _clearPhotosFromIDB(key);
  }

  function offerCustomerProgressRestore() {
    // If we arrived via ?restore=1, the IIFE below already handles restore
    // automatically — don't show the banner on top of that.
    if (restoreParam === "1") return;
    const saved = loadCustomerProgress();
    if (!saved) return;

    const banner = document.createElement("div");
    banner.style.cssText = "position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#1e1e1e;color:#fff;border-radius:12px;padding:14px 20px;display:flex;align-items:center;gap:14px;z-index:999999;box-shadow:0 8px 30px rgba(0,0,0,.5);font-size:14px;font-weight:700;max-width:92vw;";
    banner.innerHTML = `<span>📂 Resume from where you left off?</span>`;

    const yesBtn = document.createElement("button");
    yesBtn.textContent = "Resume";
    yesBtn.style.cssText = "background:#4a90e2;color:#fff;border:none;border-radius:8px;padding:8px 16px;cursor:pointer;font-weight:900;font-size:13px;flex-shrink:0;";

    const noBtn = document.createElement("button");
    noBtn.textContent = "Start fresh";
    noBtn.style.cssText = "background:#444;color:#fff;border:none;border-radius:8px;padding:8px 14px;cursor:pointer;font-weight:700;font-size:13px;flex-shrink:0;";

    banner.appendChild(yesBtn);
    banner.appendChild(noBtn);
    document.body.appendChild(banner);

    yesBtn.addEventListener("click", async () => {
      banner.remove();
      if (saveMsg) { saveMsg.textContent = "Restoring…"; saveMsg.style.display = "block"; }

      const _cl = v => { try { return JSON.parse(JSON.stringify(v || {})); } catch(e) { return {}; } };
      const se  = saved.editor || {};

      // ── 1. Load IDB photos ───────────────────────────────────────────────
      const idbPhotos = await _loadPhotosFromIDB(getCustomerSaveKey());
      // Only replace editor.photos if IDB has them (IDs will match saved page slots)
      const useIdb = idbPhotos.length > 0;
      if (useIdb) {
        editor.photos = idbPhotos;
        try { bookFiles = idbPhotos.map(p => p.file || new File([], p.filename || "photo")); } catch(e) {}
      }
      // If no IDB photos: keep current editor.photos (this session's uploads).
      // We skip restoring page-slot assignments since IDs won't match.

      // ── 2. Always restore cover state (does not depend on photo IDs) ─────
      if (saved.coverState) {
        const cs = saved.coverState;
        ["frontImageUrl","backImageUrl","bleedImageUrl","spineImageUrl","imageUrl"].forEach(k => {
          if (cs[k] && String(cs[k]).startsWith("blob:")) {
            cs[k] = ""; if (k === "bleedImageUrl") { cs.bleedZone = ""; cs.bleedImageId = ""; }
          }
        });
        Object.keys(cs).forEach(k => { try { coverState[k] = cs[k]; } catch(e) {} });
        if (coverColorSwatch) coverColorSwatch.style.background = coverState.color || "#ffffff";
        try { syncCoverInputsFromState(); } catch(e) {}
      }

      // ── 3. Always restore page structure (layout templates, stickers, maps)
      editor.pageTemplate    = _cl(se.pageTemplate);
      editor.pageFrames      = _cl(se.pageFrames);
      editor.pageFrameRot    = _cl(se.pageFrameRot);
      editor.pageFrameShapes = _cl(se.pageFrameShapes);
      editor.pageObjects     = _cl(se.pageObjects);
      editor.coverObjects    = Array.isArray(se.coverObjects)   ? _cl(se.coverObjects)   : [];
      editor.coverUserTexts  = Array.isArray(se.coverUserTexts) ? _cl(se.coverUserTexts) : [];
      if (!Array.isArray(editor.coverObjects)) try { migrateCoverObjectsToFlat(); } catch(e) {}

      // ── 4. Restore photo assignments ONLY if IDB photos are available ────
      if (useIdb) {
        editor.pageSlots   = _cl(se.pageSlots);
        editor.pageRot     = _cl(se.pageRot);
        editor.spreadPhoto = _cl(se.spreadPhoto || {});
      }
      // If no IDB: keep current pageSlots (user will drag fresh photos to pages)

      // ── 5. Restore pages count ───────────────────────────────────────────
      const pg = se.totalPages || Number(saved.pages_selected) || editor.totalPages || 0;
      if (pg) {
        editor.totalPages    = pg;
        editor.editablePages = se.editablePages || Math.max(0, pg - 1);
        editor.totalSpreads  = se.totalSpreads  || Math.max(1, Math.ceil(pg / 2));
        const _pEl = document.getElementById("pages");
        if (_pEl) _pEl.value = String(pg);
        try { updatePrice(); } catch(e) {}
      }
      editor.currentSpread = 0;
      builderMode = saved.builderMode || "pages";

      // ── 6. Re-render ─────────────────────────────────────────────────────
      try { syncCoverInputsFromState(); } catch(e) {}
      try { renderPhotoTray(); }          catch(e) {}
      try { renderThumbsRail(); }         catch(e) {}
      // Explicitly re-render the cover even if builderMode is "pages",
      // because coverState + coverObjects were just restored.
      try { renderCoverCanvas(); }        catch(e) {}
      try { renderBuilderCanvas(); }      catch(e) {}
      // Progress restore replaces ALL pages — clear stale preview cache
      try { _dmbPvReinitAll(); }          catch(e) {}

      if (saveMsg) {
        saveMsg.textContent = useIdb
          ? `✅ Restored — ${idbPhotos.length} photos + full layout`
          : "✅ Cover & layout restored — drag your photos onto the pages";
        setTimeout(() => { saveMsg.style.display = "none"; }, 4000);
      }
    });

    noBtn.addEventListener("click", async () => {
      banner.remove();
      await clearCustomerProgress();
    });

    setTimeout(() => { if (banner.isConnected) banner.remove(); }, 30000);
  }

  function buildTemplatePayload() {
    return {
      coverState: cloneState(coverState),
      coverObjects: cloneState(ensureCoverObjects()),
      activeCoverZone: activeCoverZone || "front",
      coverUserTexts: cloneState(editor.coverUserTexts || []),
      page0: {
        pageSlots: cloneState(editor.pageSlots?.[0] || { A: null, B: null }),
        pageFrames: cloneState(editor.pageFrames?.[0] || {}),
        pageTemplate: editor.pageTemplate?.[0] || null,
        pageObjects: cloneState(editor.pageObjects?.[0] || []),
        pageRot: cloneState(editor.pageRot?.[0] || { A: 0, B: 0 })
      }
    };
  }

  function saveCurrentTemplate() {
    const templateKey = getTemplateKey();

    if (!templateKey) {
      alert("No template key found in the URL.");
      return;
    }

    try {
      const payload = buildTemplatePayload();
      localStorage.setItem(getTemplateStorageKey(templateKey), JSON.stringify(payload));

      if (saveMsg) {
        saveMsg.textContent = `Template ${templateKey} saved ✅`;
        saveMsg.style.display = "block";
        setTimeout(() => { saveMsg.style.display = "none"; }, 1600);
      }
    } catch (err) {
      console.error(err);
      alert("Could not save template.");
    }
  }

  function loadTemplateByKey(templateKey) {
    if (!templateKey) return false;

    try {
      const raw = localStorage.getItem(getTemplateStorageKey(templateKey));
      if (!raw) return false;

      const payload = JSON.parse(raw);

      coverState.template = payload.coverState?.template || "default";
      coverState.title1 = payload.coverState?.title1 || "";
      coverState.title2 = payload.coverState?.title2 || "";
      coverState.color = payload.coverState?.color || "#ffffff";
      coverState.imageUrl = payload.coverState?.imageUrl || "";
      coverState.imageFile = payload.coverState?.imageFile || null;
      coverState.textStyles = cloneState(payload.coverState?.textStyles || {});

      editor.coverObjects = cloneState(payload.coverObjects || []);
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      activeCoverZone = payload.activeCoverZone || "front";
      editor.coverUserTexts = cloneState(payload.coverUserTexts || []);

      // Restore Page 0 state
      if (payload.page0) {
        if (!editor.pageSlots) editor.pageSlots = {};
        if (!editor.pageFrames) editor.pageFrames = {};
        if (!editor.pageTemplate) editor.pageTemplate = {};
        if (!editor.pageObjects) editor.pageObjects = {};
        if (!editor.pageRot) editor.pageRot = {};
        editor.pageSlots[0] = cloneState(payload.page0.pageSlots || { A: null, B: null });
        editor.pageFrames[0] = cloneState(payload.page0.pageFrames || {});
        editor.pageTemplate[0] = payload.page0.pageTemplate || null;
        editor.pageObjects[0] = cloneState(payload.page0.pageObjects || []);
        editor.pageRot[0] = cloneState(payload.page0.pageRot || { A: 0, B: 0 });
      }

      syncCoverInputsFromState();
      builderMode = "cover";
      renderBuilderCanvas();
      // Template also replaces page 0 content — dirty-mark it too
      try { _dmbPvMarkDirty(0); } catch(e) {}
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  function getTemplateStorageKey(templateKey) {
    return `dmb_template_${templateKey}`;
  }

  function buildTemplatePayload() {
    return {
      coverState: cloneState(coverState),
      coverObjects: cloneState(ensureCoverObjects()),
      activeCoverZone: activeCoverZone || "front",
      coverUserTexts: cloneState(editor.coverUserTexts || []),
      page0: {
        pageSlots: cloneState(editor.pageSlots?.[0] || { A: null, B: null }),
        pageFrames: cloneState(editor.pageFrames?.[0] || {}),
        pageTemplate: editor.pageTemplate?.[0] || null,
        pageObjects: cloneState(editor.pageObjects?.[0] || []),
        pageRot: cloneState(editor.pageRot?.[0] || { A: 0, B: 0 })
      }
    };
  }

  function saveCurrentTemplate() {
    const templateKey = getTemplateKey();

    if (!templateKey) {
      alert("No template key found in the URL.");
      return;
    }

    try {
      const payload = buildTemplatePayload();
      localStorage.setItem(getTemplateStorageKey(templateKey), JSON.stringify(payload));

      if (saveMsg) {
        saveMsg.textContent = `Template ${templateKey} saved ✅`;
        saveMsg.style.display = "block";
        setTimeout(() => { saveMsg.style.display = "none"; }, 1600);
      }
    } catch (err) {
      console.error(err);
      alert("Could not save template.");
    }
  }

  function pushUndoState(actionLabel = "Edited") {
    undoStack.push({
      label: actionLabel,
      currentSpread: editor.currentSpread,
      pageSlots: cloneState(editor.pageSlots),
      pageRot: cloneState(editor.pageRot),
      pageTemplate: cloneState(editor.pageTemplate),
      pageFrames: cloneState(editor.pageFrames),
      pageFrameRot: cloneState(editor.pageFrameRot),
      pageObjects: cloneState(editor.pageObjects || {}),
      coverObjects: cloneState(ensureCoverObjects()),
      coverUserTexts: cloneState(editor.coverUserTexts || []),
      coverState: cloneState(coverState),
      builderMode
    });

    if (undoStack.length > UNDO_LIMIT) undoStack.shift();
    redoStack = [];
    autoSave();
    // Re-apply contain clips — position/size/zone may have changed
    try { _dmbReapplyAllContains(); } catch(e) {}

    // ── Dirty-mark the PDF preview cache ─────────────────────────────────
    // pushUndoState is called for most meaningful changes (sticker moves,
    // photo changes, text edits, template changes, shape resizes, map edits).
    // NOTE: spread photo pan/zoom drag does NOT call pushUndoState — that
    // case is handled separately in the spread photo mouseup handler.
    try {
      if (builderMode === "cover") {
        _dmbPvMarkDirty("cover");
      } else if (editor.currentSpread === -1) {
        _dmbPvMarkDirty(0);
      } else {
        _dmbPvMarkDirty(editor.currentSpread * 2 + 1);
        _dmbPvMarkDirty(editor.currentSpread * 2 + 2);
      }
    } catch(e) {}
  }

  function undoLastAction() {
    if (!undoStack.length) return;

    redoStack.push({
      label: "Redo",
      currentSpread: editor.currentSpread,
      pageSlots: cloneState(editor.pageSlots),
      pageRot: cloneState(editor.pageRot),
      pageTemplate: cloneState(editor.pageTemplate),
      pageFrames: cloneState(editor.pageFrames),
      pageFrameRot: cloneState(editor.pageFrameRot),
      pageObjects: cloneState(editor.pageObjects || {}),
      coverObjects: cloneState(ensureCoverObjects()),
      coverState: cloneState(coverState),
      builderMode
    });

    const prev = undoStack.pop();

    editor.currentSpread = prev.currentSpread;
    editor.pageSlots = cloneState(prev.pageSlots);
    editor.pageRot = cloneState(prev.pageRot);
    editor.pageTemplate = cloneState(prev.pageTemplate);
    editor.pageFrames = cloneState(prev.pageFrames);
    editor.pageFrameRot = cloneState(prev.pageFrameRot);
    editor.pageObjects = cloneState(prev.pageObjects || {});
    editor.coverObjects = cloneState(prev.coverObjects || []);
    if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
    editor.coverUserTexts = cloneState(prev.coverUserTexts || []);
    builderMode = prev.builderMode || "pages";

    coverState.template = prev.coverState?.template || "default";
    coverState.title1 = prev.coverState?.title1 || "";
    coverState.title2 = prev.coverState?.title2 || "";
    coverState.color = prev.coverState?.color || "#ffffff";
    coverState.imageUrl = prev.coverState?.imageUrl || "";
    coverState.imageFile = prev.coverState?.imageFile || null;
    coverState.textStyles = cloneState(prev.coverState?.textStyles || {});

    syncCoverInputsFromState();
    renderBuilderCanvas();
    renderThumbsRail();
    renderPhotoTray();
    autoSave();
    // Undo restores ALL pages — clear and re-render the entire preview cache
    try { _dmbPvReinitAll(); } catch(e) {}
  }

  function redoLastAction() {
    if (!redoStack.length) return;

    undoStack.push({
      label: "Undo",
      currentSpread: editor.currentSpread,
      pageSlots: cloneState(editor.pageSlots),
      pageRot: cloneState(editor.pageRot),
      pageTemplate: cloneState(editor.pageTemplate),
      pageFrames: cloneState(editor.pageFrames),
      pageFrameRot: cloneState(editor.pageFrameRot),
      pageObjects: cloneState(editor.pageObjects || {}),
      coverObjects: cloneState(ensureCoverObjects()),
      coverState: cloneState(coverState),
      builderMode
    });

    const next = redoStack.pop();

    editor.currentSpread = next.currentSpread;
    editor.pageSlots = cloneState(next.pageSlots);
    editor.pageRot = cloneState(next.pageRot);
    editor.pageTemplate = cloneState(next.pageTemplate);
    editor.pageFrames = cloneState(next.pageFrames);
    editor.pageFrameRot = cloneState(next.pageFrameRot);
    editor.pageObjects = cloneState(next.pageObjects || {});
    editor.coverObjects = cloneState(next.coverObjects || []);
    if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
    editor.coverUserTexts = cloneState(next.coverUserTexts || []);
    builderMode = next.builderMode || "pages";

    coverState.template = next.coverState?.template || "default";
    coverState.title1 = next.coverState?.title1 || "";
    coverState.title2 = next.coverState?.title2 || "";
    coverState.color = next.coverState?.color || "#ffffff";
    coverState.imageUrl = next.coverState?.imageUrl || "";
    coverState.imageFile = next.coverState?.imageFile || null;
    coverState.textStyles = cloneState(next.coverState?.textStyles || {});

    syncCoverInputsFromState();
    renderBuilderCanvas();
    renderThumbsRail();
    renderPhotoTray();
    autoSave();
    // Redo restores ALL pages — clear and re-render the entire preview cache
    try { _dmbPvReinitAll(); } catch(e) {}
  }
  // ---------- cover storage ----------
  function saveCoverToStorage(cover) {
    try { localStorage.setItem("dmb_selected_cover", JSON.stringify(cover)); } catch {}
  }

  function loadCoverFromStorage() {
    try {
      const raw = localStorage.getItem("dmb_selected_cover");
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function syncStepVisibility() {
    if (!step1 || !builderStep) return;

    const builderVisible = getComputedStyle(builderStep).display !== "none";
    if (builderVisible) {
      step1.style.display = "none";
      if (bookDetails) bookDetails.style.display = "none";
    }
  }

  syncStepVisibility();

  try {
    const obs = new MutationObserver(syncStepVisibility);
    obs.observe(builderStep, { attributes: true, attributeFilter: ["style", "class"] });
  } catch {}

  document.addEventListener("click", () => setTimeout(syncStepVisibility, 0), true);

  if (mode !== "customize" && (coverTitleParam || coverImgParam || coverHandleParam)) {
    saveCoverToStorage({
      title: coverTitleParam || "",
      img: coverImgParam || "",
      handle: coverHandleParam || ""
    });
  }

  if (mode === "customize") {
    try { localStorage.removeItem("dmb_selected_cover"); } catch {}
    try { sessionStorage.removeItem("dmb_selected_cover"); } catch {}
  }

  const storedCover = loadCoverFromStorage();
  const hasCoverInUrl = !!(coverTitleParam || coverImgParam || coverHandleParam);

  try {
    const noStep = !stepParam;
    const noMode = !mode;
    const noCoverParams = !hasCoverInUrl;

    if (noStep && noMode && noCoverParams) {
      localStorage.removeItem("dmb_selected_cover");
      sessionStorage.removeItem("dmb_selected_cover");
      localStorage.removeItem("dmb_mode");
    }
  } catch {}

  const shouldShowBuilder =
    stepParam === "2" ||
    mode === "customize" ||
    hasCoverInUrl ||
    restoreParam === "1";   // ← "Continue editing" from saved books page

  const shouldShowUpload = stepParam === "upload" && restoreParam !== "1";

  if (shouldShowUpload) {
    step1.style.display = "none";
    builderStep.style.display = "none";
    if (bookDetails) bookDetails.style.display = "none";
    const s1b = document.getElementById("step1b");
    if (s1b) s1b.style.display = "flex";
    try { initPhoneUpload(); } catch(e) {}

    // Register upload step handlers here (early), in case the IIFE fails later
    const _continueBtn = document.getElementById("continueToBuilderBtn");
    if (_continueBtn) {
      _continueBtn.addEventListener("click", async function() {
        const errEl = document.getElementById("uploadStepError");
        const pagesSel = document.getElementById("step1bPages");

        // ── Guard 1: pages must be selected ──────────────────────────────
        if (!pagesSel?.value) {
          if (errEl) { errEl.textContent = window.DMB_MAGAZINE_MODE ? "Please select the number of pages for your magazine." : "Please select the number of pages for your book."; errEl.style.display = "block"; }
          return;
        }

        // ── Guard 2: minimum photos (base pages − 4) ──────────────────────
        // Extra spreads added later inside the builder do NOT affect this check.
        const _basePages   = Number(pagesSel.value) || 0;
        const _minRequired = _basePages > 0 ? Math.max(1, _basePages - 4) : 0;
        const _uploaded    = bookFiles.length;
        if (_minRequired > 0 && _uploaded < _minRequired) {
          const _need = _minRequired - _uploaded;
          if (errEl) {
            errEl.textContent =
              `📸 Add ${_need} more photo${_need !== 1 ? "s" : ""} to start designing! ` +
              `You have ${_uploaded}, you need at least ${_minRequired} for ${_basePages} pages.`;
            errEl.style.display = "block";
          }
          return;
        }

        if (errEl) errEl.style.display = "none";
        if (pagesEl) pagesEl.value = pagesSel.value;
        if (s1b) s1b.style.display = "none";
        if (step1) step1.style.display = "none";
        if (builderStep) builderStep.style.display = "block";
        try { await openEditor(); } catch(err) { console.error("openEditor failed:", err); }
        if (window.DMB_MAGAZINE_MODE) {
          const magHandle = sessionStorage.getItem("dmb_mag_template");
          if (magHandle) {
            sessionStorage.removeItem("dmb_mag_template");
            // Persist handle in URL so saveCurrentTemplate() names the file correctly
            try {
              const _u = new URL(window.location.href);
              _u.searchParams.set("cover", magHandle);
              history.replaceState(null, "", _u.toString());
            } catch {}
            try { await dmbApplyCoverTemplate(magHandle); } catch(err) {}
          }
        } else {
          if (coverHandleParam) {
            try { await dmbApplyCoverTemplate(coverHandleParam); } catch(err) { console.warn("Cover template apply failed:", err); }
          }
        }
      });
    }

    const _backBtn = document.getElementById("backToHomeBtn");
    if (_backBtn) {
      _backBtn.addEventListener("click", function() {
        window.location.assign(window.DMB_MAGAZINE_MODE ? "/pages/design-my-magazine" : "/pages/design-my-book");
      });
    }

  } else if (shouldShowBuilder) {
      step1.style.display = "none";
      builderStep.style.display = "block";
      if (bookDetails) bookDetails.style.display = "none";

      // ?restore=1: load saved state, then open editor (so editor inits around
      // the pre-loaded data), then re-apply state to overwrite anything editor
      // touched during init, then render.
      if (restoreParam === "1") {
        (async () => {
          const _saved = loadCustomerProgress();
          if (!_saved || !_saved.editor) {
            try { await openEditor(); } catch(e) {}
            return;
          }
          if (saveMsg) { saveMsg.textContent = "Restoring your design…"; saveMsg.style.display = "block"; }

          const _cl = v => { try { return JSON.parse(JSON.stringify(v || {})); } catch(e) { return {}; } };
          const _se = _saved.editor || {};
          const _pg = _se.totalPages || Number(_saved.pages_selected) || 0;

          // ── Phase 1: pre-load state so openEditor sees it ────────────────
          const _rPhotos = await _loadPhotosFromIDB(getCustomerSaveKey());
          if (_rPhotos.length) {
            editor.photos = _rPhotos;
            try { bookFiles = _rPhotos.map(p => p.file || new File([], p.filename || "photo")); } catch(e) {}
          }
          const _pElR = document.getElementById("pages");
          if (_pElR && _pg) _pElR.value = String(_pg);

          // ── Phase 2: open editor (UI init only — skip state reset) ─────────
          // skipStateReset=true preserves the IDB photos loaded in Phase 1
          // and prevents openEditor from clearing editor.coverObjects / pageSlots.
          editor.totalPages    = _pg;
          editor.editablePages = _se.editablePages || Math.max(0, _pg - 1);
          editor.totalSpreads  = _se.totalSpreads  || Math.max(1, Math.ceil(_pg / 2));
          try { await openEditor({ skipStateReset: true }); } catch(e) { console.warn("[DMB] restore openEditor:", e); }

          // ── Phase 3: apply ALL saved values ──────────────────────────────
          //    (belt-and-suspenders: openEditor may still have touched some fields)
          editor.totalPages     = _pg;
          editor.editablePages  = _se.editablePages  || Math.max(0, _pg - 1);
          editor.totalSpreads   = _se.totalSpreads   || Math.max(1, Math.ceil(_pg / 2));
          editor.currentSpread  = 0;
          editor.pageSlots      = _cl(_se.pageSlots);
          editor.pageRot        = _cl(_se.pageRot);
          editor.pageTemplate   = _cl(_se.pageTemplate);
          editor.pageFrames     = _cl(_se.pageFrames);
          editor.pageFrameRot   = _cl(_se.pageFrameRot);
          editor.pageFrameShapes= _cl(_se.pageFrameShapes);
          editor.pageObjects    = _cl(_se.pageObjects);
          editor.spreadPhoto    = _cl(_se.spreadPhoto);
          editor.coverObjects   = Array.isArray(_se.coverObjects) ? _cl(_se.coverObjects) : [];
          editor.coverUserTexts = Array.isArray(_se.coverUserTexts) ? _cl(_se.coverUserTexts) : [];
          if (!Array.isArray(editor.coverObjects)) try { migrateCoverObjectsToFlat(); } catch(e) {}

          // Re-apply IDB photos — openEditor() above overwrote editor.photos with
          // empty bookFiles (no files are uploaded in the ?restore=1 flow).
          if (_rPhotos.length) {
            editor.photos = _rPhotos;
            try { bookFiles = _rPhotos.map(p => p.file || new File([], p.filename || "photo")); } catch(e) {}
          }

          if (_saved.coverState) {
            const _cs = _saved.coverState;
            ["frontImageUrl","backImageUrl","bleedImageUrl","spineImageUrl","imageUrl"].forEach(k => {
              if (_cs[k] && String(_cs[k]).startsWith("blob:")) {
                _cs[k] = "";
                if (k === "bleedImageUrl") { _cs.bleedZone = ""; _cs.bleedImageId = ""; }
              }
            });
            Object.keys(_cs).forEach(k => { try { coverState[k] = _cs[k]; } catch(e) {} });
          }
          if (_pElR && _pg) _pElR.value = String(_pg);
          builderMode = _saved.builderMode || "pages";

          // ── Phase 4: sync UI inputs then render ───────────────────────────
          try { syncCoverInputsFromState(); }  catch(e) {}
          try { updatePrice(); }               catch(e) {}
          try { renderPhotoTray(); }           catch(e) {}
          try { renderThumbsRail(); }          catch(e) {}
          // Always render the cover (Phase 3 restored coverState + coverObjects
          // but renderBuilderCanvas only renders the cover when builderMode="cover").
          // Since saved builderMode is typically "pages", explicitly render both.
          try { renderCoverCanvas(); }         catch(e) {}
          try { renderBuilderCanvas(); }       catch(e) {}

          if (saveMsg) {
            saveMsg.textContent = _rPhotos.length
              ? `✅ Restored — ${_rPhotos.length} photos + full layout`
              : "✅ Layout restored (re-upload photos to fill pages)";
            setTimeout(() => { saveMsg.style.display = "none"; }, 3500);
          }
        })();
      }
    } else {
      step1.style.display = "flex";
      builderStep.style.display = "none";
      if (bookDetails) bookDetails.style.display = "none";
    }
  const coverToShow =
    mode !== "customize"
      ? (coverImgParam || coverTitleParam
          ? { title: coverTitleParam || "", img: coverImgParam || "" }
          : storedCover)
      : null;

  if (selectedCoverBox && selectedCoverImg && selectedCoverTitle) {
    if (mode !== "customize" && coverToShow && (coverToShow.img || coverToShow.title)) {
      selectedCoverBox.style.display = "flex";
      if (coverToShow.img) selectedCoverImg.src = coverToShow.img;
      selectedCoverImg.alt = coverToShow.title || "Selected cover";
      selectedCoverTitle.textContent = coverToShow.title || "";
    } else {
      selectedCoverBox.style.display = "none";
    }
  }

  // ---------- Step 2 ----------
  function updatePrice() {
    if (!pagesEl || !priceBox || !oldPriceEl || !newPriceEl) return;
    const data = PRICES[pagesEl.value];
    if (data) {
      // Add extra spread cost ($1.99 × extraSpreads) on top of base price
      const extraCost = (editor.extraSpreads || 0) * EXTRA_SPREAD_PRICE;
      oldPriceEl.textContent = fmtMoney(data.old + extraCost);
      newPriceEl.textContent = fmtMoney(data.new + extraCost);
      priceBox.style.display = "block";
    } else {
      priceBox.style.display = "none";
    }
  }

  function makeThumbWithRemove(file, idx, onRemove) {
    const wrap = document.createElement("div");
    wrap.style.position = "relative";
    wrap.style.width = "70px";
    wrap.style.height = "70px";

    const img = document.createElement("img");
    img.src = URL.createObjectURL(file);
    img.alt = file.name;
    img.style.width = "70px";
    img.style.height = "70px";
    img.style.objectFit = "cover";
    img.style.borderRadius = "10px";
    img.style.border = "1px solid #ddd";
    wrap.appendChild(img);

    // ── Circle-X remove button (Fix 1) ─────────────────────────────────────
    const btn = document.createElement("button");
    btn.type = "button";
    btn.setAttribute("aria-label", "Remove image");
    btn.innerHTML = `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 8l8 8M16 8l-8 8"/></svg>`;
    btn.style.cssText = "position:absolute;top:-7px;right:-7px;width:22px;height:22px;border-radius:999px;border:none;background:#111;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      onRemove(idx);
    });

    wrap.appendChild(btn);
    return wrap;
  }

  function renderPreview(filesArr, containerEl, maxThumbs, onRemove) {
    if (!containerEl) return;
    containerEl.innerHTML = "";

    if (!filesArr.length) {
      containerEl.style.display = "none";
      return;
    }

    containerEl.style.display = "flex";

    filesArr.slice(0, maxThumbs).forEach((file, idx) => {
      containerEl.appendChild(makeThumbWithRemove(file, idx, onRemove));
    });

    if (filesArr.length > maxThumbs) {
      const more = document.createElement("div");
      more.textContent = `+${filesArr.length - maxThumbs} more`;
      more.style.fontSize = "12px";
      more.style.color = "#666";
      more.style.alignSelf = "center";
      containerEl.appendChild(more);
    }
  }

  function refreshPhotoRule() {
    // ── Minimum photos rule: min = BASE pages − 4 ────────────────────────
    // IMPORTANT: use pagesEl.value (the dropdown selection), NOT editor.totalPages.
    // editor.totalPages includes extra spreads added inside the builder, but
    // the photo upload step requirement must NOT change when spreads are added.
    // Example: 24 pages → minimum 20 photos. Adding 2 spreads → still 20.
    const pages = Number(pagesEl?.value || 0);
    if (pages > 0) {
      currentMin = Math.max(1, pages - 4);
      currentMax = pages + 8;
      if (photoRuleEl) {
        photoRuleEl.textContent = `Upload at least ${currentMin} photos for ${pages} pages`;
        photoRuleEl.style.display = "block";
      }
    } else {
      currentMin = 0;
      currentMax = 0;
      if (photoRuleEl) {
        photoRuleEl.textContent = "Select pages to see how many photos you need";
        photoRuleEl.style.display = "block";
      }
    }
    if (photoErrorEl) photoErrorEl.style.display = "none";
    validatePhotos();
  }

  function validatePhotos() {
    const count = bookFiles.length;
    if (photoCountEl) {
      photoCountEl.style.display = count ? "block" : "none";
      photoCountEl.textContent = count ? `${count} photo${count !== 1 ? "s" : ""} selected` : "";
    }
    if (photoErrorEl) {
      if (currentMin > 0 && count < currentMin) {
        const need = currentMin - count;
        photoErrorEl.textContent =
          `📸 Add ${need} more photo${need !== 1 ? "s" : ""} to start designing! ` +
          `You have ${count}, you need at least ${currentMin} for ${pagesEl?.value || ""} pages.`;
        photoErrorEl.style.display = "block";
      } else {
        photoErrorEl.style.display = "none";
      }
    }
    return count > 0 && (currentMin === 0 || count >= currentMin);
  }

  window.editorAutoOpened = window.editorAutoOpened || false;

  async function tryAutoOpenEditor() {
    const selectedPages = Number(pagesEl?.value || 0);

    if (!selectedPages || bookFiles.length === 0) {
      window.editorAutoOpened = false;
      return;
    }

    // ── Minimum photo check: block auto-open if not enough photos ──────────
    // Minimum = base pages − 4 (extra spreads added inside the builder are
    // NOT factored in — this check is for the upload step only).
    const minNeeded = selectedPages > 0 ? Math.max(1, selectedPages - 4) : 0;
    if (minNeeded > 0 && bookFiles.length < minNeeded) {
      window.editorAutoOpened = false;
      // Ensure the error message is visible
      refreshPhotoRule();
      return;
    }

    // Don't reset if builder is already open with content
    const alreadyOpen =
      builderStep &&
      builderStep.style.display === "block" &&
      editor.totalPages > 0;

    if (alreadyOpen) return;

    const alreadyMatching = editor.totalPages === selectedPages;

    if (window.editorAutoOpened && alreadyMatching) return;

    window.editorAutoOpened = true;

    try {
      await openEditor();
    } catch (err) {
      window.editorAutoOpened = false;
      console.error("tryAutoOpenEditor failed:", err);
    }
  }
  
  function validateCustomizeRequired() {
    if (mode !== "customize") return true;
    return !!getEffectiveBookTitle();
  }

  function removeBookFileAt(idx) {
    if (idx < 0 || idx >= bookFiles.length) return;
    bookFiles.splice(idx, 1);
    syncInputFiles(photosEl, bookFiles);
    validatePhotos();
  }

  if (pagesEl) {
    pagesEl.addEventListener("change", () => {
      updatePrice();
      refreshPhotoRule();
      initEmptyBookFromPages();
    });
  }

  if (!templateParam && restoreParam !== "1") {
    // Only reset to defaults when NOT restoring from saved progress
    coverState.template = "default";
    coverState.title1 = "";
    coverState.title2 = "";
    coverState.color = "#ffffff";
    coverState.imageUrl = "";
    coverState.imageFile = null;
    coverState.textStyles = {};
    editor.coverObjects = [];
  }


  // --- frame rendering helpers (second-IIFE versions, have full access to editor/state) ---

  function dmbGetSnapGuides(cont) {
    let gH = cont.querySelector(".dmb-snap-guide-h");
    let gV = cont.querySelector(".dmb-snap-guide-v");
    if (!gH) {
      gH = document.createElement("div");
      gH.className = "dmb-snap-guide-h";
      cont.appendChild(gH);
    }
    if (!gV) {
      gV = document.createElement("div");
      gV.className = "dmb-snap-guide-v";
      cont.appendChild(gV);
    }
    return { gH, gV };
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Fix 6 — Smart alignment guides (object-to-object + container centre)
  // ══════════════════════════════════════════════════════════════════════════
  //
  // `dmbCheckSnap` is called during every drag pointermove. It:
  //   1. Gathers sibling objects on the same page/cover
  //   2. Computes 5 reference edges per object (left, centreX, right, top, centreY, bottom)
  //   3. Snaps obj.x / obj.y when within SNAP_T px of any reference
  //   4. Shows dynamic guide lines at each matched edge
  //
  // Guide-line pool: we lazily create <div> elements inside the container and
  // reuse them across frames to avoid DOM churn (max ~8 visible at once).

  const _SNAP_T = 5;                 // snap threshold in px
  const _GUIDE_HIDE_MS = 500;        // guides stay visible 500 ms after drag stops

  function _dmbGetGuidePool(container) {
    if (!container._snapPool) container._snapPool = [];
    return container._snapPool;
  }

  // axis: "h" (horizontal = constant Y) or "v" (vertical = constant X)
  // isCenter: true → dashed line (centre-to-centre snap), false → solid (edge snap)
  function _dmbAcquireGuide(container, axis, isCenter) {
    const pool = _dmbGetGuidePool(container);
    let el = pool.find(g => g._axis === axis && g._inUse === false);
    if (!el) {
      el = document.createElement("div");
      el._axis = axis;
      el.style.pointerEvents = "none";
      el.style.position = "absolute";
      el.style.zIndex = "9999";
      el.style.opacity = "0";
      el.style.transition = "opacity 0.08s ease";
      if (axis === "h") {
        el.style.left = "0"; el.style.right = "0"; el.style.height = "2px";
      } else {
        el.style.top = "0"; el.style.bottom = "0"; el.style.width = "2px";
      }
      container.appendChild(el);
      pool.push(el);
    }
    el._inUse = true;
    // Re-apply class every acquisition so dashed/solid toggles correctly on reuse
    const base = axis === "h" ? "dmb-snap-guide-h dmb-snap-guide-dynamic" : "dmb-snap-guide-v dmb-snap-guide-dynamic";
    el.className = isCenter ? base + " dmb-snap-guide-center" : base;
    return el;
  }

  function _dmbReleaseAllGuides(container) {
    const pool = _dmbGetGuidePool(container);
    pool.forEach(g => {
      g._inUse = false;
      g.style.opacity = "0";
    });
  }

  // Show alignment guides + snap during a "lifted" drag (page item moved to spread-row).
  // During lift the item is positioned in spread-row coords; snap needs page-body coords.
  // Returns { dx, dy } — the snap delta to add to the lifted position.
  function _dmbLiftSnap(spreadLeft, spreadTop, objW, objH, objId, liftState, gH, gV, targetType, pageNumber) {
    if (!liftState || !liftState.origParent || !liftState.pagesRow) return { dx: 0, dy: 0 };
    const _pR = liftState.pagesRow.getBoundingClientRect();
    const _pb = liftState.origParent.getBoundingClientRect();
    const _offX = _pb.left - _pR.left;
    const _offY = _pb.top  - _pR.top;
    const _so = { id: objId, x: spreadLeft - _offX, y: spreadTop - _offY, w: objW, h: objH };
    dmbCheckSnap(_so, liftState.origParent, gH, gV, { targetType, pageNumber });
    return { dx: _so.x - (spreadLeft - _offX), dy: _so.y - (spreadTop - _offY) };
  }

  function _dmbGetSiblingObjects(obj, targetType, pageNumber) {
    let arr;
    if (targetType === "cover") {
      arr = editor.coverObjects || [];
    } else if (pageNumber != null) {
      arr = ensurePageObjects(pageNumber);
    } else {
      return [];
    }
    // Normalise text objects (they use left/top strings instead of x/y numbers)
    // so the snap engine can treat every sibling uniformly.  Text is inset by its
    // padding (2px 6px) so its snap edges are the GLYPH edges (first/last letter),
    // matching the dragged-text behaviour — text-to-text aligns letter-to-letter.
    const _TX_PL = 6, _TX_PT = 2;
    return arr
      .filter(o => o && o.id !== obj.id)
      .map(o => {
        if (o.type !== "text") return o;
        const el = document.getElementById(o.id);
        const boxW = el ? Math.max(el.scrollWidth, el.offsetWidth) : 132;
        const boxH = el ? (el.offsetHeight || 34)                 : 34;
        return {
          ...o,
          x: parseFloat(o.left || "0") + _TX_PL,
          y: parseFloat(o.top  || "0") + _TX_PT,
          w: Math.max(0, boxW - _TX_PL * 2),
          h: Math.max(0, boxH - _TX_PT * 2),
        };
      })
      .filter(o => (o.w || 0) > 4 && (o.h || 0) > 4);
  }

  function dmbCheckSnap(obj, container, gH, gV, _meta) {
    // _meta = { targetType, pageNumber } — optional; when absent falls back to container-centre only
    const cW = container.offsetWidth || 270;
    const cH = container.offsetHeight || 338;

    // Dragged object edges
    const dL = obj.x, dR = obj.x + obj.w, dCx = obj.x + obj.w / 2;
    const dT = obj.y, dB = obj.y + obj.h, dCy = obj.y + obj.h / 2;

    // Collect snap candidates: { axis:"x"|"y", objEdge, refEdge }
    const snapsX = [];
    const snapsY = [];

    // Container vertical centre (Y mid-point — same for all targets)
    snapsY.push({ ref: cH / 2, edges: [dCy], label: "cc" });

    // Container edges (top=0, bottom=cH)
    snapsY.push({ ref: 0,  edges: [dT], label: "ce" });
    snapsY.push({ ref: cH, edges: [dB], label: "ce" });

    // Horizontal snap targets depend on target type
    const targetType = _meta?.targetType;
    const pageNumber = _meta?.pageNumber;

    if (targetType === "cover") {
      // Cover: snap to each zone's centre and edges
      const _magFX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      // Back zone: 0 → COVER_BACK_W
      snapsX.push({ ref: COVER_BACK_W / 2, edges: [dCx], label: "cc" });
      snapsX.push({ ref: 0,  edges: [dL], label: "ce" });
      snapsX.push({ ref: COVER_BACK_W, edges: [dR], label: "ce" });
      // Front zone: _magFX → _magFX + 300
      snapsX.push({ ref: _magFX + 150, edges: [dCx], label: "cc" });
      snapsX.push({ ref: _magFX, edges: [dL], label: "ce" });
      snapsX.push({ ref: _magFX + 300, edges: [dR], label: "ce" });
      // Spine zone (books only)
      if (!window.DMB_MAGAZINE_MODE && COVER_SPINE_W > 0) {
        snapsX.push({ ref: COVER_BACK_W + COVER_SPINE_W / 2, edges: [dCx], label: "cc" });
        snapsX.push({ ref: COVER_BACK_W, edges: [dL], label: "ce" });
        snapsX.push({ ref: COVER_BACK_W + COVER_SPINE_W, edges: [dR], label: "ce" });
      }
    } else {
      // Page objects: snap to container centre and edges
      snapsX.push({ ref: cW / 2, edges: [dCx], label: "cc" });
      snapsX.push({ ref: 0,  edges: [dL], label: "ce" });
      snapsX.push({ ref: cW, edges: [dR], label: "ce" });
    }

    // Sibling object edges
    const siblings = (targetType != null) ? _dmbGetSiblingObjects(obj, targetType, pageNumber) : [];

    for (const sib of siblings) {
      const sL = sib.x, sR = sib.x + sib.w, sCx = sib.x + sib.w / 2;
      const sT = sib.y, sB = sib.y + sib.h, sCy = sib.y + sib.h / 2;

      // X-axis: dragged left↔sib left, dragged left↔sib right, dragged right↔sib left,
      //         dragged right↔sib right, dragged centreX↔sib centreX
      snapsX.push({ ref: sL,  edges: [dL, dR], label: "obj" });
      snapsX.push({ ref: sR,  edges: [dL, dR], label: "obj" });
      snapsX.push({ ref: sCx, edges: [dCx],    label: "cc"  }); // centre→dashed

      // Y-axis: same pattern
      snapsY.push({ ref: sT,  edges: [dT, dB], label: "obj" });
      snapsY.push({ ref: sB,  edges: [dT, dB], label: "obj" });
      snapsY.push({ ref: sCy, edges: [dCy],    label: "cc"  }); // centre→dashed
    }

    // Find best snap per axis
    let bestX = null, bestXDist = _SNAP_T + 1;
    for (const s of snapsX) {
      for (const e of s.edges) {
        const d = Math.abs(e - s.ref);
        if (d < bestXDist) { bestXDist = d; bestX = { ref: s.ref, edge: e, delta: s.ref - e }; }
      }
    }

    let bestY = null, bestYDist = _SNAP_T + 1;
    for (const s of snapsY) {
      for (const e of s.edges) {
        const d = Math.abs(e - s.ref);
        if (d < bestYDist) { bestYDist = d; bestY = { ref: s.ref, edge: e, delta: s.ref - e }; }
      }
    }

    // Apply position snap
    if (bestX && bestXDist <= _SNAP_T) obj.x += bestX.delta;
    if (bestY && bestYDist <= _SNAP_T) obj.y += bestY.delta;

    // ── Show guide lines ──────────────────────────────────────────────────
    _dmbReleaseAllGuides(container);

    // Map<position, isCenter> — value is true when the snap was centre-to-centre
    // (label "cc"), which renders as a dashed line; false = solid edge line.
    const showV = new Map();
    const showH = new Map();

    for (const s of snapsX) {
      for (const e of s.edges) {
        const eSnapped = e + (bestX && bestXDist <= _SNAP_T ? bestX.delta : 0);
        if (Math.abs(eSnapped - s.ref) < 0.5) {
          const k = Math.round(s.ref);
          showV.set(k, (s.label === "cc") || !!showV.get(k));
        }
      }
    }
    for (const s of snapsY) {
      for (const e of s.edges) {
        const eSnapped = e + (bestY && bestYDist <= _SNAP_T ? bestY.delta : 0);
        if (Math.abs(eSnapped - s.ref) < 0.5) {
          const k = Math.round(s.ref);
          showH.set(k, (s.label === "cc") || !!showH.get(k));
        }
      }
    }

    for (const [vx, isCenter] of showV) {
      const line = _dmbAcquireGuide(container, "v", isCenter);
      line.style.left = vx + "px"; line.style.transform = "";
      line.style.opacity = "1";
    }
    for (const [hy, isCenter] of showH) {
      const line = _dmbAcquireGuide(container, "h", isCenter);
      line.style.top = hy + "px"; line.style.transform = "";
      line.style.opacity = "1";
    }

    // Auto-hide all guides 500 ms after drag stops moving
    clearTimeout(container._snapHideT);
    container._snapHideT = setTimeout(() => _dmbReleaseAllGuides(container), _GUIDE_HIDE_MS);
  }

  function dmbApplyZoneClip(el, obj) {
    if (!obj.coverZone) { el.style.clipPath = ""; return; }
    const FACE_W = 300;
    let zoneX1, zoneX2;
    if (obj.coverZone === "back") {
      zoneX1 = 0; zoneX2 = COVER_BACK_W;
    } else if (obj.coverZone === "spine") {
      zoneX1 = COVER_BACK_W; zoneX2 = COVER_FRONT_X;
    } else {
      zoneX1 = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      zoneX2 = zoneX1 + FACE_W;
    }
    const leftClip = Math.max(0, zoneX1 - (obj.x || 0));
    const rightClip = Math.max(0, (obj.x || 0) + (obj.w || 0) - zoneX2);
    el.style.clipPath = (leftClip === 0 && rightClip === 0) ? "" : `inset(0 ${rightClip}px 0 ${leftClip}px)`;
  }

  function dmbAlignObjectInZone(el, obj, align, targetType) {
    let zoneX = 0, zoneW;
    if (targetType === "cover") {
      const _magFX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      if (obj.coverZone === "back") { zoneX = 0; zoneW = COVER_BACK_W; }
      else if (obj.coverZone === "spine") { zoneX = COVER_BACK_W; zoneW = COVER_SPINE_W; }
      else { zoneX = _magFX; zoneW = 300; }
    } else {
      const container = el.closest('[data-page-body="true"]') || el.parentElement;
      zoneW = container ? container.offsetWidth : 270;
    }
    const elementW = obj.w || el.offsetWidth || 100;
    let newX;
    if (align === "left") newX = zoneX;
    else if (align === "center") newX = Math.round(zoneX + (zoneW - elementW) / 2);
    else newX = zoneX + zoneW - elementW;
    obj.x = newX;
    el.style.left = newX + "px";
    if (obj.coverZone) dmbApplyZoneClip(el, obj);
    pushUndoState("Align " + align.charAt(0).toUpperCase() + align.slice(1));
  }

  function dmbAlignTextNode(node, align) {
    const parent = node.parentElement;
    if (!parent) return;
    let zoneX = 0, zoneW;
    const coverWrap = parent.closest(".dmb-cover-preview");
    if (coverWrap) {
      const utEntry = (editor.coverUserTexts || []).find(function(e) { return e.id === node.id; });
      const zone = utEntry?.zone || activeCoverZone;
      const _magFX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      if (zone === "back") { zoneX = 0; zoneW = COVER_BACK_W; }
      else if (zone === "spine") { zoneX = COVER_BACK_W; zoneW = COVER_SPINE_W; }
      else { zoneX = _magFX; zoneW = 300; }
    } else {
      zoneW = parent.offsetWidth;
    }
    // scrollWidth captures actual text content width even when it overflows an
    // explicit CSS width (e.g. width:220px set by the textAlign dropdown).
    // offsetWidth alone returns the box size, not the visual text extent.
    const nodeW = Math.max(node.offsetWidth, node.scrollWidth) || 120;
    let newX;
    if (align === "left") newX = zoneX;
    else if (align === "center") newX = Math.round(zoneX + (zoneW - nodeW) / 2);
    else newX = zoneX + zoneW - nodeW;
    node.style.left = newX + "px";
    // Save to BOTH cover state AND page objects so the new position is
    // reflected in the PDF for both cover text and page text.
    // WARNING: do NOT remove savePageTextState — without it, position alignment
    // buttons (← ↔ →) leave editor.pageObjects.left stale and the PDF shows
    // the text at the old position instead of the new one.
    saveCoverTextNodeState(node);
    savePageTextState(node);
    pushUndoState("Align Text " + align.charAt(0).toUpperCase() + align.slice(1));
    showTextToolbarFor(node);
  }

  function getObjectListForTarget(targetType, pageNumber) {
    if (targetType === "cover") {
      if (!Array.isArray(editor.coverObjects)) migrateCoverObjectsToFlat();
      return editor.coverObjects;
    }
    if (!editor.pageObjects || typeof editor.pageObjects !== "object") {
      editor.pageObjects = {};
    }
    const p = Number(pageNumber);
    if (p == null || isNaN(p) || p < 0) return [];
    if (!Array.isArray(editor.pageObjects[p])) editor.pageObjects[p] = [];
    return editor.pageObjects[p];
  }

  // ── Cross-page move helper ──────────────────────────────────────────────
  async function dmbHandleCrossPageMove(obj, sourcePageNumber) {
    const si = editor.currentSpread;
    if (si < 0 || si == null) return;
    const leftPage  = si * 2 + 1;
    const rightPage = si * 2 + 2;
    if (sourcePageNumber !== leftPage && sourcePageNumber !== rightPage) return;
    if (rightPage > (editor.totalPages || 0)) return;

    const PAGE_W   = 270;
    const isOnLeft = (sourcePageNumber === leftPage);
    const cx       = obj.x + (obj.w || 0) / 2;
    const objRight = obj.x + (obj.w || 0);

    let targetPage = sourcePageNumber;
    let straddling = false;
    if (isOnLeft) {
      if      (cx > PAGE_W)    targetPage = rightPage;
      else if (objRight > PAGE_W) straddling = true;
    } else {
      if      (cx < 0)         targetPage = leftPage;
      else if (obj.x < 0)      straddling = true;
    }

    if (straddling) {
      const choice = await showChoiceDialog(
        "Object spans both pages",
        "This item crosses the divider between two pages. Where should it go?",
        [
          { id: "stay", label: `Keep on Page ${sourcePageNumber}` },
          { id: "move", label: `Move to Page ${isOnLeft ? rightPage : leftPage}` }
        ]
      );
      if (choice !== "move") return;
      targetPage = isOnLeft ? rightPage : leftPage;
    }

    if (targetPage === sourcePageNumber) return;

    const src = editor.pageObjects[sourcePageNumber];
    if (!Array.isArray(src)) return;
    const idx = src.findIndex(o => o.id === obj.id);
    if (idx === -1) return;
    src.splice(idx, 1);

    obj.x = isOnLeft ? obj.x - PAGE_W : obj.x + PAGE_W;

    if (!Array.isArray(editor.pageObjects[targetPage])) editor.pageObjects[targetPage] = [];
    editor.pageObjects[targetPage].push(obj);

    if (typeof renderBuilderCanvas === "function") renderBuilderCanvas();
    if (typeof renderThumbsRail   === "function") renderThumbsRail();
  }

  function renderFreeFrameObjects(container, meta) {
    const targetType = meta?.targetType || "page";
    const pageNumber = meta?.pageNumber ?? null;
    const zone = meta?.zone || null;
    // Pages: z >= 60 keeps frames above the spread overlay (z:50).
    // Cover: use own z-value — drops handled by peek-under method, not z-index.
    const minFrameZ = targetType === "cover" ? 0 : 60;

    const rawObjs = getObjectListForTarget(targetType, pageNumber, zone);
    const objs = Array.isArray(rawObjs)
      ? rawObjs.slice().sort((a, b) => Number(a.z || 0) - Number(b.z || 0))
      : [];

    objs.forEach((obj) => {
      if (obj.type === "map") {
        const wrap = document.createElement("div");
        wrap.className = "dmb-map-object";
        wrap.dataset.objectId = obj.id;
        wrap.style.position = "absolute";
        wrap.style.left = obj.x + "px";
        wrap.style.top = obj.y + "px";
        wrap.style.width = obj.w + "px";
        wrap.style.height = obj.h + "px";
        wrap.style.zIndex = String(obj.z || 20);
        wrap.dataset.z = String(obj.z || 20);
        wrap.style.cursor = "move";
        wrap.style.overflow = "visible";
        wrap.style.transform = `rotate(${obj.rotation || 0}deg)`;
        wrap.style.transformOrigin = "center center";
        if (obj.coverZone) dmbApplyZoneClip(wrap, obj);
        if (obj.contained) _dmbApplyContain(wrap, obj, targetType === "cover");

        const mapParser = new DOMParser();
        const svgDoc = mapParser.parseFromString(obj.svg || "", "image/svg+xml");
        const svgEl = svgDoc.querySelector("svg");
        if (svgEl) {
          if (!svgEl.getAttribute("viewBox")) {
            const origW = svgEl.getAttribute("width");
            const origH = svgEl.getAttribute("height");
            if (origW && origH) {
              svgEl.setAttribute("viewBox", `0 0 ${parseFloat(origW)} ${parseFloat(origH)}`);
            }
          }
          svgEl.removeAttribute("width");
          svgEl.removeAttribute("height");
          svgEl.style.width = "100%";
          svgEl.style.height = "100%";
          svgEl.style.display = "block";
          dmbApplyStylesToSvg(svgEl, obj);
          wrap.appendChild(svgEl);
        }

        if (Array.isArray(obj.markers)) {
          obj.markers.forEach((markerData) => {
            const marker = createMarkerElement(markerData.type || "pin", markerData.color || "#e74c3c");
            marker.style.left = (markerData.x || 50) + "%";
            marker.style.top  = (markerData.y || 50) + "%";
            wrap.appendChild(marker);
            attachMarkerInteractions(marker, markerData, wrap);
          });
        }

        const mapHandles = [
          ["tl","0","0"],["tm","50%","0"],["tr","100%","0"],
          ["ml","0","50%"],["mr","100%","50%"],
          ["bl","0","100%"],["bm","50%","100%"],["br","100%","100%"]
        ];
        mapHandles.forEach(([pos, l, t]) => {
          const h = document.createElement("div");
          h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          h.dataset.handle = pos;
          h.style.left = l;
          h.style.top = t;
          wrap.appendChild(h);
        });

        /* ── rotation handle (fixed-position, appended to body to escape overflow:hidden) ── */
        const rotHandle = document.createElement("div");
        rotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        rotHandle.innerHTML = "&#8635;";
        rotHandle.title = "Rotate";

        const degDisplay = document.createElement("div");
        degDisplay.className = "dmb-map-rotate-deg dmb-map-rot-float";
        degDisplay.textContent = Math.round(obj.rotation || 0) + "\u00b0";
        degDisplay.style.display = "none";

        rotHandle.style.display = "none"; // hidden until map is selected
        document.body.appendChild(rotHandle);
        document.body.appendChild(degDisplay);
        wrap._dmbRotHandle = rotHandle; // store reference for show/hide

        function updateRotPos() {
          if (!wrap.isConnected) { rotHandle.remove(); degDisplay.remove(); return; }
          const r = wrap.getBoundingClientRect();
          // Place handle at the actual BR corner of the bounding box, offset outward
          rotHandle.style.left = (r.right + 14) + "px";
          rotHandle.style.top = (r.bottom + 14) + "px";
          degDisplay.style.left = (r.right + 14) + "px";
          degDisplay.style.top = (r.bottom + 40) + "px";
        }

        requestAnimationFrame(updateRotPos);

        rotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r = wrap.getBoundingClientRect();
          const cx = r.left + r.width / 2;
          const cy = r.top + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          degDisplay.style.display = "block";
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            wrap.style.transform = `rotate(${obj.rotation}deg)`;
            degDisplay.textContent = Math.round(obj.rotation) + "\u00b0";
            updateRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            degDisplay.style.display = "none";
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        /* ── snap guides ── */
        const { gH, gV } = dmbGetSnapGuides(container);

        let mDragMode = null;
        let mSx = 0, mSy = 0, mOx = 0, mOy = 0, mOw = 0, mOh = 0, mAspect = 1;
        const MIND = 40;

        wrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          if (e.target.closest(".dmb-map-marker")) return;
          e.preventDefault();
          e.stopPropagation();
          if (obj.contained) wrap.style.clipPath = ""; // show full during drag
          // e.preventDefault() suppresses the click event, so select here directly
          dmbOpenEditBar(obj, wrap);
          mDragMode = "move";
          mSx = e.clientX; mSy = e.clientY;
          mOx = obj.x; mOy = obj.y;
          let _liftMap = null;
          if (targetType === "page") {
            const _pr = wrap.closest("[data-spread-row]");
            if (_pr) {
              const _wr = wrap.getBoundingClientRect(), _rr = _pr.getBoundingClientRect();
              _liftMap = { pagesRow: _pr, origParent: wrap.parentElement, origZ: wrap.style.zIndex };
              mOx = _wr.left - _rr.left; mOy = _wr.top - _rr.top;
              wrap.style.left = mOx + "px"; wrap.style.top = mOy + "px"; wrap.style.zIndex = "9000"; // below guides (9999)
              _pr.appendChild(wrap);
            }
          }
          const onMove = (ev) => {
            if (mDragMode !== "move") return;
            const dx = ev.clientX - mSx, dy = ev.clientY - mSy;
            if (_liftMap) {
              const _rawL = mOx + dx, _rawT = mOy + dy;
              const { dx: _sdx, dy: _sdy } = _dmbLiftSnap(_rawL, _rawT, obj.w, obj.h, obj.id, _liftMap, gH, gV, targetType, pageNumber);
              wrap.style.left = (_rawL + _sdx) + "px"; wrap.style.top = (_rawT + _sdy) + "px";
            } else {
              // Clamp to keep at least half the object inside the page
              const _cW = container.offsetWidth  || 270;
              const _cH = container.offsetHeight || 382;
              obj.x = Math.max(-obj.w / 2, Math.min(_cW - obj.w / 2, mOx + dx));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, mOy + dy));
              wrap.style.left = obj.x + "px"; wrap.style.top = obj.y + "px";
              if (obj.coverZone) dmbApplyZoneClip(wrap, obj);
              dmbCheckSnap(obj, container, gH, gV, { targetType, pageNumber });
              wrap.style.left = obj.x + "px"; wrap.style.top = obj.y + "px";
            }
            updateRotPos();
          };
          const onUp = async () => {
            mDragMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            if (_liftMap) {
              const _rx = parseFloat(wrap.style.left), _ry = parseFloat(wrap.style.top);
              const _pgR = _liftMap.origParent?.parentElement?.getBoundingClientRect();
              const _rR  = _liftMap.pagesRow.getBoundingClientRect();
              obj.x = _rx - (_pgR ? _pgR.left - _rR.left : 0); obj.y = _ry;
              // Clamp so object can't land fully outside its destination page
              const _cW = _liftMap.origParent.offsetWidth  || 270;
              const _cH = _liftMap.origParent.offsetHeight || 382;
              obj.x = Math.max(-obj.w / 2, Math.min(_cW - obj.w / 2, obj.x));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, obj.y));
              wrap.style.left = obj.x + "px"; wrap.style.top = obj.y + "px";
              wrap.style.zIndex = _liftMap.origZ; _liftMap.origParent.appendChild(wrap); _liftMap = null;
            }
            pushUndoState("Move Map");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, wrap);
            } else if (targetType === "page" && typeof pageNumber === "number") {
              await dmbHandleCrossPageMove(obj, pageNumber);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        wrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault();
            e.stopPropagation();
            mDragMode = handle.dataset.handle;
            mSx = e.clientX; mSy = e.clientY;
            mOx = obj.x; mOy = obj.y; mOw = obj.w; mOh = obj.h;
            mAspect = mOh > 0 ? mOw / mOh : 1;
            const onMove = (ev) => {
              const dx = ev.clientX - mSx;
              const dy = ev.clientY - mSy;
              let newW, newH;

              // Width-driven handles (all except top/bottom middle)
              if (["tl","ml","bl"].includes(mDragMode)) newW = Math.max(MIND, mOw - dx);
              else if (["tr","mr","br"].includes(mDragMode)) newW = Math.max(MIND, mOw + dx);

              // Height-driven handles (top/bottom middle only)
              if (mDragMode === "tm") newH = Math.max(MIND, mOh - dy);
              else if (mDragMode === "bm") newH = Math.max(MIND, mOh + dy);

              // Compute the other dimension proportionally
              if (newW !== undefined) newH = Math.max(MIND, Math.round(newW / mAspect));
              else if (newH !== undefined) newW = Math.max(MIND, Math.round(newH * mAspect));

              obj.w = newW; obj.h = newH;

              // Position adjustments to keep the correct anchor
              if (["tl","ml","bl"].includes(mDragMode)) obj.x = mOx + (mOw - newW);
              else if (mDragMode === "tm" || mDragMode === "bm") obj.x = mOx + (mOw - newW) / 2;
              if (["tl","tm","tr"].includes(mDragMode)) obj.y = mOy + (mOh - newH);
              else if (mDragMode === "ml" || mDragMode === "mr") obj.y = mOy + (mOh - newH) / 2;

              wrap.style.left = obj.x + "px";
              wrap.style.top = obj.y + "px";
              wrap.style.width = obj.w + "px";
              wrap.style.height = obj.h + "px";
              if (obj.coverZone) dmbApplyZoneClip(wrap, obj);
              updateRotPos();
              dmbCheckSnap(obj, container, gH, gV, { targetType, pageNumber });
            };
            const onUp = () => {
              mDragMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup", onUp);
              pushUndoState("Resize Map");
              if (targetType === "cover") {
                _dmbAutoAssignCoverZone(obj, wrap);
              }
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp);
          });
        });

        currentInsertedMap = obj;
        container.appendChild(wrap);
        requestAnimationFrame(updateRotPos);
        return;
      }

      if (obj.type === "sticker") {
        // Ensure minimum valid dimensions (preserve user-set sizes — never overwrite on re-render)
        if ((obj.w || 0) < 1 || (obj.h || 0) < 1) {
          obj.w = 100; obj.h = 100;
        }

        const sWrap = document.createElement("div");
        sWrap.className = "dmb-sticker-object";
        sWrap.dataset.objectId = obj.id;
        sWrap.style.position = "absolute";
        sWrap.style.left = (obj.x || 20) + "px";
        sWrap.style.top = (obj.y || 20) + "px";
        sWrap.style.width = obj.w + "px";
        sWrap.style.height = obj.h + "px";
        sWrap.style.zIndex = String(obj.z || 30);
        sWrap.dataset.z = String(obj.z || 30);
        sWrap.style.cursor = "move";
        sWrap.style.transform = `rotate(${obj.rotation || 0}deg)`;
        sWrap.style.transformOrigin = "center center";
        if (obj.coverZone) dmbApplyZoneClip(sWrap, obj);
        if (obj.contained) _dmbApplyContain(sWrap, obj, targetType === "cover");

        const sImg = document.createElement("img");
        // Use the pre-cropped data URL if available; fall back to original CDN URL
        sImg.src = obj.tightUrl || obj.url || "";
        sImg.alt = obj.name || "";
        sImg.draggable = false;
        sImg.style.width = obj.w + "px";
        sImg.style.height = obj.h + "px";
        sImg.style.display = "block";
        sImg.style.pointerEvents = "none";
        sWrap.appendChild(sImg);

        // Place handles at exact pixel positions on the sticker wrapper corners/edges
        function sStickerHandlePts(w, h) {
          return { tl:[0,0], tm:[w/2,0], tr:[w,0], ml:[0,h/2], mr:[w,h/2], bl:[0,h], bm:[w/2,h], br:[w,h] };
        }
        function updateStickerHandles(w, h) {
          const pts = sStickerHandlePts(w, h);
          sWrap.querySelectorAll(".dmb-frame-handle").forEach((el) => {
            const [lx, ty] = pts[el.dataset.handle] || [0, 0];
            el.style.left = lx + "px";
            el.style.top = ty + "px";
          });
        }
        const sInitW = obj.w || 100, sInitH = obj.h || 100;
        const sInitPts = sStickerHandlePts(sInitW, sInitH);
        [["tl","tl"],["tm","tm"],["tr","tr"],["ml","ml"],["mr","mr"],["bl","bl"],["bm","bm"],["br","br"]].forEach(([pos]) => {
          const h = document.createElement("div");
          h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          h.dataset.handle = pos;
          const [lx, ty] = sInitPts[pos];
          h.style.left = lx + "px";
          h.style.top = ty + "px";
          sWrap.appendChild(h);
        });

        const { gH: sGH, gV: sGV } = dmbGetSnapGuides(container);

        sWrap.addEventListener("click", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.stopPropagation();
          showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
        });

        let sDMode = null, sSx = 0, sSy = 0, sSox = 0, sSoy = 0, sSow = 0, sSoh = 0;
        const S_MIN = 30;

        sWrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.preventDefault();
          e.stopPropagation();
          if (obj.contained) sWrap.style.clipPath = ""; // show full during drag
          showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
          sDMode = "move";
          sSx = e.clientX; sSy = e.clientY;
          sSox = obj.x; sSoy = obj.y;
          let _liftS = null;
          if (targetType === "page") {
            const _pr = sWrap.closest("[data-spread-row]");
            if (_pr) {
              const _wr = sWrap.getBoundingClientRect(), _rr = _pr.getBoundingClientRect();
              _liftS = { pagesRow: _pr, origParent: sWrap.parentElement, origZ: sWrap.style.zIndex };
              sSox = _wr.left - _rr.left; sSoy = _wr.top - _rr.top;
              sWrap.style.left = sSox + "px"; sWrap.style.top = sSoy + "px"; sWrap.style.zIndex = "9000"; // below guides (9999)
              _pr.appendChild(sWrap);
            }
          }
          const onMove = (ev) => {
            if (sDMode !== "move") return;
            const dx = ev.clientX - sSx, dy = ev.clientY - sSy;
            if (_liftS) {
              const _rawL = sSox + dx, _rawT = sSoy + dy;
              const { dx: _sdx, dy: _sdy } = _dmbLiftSnap(_rawL, _rawT, obj.w, obj.h, obj.id, _liftS, sGH, sGV, targetType, pageNumber);
              sWrap.style.left = (_rawL + _sdx) + "px"; sWrap.style.top = (_rawT + _sdy) + "px";
            } else {
              const _cW = container.offsetWidth  || 270;
              const _cH = container.offsetHeight || 382;
              obj.x = Math.max(-obj.w / 2, Math.min(_cW - obj.w / 2, sSox + dx));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, sSoy + dy));
              sWrap.style.left = obj.x + "px"; sWrap.style.top = obj.y + "px";
              if (obj.coverZone) dmbApplyZoneClip(sWrap, obj);
              dmbCheckSnap(obj, container, sGH, sGV, { targetType, pageNumber });
              sWrap.style.left = obj.x + "px"; sWrap.style.top = obj.y + "px";
              showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
            }
          };
          const onUp = async () => {
            sDMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            if (_liftS) {
              const _rx = parseFloat(sWrap.style.left), _ry = parseFloat(sWrap.style.top);
              const _pgR = _liftS.origParent?.parentElement?.getBoundingClientRect();
              const _rR  = _liftS.pagesRow.getBoundingClientRect();
              obj.x = _rx - (_pgR ? _pgR.left - _rR.left : 0); obj.y = _ry;
              const _cW = _liftS.origParent.offsetWidth  || 270;
              const _cH = _liftS.origParent.offsetHeight || 382;
              obj.x = Math.max(-obj.w / 2, Math.min(_cW - obj.w / 2, obj.x));
              obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, obj.y));
              sWrap.style.left = obj.x + "px"; sWrap.style.top = obj.y + "px";
              sWrap.style.zIndex = _liftS.origZ; _liftS.origParent.appendChild(sWrap); _liftS = null;
            }
            pushUndoState("Move Sticker");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, sWrap);
            } else if (targetType === "page" && typeof pageNumber === "number") {
              await dmbHandleCrossPageMove(obj, pageNumber);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        sWrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault();
            e.stopPropagation();
            showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
            sDMode = handle.dataset.handle;
            sSx = e.clientX; sSy = e.clientY;
            sSox = obj.x; sSoy = obj.y;
            sSow = obj.w || 100; sSoh = obj.h || 100;
            const sAspect = sSow / (sSoh || 1);
            const onMove = (ev) => {
              const dx = ev.clientX - sSx;
              const dy = ev.clientY - sSy;
              let nx = sSox, ny = sSoy, nw = sSow, nh = sSoh;
              if (sDMode === "tm" || sDMode === "bm") {
                nh = Math.max(S_MIN, sDMode === "tm" ? sSoh - dy : sSoh + dy);
                if (sDMode === "tm") ny = sSoy + sSoh - nh;
                nw = Math.max(S_MIN, Math.round(nh * sAspect));
                nx = sSox + (sSow - nw) / 2;
              } else if (sDMode === "ml" || sDMode === "mr") {
                nw = Math.max(S_MIN, sDMode === "ml" ? sSow - dx : sSow + dx);
                if (sDMode === "ml") nx = sSox + sSow - nw;
                nh = Math.max(S_MIN, Math.round(nw / sAspect));
                ny = sSoy + (sSoh - nh) / 2;
              } else {
                if (sDMode.includes("r")) nw = Math.max(S_MIN, sSow + dx);
                if (sDMode.includes("l")) { nw = Math.max(S_MIN, sSow - dx); nx = sSox + sSow - nw; }
                nh = Math.max(S_MIN, Math.round(nw / sAspect));
                if (sDMode.includes("t")) ny = sSoy + sSoh - nh;
              }
              obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
              sWrap.style.left = nx + "px"; sWrap.style.top = ny + "px";
              sWrap.style.width = nw + "px"; sWrap.style.height = nh + "px";
              sImg.style.width = nw + "px"; sImg.style.height = nh + "px";
              updateStickerHandles(nw, nh);
              if (obj.coverZone) dmbApplyZoneClip(sWrap, obj);
              showFrameToolbarFor(sWrap, obj, { targetType, pageNumber, zone });
            };
            const onUp = () => {
              sDMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup", onUp);
              pushUndoState("Resize Sticker");
              if (targetType === "cover") {
                _dmbAutoAssignCoverZone(obj, sWrap);
              }
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp);
          });
        });

        /* ── rotation handle (fixed-position, appended to body to escape overflow:hidden) ── */
        const sRotHandle = document.createElement("div");
        sRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        sRotHandle.innerHTML = "&#8635;";
        sRotHandle.title = "Rotate";
        sRotHandle.style.display = "none";
        document.body.appendChild(sRotHandle);
        sWrap._dmbRotHandle = sRotHandle;

        function updateStickerRotPos() {
          if (!sWrap.isConnected) { sRotHandle.remove(); return; }
          const r = sWrap.getBoundingClientRect();
          sRotHandle.style.left = (r.right + 14) + "px";
          sRotHandle.style.top = (r.bottom + 14) + "px";
        }

        requestAnimationFrame(updateStickerRotPos);

        sRotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r = sWrap.getBoundingClientRect();
          const cx = r.left + r.width / 2;
          const cy = r.top + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            sWrap.style.transform = `rotate(${obj.rotation}deg)`;
            updateStickerRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            pushUndoState("Rotate Sticker");
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        container.appendChild(sWrap);
        return;
      }

      /* ── SHAPE OBJECTS ─────────────────────────────────────────────────────
       * Shapes follow the same drag/resize/rotate pattern as stickers, but
       * use an inline SVG instead of an <img>. The shape type (rect, circle, etc.)
       * is stored in obj.shapeType. Editing is via dmbShapeEditBar.
       *
       * WARNING: Do NOT merge this block with the sticker block above — shapes
       * use dmbOpenShapeEditBar, not showFrameToolbarFor.
       * ────────────────────────────────────────────────────────────────────── */
      if (obj.type === "shape") {
        if ((obj.w || 0) < 1 || (obj.h || 0) < 1) { obj.w = 120; obj.h = 120; }

        const shWrap = document.createElement("div");
        shWrap.className = "dmb-shape-object";
        shWrap.dataset.objectId = obj.id;
        shWrap.style.position        = "absolute";
        shWrap.style.left            = (obj.x || 60) + "px";
        shWrap.style.top             = (obj.y || 60) + "px";
        shWrap.style.width           = obj.w + "px";
        shWrap.style.height          = obj.h + "px";
        shWrap.style.zIndex          = String(obj.z || 30);
        shWrap.style.transform       = `rotate(${obj.rotation || 0}deg)`;
        shWrap.style.transformOrigin = "center center";
        shWrap.style.overflow        = "visible";
        shWrap.dataset.z             = String(obj.z || 30);
        if (obj.coverZone) dmbApplyZoneClip(shWrap, obj);
        if (obj.contained) _dmbApplyContain(shWrap, obj, targetType === "cover");

        // The SVG fills the wrapper completely
        shWrap.innerHTML = buildShapeSvg(obj.shapeType, obj.fill, obj.stroke, obj.strokeWidth, obj.opacity, obj.cornerRadius);

        // 8 resize handles (same positions as maps/stickers)
        const shHandles = [
          ["tl","0","0"],["tm","50%","0"],["tr","100%","0"],
          ["ml","0","50%"],["mr","100%","50%"],
          ["bl","0","100%"],["bm","50%","100%"],["br","100%","100%"]
        ];
        shHandles.forEach(([pos, l, t]) => {
          const hEl = document.createElement("div");
          hEl.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          hEl.dataset.handle = pos;
          hEl.style.left = l;
          hEl.style.top  = t;
          shWrap.appendChild(hEl);
        });

        // Rotation handle (body-level, escapes overflow:hidden)
        const shRotHandle = document.createElement("div");
        shRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        shRotHandle.innerHTML = "&#8635;";
        shRotHandle.title     = "Rotate";
        shRotHandle.style.display = "none";
        document.body.appendChild(shRotHandle);
        shWrap._dmbRotHandle = shRotHandle;

        function updateShRotPos() {
          if (!shWrap.isConnected) { shRotHandle.remove(); return; }
          const r = shWrap.getBoundingClientRect();
          shRotHandle.style.left = (r.right + 14) + "px";
          shRotHandle.style.top  = (r.bottom + 14) + "px";
        }
        requestAnimationFrame(updateShRotPos);

        shRotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault(); e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r  = shWrap.getBoundingClientRect();
          const cx = r.left + r.width  / 2;
          const cy = r.top  + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            shWrap.style.transform = `rotate(${obj.rotation}deg)`;
            // Sync rotation input in edit bar if this shape is selected
            const rotInput = document.getElementById("dmbShapeRotation");
            if (rotInput && dmbEditingShapeObj === obj) rotInput.value = Math.round(obj.rotation);
            updateShRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup",  onUp);
            pushUndoState("Rotate Shape");
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup",   onUp);
        });

        // Snap guides
        const { gH: shGH, gV: shGV } = dmbGetSnapGuides(container);

        let shDMode = null, shSx = 0, shSy = 0, shOx = 0, shOy = 0, shOw = 0, shOh = 0;
        const SH_MIN = 10;

        // Click → open shape edit bar
        shWrap.addEventListener("click", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.stopPropagation();
          dmbOpenShapeEditBar(obj, shWrap);
        });

        // Pointer move/drag
        shWrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.preventDefault(); e.stopPropagation();
          if (obj.contained) shWrap.style.clipPath = ""; // show full during drag
          dmbOpenShapeEditBar(obj, shWrap);
          shDMode = "move";
          shSx = e.clientX; shSy = e.clientY;
          shOx = obj.x; shOy = obj.y;
          const onMove = (ev) => {
            if (shDMode !== "move") return;
            const dx = ev.clientX - shSx, dy = ev.clientY - shSy;
            const _cW = container.offsetWidth  || 270;
            const _cH = container.offsetHeight || 382;
            obj.x = Math.max(-obj.w / 2, Math.min(_cW - obj.w / 2, shOx + dx));
            obj.y = Math.max(-obj.h / 2, Math.min(_cH - obj.h / 2, shOy + dy));
            shWrap.style.left = obj.x + "px";
            shWrap.style.top  = obj.y + "px";
            if (obj.coverZone) dmbApplyZoneClip(shWrap, obj);
            dmbCheckSnap(obj, container, shGH, shGV, { targetType, pageNumber });
            shWrap.style.left = obj.x + "px"; shWrap.style.top = obj.y + "px";
            // Reposition edit bar while dragging
            const rect = shWrap.getBoundingClientRect();
            const bar  = document.getElementById("dmbShapeEditBar");
            if (bar && bar.style.display !== "none") {
              bar.style.top  = Math.max(8, rect.top - bar.offsetHeight - 8) + "px";
              bar.style.left = Math.max(8, Math.min(rect.left, window.innerWidth - bar.offsetWidth - 8)) + "px";
            }
          };
          const onUp = async () => {
            shDMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup",  onUp);
            pushUndoState("Move Shape");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, shWrap);
            } else if (targetType === "page" && typeof pageNumber === "number") {
              await dmbHandleCrossPageMove(obj, pageNumber);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup",  onUp);
        });

        // Resize handles
        shWrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault(); e.stopPropagation();
            shDMode = handle.dataset.handle;
            shSx = e.clientX; shSy = e.clientY;
            shOx = obj.x; shOy = obj.y;
            shOw = obj.w || 120; shOh = obj.h || 120;
            const onMove = (ev) => {
              const dx = ev.clientX - shSx, dy = ev.clientY - shSy;
              let nx = shOx, ny = shOy, nw = shOw, nh = shOh;
              if (shDMode.includes("r")) nw = Math.max(SH_MIN, shOw + dx);
              if (shDMode.includes("l")) { nw = Math.max(SH_MIN, shOw - dx); nx = shOx + shOw - nw; }
              if (shDMode.includes("b")) nh = Math.max(SH_MIN, shOh + dy);
              if (shDMode.includes("t")) { nh = Math.max(SH_MIN, shOh - dy); ny = shOy + shOh - nh; }
              // For tm/bm (top/bottom middle) → height only
              if (shDMode === "tm") { nh = Math.max(SH_MIN, shOh - dy); ny = shOy + shOh - nh; nw = shOw; }
              if (shDMode === "bm") { nh = Math.max(SH_MIN, shOh + dy); nw = shOw; }
              if (shDMode === "ml") { nw = Math.max(SH_MIN, shOw - dx); nx = shOx + shOw - nw; nh = shOh; }
              if (shDMode === "mr") { nw = Math.max(SH_MIN, shOw + dx); nh = shOh; }
              obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
              shWrap.style.left   = nx + "px";
              shWrap.style.top    = ny + "px";
              shWrap.style.width  = nw + "px";
              shWrap.style.height = nh + "px";
              if (obj.coverZone) dmbApplyZoneClip(shWrap, obj);
            };
            const onUp = () => {
              shDMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup",  onUp);
              pushUndoState("Resize Shape");
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup",  onUp);
          });
        });

        container.appendChild(shWrap);
        return;
      }

      if (obj.type === "mag-icon") {
        if ((obj.w || 0) < 1 || (obj.h || 0) < 1) { obj.w = 150; obj.h = 60; }
        const miWrap = document.createElement("div");
        miWrap.className = "dmb-sticker-object dmb-mag-icon-object";
        miWrap.dataset.objectId = obj.id;
        miWrap.dataset.iconId = obj.iconId || "";
        miWrap.style.cssText = `position:absolute;left:${obj.x||20}px;top:${obj.y||20}px;width:${obj.w}px;height:${obj.h}px;z-index:${obj.z||30};cursor:move;transform:rotate(${obj.rotation||0}deg);transform-origin:center center;`;
        miWrap.dataset.z = String(obj.z || 30);
        if (obj.coverZone) dmbApplyZoneClip(miWrap, obj);
        if (obj.contained) _dmbApplyContain(miWrap, obj, targetType === "cover");

        const miImgEl = document.createElement("img");
        miImgEl.draggable = false;
        miImgEl.style.cssText = "width:100%;height:100%;object-fit:contain;display:block;pointer-events:none;";
        miWrap.appendChild(miImgEl);
        dmbGetColoredIconDataUrl(obj.iconId, obj.color || "#000000").then((dataUrl) => {
          if (miImgEl.isConnected) miImgEl.src = dataUrl;
        });

        function miHandlePts(w, h) { return { tl:[0,0], tm:[w/2,0], tr:[w,0], ml:[0,h/2], mr:[w,h/2], bl:[0,h], bm:[w/2,h], br:[w,h] }; }
        function updateMiHandles(w, h) {
          const pts = miHandlePts(w, h);
          miWrap.querySelectorAll(".dmb-frame-handle").forEach((el) => {
            const [lx, ty] = pts[el.dataset.handle] || [0, 0];
            el.style.left = lx + "px"; el.style.top = ty + "px";
          });
        }
        const miInitPts = miHandlePts(obj.w, obj.h);
        [["tl"],["tm"],["tr"],["ml"],["mr"],["bl"],["bm"],["br"]].forEach(([pos]) => {
          const hEl = document.createElement("div");
          hEl.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
          hEl.dataset.handle = pos;
          const [lx, ty] = miInitPts[pos];
          hEl.style.left = lx + "px"; hEl.style.top = ty + "px";
          miWrap.appendChild(hEl);
        });

        const { gH: miGH, gV: miGV } = dmbGetSnapGuides(container);

        miWrap.addEventListener("click", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.stopPropagation();
          showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
        });

        let miDMode = null, miSx = 0, miSy = 0, miOx = 0, miOy = 0, miOw = 0, miOh = 0;
        const MI_MIN = 20;

        miWrap.addEventListener("pointerdown", (e) => {
          if (e.target.closest(".dmb-frame-handle")) return;
          e.preventDefault(); e.stopPropagation();
          if (obj.contained) miWrap.style.clipPath = ""; // show full during drag
          showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
          miDMode = "move"; miSx = e.clientX; miSy = e.clientY; miOx = obj.x; miOy = obj.y;
          let _liftMI = null;
          if (targetType === "page") {
            const _pr = miWrap.closest("[data-spread-row]");
            if (_pr) {
              const _wr = miWrap.getBoundingClientRect(), _rr = _pr.getBoundingClientRect();
              _liftMI = { pagesRow: _pr, origParent: miWrap.parentElement, origZ: miWrap.style.zIndex };
              miOx = _wr.left - _rr.left; miOy = _wr.top - _rr.top;
              miWrap.style.left = miOx + "px"; miWrap.style.top = miOy + "px"; miWrap.style.zIndex = "9000"; // below guides (9999)
              _pr.appendChild(miWrap);
            }
          }
          const onMove = (ev) => {
            if (miDMode !== "move") return;
            const dx = ev.clientX - miSx, dy = ev.clientY - miSy;
            if (_liftMI) {
              const _rawL = miOx + dx, _rawT = miOy + dy;
              const { dx: _sdx, dy: _sdy } = _dmbLiftSnap(_rawL, _rawT, obj.w, obj.h, obj.id, _liftMI, miGH, miGV, targetType, pageNumber);
              miWrap.style.left = (_rawL + _sdx) + "px"; miWrap.style.top = (_rawT + _sdy) + "px";
            } else {
              obj.x = miOx + dx; obj.y = miOy + dy;
              miWrap.style.left = obj.x + "px"; miWrap.style.top = obj.y + "px";
              if (obj.coverZone) dmbApplyZoneClip(miWrap, obj);
              dmbCheckSnap(obj, container, miGH, miGV, { targetType, pageNumber });
              miWrap.style.left = obj.x + "px"; miWrap.style.top = obj.y + "px";
              showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
            }
          };
          const onUp = async () => {
            miDMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            if (_liftMI) {
              const _rx = parseFloat(miWrap.style.left), _ry = parseFloat(miWrap.style.top);
              const _pgR = _liftMI.origParent?.parentElement?.getBoundingClientRect();
              const _rR  = _liftMI.pagesRow.getBoundingClientRect();
              obj.x = _rx - (_pgR ? _pgR.left - _rR.left : 0); obj.y = _ry;
              miWrap.style.left = obj.x + "px"; miWrap.style.top = obj.y + "px";
              miWrap.style.zIndex = _liftMI.origZ; _liftMI.origParent.appendChild(miWrap); _liftMI = null;
            }
            pushUndoState("Move Icon");
            if (targetType === "cover") _dmbAutoAssignCoverZone(obj, miWrap);
            else if (targetType === "page" && typeof pageNumber === "number") await dmbHandleCrossPageMove(obj, pageNumber);
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        miWrap.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
          handle.addEventListener("pointerdown", (e) => {
            e.preventDefault(); e.stopPropagation();
            showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
            miDMode = handle.dataset.handle; miSx = e.clientX; miSy = e.clientY;
            miOx = obj.x; miOy = obj.y; miOw = obj.w || 150; miOh = obj.h || 60;
            const miAspect = miOw / (miOh || 1);
            const onMove = (ev) => {
              const dx = ev.clientX - miSx, dy = ev.clientY - miSy;
              let nx = miOx, ny = miOy, nw = miOw, nh = miOh;
              if (miDMode === "tm" || miDMode === "bm") {
                nh = Math.max(MI_MIN, miDMode === "tm" ? miOh - dy : miOh + dy);
                if (miDMode === "tm") ny = miOy + miOh - nh;
                nw = Math.max(MI_MIN, Math.round(nh * miAspect)); nx = miOx + (miOw - nw) / 2;
              } else if (miDMode === "ml" || miDMode === "mr") {
                nw = Math.max(MI_MIN, miDMode === "ml" ? miOw - dx : miOw + dx);
                if (miDMode === "ml") nx = miOx + miOw - nw;
                nh = Math.max(MI_MIN, Math.round(nw / miAspect)); ny = miOy + (miOh - nh) / 2;
              } else {
                if (miDMode.includes("r")) nw = Math.max(MI_MIN, miOw + dx);
                if (miDMode.includes("l")) { nw = Math.max(MI_MIN, miOw - dx); nx = miOx + miOw - nw; }
                nh = Math.max(MI_MIN, Math.round(nw / miAspect));
                if (miDMode.includes("t")) ny = miOy + miOh - nh;
              }
              obj.x = nx; obj.y = ny; obj.w = nw; obj.h = nh;
              miWrap.style.left = nx + "px"; miWrap.style.top = ny + "px";
              miWrap.style.width = nw + "px"; miWrap.style.height = nh + "px";
              updateMiHandles(nw, nh);
              if (obj.coverZone) dmbApplyZoneClip(miWrap, obj);
              showFrameToolbarFor(miWrap, obj, { targetType, pageNumber, zone });
            };
            const onUp = () => {
              miDMode = null;
              document.removeEventListener("pointermove", onMove);
              document.removeEventListener("pointerup", onUp);
              pushUndoState("Resize Icon");
              if (targetType === "cover") _dmbAutoAssignCoverZone(obj, miWrap);
            };
            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp);
          });
        });

        const miRotHandle = document.createElement("div");
        miRotHandle.className = "dmb-map-rotate-handle dmb-map-rot-float";
        miRotHandle.innerHTML = "&#8635;"; miRotHandle.title = "Rotate"; miRotHandle.style.display = "none";
        document.body.appendChild(miRotHandle);
        miWrap._dmbRotHandle = miRotHandle;

        function updateMiRotPos() {
          if (!miWrap.isConnected) { miRotHandle.remove(); return; }
          const r = miWrap.getBoundingClientRect();
          miRotHandle.style.left = (r.right + 14) + "px"; miRotHandle.style.top = (r.bottom + 14) + "px";
        }
        requestAnimationFrame(updateMiRotPos);

        miRotHandle.addEventListener("pointerdown", (e) => {
          e.preventDefault(); e.stopPropagation();
          const startRot = obj.rotation || 0;
          const r = miWrap.getBoundingClientRect();
          const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          const startAng = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          const onMove = (ev) => {
            const ang = Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI;
            obj.rotation = _dmbSnapAngle(startRot + (ang - startAng));
            miWrap.style.transform = `rotate(${obj.rotation}deg)`;
            updateMiRotPos();
            showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
          };
          const onUp = () => {
            hideRotDegTooltip();
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            pushUndoState("Rotate Icon");
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });

        container.appendChild(miWrap);
        return;
      }

      if (obj.type === "text") {
        // Safety net: never re-create an empty text box — it was deleted.
        // The primary cleanup happens in savePageTextState, but stale data in
        // older localStorage saves may still have {text: ""} objects.
        if (!obj.text || !obj.text.trim()) return;
        const txt = document.createElement("div");
        txt.id = obj.id;
        txt.textContent = obj.text || "";
        txt.classList.add("dmb-editable-text");
        txt.style.position = "absolute";
        txt.style.left = obj.left || "40px";
        txt.style.top = obj.top || "40px";
        if (obj.width) txt.style.width = obj.width;
        txt.style.fontSize = obj.fontSize || "28px";
        txt.style.fontWeight = obj.fontWeight || "800";
        txt.style.color = obj.color || "#666";
        txt.style.fontFamily = obj.fontFamily || "'Londrina Solid', sans-serif";
        if (obj.textAlign) txt.style.textAlign = obj.textAlign;
        if (obj.textDecoration) txt.style.textDecoration = obj.textDecoration;
        if (obj.transform) txt.style.transform = obj.transform;
        if (obj.rotate) txt.dataset.rotate = obj.rotate;
        txt.dataset.z = obj.z || String(Date.now());
        txt.style.zIndex = txt.dataset.z;
        txt.dataset.pageNumber = String(pageNumber);
        txt.style.padding = "2px 6px";
        txt.style.background = "transparent";
        txt.style.outline = "none";
        attachTextNodeHandlers(txt);
        container.appendChild(txt);
        return;
      }

      if (obj.type !== "photo-frame") return;

      const frame = document.createElement("div");
      frame.className = "dmb-photo-frame-object";
      frame.dataset.objectId = obj.id;
      frame.style.left = `${obj.x}px`;
      frame.style.top = `${obj.y}px`;
      frame.style.width = `${obj.w}px`;
      frame.style.height = `${obj.h}px`;
      const z = obj.z || 10;
      // On pages: z >= 60 (above spread overlay z:50). On cover: z >= 100001 (above cover drag overlay z:100000).
      frame.style.zIndex = String(Math.max(z, minFrameZ));
      frame.dataset.z = String(z);
      if (obj.rotation) frame.style.transform = `rotate(${obj.rotation}deg)`;
      if (obj.coverZone) dmbApplyZoneClip(frame, obj);

      if (obj.photoId) {
        const ph = getPhotoById(obj.photoId);
        if (ph) {
          // Overflow visible so buttons escape; inner clip keeps photo contained
          frame.style.overflow = "visible";
          const photoClip = document.createElement("div");
          photoClip.style.cssText = "position:absolute;inset:0;overflow:hidden;border-radius:inherit;pointer-events:none;";
          const img = document.createElement("img");
          img.src = ph.url; img.alt = ""; img.draggable = false;
          img.style.cssText = "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;";
          if (obj.frameShape) applyDmbFrameShape(img, obj.frameShape);
          photoClip.appendChild(img);
          frame.appendChild(photoClip);

          // Adaptive button layout based on frame width
          const _btnSVGs = [
            { aria:"Remove photo",  title:"Remove photo",  svg:`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Remove Photo");obj.photoId=null;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail();renderPhotoTray(); }},
            { aria:"Rotate",        title:"Rotate 90° anti-clockwise", svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Rotate Photo");obj.rotation=((obj.rotation||0)-90+360)%360;if(builderMode==="cover")renderCoverCanvas();else renderSpread();renderThumbsRail(); }},
            { aria:"Crop",          title:"Crop photo",    svg:`<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();openCropModal(obj.photoId); }},
            { aria:"Frame shape",   title:"Frame shape",   svg:`<svg viewBox="0 0 22 22" width="13" height="13" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();showDmbFramePicker(e.currentTarget,obj.frameShape||"",(s)=>{ pushUndoState("Frame Shape");obj.frameShape=s;applyDmbFrameShape(img,s); }); }}
          ];
          const _bs = "border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";
          const fw = obj.w || 100;

          if (fw >= 130) {
            // Wide: single row top-right
            _btnSVGs.forEach((d, i) => {
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:4px;right:${4+i*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else if (fw >= 65) {
            // Medium: 2×2 grid top-right
            _btnSVGs.forEach((d, i) => {
              const r=Math.floor(i/2), c=i%2;
              const b = document.createElement("button"); b.type="button";
              b.setAttribute("aria-label",d.aria); b.title=d.title; b.innerHTML=d.svg;
              b.style.cssText=`position:absolute;top:${4+r*26}px;right:${4+c*26}px;width:24px;height:24px;z-index:11;${_bs}`;
              b.addEventListener("click",d.fn); frame.appendChild(b);
            });
          } else {
            // Narrow: single ⋯ toggle
            const mb = document.createElement("button"); mb.type="button"; mb.title="Options";
            mb.innerHTML="···";
            mb.style.cssText=`position:absolute;top:2px;right:2px;width:22px;height:22px;z-index:12;font-size:13px;line-height:1;${_bs}`;
            const pop = document.createElement("div");
            pop.style.cssText="position:absolute;top:26px;right:0;background:rgba(20,20,20,0.92);border-radius:8px;padding:4px;display:none;flex-direction:column;gap:2px;z-index:20;min-width:110px;";
            _btnSVGs.forEach(d => {
              const b = document.createElement("button"); b.type="button";
              b.innerHTML=`<span style="display:flex;align-items:center;gap:6px;">${d.svg}<span style="font-size:11px;font-weight:700;color:#fff;">${d.aria}</span></span>`;
              b.style.cssText="background:none;border:none;cursor:pointer;padding:4px 8px;border-radius:6px;width:100%;text-align:left;";
              b.addEventListener("click",(ev)=>{ pop.style.display="none"; d.fn(ev); });
              pop.appendChild(b);
            });
            mb.addEventListener("click",(e)=>{ e.preventDefault();e.stopPropagation(); const _open=pop.style.display==="none"; document.querySelectorAll(".dmb-frame-popup-open").forEach(p=>{p.style.display="none";p.classList.remove("dmb-frame-popup-open");}); if(_open){pop.style.display="flex";pop.classList.add("dmb-frame-popup-open");} });
            frame.appendChild(mb); frame.appendChild(pop);
          }
        }
      } else {
        const plus = document.createElement("div");
        plus.className = "dmb-photo-frame-plus";
        plus.innerHTML = '<span style="font-size:22px;display:block;">+</span><span style="font-size:11px;opacity:.7;">Drop photo here</span>';
        frame.appendChild(plus);
      }

      const handles = [
        ["tl", "0", "0"], ["tm", "50%", "0"], ["tr", "100%", "0"],
        ["ml", "0", "50%"], ["mr", "100%", "50%"],
        ["bl", "0", "100%"], ["bm", "50%", "100%"], ["br", "100%", "100%"]
      ];
      handles.forEach(([pos, left, top]) => {
        const h = document.createElement("div");
        h.className = `dmb-frame-handle dmb-frame-handle-${pos}`;
        h.dataset.handle = pos;
        h.style.left = left;
        h.style.top = top;
        frame.appendChild(h);
      });

      /* ── Frame rotation handle (Fix 4) ── */
      const _fRotHandle2 = document.createElement("div");
      _fRotHandle2.className = "dmb-map-rotate-handle dmb-map-rot-float";
      _fRotHandle2.innerHTML = "&#8635;";
      _fRotHandle2.title = "Rotate frame";
      _fRotHandle2.style.display = "none";
      document.body.appendChild(_fRotHandle2);
      frame._dmbRotHandle = _fRotHandle2;

      function _updateFrameRotPos2() {
        if (!frame.isConnected) { _fRotHandle2.remove(); return; }
        const _rr = frame.getBoundingClientRect();
        _fRotHandle2.style.left = (_rr.right + 14) + "px";
        _fRotHandle2.style.top = (_rr.bottom + 14) + "px";
      }
      requestAnimationFrame(_updateFrameRotPos2);

      _fRotHandle2.addEventListener("pointerdown", (e) => {
        e.preventDefault(); e.stopPropagation();
        const _startRot = obj.rotation || 0;
        const _rr2 = frame.getBoundingClientRect();
        const _cx = _rr2.left + _rr2.width / 2, _cy = _rr2.top + _rr2.height / 2;
        const _startAng = Math.atan2(e.clientY - _cy, e.clientX - _cx) * 180 / Math.PI;
        const _onMove = (ev) => {
          const _ang = Math.atan2(ev.clientY - _cy, ev.clientX - _cx) * 180 / Math.PI;
          obj.rotation = _dmbSnapAngle(_startRot + (_ang - _startAng));
          frame.style.transform = `rotate(${obj.rotation}deg)`;
          _updateFrameRotPos2();
          showRotDegTooltip(obj.rotation, ev.clientX, ev.clientY);
        };
        const _onUp = () => {
          hideRotDegTooltip();
          document.removeEventListener("pointermove", _onMove);
          document.removeEventListener("pointerup", _onUp);
          pushUndoState("Rotate Frame");
        };
        document.addEventListener("pointermove", _onMove);
        document.addEventListener("pointerup", _onUp);
      });

      frame.addEventListener("click", (e) => {
        e.stopPropagation();
        showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
      });

      frame.addEventListener("dragover", (e) => {
        e.preventDefault();
        const payload = getDragPayload(e);
        e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
      });

      frame.addEventListener("drop", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const payload = getDragPayload(e);
        if (!payload || !payload.photoId) return;
        pushUndoState("Drop Photo In Frame");
        obj.photoId = payload.photoId;
        if (builderMode === "cover") renderCoverCanvas(); else renderSpread();
        renderPhotoTray();
        renderThumbsRail();
      });

      let dragMode = null;
      let sx = 0, sy = 0, ox = 0, oy = 0, ow = 0, oh = 0;

      const { gH: fGH, gV: fGV } = dmbGetSnapGuides(container);

      frame.addEventListener("pointerdown", (e) => {
        if (e.target.closest(".dmb-frame-handle")) return;
        // Let action buttons (crop, remove, rotate, etc.) receive their click events.
        // pointerdown.preventDefault() suppresses the click event for the whole pointer
        // sequence, so buttons inside the frame would silently do nothing without this guard.
        if (e.target.closest("button")) return;
        e.preventDefault();
        e.stopPropagation();
        showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
        dragMode = "move";
        sx = e.clientX; sy = e.clientY;
        ox = obj.x; oy = obj.y;
        let _liftF = null;
        if (targetType === "page") {
          const _pr = frame.closest("[data-spread-row]");
          if (_pr) {
            _liftF = { pagesRow: _pr, origParent: frame.parentElement, origZ: frame.style.zIndex };
            // Use CSS-based page offset instead of getBoundingClientRect().
            // getBoundingClientRect gives the AXIS-ALIGNED bounding box of the rotated
            // element, which differs from the CSS left/top (the pre-rotation anchor).
            // Using offsetLeft/offsetTop avoids the position jump on rotated frames.
            const _pageEl = _liftF.origParent.parentElement; // the page div
            const _pageOffL = (_pageEl && _pageEl.offsetLeft) || 0;
            const _pageOffT = (_pageEl && _pageEl.offsetTop)  || 0;
            ox = obj.x + _pageOffL;
            oy = obj.y + _pageOffT;
            frame.style.left = ox + "px"; frame.style.top = oy + "px"; frame.style.zIndex = "9000"; // below guides (9999)
            _pr.appendChild(frame);
          }
        }

        const onMove = (ev) => {
          if (dragMode !== "move") return;
          const dx = ev.clientX - sx, dy = ev.clientY - sy;
          if (_liftF) {
            const _rawL = ox + dx, _rawT = oy + dy;
            const { dx: _sdx, dy: _sdy } = _dmbLiftSnap(_rawL, _rawT, obj.w, obj.h, obj.id, _liftF, fGH, fGV, targetType, pageNumber);
            frame.style.left = (_rawL + _sdx) + "px"; frame.style.top = (_rawT + _sdy) + "px";
          } else {
            obj.x = ox + dx; obj.y = oy + dy;
            frame.style.left = `${obj.x}px`; frame.style.top = `${obj.y}px`;
            if (obj.coverZone) dmbApplyZoneClip(frame, obj);
            dmbCheckSnap(obj, container, fGH, fGV, { targetType, pageNumber });
            frame.style.left = `${obj.x}px`; frame.style.top = `${obj.y}px`;
            showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
          }
        };
        const onUp = async () => {
          dragMode = null;
          document.removeEventListener("pointermove", onMove);
          document.removeEventListener("pointerup", onUp);
          if (_liftF) {
            const _rx = parseFloat(frame.style.left), _ry = parseFloat(frame.style.top);
            // Use same CSS-based offset as the lift start (no getBoundingClientRect)
            const _pageEl2 = _liftF.origParent?.parentElement;
            const _pOff = (_pageEl2 && _pageEl2.offsetLeft) || 0;
            const _pOffT = (_pageEl2 && _pageEl2.offsetTop)  || 0;
            obj.x = _rx - _pOff;
            obj.y = _ry - _pOffT;
            frame.style.left = obj.x + "px"; frame.style.top = obj.y + "px";
            frame.style.zIndex = _liftF.origZ; _liftF.origParent.appendChild(frame); _liftF = null;
          }
          pushUndoState("Move Frame");
          if (targetType === "cover") {
            _dmbAutoAssignCoverZone(obj, frame);
          } else if (targetType === "page" && typeof pageNumber === "number") {
            await dmbHandleCrossPageMove(obj, pageNumber);
          }
        };
        document.addEventListener("pointermove", onMove);
        document.addEventListener("pointerup", onUp);
      });

      frame.querySelectorAll(".dmb-frame-handle").forEach((handle) => {
        handle.addEventListener("pointerdown", (e) => {
          e.preventDefault();
          e.stopPropagation();
          showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
          dragMode = handle.dataset.handle;
          sx = e.clientX; sy = e.clientY;
          ox = obj.x; oy = obj.y; ow = obj.w; oh = obj.h;

          const onMove = (ev) => {
            const dx = ev.clientX - sx;
            const dy = ev.clientY - sy;
            // Decompose screen-space delta into the element's rotated local coordinate system.
            // Without this, resizing a rotated frame pulls in the wrong direction.
            // For non-rotated frames (rotation=0): cos=1, sin=0 → ldx=dx, ldy=dy (no change).
            const _rot = (obj.rotation || 0) * Math.PI / 180;
            const _cos = Math.cos(_rot), _sin = Math.sin(_rot);
            const ldx = dx * _cos + dy * _sin;   // delta along element's local X axis
            const ldy = -dx * _sin + dy * _cos;  // delta along element's local Y axis

            if (dragMode.includes("r")) obj.w = Math.max(60, ow + ldx);
            if (dragMode.includes("b")) obj.h = Math.max(60, oh + ldy);
            if (dragMode.includes("l")) {
              const nextW = Math.max(60, ow - ldx);
              const diff = ow - nextW;
              // The left edge moves in the element's local -X direction; convert to parent space
              obj.x = ox + diff * _cos;
              obj.y = oy + diff * _sin;
              obj.w = nextW;
            }
            if (dragMode.includes("t")) {
              const nextH = Math.max(60, oh - ldy);
              const diff = oh - nextH;
              // The top edge moves in the element's local -Y direction; convert to parent space
              obj.x = ox - diff * _sin;
              obj.y = oy + diff * _cos;
              obj.h = nextH;
            }
            frame.style.left = `${obj.x}px`;
            frame.style.top = `${obj.y}px`;
            frame.style.width = `${obj.w}px`;
            frame.style.height = `${obj.h}px`;
            if (obj.coverZone) dmbApplyZoneClip(frame, obj);
            showFrameToolbarFor(frame, obj, { targetType, pageNumber, zone });
          };
          const onUp = () => {
            dragMode = null;
            document.removeEventListener("pointermove", onMove);
            document.removeEventListener("pointerup", onUp);
            pushUndoState("Resize Frame");
            if (targetType === "cover") {
              _dmbAutoAssignCoverZone(obj, frame);
            }
          };
          document.addEventListener("pointermove", onMove);
          document.addEventListener("pointerup", onUp);
        });
      });

      container.appendChild(frame);
    });
  }
  // --- end frame rendering helpers ---

  function renderCoverCanvas() {
    if (!spreadCanvas || !spreadIndexEl) return;
    // Remove orphaned fixed-position rotation handles before re-render
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => el.remove());
    // Mark cover dirty so PDF preview re-renders after this change (2s debounce)
    _dmbPvMarkDirty("cover");

    spreadCanvas.innerHTML = "";

    const wrap = document.createElement("div");
    wrap.className = "dmb-cover-preview";

    const back = document.createElement("div");
    back.className = "dmb-cover-face dmb-cover-back";
    back.id = "coverBack";
    back.style.cursor = "pointer";
    if (coverState.backImageUrl) {
      back.style.background = coverState.color || "#ffffff";
      back.style.overflow = "hidden";
      const _backImgDiv = document.createElement("div");
      _backImgDiv.style.cssText = `position:absolute;inset:0;background:url(${coverState.backImageUrl}) center/cover no-repeat;transform:rotate(${coverState.backImageRot||0}deg);transform-origin:center center;z-index:0;pointer-events:none;`;
      back.appendChild(_backImgDiv);
      // Control buttons (X, rotate, crop, frames) — same style as page photos
      const _bRm = document.createElement("button");
      _bRm.type="button"; _bRm.setAttribute("aria-label","Remove photo"); _bRm.title="Remove photo";
      _bRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
      _bRm.style.cssText="position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Photo"); coverState.backImageUrl=""; coverState.backImageId=""; coverState.backImageRot=0; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
      back.appendChild(_bRm);
      const _bRot = document.createElement("button");
      _bRot.type="button"; _bRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _bRot.title="Rotate 90° anti-clockwise";
      _bRot.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      _bRot.style.cssText="position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Photo"); coverState.backImageRot=((coverState.backImageRot||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
      back.appendChild(_bRot);
      const _bCrop = document.createElement("button");
      _bCrop.type="button"; _bCrop.setAttribute("aria-label","Crop photo"); _bCrop.title="Crop photo";
      _bCrop.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
      _bCrop.style.cssText="position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); if(coverState.backImageId) openCropModal(coverState.backImageId); });
      back.appendChild(_bCrop);
      const _bFrame = document.createElement("button");
      _bFrame.type="button"; _bFrame.setAttribute("aria-label","Frame shape"); _bFrame.title="Frame shape";
      _bFrame.innerHTML=`<svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
      _bFrame.style.cssText="position:absolute;top:8px;right:104px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _bFrame.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); showDmbFramePicker(_bFrame, coverState.backImageFrameShape||"", (shapeId)=>{ pushUndoState("Frame Shape"); coverState.backImageFrameShape=shapeId; applyDmbFrameShape(_backImgDiv, shapeId); saveCoverDesignToStorage(); }); });
      back.appendChild(_bFrame);
    } else if (window.DMB_MAGAZINE_MODE) {
      back.style.background = "#c8c8c8";
      const _backHint = document.createElement("div");
      _backHint.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;pointer-events:none;z-index:0;";
      _backHint.innerHTML = `<svg width="30" height="30" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="11" stroke="rgba(255,255,255,0.75)" stroke-width="1.5"/><line x1="13" y1="7.5" x2="13" y2="18.5" stroke="rgba(255,255,255,0.75)" stroke-width="2" stroke-linecap="round"/><line x1="7.5" y1="13" x2="18.5" y2="13" stroke="rgba(255,255,255,0.75)" stroke-width="2" stroke-linecap="round"/></svg><span style="font-size:9px;font-weight:700;color:rgba(255,255,255,0.8);letter-spacing:0.5px;text-transform:uppercase;">Drop photo here</span>`;
      back.appendChild(_backHint);
    } else {
      back.style.background = coverState.color || "#ffffff";
    }
    back.addEventListener("click", (e) => {
      e.stopPropagation();
      activeCoverZone = "back";
      if (typeof markActiveCoverZone === "function") markActiveCoverZone();
      if (typeof hideTextToolbar === "function") hideTextToolbar();
    });
    back.addEventListener("dragover", (e) => { e.preventDefault(); e.dataTransfer.dropEffect = "copy"; back.style.outline = "2px solid #111"; back.style.outlineOffset = "-2px"; });
    back.addEventListener("dragleave", () => { back.style.outline = "none"; });
    back.addEventListener("drop", (e) => {
      e.preventDefault(); back.style.outline = "none";
      const payload = getDragPayload(e);
      const photoId = payload?.photoId || (e.dataTransfer.getData("text/plain") || "").trim();
      if (!photoId) return;
      const photo = getPhotoById(photoId);
      if (!photo) return;
      pushUndoState("Drop Photo On Cover Back");
      coverState.backImageUrl = photo.url;
      coverState.backImageId = photoId;
      coverState.backImageRot = 0;
      saveCoverDesignToStorage();
      renderCoverCanvas();
    });


    let spine = null;
    if (!window.DMB_MAGAZINE_MODE) {
      spine = document.createElement("div");
      spine.className = "dmb-cover-spine";
      spine.style.background = coverState.color || "#ffffff";
      spine.id = "coverSpine";
      spine.style.cursor = "pointer";
      // Hide internal seam borders when a bleed photo covers those junctions
      if (coverState.bleedZone === "full" || coverState.bleedZone === "spine-back")  spine.style.borderLeft  = "none";
      if (coverState.bleedZone === "full" || coverState.bleedZone === "front-spine") spine.style.borderRight = "none";
      if (coverState.spineImageUrl) {
        const _spineImgDiv = document.createElement("div");
        _spineImgDiv.style.cssText = `position:absolute;inset:0;background:url(${coverState.spineImageUrl}) center/cover no-repeat;z-index:0;pointer-events:none;`;
        spine.appendChild(_spineImgDiv);
      }
      spine.addEventListener("click", (e) => {
        e.stopPropagation();
        activeCoverZone = "spine";
        if (typeof markActiveCoverZone === "function") markActiveCoverZone();
        if (typeof hideTextToolbar === "function") hideTextToolbar();
      });
    }


    const front = document.createElement("div");
    front.className = "dmb-cover-face dmb-cover-front";
    front.id = "coverFront";
    front.style.cursor = "pointer";
    if (coverState.frontImageUrl) {
      front.style.background = coverState.color || "#ffffff";
      front.style.overflow = "hidden";
      const _frontImgDiv = document.createElement("div");
      _frontImgDiv.style.cssText = `position:absolute;inset:0;background:url(${coverState.frontImageUrl}) center/cover no-repeat;transform:rotate(${coverState.frontImageRot||0}deg);transform-origin:center center;z-index:0;pointer-events:none;`;
      front.appendChild(_frontImgDiv);
      // Control buttons (X, rotate, crop, frames) — same style as page photos
      const _fRm = document.createElement("button");
      _fRm.type="button"; _fRm.setAttribute("aria-label","Remove photo"); _fRm.title="Remove photo";
      _fRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
      _fRm.style.cssText="position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Photo"); coverState.frontImageUrl=""; coverState.frontImageId=""; coverState.frontImageRot=0; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
      front.appendChild(_fRm);
      const _fRot = document.createElement("button");
      _fRot.type="button"; _fRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _fRot.title="Rotate 90° anti-clockwise";
      _fRot.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      _fRot.style.cssText="position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Photo"); coverState.frontImageRot=((coverState.frontImageRot||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
      front.appendChild(_fRot);
      const _fCrop = document.createElement("button");
      _fCrop.type="button"; _fCrop.setAttribute("aria-label","Crop photo"); _fCrop.title="Crop photo";
      _fCrop.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
      _fCrop.style.cssText="position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); if(coverState.frontImageId) openCropModal(coverState.frontImageId); });
      front.appendChild(_fCrop);
      const _fFrame = document.createElement("button");
      _fFrame.type="button"; _fFrame.setAttribute("aria-label","Frame shape"); _fFrame.title="Frame shape";
      _fFrame.innerHTML=`<svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
      _fFrame.style.cssText="position:absolute;top:8px;right:104px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
      _fFrame.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); showDmbFramePicker(_fFrame, coverState.frontImageFrameShape||"", (shapeId)=>{ pushUndoState("Frame Shape"); coverState.frontImageFrameShape=shapeId; applyDmbFrameShape(_frontImgDiv, shapeId); saveCoverDesignToStorage(); }); });
      front.appendChild(_fFrame);
    } else if (window.DMB_MAGAZINE_MODE) {
      front.style.background = "#c8c8c8";
      const _frontHint = document.createElement("div");
      _frontHint.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;pointer-events:none;z-index:0;";
      _frontHint.innerHTML = `<svg width="30" height="30" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="11" stroke="rgba(255,255,255,0.75)" stroke-width="1.5"/><line x1="13" y1="7.5" x2="13" y2="18.5" stroke="rgba(255,255,255,0.75)" stroke-width="2" stroke-linecap="round"/><line x1="7.5" y1="13" x2="18.5" y2="13" stroke="rgba(255,255,255,0.75)" stroke-width="2" stroke-linecap="round"/></svg><span style="font-size:9px;font-weight:700;color:rgba(255,255,255,0.8);letter-spacing:0.5px;text-transform:uppercase;">Drop photo here</span>`;
      front.appendChild(_frontHint);
    } else {
      front.style.background = coverState.color || "#ffffff";
    }
    front.addEventListener("click", (e) => {
      e.stopPropagation();
      activeCoverZone = "front";
      if (typeof markActiveCoverZone === "function") markActiveCoverZone();
      if (typeof hideTextToolbar === "function") hideTextToolbar();
    });
    front.addEventListener("dragover", (e) => { e.preventDefault(); e.dataTransfer.dropEffect = "copy"; front.style.outline = "2px solid #111"; front.style.outlineOffset = "-2px"; });
    front.addEventListener("dragleave", () => { front.style.outline = "none"; });
    front.addEventListener("drop", (e) => {
      e.preventDefault(); front.style.outline = "none";
      const payload = getDragPayload(e);
      const photoId = payload?.photoId || (e.dataTransfer.getData("text/plain") || "").trim();
      if (!photoId) return;
      const photo = getPhotoById(photoId);
      if (!photo) return;
      pushUndoState("Drop Photo On Cover Front");
      coverState.frontImageUrl = photo.url;
      coverState.frontImageId = photoId;
      coverState.frontImageRot = 0;
      saveCoverDesignToStorage();
      renderCoverCanvas();
    });


    const overlay = document.createElement("div");
    overlay.id = "coverOverlay";
    overlay.className = "dmb-cover-overlay";
    overlay.style.zIndex = "9999";

    wrap.appendChild(back);
    if (spine) wrap.appendChild(spine);
    wrap.appendChild(front);
    wrap.appendChild(overlay);

    // ── SAFE-ZONE GUIDE LINES ──────────────────────────────────────────────
    // Add two vertical dashed guide lines (14px from left/right edge) to each
    // cover face: back, spine, and front.  They show ONLY while an object is
    // being dragged (class dmb-cover-guides-on on the wrap) and disappear on
    // pointerup.  Guides are purely visual (pointer-events:none) — the customer
    // can place objects outside them if they wish.
    //
    // WARNING: Do NOT add these to the overlay — they belong inside each face
    // so they appear behind dragged objects (overlay z:9999) and serve as a
    // passive reference, never blocking interaction.
    (function _addCoverSafeGuides() {
      function addGuidesToFace(faceEl) {
        ["left", "right"].forEach(function(side) {
          var g = document.createElement("div");
          g.className = "dmb-cover-safe-guide dmb-cover-safe-guide-" + side;
          g.setAttribute("aria-hidden", "true");
          faceEl.appendChild(g);
        });
      }
      addGuidesToFace(back);
      if (spine) addGuidesToFace(spine);
      addGuidesToFace(front);

      // Show guides on any pointerdown inside the cover preview.
      // Capture phase so we catch events on deeply nested children (objects
      // in the overlay) before they stop propagation.
      wrap.addEventListener("pointerdown", function() {
        wrap.classList.add("dmb-cover-guides-on");
      }, { capture: true });

      // Global pointerup hides guides on all cover previews.
      // Guard with a flag so we only add this listener once per page load
      // (renderCoverCanvas is called on every state change — without the guard
      //  we would accumulate identical listeners).
      if (!window._dmbCoverGuideHideWired) {
        window._dmbCoverGuideHideWired = true;
        document.addEventListener("pointerup", function() {
          document.querySelectorAll(".dmb-cover-preview.dmb-cover-guides-on")
            .forEach(function(w) { w.classList.remove("dmb-cover-guides-on"); });
        });
      }
    })();
    // ── end safe-zone guides ───────────────────────────────────────────────

    // ── Cover drag overlay (same style as spread drop overlay) ──
    const coverDragOverlay = document.createElement("div");
    coverDragOverlay.className = "dmb-cover-drag-overlay";

    function makeCoverZone(label) {
      const zone = document.createElement("div");
      zone.className = "dmb-cover-drop-zone";
      const lbl = document.createElement("div");
      lbl.className = "dmb-cover-zone-label";
      lbl.textContent = label;
      zone.appendChild(lbl);
      return zone;
    }

    let coverDropZones;
    if (window.DMB_MAGAZINE_MODE) {
      const zBack  = makeCoverZone("Back");
      const zFront = makeCoverZone("Front");
      coverDragOverlay.appendChild(zBack);
      coverDragOverlay.appendChild(zFront);
      coverDropZones = [
        { el: zBack,  targets: ["back"] },
        { el: zFront, targets: ["front"] }
      ];
    } else {
      const zBack       = makeCoverZone("Back");
      const zBackSpine  = makeCoverZone("Back + Spine");
      const zFull       = makeCoverZone("Full cover");
      const zSpineFront = makeCoverZone("Spine + Front");
      const zFront      = makeCoverZone("Front");
      coverDragOverlay.appendChild(zBack);
      coverDragOverlay.appendChild(zBackSpine);
      coverDragOverlay.appendChild(zFull);
      coverDragOverlay.appendChild(zSpineFront);
      coverDragOverlay.appendChild(zFront);
      coverDropZones = [
        { el: zBack,       targets: ["back"] },
        { el: zBackSpine,  targets: ["back", "spine"] },
        { el: zFull,       targets: ["back", "spine", "front"] },
        { el: zSpineFront, targets: ["spine", "front"] },
        { el: zFront,      targets: ["front"] }
      ];
    }

    wrap.appendChild(coverDragOverlay);

    let coverWrapEnter = 0;
    wrap.addEventListener("dragenter", (e) => {
      if (!getDragPayload(e)) return;
      coverWrapEnter++;
      coverDragOverlay.classList.add("active");
    });
    wrap.addEventListener("dragleave", (e) => {
      if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
      if (--coverWrapEnter <= 0) { coverWrapEnter = 0; coverDragOverlay.classList.remove("active"); }
    });
    wrap.addEventListener("dragover", (e) => { if (getDragPayload(e)) e.preventDefault(); });

    // Peek at the element underneath the cover drag overlay at screen position (cx,cy).
    // We briefly hide the overlay so elementFromPoint sees what's beneath it.
    function _elementUnderOverlay(cx, cy) {
      const saved = coverDragOverlay.style.display;
      coverDragOverlay.style.display = "none";
      const el = document.elementFromPoint(cx, cy);
      coverDragOverlay.style.display = saved;
      return el;
    }

    // Return the nearest cover photo-frame DOM element at screen point, or null.
    function _coverFrameElAtPoint(cx, cy) {
      const under = _elementUnderOverlay(cx, cy);
      if (!under) return null;
      // Free photo-frame (in overlay)
      const free = under.closest(".dmb-photo-frame-object");
      if (free) return free;
      // Layout frame (direct child of front/back face with data-cover-frame-key)
      const layout = under.closest("[data-cover-frame-key]");
      if (layout) return layout;
      return null;
    }

    function _clearCoverFrameHover() {
      document.querySelectorAll(".dmb-cover-frame-dragover")
        .forEach(f => f.classList.remove("dmb-cover-frame-dragover"));
    }

    coverDropZones.forEach(({ el, targets }) => {
      let zc = 0;
      el._pendingCoverFrame = null;

      el.addEventListener("dragenter", (e) => {
        e.preventDefault(); e.stopPropagation();
        if (++zc > 0) el.classList.add("drag-over");
      });
      el.addEventListener("dragleave", () => {
        if (--zc <= 0) { zc = 0; el.classList.remove("drag-over"); }
        _clearCoverFrameHover();
        el._pendingCoverFrame = null;
      });
      el.addEventListener("dragover", (e) => {
        e.preventDefault(); e.stopPropagation();
        // Peek under overlay to find frames and show black-border highlight
        const frameEl = _coverFrameElAtPoint(e.clientX, e.clientY);
        _clearCoverFrameHover();
        if (frameEl) { frameEl.classList.add("dmb-cover-frame-dragover"); }
        el._pendingCoverFrame = frameEl || null;
      });
      el.addEventListener("drop", (e) => {
        e.preventDefault(); e.stopPropagation();
        _clearCoverFrameHover();
        coverWrapEnter = 0; coverDragOverlay.classList.remove("active"); el.classList.remove("drag-over");
        const payload = getDragPayload(e);
        if (!payload) return;
        const photoId = payload.photoId || (e.dataTransfer.getData("text/plain") || "").trim();
        if (!photoId) return;
        const photo = getPhotoById(photoId);
        if (!photo) return;

        // ── Route to frame if cursor was over one ────────────────────────────
        const frameEl = el._pendingCoverFrame || _coverFrameElAtPoint(e.clientX, e.clientY);
        el._pendingCoverFrame = null;
        if (frameEl) {
          // Free photo-frame (stored in editor.coverObjects)
          if (frameEl.dataset.objectId) {
            const obj = (editor.coverObjects || []).find(o => o.id === frameEl.dataset.objectId);
            if (obj) {
              pushUndoState("Drop Photo In Cover Frame");
              obj.photoId = photoId;
              saveCoverDesignToStorage();
              renderCoverCanvas(); renderThumbsRail(); renderPhotoTray();
              return;
            }
          }
          // Layout frame (coverState.frontFrames / backFrames)
          if (frameEl.dataset.coverFrameKey) {
            const fZone = frameEl.dataset.coverZone || "front";
            const fKey  = frameEl.dataset.coverFrameKey;
            pushUndoState("Drop Photo In Cover Layout Frame");
            if (fZone === "front") { if (!coverState.frontFrames) coverState.frontFrames = {}; coverState.frontFrames[fKey] = photoId; }
            else                   { if (!coverState.backFrames)  coverState.backFrames  = {}; coverState.backFrames[fKey]  = photoId; }
            saveCoverDesignToStorage();
            renderCoverCanvas(); renderThumbsRail(); renderPhotoTray();
            return;
          }
        }

        // ── Zone drop (original logic) ────────────────────────────────────────
        pushUndoState("Drop Photo On Cover");
        if (targets.length > 1) {
          // Multi-zone: seamless bleed image
          if (targets.includes("front")) { coverState.frontImageUrl = ""; coverState.frontImageId = ""; coverState.frontImageRot = 0; }
          if (targets.includes("back"))  { coverState.backImageUrl  = ""; coverState.backImageId  = ""; coverState.backImageRot  = 0; }
          coverState.spineImageUrl = "";
          coverState.bleedImageUrl = photo.url;
          coverState.bleedImageId  = photoId;
          coverState.bleedImageRot = 0;
          coverState.bleedZone     = targets.includes("back") && targets.includes("front") ? "full"
                                   : targets.includes("back") ? "spine-back" : "front-spine";
        } else {
          // Single zone: individual face image, clear any bleed that covers it
          if (targets.includes("front")) {
            coverState.frontImageUrl = photo.url; coverState.frontImageId = photoId; coverState.frontImageRot = 0;
            if (coverState.bleedZone === "front-spine" || coverState.bleedZone === "full") { coverState.bleedImageUrl = ""; coverState.bleedImageId = ""; coverState.bleedZone = ""; coverState.bleedImageRot = 0; }
          }
          if (targets.includes("back")) {
            coverState.backImageUrl = photo.url; coverState.backImageId = photoId; coverState.backImageRot = 0;
            if (coverState.bleedZone === "spine-back" || coverState.bleedZone === "full") { coverState.bleedImageUrl = ""; coverState.bleedImageId = ""; coverState.bleedZone = ""; coverState.bleedImageRot = 0; }
          }
        }
        saveCoverDesignToStorage();
        renderCoverCanvas();
        renderThumbsRail();
        renderPhotoTray();
      });
    });

    spreadCanvas.appendChild(wrap);

    // Render photo grid layout frames inside each face (clipped to face bounds)
    function renderCoverFaceFrames(faceEl, zone) {
      const layoutId = zone === "front" ? coverState.frontLayout : coverState.backLayout;
      if (!layoutId) return;
      const defs   = TEMPLATE_DEFS[layoutId] || [];
      const frames = zone === "front" ? coverState.frontFrames : coverState.backFrames;
      faceEl.style.overflow = "hidden";
      defs.forEach((f) => {
        const fw = document.createElement("div");
        fw.style.cssText = `position:absolute;left:${f.x}%;top:${f.y}%;width:${f.w}%;height:${f.h}%;border:1px solid #eee;background:#f5f5f5;overflow:hidden;z-index:2;box-sizing:border-box;`;
        fw.dataset.coverZone = zone;
        fw.dataset.coverFrameKey = f.key;
        const pid = frames[f.key] || null;
        if (!pid) {
          const hint = document.createElement("div");
          hint.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;pointer-events:none;background:rgba(220,220,220,0.55);border:1.5px dashed #ccc;border-radius:2px;";
          hint.innerHTML = `<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="11" stroke="#c0c0c0" stroke-width="1.5"/><line x1="13" y1="7.5" x2="13" y2="18.5" stroke="#bbb" stroke-width="2" stroke-linecap="round"/><line x1="7.5" y1="13" x2="18.5" y2="13" stroke="#bbb" stroke-width="2" stroke-linecap="round"/></svg><span style="font-size:8px;font-weight:900;color:#bbb;letter-spacing:0.4px;text-transform:uppercase;">Drop photo</span>`;
          fw.appendChild(hint);
        } else {
          const photo = getPhotoById(pid);
          if (photo) {
            const frameRots = zone === "front" ? coverState.frontFrameRot : coverState.backFrameRot;
            const frameShapes = zone === "front" ? coverState.frontFrameShapes : coverState.backFrameShapes;
            const frameRot = frameRots[f.key] || 0;
            const frameShape = frameShapes[f.key] || "";
            const img = document.createElement("img");
            img.src = photo.url;
            img.draggable = false;
            img.style.cssText = `position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;transform:rotate(${frameRot}deg);transform-origin:center center;`;
            if (frameShape) applyDmbFrameShape(img, frameShape);
            fw.appendChild(img);
            // Control buttons — X, rotate, crop, frames
            const _lRm = document.createElement("button");
            _lRm.type="button"; _lRm.setAttribute("aria-label","Remove photo"); _lRm.title="Remove photo";
            _lRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
            _lRm.style.cssText="position:absolute;top:4px;right:4px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Photo"); if(zone==="front") coverState.frontFrames[f.key]=null; else coverState.backFrames[f.key]=null; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
            fw.appendChild(_lRm);
            const _lRot = document.createElement("button");
            _lRot.type="button"; _lRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _lRot.title="Rotate 90° anti-clockwise";
            _lRot.innerHTML=`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            _lRot.style.cssText="position:absolute;top:4px;right:32px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Photo"); const rots = zone==="front"?coverState.frontFrameRot:coverState.backFrameRot; rots[f.key]=((rots[f.key]||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
            fw.appendChild(_lRot);
            const _lCrop = document.createElement("button");
            _lCrop.type="button"; _lCrop.setAttribute("aria-label","Crop photo"); _lCrop.title="Crop photo";
            _lCrop.innerHTML=`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
            _lCrop.style.cssText="position:absolute;top:4px;right:60px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); openCropModal(pid); });
            fw.appendChild(_lCrop);
            const _lFrame = document.createElement("button");
            _lFrame.type="button"; _lFrame.setAttribute("aria-label","Frame shape"); _lFrame.title="Frame shape";
            _lFrame.innerHTML=`<svg viewBox="0 0 22 22" width="12" height="12" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
            _lFrame.style.cssText="position:absolute;top:4px;right:88px;width:24px;height:24px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
            _lFrame.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); const shapes = zone==="front"?coverState.frontFrameShapes:coverState.backFrameShapes; showDmbFramePicker(_lFrame, shapes[f.key]||"", (shapeId)=>{ pushUndoState("Frame Shape"); shapes[f.key]=shapeId; applyDmbFrameShape(img, shapeId); saveCoverDesignToStorage(); }); });
            fw.appendChild(_lFrame);
          }
        }
        fw.addEventListener("dragover", (e) => {
          e.preventDefault(); e.stopPropagation();
          e.dataTransfer.dropEffect = "copy";
          fw.style.outline = "2px solid #111"; fw.style.outlineOffset = "-2px";
        });
        fw.addEventListener("dragleave", () => { fw.style.outline = "none"; });
        fw.addEventListener("drop", (e) => {
          e.preventDefault(); e.stopPropagation();
          fw.style.outline = "none";
          const payload = getDragPayload(e);
          const photoId = (payload?.photoId) || ((e.dataTransfer.getData("text/plain") || "").trim());
          if (!photoId) return;
          pushUndoState("Drop Photo In Cover Frame");
          if (zone === "front") coverState.frontFrames[f.key] = photoId;
          else coverState.backFrames[f.key] = photoId;
          saveCoverDesignToStorage();
          renderCoverCanvas();
        });
        faceEl.appendChild(fw);
      });
    }
    renderCoverFaceFrames(back, "back");
    renderCoverFaceFrames(front, "front");

    // ── Seamless bleed image (spans back+spine+front or a subset) ──
    if (coverState.bleedImageUrl && coverState.bleedZone) {
      const _bleedZoneMap = {
        "spine-back":  { x: 0,              w: COVER_BACK_W + COVER_SPINE_W },
        "full":        { x: 0,              w: COVER_BACK_W + COVER_SPINE_W + 300 },
        "front-spine": { x: COVER_BACK_W,   w: COVER_SPINE_W + 300 }
      };
      const _bz = _bleedZoneMap[coverState.bleedZone];
      if (_bz) {
        const bleedWrap = document.createElement("div");
        // Extend 1px beyond each covered edge to absorb border seams
        const _bleedLeft = _bz.x > 0 ? _bz.x - 1 : 0;
        const _bleedW    = _bz.x > 0 ? _bz.w + 2 : _bz.w + 1;
        bleedWrap.style.cssText = `position:absolute;left:${_bleedLeft}px;top:0;width:${_bleedW}px;height:100%;overflow:hidden;z-index:5;`;
        const bleedImg = document.createElement("div");
        bleedImg.style.cssText = `position:absolute;inset:0;background:url(${coverState.bleedImageUrl}) center/cover no-repeat;transform:rotate(${coverState.bleedImageRot||0}deg);transform-origin:center center;pointer-events:none;`;
        bleedWrap.appendChild(bleedImg);
        // Control buttons — top-right of the bleed wrap (left/back corner side)
        const _blRm = document.createElement("button");
        _blRm.type="button"; _blRm.setAttribute("aria-label","Remove photo"); _blRm.title="Remove photo";
        _blRm.innerHTML=`<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
        _blRm.style.cssText="position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
        _blRm.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Remove Bleed Photo"); coverState.bleedImageUrl=""; coverState.bleedImageId=""; coverState.bleedZone=""; coverState.bleedImageRot=0; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); renderPhotoTray(); });
        bleedWrap.appendChild(_blRm);
        const _blRot = document.createElement("button");
        _blRot.type="button"; _blRot.setAttribute("aria-label","Rotate 90 degrees anti-clockwise"); _blRot.title="Rotate 90° anti-clockwise";
        _blRot.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        _blRot.style.cssText="position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
        _blRot.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); pushUndoState("Rotate Bleed Photo"); coverState.bleedImageRot=((coverState.bleedImageRot||0)-90+360)%360; saveCoverDesignToStorage(); renderCoverCanvas(); renderThumbsRail(); });
        bleedWrap.appendChild(_blRot);
        const _blCrop = document.createElement("button");
        _blCrop.type="button"; _blCrop.setAttribute("aria-label","Crop photo"); _blCrop.title="Crop photo";
        _blCrop.innerHTML=`<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
        _blCrop.style.cssText="position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0;";
        _blCrop.addEventListener("click",(e)=>{ e.preventDefault(); e.stopPropagation(); if(coverState.bleedImageId) openCropModal(coverState.bleedImageId); });
        bleedWrap.appendChild(_blCrop);
        wrap.insertBefore(bleedWrap, overlay);
      }
    }

    renderFreeFrameObjects(overlay, { targetType: "cover" });

    // Re-create user-added text nodes (survive re-renders via editor.coverUserTexts)
    // All user texts live in the overlay so they drag seamlessly across back/spine/front
    if (Array.isArray(editor.coverUserTexts)) {
      const _magFrontX = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      const zoneOffsets = { back: 40, spine: COVER_BACK_W + 5, front: _magFrontX + 40 };
      editor.coverUserTexts.forEach(({ id, zone }) => {
        const saved = coverState.textStyles && coverState.textStyles[id];
        const utxt = document.createElement("div");
        utxt.id = id;
        utxt.contentEditable = "true";
        utxt.classList.add("dmb-editable-text");
        utxt.style.position = "absolute";
        utxt.style.minWidth = "120px";
        utxt.style.padding = "2px 6px";
        utxt.style.background = "transparent";
        utxt.style.outline = "none";
        utxt.style.fontSize = saved?.fontSize || "28px";
        utxt.style.fontWeight = "800";
        utxt.style.color = saved?.color || "#666";
        utxt.style.fontFamily = saved?.fontFamily || "'Londrina Solid', sans-serif";
        utxt.style.left = saved?.left || (zoneOffsets[zone] ?? (_magFrontX + 40)) + "px";
        utxt.style.top = saved?.top || "40px";
        // Ensure z is always persisted — if not saved yet, assign one now so
        // the PDF render uses the same value as the builder DOM.
        if (!saved?.z) {
          const _newZ = String(Date.now());
          if (!coverState.textStyles) coverState.textStyles = {};
          if (!coverState.textStyles[id]) coverState.textStyles[id] = {};
          coverState.textStyles[id].z = _newZ;
        }
        utxt.dataset.z = coverState.textStyles?.[id]?.z || String(Date.now());
        utxt.style.zIndex = utxt.dataset.z;
        if (saved?.textAlign) utxt.style.textAlign = saved.textAlign;
        if (saved?.textDecoration) utxt.style.textDecoration = saved.textDecoration;
        if (saved?.transform) utxt.style.transform = saved.transform;
        if (saved?.rotate) utxt.dataset.rotate = saved.rotate;
        utxt.textContent = saved?.text || "Enter text";
        attachTextNodeHandlers(utxt);
        // Sync to panel when text is edited directly on the cover
        utxt.addEventListener("input", () => {
          const panelInput = document.querySelector(`#dmbCoverTextList input[data-text-id="${id}"]`);
          if (panelInput) panelInput.value = utxt.textContent;
        });
        overlay.appendChild(utxt);  // overlay spans full cover — seamless drag
      });
    }
    // Logo watermark — appended to overlay last so it always renders above stickers/maps/texts
    if (window.DMB_LOGO_URL) {
      const logoImg = document.createElement("img");
      logoImg.className = "dmb-logo-watermark";
      logoImg.src = window.DMB_LOGO_URL;
      const _logoLeft = COVER_BACK_W - Math.round(COVER_BACK_W * 0.06) - 90;
      const _logoZ = Math.max(
        ...(editor.coverObjects || []).map(function(o) { return Number(o.z) || 0; }),
        ...(editor.coverUserTexts || []).map(function(u) { var s = coverState.textStyles && coverState.textStyles[u.id]; return s ? (Number(s.z) || 0) : 0; }),
        99999
      ) + 1;
      logoImg.style.cssText = "position:absolute;bottom:6%;left:" + _logoLeft + "px;width:90px;opacity:0.85;pointer-events:none;display:block;z-index:" + _logoZ + ";";
      overlay.appendChild(logoImg);
    }

    if (typeof renderCoverTextList === "function") renderCoverTextList();

    if (typeof markActiveCoverZone === "function") {
      markActiveCoverZone();
    }

    // ── Fix 2: Capture boxWidth/boxHeight for all cover text nodes ──────────
    // After template text nodes are rendered into the DOM, measure their actual
    // offsetWidth/Height and save into coverState.textStyles. This ensures the
    // PDF rotation anchor is pixel-accurate even for templates that don't store
    // boxWidth/boxHeight in their JSON (all existing templates).
    requestAnimationFrame(() => {
      if (!coverState.textStyles) return;
      overlay.querySelectorAll(".dmb-editable-text").forEach(node => {
        if (!node.id || !coverState.textStyles[node.id]) return;
        const s = coverState.textStyles[node.id];
        if (!s.boxWidth || parseFloat(s.boxWidth) === 0) {
          s.boxWidth  = String(node.offsetWidth  || 0);
          s.boxHeight = String(node.offsetHeight || 0);
        }
      });
    });

    spreadIndexEl.textContent = "Cover";
  }

  updatePrice();
  refreshPhotoRule();
  _syncSpreadAdderUI(); // sync counter display on load
  initCoverDesigner();

  wireTextToolbar();
  ensureFrameToolbar();
  initCoverZoneButtons();

  if (builderStep) {
    initUnifiedTabs();
    builderMode = "cover";
    syncBuilderModeButtons();
    renderCoverCanvas();
    renderThumbsRail();

    if (bookMeta) {
      const selectedPages = Number(pagesEl?.value || 0);
      if (selectedPages > 0) {
        bookMeta.textContent = `${selectedPages} pages (${Math.max(0, selectedPages - 1)} to design) • ${editor.photos.length} photos`;
      } else {
        bookMeta.textContent = "Start by choosing pages, photos, and customizing your cover.";
      }
    }
  }

  if (templateParam && restoreParam !== "1") {
    // Load the user's saved template state — skip if ?restore=1 is handling it.
    loadTemplateByKey(templateParam);
  }

  // ---------- editor core ----------
  function getUsedPhotoIds() {
    const used = new Set();

    for (let p = 1; p <= editor.totalPages; p++) {
      const tid = getPageTemplateId(p);

      if (tid) {
        const fm = editor.pageFrames?.[p] || {};
        Object.values(fm).forEach((id) => { if (id) used.add(id); });
      } else {
        const A = editor.pageSlots[p]?.A;
        const B = editor.pageSlots[p]?.B;
        if (A) used.add(A);
        if (B) used.add(B);
      }
    }

    // Also include full-spread photos
    if (editor.spreadPhoto) {
      Object.values(editor.spreadPhoto).forEach((sp) => { if (sp?.photoId) used.add(sp.photoId); });
    }

    // Include photos placed in free photo frames (editor.pageObjects)
    if (editor.pageObjects) {
      Object.values(editor.pageObjects).forEach((objs) => {
        if (!Array.isArray(objs)) return;
        objs.forEach((o) => { if (o.type === "photo-frame" && o.photoId) used.add(o.photoId); });
      });
    }
    // Include free frames on cover
    if (Array.isArray(editor.coverObjects)) {
      editor.coverObjects.forEach((o) => { if (o.type === "photo-frame" && o.photoId) used.add(o.photoId); });
    }

    // Include page 0 (special page)
    const tid0 = getPageTemplateId(0);
    if (tid0) {
      const fm0 = editor.pageFrames?.[0] || {};
      Object.values(fm0).forEach((id) => { if (id) used.add(id); });
    } else {
      const A0 = editor.pageSlots[0]?.A;
      const B0 = editor.pageSlots[0]?.B;
      if (A0) used.add(A0);
      if (B0) used.add(B0);
    }

    return used;
  }

  function getPhotoById(id) {
    return editor.photos.find((p) => p.id === id) || null;
  }

  function applyRotationAndCover(imgEl, boxEl, deg) {
    imgEl.style.objectFit = "cover";
    imgEl.style.objectPosition = "center";
    imgEl.style.transformOrigin = "center";

    if (deg % 180 !== 0) {
      const w = boxEl.clientWidth || 1;
      const h = boxEl.clientHeight || 1;
      const s = Math.max(w / h, h / w);
      imgEl.style.transform = `rotate(${deg}deg) scale(${s})`;
    } else {
      imgEl.style.transform = `rotate(${deg}deg)`;
    }
  }

  async function getImageMetaFromFile(file) {
    const url = URL.createObjectURL(file);
    try {
      const img = new Image();
      img.decoding = "async";
      img.src = url;
      await img.decode();
      const w = img.naturalWidth || 1;
      const h = img.naturalHeight || 1;
      return { w, h, ratio: w / h };
    } catch {
      return { w: 1, h: 1, ratio: 1 };
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  function renderPhotoTray() {
    if (!editorPhotoTray) return;

    const used = getUsedPhotoIds();
    const photos = applyPhotoFilters(editor.photos);

    editorPhotoTray.innerHTML = "";

    photos.forEach((ph) => {
      const isUsed = used.has(ph.id);

      const t = document.createElement("div");
      t.className = "dmb-photo-thumb";
      t.draggable = true;

      t.addEventListener("dragstart", (e) => {
        setDragPayload(e, { type: "photo", photoId: ph.id });
      });

      const img = document.createElement("img");
      img.src = ph.url;
      img.alt = "photo";
      img.draggable = false;
      t.appendChild(img);

      if (isUsed) {
        const badge = document.createElement("div");
        badge.className = "dmb-photo-used";
        badge.textContent = "USED";
        t.appendChild(badge);
      }

      const menuWrap = document.createElement("div");
      menuWrap.className = "dmb-photo-hover-menu";

      const menuBtn = document.createElement("button");
      menuBtn.type = "button";
      menuBtn.className = "dmb-photo-hover-menu-btn";
      menuBtn.textContent = "⋯";
      menuWrap.appendChild(menuBtn);

      menuBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const choice = window.prompt("Type one: remove / rotate / duplicate / tag / download", "remove");
        if (!choice) return;

        const v = choice.trim().toLowerCase();

        if (v === "remove") {
          const ok = window.confirm("Remove this uploaded photo?");
          if (!ok) return;
          const idx = editor.photos.findIndex((x) => x.id === ph.id);
          if (idx >= 0) {
            bookFiles.splice(idx, 1);
            editor.photos.splice(idx, 1);
            renderPhotoTray();
            renderThumbsRail();
            renderBuilderCanvas();
          }
        } else if (v === "rotate") {
          openCropModal(ph.id);
        } else if (v === "duplicate") {
          if (ph.file) {
            const clone = new File([ph.file], ph.file.name, { type: ph.file.type });
            bookFiles.push(clone);
            refreshBuilderPhotos();
          }
        } else if (v === "tag") {
          const tag = window.prompt("Enter tag");
          if (!tag) return;
          ph.tags = ph.tags || [];
          ph.tags.push(tag.toLowerCase());
          renderPhotoTray();
        } else if (v === "download") {
          const a = document.createElement("a");
          a.href = ph.url;
          a.download = ph.file?.name || "photo";
          a.click();
        }
      });

      t.appendChild(menuWrap);
      editorPhotoTray.appendChild(t);
    });
  }


  function renderThumbsRail() {
    if (!thumbsRail) return;

    thumbsRail.innerHTML = "";

    // Page 0 thumb (special page — always first)
    {
      const card0 = document.createElement("button");
      card0.type = "button";
      card0.className = "dmb-page-thumb";
      card0.style.textAlign = "left";

      const label0 = document.createElement("div");
      label0.textContent = "Special Page";
      label0.style.fontWeight = "900";
      label0.style.fontSize = "12px";
      label0.style.marginBottom = "6px";
      card0.appendChild(label0);

      const mini0 = document.createElement("div");
      mini0.style.width = "100%";
      mini0.style.aspectRatio = "1 / 1.414";
      mini0.style.borderRadius = "10px";
      mini0.style.border = "1px solid #eee";
      mini0.style.overflow = "hidden";
      mini0.style.position = "relative";
      mini0.style.background = "#fafafa";

      const thumbTemplateId0 = getPageTemplateId(0);
      if (thumbTemplateId0) {
        const tag0 = document.createElement("div");
        tag0.textContent = TEMPLATE_NAMES[thumbTemplateId0] || thumbTemplateId0.toUpperCase();
        tag0.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:900;color:#555;";
        mini0.appendChild(tag0);
        (TEMPLATE_DEFS[thumbTemplateId0] || []).forEach((f) => {
          const r = document.createElement("div");
          r.style.position = "absolute";
          r.style.left = f.x + "%";
          r.style.top = f.y + "%";
          r.style.width = f.w + "%";
          r.style.height = f.h + "%";
          r.style.border = "1px solid #ddd";
          r.style.boxSizing = "border-box";
          mini0.appendChild(r);
        });
        const pf0 = editor.pageFrames?.[0] || {};
        Object.entries(pf0).forEach(([slotKey, photoId]) => {
          if (!photoId) return;
          const frameDef = (TEMPLATE_DEFS[thumbTemplateId0] || []).find((x) => x.key === slotKey);
          const ph = getPhotoById(photoId);
          if (!frameDef || !ph) return;
          const img = document.createElement("img");
          img.src = ph.url;
          img.style.cssText = `position:absolute;left:${frameDef.x}%;top:${frameDef.y}%;width:${frameDef.w}%;height:${frameDef.h}%;object-fit:cover;`;
          mini0.appendChild(img);
        });
      } else {
        const A0 = editor.pageSlots[0]?.A;
        const B0 = editor.pageSlots[0]?.B;
        if (A0 && !B0) {
          const ph = getPhotoById(A0);
          const img = document.createElement("img");
          img.src = ph ? ph.url : "";
          img.style.cssText = "width:100%;height:100%;object-fit:cover;";
          mini0.appendChild(img);
        } else if (A0 && B0) {
          const phA = getPhotoById(A0);
          const phB = getPhotoById(B0);
          const top = document.createElement("div");
          top.style.cssText = "position:absolute;left:0;right:0;top:0;height:50%;";
          const imgA = document.createElement("img");
          imgA.src = phA ? phA.url : "";
          imgA.style.cssText = "width:100%;height:100%;object-fit:cover;";
          top.appendChild(imgA);
          const bot = document.createElement("div");
          bot.style.cssText = "position:absolute;left:0;right:0;bottom:0;height:50%;";
          const imgB = document.createElement("img");
          imgB.src = phB ? phB.url : "";
          imgB.style.cssText = "width:100%;height:100%;object-fit:cover;";
          bot.appendChild(imgB);
          mini0.appendChild(top);
          mini0.appendChild(bot);
        } else {
          const _freeObjs0 = Array.isArray(editor.pageObjects?.[0]) ? editor.pageObjects[0] : [];
          const _frames0 = _freeObjs0.filter(o => o.type === "photo-frame" && o.photoId);
          const PW0 = 270, PH0 = 270 * 1.414;
          if (_frames0.length > 0) {
            _frames0.forEach(o => {
              const _fph = getPhotoById(o.photoId);
              if (!_fph) return;
              const _fi = document.createElement("img");
              _fi.src = _fph.url;
              _fi.style.cssText = `position:absolute;left:${(o.x/PW0*100).toFixed(1)}%;top:${(o.y/PH0*100).toFixed(1)}%;width:${(o.w/PW0*100).toFixed(1)}%;height:${(o.h/PH0*100).toFixed(1)}%;object-fit:cover;border-radius:2px;`;
              mini0.appendChild(_fi);
            });
          } else if (_freeObjs0.length > 0) {
            const _ind0 = document.createElement("div");
            _ind0.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;";
            _ind0.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#bbb" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5" fill="#bbb"/><polyline points="21 15 16 10 5 21" stroke="#bbb"/></svg><span style="font-size:10px;font-weight:900;color:#bbb;">Has frames</span>`;
            mini0.appendChild(_ind0);
          } else {
            const empty0 = document.createElement("div");
            empty0.textContent = "Empty";
            empty0.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:900;color:#aaa;";
            mini0.appendChild(empty0);
          }
        }
      }

      card0.appendChild(mini0);
      card0.addEventListener("click", () => {
        builderMode = "pages";
        editor.currentSpread = -1;
        renderBuilderCanvas();
        if (spreadViewport) {
          spreadViewport.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
      thumbsRail.appendChild(card0);
    }

    for (let p = 1; p <= editor.totalPages; p++) {
      const card = document.createElement("button");
      card.type = "button";
      card.className = "dmb-page-thumb";
      card.style.textAlign = "left";

      const label = document.createElement("div");
      label.textContent = isLockedPage(p) ? `Page ${p} • SPECIAL` : `Page ${p}`;
      label.style.fontWeight = "900";
      label.style.fontSize = "12px";
      label.style.marginBottom = "6px";
      card.appendChild(label);

      const mini = document.createElement("div");
      mini.style.width = "100%";
      mini.style.aspectRatio = "1 / 1.414";
      mini.style.borderRadius = "10px";
      mini.style.border = "1px solid #eee";
      mini.style.overflow = "hidden";
      mini.style.position = "relative";
      mini.style.background = "#fafafa";

      if (isLockedPage(p)) {
        const sp = document.createElement("div");
        sp.textContent = "SPECIAL";
        sp.style.position = "absolute";
        sp.style.inset = "0";
        sp.style.display = "flex";
        sp.style.alignItems = "center";
        sp.style.justifyContent = "center";
        sp.style.fontSize = "11px";
        sp.style.fontWeight = "900";
        sp.style.color = "#777";
        mini.appendChild(sp);
      } else {
        const thumbTemplateId = getPageTemplateId(p);

        if (thumbTemplateId) {
          const tag = document.createElement("div");
          tag.textContent = TEMPLATE_NAMES[thumbTemplateId] || thumbTemplateId.toUpperCase();
          tag.style.position = "absolute";
          tag.style.inset = "0";
          tag.style.display = "flex";
          tag.style.alignItems = "center";
          tag.style.justifyContent = "center";
          tag.style.fontSize = "10px";
          tag.style.fontWeight = "900";
          tag.style.color = "#555";
          mini.appendChild(tag);

          (TEMPLATE_DEFS[thumbTemplateId] || []).forEach((f) => {
            const r = document.createElement("div");
            r.style.position = "absolute";
            r.style.left = f.x + "%";
            r.style.top = f.y + "%";
            r.style.width = f.w + "%";
            r.style.height = f.h + "%";
            r.style.border = "1px solid #ddd";
            r.style.boxSizing = "border-box";
            mini.appendChild(r);
          });

          const pageFrames = editor.pageFrames?.[p] || {};
          Object.entries(pageFrames).forEach(([slotKey, photoId]) => {
            if (!photoId) return;
            const frameDef = (TEMPLATE_DEFS[thumbTemplateId] || []).find((x) => x.key === slotKey);
            const ph = getPhotoById(photoId);
            if (!frameDef || !ph) return;

            const img = document.createElement("img");
            img.src = ph.url;
            img.style.position = "absolute";
            img.style.left = frameDef.x + "%";
            img.style.top = frameDef.y + "%";
            img.style.width = frameDef.w + "%";
            img.style.height = frameDef.h + "%";
            img.style.objectFit = "cover";
            mini.appendChild(img);
          });
        } else {
          // Check for full-spread photo first
          const thumbSi = Math.floor((p - 1) / 2);
          const thumbSp = editor.spreadPhoto?.[thumbSi];
          if (thumbSp?.photoId) {
            const ph = getPhotoById(thumbSp.photoId);
            if (ph) {
              const img = document.createElement("img");
              img.src = ph.url;
              img.style.width = "100%";
              img.style.height = "100%";
              img.style.objectFit = "cover";
              mini.appendChild(img);
            }
          }

          const A = editor.pageSlots[p]?.A;
          const B = editor.pageSlots[p]?.B;

          if (!thumbSp?.photoId && A && !B) {
            const ph = getPhotoById(A);
            const img = document.createElement("img");
            img.src = ph ? ph.url : "";
            img.style.width = "100%";
            img.style.height = "100%";
            img.style.objectFit = "cover";
            mini.appendChild(img);
          } else if (!thumbSp?.photoId && A && B) {
            const phA = getPhotoById(A);
            const phB = getPhotoById(B);

            const top = document.createElement("div");
            top.style.position = "absolute";
            top.style.left = "0";
            top.style.right = "0";
            top.style.top = "0";
            top.style.height = "50%";

            const imgA = document.createElement("img");
            imgA.src = phA ? phA.url : "";
            imgA.style.width = "100%";
            imgA.style.height = "100%";
            imgA.style.objectFit = "cover";
            top.appendChild(imgA);

            const bot = document.createElement("div");
            bot.style.position = "absolute";
            bot.style.left = "0";
            bot.style.right = "0";
            bot.style.bottom = "0";
            bot.style.height = "50%";

            const imgB = document.createElement("img");
            imgB.src = phB ? phB.url : "";
            imgB.style.width = "100%";
            imgB.style.height = "100%";
            imgB.style.objectFit = "cover";
            bot.appendChild(imgB);

            const divider = document.createElement("div");
            divider.style.position = "absolute";
            divider.style.left = "0";
            divider.style.right = "0";
            divider.style.top = "50%";
            divider.style.height = "1px";
            divider.style.background = "rgba(0,0,0,0.12)";

            mini.appendChild(top);
            mini.appendChild(bot);
            mini.appendChild(divider);
          } else if (!thumbSp?.photoId) {
            // Check for free objects (frames with photos, text, stickers, maps)
            const _freeObjs = Array.isArray(editor.pageObjects?.[p]) ? editor.pageObjects[p] : [];
            const _framesWithPhoto = _freeObjs.filter(o => o.type === "photo-frame" && o.photoId);
            const PAGE_W_THUMB = 270, PAGE_H_THUMB = 270 * 1.414;

            if (_framesWithPhoto.length > 0) {
              // Render free frame photos at scaled positions
              _framesWithPhoto.forEach(o => {
                const _fph = getPhotoById(o.photoId);
                if (!_fph) return;
                const _fi = document.createElement("img");
                _fi.src = _fph.url;
                _fi.style.cssText = `position:absolute;left:${(o.x/PAGE_W_THUMB*100).toFixed(1)}%;top:${(o.y/PAGE_H_THUMB*100).toFixed(1)}%;width:${(o.w/PAGE_W_THUMB*100).toFixed(1)}%;height:${(o.h/PAGE_H_THUMB*100).toFixed(1)}%;object-fit:cover;border-radius:2px;`;
                mini.appendChild(_fi);
              });
            } else if (_freeObjs.length > 0) {
              // Has frames/text/stickers but no photos yet — show indicator
              const _ind = document.createElement("div");
              _ind.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;";
              _ind.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#bbb" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5" fill="#bbb"/><polyline points="21 15 16 10 5 21" stroke="#bbb"/></svg><span style="font-size:10px;font-weight:900;color:#bbb;">Has frames</span>`;
              mini.appendChild(_ind);
            } else {
              const empty = document.createElement("div");
              empty.textContent = "Empty";
              empty.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:900;color:#aaa;";
              mini.appendChild(empty);
            }
          }
        }
      }

      card.appendChild(mini);

      card.addEventListener("click", () => {
        builderMode = "pages";
        editor.currentSpread = Math.floor((p - 1) / 2);
        renderBuilderCanvas();
        if (spreadViewport) {
          spreadViewport.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });

      thumbsRail.appendChild(card);
    }
  }
  function updateCoverZoneButtons() {
    const frontBtn = $("coverZoneFrontBtn");
    const backBtn = $("coverZoneBackBtn");
    const spineBtn = $("coverZoneSpineBtn");

    [frontBtn, backBtn, spineBtn].forEach((btn) => {
      if (btn) btn.classList.remove("active");
    });

    if (activeCoverZone === "front" && frontBtn) frontBtn.classList.add("active");
    if (activeCoverZone === "back" && backBtn) backBtn.classList.add("active");
    if (activeCoverZone === "spine" && spineBtn) spineBtn.classList.add("active");
  }
  function makeHint(text) {
    const hint = document.createElement("div");
    hint.textContent = text;
    hint.style.position = "absolute";
    hint.style.inset = "14px";
    hint.style.border = "2px dashed #ddd";
    hint.style.borderRadius = "12px";
    hint.style.display = "flex";
    hint.style.alignItems = "center";
    hint.style.justifyContent = "center";
    hint.style.color = "#888";
    hint.style.fontWeight = "900";
    hint.style.fontSize = "12px";
    hint.style.pointerEvents = "none";
    return hint;
  }

  function handleDropOnPage(pageNumber, clientY, payload, dataTransfer, bodyEl, clientX) {
    if (isLockedPage(pageNumber)) return;

    if (isTemplatePage(pageNumber)) {
      const photoId = (() => {
        if (payload && payload.photoId) return payload.photoId;

        const tp = dataTransfer ? (dataTransfer.getData("text/plain") || "").trim() : "";
        if (!tp) return "";

        if (tp[0] === "{") {
          try {
            const obj = JSON.parse(tp);
            return obj.photoId || "";
          } catch {
            return "";
          }
        }
        return tp;
      })();

      if (!photoId) return;

      const targetRect = pickNearestTemplateFrame(bodyEl, pageNumber, clientX ?? 0, clientY ?? 0);
      if (!targetRect) return;

      const slotKey = targetRect.key;
      const currentInTarget = getFramePhotoId(pageNumber, slotKey);

      const used = getUsedPhotoIds();
      const isReusedPhoto = payload?.type === "photo" && used.has(photoId);
      if (isReusedPhoto) showReuseNotice();

      pushUndoState();

      if (payload && payload.type === "placed") {
        const fromPage = Number(payload.fromPage);
        const fromSlot = payload.fromSlot;

        if (fromPage && fromSlot) {
          if (fromPage === pageNumber && fromSlot === slotKey) return;

          const replaced = currentInTarget;
          const replacedRot = getFrameRotation(pageNumber, slotKey);

          setFramePhotoId(pageNumber, slotKey, photoId);
          setFrameRotation(pageNumber, slotKey, 0);

          if (replaced) {
            setFramePhotoId(fromPage, fromSlot, replaced);
            setFrameRotation(fromPage, fromSlot, replacedRot);
          } else {
            clearFrame(fromPage, fromSlot);

            if (!isTemplatePage(fromPage)) {
              if (fromSlot === "A" && editor.pageSlots[fromPage]?.B) {
                editor.pageSlots[fromPage].A = editor.pageSlots[fromPage].B;
                editor.pageSlots[fromPage].B = null;
                editor.pageRot[fromPage].A = editor.pageRot[fromPage].B;
                editor.pageRot[fromPage].B = 0;
              }
            }
          }

          renderSpread();
          renderThumbsRail();
          renderPhotoTray();
          return;
        }
      }

      setFramePhotoId(pageNumber, slotKey, photoId);
      setFrameRotation(pageNumber, slotKey, 0);

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
      return;
    }

    const photoId = (() => {
      if (payload && payload.photoId) return payload.photoId;

      const tp = dataTransfer ? (dataTransfer.getData("text/plain") || "").trim() : "";
      if (!tp) return "";

      if (tp[0] === "{") {
        try {
          const obj = JSON.parse(tp);
          return obj.photoId || "";
        } catch {
          return "";
        }
      }
      return tp;
    })();

    if (!photoId) return;

    const targetA = editor.pageSlots[pageNumber]?.A || null;
    const targetB = editor.pageSlots[pageNumber]?.B || null;
    const targetRotA = editor.pageRot?.[pageNumber]?.A || 0;
    const targetRotB = editor.pageRot?.[pageNumber]?.B || 0;

    const used = getUsedPhotoIds();
    const isReusedPhoto = payload?.type === "photo" && used.has(photoId);
    if (isReusedPhoto) showReuseNotice();

    const rect = bodyEl.getBoundingClientRect();
    const y = (typeof clientY === "number" ? clientY : rect.top) - rect.top;
    const mid = rect.height / 2;
    const droppedOnTop = y < mid;

    pushUndoState();

    if (payload && payload.type === "placed") {
      const fromPage = Number(payload.fromPage);
      const fromSlot = payload.fromSlot;

      if (fromPage && fromSlot && editor.pageSlots[fromPage]) {
        if (
          !(
            (fromPage === pageNumber && fromSlot === "A" && targetA === photoId && !targetB) ||
            (fromPage === pageNumber && fromSlot === "B" && targetB === photoId)
          )
        ) {
          editor.pageSlots[fromPage][fromSlot] = null;
          editor.pageRot[fromPage][fromSlot] = 0;

          if (!editor.pageSlots[fromPage].A && editor.pageSlots[fromPage].B) {
            editor.pageSlots[fromPage].A = editor.pageSlots[fromPage].B;
            editor.pageSlots[fromPage].B = null;
            editor.pageRot[fromPage].A = editor.pageRot[fromPage].B;
            editor.pageRot[fromPage].B = 0;
          }
        }
      }
    }

    if (!targetA && !targetB) {
      editor.pageSlots[pageNumber].A = photoId;
      editor.pageSlots[pageNumber].B = null;
      editor.pageRot[pageNumber].A = 0;
      editor.pageRot[pageNumber].B = 0;

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
      return;
    }

    if (targetA && !targetB) {
      const old = targetA;
      const oldRot = targetRotA;

      if (droppedOnTop) {
        editor.pageSlots[pageNumber].A = photoId;
        editor.pageSlots[pageNumber].B = old;
        editor.pageRot[pageNumber].A = 0;
        editor.pageRot[pageNumber].B = oldRot;
      } else {
        editor.pageSlots[pageNumber].A = old;
        editor.pageSlots[pageNumber].B = photoId;
        editor.pageRot[pageNumber].A = oldRot;
        editor.pageRot[pageNumber].B = 0;
      }

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
      return;
    }

    if (targetA && targetB) {
      const replaceSlot = droppedOnTop ? "A" : "B";
      const replaced = editor.pageSlots[pageNumber][replaceSlot];
      const replacedRot = editor.pageRot[pageNumber][replaceSlot] || 0;

      editor.pageSlots[pageNumber][replaceSlot] = photoId;
      editor.pageRot[pageNumber][replaceSlot] = 0;

      if (payload && payload.type === "placed") {
        const fromPage = Number(payload.fromPage);
        const fromSlot = payload.fromSlot;

        if (replaced && fromPage && fromSlot && editor.pageSlots[fromPage]) {
          editor.pageSlots[fromPage][fromSlot] = replaced;
          editor.pageRot[fromPage][fromSlot] = replacedRot;

          if (!editor.pageSlots[fromPage].A && editor.pageSlots[fromPage].B) {
            editor.pageSlots[fromPage].A = editor.pageSlots[fromPage].B;
            editor.pageSlots[fromPage].B = null;
            editor.pageRot[fromPage].A = editor.pageRot[fromPage].B;
            editor.pageRot[fromPage].B = 0;
          }
        }
      }

      renderSpread();
      renderThumbsRail();
      renderPhotoTray();
    }
  }

  // ---------- Crop Modal ----------
  let DMB_CROP = {
    open: false,
    photoId: null,
    img: null,
    canvas: null,
    ctx: null,
    rect: null,
    dragMode: null,
    start: null,
    imgDraw: null
  };

  function ensureCropModal() {
    if (document.getElementById("dmbCropOverlay")) return;

    const overlay = document.createElement("div");
    overlay.id = "dmbCropOverlay";
    overlay.style.position = "absolute";
    overlay.style.inset = "0";
    overlay.style.background = "rgba(0,0,0,0.65)";
    overlay.style.display = "none";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.zIndex = "9999";

    const panel = document.createElement("div");
    panel.style.width = "min(92vw, 900px)";
    panel.style.maxHeight = "90vh";
    panel.style.background = "#fff";
    panel.style.borderRadius = "16px";
    panel.style.overflow = "hidden";
    panel.style.boxShadow = "0 20px 60px rgba(0,0,0,0.35)";
    panel.style.display = "flex";
    panel.style.flexDirection = "column";

    const head = document.createElement("div");
    head.style.display = "flex";
    head.style.alignItems = "center";
    head.style.justifyContent = "space-between";
    head.style.padding = "12px 14px";
    head.style.borderBottom = "1px solid #eee";

    const title = document.createElement("div");
    title.textContent = "Crop photo";
    title.style.fontWeight = "900";
    title.style.fontSize = "14px";

    const hint = document.createElement("div");
    hint.textContent = "Drag to draw a crop box. Drag inside the box to move it.";
    hint.style.fontSize = "12px";
    hint.style.color = "#666";
    hint.style.fontWeight = "700";
    hint.style.marginLeft = "10px";

    const left = document.createElement("div");
    left.style.display = "flex";
    left.style.alignItems = "center";
    left.appendChild(title);
    left.appendChild(hint);

    const actions = document.createElement("div");
    actions.style.display = "flex";
    actions.style.gap = "10px";

    const mkBtn = (txt) => {
      const b = document.createElement("button");
      b.type = "button";
      b.textContent = txt;
      b.style.border = "1px solid #111";
      b.style.borderRadius = "999px";
      b.style.padding = "8px 12px";
      b.style.fontWeight = "900";
      b.style.cursor = "pointer";
      b.style.background = "#fff";
      return b;
    };

    const cancelBtn = mkBtn("Cancel");
    const resetBtn = mkBtn("Reset");
    const doneBtn = mkBtn("Done");
    doneBtn.style.background = "#111";
    doneBtn.style.color = "#fff";

    actions.appendChild(cancelBtn);
    actions.appendChild(resetBtn);
    actions.appendChild(doneBtn);

    head.appendChild(left);
    head.appendChild(actions);

    const body = document.createElement("div");
    body.style.padding = "12px";
    body.style.background = "#fafafa";
    body.style.display = "flex";
    body.style.justifyContent = "center";
    body.style.alignItems = "center";

    const canvas = document.createElement("canvas");
    canvas.id = "dmbCropCanvas";
    canvas.style.background = "#000";
    canvas.style.borderRadius = "12px";
    canvas.style.maxWidth = "100%";
    canvas.style.maxHeight = "70vh";
    canvas.style.touchAction = "none";

    body.appendChild(canvas);

    panel.appendChild(head);
    panel.appendChild(body);
    overlay.appendChild(panel);

    const root = document.getElementById("dmb-root");
    if (root) {
      const cs = getComputedStyle(root);
      if (cs.position === "static") root.style.position = "relative";
      root.appendChild(overlay);
    } else {
      document.body.appendChild(overlay);
    }

    cancelBtn.addEventListener("click", closeCropModal);
    resetBtn.addEventListener("click", () => {
      DMB_CROP.rect = null;
      drawCropCanvas();
    });
    doneBtn.addEventListener("click", applyCrop);

    const onDown = (e) => {
      if (!DMB_CROP.open) return;
      const { x, y } = canvasPoint(e);
      const r = DMB_CROP.rect;

      if (r && x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h) {
        DMB_CROP.dragMode = "move";
        DMB_CROP.start = { x, y, rx: r.x, ry: r.y };
      } else {
        DMB_CROP.dragMode = "new";
        DMB_CROP.start = { x, y };
        DMB_CROP.rect = { x, y, w: 0, h: 0 };
      }
      e.preventDefault();
    };

    const onMove = (e) => {
      if (!DMB_CROP.open || !DMB_CROP.dragMode) return;
      const { x, y } = canvasPoint(e);
      const r = DMB_CROP.rect;

      if (DMB_CROP.dragMode === "new" && DMB_CROP.start && r) {
        r.x = Math.min(DMB_CROP.start.x, x);
        r.y = Math.min(DMB_CROP.start.y, y);
        r.w = Math.abs(x - DMB_CROP.start.x);
        r.h = Math.abs(y - DMB_CROP.start.y);
      }

      if (DMB_CROP.dragMode === "move" && DMB_CROP.start && r) {
        const dx = x - DMB_CROP.start.x;
        const dy = y - DMB_CROP.start.y;
        r.x = DMB_CROP.start.rx + dx;
        r.y = DMB_CROP.start.ry + dy;
      }

      clampCropRect();
      drawCropCanvas();
      e.preventDefault();
    };

    const onUp = () => {
      if (!DMB_CROP.open) return;
      DMB_CROP.dragMode = null;
      DMB_CROP.start = null;
    };

    canvas.addEventListener("pointerdown", onDown);
    canvas.addEventListener("pointermove", onMove);
    canvas.addEventListener("pointerup", onUp);
    canvas.addEventListener("pointercancel", onUp);

    DMB_CROP.canvas = canvas;
    DMB_CROP.ctx = canvas.getContext("2d");
  }

  function openCropModal(photoId) {
    ensureCropModal();

    const ph = getPhotoById(photoId);
    if (!ph) return;

    const overlay = document.getElementById("dmbCropOverlay");
    const canvas = DMB_CROP.canvas;

    DMB_CROP.open = true;
    DMB_CROP.photoId = photoId;
    DMB_CROP.rect = null;

    const maxW = Math.min(window.innerWidth * 0.92, 900);
    const maxH = Math.min(window.innerHeight * 0.70, 700);
    canvas.width = Math.floor(maxW);
    canvas.height = Math.floor(maxH);

    const img = new Image();
    img.decoding = "async";
    img.onload = () => {
      DMB_CROP.img = img;
      computeImageDraw();
      drawCropCanvas();
    };
    img.src = ph.url;

    if (overlay) overlay.style.display = "flex";
  }

  function closeCropModal() {
    const overlay = document.getElementById("dmbCropOverlay");
    if (overlay) overlay.style.display = "none";
    DMB_CROP.open = false;
    DMB_CROP.photoId = null;
    DMB_CROP.img = null;
    DMB_CROP.rect = null;
    DMB_CROP.dragMode = null;
    DMB_CROP.start = null;
  }

  function canvasPoint(e) {
    const rect = DMB_CROP.canvas.getBoundingClientRect();
    return {
      x: (e.clientX - rect.left) * (DMB_CROP.canvas.width / rect.width),
      y: (e.clientY - rect.top) * (DMB_CROP.canvas.height / rect.height)
    };
  }

  function computeImageDraw() {
    const img = DMB_CROP.img;
    const c = DMB_CROP.canvas;
    if (!img || !c) return;

    const scale = Math.min(c.width / img.naturalWidth, c.height / img.naturalHeight);
    const dw = img.naturalWidth * scale;
    const dh = img.naturalHeight * scale;
    const ox = (c.width - dw) / 2;
    const oy = (c.height - dh) / 2;

    DMB_CROP.imgDraw = { scale, ox, oy, dw, dh };
  }

  function clampCropRect() {
    const r = DMB_CROP.rect;
    const d = DMB_CROP.imgDraw;
    if (!r || !d) return;

    const minSize = 20;

    r.w = Math.max(minSize, r.w);
    r.h = Math.max(minSize, r.h);

    const minX = d.ox;
    const minY = d.oy;
    const maxX = d.ox + d.dw;
    const maxY = d.oy + d.dh;

    if (r.x < minX) r.x = minX;
    if (r.y < minY) r.y = minY;
    if (r.x + r.w > maxX) r.x = maxX - r.w;
    if (r.y + r.h > maxY) r.y = maxY - r.h;

    r.w = Math.min(r.w, maxX - minX);
    r.h = Math.min(r.h, maxY - minY);
  }

  function drawCropCanvas() {
    const ctx = DMB_CROP.ctx;
    const c = DMB_CROP.canvas;
    const img = DMB_CROP.img;
    const d = DMB_CROP.imgDraw;
    if (!ctx || !c) return;

    ctx.clearRect(0, 0, c.width, c.height);
    ctx.fillStyle = "#000";
    ctx.fillRect(0, 0, c.width, c.height);

    if (!img || !d) return;

    ctx.drawImage(img, d.ox, d.oy, d.dw, d.dh);

    ctx.fillStyle = "rgba(0,0,0,0.45)";
    ctx.fillRect(0, 0, c.width, c.height);

    const r = DMB_CROP.rect;
    if (r) {
      clampCropRect();

      ctx.save();
      ctx.globalCompositeOperation = "destination-out";
      ctx.fillRect(r.x, r.y, r.w, r.h);
      ctx.restore();

      ctx.strokeStyle = "#fff";
      ctx.lineWidth = 2;
      ctx.strokeRect(r.x, r.y, r.w, r.h);
    }
  }

  async function applyCrop() {
    const img = DMB_CROP.img;
    const d = DMB_CROP.imgDraw;
    const r = DMB_CROP.rect;
    const photoId = DMB_CROP.photoId;

    if (!img || !d || !r || !photoId) return;

    const sx = Math.max(0, Math.round((r.x - d.ox) / d.scale));
    const sy = Math.max(0, Math.round((r.y - d.oy) / d.scale));
    const sw = Math.max(1, Math.round(r.w / d.scale));
    const sh = Math.max(1, Math.round(r.h / d.scale));

    const out = document.createElement("canvas");
    out.width = sw;
    out.height = sh;
    const octx = out.getContext("2d");
    octx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);

    const blob = await new Promise((res) => out.toBlob(res, "image/jpeg", 0.92));
    if (!blob) return;

    const ph = getPhotoById(photoId);
    if (!ph) return;

    try { URL.revokeObjectURL(ph.url); } catch {}
    const newUrl = URL.createObjectURL(blob);
    ph.url = newUrl;
    ph.file = new File([blob], ph.file?.name || "cropped.jpg", { type: "image/jpeg" });

    closeCropModal();
    renderSpread();
    renderThumbsRail();
    renderPhotoTray();
  }

  function makePlacedImageBox(photoId, pos, pageNumber, slot, isPreview = false, noButtons = false) {
    const ph = getPhotoById(photoId);

    const box = document.createElement("div");
    box.style.position = "absolute";
    box.style.left = "0";
    box.style.right = "0";
    if (pos.top != null) box.style.top = pos.top + "px";
    if (pos.bottom != null) box.style.bottom = pos.bottom + "px";
    if (pos.height != null) box.style.height = pos.height;
    box.style.zIndex = "1";
    box.style.overflow = "hidden";
    box.style.background = "#fff";
    box.style.cursor = "grab";
    box.draggable = true;

    box.addEventListener("dragover", (e) => {
      e.preventDefault();
      const payload = getDragPayload(e);
      e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
    });

    box.addEventListener("drop", (e) => {
      e.preventDefault();
      const parent = box.parentElement;
      if (!parent) return;
      const payload = getDragPayload(e);
      // Find nearest ancestor with a frameKey (works even when placed inside fwClip)
      const frameEl = parent.closest ? parent.closest("[data-frame-key]") : null;
      if (frameEl && frameEl.dataset.frameKey) {
        e.stopPropagation(); // frame handles it — don't let pagesRow see this drop
        const fKey = frameEl.dataset.frameKey;
        const fPage = Number(frameEl.dataset.framePage) || pageNumber;
        const photoId = (function() {
          if (payload && payload.photoId) return payload.photoId;
          const tp = e.dataTransfer ? (e.dataTransfer.getData("text/plain") || "").trim() : "";
          if (!tp) return "";
          if (tp[0] === "{") { try { return JSON.parse(tp).photoId || ""; } catch(ex) { return ""; } }
          return tp;
        })();
        if (!photoId) return;
        const used = getUsedPhotoIds();
        if (payload && payload.type === "photo" && used.has(photoId)) showReuseNotice();
        pushUndoState("Replace Photo In Frame");
        if (payload && payload.type === "placed") {
          const fromPage = Number(payload.fromPage);
          const fromSlot = payload.fromSlot;
          if (fromPage && fromSlot) {
            const currentInTarget = getFramePhotoId(fPage, fKey);
            const replacedRot = getFrameRotation(fPage, fKey);
            setFramePhotoId(fPage, fKey, photoId);
            setFrameRotation(fPage, fKey, 0);
            if (currentInTarget) {
              setFramePhotoId(fromPage, fromSlot, currentInTarget);
              setFrameRotation(fromPage, fromSlot, replacedRot);
            } else {
              clearFrame(fromPage, fromSlot);
            }
          } else {
            setFramePhotoId(fPage, fKey, photoId);
            setFrameRotation(fPage, fKey, 0);
          }
        } else {
          setFramePhotoId(fPage, fKey, photoId);
          setFrameRotation(fPage, fKey, 0);
        }
        renderSpread();
        renderThumbsRail();
        renderPhotoTray();
      }
      // non-frame drop: let event bubble to pagesRow for zone detection
    });

    box.addEventListener("dragstart", (e) => {
      setDragPayload(e, { type: "placed", photoId, fromPage: pageNumber, fromSlot: slot });
    });

    const img = document.createElement("img");
    img.src = ph ? ph.url : "";
    img.alt = "placed";
    img.style.position = "absolute";
    img.style.inset = "0";
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.pointerEvents = "none";
    box.appendChild(img);

    const deg = getFrameRotation(pageNumber, slot);
    applyRotationAndCover(img, box, deg);
    box.dataset.placedImg = "1";
    box.dataset.placedRot = String(deg);
    requestAnimationFrame(() => {
      const latestDeg = getFrameRotation(pageNumber, slot);
      applyRotationAndCover(img, box, latestDeg);
      box.dataset.placedRot = String(latestDeg);
    });

    if (!isPreview && !noButtons) {
      const rm = document.createElement("button");
      rm.type = "button";
      rm.innerHTML = `<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
      rm.setAttribute("aria-label", "Remove photo");
      rm.title = "Remove photo";
      rm.style.position = "absolute";
      rm.style.top = "8px";
      rm.style.right = "8px";
      rm.style.width = "28px";
      rm.style.height = "28px";
      rm.style.borderRadius = "999px";
      rm.style.border = "none";
      rm.style.background = "rgba(0,0,0,0.72)";
      rm.style.color = "#fff";
      rm.style.cursor = "pointer";
      rm.style.zIndex = "4";
      rm.style.display = "flex";
      rm.style.alignItems = "center";
      rm.style.justifyContent = "center";
      rm.style.padding = "0";

      rm.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        pushUndoState("Remove Photo");
        clearFrame(pageNumber, slot);

        if (!isTemplatePage(pageNumber)) {
          if (slot === "A" && editor.pageSlots[pageNumber].B) {
            editor.pageSlots[pageNumber].A = editor.pageSlots[pageNumber].B;
            editor.pageSlots[pageNumber].B = null;
            editor.pageRot[pageNumber].A = editor.pageRot[pageNumber].B;
            editor.pageRot[pageNumber].B = 0;
          }
        }

        renderBuilderCanvas();
        renderThumbsRail();
        renderPhotoTray();
      });

      box.appendChild(rm);

      const rotBtn = document.createElement("button");
      rotBtn.type = "button";
      rotBtn.setAttribute("aria-label", "Rotate 90 degrees anti-clockwise");
      rotBtn.title = "Rotate 90° anti-clockwise";
      rotBtn.innerHTML = `
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          <path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      rotBtn.style.position = "absolute";
      rotBtn.style.top = "8px";
      rotBtn.style.right = "40px";
      rotBtn.style.width = "28px";
      rotBtn.style.height = "28px";
      rotBtn.style.borderRadius = "999px";
      rotBtn.style.border = "none";
      rotBtn.style.background = "rgba(0,0,0,0.72)";
      rotBtn.style.cursor = "pointer";
      rotBtn.style.zIndex = "4";
      rotBtn.style.display = "flex";
      rotBtn.style.flexDirection = "column";
      rotBtn.style.alignItems = "center";
      rotBtn.style.justifyContent = "center";
      rotBtn.style.gap = "1px";
      rotBtn.style.padding = "0";

      rotBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        pushUndoState("Rotate Photo");
        rotateFrameCCW90(editor, pageNumber, slot);
        renderBuilderCanvas();
        renderThumbsRail();
      });

      box.appendChild(rotBtn);

      const cropBtn = document.createElement("button");
      cropBtn.type = "button";
      cropBtn.setAttribute("aria-label", "Crop photo");
      cropBtn.title = "Crop photo";
      cropBtn.innerHTML = `
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          <path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `;
      cropBtn.style.position = "absolute";
      cropBtn.style.top = "8px";
      cropBtn.style.right = "72px";
      cropBtn.style.width = "28px";
      cropBtn.style.height = "28px";
      cropBtn.style.borderRadius = "999px";
      cropBtn.style.border = "none";
      cropBtn.style.background = "rgba(0,0,0,0.72)";
      cropBtn.style.cursor = "pointer";
      cropBtn.style.zIndex = "4";
      cropBtn.style.display = "flex";
      cropBtn.style.alignItems = "center";
      cropBtn.style.justifyContent = "center";
      cropBtn.style.padding = "0";

      cropBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        openCropModal(photoId);
      });

      box.appendChild(cropBtn);

      function forwardDropToBody(e) {
        e.preventDefault();
        e.stopPropagation();
        const body = box.parentElement;
        if (!body) return;
        const payload = getDragPayload(e);
        handleDropOnPage(pageNumber, e.clientY, payload, e.dataTransfer, body, e.clientX);
      }

      rm.addEventListener("dragover", (e) => e.preventDefault());
      rm.addEventListener("drop", forwardDropToBody);

      rotBtn.addEventListener("dragover", (e) => e.preventDefault());
      rotBtn.addEventListener("drop", forwardDropToBody);

      cropBtn.addEventListener("dragover", (e) => e.preventDefault());
      cropBtn.addEventListener("drop", forwardDropToBody);

      // Frames button
      const frameShapeBtn = document.createElement("button");
      frameShapeBtn.type = "button";
      frameShapeBtn.setAttribute("aria-label", "Frame shape");
      frameShapeBtn.title = "Frame shape";
      frameShapeBtn.innerHTML = `<svg viewBox="0 0 22 22" width="14" height="14" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`;
      frameShapeBtn.style.cssText = "position:absolute;top:8px;right:104px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:4;display:flex;align-items:center;justify-content:center;padding:0;";
      frameShapeBtn.addEventListener("click", (e) => {
        e.preventDefault(); e.stopPropagation();
        const current = getSlotFrameShape(pageNumber, slot);
        showDmbFramePicker(frameShapeBtn, current, (shapeId) => {
          pushUndoState("Frame Shape");
          setSlotFrameShape(pageNumber, slot, shapeId);
          renderBuilderCanvas();
          renderThumbsRail();
        });
      });
      frameShapeBtn.addEventListener("dragover", (e) => e.preventDefault());
      frameShapeBtn.addEventListener("drop", forwardDropToBody);
      box.appendChild(frameShapeBtn);

      // Apply stored frame shape to the placed image
      const _placedImg = box.querySelector("img");
      if (_placedImg) applyDmbFrameShape(_placedImg, getSlotFrameShape(pageNumber, slot));
    }

    return box;
  }

  function makeA4Page(pageNumber, side, isPreview = false) {
    const page = document.createElement("div");
    page.style.width = "270px";
    page.style.aspectRatio = "1 / 1.414";
    page.style.border = "1px solid #e5e5e5";
    page.style.borderRadius = "0";
    page.style.background = "#fff";
    page.style.position = "relative";
    page.style.overflow = "visible";
    page.style.boxShadow = "0 6px 18px rgba(0,0,0,0.06)";

    const body = document.createElement("div");
    body.style.position = "absolute";
    body.style.inset = "0";
    // Use stored page background color if set; fall back to default page colour
    const _pageBg = editor.pageBackgrounds?.[pageNumber];
    body.style.background = _pageBg || (isPreview ? "#ffffff" : "#fcfcfc");
    body.style.zIndex = "auto";
    body.setAttribute("data-page-body", "true");
    body.dataset.pageNumber = String(pageNumber);
    page.appendChild(body);

    if (isLockedPage(pageNumber)) {
      if (!isPreview) {
        const special = document.createElement("div");
        special.style.position = "absolute";
        special.style.inset = "0";
        special.style.display = "flex";
        special.style.alignItems = "center";
        special.style.justifyContent = "center";
        special.style.textAlign = "center";
        special.style.padding = "24px";
        special.style.fontWeight = "900";
        special.style.fontSize = "13px";
        special.style.color = "#bbb";
        special.textContent = "Can't be edited";
        body.appendChild(special);
      }
      renderFreeFrameObjects(body, { targetType: "page", pageNumber: pageNumber });
      return page;
    }

    // ── Spread photo ──
    const si = Math.floor((pageNumber - 1) / 2);
    const isLeftPage = (side === "L");
    const sp = editor.spreadPhoto?.[si];
    if (sp && sp.photoId) {
      const ph = getPhotoById(sp.photoId);
      if (ph) {
        const templateIdForSpread = getPageTemplateId(pageNumber);
        const imgWrap = document.createElement("div");
        imgWrap.style.position = "absolute";
        imgWrap.style.width = "200%";
        imgWrap.style.height = "100%";
        imgWrap.style.left = isLeftPage ? "0" : "-100%";
        imgWrap.style.top = "0";
        imgWrap.style.transformOrigin = "50% 50%";
        imgWrap.setAttribute("data-spread-img-layer", "true");
        imgWrap.setAttribute("data-spread-img-side", side);
        const px = sp.panX || 0, py = sp.panY || 0, zoom = sp.zoom || 1, rot = sp.rotation || 0;
        imgWrap.style.transform = `translate(${px}px,${py}px) scale(${zoom}) rotate(${rot}deg)`;
        // Store transform values for PDF pre-rendering (avoids html2canvas transform issues)
        imgWrap.dataset.pdfPanX = String(px);
        imgWrap.dataset.pdfPanY = String(py);
        imgWrap.dataset.pdfZoom = String(zoom);
        imgWrap.dataset.pdfRotation = String(rot);
        if (templateIdForSpread || isPreview) {
          imgWrap.style.cursor = "default";
          imgWrap.style.pointerEvents = "none";
          imgWrap.style.zIndex = "0";
        } else {
          imgWrap.style.cursor = "move";
          imgWrap.style.zIndex = "1";
        }
        const img = document.createElement("img");
        img.src = ph.url;
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "cover";
        img.style.pointerEvents = "none";
        img.style.display = "block";
        img.draggable = false;
        imgWrap.appendChild(img);
        body.appendChild(imgWrap);
        if (!templateIdForSpread && !isPreview) {
          imgWrap.addEventListener("mousedown", (e) => {
            if (e.button !== 0) return;
            spreadPhotoDragState = { type: "pan", si, startX: e.clientX, startY: e.clientY, startPanX: sp.panX || 0, startPanY: sp.panY || 0 };
            e.preventDefault();
            e.stopPropagation();
          });
        }
        if (!isLeftPage && !isPreview) {
          // X button (matches regular photos style)
          const rmBtn = document.createElement("button");
          rmBtn.type = "button";
          rmBtn.innerHTML = `<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`;
          rmBtn.setAttribute("aria-label", "Remove spread photo");
          rmBtn.style.cssText = "position:absolute;top:8px;right:8px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;z-index:40;display:flex;align-items:center;justify-content:center;padding:0;";
          rmBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            pushUndoState();
            editor.spreadPhoto[si] = null;
            renderSpread(); renderThumbsRail(); renderPhotoTray();
          });
          body.appendChild(rmBtn);
          // Rotate button
          const rotBtn = document.createElement("button");
          rotBtn.type = "button";
          rotBtn.setAttribute("aria-label", "Rotate 90°");
          rotBtn.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          rotBtn.style.cssText = "position:absolute;top:8px;right:40px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:40;display:flex;align-items:center;justify-content:center;padding:0;";
          rotBtn.addEventListener("click", (e) => {
            e.preventDefault(); e.stopPropagation();
            sp.rotation = ((sp.rotation || 0) + 90) % 360;
            renderSpread(); renderThumbsRail();
          });
          body.appendChild(rotBtn);
          // Crop button
          const cropBtn = document.createElement("button");
          cropBtn.type = "button";
          cropBtn.setAttribute("aria-label", "Crop photo");
          cropBtn.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`;
          cropBtn.style.cssText = "position:absolute;top:8px;right:72px;width:28px;height:28px;border-radius:999px;border:none;background:rgba(0,0,0,0.72);cursor:pointer;z-index:40;display:flex;align-items:center;justify-content:center;padding:0;";
          cropBtn.addEventListener("click", (e) => {
            e.preventDefault(); e.stopPropagation();
            openCropModal(sp.photoId);
          });
          body.appendChild(cropBtn);
        }
        if (!templateIdForSpread) {
          renderFreeFrameObjects(body, { targetType: "page", pageNumber });
          return page;
        }
        // Has template: fall through to render template frames on top of spread photo
      }
    }

    const msg = document.createElement("div");
    msg.style.position = "absolute";
    msg.style.left = "12px";
    msg.style.right = "12px";
    msg.style.bottom = "12px";
    msg.style.padding = "10px 12px";
    msg.style.borderRadius = "12px";
    msg.style.background = "rgba(0,0,0,0.70)";
    msg.style.color = "#fff";
    msg.style.fontWeight = "900";
    msg.style.fontSize = "12px";
    msg.style.display = "none";
    msg.style.zIndex = "4";
    msg.textContent = "To add another picture to this page, drag another picture over it.";
    msg.style.pointerEvents = "none";
    if (!isPreview) body.appendChild(msg);

    const templateIdForBody = getPageTemplateId(pageNumber);
    if (templateIdForBody) {
      const defs = TEMPLATE_DEFS[templateIdForBody] || [];
      const hasAny = Object.values(editor.pageFrames?.[pageNumber] || {}).some(Boolean);

      if (!hasAny && !isPreview) body.appendChild(makeHint("Choose a frame, then drop a photo"));

      // Render slot photos as background (when layout applied "over" existing photos)
      const slotA = editor.pageSlots?.[pageNumber]?.A;
      const slotB = editor.pageSlots?.[pageNumber]?.B;
      if (slotA || slotB) {
        if (slotA && !slotB) {
          const bg = makePlacedImageBox(slotA, { top: 0, bottom: 0 }, pageNumber, "A", isPreview);
          bg.style.zIndex = "0";
          bg.style.pointerEvents = "none";
          body.appendChild(bg);
        } else if (slotA && slotB) {
          const bgA = makePlacedImageBox(slotA, { top: 0, height: "50%" }, pageNumber, "A", isPreview);
          bgA.style.zIndex = "0"; bgA.style.pointerEvents = "none";
          const bgB = makePlacedImageBox(slotB, { bottom: 0, height: "50%" }, pageNumber, "B", isPreview);
          bgB.style.zIndex = "0"; bgB.style.pointerEvents = "none";
          body.appendChild(bgA);
          body.appendChild(bgB);
        }
      }

      defs.forEach((f) => {
        const frameWrap = document.createElement("div");
        frameWrap.style.position = "absolute";
        frameWrap.style.left = f.x + "%";
        frameWrap.style.top = f.y + "%";
        frameWrap.style.width = f.w + "%";
        frameWrap.style.height = f.h + "%";
        frameWrap.style.border = "1px solid #eee";
        frameWrap.style.background = "#fff";
        frameWrap.style.overflow = "visible";  // buttons escape; inner clip handles photo
        frameWrap.style.zIndex = "60";  // above spread overlay (z-index:50) so drops land on frame
        frameWrap.dataset.frameKey = f.key;
        frameWrap.dataset.framePage = String(pageNumber);

        const fwClip = document.createElement("div");
        fwClip.style.cssText = "position:absolute;inset:0;overflow:hidden;border-radius:inherit;";
        frameWrap.appendChild(fwClip);

        const pid = getFramePhotoId(pageNumber, f.key);

        if (!pid && !isPreview) {
          const hint = document.createElement("div");
          hint.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;pointer-events:none;background:rgba(220,220,220,0.55);border:1.5px dashed #ccc;border-radius:2px;";
          hint.innerHTML = `<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><circle cx="13" cy="13" r="11" stroke="#c0c0c0" stroke-width="1.5"/><line x1="13" y1="7.5" x2="13" y2="18.5" stroke="#bbb" stroke-width="2" stroke-linecap="round"/><line x1="7.5" y1="13" x2="18.5" y2="13" stroke="#bbb" stroke-width="2" stroke-linecap="round"/></svg><span style="font-size:8px;font-weight:900;color:#bbb;letter-spacing:0.4px;text-transform:uppercase;">Drop photo</span>`;
          fwClip.appendChild(hint);
        } else if (pid) {
          const placed = makePlacedImageBox(pid, { top: 0, bottom: 0 }, pageNumber, f.key, isPreview, true);
          placed.style.cssText += ";position:absolute;left:0;right:0;top:0;bottom:0;height:auto;";
          fwClip.appendChild(placed);
          // Re-apply stored frame shape after image loads
          const _storedShape = editor.pageFrameShapes?.[pageNumber]?.[f.key] || '';
          if (_storedShape) {
            const _si = placed.querySelector('img');
            if (_si) applyDmbFrameShape(_si, _storedShape);
          }

          if (!isPreview) {
            const _tBtnSVGs = [
              { aria:"Remove", title:"Remove photo", svg:`<svg viewBox="0 0 14 14" width="12" height="12" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Remove Photo");clearFrame(pageNumber,f.key);renderSpread();renderThumbsRail();renderPhotoTray(); }},
              { aria:"Rotate", title:"Rotate 90° anti-clockwise", svg:`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M12 4a8 8 0 1 0 7.2 4.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M19.5 4.5v5h-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();pushUndoState("Rotate Photo");const rots=editor.pageFrameRot?.[pageNumber]||{};rots[f.key]=((rots[f.key]||0)-90+360)%360;if(!editor.pageFrameRot)editor.pageFrameRot={};editor.pageFrameRot[pageNumber]=rots;renderSpread();renderThumbsRail(); }},
              { aria:"Crop",   title:"Crop photo",    svg:`<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M7 3v11a3 3 0 0 0 3 3h11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/><path d="M17 21V10a3 3 0 0 0-3-3H3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation();openCropModal(pid); }},
              { aria:"Shape",  title:"Frame shape",   svg:`<svg viewBox="0 0 22 22" width="12" height="12" fill="none" stroke="#fff" stroke-width="1.8"><circle cx="11" cy="11" r="9"/><polygon points="11,4 13,8.5 18,9 14.5,12.5 15.5,17.5 11,15 6.5,17.5 7.5,12.5 4,9 9,8.5" fill="#fff" stroke="none" opacity="0.7"/></svg>`, fn:(e)=>{ e.preventDefault();e.stopPropagation(); if(!editor.pageFrameShapes)editor.pageFrameShapes={}; if(!editor.pageFrameShapes[pageNumber])editor.pageFrameShapes[pageNumber]={}; const curShape=editor.pageFrameShapes[pageNumber][f.key]||''; showDmbFramePicker(e.currentTarget, curShape, (shapeId)=>{ pushUndoState("Frame Shape"); if(!editor.pageFrameShapes)editor.pageFrameShapes={}; if(!editor.pageFrameShapes[pageNumber])editor.pageFrameShapes[pageNumber]={}; editor.pageFrameShapes[pageNumber][f.key]=shapeId; const _img=fwClip.querySelector('img'); if(_img)applyDmbFrameShape(_img,shapeId); renderSpread(); }); }}
            ];
            const _tbs = "border-radius:999px;border:none;background:rgba(0,0,0,0.72);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;";
            // Always use ··· popup for layout frames (clean at any size)
            const mb=document.createElement("button");mb.type="button";mb.title="Options";
            mb.innerHTML="···";
            mb.style.cssText=`position:absolute;top:3px;right:3px;width:22px;height:22px;z-index:12;font-size:14px;line-height:1;${_tbs}`;
            const pop=document.createElement("div");
            pop.style.cssText="position:absolute;top:26px;right:0;background:rgba(20,20,20,0.92);border-radius:8px;padding:3px;display:none;flex-direction:column;gap:2px;z-index:20;min-width:110px;";
            _tBtnSVGs.forEach(d=>{
              const b=document.createElement("button");b.type="button";
              b.innerHTML=`<span style="display:flex;align-items:center;gap:6px;">${d.svg}<span style="font-size:11px;font-weight:700;color:#fff;">${d.aria}</span></span>`;
              b.style.cssText="background:none;border:none;cursor:pointer;padding:4px 8px;border-radius:6px;width:100%;text-align:left;";
              b.addEventListener("click",(ev)=>{pop.style.display="none";d.fn(ev);});
              pop.appendChild(b);
            });
            mb.addEventListener("click",(e)=>{e.preventDefault();e.stopPropagation(); const _open=pop.style.display==="none"; document.querySelectorAll(".dmb-frame-popup-open").forEach(p=>{p.style.display="none";p.classList.remove("dmb-frame-popup-open");}); if(_open){pop.style.display="flex";pop.classList.add("dmb-frame-popup-open");}});
            frameWrap.appendChild(mb);frameWrap.appendChild(pop);
          }
        }

        frameWrap.addEventListener("dragover", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const payload = getDragPayload(e);
          e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
          frameWrap.style.outline = "2px solid #111";
          frameWrap.style.outlineOffset = "-2px";
          body.style.outline = "none";
        });

        frameWrap.addEventListener("dragleave", () => {
          frameWrap.style.outline = "none";
        });

        frameWrap.addEventListener("drop", (e) => {
          e.preventDefault();
          e.stopPropagation();
          frameWrap.style.outline = "none";
          body.style.outline = "none";
          const payload = getDragPayload(e);
          const photoId = (() => {
            if (payload && payload.photoId) return payload.photoId;
            const tp = e.dataTransfer ? (e.dataTransfer.getData("text/plain") || "").trim() : "";
            if (!tp) return "";
            if (tp[0] === "{") { try { return JSON.parse(tp).photoId || ""; } catch { return ""; } }
            return tp;
          })();
          if (!photoId) return;
          const used = getUsedPhotoIds();
          if (payload?.type === "photo" && used.has(photoId)) showReuseNotice();
          pushUndoState("Drop Photo In Frame");
          if (payload && payload.type === "placed") {
            const fromPage = Number(payload.fromPage);
            const fromSlot = payload.fromSlot;
            if (fromPage && fromSlot) {
              const currentInTarget = getFramePhotoId(pageNumber, f.key);
              const replacedRot = getFrameRotation(pageNumber, f.key);
              setFramePhotoId(pageNumber, f.key, photoId);
              setFrameRotation(pageNumber, f.key, 0);
              if (currentInTarget) {
                setFramePhotoId(fromPage, fromSlot, currentInTarget);
                setFrameRotation(fromPage, fromSlot, replacedRot);
              } else {
                clearFrame(fromPage, fromSlot);
              }
            } else {
              setFramePhotoId(pageNumber, f.key, photoId);
              setFrameRotation(pageNumber, f.key, 0);
            }
          } else {
            setFramePhotoId(pageNumber, f.key, photoId);
            setFrameRotation(pageNumber, f.key, 0);
          }
          renderSpread();
          renderThumbsRail();
          renderPhotoTray();
        });

        body.appendChild(frameWrap);
      });

      renderFreeFrameObjects(body, { targetType: "page", pageNumber: pageNumber });
      return page;
    }

    if (!editor.pageSlots[pageNumber]) {
      editor.pageSlots[pageNumber] = { A: null, B: null };
    }
    if (!editor.pageRot[pageNumber]) {
      editor.pageRot[pageNumber] = { A: 0, B: 0 };
    }
    if (!editor.pageTemplate[pageNumber]) {
      editor.pageTemplate[pageNumber] = null;
    }
    if (!editor.pageFrames[pageNumber]) {
      editor.pageFrames[pageNumber] = {};
    }
    if (!editor.pageFrameRot[pageNumber]) {
      editor.pageFrameRot[pageNumber] = {};
    }


    const A = editor.pageSlots[pageNumber].A;
    const B = editor.pageSlots[pageNumber].B;

    if (!A && !B) {
      if (!isPreview) body.appendChild(makeHint("Drop a photo here"));
    } else if (A && !B) {
      body.appendChild(makePlacedImageBox(A, { top: 0, bottom: 0 }, pageNumber, "A", isPreview));
      if (!isPreview) {
        msg.style.display = "block";
        // Auto-dismiss after 4 seconds
        setTimeout(() => { msg.style.opacity = "0"; setTimeout(() => { msg.style.display = "none"; }, 400); }, 4000);
      }
    } else {
      body.appendChild(makePlacedImageBox(A, { top: 0, height: "50%" }, pageNumber, "A", isPreview));
      body.appendChild(makePlacedImageBox(B, { bottom: 0, height: "50%" }, pageNumber, "B", isPreview));

      const divider = document.createElement("div");
      divider.style.position = "absolute";
      divider.style.left = "0";
      divider.style.right = "0";
      divider.style.top = "50%";
      divider.style.height = "1px";
      divider.style.background = "#eee";
      divider.style.zIndex = "2";
      divider.style.pointerEvents = "none";
      body.appendChild(divider);
    }

    
    body.addEventListener("dragover", (e) => {
      e.preventDefault();
      const payload = getDragPayload(e);
      e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
      body.style.outline = "2px solid #111";
      body.style.outlineOffset = "-2px";
    });

    body.addEventListener("dragleave", () => {
      body.style.outline = "none";
    });

    body.addEventListener("drop", (e) => {
      e.preventDefault();
      e.stopPropagation();
      body.style.outline = "none";
      const payload = getDragPayload(e);
      handleDropOnPage(pageNumber, e.clientY, payload, e.dataTransfer, body);
    });

    page.addEventListener("dragover", (e) => {
      if (isLockedPage(pageNumber)) return;
      e.preventDefault();
      const payload = getDragPayload(e);
      e.dataTransfer.dropEffect = (payload && payload.type === "placed") ? "move" : "copy";
    });

    page.addEventListener("drop", (e) => {
      if (isLockedPage(pageNumber)) return;
      e.preventDefault();
      const payload = getDragPayload(e);
      handleDropOnPage(pageNumber, e.clientY, payload, e.dataTransfer, body);
    });
    renderFreeFrameObjects(body, { targetType: "page", pageNumber: pageNumber });
    return page;
  }

  function renderUnifiedCoverObjects(stageEl) {
    const objs = (editor.coverObjects || []).slice().sort((a, b) => (a.z || 0) - (b.z || 0));

    objs.forEach((obj) => {
      if (obj.type === "text") {
        // render text object
      }

      if (obj.type === "photo-frame") {
        // render frame object
      }
    });
  }

  function forceSpreadLayout() {
    if (!spreadViewport || !spreadCanvas) return;

    spreadViewport.style.overflowX = "auto";
    spreadViewport.style.overflowY = "auto";
    spreadViewport.style.padding = "12px";
    spreadViewport.style.minHeight = "480px";
    spreadViewport.style.height = "62vh";
    spreadViewport.style.maxHeight = "760px";
    spreadViewport.style.boxSizing = "border-box";

    spreadCanvas.style.display = "flex";
    spreadCanvas.style.flexWrap = "nowrap";
    spreadCanvas.style.justifyContent = "flex-start";
    spreadCanvas.style.alignItems = "flex-start";
    spreadCanvas.style.gap = "14px";
    spreadCanvas.style.width = "max-content";
    spreadCanvas.style.minWidth = "0";
    spreadCanvas.style.margin = "0";
    spreadCanvas.style.boxSizing = "border-box";
  }

  function renderSpread() {
    // Hide the logo watermark — it belongs only on the back cover
    document.querySelectorAll(".dmb-logo-watermark").forEach((el) => { el.style.display = "none"; });
    // Remove any orphaned fixed-position rotation handles from a previous spread render.
    // These are appended to document.body to escape overflow:hidden and are not destroyed
    // when the spread DOM is rebuilt — so we sweep them explicitly before each re-render.
    document.querySelectorAll(".dmb-map-rot-float").forEach((el) => el.remove());
    if (!spreadCanvas || !spreadIndexEl || !prevSpreadBtn || !nextSpreadBtn) return;

    const selectedPages = Number(document.getElementById("pages")?.value || 0);
    // Include any extra spreads the customer added (+2 pages / +1 spread each),
    // otherwise this recompute would wipe them out on every re-render — leaving
    // the "Spread X / Y" total stale and the Next button unable to reach them.
    const _extraSpreads = editor.extraSpreads || 0;
    if (selectedPages > 0) {
      editor.totalPages = selectedPages + _extraSpreads * 2;
      editor.editablePages = Math.max(0, editor.totalPages - 1);
      editor.totalSpreads = Math.max(1, Math.ceil(selectedPages / 2) + _extraSpreads);
    } else {
      editor.totalPages = 0;
      editor.editablePages = 0;
      editor.totalSpreads = 1;
    }
    if (editor.currentSpread > editor.totalSpreads - 1) editor.currentSpread = 0;

    // Mark the currently-displayed pages dirty so PDF preview re-renders (2s debounce)
    if (editor.currentSpread === -1) {
      _dmbPvMarkDirty(0);
    } else {
      _dmbPvMarkDirty(editor.currentSpread * 2 + 1);
      _dmbPvMarkDirty(editor.currentSpread * 2 + 2);
    }

    spreadCanvas.innerHTML = "";

    // ── Page 0 (special single page — before all spreads) ──
    if (editor.currentSpread === -1) {
      spreadIndexEl.textContent = "Your Special Page";
      const page0El = makeA4Page(0, "L");

      const dropOverlay0 = document.createElement("div");
      dropOverlay0.className = "dmb-spread-drag-overlay";
      const zone0 = document.createElement("div");
      zone0.className = "dmb-spread-drop-zone";
      zone0.style.flex = "1";
      const zone0Lbl = document.createElement("div");
      zone0Lbl.className = "dmb-drop-zone-label";
      zone0Lbl.textContent = "Drop photo here";
      zone0.appendChild(zone0Lbl);
      dropOverlay0.appendChild(zone0);

      const pagesRow0 = document.createElement("div");
      pagesRow0.style.cssText = "position:relative;display:flex;gap:0;flex-shrink:0;";
      pagesRow0.appendChild(page0El);
      pagesRow0.appendChild(dropOverlay0);

      let ec0 = 0;
      pagesRow0.addEventListener("dragenter", (e) => {
        if (!getDragPayload(e)) return;
        ec0++;
        dropOverlay0.classList.add("active");
      });
      pagesRow0.addEventListener("dragleave", (e) => {
        if (e.relatedTarget && pagesRow0.contains(e.relatedTarget)) return;
        if (--ec0 <= 0) { ec0 = 0; dropOverlay0.classList.remove("active"); }
      });
      pagesRow0.addEventListener("dragover", (e) => { if (getDragPayload(e)) e.preventDefault(); });
      pagesRow0.addEventListener("drop", async (e) => {
        e.preventDefault();
        ec0 = 0; dropOverlay0.classList.remove("active");
        const payload = getDragPayload(e);
        if (!payload) return;
        await handleSpreadZoneDrop("left", payload, 0, null, -1);
      });

      const lbl0 = document.createElement("div");
      lbl0.className = "dmb-page-label";
      lbl0.textContent = "Your Special Page";
      lbl0.style.width = "270px";
      const labelsRow0 = document.createElement("div");
      labelsRow0.style.display = "flex";
      labelsRow0.appendChild(lbl0);

      const pagesMain0 = document.createElement("div");
      pagesMain0.style.cssText = "display:flex;flex-direction:column;gap:6px;";
      pagesMain0.appendChild(labelsRow0);
      pagesMain0.appendChild(pagesRow0);

      const outerRow0 = document.createElement("div");
      outerRow0.style.cssText = "display:flex;gap:8px;align-items:flex-start;";
      outerRow0.appendChild(buildActionBtns(0));
      outerRow0.appendChild(pagesMain0);

      spreadCanvas.appendChild(outerRow0);
      forceSpreadLayout();
      if (spreadViewport) spreadViewport.scrollLeft = 0;
      prevSpreadBtn.disabled = true;
      nextSpreadBtn.disabled = editor.totalSpreads <= 0;
      return;
    }

    const spreadNum = editor.currentSpread + 1;
    spreadIndexEl.textContent = `Spread ${spreadNum} / ${editor.totalSpreads}`;

    const leftPage = editor.currentSpread * 2 + 1;
    const rightPage = editor.currentSpread * 2 + 2;
    const si = editor.currentSpread;

    // ── Pages row (position:relative, pages touch — no gap) ──
    const pagesRow = document.createElement("div");
    pagesRow.style.position = "relative";
    pagesRow.style.display = "flex";
    pagesRow.style.gap = "0";
    pagesRow.style.flexShrink = "0";
    pagesRow.dataset.spreadRow = "true";

    // ── Labels row (label per page, each 270px wide to align exactly with its page) ──
    const labelsRow = document.createElement("div");
    labelsRow.style.display = "flex";
    labelsRow.style.gap = "0";

    const leftPageEl = (leftPage <= editor.totalPages) ? makeA4Page(leftPage, "L") : null;
    if (leftPageEl) {
      pagesRow.appendChild(leftPageEl);
      const lbl = document.createElement("div");
      lbl.className = "dmb-page-label";
      lbl.textContent = `Page ${leftPage} (L)`;
      lbl.style.width = "270px";
      labelsRow.appendChild(lbl);
    }

    const rightPageEl = (rightPage <= editor.totalPages) ? makeA4Page(rightPage, "R") : null;
    if (rightPageEl) {
      pagesRow.appendChild(rightPageEl);
      const lbl = document.createElement("div");
      lbl.className = "dmb-page-label";
      lbl.textContent = `Page ${rightPage} (R)`;
      lbl.style.width = "270px";
      labelsRow.appendChild(lbl);
    }


    // ── Spine gradient (absolute, overlaid on the seam between the two pages) ──
    const leftHasContent = leftPage <= editor.totalPages && pageHasAnyContent(leftPage);
    const rightHasContent = rightPage <= editor.totalPages && pageHasAnyContent(rightPage);

    if (leftPageEl && rightPageEl) {
      const spine = document.createElement("div");
      spine.className = "dmb-spread-spine" +
        (leftHasContent ? " left-filled" : "") +
        (rightHasContent ? " right-filled" : "");
      const spineL = document.createElement("div");
      spineL.className = "dmb-spread-spine-left";
      const spineR = document.createElement("div");
      spineR.className = "dmb-spread-spine-right";
      spine.appendChild(spineL);
      spine.appendChild(spineR);
      pagesRow.appendChild(spine);
    }

    // ── Drop overlay (absolute, covers pagesRow exactly) ──
    const dropOverlay = document.createElement("div");
    dropOverlay.className = "dmb-spread-drag-overlay";

    function makeZone(label, disabled) {
      const zone = document.createElement("div");
      zone.className = "dmb-spread-drop-zone" + (disabled ? " disabled" : "");
      const lbl = document.createElement("div");
      lbl.className = "dmb-drop-zone-label";
      lbl.textContent = label;
      zone.appendChild(lbl);
      return zone;
    }

    const leftZone = makeZone(isLockedPage(leftPage) ? "Locked" : "Left page", isLockedPage(leftPage));
    const centerZone = makeZone("Full spread", isLockedPage(leftPage) || !rightPageEl);
    const rightZone = makeZone("Right page", !rightPageEl);
    dropOverlay.appendChild(leftZone);
    dropOverlay.appendChild(centerZone);
    dropOverlay.appendChild(rightZone);
    pagesRow.appendChild(dropOverlay);

    // ── Drag events on pagesRow ──
    // Overlay (z-index:50) is pointer-events:auto — zones receive drops for background area.
    // Template frames (z-index:60) and free frames (z-index:60) are ABOVE the overlay,
    // so they receive drops directly via their own stopPropagation handlers.
    let enterCount = 0;
    function clearZoneHighlights() {
      leftZone.classList.remove("drag-over");
      centerZone.classList.remove("drag-over");
      rightZone.classList.remove("drag-over");
    }
    pagesRow.addEventListener("dragenter", (e) => {
      if (!getDragPayload(e)) return;
      enterCount++;
      dropOverlay.classList.add("active");
    });
    pagesRow.addEventListener("dragleave", (e) => {
      if (e.relatedTarget && pagesRow.contains(e.relatedTarget)) return;
      if (--enterCount <= 0) { enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights(); }
    });
    pagesRow.addEventListener("dragover", (e) => { if (getDragPayload(e)) e.preventDefault(); });

    // Zone-level highlighting and drop handling (original approach — reliable)
    [leftZone, centerZone, rightZone].forEach(zone => {
      if (zone.classList.contains("disabled")) return;
      let zc = 0;
      zone.addEventListener("dragenter", (e) => { e.preventDefault(); e.stopPropagation(); if (++zc > 0) zone.classList.add("drag-over"); });
      zone.addEventListener("dragleave", () => { if (--zc <= 0) { zc = 0; zone.classList.remove("drag-over"); } });
      zone.addEventListener("dragover",  (e) => { e.preventDefault(); e.stopPropagation(); });
    });

    leftZone.addEventListener("drop", async (e) => {
      e.preventDefault(); e.stopPropagation();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload || isLockedPage(leftPage)) return;
      await handleSpreadZoneDrop("left", payload, leftPage, rightPage, si);
    });
    centerZone.addEventListener("drop", async (e) => {
      e.preventDefault(); e.stopPropagation();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload || isLockedPage(leftPage) || !rightPageEl) return;
      await handleSpreadZoneDrop("spread", payload, leftPage, rightPage, si);
    });
    rightZone.addEventListener("drop", async (e) => {
      e.preventDefault(); e.stopPropagation();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload || !rightPageEl) return;
      await handleSpreadZoneDrop("right", payload, leftPage, rightPage, si);
    });

    // Fallback: pagesRow catches any drops that reach it (e.g. spine area)
    pagesRow.addEventListener("drop", async (e) => {
      e.preventDefault();
      enterCount = 0; dropOverlay.classList.remove("active"); clearZoneHighlights();
      const payload = getDragPayload(e);
      if (!payload) return;
      const pr = pagesRow.getBoundingClientRect();
      const dx = e.clientX - pr.left;
      const w  = pr.width;
      let zone = !rightPageEl ? "left" : dx < w / 3 ? "left" : dx > w * 2 / 3 ? "right" : "spread";
      if (zone === "left" && isLockedPage(leftPage)) return;
      if (zone !== "left" && !rightPageEl) return;
      await handleSpreadZoneDrop(zone, payload, leftPage, rightPage, si);
    });

    // ── Action buttons helper ──
    function buildActionBtns(pNum) {
      const actions = document.createElement("div");
      actions.className = "dmb-page-outer-actions";

      const clearBtn = document.createElement("button");
      clearBtn.type = "button";
      clearBtn.className = "dmb-page-action-btn";
      clearBtn.textContent = "Clear page";
      clearBtn.addEventListener("click", async () => {
        if (!pageHasAnyContent(pNum)) return;
        const choice = await showChoiceDialog(
          "Clear page",
          "What would you like to remove?",
          [
            { id: "photos", label: "Remove photos only (keep layout & text)" },
            { id: "all", label: "Remove everything" },
            { id: "cancel", label: "Cancel" }
          ]
        );
        if (!choice || choice === "cancel") return;
        pushUndoState("Clear Page");
        if (choice === "photos") clearPagePhotosOnly(pNum);
        else clearPageAllLayouts(pNum);
        renderSpread(); renderThumbsRail(); renderPhotoTray();
      });

      const layoutBtn = document.createElement("button");
      layoutBtn.type = "button";
      layoutBtn.className = "dmb-page-action-btn";
      layoutBtn.textContent = "Choose layout";
      layoutBtn.addEventListener("click", async () => {
        const psi = Math.floor((pNum - 1) / 2);
        if (editor.spreadPhoto?.[psi]) {
          const choice = await showChoiceDialog(
            "Full spread photo active",
            "This page has a full-spread photo. What would you like to do?",
            [
              { id: "keep", label: "Keep spread photo, pick layout on top" },
              { id: "remove", label: "Remove spread photo, pick layout" },
              { id: "cancel", label: "Cancel" }
            ]
          );
          if (!choice || choice === "cancel") return;
          if (choice === "remove") { pushUndoState(); editor.spreadPhoto[psi] = null; renderSpread(); return; }
        }
        showLayoutsForPage(pNum);
      });

      const textBtn = document.createElement("button");
      textBtn.type = "button";
      textBtn.className = "dmb-page-action-btn";
      textBtn.textContent = "Add text";
      textBtn.addEventListener("click", () => {
        // Set lastToolbarSide so addDefaultText targets the correct page body
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        if (canvasTextBtn) canvasTextBtn.click();
      });

      const frameBtn = document.createElement("button");
      frameBtn.type = "button";
      frameBtn.className = "dmb-page-action-btn";
      frameBtn.textContent = "Add photo frame";
      frameBtn.addEventListener("click", () => {
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        if (canvasPhotoBtn) canvasPhotoBtn.click();
      });

      // ── SHAPES BUTTON (pages) ─────────────────────────────────────────
      // Sets lastToolbarSide so insertShapeIntoActivePage targets this page.
      // Then opens the floating shape picker panel (same as Shapes toolbar btn).
      // WARNING: Do NOT redirect to canvasShapeBtn.click() alone — the picker
      // panel toggle code also repositions the panel; call that directly instead.
      const shapesBtn = document.createElement("button");
      shapesBtn.type = "button";
      shapesBtn.className = "dmb-page-action-btn";
      shapesBtn.textContent = "Add shape";
      shapesBtn.addEventListener("click", () => {
        lastToolbarSide = (pNum % 2 === 0) ? "right" : "left";
        // Open the shape picker panel (re-use the canvasShapeBtn click logic)
        if (canvasShapeBtn) canvasShapeBtn.click();
      });

      // ── Page background colour ─────────────────────────────────────────
      // A colour swatch button that opens a native colour picker.
      // Shows "×" when a custom colour is set so it can be cleared.
      // WARNING: keep the hidden <input type="color"> INSIDE the button so
      // clicking the button triggers the colour picker on all browsers.
      const bgBtn = document.createElement("button");
      bgBtn.type = "button";
      bgBtn.className = "dmb-page-action-btn dmb-page-bg-btn";
      bgBtn.title = "Page background colour";

      const bgColorInput = document.createElement("input");
      bgColorInput.type = "color";
      bgColorInput.className = "dmb-page-bg-input";
      bgColorInput.value = editor.pageBackgrounds?.[pNum] || "#ffffff";
      bgColorInput.tabIndex = -1;
      bgColorInput.setAttribute("aria-hidden", "true");

      const bgSwatch = document.createElement("span");
      bgSwatch.className = "dmb-page-bg-swatch";
      bgSwatch.style.background = editor.pageBackgrounds?.[pNum] || "#ffffff";

      const bgLabel = document.createElement("span");
      bgLabel.textContent = "Background";

      // ── Circle-X clear background colour (Fix 1) ───────────────────────
      const bgClear = document.createElement("span");
      bgClear.className = "dmb-page-bg-clear";
      bgClear.innerHTML = `<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 8l8 8M16 8l-8 8"/></svg>`;
      bgClear.title = "Remove background colour";
      bgClear.style.display = editor.pageBackgrounds?.[pNum] ? "inline" : "none";

      // Apply colour change
      function _applyBgColor(color) {
        if (!editor.pageBackgrounds) editor.pageBackgrounds = {};
        if (color && color.toLowerCase() !== "#ffffff") {
          editor.pageBackgrounds[pNum] = color;
        } else {
          delete editor.pageBackgrounds[pNum];
        }
        bgSwatch.style.background = color || "#ffffff";
        bgColorInput.value = color || "#ffffff";
        bgClear.style.display = editor.pageBackgrounds?.[pNum] ? "inline" : "none";
        pushUndoState("Page Background");
        renderBuilderCanvas();
        renderThumbsRail();
      }

      bgColorInput.addEventListener("input", () => _applyBgColor(bgColorInput.value));

      // Clear button: stop propagation so it doesn't re-open the colour picker
      bgClear.addEventListener("click", (e) => {
        e.stopPropagation();
        _applyBgColor("#ffffff");
      });

      bgBtn.appendChild(bgColorInput);
      bgBtn.appendChild(bgSwatch);
      bgBtn.appendChild(bgLabel);
      bgBtn.appendChild(bgClear);

      actions.appendChild(clearBtn);
      actions.appendChild(layoutBtn);
      actions.appendChild(textBtn);
      actions.appendChild(frameBtn);
      actions.appendChild(shapesBtn);
      actions.appendChild(bgBtn);
      return actions;
    }

    // ── Outer row: [left actions] + [labels stacked above pages] + [right actions] ──
    const pagesMain = document.createElement("div");
    pagesMain.style.display = "flex";
    pagesMain.style.flexDirection = "column";
    pagesMain.style.gap = "6px";
    pagesMain.appendChild(labelsRow);
    pagesMain.appendChild(pagesRow);

    const outerRow = document.createElement("div");
    outerRow.style.display = "flex";
    outerRow.style.gap = "8px";
    outerRow.style.alignItems = "flex-start";

    if (leftPageEl && !isLockedPage(leftPage)) outerRow.appendChild(buildActionBtns(leftPage));
    outerRow.appendChild(pagesMain);
    if (rightPageEl && !isLockedPage(rightPage)) outerRow.appendChild(buildActionBtns(rightPage));

    spreadCanvas.appendChild(outerRow);
    forceSpreadLayout();
    if (spreadViewport) spreadViewport.scrollLeft = 0;
    prevSpreadBtn.disabled = editor.currentSpread < 0;
    nextSpreadBtn.disabled = editor.currentSpread >= editor.totalSpreads - 1;
  }

  function showLayoutsForPage(pageNumber) {
    const panel = document.querySelector('.dmb-side-panel[data-panel="layouts"]');
    if (!panel) return;
    panel.innerHTML = "";
    const section = document.createElement("div");
    section.className = "dmb-section";
    section.style.cssText = "flex:1 1 0;min-height:0;display:flex;flex-direction:column;overflow:hidden;";
    const title = document.createElement("div");
    title.className = "dmb-mini-label";
    title.textContent = `Layouts — Page ${pageNumber}`;
    section.appendChild(title);
    const listWrap = document.createElement("div");
    listWrap.style.cssText = "overflow-y:auto;flex:1 1 0;min-height:0;margin-top:6px;";
    const list = document.createElement("div");
    list.className = "dmb-template-list";
    const addItem = (id, name, subtitle, isDefault = false) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-template-item";
      const currentId = getPageTemplateId(pageNumber);
      if ((isDefault && !currentId) || (!isDefault && currentId === id)) btn.classList.add("active");
      const row = document.createElement("div");
      row.className = "dmb-template-item-row";
      const mini = document.createElement("div");
      mini.className = "dmb-template-mini";
      if (isDefault) {
        const a = document.createElement("div");
        a.className = "dmb-template-mini-frame";
        a.style.cssText = "left:0;top:0;width:100%;height:49%";
        const b = document.createElement("div");
        b.className = "dmb-template-mini-frame";
        b.style.cssText = "left:0;top:51%;width:100%;height:49%";
        mini.appendChild(a);
        mini.appendChild(b);
      } else {
        renderTemplateMini(mini, id);
      }
      const txt = document.createElement("div");
      txt.style.minWidth = "0";
      const nm = document.createElement("div");
      nm.className = "dmb-template-item-name";
      nm.textContent = name;
      const sub = document.createElement("div");
      sub.className = "dmb-template-item-sub";
      sub.textContent = subtitle;
      txt.appendChild(nm);
      txt.appendChild(sub);
      row.appendChild(mini);
      row.appendChild(txt);
      btn.appendChild(row);
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isDefault) await setPageTemplateWithConfirm(pageNumber, null);
        else await setPageTemplateWithConfirm(pageNumber, id);
      });
      list.appendChild(btn);
    };
    addItem(null, "Default Layout", "1 photo full / 2-photo split", true);
    Object.keys(TEMPLATE_DEFS).forEach((id) => {
      addItem(id, TEMPLATE_NAMES[id] || id.toUpperCase(), `${TEMPLATE_DEFS[id].length} frame(s)`);
    });
    listWrap.appendChild(list);
    section.appendChild(listWrap);
    panel.appendChild(section);
    document.querySelector('.dmb-icon-tab[data-tab="layouts"]')?.click();
  }

  function showLayoutsForCoverZone(zone) {
    // Use a dedicated floating modal so we don't touch the shared layouts panel
    const existing = document.getElementById("dmb-cover-layout-modal");
    if (existing) existing.remove();

    const overlay = document.createElement("div");
    overlay.id = "dmb-cover-layout-modal";
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:999999;display:flex;align-items:center;justify-content:center;";

    const modal = document.createElement("div");
    modal.style.cssText = "background:#1e1e1e;border:1px solid #444;border-radius:16px;padding:20px;width:340px;max-height:80vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.7);";

    const header = document.createElement("div");
    header.style.cssText = "display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;";
    const ttl = document.createElement("div");
    ttl.style.cssText = "font-weight:900;font-size:15px;color:#fff;";
    ttl.textContent = `Cover Layout — ${zone === "front" ? "Front" : "Back"}`;
    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.textContent = "✕";
    closeBtn.style.cssText = "background:none;border:none;color:#aaa;font-size:18px;cursor:pointer;padding:0 4px;";
    closeBtn.addEventListener("click", () => overlay.remove());
    header.appendChild(ttl);
    header.appendChild(closeBtn);
    modal.appendChild(header);

    const listWrap = document.createElement("div");
    listWrap.style.cssText = "overflow-y:auto;flex:1;";
    const list = document.createElement("div");
    list.className = "dmb-template-list";

    const currentId = zone === "front" ? coverState.frontLayout : coverState.backLayout;

    const addItem = (id, name, subtitle, isNone = false) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dmb-template-item";
      if ((isNone && !currentId) || (!isNone && currentId === id)) btn.classList.add("active");
      const row = document.createElement("div");
      row.className = "dmb-template-item-row";
      const mini = document.createElement("div");
      mini.className = "dmb-template-mini";
      if (isNone) {
        const a = document.createElement("div");
        a.className = "dmb-template-mini-frame";
        a.style.cssText = "left:0;top:0;width:100%;height:100%";
        mini.appendChild(a);
      } else {
        renderTemplateMini(mini, id);
      }
      const txt = document.createElement("div");
      txt.style.minWidth = "0";
      const nm = document.createElement("div");
      nm.className = "dmb-template-item-name";
      nm.textContent = name;
      const sub = document.createElement("div");
      sub.className = "dmb-template-item-sub";
      sub.textContent = subtitle;
      txt.appendChild(nm);
      txt.appendChild(sub);
      row.appendChild(mini);
      row.appendChild(txt);
      btn.appendChild(row);
      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        overlay.remove();
        await setCoverLayoutWithConfirm(zone, isNone ? null : id);
      });
      list.appendChild(btn);
    };

    addItem(null, "No Layout", "Remove layout", true);
    Object.keys(TEMPLATE_DEFS).forEach((id) => {
      addItem(id, TEMPLATE_NAMES[id] || id.toUpperCase(), `${TEMPLATE_DEFS[id].length} frame(s)`);
    });

    listWrap.appendChild(list);
    modal.appendChild(listWrap);
    overlay.appendChild(modal);
    overlay.addEventListener("click", (e) => { if (e.target === overlay) overlay.remove(); });
    document.body.appendChild(overlay);
  }

  async function setCoverLayoutWithConfirm(zone, templateId) {
    const frames = zone === "front" ? coverState.frontFrames : coverState.backFrames;
    const hasPhotos = Object.values(frames || {}).some(Boolean);
    const hasCoverImage = zone === "front" && !!coverState.imageUrl;

    if (hasPhotos || hasCoverImage) {
      const choice = await showChoiceDialog(
        "This cover face has photos",
        "How would you like to apply the layout?",
        [
          { id: "over",    label: "Apply layout, keep existing photos" },
          { id: "replace", label: "Remove photos and apply layout" },
          { id: "cancel",  label: "Cancel" }
        ]
      );
      if (!choice || choice === "cancel") return;
      if (choice === "replace") {
        if (zone === "front") { coverState.frontFrames = {}; coverState.frontFrameRot = {}; }
        else                  { coverState.backFrames  = {}; coverState.backFrameRot  = {}; }
        // Also clear cover background image if on front
        if (zone === "front") { coverState.imageUrl = ""; coverState.imageFile = null; }
      }
    }

    if (zone === "front") {
      coverState.frontLayout = templateId || null;
      if (templateId) {
        const defs = TEMPLATE_DEFS[templateId] || [];
        defs.forEach((f) => {
          if (!(f.key in coverState.frontFrames)) coverState.frontFrames[f.key] = null;
          if (!(f.key in coverState.frontFrameRot)) coverState.frontFrameRot[f.key] = 0;
        });
        // Remove stale keys
        Object.keys(coverState.frontFrames).forEach((k) => {
          if (!defs.find((d) => d.key === k)) delete coverState.frontFrames[k];
        });
      } else {
        coverState.frontFrames = {};
        coverState.frontFrameRot = {};
      }
    } else {
      coverState.backLayout = templateId || null;
      if (templateId) {
        const defs = TEMPLATE_DEFS[templateId] || [];
        defs.forEach((f) => {
          if (!(f.key in coverState.backFrames)) coverState.backFrames[f.key] = null;
          if (!(f.key in coverState.backFrameRot)) coverState.backFrameRot[f.key] = 0;
        });
        Object.keys(coverState.backFrames).forEach((k) => {
          if (!defs.find((d) => d.key === k)) delete coverState.backFrames[k];
        });
      } else {
        coverState.backFrames = {};
        coverState.backFrameRot = {};
      }
    }

    saveCoverDesignToStorage();
    builderMode = "cover";
    renderCoverCanvas();
  }

  function _showMobileQualityWarning() {
    // Only on mobile, only once per session
    if (window.innerWidth > 749) return;
    if (sessionStorage.getItem("dmb_mobile_warned")) return;
    sessionStorage.setItem("dmb_mobile_warned", "1");
    const modal = document.getElementById("dmbMobileQualityModal");
    if (!modal) return;
    modal.style.display = "flex";
    const dismiss = () => { modal.style.display = "none"; };
    document.getElementById("dmbMobileQualityContinue")?.addEventListener("click", dismiss, { once: true });
    document.getElementById("dmbMobileQualityGotIt")?.addEventListener("click", dismiss, { once: true });
  }

  async function openEditor({ skipStateReset = false } = {}) {
    const selectedPages = Number(document.getElementById("pages")?.value || 0);
    if (!selectedPages) return;

    if (step1) step1.style.display = "none";
    if (builderStep) builderStep.style.display = "block";
    _showMobileQualityWarning();
    if (bookDetails) bookDetails.style.display = "none";

    if (!skipStateReset) {
      editor.totalPages = selectedPages;
      editor.editablePages = Math.max(0, selectedPages - 1);
      editor.totalSpreads = Math.max(1, Math.ceil(selectedPages / 2));
      editor.currentSpread = 0;

      editor.pageSlots = {};
      editor.pageRot = {};
      editor.pageTemplate = {};
      editor.pageFrames = {};
      editor.pageFrameRot = {};
      editor.pageObjects = {};
      editor.spreadPhoto = {};
      editor.coverObjects = [];
      editor.coverUserTexts = [];
      for (let p = 1; p <= selectedPages; p++) {
        editor.pageSlots[p] = { A: null, B: null };
        editor.pageRot[p] = { A: 0, B: 0 };
        editor.pageTemplate[p] = null;
        editor.pageFrames[p] = {};
        editor.pageFrameRot[p] = {};
        editor.pageObjects[p] = [];
      }
      const totalSpreads = editor.totalSpreads || Math.ceil(selectedPages / 2);
      for (let s = 0; s < totalSpreads; s++) editor.spreadPhoto[s] = null;
    }
    initSpreadPhotoDragListeners();

    const files = skipStateReset ? [] : (bookFiles || []);
    const metas = await Promise.all(files.map(getImageMetaFromFile));

    if (!skipStateReset) editor.photos = files.map((f, i) => ({
      id: uid(),
      file: f,
      url: URL.createObjectURL(f),
      ratio: metas[i]?.ratio ?? 1,
      filename: String(f.name || "").toLowerCase(),
      dateTaken: metas[i]?.date || "",
      tags: [],
      addedIndex: i
    }));

    if (bookMeta) {
      bookMeta.textContent =
        `${getEffectiveBookTitle()} • ${editor.totalPages} pages (${editor.editablePages} to design) • ${editor.photos.length} photos`;
    }

    initUnifiedTabs();
    initPhotoImportMenu();
    initPhotoSearchSortControls();
    initProjectMenu();
    initHistoryButton();
    syncCoverInputsFromState();
    ensurePreviewOverlay();
    wireTextToolbar();
    try { initMapTools(); } catch(e) {}
    try { enableMapMarkerPlacement(); } catch(e) {}
    try { initStickerLibrary(); } catch(e) {}
    try { initMagIconPanel(); } catch(e) {}
    try { initCustomStickersPanel(); } catch(e) {}
    try { initPhoneUpload(); } catch(e) {}

    // Global dragend: clear any lingering spread overlays if drag ends without a drop
    document.addEventListener("dragend", () => {
      document.querySelectorAll(".dmb-spread-drag-overlay.active").forEach(el => { el.classList.remove("active"); });
      document.querySelectorAll(".dmb-spread-drop-zone.drag-over").forEach(el => { el.classList.remove("drag-over"); });
      document.querySelectorAll(".dmb-cover-drag-overlay.active").forEach(el => { el.classList.remove("active"); });
    });

    // Global click: close any open ··· option popups when clicking outside
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-frame-key]") && !e.target.closest(".dmb-photo-frame-object")) {
        document.querySelectorAll(".dmb-frame-popup-open").forEach(pop => {
          pop.style.display = "none";
          pop.classList.remove("dmb-frame-popup-open");
        });
      }
    });

    document.dispatchEvent(new CustomEvent("dmb:editorOpened"));

    builderMode = "cover";
    syncBuilderModeButtons();
    renderPhotoTray();
    renderThumbsRail();
    renderCoverCanvas();

    // Offer to restore saved customer progress (after first render)
    setTimeout(() => { try { offerCustomerProgressRestore(); } catch(e) {} }, 600);

    // Start builder tour for first-time visitors
    setTimeout(() => { try { dmbStartTour(); } catch(e) {} }, 1200);

    // Kick off background PDF preview rendering for all pages
    try { _dmbPvInitAll(); } catch(e) {}

    setCanvasZoom(1);

    if (builderStep) builderStep.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function closeEditorBackToDetails() {
    document.querySelectorAll(".dmb-logo-watermark").forEach((el) => el.remove());
    if (step1) step1.style.display = "flex";
    if (builderStep) builderStep.style.display = "none";
    if (bookDetails) bookDetails.style.display = "none";
  }

  let _spreadDragListenersAdded = false;
  function initSpreadPhotoDragListeners() {
    if (_spreadDragListenersAdded) return;
    _spreadDragListenersAdded = true;
    const PAGE_W = 270, PAGE_H = Math.round(270 * 1.414);
    document.addEventListener("mousemove", (e) => {
      if (!spreadPhotoDragState) return;
      const { type, si, startX, startY, startPanX, startPanY, startZoom } = spreadPhotoDragState;
      const sp = editor.spreadPhoto?.[si];
      if (!sp) { spreadPhotoDragState = null; return; }
      if (type === "pan") {
        const zoom = sp.zoom || 1;
        const maxX = PAGE_W * (zoom - 1), maxY = (PAGE_H / 2) * (zoom - 1);
        sp.panX = Math.max(-maxX, Math.min(maxX, startPanX + (e.clientX - startX)));
        sp.panY = Math.max(-maxY, Math.min(maxY, startPanY + (e.clientY - startY)));
        spreadCanvas.querySelectorAll("[data-spread-img-layer]").forEach(l => {
          l.style.transform = `translate(${sp.panX}px,${sp.panY}px) scale(${zoom}) rotate(${sp.rotation || 0}deg)`;
        });
      } else if (type === "resize") {
        const newZoom = Math.max(1, Math.min(4, startZoom + (e.clientX - startX) / 150));
        const maxX = PAGE_W * (newZoom - 1), maxY = (PAGE_H / 2) * (newZoom - 1);
        sp.zoom = newZoom;
        sp.panX = Math.max(-maxX, Math.min(maxX, startPanX));
        sp.panY = Math.max(-maxY, Math.min(maxY, startPanY));
        spreadCanvas.querySelectorAll("[data-spread-img-layer]").forEach(l => {
          l.style.transform = `translate(${sp.panX}px,${sp.panY}px) scale(${newZoom}) rotate(${sp.rotation || 0}deg)`;
        });
      }
    });
    document.addEventListener("mouseup", () => {
      if (spreadPhotoDragState) {
        const _pvDragSi = spreadPhotoDragState.si;
        spreadPhotoDragState = null;
        renderThumbsRail();
        // Dirty-mark both pages of the affected spread so the PDF preview
        // re-renders with the new pan/zoom/rotation. This drag handler never
        // calls pushUndoState, so we hook directly here.
        try { _dmbPvMarkDirty(_pvDragSi * 2 + 1); _dmbPvMarkDirty(_pvDragSi * 2 + 2); } catch(e) {}
      }
    });
  }

  function chooseDistributedPages(pages, k) {
    const n = pages.length;
    if (k <= 0) return new Set();
    if (k >= n) return new Set(pages);

    const chosen = [];
    for (let i = 0; i < k; i++) {
      const idx = Math.round((i + 0.5) * (n / k) - 0.5);
      chosen.push(pages[Math.max(0, Math.min(n - 1, idx))]);
    }

    const set = new Set(chosen);

    let guard = 0;
    while (guard++ < 1000) {
      let changed = false;
      const sorted = Array.from(set).sort((a, b) => a - b);

      for (let i = 0; i < sorted.length - 1; i++) {
        if (sorted[i + 1] === sorted[i] + 1) {
          const bad = sorted[i + 1];
          const pos = pages.indexOf(bad);
          const options = [pages[pos + 1], pages[pos - 1]].filter(Boolean);

          for (const opt of options) {
            if (!set.has(opt) && !set.has(opt - 1) && !set.has(opt + 1)) {
              set.delete(bad);
              set.add(opt);
              changed = true;
              break;
            }
          }
        }
      }

      if (!changed) break;
    }

    return set;
  }

  function getDmbVariantIdByPages(pagesValue) {
    const map = {
      "24": 48404302856407,
      "30": 48350688051415,
      "40": 48350688084183,
      "50": 48350688116951
    };
    return map[String(pagesValue || "")] || null;
  }

  // ─── PDF generation ────────────────────────────────────────────────
  // Page order: front cover → spine → back cover → book pages 1..N
  // Programmatic PDF — each element drawn directly from source at 300 DPI.
  // No html2canvas: photos are taken straight from their original files/URLs.
  // _pvOpt: { cover:true, resolve, reject } for cover preview
  //         { page:N,   resolve, reject } for single page preview
  //         null/undefined for normal full PDF export
  async function buildPdfBlobOnePagePerBookPage(onProgress, _pvOpt) {

    // ── Load jsPDF only (no html2canvas needed) ───────────────────────
    function loadScript(src) {
      return new Promise(function(resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) { resolve(); return; }
        var s = document.createElement("script");
        s.src = src;
        s.onload = resolve;
        s.onerror = function() { reject(new Error("Could not load " + src)); };
        document.head.appendChild(s);
      });
    }
    // Preview mode skips jsPDF entirely — it only needs canvas rendering
    if (!_pvOpt) await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js");

    // ── Sizing constants ──────────────────────────────────────────────
    var A4_W_MM    = 210;
    var A4_H_MM    = 297;
    var FACE_PX    = 300;
    var FACE_H_PX  = Math.round(FACE_PX * A4_H_MM / A4_W_MM);   // 424
    var SPINE_PX   = 22;
    var SPINE_W_MM = parseFloat(((SPINE_PX / FACE_PX) * A4_W_MM).toFixed(2));
    var PAGE_W_PX  = 270;

    // Output canvas at 300 DPI — full print quality
    var MM2PX      = 300 / 25.4;
    var OUT_W      = Math.round(A4_W_MM * MM2PX);    // 2480
    var OUT_H      = Math.round(A4_H_MM * MM2PX);    // 3508
    var PAGE_SCALE = OUT_W / PAGE_W_PX;
    var FACE_SCALE = OUT_W / FACE_PX;
    var FACE_OUT_H = Math.round(FACE_H_PX * FACE_SCALE);

    // jsPDF is only needed for the real export, not preview rendering
    var jsPDF = (!_pvOpt && window.jspdf) ? window.jspdf.jsPDF : null;
    var pdf   = null;

    // ── Canvas helpers ─────────────────────────────────────────────────
    function mkCanvas(w, h) {
      var c = document.createElement("canvas");
      c.width  = Math.max(1, Math.round(w));
      c.height = Math.max(1, Math.round(h));
      var ctx = c.getContext("2d");
      // ── Quality: always use high-quality image smoothing for PDF rendering ──
      // Default browser setting is "low", which produces aliasing artefacts
      // (white/black dots, noise) when downscaling large camera photos to the
      // 300 DPI canvas. "high" uses bicubic/Lanczos resampling → clean result.
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, c.width, c.height);
      return { canvas: c, ctx: ctx };
    }

    function loadImg(url) {
      return new Promise(function(res, rej) {
        if (!url) return rej(new Error("No URL"));
        var img = new Image();
        if (!url.startsWith("blob:") && !url.startsWith("data:")) img.crossOrigin = "anonymous";
        img.onload  = function() { res(img); };
        img.onerror = function() { rej(new Error("Failed: " + url.slice(0, 60))); };
        img.src = url;
      });
    }

    // ── Photo drawing helpers ───────────────────────────────────────────────
    // _setHiQ: always re-apply imageSmoothingQuality after ctx.save() because
    // save/restore does NOT preserve the smoothing setting in all browsers.
    function _setHiQ(ctx) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
    }

    // _downsampleImg: stepped downsampling for very large photos.
    // A single drawImage from e.g. 4000px → 600px can still look noisy even
    // with "high" smoothing. Halving in steps produces a cleaner result.
    // Returns a canvas that can be used as the source for the final drawImage.
    // If the photo is small enough (< 2× the target), returns the original img.
    function _downsampleImg(img, targetW, targetH) {
      var sW = img.naturalWidth, sH = img.naturalHeight;
      // Only step-down if source is more than 2× the target dimension
      if (sW <= targetW * 2 && sH <= targetH * 2) return img;
      var cur = img;
      while (sW > targetW * 2 || sH > targetH * 2) {
        var nW = Math.max(Math.round(sW / 2), targetW);
        var nH = Math.max(Math.round(sH / 2), targetH);
        var step = document.createElement("canvas");
        step.width = nW; step.height = nH;
        var sCtx = step.getContext("2d");
        sCtx.imageSmoothingEnabled = true;
        sCtx.imageSmoothingQuality = "high";
        sCtx.drawImage(cur, 0, 0, nW, nH);
        cur = step;
        sW = nW; sH = nH;
      }
      return cur;
    }

    // object-fit:cover + pan/zoom/rotation into a clipped destination rect
    function drawFit(ctx, img, dx, dy, dw, dh, panX, panY, zoom, rotDeg) {
      panX = panX || 0; panY = panY || 0; zoom = zoom || 1; rotDeg = rotDeg || 0;
      var iA = img.naturalWidth / img.naturalHeight;
      var fA = dw / dh;
      var sw, sh;
      if (iA > fA) { sh = dh; sw = sh * iA; } else { sw = dw; sh = sw / iA; }
      // Pre-downsample large source photos for clean anti-aliasing
      var src = _downsampleImg(img, Math.round(sw), Math.round(sh));
      ctx.save();
      _setHiQ(ctx);
      ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
      ctx.translate(dx + dw / 2 + panX, dy + dh / 2 + panY);
      if (rotDeg) ctx.rotate(rotDeg * Math.PI / 180);
      ctx.scale(zoom, zoom);
      ctx.drawImage(src, -sw / 2, -sh / 2, sw, sh);
      ctx.restore();
    }

    // object-fit:cover + rotation-only (matches applyRotationAndCover)
    function drawRotFit(ctx, img, dx, dy, dw, dh, rotDeg) {
      rotDeg = rotDeg || 0;
      var swapped = (Math.abs(Math.round(rotDeg) % 180) === 90);
      var iW = img.naturalWidth, iH = img.naturalHeight;
      var effW = swapped ? iH : iW, effH = swapped ? iW : iH;
      var iA = effW / effH, fA = dw / dh;
      var sw, sh;
      if (iA > fA) { sh = dh; sw = sh * iA; } else { sw = dw; sh = sw / iA; }
      var es = swapped ? Math.max(dw / dh, dh / dw) : 1;
      // Pre-downsample large source photos for clean anti-aliasing
      var src = _downsampleImg(img, Math.round(sw), Math.round(sh));
      ctx.save();
      _setHiQ(ctx);
      ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
      ctx.translate(dx + dw / 2, dy + dh / 2);
      if (rotDeg) ctx.rotate(rotDeg * Math.PI / 180);
      if (es !== 1) ctx.scale(es, es);
      ctx.drawImage(src, -sw / 2, -sh / 2, sw, sh);
      ctx.restore();
    }

    // Build a styled SVG string from a map object (fill/stroke/opacity applied)
    function styledSvg(obj) {
      // Builds a CLEAN, minimal SVG for canvas/PDF rendering.
      //
      // Raw SVG map files contain non-standard namespace declarations
      // (xmlns:mapsvg, xmlns:dc, xmlns:rdf, xmlns:sodipodi, etc.) and embedded
      // <metadata>/<defs> blocks. When serialised and loaded as a blob/data URL
      // on a <canvas>, most browsers silently refuse to paint them → maps invisible.
      //
      // This function builds the SVG from scratch with:
      //   • Only xmlns="http://www.w3.org/2000/svg" (no custom namespaces)
      //   • Only <path> elements with fill/stroke applied as attributes
      //   • A proper <defs><filter> when showOutline is active (morphology ring)
      //   • No metadata, no vector-effect (stroke-width recalibrated in drawSvgObj)
      //
      // showOutline + transparentFill ("outline only, hollow interior"):
      //   Paths keep the fill colour (not "none") so SVG SourceAlpha has a
      //   silhouette to dilate. The hollow-centre filter output hides the fill
      //   visually and shows only the outer ring.
      //
      // hideProvinces + transparentFill (no provinces, hollow):
      //   Province strokes are hidden (stroke = fill). Visibility comes from
      //   showOutline; without it the map is intentionally transparent.
      try {
        var doc = new DOMParser().parseFromString(obj.svg || "", "image/svg+xml");
        var svgEl = doc.querySelector("svg");
        if (!svgEl) return obj.svg || "";

        // ── Resolve viewBox ─────────────────────────────────────────────────
        var vb = svgEl.getAttribute("viewBox");
        if (!vb) {
          var vw = svgEl.getAttribute("width"), vh = svgEl.getAttribute("height");
          if (vw && vh) vb = "0 0 " + parseFloat(vw) + " " + parseFloat(vh);
        }

        var opacity     = (obj.opacity != null) ? String(obj.opacity) : "1";
        var baseFill    = obj.fill   || "#d9d9d9";
        var strokeColor = obj.stroke || "#111111";
        var sw          = Math.max(0.5, parseFloat(obj.strokeWidth || 1.2));

        // When showOutline + transparentFill: SourceAlpha needs a real fill to
        // capture the silhouette; the filter hides the fill visually.
        var fill = (obj.transparentFill && !obj.showOutline) ? "none" : baseFill;

        // Province strokes: when hideProvinces, make stroke = fill so internal
        // borders blend away. When fill is "none" (and no showOutline), this
        // results in an intentionally invisible map.
        var stroke      = obj.hideProvinces ? fill : strokeColor;
        var strokeWidth = obj.hideProvinces ? "1"  : String(sw);
        var dasharray   = (!obj.hideProvinces && obj.strokeDasharray) ? String(obj.strokeDasharray) : null;

        // ── showOutline: morphology-based outer-silhouette filter ───────────
        // Mirrors dmbEnsureOutlineFilter() used in the builder DOM.
        // radius is in SVG user-units — drawSvgObj will recalibrate it via
        // the same scaledSW logic it uses for path stroke-width.
        var filterDefs   = "";
        var groupFilter  = "";
        if (obj.showOutline) {
          var filterId  = (obj.filterId || "dmbOF_pdf").replace(/[^a-zA-Z0-9_-]/g, "_");
          var hollow    = !!obj.transparentFill;
          var filterBody =
              '<feMorphology operator="dilate" radius="' + sw + '" in="SourceAlpha" result="dilated"/>'
            + '<feComposite in="dilated" in2="SourceAlpha" operator="out" result="ring"/>'
            + '<feFlood flood-color="' + strokeColor + '" result="color"/>'
            + '<feComposite in="color" in2="ring" operator="in" result="coloredRing"/>';

          if (hollow) {
            // Output: outer ring only — interior remains transparent
            filterBody += '<feComposite in="coloredRing" in2="SourceAlpha" operator="out"/>';
          } else {
            // Output: original content + outer ring drawn on top
            filterBody += '<feMerge>'
              + '<feMergeNode in="SourceGraphic"/>'
              + '<feMergeNode in="coloredRing"/>'
              + '</feMerge>';
          }

          filterDefs  = '<defs>'
            + '<filter id="' + filterId + '" x="-20%" y="-20%" width="140%" height="140%">'
            + filterBody + '</filter></defs>';
          groupFilter = ' filter="url(#' + filterId + ')"';
        }

        // ── Paths ───────────────────────────────────────────────────────────
        var paths = [];
        svgEl.querySelectorAll("path").forEach(function(p) {
          var d = p.getAttribute("d");
          if (!d) return;
          var a = 'd="' + d.replace(/"/g, "&quot;") + '"'
            + ' fill="' + fill + '"'
            + ' stroke="' + stroke + '"'
            + ' stroke-width="' + strokeWidth + '"';
          if (dasharray) a += ' stroke-dasharray="' + dasharray + '"';
          paths.push('<path ' + a + '/>');
        });

        return '<svg xmlns="http://www.w3.org/2000/svg"'
          + (vb ? ' viewBox="' + vb + '"' : '')
          + ' opacity="' + opacity + '">'
          + filterDefs
          + '<g' + groupFilter + '>' + paths.join("") + '</g>'
          + '</svg>';
      } catch(e) { return obj.svg || ""; }
    }

    async function drawSvgObj(ctx, obj, dx, dy, dw, dh) {
      var markup = styledSvg(obj);
      // styledSvg sets vector-effect="non-scaling-stroke" — correct for the
      // builder (always 1.2px on screen) but UNRELIABLE when SVG is loaded as
      // an external image (browsers silently ignore vector-effect in that context).
      // Result: stroke scales by viewBoxWidth/renderWidth. Geographic SVGs have
      // large viewBox coordinates → stroke → 0px → map completely invisible.
      //
      // FIX: parse the SVG viewBox, remove vector-effect from all paths, and
      // recompute stroke-width in SVG user-units so the stroke renders as exactly
      // TARGET_STROKE_PX pixels in the intermediate bitmap — regardless of viewBox.
      // ctx.drawImage then upscales to the PDF canvas size, giving a clearly
      // visible ~5–8px border line at print resolution.

      var builderW = Math.max(100, obj.w || 200);
      var builderH = Math.max(100, obj.h || 200);
      var renderW  = Math.round(builderW * 2);  // intermediate bitmap width
      var renderH  = Math.round(builderH * 2);  // intermediate bitmap height

      try {
        var tmpDoc = new DOMParser().parseFromString(markup, "image/svg+xml");
        var tmpSvg = tmpDoc.querySelector("svg");
        if (tmpSvg) {
          // ── Set explicit bitmap dimensions ──────────────────────────────
          tmpSvg.setAttribute("width",  String(renderW));
          tmpSvg.setAttribute("height", String(renderH));

          // ── Compute viewBox-aware stroke width ─────────────────────────
          // In the builder, vector-effect:non-scaling-stroke makes the stroke
          // always appear as exactly obj.strokeWidth CSS pixels regardless of
          // zoom.  For the PDF we must convert that pixel value to SVG user
          // units at the intermediate bitmap resolution.
          //
          // Formula:
          //   builderW pixels wide ↔ vbW SVG user units
          //   → 1 SVG unit = builderW/vbW px in the builder
          //   → user wants userSW px → in SVG units = userSW * (vbW / builderW)
          //
          // renderW = builderW * 2, so the render is 2× the builder size and
          // the stroke appears 2× larger in the bitmap — ctx.drawImage then
          // scales it down proportionally when drawing onto the PDF canvas.
          var vbStr   = tmpSvg.getAttribute("viewBox") || "";
          var vbParts = vbStr.trim().split(/[\s,]+/);
          // viewBox = "minX minY width height" → width is index 2
          var vbW        = (vbParts.length >= 3) ? (parseFloat(vbParts[2]) || renderW) : renderW;
          var svgPxScale = renderW / vbW; // how many px per SVG user unit
          // User's intended stroke width in builder CSS pixels
          var userSW   = Math.max(0.5, parseFloat(obj.strokeWidth || 1.2));
          // Convert to SVG user units so it renders proportionally in the PDF
          var scaledSW = userSW * vbW / Math.max(1, builderW);

          tmpSvg.querySelectorAll("path").forEach(function(p) {
            // Remove vector-effect — it's ignored in external-image context
            // and causes unpredictable stroke scaling
            p.removeAttribute("vector-effect");
            // Apply viewBox-calibrated stroke width (skip if stroke already none)
            if (p.getAttribute("stroke") !== "none") {
              p.setAttribute("stroke-width", String(scaledSW.toFixed(4)));
            }
          });
          // Also calibrate the showOutline filter's morphology radius so the
          // outline ring is as thick as a normal stroke at this viewBox scale.
          tmpSvg.querySelectorAll("feMorphology").forEach(function(fe) {
            fe.setAttribute("radius", String(scaledSW.toFixed(4)));
          });

          markup = new XMLSerializer().serializeToString(tmpSvg);
        }
      } catch(e) {}

      // ── Three rendering paths (all draw at renderW×renderH,
      //    ctx.drawImage upscales to the final dw×dh on the PDF canvas) ──────
      var _mapName = (obj && obj.name) || 'map';

      // Path 1: createImageBitmap — fastest; may fail for complex SVGs.
      try {
        var svgBlob1 = new Blob([markup], { type: "image/svg+xml" });
        var bitmap   = await createImageBitmap(svgBlob1, {
          resizeWidth:  renderW,
          resizeHeight: renderH
        });
        ctx.save(); ctx.drawImage(bitmap, dx, dy, dw, dh); ctx.restore();
        return;
      } catch(e1) { /* fall through */ }

      // Path 2: Blob URL + <img> — reliable fallback. Always revoke the URL.
      try {
        var svgBlob2 = new Blob([markup], { type: "image/svg+xml" });
        var blobUrl  = URL.createObjectURL(svgBlob2);
        try {
          var blobImg = await loadImg(blobUrl);
          ctx.save(); ctx.drawImage(blobImg, dx, dy, dw, dh); ctx.restore();
          return;
        } finally {
          URL.revokeObjectURL(blobUrl);
        }
      } catch(e2) { /* fall through */ }

      // Path 3: base64 data URL — last resort (avoids URL-encoding issues).
      try {
        var b64     = btoa(unescape(encodeURIComponent(markup)));
        var dataUrl = "data:image/svg+xml;base64," + b64;
        var dataImg = await loadImg(dataUrl);
        ctx.save(); ctx.drawImage(dataImg, dx, dy, dw, dh); ctx.restore();
      } catch(e3) {
        console.error('[DMB] Map "' + _mapName + '" failed all 3 render paths:', e3.message || e3);
      }
    }

    // Render free objects (stickers / maps / photo-frames) onto ctx
    async function drawFreeObjs(ctx, objects, scale) {
      if (!Array.isArray(objects)) return;
      var sorted = objects.slice().sort(function(a, b) { return (a.z || 0) - (b.z || 0); });
      for (var i = 0; i < sorted.length; i++) {
        var obj = sorted[i];
        if (!obj || !obj.type) continue;
        var ox = (obj.x || 0) * scale;
        var oy = (obj.y || 0) * scale;
        var ow = (obj.w || 100) * scale;
        var oh = (obj.h || 100) * scale;
        var rotDeg = obj.rotation || 0;
        try {
          ctx.save();
          // ── Contain-to-page PDF clip ──────────────────────────────────────
          // CSS clip-path only works in the browser — the canvas needs its own
          // clip rect. For cover items with obj.contained, clip the drawing to
          // the zone/spread boundary in the SPREAD canvas coordinate system
          // (before the item's own transforms are applied).
          if (obj.contained && obj.coverZone) {
            var _cFPS  = FACE_PX  * scale;
            var _cSPS  = SPINE_PX * scale;
            // Magazine has no spine — front starts at FACE_PX (300), books at COVER_FRONT_X (322)
            var _cFXS  = (window.DMB_MAGAZINE_MODE ? FACE_PX : COVER_FRONT_X) * scale;
            var _cCL, _cCR;
            if (obj.contained === 2) {
              _cCL = 0;
              _cCR = (window.DMB_MAGAZINE_MODE ? FACE_PX * 2 : FACE_PX * 2 + SPINE_PX) * scale;
            } else {
              if (obj.coverZone === "back")       { _cCL = 0;      _cCR = _cFPS; }
              else if (obj.coverZone === "spine") { _cCL = _cFPS;  _cCR = _cFPS + _cSPS; }
              else /* front */                    { _cCL = _cFXS;  _cCR = _cFXS + _cFPS; }
            }
            ctx.beginPath();
            ctx.rect(_cCL, 0, _cCR - _cCL, FACE_OUT_H);
            ctx.clip();
          }
          ctx.translate(ox + ow / 2, oy + oh / 2);
          if (rotDeg) ctx.rotate(rotDeg * Math.PI / 180);
          ctx.translate(-ow / 2, -oh / 2);
          if (obj.type === "sticker" && (obj.tightUrl || obj.url)) {
            if (obj.tightUrl) {
              // Pre-cropped data URL — no CORS issues, use it directly
              const stickerImg = await loadImg(obj.tightUrl);
              ctx.drawImage(stickerImg, 0, 0, ow, oh);
            } else {
              // Older sticker without tightUrl: fetch via XHR to get a fresh CORS response
              // and avoid canvas tainting from the browser's non-CORS thumbnail cache
              const corsUrl = await (async () => {
                try {
                  const resp = await fetch(obj.url, { mode: "cors", cache: "no-store" });
                  const blob = await resp.blob();
                  return URL.createObjectURL(blob);
                } catch(fe) { return obj.url; }
              })();
              const stickerImg = await loadImg(corsUrl);
              if (corsUrl.startsWith("blob:")) URL.revokeObjectURL(corsUrl);
              if (obj.cropX !== undefined && obj.cropW) {
                ctx.drawImage(stickerImg, obj.cropX, obj.cropY, obj.cropW, obj.cropH, 0, 0, ow, oh);
              } else {
                ctx.drawImage(stickerImg, 0, 0, ow, oh);
              }
            }
          } else if (obj.type === "mag-icon" && obj.iconId) {
            try {
              const iconUrl = dmbMagIconUrl(obj.iconId);
              const corsUrl = await (async () => {
                try {
                  const resp = await fetch(iconUrl, { mode: "cors", cache: "no-store" });
                  const blob = await resp.blob();
                  return URL.createObjectURL(blob);
                } catch(fe) { return iconUrl; }
              })();
              const iconImg = await loadImg(corsUrl);
              if (corsUrl.startsWith("blob:")) URL.revokeObjectURL(corsUrl);
              const tmpC = document.createElement("canvas");
              tmpC.width = ow; tmpC.height = oh;
              const tmpX = tmpC.getContext("2d");
              tmpX.drawImage(iconImg, 0, 0, ow, oh);
              tmpX.globalCompositeOperation = "source-in";
              tmpX.fillStyle = obj.color || "#000000";
              tmpX.fillRect(0, 0, ow, oh);
              ctx.drawImage(tmpC, 0, 0, ow, oh);
            } catch(iconErr) {}
          } else if (obj.type === "map" && obj.svg) {
            await drawSvgObj(ctx, obj, 0, 0, ow, oh);
            // Draw markers on top of the map SVG
            if (Array.isArray(obj.markers) && obj.markers.length > 0) {
              var mSize = Math.max(8, Math.min(ow, oh) * 0.07);
              obj.markers.forEach(function(md) {
                var mX = ((md.x || 0) / 100) * ow;
                var mY = ((md.y || 0) / 100) * oh;
                var mColor = md.color || "#e74c3c";
                var mType  = md.type  || "pin";
                ctx.save();
                if (mType === "dot") {
                  ctx.beginPath(); ctx.arc(mX, mY, mSize * 0.7, 0, Math.PI * 2);
                  ctx.fillStyle = mColor; ctx.fill();
                  ctx.strokeStyle = "#ffffff"; ctx.lineWidth = mSize * 0.2; ctx.stroke();
                } else if (mType === "pin") {
                  var pr = mSize * 0.85;
                  ctx.beginPath(); ctx.arc(mX, mY - mSize * 0.4, pr, 0, Math.PI * 2);
                  ctx.fillStyle = mColor; ctx.fill();
                  ctx.strokeStyle = "#ffffff"; ctx.lineWidth = mSize * 0.15; ctx.stroke();
                  ctx.beginPath();
                  ctx.moveTo(mX - pr * 0.6, mY - mSize * 0.4 + pr * 0.6);
                  ctx.lineTo(mX + pr * 0.6, mY - mSize * 0.4 + pr * 0.6);
                  ctx.lineTo(mX, mY + mSize * 0.9); ctx.closePath();
                  ctx.fillStyle = mColor; ctx.fill();
                  ctx.beginPath(); ctx.arc(mX, mY - mSize * 0.4, pr * 0.35, 0, Math.PI * 2);
                  ctx.fillStyle = "white"; ctx.fill();
                } else {
                  var mChar = mType === "heart" ? "♥" : "★";
                  ctx.font = "bold " + Math.round(mSize * 2) + "px serif";
                  ctx.fillStyle = mColor; ctx.textBaseline = "middle"; ctx.textAlign = "center";
                  ctx.shadowColor = "rgba(0,0,0,0.35)"; ctx.shadowBlur = mSize * 0.3;
                  ctx.fillText(mChar, mX, mY);
                  ctx.shadowBlur = 0;
                }
                ctx.restore();
              });
            }
          } else if (obj.type === "photo-frame" && obj.photoId) {
            var _ph = getPhotoById(obj.photoId);
            if (_ph) {
              if (obj.frameShape) applyCanvasFrameClip(ctx, obj.frameShape, ow, oh);
              drawFit(ctx, await loadImg(_ph.url), 0, 0, ow, oh);
            }
          } else if (obj.type === "shape") {
            // ── SHAPE PDF rendering ─────────────────────────────────────────
            // The generic transform above (translate-to-centre, rotate, translate-back)
            // has already been applied. drawShapeOnCanvas draws in 0..100 space
            // scaled to ow×oh. Opacity is applied via globalAlpha then reset.
            // WARNING: Do NOT move this block outside the try{}/catch() — ctx.save()
            // above must pair with ctx.restore() at line 11718.
            ctx.globalAlpha = (obj.opacity !== undefined && obj.opacity !== null) ? obj.opacity : 1;
            drawShapeOnCanvas(ctx, obj.shapeType || "rect", obj.fill || "#6366f1", obj.stroke || "transparent", obj.strokeWidth || 0, ow, oh, obj.cornerRadius);
            ctx.globalAlpha = 1;
          } else if (obj.type === "text" && obj.text) {
            // ══ TEXT PDF RENDERING — replicates HTML/CSS builder exactly ══════════
            //
            // The builder renders text as position:absolute divs with these properties:
            //   • padding: 2px 6px  → text content starts 6px from element left edge,
            //                          2px from element top edge
            //   • transform-origin: center center  → rotation around element CENTRE
            //   • white-space: pre  → ONLY \n splits lines, NO word-wrapping ever
            //   • line-height: normal ≈ 1.2× font-size (browser default)
            //   • transform: rotate(Rdeg)  → rotation stored in obj.rotate / obj.transform
            //   • transform: translate(-50%,-50%) → obj.left/top is VISUAL CENTRE,
            //                                        not top-left of element
            //
            // BUGS FIXED vs previous version:
            //   1. Line height changed 1.1 → 1.2 to match browser default
            //   2. Word-wrap removed (white-space:pre = \n only)
            //   3. Padding offset added (6px H, 2px V) to non-centred text
            //   4. Rotation anchor moved from top-left → element centre
            //   5. Centred text vertical offset: txFontSize/2 → txTotalH/2 (multi-line)
            //   6. Font quotes: single quotes → double quotes for canvas compatibility
            //   7. textDecoration underline drawn manually (canvas has no text-decoration)
            //   8. obj.width no longer falls back to parent width (fixed in savePageTextState)
            //
            // WARNING: ctx.restore() below undoes the generic translate+rotate applied at
            // the top of this for-loop. Do NOT collapse the restore/save pair — text uses
            // its own coordinate system (left/top) instead of the generic x/y.
            ctx.restore(); // undo generic object transform (translate-to-centre, rotate)
            ctx.save();
            // Force-load every custom font before drawing on canvas.
            // document.fonts.ready only waits for fonts already in the loading
            // queue — it does NOT trigger loads for fonts not yet used in the DOM.
            // If a font hasn't been rendered in a live element, canvas falls back
            // to a system font and both Preview and PDF show the wrong typeface.
            // document.fonts.load("weight size 'family'") forces the browser to
            // fetch and decode the font file regardless of DOM usage.
            try { await document.fonts.ready; } catch(e2) {}
            try {
              var _fontFamilies = [
                "900 28px 'Londrina Solid'", "normal 28px 'Aurelia'",
                "normal 28px 'Burbank Big Condensed'", "normal 28px 'White Garden Wide'",
                "normal 28px 'Vogue Moderne'", "normal 28px 'GFS Didot'",
                "normal 28px 'Prata'", "normal 28px 'Theano Didot'",
                "normal 28px 'Lindys Diner'", "normal 28px 'Chomsky'",
                "normal 28px 'Anton'", "normal 28px '70s Disco'",
                "normal 28px 'Geraldine'", "normal 28px 'Lemon Drops'",
                "normal 28px 'Mouldy Cheese'", "normal 28px 'Nature Beauty'",
                "normal 28px 'Super Maples'", "normal 28px 'The Heart of Everything'",
                "normal 28px 'Tomatoes'", "normal 28px 'Wedding Day'"
              ];
              await Promise.allSettled(_fontFamilies.map(function(f) {
                return document.fonts.load(f);
              }));
            } catch(e3) {}

            // ── Padding constants matching builder CSS "padding: 2px 6px" ──────
            var TX_PL = 6, TX_PT = 2; // horizontal pad (each side), vertical pad (each side)

            var txLeft    = parseFloat(obj.left || "0");
            var txTop     = parseFloat(obj.top  || "0");
            var txFontPx  = parseFloat(obj.fontSize || "28");
            var txFontSize = txFontPx * scale;

            // Font: replace ' with " so multi-word names work in canvas ctx.font
            var txFontFam = (obj.fontFamily || "sans-serif").replace(/'/g, '"');
            ctx.font      = (obj.fontWeight || "800") + " " + txFontSize + "px " + txFontFam;
            ctx.fillStyle  = obj.color || "#666";
            ctx.textBaseline = "top";
            ctx.textAlign    = "left"; // reset; set correctly per line below

            // ── Line height: match builder CSS "line-height: 1.1" exactly ──────
            // The previous value (1.2) was larger than the CSS value, so each
            // text box's content sat progressively lower in the PDF than in the
            // builder, causing stacked text boxes to appear increasingly mis-spaced.
            var txLineH = txFontSize * 1.1;

            // ── Half-leading offset ─────────────────────────────────────────────
            // CSS line-height: 1.1 distributes the 0.1×fontSize "leading" equally
            // above and below each glyph (half-leading = 0.05×fontSize).  The top
            // padding starts the LINE BOX at top+2, but the glyph itself is
            // 0.05×fontSize lower inside that box.  canvas textBaseline:"top" draws
            // at the em-square top (no half-leading), so we add it back so the first
            // visible glyph lands at the same pixel as in the browser.
            var txHalfLead = txFontSize * 0.05;

            // ── Lines: white-space:pre → ONLY explicit \n, never word-wrap ────
            // DO NOT add word-wrapping here — the builder never wraps at word boundaries.
            var txLines  = obj.text.split("\n");
            var txTotalH = txLines.length * txLineH; // total height of all lines

            // ── Width constraint (for alignment only, NOT wrapping) ──────────
            var txMaxW = (obj.width && parseFloat(obj.width) > 0)
              ? parseFloat(obj.width) * scale : 0;

            // ── Rotation: prefer obj.rotate dataset, override with transform string ──
            // Both are stored in degrees.
            var txRotD = parseFloat(obj.rotate || "0") || 0;
            if (obj.transform) {
              // FIX: regex handles scientific notation (e.g. "rotate(-2.84217e-14deg)")
              // so floating-point drift doesn't parse as "-2.84217" (a real rotation).
              var _txRotM = obj.transform.match(/rotate\(\s*(-?[\d.]+(?:[eE][+-]?\d+)?)/);
              if (_txRotM) txRotD = parseFloat(_txRotM[1]);
            }
            // Clamp near-zero float drift to exactly 0. Values like -2.84e-14 accumulate
            // from repeated rotate-then-unrotate operations and should use the simpler
            // non-rotated rendering path — not the rotated path with a ~0° rotation.
            if (Math.abs(txRotD) < 0.001) txRotD = 0;

            // ── Layout mode detection ─────────────────────────────────────────
            // txCentered: transform contains translate(-50%,-50%) so obj.left/top
            // is the VISUAL CENTRE of the element (not top-left of the box).
            var txCentered = !!(obj.transform && obj.transform.indexOf("translate(-50%") !== -1);

            // ── Natural content width = widest line (canvas coords) ─────────────
            // When obj.width is not set (txMaxW === 0), we still need a reference
            // width so that centre/right alignment works correctly across all lines.
            // Example: "our\nstory" centred → "story" is widest; "our" must be
            // centred WITHIN "story"'s width, not left-aligned at the same x.
            // txEffectiveW is the width used for alignment (explicit or natural).
            var txNaturalW = 0;
            txLines.forEach(function(l) {
              var w = ctx.measureText(l).width;
              if (w > txNaturalW) txNaturalW = w;
            });
            var txEffectiveW = txMaxW > 0 ? txMaxW : txNaturalW;

            // ── Helper: draw one line with correct alignment + optional underline ──
            // xOrigin: canvas-coord left edge of the content area
            // We always use ctx.textAlign = "left" and compute x manually so that
            // each line is independently centred/right-aligned within txEffectiveW.
            // This matches CSS text-align behaviour for multi-line text.
            function _txDrawLine(line, xOrigin, y) {
              var lw = ctx.measureText(line).width;
              var x;
              ctx.textAlign = "left"; // always draw left-to-right; we shift x ourselves
              if (obj.textAlign === "center") {
                // Centre this line within the content width
                x = xOrigin + (txEffectiveW - lw) / 2;
              } else if (obj.textAlign === "right") {
                // Right-align this line to the content width's right edge
                x = xOrigin + txEffectiveW - lw;
              } else {
                // Left-align (default)
                x = xOrigin;
              }
              ctx.fillText(line, x, y);
              // Underline: canvas has no text-decoration — draw a line manually
              if (obj.textDecoration && obj.textDecoration.indexOf("underline") !== -1) {
                ctx.save();
                ctx.strokeStyle = obj.color || "#666";
                ctx.lineWidth   = Math.max(1, txFontPx * scale * 0.06);
                ctx.beginPath();
                ctx.moveTo(x,      y + txFontSize * 1.05);
                ctx.lineTo(x + lw, y + txFontSize * 1.05);
                ctx.stroke();
                ctx.restore();
              }
            }

            if (txCentered) {
              // ── CENTRED LAYOUT ─────────────────────────────────────────────
              // obj.left/top is the VISUAL CENTRE of the element.
              // Translate canvas origin to that centre, apply any rotation, then
              // draw the whole text block centred on origin.
              //
              // Vertical: place line 0 at y = -(txTotalH/2), increment by txLineH.
              // FIX: previous code used txFontSize/2 instead of txTotalH/2,
              //      which misplaced multi-line blocks (all lines shifted down).
              ctx.translate(txLeft * scale, txTop * scale);
              if (txRotD) ctx.rotate(txRotD * Math.PI / 180);

              txLines.forEach(function(line, li) {
                var lw  = ctx.measureText(line).width;
                var y   = li * txLineH - txTotalH / 2;
                // Horizontal: always centre each line around origin (x = 0)
                ctx.textAlign = "center";
                ctx.fillText(line, 0, y);
                if (obj.textDecoration && obj.textDecoration.indexOf("underline") !== -1) {
                  ctx.save();
                  ctx.strokeStyle = obj.color || "#666";
                  ctx.lineWidth   = Math.max(1, txFontSize * 0.06);
                  ctx.beginPath();
                  ctx.moveTo(-lw / 2, y + txFontSize * 1.05);
                  ctx.lineTo( lw / 2, y + txFontSize * 1.05);
                  ctx.stroke();
                  ctx.restore();
                }
              });

            } else {
              // ── NORMAL LAYOUT (obj.left/top is element box top-left) ────────
              //
              // Builder: text content starts at (left + TX_PL, top + TX_PT) in page px.
              // FIX: previous code ignored padding → text appeared 6px left, 2px above
              //      where it should be.
              //
              // Rotation: CSS transform-origin is CENTER of element box, so rotation
              // anchor is (left + boxW/2, top + boxH/2) — NOT the top-left corner.
              // FIX: previous code rotated around (left, top) which caused rotated
              //      text to appear in the wrong position.

              // ── Element box dimensions for the rotation anchor ───────────────
              // CRITICAL for rotated text: the rotation anchor is the element CENTRE
              // (left + boxW/2, top + boxH/2). If boxW is estimated from canvas text
              // measurement it can differ from the browser's CSS rendering by 1–3px;
              // at 90° that error shifts the anchor visibly up/down in the PDF.
              //
              // FIX: prefer obj.boxWidth / obj.boxHeight saved from the real DOM
              // offsetWidth / offsetHeight at design time. Fall back to measurement.
              var _txBoxW, _txBoxH;
              if (obj.boxWidth && parseFloat(obj.boxWidth) > 0) {
                // Exact DOM width stored at save time — no measurement error
                _txBoxW = parseFloat(obj.boxWidth);
              } else {
                var _txCW = txMaxW > 0 ? txMaxW / scale : 0;
                if (_txCW === 0) {
                  txLines.forEach(function(l) {
                    var mw = ctx.measureText(l).width / scale;
                    if (mw > _txCW) _txCW = mw;
                  });
                }
                _txBoxW = _txCW + TX_PL * 2;
              }
              if (obj.boxHeight && parseFloat(obj.boxHeight) > 0) {
                _txBoxH = parseFloat(obj.boxHeight);
              } else {
                _txBoxH = txTotalH / scale + TX_PT * 2;
              }

              if (txRotD) {
                // ── Rotated non-centred text ──────────────────────────────────
                // 1. Translate to element centre
                // 2. Rotate (matches CSS transform-origin: center center)
                // 3. Draw text with offset from rotated centre back to content origin
                var _txCx = txLeft + _txBoxW / 2; // centre X in page px
                var _txCy = txTop  + _txBoxH / 2; // centre Y in page px
                ctx.translate(_txCx * scale, _txCy * scale);
                ctx.rotate(txRotD * Math.PI / 180);

                // Content origin relative to (now-rotated) element centre,
                // + half-leading so glyph lands at same pixel as in browser.
                var _rxOrigin = (-_txBoxW / 2 + TX_PL) * scale;
                var _ryOrigin = (-_txBoxH / 2 + TX_PT) * scale + txHalfLead;
                txLines.forEach(function(line, li) {
                  _txDrawLine(line, _rxOrigin, _ryOrigin + li * txLineH);
                });

              } else {
                // ── Non-rotated non-centred text ──────────────────────────────
                // Offset drawing origin by padding + half-leading to reach the
                // exact pixel where the browser places the first glyph.
                var _nxOrigin = (txLeft + TX_PL) * scale;
                var _nyOrigin = (txTop  + TX_PT) * scale + txHalfLead;
                txLines.forEach(function(line, li) {
                  _txDrawLine(line, _nxOrigin, _nyOrigin + li * txLineH);
                });
              }
            }
          }
          ctx.restore();
        } catch(e) { ctx.restore(); }
      }
    }

    // Encode canvas as JPEG and add as a PDF page.
    // Quality 0.96: near-maximum JPEG quality. Each decode→canvas→re-encode cycle
    // loses fidelity; 0.96 minimises that loss while keeping file size reasonable.
    // "NONE" disables jsPDF's own image compression (we handle it via toDataURL).
    function addCanvasPage(canvas, wMm, hMm) {
      var orient = hMm >= wMm ? "portrait" : "landscape";
      if (!pdf) pdf = new jsPDF({ unit: "mm", format: [wMm, hMm], orientation: orient, compress: true });
      else pdf.addPage([wMm, hMm], orient);
      pdf.addImage(canvas.toDataURL("image/jpeg", 0.96), "JPEG", 0, 0, wMm, hMm, undefined, "NONE");
    }

    // ── Cover spread ──────────────────────────────────────────────────
    async function renderCoverSpread() {
      var isMag = !!window.DMB_MAGAZINE_MODE;
      var spreadUiW = isMag ? FACE_PX * 2 : (FACE_PX * 2 + SPINE_PX);
      var spreadCvW = Math.round(spreadUiW * FACE_SCALE);
      var spreadCvH = FACE_OUT_H;
      var cc = mkCanvas(spreadCvW, spreadCvH);
      var ctx = cc.ctx;

      // Background
      ctx.fillStyle = coverState.color || "#ffffff";
      ctx.fillRect(0, 0, spreadCvW, spreadCvH);

      // ── Build cover object lists early so we can split below/above photos ──
      var _domZc = {};
      document.querySelectorAll("#coverOverlay [style*='z-index'], #coverOverlay [data-z]").forEach(function(el) {
        var z = parseInt(el.style.zIndex || el.dataset.z || "0", 10);
        if (el.id)               _domZc[el.id]               = z;
        if (el.dataset.objectId) _domZc[el.dataset.objectId] = z;
      });
      var _allCoverItems = (editor.coverObjects || []).map(function(o) {
        return Object.assign({}, o, { z: _domZc[o.id] !== undefined ? _domZc[o.id] : (o.z || 0) });
      });
      if (Array.isArray(editor.coverUserTexts)) {
        editor.coverUserTexts.forEach(function(entry) {
          var s = coverState.textStyles && coverState.textStyles[entry.id];
          if (!s || !s.text) return;
          var lStr = s.left || "0", tStr = s.top || "0";
          var lPx = lStr.endsWith("%") ? (parseFloat(lStr)/100) * spreadUiW : parseFloat(lStr);
          var tPx = tStr.endsWith("%") ? (parseFloat(tStr)/100) * FACE_H_PX  : parseFloat(tStr);
          // Convert width percentage to pixels if needed (same logic as left/top above).
          // WARNING: do NOT remove width — the textAlign toolbar sets node.style.width="220px"
          // so cover text with explicit centering would ignore that width without this.
          var wStr = s.width || "";
          var wPx = wStr.endsWith("%") ? (parseFloat(wStr) / 100) * FACE_PX : parseFloat(wStr) || 0;
          _allCoverItems.push({ type:"text", text:s.text, left:String(lPx), top:String(tPx),
            fontSize:s.fontSize||"28px", fontWeight:s.fontWeight||"800",
            color:s.color||"#666", fontFamily:s.fontFamily||"'Londrina Solid',sans-serif",
            textAlign:s.textAlign||"", textDecoration:s.textDecoration||"",
            transform:s.transform||"", rotate:s.rotate||"0",
            width: wPx > 0 ? String(wPx) : "",
            // Real DOM dimensions for pixel-accurate rotation anchor in PDF
            boxWidth:  s.boxWidth  || "",
            boxHeight: s.boxHeight || "",
            z: _domZc[entry.id] !== undefined ? _domZc[entry.id] : Number(s.z || 0)
          });
        });
      }
      var _belowCover = _allCoverItems.filter(function(o){ return (o.z||0) < 1; });
      var _aboveCover = _allCoverItems.filter(function(o){ return (o.z||0) >= 1; });

      // Draw objects that are BEHIND photos first
      try { if (_belowCover.length) await drawFreeObjs(ctx, _belowCover, FACE_SCALE); } catch(e) {}

      // Front cover background image (from coverImageInput upload)
      if (coverState.imageUrl) {
        try {
          var frontX = (isMag ? FACE_PX : FACE_PX + SPINE_PX) * FACE_SCALE;
          drawFit(ctx, await loadImg(coverState.imageUrl), frontX, 0, FACE_PX * FACE_SCALE, spreadCvH);
        } catch(e) {}
      }

      // Front cover dragged photo (drag-and-drop from photo grid onto front face)
      if (coverState.frontImageUrl) {
        try {
          var frontFaceX = (isMag ? FACE_PX : FACE_PX + SPINE_PX) * FACE_SCALE;
          drawFit(ctx, await loadImg(coverState.frontImageUrl), frontFaceX, 0, FACE_PX * FACE_SCALE, spreadCvH);
        } catch(e) {}
      }

      // Back cover dragged photo (drag-and-drop from photo grid onto back face)
      if (coverState.backImageUrl) {
        try {
          drawFit(ctx, await loadImg(coverState.backImageUrl), 0, 0, FACE_PX * FACE_SCALE, spreadCvH);
        } catch(e) {}
      }

      // Seamless bleed photo spanning multiple cover zones
      if (coverState.bleedImageUrl && coverState.bleedZone) {
        try {
          var _bleedZones = {
            "spine-back":  { dx: 0,                              dw: (FACE_PX + SPINE_PX) * FACE_SCALE },
            "full":        { dx: 0,                              dw: spreadCvW },
            "front-spine": { dx: FACE_PX * FACE_SCALE,           dw: (SPINE_PX + FACE_PX) * FACE_SCALE }
          };
          var _bpz = _bleedZones[coverState.bleedZone];
          if (_bpz) {
            drawFit(ctx, await loadImg(coverState.bleedImageUrl),
              _bpz.dx, 0, _bpz.dw, spreadCvH,
              0, 0, 1, coverState.bleedImageRot || 0);
          }
        } catch(e) {}
      }

      // Draw photo grid layout frames on front cover
      if (coverState.frontLayout) {
        var frontLayoutDefs = TEMPLATE_DEFS[coverState.frontLayout] || [];
        var frontFaceX = (isMag ? FACE_PX : FACE_PX + SPINE_PX) * FACE_SCALE;
        for (var cfi = 0; cfi < frontLayoutDefs.length; cfi++) {
          var cff = frontLayoutDefs[cfi];
          var cfpid = coverState.frontFrames && coverState.frontFrames[cff.key];
          if (!cfpid) continue;
          try {
            var cfph = getPhotoById(cfpid);
            if (!cfph) continue;
            var cfrot = (coverState.frontFrameRot && coverState.frontFrameRot[cff.key]) || 0;
            drawRotFit(ctx, await loadImg(cfph.url),
              frontFaceX + (cff.x / 100) * FACE_PX * FACE_SCALE,
              (cff.y / 100) * FACE_OUT_H,
              (cff.w / 100) * FACE_PX * FACE_SCALE,
              (cff.h / 100) * FACE_OUT_H, cfrot);
          } catch(e) {}
        }
      }

      // Draw photo grid layout frames on back cover
      if (coverState.backLayout) {
        var backLayoutDefs = TEMPLATE_DEFS[coverState.backLayout] || [];
        for (var cbi = 0; cbi < backLayoutDefs.length; cbi++) {
          var cbf = backLayoutDefs[cbi];
          var cbpid = coverState.backFrames && coverState.backFrames[cbf.key];
          if (!cbpid) continue;
          try {
            var cbph = getPhotoById(cbpid);
            if (!cbph) continue;
            var cbrot = (coverState.backFrameRot && coverState.backFrameRot[cbf.key]) || 0;
            drawRotFit(ctx, await loadImg(cbph.url),
              (cbf.x / 100) * FACE_PX * FACE_SCALE,
              (cbf.y / 100) * FACE_OUT_H,
              (cbf.w / 100) * FACE_PX * FACE_SCALE,
              (cbf.h / 100) * FACE_OUT_H, cbrot);
          } catch(e) {}
        }
      }

      // Draw objects that are IN FRONT of photos (z >= 1)
      try { await drawFreeObjs(ctx, _aboveCover, FACE_SCALE); } catch(e) {}

      // Logo watermark on back cover — drawn last so it is always above all objects
      if (window.DMB_LOGO_URL) {
        try {
          var logoImg = await loadImg(window.DMB_LOGO_URL);
          var logoW = 90 * FACE_SCALE;
          var logoH = logoW * (logoImg.naturalHeight / (logoImg.naturalWidth || 1));
          var logoX = (FACE_PX - 18.75 - 90) * FACE_SCALE;
          var logoY = FACE_OUT_H - FACE_H_PX * 0.015625 * FACE_SCALE - logoH;
          ctx.save(); ctx.globalAlpha = 0.85;
          ctx.drawImage(logoImg, logoX, logoY, logoW, logoH);
          ctx.restore();
        } catch(e) {}
      }

      return cc.canvas;
    }

    // Crop a zone from the cover spread canvas
    function cropCoverZone(spreadCanvas, zone) {
      var isMag = !!window.DMB_MAGAZINE_MODE;
      var bw = Math.round(FACE_PX * FACE_SCALE);
      var sw = Math.round(SPINE_PX * FACE_SCALE);
      var h  = spreadCanvas.height;
      var sx, cw;
      if (zone === "back")        { sx = 0;             cw = bw; }
      else if (zone === "spine")  { sx = bw;            cw = sw; }
      else /* front */            { sx = isMag ? bw : bw + sw; cw = bw; }
      var cc = mkCanvas(cw, h);
      cc.ctx.drawImage(spreadCanvas, sx, 0, cw, h, 0, 0, cw, h);
      return cc.canvas;
    }

    // ── Page rendering ──────────────────────────────────────────────────────
    async function renderPage(pageNumber, side) {
      var cc  = mkCanvas(OUT_W, OUT_H);
      var ctx = cc.ctx;

      // ── Per-page background colour ────────────────────────────────────────
      // mkCanvas fills with white by default. If the customer chose a custom
      // background colour for this page, fill the canvas with it now so it
      // shows under photos and all objects.
      var _bgColor = editor.pageBackgrounds?.[pageNumber];
      if (_bgColor && _bgColor.toLowerCase() !== "#ffffff") {
        ctx.fillStyle = _bgColor;
        ctx.fillRect(0, 0, OUT_W, OUT_H);
      }

      // Helper: get free objects for this page (try both numeric and string key)
      function getPageFreeObjs(pn) {
        if (!editor.pageObjects) return [];
        var objs = editor.pageObjects[pn] || editor.pageObjects[String(pn)] || [];
        return Array.isArray(objs) ? objs : [];
      }

      // Page 0 (the special inner-cover page) uses the same full rendering path
      // as every other page — it handles templates, slot photos with rotation,
      // spread photos, template frames, and the z-order split (below/above photos).
      // The old simplified page-0 handler was missing all of those features,
      // which caused slot photos to not appear when rotation was applied, and
      // template-frame photos to never appear in the PDF.

      if (isLockedPage(pageNumber)) {
        try { await drawFreeObjs(ctx, getPageFreeObjs(pageNumber), PAGE_SCALE); } catch(e) {}
        return cc.canvas;
      }

      var si         = Math.floor((pageNumber - 1) / 2);
      var isLeft     = (side === "L");
      var sp         = editor.spreadPhoto && editor.spreadPhoto[si];
      var templateId = getPageTemplateId(pageNumber);
      var _spreadRendered = false;

      // ── Spread photo ──
      if (sp && sp.photoId) {
        try {
          var sph = getPhotoById(sp.photoId);
          if (sph) {
            var sImg  = await loadImg(sph.url);
            var spW   = OUT_W * 2;
            var spH   = OUT_H;
            var offX  = isLeft ? 0 : -OUT_W;
            var spIA  = sImg.naturalWidth / sImg.naturalHeight;
            var spFA  = spW / spH;
            var spSW, spSH;
            if (spIA > spFA) { spSH = spH; spSW = spSH * spIA; } else { spSW = spW; spSH = spSW / spIA; }
            var sPanX   = (sp.panX || 0) * PAGE_SCALE;
            var sPanY   = (sp.panY || 0) * PAGE_SCALE;
            var sZoom   = sp.zoom || 1;
            var sRotDeg = sp.rotation || 0;
            ctx.save();
            ctx.beginPath(); ctx.rect(0, 0, OUT_W, OUT_H); ctx.clip();
            ctx.translate(spW / 2 + offX + sPanX, spH / 2 + sPanY);
            if (sRotDeg) ctx.rotate(sRotDeg * Math.PI / 180);
            ctx.scale(sZoom, sZoom);
            ctx.drawImage(sImg, -spSW / 2, -spSH / 2, spSW, spSH);
            ctx.restore();
            _spreadRendered = true;
          }
        } catch(e) {}
      }

      // ── Z-ORDER FIX: split free objects around the photo layer ─────────
      // Photos (makePlacedImageBox) use z-index 1 in the builder.
      // "Send backward" (⬇ Back button) sets obj.z = 0, so those objects must
      // be drawn on canvas BEFORE photos to appear behind them in the PDF.
      // Objects with z≥1 (default and "bring forward") are drawn AFTER photos.
      // DO NOT merge _belowObjs and _aboveObjs into a single drawFreeObjs call.
      var _freeObjsAll = getPageFreeObjs(pageNumber);
      var _belowObjs   = _freeObjsAll.filter(function(o){ return (o.z || 0) < 1; }); // behind photos
      var _aboveObjs   = _freeObjsAll.filter(function(o){ return (o.z || 0) >= 1; }); // above photos
      try { if (_belowObjs.length) await drawFreeObjs(ctx, _belowObjs, PAGE_SCALE); } catch(e) {}

      // ── Template layout ──
      if (templateId) {
        var defs  = TEMPLATE_DEFS[templateId] || [];
        var slotA = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].A;
        var slotB = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].B;
        if (slotA) {
          try {
            var phA = getPhotoById(slotA);
            if (phA) drawRotFit(ctx, await loadImg(phA.url), 0, 0, OUT_W,
              slotB ? OUT_H / 2 : OUT_H,
              (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].A) || 0);
          } catch(e) {}
        }
        if (slotB) {
          try {
            var phB = getPhotoById(slotB);
            if (phB) drawRotFit(ctx, await loadImg(phB.url), 0, OUT_H / 2, OUT_W, OUT_H / 2,
              (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].B) || 0);
          } catch(e) {}
        }
        for (var di = 0; di < defs.length; di++) {
          var f    = defs[di];
          var fpid = editor.pageFrames && editor.pageFrames[pageNumber] && editor.pageFrames[pageNumber][f.key];
          if (!fpid) continue;
          try {
            var fph  = getPhotoById(fpid);
            if (!fph) continue;
            var frot = (editor.pageFrameRot && editor.pageFrameRot[pageNumber] && editor.pageFrameRot[pageNumber][f.key]) || 0;
            drawRotFit(ctx, await loadImg(fph.url),
              (f.x / 100) * OUT_W, (f.y / 100) * OUT_H,
              (f.w / 100) * OUT_W, (f.h / 100) * OUT_H, frot);
          } catch(e) {}
        }
      } else if (!_spreadRendered) {
        // ── Default A/B slot layout ──
        var A = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].A;
        var B = editor.pageSlots && editor.pageSlots[pageNumber] && editor.pageSlots[pageNumber].B;
        if (A) {
          try {
            var pA = getPhotoById(A);
            if (pA) drawRotFit(ctx, await loadImg(pA.url), 0, 0, OUT_W,
              B ? OUT_H / 2 : OUT_H,
              (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].A) || 0);
          } catch(e) {}
        }
        if (B) {
          try {
            var pB = getPhotoById(B);
            if (pB) drawRotFit(ctx, await loadImg(pB.url), 0, OUT_H / 2, OUT_W, OUT_H / 2,
              (editor.pageRot && editor.pageRot[pageNumber] && editor.pageRot[pageNumber].B) || 0);
          } catch(e) {}
        }
      }

      // ── Objects "above photos" (z >= 1) drawn AFTER photos ──
      try { if (_aboveObjs.length) await drawFreeObjs(ctx, _aboveObjs, PAGE_SCALE); } catch(e) {}
      return cc.canvas;
    }

    // ── Preview mode: render one canvas and return early ─────────────────────
    // When _pvOpt is set we skip jsPDF entirely, render only the requested
    // page/cover, and hand the canvas(es) back via _pvOpt.resolve().
    if (_pvOpt) {
      try {
        if (_pvOpt.cover) {
          var _pvSpread = await renderCoverSpread();
          _pvOpt.resolve({
            back:  cropCoverZone(_pvSpread, "back"),
            spine: cropCoverZone(_pvSpread, "spine"),
            front: cropCoverZone(_pvSpread, "front"),
          });
        } else {
          var _pvPn   = _pvOpt.page;
          var _pvSide = (_pvPn === 0) ? "L" : (_pvPn % 2 === 0 ? "R" : "L");
          _pvOpt.resolve(await renderPage(_pvPn, _pvSide));
        }
      } catch(_pvErr) {
        if (typeof _pvOpt.reject === "function") _pvOpt.reject(_pvErr);
      }
      return;
    }

    // ── Build PDF ────────────────────────────────────────────────────────────
    // Total steps: 3 cover faces + page 0 + all book pages
    var _totalSteps = 3 + 1 + (editor.totalPages || 0);
    var _doneSteps  = 0;
    function _onPageDone() {
      _doneSteps++;
      if (typeof onProgress === "function") onProgress(_doneSteps, _totalSteps);
    }

    var coverSpread = await renderCoverSpread();
    addCanvasPage(cropCoverZone(coverSpread, "front"), A4_W_MM, A4_H_MM); _onPageDone();
    if (!window.DMB_MAGAZINE_MODE) { addCanvasPage(cropCoverZone(coverSpread, "spine"), SPINE_W_MM, A4_H_MM); _onPageDone(); }
    else _onPageDone(); // spine not added for magazines but keep step count consistent
    addCanvasPage(cropCoverZone(coverSpread, "back"),  A4_W_MM, A4_H_MM); _onPageDone();

    // Page 0 (special page before page 1)
    addCanvasPage(await renderPage(0, "L"), A4_W_MM, A4_H_MM); _onPageDone();

    for (var p = 1; p <= (editor.totalPages || 0); p++) {
      addCanvasPage(await renderPage(p, p % 2 === 0 ? "R" : "L"), A4_W_MM, A4_H_MM);
      _onPageDone();
    }

    if (!pdf) throw new Error("No pages were rendered — check that pages are selected.");
    return pdf.output("blob");
  }

  // ─── End PDF generation ────────────────────────────────────────────────

  async function addDesignedBookToCart() {
    const pagesSelected = String(pagesEl?.value || "");
    const variantId = getDmbVariantIdByPages(pagesSelected);

    if (!variantId) {
      alert("Please select the number of pages before adding to cart.");
      return;
    }

    const titleOk = !!getEffectiveBookTitle();
    if (!titleOk) {
      alert("Please add at least one text to the cover before adding to cart.");
      return;
    }

    // NOTE: Minimum photo check is enforced at the upload step (continueToBuilderBtn
    // and tryAutoOpenEditor), so no need to re-block here at cart time.

    const selectedCover = loadCoverFromStorage ? (loadCoverFromStorage() || null) : null;
    const _extraSpreads = editor.extraSpreads || 0;

    let properties = {
      "Book Title": getEffectiveBookTitle(),
      "Pages Selected": pagesSelected,
      "Extra Spreads": String(_extraSpreads),
      "Total Pages": String(editor?.totalPages || Number(pagesSelected)),
      "Editable Pages": String(editor?.editablePages ?? (Number(pagesSelected) - 1)),
      "Mode": mode === "customize" ? "customize" : "collection",
      "Selected Cover": selectedCover?.title || selectedCover?.handle || selectedCover?.name || "",
      "Photos Uploaded": String(Array.isArray(bookFiles) ? bookFiles.length : (editor?.photos?.length || 0)),
      "Special Page Text": String(SPECIAL_PAGE_TEXT || ""),
      "Design Version": "DMB v1",
      "Cover Template": coverState.template || "default",
      "Cover Title 1": coverState.title1 || "",
      "Cover Title 2": coverState.title2 || "",
      "Cover Color": coverState.color || "#ffffff"
    };

    try {
      properties["Layout JSON"] = JSON.stringify({
        page_slots: editor?.pageSlots || {},
        page_rot: editor?.pageRot || {},
        page_template: editor?.pageTemplate || {},
        page_frames: editor?.pageFrames || {},
        page_frame_rot: editor?.pageFrameRot || {},
        total_pages: editor?.totalPages || Number(pagesSelected) || 0,
        editable_pages: editor?.editablePages || Math.max(0, (Number(pagesSelected) || 0) - 1)
      });
    } catch {
      properties["Layout JSON"] = "Layout serialization failed";
    }

    const hiddenProps = {};
    Object.keys(properties).forEach((k) => {
      hiddenProps["_" + String(k).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "")] = properties[k];
    });

    hiddenProps["Design Summary"] =
      `${properties["Book Title"] || ""} • ${properties["Pages Selected"] || ""} pages • ${properties["Photos Uploaded"] || ""} photos`;

    properties = hiddenProps;

    const pdfOverlay = document.getElementById("dmbPdfOverlay");
    const pdfOverlayMsg = document.getElementById("dmbPdfOverlayMsg");
    const showPdfOverlay = (msg) => {
      if (pdfOverlayMsg) pdfOverlayMsg.textContent = msg;
      if (pdfOverlay) pdfOverlay.style.display = "flex";
    };
    const hidePdfOverlay = () => { if (pdfOverlay) pdfOverlay.style.display = "none"; };

    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = "Adding...";
    }

    showPdfOverlay("Generating your memories book...");
    // Show generation progress bar
    const _gProgWrap  = document.getElementById("dmbUploadProgressWrap");
    const _gProgBar   = document.getElementById("dmbUploadProgressBar");
    const _gProgLabel = document.getElementById("dmbUploadProgressLabel");
    const _gProgMsg   = document.getElementById("dmbPdfOverlayMsg");
    if (_gProgWrap) _gProgWrap.style.display = "block";
    function _onGenProgress(done, total) {
      const pct = Math.round((done / total) * 100);
      if (_gProgBar)   _gProgBar.style.width   = pct + "%";
      const _genMsgs = [
        "Bringing your memories to life… ✨",
        "Turning your photos into magic… 🌟",
        "Your story is taking shape… 📖",
        "Crafting something beautiful… 🎨",
        "Weaving your moments together… 🌸",
        "Every page tells a story… 💛",
        "Adding the finishing touches… 🎁",
        "Almost a masterpiece… 🖼️"
      ];
      if (_gProgLabel) _gProgLabel.textContent = _genMsgs[Math.floor((done / total) * (_genMsgs.length - 1))];
      if (_gProgMsg)   _gProgMsg.textContent   = "Creating your book… 💛";
    }

    // ── Step 1: Save the design BEFORE generating the PDF ─────────────────────
    // The design is persisted so the customer never loses their work regardless
    // of what happens next. It is only cleared after a confirmed successful
    // upload AND cart add. If anything fails, they can just press Add to Cart
    // again and their design is right there waiting.
    showPdfOverlay("Saving your design… 💾");
    try {
      if (saveMsg) saveMsg.style.display = "none";
      await saveCustomerProgress();
      if (saveMsg) saveMsg.style.display = "none";
      // Verify the save actually landed — saveCustomerProgress() silently returns
      // (no throw) when localStorage is full, so we can't rely on try/catch alone.
      const _saveKey = getCustomerSaveKey();
      const _verified = !!localStorage.getItem(_saveKey);
      if (!_verified) throw new Error("Design could not be saved (storage full). Please free up browser storage and try again.");
    } catch(saveErr) {
      hidePdfOverlay();
      alert(saveErr?.message || "Could not save your design. Please free up browser storage and try again.");
      if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.textContent = "Add to Cart"; }
      return;
    }

    try {
      // ── Step 2: Generate the PDF ─────────────────────────────────────────
      showPdfOverlay("Generating your memories book...");
      const pdfBlob = await buildPdfBlobOnePagePerBookPage(_onGenProgress);
      if (_gProgBar)   _gProgBar.style.width  = "100%";
      if (_gProgLabel) _gProgLabel.textContent = "Your book looks amazing! 🎉";

      // ── Step 3: Upload to Drive — MUST succeed before cart add ────────────
      // If this throws, we catch below, show an error, and leave the design
      // saved so the customer can simply press Add to Cart again.
      showPdfOverlay("Sending your book… 💛");
      const up = await uploadPdfToGoogleDrive(pdfBlob);
      properties["_pdf_view"]      = up.viewUrl;
      properties["_pdf_download"]  = up.downloadUrl;
      properties["_pdf_file_id"]   = up.id;

      // ── Step 4: Add to cart ───────────────────────────────────────────────────
      showPdfOverlay("Adding to cart...");
      const _cartItems = [{ id: variantId, quantity: 1, properties }];
      const _extraSpreadVid = window.DMB_EXTRA_SPREAD_VARIANT_ID;
      if (_extraSpreads > 0 && _extraSpreadVid) {
        _cartItems.push({ id: _extraSpreadVid, quantity: _extraSpreads });
      }

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: _cartItems })
      });

      if (!res.ok) {
        // Cart add failed — trash the Drive file we just uploaded so it doesn't
        // accumulate as an orphan. Customer's design is still saved; they retry
        // and a fresh upload + cart add will happen together.
        try {
          await postToScript({ action: "trash_file", fileId: up.id }, 2);
        } catch(te) { /* non-fatal — cleanupOldChunks will catch it eventually */ }
        let msg = "Failed to add to cart.";
        try { const err = await res.json(); msg = err?.description || err?.message || msg; } catch {}
        throw new Error(msg);
      }

      // ── Step 5: Everything succeeded — clear saved design ─────────────────
      try { await clearCustomerProgress(); } catch {}
      try {
        localStorage.setItem("design_my_book_last_added", JSON.stringify({
          added_at: new Date().toISOString(),
          pages_selected: pagesSelected,
          properties
        }));
      } catch {}

      window.location.href = "/";

    } catch (err) {
      // ── Any failure: hide overlay, show friendly message, re-enable button ──
      // The design is already saved (Step 1) so the customer can try again at
      // any time — their book will be exactly as they left it.
      hidePdfOverlay();
      const _msg = "Due to a connection issue your book could not be processed. It's saved in your Saved Books — please try again on a better Wi-Fi connection. 📶";

      // Show as a dismissible banner above the builder (not a blocking alert)
      const _errBanner = document.createElement("div");
      _errBanner.style.cssText = "position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:999999;background:#1e1e1e;color:#fff;border-radius:12px;padding:14px 20px;max-width:92vw;font-size:14px;font-weight:700;text-align:center;box-shadow:0 8px 30px rgba(0,0,0,.5);display:flex;align-items:center;gap:12px;";
      _errBanner.innerHTML = `<span>${_msg}</span><button type="button" style="background:#444;border:none;border-radius:8px;color:#fff;padding:6px 12px;cursor:pointer;font-size:13px;font-weight:900;flex-shrink:0;">OK</button>`;
      _errBanner.querySelector("button").onclick = () => _errBanner.remove();
      document.body.appendChild(_errBanner);
      setTimeout(() => { if (_errBanner.isConnected) _errBanner.remove(); }, 12000);

      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = "Add to Cart";
      }
    }
  }

  if (prevSpreadBtn) {
    prevSpreadBtn.addEventListener("click", () => {
      if (builderMode === "cover") {
        builderMode = "pages";
        editor.currentSpread = 0;
        renderBuilderCanvas();
        return;
      }

      if (editor.currentSpread > -1) {
        editor.currentSpread--;
        renderBuilderCanvas();
      }
    });
  }

  if (nextSpreadBtn) {
    nextSpreadBtn.addEventListener("click", () => {
      if (editor.currentSpread < editor.totalSpreads - 1) {
        editor.currentSpread++;
        renderSpread();
      }
    });
  }

  if (undoBtn) {
    undoBtn.addEventListener("click", undoLastAction);
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", () => {
      // Open preview in confirm mode — customer must review every page
      // before the PDF is generated and the order is placed.
      openPreviewOverlay(true);
    });
  }

  // ── Extra spread buttons ──────────────────────────────────────────────────
  // "+" adds a spread (2 pages, +$1.99); "−" removes the last added spread.
  // Buttons are hidden until the customer selects a page count.
  const _addSpreadBtn    = $("dmbAddSpreadBtn");
  const _removeSpreadBtn = $("dmbRemoveSpreadBtn");
  if (_addSpreadBtn)    _addSpreadBtn.addEventListener("click",    addExtraSpread);
  if (_removeSpreadBtn) _removeSpreadBtn.addEventListener("click", removeExtraSpread);
  function initMagazineStylePicker() {
    const styles = window.DMB_MAGAZINE_STYLES || [];
    const grid = document.getElementById("dmbMagStyleGrid");
    const continueBtn = document.getElementById("continueToMagBuilderBtn");
    const backBtn = document.getElementById("backToUploadBtn");
    if (!grid) return;

    // Only init once
    if (grid.dataset.initialized) return;
    grid.dataset.initialized = "1";

    let selectedStyle = null;

    styles.forEach(function(s) {
      const card = document.createElement("div");
      card.className = "dmb-mag-style-card";
      card.dataset.styleId = s.id;
      card.style.cssText =
        "display:flex;flex-direction:column;align-items:center;gap:8px;padding:12px;" +
        "border:2px solid #ddd;border-radius:10px;cursor:pointer;transition:border-color .15s,background .15s;";

      if (s.img) {
        const img = document.createElement("img");
        img.src = s.img;
        img.alt = s.label;
        img.style.cssText = "width:100%;height:140px;object-fit:cover;border-radius:6px;";
        card.appendChild(img);
      } else {
        const ph = document.createElement("div");
        ph.style.cssText =
          "width:100%;height:140px;background:#f0f0f0;border-radius:6px;" +
          "display:flex;align-items:center;justify-content:center;color:#bbb;font-size:12px;text-align:center;padding:8px;box-sizing:border-box;";
        ph.textContent = "Template coming soon";
        card.appendChild(ph);
      }

      const lbl = document.createElement("div");
      lbl.style.cssText = "font-size:13px;font-weight:600;text-align:center;";
      lbl.textContent = s.label;
      card.appendChild(lbl);

      card.addEventListener("click", function() {
        grid.querySelectorAll(".dmb-mag-style-card").forEach(function(c) {
          c.style.borderColor = "#ddd";
          c.style.background = "";
        });
        card.style.borderColor = "#111";
        card.style.background = "#f5f5f5";
        selectedStyle = s.id;
        window.DMB_SELECTED_MAGAZINE_STYLE = s.id;
        if (continueBtn) continueBtn.disabled = false;
      });

      grid.appendChild(card);
    });

    if (continueBtn) {
      continueBtn.disabled = true;
      continueBtn.addEventListener("click", async function() {
        if (!selectedStyle) return;
        const s1c = document.getElementById("step1c");
        if (s1c) s1c.style.display = "none";
        if (builderStep) builderStep.style.display = "block";
        try { await openEditor(); } catch(err) {
          console.error("openEditor failed:", err);
          if (s1c) s1c.style.display = "flex";
          if (builderStep) builderStep.style.display = "none";
        }
      });
    }

    if (backBtn) {
      backBtn.addEventListener("click", function() {
        const s1c = document.getElementById("step1c");
        const s1b = document.getElementById("step1b");
        if (s1c) s1c.style.display = "none";
        if (s1b) s1b.style.display = "flex";
      });
    }
  }

  if (backToDetailsBtn) {
    backToDetailsBtn.addEventListener("click", closeEditorBackToDetails);
  }

  if (saveLayoutBtn) {
    saveLayoutBtn.style.display = "none";
  }

  window.addEventListener("beforeunload", () => {
    try {
      const payload = getCurrentBuilderStateSnapshot();
      localStorage.setItem("dmb_saved_project_v1", JSON.stringify(payload));
      // NOTE: we do NOT auto-save to the per-book customer key here.
      // That key is only written by explicit "Save Template" clicks so it
      // never gets corrupted by navigating away mid-session.
    } catch {}
  });
  if (saveTemplateBtn) {
    saveTemplateBtn.addEventListener("click", () => {
      saveCustomerProgress();
    });
  }
  window.addEventListener("resize", () => {
    if (builderStep && builderStep.style.display === "block") {
      try { renderBuilderCanvas(); } catch(e) {}
      renderThumbsRail();
      renderPhotoTray();
    }
  });

  if (redoBtn) redoBtn.addEventListener("click", redoLastAction);

  if (previewBtn) {
    previewBtn.addEventListener("click", () => {
      openPreviewOverlay();
    });
  }

  // ── Tutorial Modal ────────────────────────────────────────────────────
  (function() {
    const tutBtn    = document.getElementById("videoTutorialBtn");
    const tutModal  = document.getElementById("dmbTutorialModal");
    const tutClose  = document.getElementById("dmbTutorialClose");
    const tourBtn   = document.getElementById("dmbStartTourBtn");
    const qrImg     = document.getElementById("dmbTutorialQRImg");
    const qrPh      = document.getElementById("dmbTutorialQRPlaceholder");

    if (!tutBtn || !tutModal) return;

    // If QR image src is set, show the image and hide the placeholder
    if (qrImg && qrImg.src && qrImg.src !== window.location.href) {
      qrImg.style.display = "block";
      if (qrPh) qrPh.style.display = "none";
    }

    function openModal()  { tutModal.style.display = "flex"; }
    function closeModal() { tutModal.style.display = "none"; }

    tutBtn.addEventListener("click", openModal);
    if (tutClose) tutClose.addEventListener("click", closeModal);

    // Click outside the inner box closes the modal
    tutModal.addEventListener("click", (e) => {
      if (e.target === tutModal) closeModal();
    });

    // Escape key closes the modal
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && tutModal.style.display !== "none") closeModal();
    });

    // Start Tour button
    if (tourBtn) {
      tourBtn.addEventListener("click", () => {
        closeModal();
        setTimeout(() => {
          if (window.dmbRestartTour) window.dmbRestartTour();
        }, 200);
      });
    }
  })();
  if (exportTemplateBtn) {
    exportTemplateBtn.addEventListener("click", () => {
      const code = window.prompt("Enter admin passcode:");
      if (code !== "MayarMemories2026") {
        if (code !== null) alert("Incorrect passcode.");
        return;
      }
      exportTemplateJSON();
    });
  }

  const zoomRange = $("zoomRange");

  if (zoomRange) {
    zoomRange.addEventListener("input", () => {
      setCanvasZoom(Number(zoomRange.value) / 100);
    });
  }

  if (zoomInBtn) {
    zoomInBtn.addEventListener("click", () => {
      const next = Math.min(200, Math.round(currentZoom * 100) + 10);
      setCanvasZoom(next / 100);
    });
  }

  if (zoomOutBtn) {
    zoomOutBtn.addEventListener("click", () => {
      const next = Math.max(25, Math.round(currentZoom * 100) - 10);
      setCanvasZoom(next / 100);
    });
  }

  if (smartCreationBtn) {
    smartCreationBtn.addEventListener("click", () => {
      smartCreateBook();
    });
  }

  if (coverThumbBtn) {
    coverThumbBtn.addEventListener("click", () => {
      builderMode = "cover";
      syncBuilderModeButtons();
      renderBuilderCanvas();
      activateLeftTab("cover");
    });
  }

  if (canvasLayoutBtn) {
    canvasLayoutBtn.addEventListener("click", () => {
      document.querySelector('.dmb-icon-tab[data-tab="layouts"]')?.click();
    });
  }

  if (canvasTextBtn || addTextBtn) {
    const addDefaultText = () => {
      let target = null;

      const _magFrontX3 = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
      let coverTextDefaultX = _magFrontX3 + 40;
      if (builderMode === "cover") {
        // Place text in the overlay (spans full cover) so drag is seamless across all zones
        target = document.getElementById("coverOverlay") || spreadCanvas;
        const zoneOffsets = { back: 40, spine: COVER_BACK_W + 5, front: _magFrontX3 + 40 };
        coverTextDefaultX = zoneOffsets[activeCoverZone] ?? (_magFrontX3 + 40);
      } else {
        const pageBodies = spreadCanvas?.querySelectorAll('[data-page-body="true"]');
        const bodyIdx = lastToolbarSide === "right" && pageBodies && pageBodies.length > 1 ? 1 : 0;
        target = pageBodies && pageBodies.length ? pageBodies[bodyIdx] : null;
      }

      if (!target) return;
      pushUndoState("Add Text");
      const txt = document.createElement("div");
      txt.textContent = "Enter text";
      txt.contentEditable = "true";
      txt.classList.add("dmb-editable-text");
      // Spine: rotate -90° so text reads along the spine
      if (builderMode === "cover" && activeCoverZone === "spine") {
        const spineCenter = COVER_BACK_W + Math.round(COVER_SPINE_W / 2);
        txt.style.left = spineCenter + "px";
        txt.style.top = "50%";
        txt.style.transform = "translate(-50%, -50%) rotate(-90deg)";
        txt.style.minWidth = "";
      } else {
        txt.style.left = (builderMode === "cover" ? coverTextDefaultX : 40) + "px";
        txt.style.top = "40px";
        txt.style.minWidth = "120px";
      }
      txt.style.padding = "2px 6px";
      txt.style.fontSize = "28px";
      txt.style.fontWeight = "800";
      txt.style.color = "#666";
      txt.style.fontFamily = "'Londrina Solid', sans-serif";
      txt.style.background = "transparent";
      txt.style.outline = "none";
      txt.dataset.z = String(Date.now());
      txt.style.zIndex = txt.dataset.z;

      // Track user-added cover text so it survives re-renders
      if (builderMode === "cover") {
        const utId = "utext_" + Date.now() + "_" + Math.random().toString(36).slice(2);
        txt.id = utId;
        const zone = activeCoverZone === "back" ? "back" : activeCoverZone === "spine" ? "spine" : "front";
        if (!Array.isArray(editor.coverUserTexts)) editor.coverUserTexts = [];
        editor.coverUserTexts.push({ id: utId, zone });
        saveCoverTextNodeState(txt);
      }

      if (builderMode !== "cover") {
        const _pn = parseInt(target.dataset.pageNumber);
        if (Number.isFinite(_pn)) {
          txt.dataset.pageNumber = String(_pn);
          const _txtId = "pgtext_" + Date.now() + "_" + Math.random().toString(36).slice(2);
          txt.id = _txtId;
          if (!Array.isArray(editor.pageObjects[_pn])) editor.pageObjects[_pn] = [];
          editor.pageObjects[_pn].push({
            id: _txtId, type: "text",
            text: txt.textContent || "",
            left: txt.style.left || "40px", top: txt.style.top || "40px",
            fontSize: txt.style.fontSize || "28px", fontWeight: txt.style.fontWeight || "800",
            color: txt.style.color || "#666", fontFamily: txt.style.fontFamily || "'Londrina Solid', sans-serif",
            textAlign: "", textDecoration: "", transform: "", rotate: "0",
            z: txt.dataset.z || String(Date.now()), width: ""
          });
        }
      }
      attachTextNodeHandlers(txt);
      target.appendChild(txt);
      showTextToolbarFor(txt);

      txt.focus();

      const range = document.createRange();
      range.selectNodeContents(txt);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    };

    if (canvasTextBtn) canvasTextBtn.addEventListener("click", addDefaultText);
    if (addTextBtn) addTextBtn.addEventListener("click", addDefaultText);
  }

  if (canvasPhotoBtn) {
    canvasPhotoBtn.addEventListener("click", () => {
      let target;

      if (builderMode === "cover") {
        target = {
          targetType: "cover",
          zone: getCurrentCoverZone()
        };
      } else {
        let pageNumber = null;
        if (editor.currentSpread === -1) {
          pageNumber = 0;
        } else {
          const leftPage = editor.currentSpread * 2 + 1;
          const rightPage = leftPage + 1;
          if (lastToolbarSide === "right") {
            if (rightPage <= editor.totalPages && !isLockedPage(rightPage)) pageNumber = rightPage;
            else if (leftPage <= editor.totalPages && !isLockedPage(leftPage)) pageNumber = leftPage;
          } else {
            if (leftPage <= editor.totalPages && !isLockedPage(leftPage)) pageNumber = leftPage;
            else if (rightPage <= editor.totalPages && !isLockedPage(rightPage)) pageNumber = rightPage;
          }
        }

        if (pageNumber == null) {
          const msg = document.getElementById("saveMsg");
          if (msg) {
            msg.textContent = "No editable page on this spread.";
            msg.style.display = "block";
            setTimeout(() => { msg.style.display = "none"; }, 1400);
          }
          return;
        }

        target = {
          targetType: "page",
          page: pageNumber
        };
      }

      pushUndoState("Add Photo Frame");

      const obj = newFrameObject(target);

      if (target.targetType === "cover") {
        // Offset x to full-cover coordinates based on the active zone
        const _magFrontX4 = window.DMB_MAGAZINE_MODE ? COVER_BACK_W : COVER_FRONT_X;
        const zoneOffsets = { back: 0, spine: COVER_BACK_W, front: _magFrontX4 };
        obj.x = (zoneOffsets[target.zone] || _magFrontX4) + 40;
        ensureCoverObjects().push(obj);
      } else {
        ensurePageObjects(target.page).push(obj);
      }

      if (builderMode === "cover") renderCoverCanvas(); else renderSpread();

      requestAnimationFrame(() => {
        const el = document.querySelector(`.dmb-photo-frame-object[data-object-id="${obj.id}"]`);
        if (el) {
          showFrameToolbarFor(el, obj, {
            targetType: obj.targetType,
            pageNumber: obj.page ?? null,
            zone: obj.zone || null
          });
        }
      });
    });
  }

  /* ── SHAPE PICKER — open / close + item click handler ─────────────────
   * Clicking "Shapes" in the toolbar toggles the floating shape picker panel.
   * Clicking a shape in the panel either adds it immediately (all except line)
   * or activates "line draw mode" where the next canvas drag creates the line.
   *
   * WARNING: Line draw mode adds a one-shot pointerdown listener on the canvas
   * container. Always cancel _dmbLineModeActive via Escape or on completion so
   * subsequent canvas clicks work normally.
   * ────────────────────────────────────────────────────────────────────────── */
  (function initShapePickerPanel() {
    const panel   = document.getElementById("dmbShapePickerPanel");
    const closeBtn = document.getElementById("dmbShapePickerClose");
    if (!panel) return;

    // Position the panel near the Shapes button
    function positionShapePanel() {
      if (!canvasShapeBtn) return;
      const btnRect = canvasShapeBtn.getBoundingClientRect();
      panel.style.top  = (btnRect.bottom + 6) + "px";
      panel.style.left = Math.max(8, btnRect.left) + "px";
    }

    if (canvasShapeBtn) {
      canvasShapeBtn.addEventListener("click", () => {
        if (panel.style.display === "none" || !panel.style.display) {
          positionShapePanel();
          panel.style.display = "block";
          canvasShapeBtn.classList.add("is-active");
        } else {
          panel.style.display = "none";
          canvasShapeBtn.classList.remove("is-active");
        }
      });
    }

    closeBtn?.addEventListener("click", () => {
      panel.style.display = "none";
      canvasShapeBtn?.classList.remove("is-active");
    });

    // Close picker when clicking outside it
    document.addEventListener("pointerdown", (e) => {
      if (!panel || panel.style.display === "none") return;
      if (panel.contains(e.target))                 return;
      if (e.target === canvasShapeBtn)              return; // handled by toggle above
      panel.style.display = "none";
      canvasShapeBtn?.classList.remove("is-active");
    }, { capture: true });

    // Shape item click → add shape or activate line mode
    panel.querySelectorAll(".dmb-shape-item[data-shape]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const shapeType = btn.dataset.shape;
        panel.style.display = "none";
        canvasShapeBtn?.classList.remove("is-active");

        if (shapeType === "line") {
          // ── LINE DRAW MODE ── user must click+drag on the canvas to create
          _dmbLineModeActive = true;
          document.body.classList.add("dmb-line-draw-mode");

          // Escape cancels line mode
          const cancelLine = (e) => {
            if (e.key === "Escape") {
              _dmbLineModeActive = false;
              document.body.classList.remove("dmb-line-draw-mode");
              document.removeEventListener("keydown", cancelLine);
            }
          };
          document.addEventListener("keydown", cancelLine);

          // One-shot canvas pointerdown to start the line drag.
          // Target the actual page-body divs and the cover overlay/preview —
          // the old class names (.dmb-page-canvas-container etc.) don't exist.
          const canvasContainers = document.querySelectorAll(
            '[data-page-body="true"], .dmb-cover-preview, #coverOverlay'
          );
          const startLineDraw = (downEvt) => {
            if (!_dmbLineModeActive) return;
            const target   = downEvt.currentTarget;
            const tRect    = target.getBoundingClientRect();
            const startX   = downEvt.clientX - tRect.left;
            const startY   = downEvt.clientY - tRect.top;

            // Live preview element
            const preview = document.createElement("div");
            preview.style.cssText = "position:absolute;pointer-events:none;background:#6366f1;opacity:0.6;transform-origin:left center;z-index:9999;border-radius:4px;";
            target.style.position = "relative";
            target.appendChild(preview);

            const onMove = (mv) => {
              const ex = mv.clientX - tRect.left, ey = mv.clientY - tRect.top;
              const dx = ex - startX, dy = ey - startY;
              const len = Math.sqrt(dx*dx + dy*dy);
              const ang = Math.atan2(dy, dx) * 180 / Math.PI;
              preview.style.width     = len + "px";
              preview.style.height    = "8px";
              preview.style.left      = startX + "px";
              preview.style.top       = (startY - 4) + "px";
              preview.style.transform = `rotate(${ang}deg)`;
            };

            const onUp = (upEvt) => {
              preview.remove();
              _dmbLineModeActive = false;
              document.body.classList.remove("dmb-line-draw-mode");
              document.removeEventListener("keydown", cancelLine);
              document.removeEventListener("pointermove", onMove);
              canvasContainers.forEach((c) => c.removeEventListener("pointerdown", startLineDraw));

              const ex   = upEvt.clientX - tRect.left, ey = upEvt.clientY - tRect.top;
              const dx   = ex - startX, dy = ey - startY;
              const len  = Math.sqrt(dx*dx + dy*dy);
              if (len < 8) return; // too short — ignore
              const ang  = Math.atan2(dy, dx) * 180 / Math.PI;
              const cx   = (startX + ex) / 2, cy = (startY + ey) / 2;
              const lineH = 8;
              // WARNING: `currentPage` is not defined — use spread/side logic
              const isCover = (builderMode === "cover");
              let pn = null;
              if (!isCover) {
                if (editor.currentSpread === -1) {
                  pn = 0;
                } else {
                  const _lp = editor.currentSpread * 2 + 1;
                  const _rp = _lp + 1;
                  if (lastToolbarSide === "right" && _rp <= editor.totalPages && !isLockedPage(_rp)) {
                    pn = _rp;
                  } else if (_lp <= editor.totalPages && !isLockedPage(_lp)) {
                    pn = _lp;
                  } else {
                    pn = (_rp <= editor.totalPages) ? _rp : null;
                  }
                }
              }
              const lineObj = {
                id: "shape_" + Date.now(), type: "shape", shapeType: "line",
                x: cx - len / 2, y: cy - lineH / 2, w: len, h: lineH,
                fill: "#6366f1", stroke: "transparent", strokeWidth: 0,
                opacity: 1, rotation: ang, z: Date.now(),
              };
              pushUndoState("Add Line");
              if (isCover) {
                if (!Array.isArray(editor.coverObjects)) editor.coverObjects = [];
                editor.coverObjects.push(lineObj);
                renderCoverCanvas();
              } else if (pn !== null) {
                if (!editor.pageObjects) editor.pageObjects = {};
                if (!Array.isArray(editor.pageObjects[pn])) editor.pageObjects[pn] = [];
                editor.pageObjects[pn].push(lineObj);
                renderBuilderCanvas();
              }
            };

            document.addEventListener("pointermove", onMove);
            document.addEventListener("pointerup", onUp, { once: true });
            downEvt.preventDefault();
            downEvt.stopPropagation();
          };

          canvasContainers.forEach((c) => c.addEventListener("pointerdown", startLineDraw, { once: true }));
        } else {
          // All other shapes: add immediately at centre of canvas
          insertShapeIntoActivePage(shapeType);
        }
      });
    });
  })();

  if (canvasLayersBtn) {
    canvasLayersBtn.addEventListener("click", () => {
      const msg = document.getElementById("saveMsg");
      if (msg) {
        msg.textContent = "Layers panel is not active yet.";
        msg.style.display = "block";
        setTimeout(() => { msg.style.display = "none"; }, 1400);
      }
    });
  }

  if (canvasDeleteBtn) {
    canvasDeleteBtn.addEventListener("click", () => {
      if (selectedTextNode) {
        const node = selectedTextNode;
        hideTextToolbar();
        node.remove();
        return;
      }

      if (selectedFrameObject) {
        pushUndoState("Delete Frame");
        deleteFrameObjectByTarget(
          selectedFrameObject.targetType,
          selectedFrameObject.pageNumber,
          selectedFrameObject.zone,
          selectedFrameObject.id
        );
        hideFrameToolbar();
        renderBuilderCanvas();
        return;
      }

      const msg = document.getElementById("saveMsg");
      if (msg) {
        msg.textContent = "Select a text or frame first.";
        msg.style.display = "block";
        setTimeout(() => { msg.style.display = "none"; }, 1400);
      }
    });
  }


  document.addEventListener("change", async (e) => {
    const fileInput = e.target.closest("#bookPhotos, #step1bFileInput");
    const cameraInput = e.target.closest("#cameraPhotos, #step1bCameraInput");

    if (fileInput) {
      const picked = await compressFilesForMobile(Array.from(fileInput.files || []));
      bookFiles = mergeFilesKeepOld(bookFiles, picked);
      syncInputFiles(fileInput, bookFiles);
      validatePhotos();
      renderUploadGrid();
      refreshBuilderPhotos();
      await tryAutoOpenEditor();
      return;
    }

    if (cameraInput) {
      const picked = await compressFilesForMobile(Array.from(cameraInput.files || []));
      bookFiles = mergeFilesKeepOld(bookFiles, picked);
      validatePhotos();
      renderUploadGrid();
      refreshBuilderPhotos();
      await tryAutoOpenEditor();
    }
  });


  // ---- Drag & Drop zone in step 1b (Upload Your Photos page) ----
  const step1bDragZone = document.getElementById("step1bDragDropZone");
  if (step1bDragZone) {
    step1bDragZone.addEventListener("dragover", (e) => {
      e.preventDefault();
      step1bDragZone.classList.add("drag-over");
    });
    step1bDragZone.addEventListener("dragleave", () => {
      step1bDragZone.classList.remove("drag-over");
    });
    step1bDragZone.addEventListener("drop", (e) => {
      e.preventDefault();
      step1bDragZone.classList.remove("drag-over");
      const files = Array.from(e.dataTransfer?.files || []).filter(f => f.type.startsWith("image/"));
      if (!files.length) return;
      bookFiles = mergeFilesKeepOld(bookFiles, files);
      validatePhotos();
      renderUploadGrid();
      refreshBuilderPhotos();
    });
    step1bDragZone.addEventListener("click", () => {
      const input = document.getElementById("step1bFileInput");
      if (input) input.click();
    });
  }

  // ---- Drag & Drop zone inside "Add more photos" popup (builder) ----
  const builderDragDropZone = document.getElementById("builderDragDropZone");
  if (builderDragDropZone) {
    builderDragDropZone.addEventListener("dragover", (e) => {
      e.preventDefault();
      builderDragDropZone.classList.add("drag-over");
    });
    builderDragDropZone.addEventListener("dragleave", () => {
      builderDragDropZone.classList.remove("drag-over");
    });
    builderDragDropZone.addEventListener("drop", (e) => {
      e.preventDefault();
      builderDragDropZone.classList.remove("drag-over");
      const menu = document.getElementById("photoImportMenu");
      if (menu) menu.style.display = "none";
      const files = Array.from(e.dataTransfer?.files || []).filter(f => f.type.startsWith("image/"));
      if (!files.length) return;
      bookFiles = mergeFilesKeepOld(bookFiles, files);
      refreshBuilderPhotos();
    });
  }

  // ---- Scroll arrow for step 1b: show when footer scrolls out of view ----
  const step1bFooter = document.getElementById("step1bFooter");
  const dmbScrollArrowBtn = document.getElementById("dmbScrollArrowBtn");

  if (step1bFooter && dmbScrollArrowBtn) {
    dmbScrollArrowBtn.addEventListener("click", () => {
      step1bFooter.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    const footerObserver = new IntersectionObserver((entries) => {
      const step1bEl = document.getElementById("step1b");
      const isStep1bVisible = step1bEl && step1bEl.style.display !== "none";
      const hasPhotos = bookFiles.length > 0;
      const footerVisible = entries[0].isIntersecting;
      dmbScrollArrowBtn.style.display = (isStep1bVisible && hasPhotos && !footerVisible) ? "flex" : "none";
    }, { threshold: 0.5 });

    footerObserver.observe(step1bFooter);
  }

  window.__dmbDebug = {
    getState: () => ({
      pagesValue: pagesEl?.value,
      totalPages: editor.totalPages,
      totalSpreads: editor.totalSpreads,
      currentSpread: editor.currentSpread,
      builderMode,
      photos: editor.photos?.length || 0,
      step1: step1?.style.display,
      step2: builderStep?.style.display
    })
  };
  try { initPhoneUpload(); } catch (_) {}

  document.addEventListener("click", async (e) => {
    const addBtn = e.target.closest("#addMorePhotosBtn");
    const deviceBtn = e.target.closest("#importDeviceBtn");
    const cameraBtn = e.target.closest("#importCameraBtn");
    const projectBtn = e.target.closest("#projectMenuBtn");
    const historyBtn = e.target.closest("#historyBtn");

    const menu = $("photoImportMenu");
    const bookInput = $("bookPhotos");
    const cameraInput = $("cameraPhotos");

    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (menu) {
        if (menu.style.display === "block") {
          menu.style.display = "none";
        } else {
          const rect = addBtn.getBoundingClientRect();
          menu.style.top = (rect.bottom + 4) + "px";
          menu.style.left = rect.left + "px";
          menu.style.width = rect.width + "px";
          menu.style.display = "block";
        }
      }
      return;
    }

    if (deviceBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (menu) menu.style.display = "none";
      if (bookInput) bookInput.click();
      return;
    }

    if (cameraBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (menu) menu.style.display = "none";
      if (cameraInput) cameraInput.click();
      return;
    }

    if (projectBtn) {
      e.preventDefault();
      e.stopPropagation();
      openProjectMenuPrompt();
      return;
    }

    if (historyBtn) {
      e.preventDefault();
      e.stopPropagation();
      openHistoryPanel();
      return;
    }
    if (menu && !e.target.closest("#photoImportMenu")) {
      menu.style.display = "none";
    }
  }, true);
document.addEventListener("click", (e) => {
  const mirror = e.target.closest(".dmb-tool-mirror");
  if (!mirror) return;

  lastToolbarSide = "right";
  const targetSelector = mirror.getAttribute("data-click");
  const realBtn = targetSelector ? document.querySelector(targetSelector) : null;
  if (realBtn) realBtn.click();
  lastToolbarSide = "left";
});

document.addEventListener("click", (e) => {
  const inFrame = e.target.closest(".dmb-photo-frame-object");
  const inFrameToolbar = e.target.closest("#dmbFrameToolbar");
  if (!inFrame && !inFrameToolbar) {
    hideFrameToolbar();
  }
});

// ======= UPLOAD STEP =======
function renderUploadGrid() {
  const grid = document.getElementById("uploadPhotoGrid");
  const countEl = document.getElementById("uploadPhotoCount");
  if (!grid) return;

  grid.innerHTML = "";
  const count = bookFiles.length;

  if (countEl) {
    countEl.style.display = count ? "block" : "none";
    countEl.textContent = count ? `${count} photo${count !== 1 ? "s" : ""} selected` : "";
  }

  bookFiles.forEach((file, idx) => {
    const thumb = document.createElement("div");
    thumb.className = "dmb-upload-grid-thumb";

    const img = document.createElement("img");
    img.src = URL.createObjectURL(file);
    img.alt = "";
    thumb.appendChild(img);

    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "dmb-upload-grid-thumb-remove";
    removeBtn.setAttribute("aria-label", "Remove photo");
    removeBtn.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6l-12 12"/></svg>`;
    removeBtn.addEventListener("click", () => {
      bookFiles.splice(idx, 1);
      renderUploadGrid();
    });
    thumb.appendChild(removeBtn);

    grid.appendChild(thumb);
  });
}

document.addEventListener("click", async (e) => {
  if (e.target.closest("#backToHomeBtn")) {
    const s1b = document.getElementById("step1b");
    if (s1b) s1b.style.display = "none";
    if (step1) step1.style.display = "flex";
    return;
  }

  if (e.target.closest(".dmb-mag-template-btn")) {
    const btn = e.target.closest(".dmb-mag-template-btn");
    const handle = btn.dataset.handle;

    // Check if there's a saved design for this template
    const _savedKey = handle ? "dmb_progress_mag_" + handle : null;
    const _hasSave  = _savedKey ? !!localStorage.getItem(_savedKey) : false;

    if (_hasSave) {
      // Ask: continue or start fresh
      showChoiceDialog(
        "You have a saved design",
        "We found a saved version of this magazine. Would you like to pick up where you left off?",
        [
          { id: "continue", label: "📂 Continue editing" },
          { id: "new",      label: "🆕 Start fresh" }
        ]
      ).then(choice => {
        if (!choice || choice === "new") {
          // Clear saved progress and go to upload
          try { localStorage.removeItem(_savedKey); } catch(er) {}
          _clearPhotosFromIDB(_savedKey).catch(() => {});
          if (handle) sessionStorage.setItem("dmb_mag_template", handle);
          window.location.href = handle
            ? "/pages/design-my-magazine?step=upload&cover=" + encodeURIComponent(handle)
            : "/pages/design-my-magazine?step=upload";
        } else {
          // Restore directly — skip upload
          if (handle) sessionStorage.setItem("dmb_mag_template", handle);
          window.location.href = handle
            ? "/pages/design-my-magazine?template=" + encodeURIComponent(handle) + "&restore=1"
            : "/pages/design-my-magazine?restore=1";
        }
      });
      return;
    }

    // No saved design — go straight to upload as before
    if (handle) sessionStorage.setItem("dmb_mag_template", handle);
    window.location.href = handle
      ? "/pages/design-my-magazine?step=upload&cover=" + encodeURIComponent(handle)
      : "/pages/design-my-magazine?step=upload";
    return;
  }

  if (e.target.closest("#continueToBuilderBtn")) {
    // In magazine mode the IIFE handler already manages the flow
    if (window.DMB_MAGAZINE_MODE) return;

    const errEl = document.getElementById("uploadStepError");
    const pagesSel = document.getElementById("step1bPages");

    if (!pagesSel?.value) {
      if (errEl) { errEl.textContent = "Please select the number of pages for your book."; errEl.style.display = "block"; }
      return;
    }
    if (errEl) errEl.style.display = "none";

    if (pagesEl) pagesEl.value = pagesSel.value;

    const s1b = document.getElementById("step1b");
    if (s1b) s1b.style.display = "none";
    if (step1) step1.style.display = "none";
    if (builderStep) builderStep.style.display = "block";

    try {
      await openEditor();
    } catch (err) {
      console.error("openEditor failed:", err);
      if (s1b) s1b.style.display = "flex";
      if (builderStep) builderStep.style.display = "none";
      if (errEl) { errEl.textContent = "Something went wrong opening the builder. Check the console for details."; errEl.style.display = "block"; }
    }
    return;
  }
});

})(); // closes the main (() => { app IIFE at line 699
